/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2020 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */
!(function webpackUniversalModuleDefinition(t, r) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = r())
    : "function" == typeof define && define.amd
    ? define("pdfjs-dist/build/pdf.worker", [], r)
    : "object" == typeof exports
    ? (exports["pdfjs-dist/build/pdf.worker"] = r())
    : (t["pdfjs-dist/build/pdf.worker"] = t.pdfjsWorker = r());
})(this, function () {
  return (function (t) {
    var r = {};
    function __w_pdfjs_require__(a) {
      if (r[a]) return r[a].exports;
      var i = (r[a] = { i: a, l: !1, exports: {} });
      return (
        t[a].call(i.exports, i, i.exports, __w_pdfjs_require__),
        (i.l = !0),
        i.exports
      );
    }
    return (
      (__w_pdfjs_require__.m = t),
      (__w_pdfjs_require__.c = r),
      (__w_pdfjs_require__.d = function (t, r, a) {
        __w_pdfjs_require__.o(t, r) ||
          Object.defineProperty(t, r, { enumerable: !0, get: a });
      }),
      (__w_pdfjs_require__.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      }),
      (__w_pdfjs_require__.t = function (t, r) {
        if ((1 & r && (t = __w_pdfjs_require__(t)), 8 & r)) return t;
        if (4 & r && "object" == typeof t && t && t.__esModule) return t;
        var a = Object.create(null);
        if (
          (__w_pdfjs_require__.r(a),
          Object.defineProperty(a, "default", { enumerable: !0, value: t }),
          2 & r && "string" != typeof t)
        )
          for (var i in t)
            __w_pdfjs_require__.d(
              a,
              i,
              function (r) {
                return t[r];
              }.bind(null, i),
            );
        return a;
      }),
      (__w_pdfjs_require__.n = function (t) {
        var r =
          t && t.__esModule
            ? function getDefault() {
                return t.default;
              }
            : function getModuleExports() {
                return t;
              };
        return __w_pdfjs_require__.d(r, "a", r), r;
      }),
      (__w_pdfjs_require__.o = function (t, r) {
        return Object.prototype.hasOwnProperty.call(t, r);
      }),
      (__w_pdfjs_require__.p = ""),
      __w_pdfjs_require__((__w_pdfjs_require__.s = 0))
    );
  })([
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        Object.defineProperty(r, "WorkerMessageHandler", {
          enumerable: !0,
          get: function get() {
            return i.WorkerMessageHandler;
          },
        });
      var i = a(1);
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.WorkerMessageHandler = r.WorkerTask = void 0);
      var i = (function _interopRequireDefault(t) {
          return t && t.__esModule ? t : { default: t };
        })(a(2)),
        o = a(5),
        l = a(198),
        c = a(199),
        u = a(7),
        h = a(238),
        d = a(239),
        p = a(201);
      function _slicedToArray(t, r) {
        return (
          (function _arrayWithHoles(t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function _iterableToArrayLimit(t, r) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var a = [],
              i = !0,
              o = !1,
              l = void 0;
            try {
              for (
                var c, u = t[Symbol.iterator]();
                !(i = (c = u.next()).done) &&
                (a.push(c.value), !r || a.length !== r);
                i = !0
              );
            } catch (t) {
              (o = !0), (l = t);
            } finally {
              try {
                i || null == u.return || u.return();
              } finally {
                if (o) throw l;
              }
            }
            return a;
          })(t, r) ||
          (function _unsupportedIterableToArray(t, r) {
            if (!t) return;
            if ("string" == typeof t) return _arrayLikeToArray(t, r);
            var a = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === a && t.constructor && (a = t.constructor.name);
            if ("Map" === a || "Set" === a) return Array.from(t);
            if (
              "Arguments" === a ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
            )
              return _arrayLikeToArray(t, r);
          })(t, r) ||
          (function _nonIterableRest() {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function _arrayLikeToArray(t, r) {
        (null == r || r > t.length) && (r = t.length);
        for (var a = 0, i = new Array(r); a < r; a++) i[a] = t[a];
        return i;
      }
      function asyncGeneratorStep(t, r, a, i, o, l, c) {
        try {
          var u = t[l](c),
            h = u.value;
        } catch (t) {
          return void a(t);
        }
        u.done ? r(h) : Promise.resolve(h).then(i, o);
      }
      function _asyncToGenerator(t) {
        return function () {
          var r = this,
            a = arguments;
          return new Promise(function (i, o) {
            var l = t.apply(r, a);
            function _next(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "next", t);
            }
            function _throw(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "throw", t);
            }
            _next(void 0);
          });
        };
      }
      var m = (function WorkerTaskClosure() {
        function WorkerTask(t) {
          (this.name = t),
            (this.terminated = !1),
            (this._capability = (0, o.createPromiseCapability)());
        }
        return (
          (WorkerTask.prototype = {
            get finished() {
              return this._capability.promise;
            },
            finish: function finish() {
              this._capability.resolve();
            },
            terminate: function terminate() {
              this.terminated = !0;
            },
            ensureNotTerminated: function ensureNotTerminated() {
              if (this.terminated)
                throw new Error("Worker task was terminated");
            },
          }),
          WorkerTask
        );
      })();
      r.WorkerTask = m;
      var g = {
        setup: function setup(t, r) {
          var a = !1;
          t.on("test", function wphSetupTest(r) {
            if (!a)
              if (((a = !0), r instanceof Uint8Array)) {
                var i = 255 === r[0];
                (t.postMessageTransfers = i),
                  t.send("test", { supportTransfers: i });
              } else t.send("test", null);
          }),
            t.on("configure", function wphConfigure(t) {
              (0, o.setVerbosityLevel)(t.verbosity);
            }),
            t.on("GetDocRequest", function wphSetupDoc(t) {
              return g.createDocumentHandler(t, r);
            });
        },
        createDocumentHandler: function createDocumentHandler(t, r) {
          var a,
            u = !1,
            g = null,
            b = [],
            y = (0, o.getVerbosityLevel)(),
            v = t.apiVersion,
            S = "2.5.207";
          if (v !== S)
            throw new Error(
              'The API version "'.concat(v, '" does not match ') +
                'the Worker version "'.concat(S, '".'),
            );
          var k = [];
          for (var w in []) k.push(w);
          if (k.length)
            throw new Error(
              "The `Array.prototype` contains unexpected enumerable properties: " +
                k.join(", ") +
                "; thus breaking e.g. `for...in` iteration of `Array`s.",
            );
          var C = t.docId,
            x = t.docBaseUrl,
            _ = t.docId + "_worker",
            A = new h.MessageHandler(_, C, r);
          function ensureNotTerminated() {
            if (u) throw new Error("Worker was terminated");
          }
          function startWorkerTask(t) {
            b.push(t);
          }
          function finishWorkerTask(t) {
            t.finish();
            var r = b.indexOf(t);
            b.splice(r, 1);
          }
          function loadDocument(t) {
            return _loadDocument.apply(this, arguments);
          }
          function _loadDocument() {
            return (_loadDocument = _asyncToGenerator(
              i.default.mark(function _callee(t) {
                var r, o, l, c;
                return i.default.wrap(function _callee$(i) {
                  for (;;)
                    switch ((i.prev = i.next)) {
                      case 0:
                        return (i.next = 2), a.ensureDoc("checkHeader");
                      case 2:
                        return (i.next = 4), a.ensureDoc("parseStartXRef");
                      case 4:
                        return (i.next = 6), a.ensureDoc("parse", [t]);
                      case 6:
                        if (t) {
                          i.next = 9;
                          break;
                        }
                        return (i.next = 9), a.ensureDoc("checkFirstPage");
                      case 9:
                        return (
                          (i.next = 11),
                          Promise.all([
                            a.ensureDoc("numPages"),
                            a.ensureDoc("fingerprint"),
                          ])
                        );
                      case 11:
                        return (
                          (r = i.sent),
                          (o = _slicedToArray(r, 2)),
                          (l = o[0]),
                          (c = o[1]),
                          i.abrupt("return", { numPages: l, fingerprint: c })
                        );
                      case 16:
                      case "end":
                        return i.stop();
                    }
                }, _callee);
              }),
            )).apply(this, arguments);
          }
          function getPdfManager(t, r) {
            var a,
              i = (0, o.createPromiseCapability)(),
              l = t.source;
            if (l.data) {
              try {
                (a = new c.LocalPdfManager(C, l.data, l.password, r, x)),
                  i.resolve(a);
              } catch (t) {
                i.reject(t);
              }
              return i.promise;
            }
            var u,
              h = [];
            try {
              u = new d.PDFWorkerStream(A);
            } catch (t) {
              return i.reject(t), i.promise;
            }
            var p = u.getFullReader();
            p.headersReady
              .then(function () {
                if (p.isRangeSupported) {
                  var t = l.disableAutoFetch || p.isStreamingSupported;
                  a = new c.NetworkPdfManager(
                    C,
                    u,
                    {
                      msgHandler: A,
                      password: l.password,
                      length: p.contentLength,
                      disableAutoFetch: t,
                      rangeChunkSize: l.rangeChunkSize,
                    },
                    r,
                    x,
                  );
                  for (var o = 0; o < h.length; o++)
                    a.sendProgressiveData(h[o]);
                  (h = []), i.resolve(a), (g = null);
                }
              })
              .catch(function (t) {
                i.reject(t), (g = null);
              });
            var m = 0;
            return (
              new Promise(function (t, u) {
                p.read().then(function readChunk(t) {
                  var d = t.value,
                    b = t.done;
                  try {
                    if ((ensureNotTerminated(), b))
                      return (
                        a ||
                          (function flushChunks() {
                            var t = (0, o.arraysToBytes)(h);
                            l.length &&
                              t.length !== l.length &&
                              (0, o.warn)(
                                "reported HTTP length is different from actual",
                              );
                            try {
                              (a = new c.LocalPdfManager(
                                C,
                                t,
                                l.password,
                                r,
                                x,
                              )),
                                i.resolve(a);
                            } catch (t) {
                              i.reject(t);
                            }
                            h = [];
                          })(),
                        void (g = null)
                      );
                    (m += (0, o.arrayByteLength)(d)),
                      p.isStreamingSupported ||
                        A.send("DocProgress", {
                          loaded: m,
                          total: Math.max(m, p.contentLength || 0),
                        }),
                      a ? a.sendProgressiveData(d) : h.push(d),
                      p.read().then(readChunk, u);
                  } catch (t) {
                    u(t);
                  }
                }, u);
              }).catch(function (t) {
                i.reject(t), (g = null);
              }),
              (g = function cancelXHRs(t) {
                u.cancelAllRequests(t);
              }),
              i.promise
            );
          }
          return (
            (A.postMessageTransfers = t.postMessageTransfers),
            A.on("GetPage", function wphSetupGetPage(t) {
              return a.getPage(t.pageIndex).then(function (t) {
                return Promise.all([
                  a.ensure(t, "rotate"),
                  a.ensure(t, "ref"),
                  a.ensure(t, "userUnit"),
                  a.ensure(t, "view"),
                ]).then(function (t) {
                  var r = _slicedToArray(t, 4);
                  return {
                    rotate: r[0],
                    ref: r[1],
                    userUnit: r[2],
                    view: r[3],
                  };
                });
              });
            }),
            A.on("GetPageIndex", function wphSetupGetPageIndex(t) {
              var r = l.Ref.get(t.ref.num, t.ref.gen);
              return a.pdfDocument.catalog.getPageIndex(r);
            }),
            A.on("GetDestinations", function wphSetupGetDestinations(t) {
              return a.ensureCatalog("destinations");
            }),
            A.on("GetDestination", function wphSetupGetDestination(t) {
              return a.ensureCatalog("getDestination", [t.id]);
            }),
            A.on("GetPageLabels", function wphSetupGetPageLabels(t) {
              return a.ensureCatalog("pageLabels");
            }),
            A.on("GetPageLayout", function wphSetupGetPageLayout(t) {
              return a.ensureCatalog("pageLayout");
            }),
            A.on("GetPageMode", function wphSetupGetPageMode(t) {
              return a.ensureCatalog("pageMode");
            }),
            A.on("GetViewerPreferences", function (t) {
              return a.ensureCatalog("viewerPreferences");
            }),
            A.on("GetOpenAction", function (t) {
              return a.ensureCatalog("openAction");
            }),
            A.on("GetAttachments", function wphSetupGetAttachments(t) {
              return a.ensureCatalog("attachments");
            }),
            A.on("GetJavaScript", function wphSetupGetJavaScript(t) {
              return a.ensureCatalog("javaScript");
            }),
            A.on("GetOutline", function wphSetupGetOutline(t) {
              return a.ensureCatalog("documentOutline");
            }),
            A.on("GetPermissions", function (t) {
              return a.ensureCatalog("permissions");
            }),
            A.on("GetMetadata", function wphSetupGetMetadata(t) {
              return Promise.all([
                a.ensureDoc("documentInfo"),
                a.ensureCatalog("metadata"),
              ]);
            }),
            A.on("GetData", function wphSetupGetData(t) {
              return (
                a.requestLoadedStream(),
                a.onLoadedStream().then(function (t) {
                  return t.bytes;
                })
              );
            }),
            A.on("GetStats", function wphSetupGetStats(t) {
              return a.pdfDocument.xref.stats;
            }),
            A.on("GetAnnotations", function (t) {
              var r = t.pageIndex,
                i = t.intent;
              return a.getPage(r).then(function (t) {
                return t.getAnnotationsData(i);
              });
            }),
            A.on(
              "GetOperatorList",
              function wphSetupRenderPage(t, r) {
                var i = t.pageIndex;
                a.getPage(i).then(function (a) {
                  var l = new m("GetOperatorList: page ".concat(i));
                  startWorkerTask(l);
                  var c = y >= o.VerbosityLevel.INFOS ? Date.now() : 0;
                  a.getOperatorList({
                    handler: A,
                    sink: r,
                    task: l,
                    intent: t.intent,
                    renderInteractiveForms: t.renderInteractiveForms,
                  }).then(
                    function (t) {
                      finishWorkerTask(l),
                        c &&
                          (0, o.info)(
                            "page=".concat(i + 1, " - getOperatorList: time=") +
                              ""
                                .concat(Date.now() - c, "ms, len=")
                                .concat(t.length),
                          ),
                        r.close();
                    },
                    function (t) {
                      finishWorkerTask(l),
                        l.terminated ||
                          (A.send("UnsupportedFeature", {
                            featureId: o.UNSUPPORTED_FEATURES.errorOperatorList,
                          }),
                          r.error(t));
                    },
                  );
                });
              },
              this,
            ),
            A.on("GetTextContent", function wphExtractText(t, r) {
              var i = t.pageIndex;
              (r.onPull = function (t) {}),
                (r.onCancel = function (t) {}),
                a.getPage(i).then(function (a) {
                  var l = new m("GetTextContent: page " + i);
                  startWorkerTask(l);
                  var c = y >= o.VerbosityLevel.INFOS ? Date.now() : 0;
                  a.extractTextContent({
                    handler: A,
                    task: l,
                    sink: r,
                    normalizeWhitespace: t.normalizeWhitespace,
                    combineTextItems: t.combineTextItems,
                  }).then(
                    function () {
                      finishWorkerTask(l),
                        c &&
                          (0, o.info)(
                            "page=".concat(i + 1, " - getTextContent: time=") +
                              "".concat(Date.now() - c, "ms"),
                          ),
                        r.close();
                    },
                    function (t) {
                      finishWorkerTask(l), l.terminated || r.error(t);
                    },
                  );
                });
            }),
            A.on("FontFallback", function (t) {
              return a.fontFallback(t.id, A);
            }),
            A.on("Cleanup", function wphCleanup(t) {
              return a.cleanup(!0);
            }),
            A.on("Terminate", function wphTerminate(t) {
              u = !0;
              var r = [];
              if (a) {
                a.terminate(new o.AbortException("Worker was terminated."));
                var i = a.cleanup();
                r.push(i), (a = null);
              } else (0, l.clearPrimitiveCaches)();
              return (
                g && g(new o.AbortException("Worker was terminated.")),
                b.forEach(function (t) {
                  r.push(t.finished), t.terminate();
                }),
                Promise.all(r).then(function () {
                  A.destroy(), (A = null);
                })
              );
            }),
            A.on("Ready", function wphReady(r) {
              !(function setupDoc(t) {
                function onSuccess(t) {
                  ensureNotTerminated(), A.send("GetDoc", { pdfInfo: t });
                }
                function onFailure(t) {
                  if (
                    (ensureNotTerminated(), t instanceof o.PasswordException)
                  ) {
                    var r = new m(
                      "PasswordException: response ".concat(t.code),
                    );
                    startWorkerTask(r),
                      A.sendWithPromise("PasswordRequest", t)
                        .then(function (t) {
                          var i = t.password;
                          finishWorkerTask(r),
                            a.updatePassword(i),
                            pdfManagerReady();
                        })
                        .catch(function () {
                          finishWorkerTask(r), A.send("DocException", t);
                        });
                  } else
                    t instanceof o.InvalidPDFException ||
                    t instanceof o.MissingPDFException ||
                    t instanceof o.UnexpectedResponseException ||
                    t instanceof o.UnknownErrorException
                      ? A.send("DocException", t)
                      : A.send(
                          "DocException",
                          new o.UnknownErrorException(t.message, t.toString()),
                        );
                }
                function pdfManagerReady() {
                  ensureNotTerminated(),
                    loadDocument(!1).then(
                      onSuccess,
                      function loadFailure(t) {
                        ensureNotTerminated(),
                          t instanceof p.XRefParseException
                            ? (a.requestLoadedStream(),
                              a.onLoadedStream().then(function () {
                                ensureNotTerminated(),
                                  loadDocument(!0).then(onSuccess, onFailure);
                              }))
                            : onFailure(t);
                      },
                      onFailure,
                    );
                }
                ensureNotTerminated(),
                  getPdfManager(t, {
                    maxImageSize: t.maxImageSize,
                    disableFontFace: t.disableFontFace,
                    ignoreErrors: t.ignoreErrors,
                    isEvalSupported: t.isEvalSupported,
                    fontExtraProperties: t.fontExtraProperties,
                  })
                    .then(function (t) {
                      if (u)
                        throw (
                          (t.terminate(
                            new o.AbortException("Worker was terminated."),
                          ),
                          new Error("Worker was terminated"))
                        );
                      (a = t).onLoadedStream().then(function (t) {
                        A.send("DataLoaded", { length: t.bytes.byteLength });
                      });
                    })
                    .then(pdfManagerReady, onFailure);
              })(t),
                (t = null);
            }),
            _
          );
        },
        initializeFromPort: function initializeFromPort(t) {
          var r = new h.MessageHandler("worker", "main", t);
          g.setup(r, t), r.send("ready", null);
        },
      };
      (r.WorkerMessageHandler = g),
        "undefined" == typeof window &&
          !u.isNodeJS &&
          "undefined" != typeof self &&
          (function isMessagePort(t) {
            return "function" == typeof t.postMessage && "onmessage" in t;
          })(self) &&
          g.initializeFromPort(self);
    },
    function (t, r, a) {
      "use strict";
      t.exports = a(3);
    },
    function (t, r, a) {
      "use strict";
      (function (t) {
        function _typeof(t) {
          return (_typeof =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function _typeof(t) {
                  return typeof t;
                }
              : function _typeof(t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                })(t);
        }
        var r = (function (t) {
          var r,
            a = Object.prototype,
            i = a.hasOwnProperty,
            o = "function" == typeof Symbol ? Symbol : {},
            l = o.iterator || "@@iterator",
            c = o.asyncIterator || "@@asyncIterator",
            u = o.toStringTag || "@@toStringTag";
          function wrap(t, r, a, i) {
            var o = r && r.prototype instanceof Generator ? r : Generator,
              l = Object.create(o.prototype),
              c = new Context(i || []);
            return (
              (l._invoke = (function makeInvokeMethod(t, r, a) {
                var i = h;
                return function invoke(o, l) {
                  if (i === p) throw new Error("Generator is already running");
                  if (i === m) {
                    if ("throw" === o) throw l;
                    return doneResult();
                  }
                  for (a.method = o, a.arg = l; ; ) {
                    var c = a.delegate;
                    if (c) {
                      var u = maybeInvokeDelegate(c, a);
                      if (u) {
                        if (u === g) continue;
                        return u;
                      }
                    }
                    if ("next" === a.method) a.sent = a._sent = a.arg;
                    else if ("throw" === a.method) {
                      if (i === h) throw ((i = m), a.arg);
                      a.dispatchException(a.arg);
                    } else "return" === a.method && a.abrupt("return", a.arg);
                    i = p;
                    var b = tryCatch(t, r, a);
                    if ("normal" === b.type) {
                      if (((i = a.done ? m : d), b.arg === g)) continue;
                      return { value: b.arg, done: a.done };
                    }
                    "throw" === b.type &&
                      ((i = m), (a.method = "throw"), (a.arg = b.arg));
                  }
                };
              })(t, a, c)),
              l
            );
          }
          function tryCatch(t, r, a) {
            try {
              return { type: "normal", arg: t.call(r, a) };
            } catch (t) {
              return { type: "throw", arg: t };
            }
          }
          t.wrap = wrap;
          var h = "suspendedStart",
            d = "suspendedYield",
            p = "executing",
            m = "completed",
            g = {};
          function Generator() {}
          function GeneratorFunction() {}
          function GeneratorFunctionPrototype() {}
          var b = {};
          b[l] = function () {
            return this;
          };
          var y = Object.getPrototypeOf,
            v = y && y(y(values([])));
          v && v !== a && i.call(v, l) && (b = v);
          var S =
            (GeneratorFunctionPrototype.prototype =
            Generator.prototype =
              Object.create(b));
          function defineIteratorMethods(t) {
            ["next", "throw", "return"].forEach(function (r) {
              t[r] = function (t) {
                return this._invoke(r, t);
              };
            });
          }
          function AsyncIterator(t, r) {
            function invoke(a, o, l, c) {
              var u = tryCatch(t[a], t, o);
              if ("throw" !== u.type) {
                var h = u.arg,
                  d = h.value;
                return d && "object" === _typeof(d) && i.call(d, "__await")
                  ? r.resolve(d.__await).then(
                      function (t) {
                        invoke("next", t, l, c);
                      },
                      function (t) {
                        invoke("throw", t, l, c);
                      },
                    )
                  : r.resolve(d).then(
                      function (t) {
                        (h.value = t), l(h);
                      },
                      function (t) {
                        return invoke("throw", t, l, c);
                      },
                    );
              }
              c(u.arg);
            }
            var a;
            this._invoke = function enqueue(t, i) {
              function callInvokeWithMethodAndArg() {
                return new r(function (r, a) {
                  invoke(t, i, r, a);
                });
              }
              return (a = a
                ? a.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg)
                : callInvokeWithMethodAndArg());
            };
          }
          function maybeInvokeDelegate(t, a) {
            var i = t.iterator[a.method];
            if (i === r) {
              if (((a.delegate = null), "throw" === a.method)) {
                if (
                  t.iterator.return &&
                  ((a.method = "return"),
                  (a.arg = r),
                  maybeInvokeDelegate(t, a),
                  "throw" === a.method)
                )
                  return g;
                (a.method = "throw"),
                  (a.arg = new TypeError(
                    "The iterator does not provide a 'throw' method",
                  ));
              }
              return g;
            }
            var o = tryCatch(i, t.iterator, a.arg);
            if ("throw" === o.type)
              return (
                (a.method = "throw"), (a.arg = o.arg), (a.delegate = null), g
              );
            var l = o.arg;
            return l
              ? l.done
                ? ((a[t.resultName] = l.value),
                  (a.next = t.nextLoc),
                  "return" !== a.method && ((a.method = "next"), (a.arg = r)),
                  (a.delegate = null),
                  g)
                : l
              : ((a.method = "throw"),
                (a.arg = new TypeError("iterator result is not an object")),
                (a.delegate = null),
                g);
          }
          function pushTryEntry(t) {
            var r = { tryLoc: t[0] };
            1 in t && (r.catchLoc = t[1]),
              2 in t && ((r.finallyLoc = t[2]), (r.afterLoc = t[3])),
              this.tryEntries.push(r);
          }
          function resetTryEntry(t) {
            var r = t.completion || {};
            (r.type = "normal"), delete r.arg, (t.completion = r);
          }
          function Context(t) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(pushTryEntry, this),
              this.reset(!0);
          }
          function values(t) {
            if (t) {
              var a = t[l];
              if (a) return a.call(t);
              if ("function" == typeof t.next) return t;
              if (!isNaN(t.length)) {
                var o = -1,
                  c = function next() {
                    for (; ++o < t.length; )
                      if (i.call(t, o))
                        return (next.value = t[o]), (next.done = !1), next;
                    return (next.value = r), (next.done = !0), next;
                  };
                return (c.next = c);
              }
            }
            return { next: doneResult };
          }
          function doneResult() {
            return { value: r, done: !0 };
          }
          return (
            (GeneratorFunction.prototype = S.constructor =
              GeneratorFunctionPrototype),
            (GeneratorFunctionPrototype.constructor = GeneratorFunction),
            (GeneratorFunctionPrototype[u] = GeneratorFunction.displayName =
              "GeneratorFunction"),
            (t.isGeneratorFunction = function (t) {
              var r = "function" == typeof t && t.constructor;
              return (
                !!r &&
                (r === GeneratorFunction ||
                  "GeneratorFunction" === (r.displayName || r.name))
              );
            }),
            (t.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
                  : ((t.__proto__ = GeneratorFunctionPrototype),
                    u in t || (t[u] = "GeneratorFunction")),
                (t.prototype = Object.create(S)),
                t
              );
            }),
            (t.awrap = function (t) {
              return { __await: t };
            }),
            defineIteratorMethods(AsyncIterator.prototype),
            (AsyncIterator.prototype[c] = function () {
              return this;
            }),
            (t.AsyncIterator = AsyncIterator),
            (t.async = function (r, a, i, o, l) {
              void 0 === l && (l = Promise);
              var c = new AsyncIterator(wrap(r, a, i, o), l);
              return t.isGeneratorFunction(a)
                ? c
                : c.next().then(function (t) {
                    return t.done ? t.value : c.next();
                  });
            }),
            defineIteratorMethods(S),
            (S[u] = "Generator"),
            (S[l] = function () {
              return this;
            }),
            (S.toString = function () {
              return "[object Generator]";
            }),
            (t.keys = function (t) {
              var r = [];
              for (var a in t) r.push(a);
              return (
                r.reverse(),
                function next() {
                  for (; r.length; ) {
                    var a = r.pop();
                    if (a in t) return (next.value = a), (next.done = !1), next;
                  }
                  return (next.done = !0), next;
                }
              );
            }),
            (t.values = values),
            (Context.prototype = {
              constructor: Context,
              reset: function reset(t) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = r),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = r),
                  this.tryEntries.forEach(resetTryEntry),
                  !t)
                )
                  for (var a in this)
                    "t" === a.charAt(0) &&
                      i.call(this, a) &&
                      !isNaN(+a.slice(1)) &&
                      (this[a] = r);
              },
              stop: function stop() {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(t) {
                if (this.done) throw t;
                var a = this;
                function handle(i, o) {
                  return (
                    (c.type = "throw"),
                    (c.arg = t),
                    (a.next = i),
                    o && ((a.method = "next"), (a.arg = r)),
                    !!o
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var l = this.tryEntries[o],
                    c = l.completion;
                  if ("root" === l.tryLoc) return handle("end");
                  if (l.tryLoc <= this.prev) {
                    var u = i.call(l, "catchLoc"),
                      h = i.call(l, "finallyLoc");
                    if (u && h) {
                      if (this.prev < l.catchLoc) return handle(l.catchLoc, !0);
                      if (this.prev < l.finallyLoc) return handle(l.finallyLoc);
                    } else if (u) {
                      if (this.prev < l.catchLoc) return handle(l.catchLoc, !0);
                    } else {
                      if (!h)
                        throw new Error(
                          "try statement without catch or finally",
                        );
                      if (this.prev < l.finallyLoc) return handle(l.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(t, r) {
                for (var a = this.tryEntries.length - 1; a >= 0; --a) {
                  var o = this.tryEntries[a];
                  if (
                    o.tryLoc <= this.prev &&
                    i.call(o, "finallyLoc") &&
                    this.prev < o.finallyLoc
                  ) {
                    var l = o;
                    break;
                  }
                }
                l &&
                  ("break" === t || "continue" === t) &&
                  l.tryLoc <= r &&
                  r <= l.finallyLoc &&
                  (l = null);
                var c = l ? l.completion : {};
                return (
                  (c.type = t),
                  (c.arg = r),
                  l
                    ? ((this.method = "next"), (this.next = l.finallyLoc), g)
                    : this.complete(c)
                );
              },
              complete: function complete(t, r) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && r && (this.next = r),
                  g
                );
              },
              finish: function finish(t) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var a = this.tryEntries[r];
                  if (a.finallyLoc === t)
                    return (
                      this.complete(a.completion, a.afterLoc),
                      resetTryEntry(a),
                      g
                    );
                }
              },
              catch: function _catch(t) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var a = this.tryEntries[r];
                  if (a.tryLoc === t) {
                    var i = a.completion;
                    if ("throw" === i.type) {
                      var o = i.arg;
                      resetTryEntry(a);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(t, a, i) {
                return (
                  (this.delegate = {
                    iterator: values(t),
                    resultName: a,
                    nextLoc: i,
                  }),
                  "next" === this.method && (this.arg = r),
                  g
                );
              },
            }),
            t
          );
        })("object" === _typeof(t) ? t.exports : {});
        try {
          regeneratorRuntime = r;
        } catch (t) {
          Function("r", "regeneratorRuntime = r")(r);
        }
      }).call(this, a(4)(t));
    },
    function (t, r, a) {
      "use strict";
      t.exports = function (t) {
        return (
          t.webpackPolyfill ||
            ((t.deprecate = function () {}),
            (t.paths = []),
            t.children || (t.children = []),
            Object.defineProperty(t, "loaded", {
              enumerable: !0,
              get: function get() {
                return t.l;
              },
            }),
            Object.defineProperty(t, "id", {
              enumerable: !0,
              get: function get() {
                return t.i;
              },
            }),
            (t.webpackPolyfill = 1)),
          t
        );
      };
    },
    function (t, r, a) {
      "use strict";
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _inherits(t, r) {
        if ("function" != typeof r && null !== r)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (t.prototype = Object.create(r && r.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          r && _setPrototypeOf(t, r);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.arrayByteLength = arrayByteLength),
        (r.arraysToBytes = function arraysToBytes(t) {
          var r = t.length;
          if (1 === r && t[0] instanceof Uint8Array) return t[0];
          for (var a = 0, i = 0; i < r; i++) a += arrayByteLength(t[i]);
          for (var o = 0, l = new Uint8Array(a), c = 0; c < r; c++) {
            var u = t[c];
            u instanceof Uint8Array ||
              (u = "string" == typeof u ? stringToBytes(u) : new Uint8Array(u));
            var h = u.byteLength;
            l.set(u, o), (o += h);
          }
          return l;
        }),
        (r.assert = assert),
        (r.bytesToString = function bytesToString(t) {
          assert(
            null !== t && "object" === _typeof(t) && void 0 !== t.length,
            "Invalid argument for bytesToString",
          );
          var r = t.length,
            a = 8192;
          if (r < a) return String.fromCharCode.apply(null, t);
          for (var i = [], o = 0; o < r; o += a) {
            var l = Math.min(o + a, r),
              c = t.subarray(o, l);
            i.push(String.fromCharCode.apply(null, c));
          }
          return i.join("");
        }),
        (r.createPromiseCapability = function createPromiseCapability() {
          var t = Object.create(null),
            r = !1;
          return (
            Object.defineProperty(t, "settled", {
              get: function get() {
                return r;
              },
            }),
            (t.promise = new Promise(function (a, i) {
              (t.resolve = function (t) {
                (r = !0), a(t);
              }),
                (t.reject = function (t) {
                  (r = !0), i(t);
                });
            })),
            t
          );
        }),
        (r.getVerbosityLevel = function getVerbosityLevel() {
          return o;
        }),
        (r.info = function info(t) {
          o >= i.INFOS && console.log("Info: ".concat(t));
        }),
        (r.isArrayBuffer = function isArrayBuffer(t) {
          return (
            "object" === _typeof(t) && null !== t && void 0 !== t.byteLength
          );
        }),
        (r.isArrayEqual = function isArrayEqual(t, r) {
          if (t.length !== r.length) return !1;
          return t.every(function (t, a) {
            return t === r[a];
          });
        }),
        (r.isBool = function isBool(t) {
          return "boolean" == typeof t;
        }),
        (r.isEmptyObj = function isEmptyObj(t) {
          for (var r in t) return !1;
          return !0;
        }),
        (r.isNum = function isNum(t) {
          return "number" == typeof t;
        }),
        (r.isString = function isString(t) {
          return "string" == typeof t;
        }),
        (r.isSameOrigin = function isSameOrigin(t, r) {
          var a;
          try {
            if (!(a = new URL(t)).origin || "null" === a.origin) return !1;
          } catch (t) {
            return !1;
          }
          var i = new URL(r, a);
          return a.origin === i.origin;
        }),
        (r.createValidAbsoluteUrl = function createValidAbsoluteUrl(t, r) {
          if (!t) return null;
          try {
            var a = r ? new URL(t, r) : new URL(t);
            if (
              (function _isValidProtocol(t) {
                if (!t) return !1;
                switch (t.protocol) {
                  case "http:":
                  case "https:":
                  case "ftp:":
                  case "mailto:":
                  case "tel:":
                    return !0;
                  default:
                    return !1;
                }
              })(a)
            )
              return a;
          } catch (t) {}
          return null;
        }),
        (r.removeNullCharacters = function removeNullCharacters(t) {
          if ("string" != typeof t)
            return (
              warn("The argument for removeNullCharacters must be a string."), t
            );
          return t.replace(b, "");
        }),
        (r.setVerbosityLevel = function setVerbosityLevel(t) {
          Number.isInteger(t) && (o = t);
        }),
        (r.shadow = shadow),
        (r.string32 = function string32(t) {
          return String.fromCharCode(
            (t >> 24) & 255,
            (t >> 16) & 255,
            (t >> 8) & 255,
            255 & t,
          );
        }),
        (r.stringToBytes = stringToBytes),
        (r.stringToPDFString = function stringToPDFString(t) {
          var r = t.length,
            a = [];
          if ("þ" === t[0] && "ÿ" === t[1])
            for (var i = 2; i < r; i += 2)
              a.push(
                String.fromCharCode(
                  (t.charCodeAt(i) << 8) | t.charCodeAt(i + 1),
                ),
              );
          else if ("ÿ" === t[0] && "þ" === t[1])
            for (var o = 2; o < r; o += 2)
              a.push(
                String.fromCharCode(
                  (t.charCodeAt(o + 1) << 8) | t.charCodeAt(o),
                ),
              );
          else
            for (var l = 0; l < r; ++l) {
              var c = w[t.charCodeAt(l)];
              a.push(c ? String.fromCharCode(c) : t.charAt(l));
            }
          return a.join("");
        }),
        (r.stringToUTF8String = function stringToUTF8String(t) {
          return decodeURIComponent(escape(t));
        }),
        (r.utf8StringToString = function utf8StringToString(t) {
          return unescape(encodeURIComponent(t));
        }),
        (r.warn = warn),
        (r.unreachable = unreachable),
        (r.IsEvalSupportedCached =
          r.IsLittleEndianCached =
          r.createObjectURL =
          r.FormatError =
          r.Util =
          r.UnknownErrorException =
          r.UnexpectedResponseException =
          r.TextRenderingMode =
          r.StreamType =
          r.PermissionFlag =
          r.PasswordResponses =
          r.PasswordException =
          r.MissingPDFException =
          r.InvalidPDFException =
          r.AbortException =
          r.CMapCompressionType =
          r.ImageKind =
          r.FontType =
          r.AnnotationType =
          r.AnnotationStateModelType =
          r.AnnotationReviewState =
          r.AnnotationReplyType =
          r.AnnotationMarkedState =
          r.AnnotationFlag =
          r.AnnotationFieldFlag =
          r.AnnotationBorderStyleType =
          r.UNSUPPORTED_FEATURES =
          r.VerbosityLevel =
          r.OPS =
          r.IDENTITY_MATRIX =
          r.FONT_IDENTITY_MATRIX =
          r.BaseException =
            void 0),
        a(6);
      r.IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
      r.FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
      r.PermissionFlag = {
        PRINT: 4,
        MODIFY_CONTENTS: 8,
        COPY: 16,
        MODIFY_ANNOTATIONS: 32,
        FILL_INTERACTIVE_FORMS: 256,
        COPY_FOR_ACCESSIBILITY: 512,
        ASSEMBLE: 1024,
        PRINT_HIGH_QUALITY: 2048,
      };
      r.TextRenderingMode = {
        FILL: 0,
        STROKE: 1,
        FILL_STROKE: 2,
        INVISIBLE: 3,
        FILL_ADD_TO_PATH: 4,
        STROKE_ADD_TO_PATH: 5,
        FILL_STROKE_ADD_TO_PATH: 6,
        ADD_TO_PATH: 7,
        FILL_STROKE_MASK: 3,
        ADD_TO_PATH_FLAG: 4,
      };
      r.ImageKind = { GRAYSCALE_1BPP: 1, RGB_24BPP: 2, RGBA_32BPP: 3 };
      r.AnnotationType = {
        TEXT: 1,
        LINK: 2,
        FREETEXT: 3,
        LINE: 4,
        SQUARE: 5,
        CIRCLE: 6,
        POLYGON: 7,
        POLYLINE: 8,
        HIGHLIGHT: 9,
        UNDERLINE: 10,
        SQUIGGLY: 11,
        STRIKEOUT: 12,
        STAMP: 13,
        CARET: 14,
        INK: 15,
        POPUP: 16,
        FILEATTACHMENT: 17,
        SOUND: 18,
        MOVIE: 19,
        WIDGET: 20,
        SCREEN: 21,
        PRINTERMARK: 22,
        TRAPNET: 23,
        WATERMARK: 24,
        THREED: 25,
        REDACT: 26,
      };
      r.AnnotationStateModelType = { MARKED: "Marked", REVIEW: "Review" };
      r.AnnotationMarkedState = { MARKED: "Marked", UNMARKED: "Unmarked" };
      r.AnnotationReviewState = {
        ACCEPTED: "Accepted",
        REJECTED: "Rejected",
        CANCELLED: "Cancelled",
        COMPLETED: "Completed",
        NONE: "None",
      };
      r.AnnotationReplyType = { GROUP: "Group", REPLY: "R" };
      r.AnnotationFlag = {
        INVISIBLE: 1,
        HIDDEN: 2,
        PRINT: 4,
        NOZOOM: 8,
        NOROTATE: 16,
        NOVIEW: 32,
        READONLY: 64,
        LOCKED: 128,
        TOGGLENOVIEW: 256,
        LOCKEDCONTENTS: 512,
      };
      r.AnnotationFieldFlag = {
        READONLY: 1,
        REQUIRED: 2,
        NOEXPORT: 4,
        MULTILINE: 4096,
        PASSWORD: 8192,
        NOTOGGLETOOFF: 16384,
        RADIO: 32768,
        PUSHBUTTON: 65536,
        COMBO: 131072,
        EDIT: 262144,
        SORT: 524288,
        FILESELECT: 1048576,
        MULTISELECT: 2097152,
        DONOTSPELLCHECK: 4194304,
        DONOTSCROLL: 8388608,
        COMB: 16777216,
        RICHTEXT: 33554432,
        RADIOSINUNISON: 33554432,
        COMMITONSELCHANGE: 67108864,
      };
      r.AnnotationBorderStyleType = {
        SOLID: 1,
        DASHED: 2,
        BEVELED: 3,
        INSET: 4,
        UNDERLINE: 5,
      };
      r.StreamType = {
        UNKNOWN: "UNKNOWN",
        FLATE: "FLATE",
        LZW: "LZW",
        DCT: "DCT",
        JPX: "JPX",
        JBIG: "JBIG",
        A85: "A85",
        AHX: "AHX",
        CCF: "CCF",
        RLX: "RLX",
      };
      r.FontType = {
        UNKNOWN: "UNKNOWN",
        TYPE1: "TYPE1",
        TYPE1C: "TYPE1C",
        CIDFONTTYPE0: "CIDFONTTYPE0",
        CIDFONTTYPE0C: "CIDFONTTYPE0C",
        TRUETYPE: "TRUETYPE",
        CIDFONTTYPE2: "CIDFONTTYPE2",
        TYPE3: "TYPE3",
        OPENTYPE: "OPENTYPE",
        TYPE0: "TYPE0",
        MMTYPE1: "MMTYPE1",
      };
      var i = { ERRORS: 0, WARNINGS: 1, INFOS: 5 };
      r.VerbosityLevel = i;
      r.CMapCompressionType = { NONE: 0, BINARY: 1, STREAM: 2 };
      r.OPS = {
        dependency: 1,
        setLineWidth: 2,
        setLineCap: 3,
        setLineJoin: 4,
        setMiterLimit: 5,
        setDash: 6,
        setRenderingIntent: 7,
        setFlatness: 8,
        setGState: 9,
        save: 10,
        restore: 11,
        transform: 12,
        moveTo: 13,
        lineTo: 14,
        curveTo: 15,
        curveTo2: 16,
        curveTo3: 17,
        closePath: 18,
        rectangle: 19,
        stroke: 20,
        closeStroke: 21,
        fill: 22,
        eoFill: 23,
        fillStroke: 24,
        eoFillStroke: 25,
        closeFillStroke: 26,
        closeEOFillStroke: 27,
        endPath: 28,
        clip: 29,
        eoClip: 30,
        beginText: 31,
        endText: 32,
        setCharSpacing: 33,
        setWordSpacing: 34,
        setHScale: 35,
        setLeading: 36,
        setFont: 37,
        setTextRenderingMode: 38,
        setTextRise: 39,
        moveText: 40,
        setLeadingMoveText: 41,
        setTextMatrix: 42,
        nextLine: 43,
        showText: 44,
        showSpacedText: 45,
        nextLineShowText: 46,
        nextLineSetSpacingShowText: 47,
        setCharWidth: 48,
        setCharWidthAndBounds: 49,
        setStrokeColorSpace: 50,
        setFillColorSpace: 51,
        setStrokeColor: 52,
        setStrokeColorN: 53,
        setFillColor: 54,
        setFillColorN: 55,
        setStrokeGray: 56,
        setFillGray: 57,
        setStrokeRGBColor: 58,
        setFillRGBColor: 59,
        setStrokeCMYKColor: 60,
        setFillCMYKColor: 61,
        shadingFill: 62,
        beginInlineImage: 63,
        beginImageData: 64,
        endInlineImage: 65,
        paintXObject: 66,
        markPoint: 67,
        markPointProps: 68,
        beginMarkedContent: 69,
        beginMarkedContentProps: 70,
        endMarkedContent: 71,
        beginCompat: 72,
        endCompat: 73,
        paintFormXObjectBegin: 74,
        paintFormXObjectEnd: 75,
        beginGroup: 76,
        endGroup: 77,
        beginAnnotations: 78,
        endAnnotations: 79,
        beginAnnotation: 80,
        endAnnotation: 81,
        paintJpegXObject: 82,
        paintImageMaskXObject: 83,
        paintImageMaskXObjectGroup: 84,
        paintImageXObject: 85,
        paintInlineImageXObject: 86,
        paintInlineImageXObjectGroup: 87,
        paintImageXObjectRepeat: 88,
        paintImageMaskXObjectRepeat: 89,
        paintSolidColorImageMask: 90,
        constructPath: 91,
      };
      r.UNSUPPORTED_FEATURES = {
        unknown: "unknown",
        forms: "forms",
        javaScript: "javaScript",
        smask: "smask",
        shadingPattern: "shadingPattern",
        font: "font",
        errorTilingPattern: "errorTilingPattern",
        errorExtGState: "errorExtGState",
        errorXObject: "errorXObject",
        errorFontLoadType3: "errorFontLoadType3",
        errorFontState: "errorFontState",
        errorFontMissing: "errorFontMissing",
        errorFontTranslate: "errorFontTranslate",
        errorColorSpace: "errorColorSpace",
        errorOperatorList: "errorOperatorList",
        errorFontToUnicode: "errorFontToUnicode",
        errorFontLoadNative: "errorFontLoadNative",
        errorFontGetPath: "errorFontGetPath",
      };
      r.PasswordResponses = { NEED_PASSWORD: 1, INCORRECT_PASSWORD: 2 };
      var o = i.WARNINGS;
      function warn(t) {
        o >= i.WARNINGS && console.log("Warning: ".concat(t));
      }
      function unreachable(t) {
        throw new Error(t);
      }
      function assert(t, r) {
        t || unreachable(r);
      }
      function shadow(t, r, a) {
        return (
          Object.defineProperty(t, r, {
            value: a,
            enumerable: !0,
            configurable: !0,
            writable: !1,
          }),
          a
        );
      }
      var l = (function BaseExceptionClosure() {
        function BaseException(t) {
          this.constructor === BaseException &&
            unreachable("Cannot initialize BaseException."),
            (this.message = t),
            (this.name = this.constructor.name);
        }
        return (
          (BaseException.prototype = new Error()),
          (BaseException.constructor = BaseException),
          BaseException
        );
      })();
      r.BaseException = l;
      var c = (function (t) {
        _inherits(PasswordException, t);
        var r = _createSuper(PasswordException);
        function PasswordException(t, a) {
          var i;
          return (
            _classCallCheck(this, PasswordException),
            ((i = r.call(this, t)).code = a),
            i
          );
        }
        return PasswordException;
      })(l);
      r.PasswordException = c;
      var u = (function (t) {
        _inherits(UnknownErrorException, t);
        var r = _createSuper(UnknownErrorException);
        function UnknownErrorException(t, a) {
          var i;
          return (
            _classCallCheck(this, UnknownErrorException),
            ((i = r.call(this, t)).details = a),
            i
          );
        }
        return UnknownErrorException;
      })(l);
      r.UnknownErrorException = u;
      var h = (function (t) {
        _inherits(InvalidPDFException, t);
        var r = _createSuper(InvalidPDFException);
        function InvalidPDFException() {
          return (
            _classCallCheck(this, InvalidPDFException), r.apply(this, arguments)
          );
        }
        return InvalidPDFException;
      })(l);
      r.InvalidPDFException = h;
      var d = (function (t) {
        _inherits(MissingPDFException, t);
        var r = _createSuper(MissingPDFException);
        function MissingPDFException() {
          return (
            _classCallCheck(this, MissingPDFException), r.apply(this, arguments)
          );
        }
        return MissingPDFException;
      })(l);
      r.MissingPDFException = d;
      var p = (function (t) {
        _inherits(UnexpectedResponseException, t);
        var r = _createSuper(UnexpectedResponseException);
        function UnexpectedResponseException(t, a) {
          var i;
          return (
            _classCallCheck(this, UnexpectedResponseException),
            ((i = r.call(this, t)).status = a),
            i
          );
        }
        return UnexpectedResponseException;
      })(l);
      r.UnexpectedResponseException = p;
      var m = (function (t) {
        _inherits(FormatError, t);
        var r = _createSuper(FormatError);
        function FormatError() {
          return _classCallCheck(this, FormatError), r.apply(this, arguments);
        }
        return FormatError;
      })(l);
      r.FormatError = m;
      var g = (function (t) {
        _inherits(AbortException, t);
        var r = _createSuper(AbortException);
        function AbortException() {
          return (
            _classCallCheck(this, AbortException), r.apply(this, arguments)
          );
        }
        return AbortException;
      })(l);
      r.AbortException = g;
      var b = /\x00/g;
      function stringToBytes(t) {
        assert("string" == typeof t, "Invalid argument for stringToBytes");
        for (var r = t.length, a = new Uint8Array(r), i = 0; i < r; ++i)
          a[i] = 255 & t.charCodeAt(i);
        return a;
      }
      function arrayByteLength(t) {
        return void 0 !== t.length
          ? t.length
          : (assert(
              void 0 !== t.byteLength,
              "arrayByteLength - invalid argument.",
            ),
            t.byteLength);
      }
      var y = {
        get value() {
          return shadow(
            this,
            "value",
            (function isLittleEndian() {
              var t = new Uint8Array(4);
              return (t[0] = 1), 1 === new Uint32Array(t.buffer, 0, 1)[0];
            })(),
          );
        },
      };
      r.IsLittleEndianCached = y;
      var v = {
        get value() {
          return shadow(
            this,
            "value",
            (function isEvalSupported() {
              try {
                return new Function(""), !0;
              } catch (t) {
                return !1;
              }
            })(),
          );
        },
      };
      r.IsEvalSupportedCached = v;
      var S = ["rgb(", 0, ",", 0, ",", 0, ")"],
        k = (function () {
          function Util() {
            _classCallCheck(this, Util);
          }
          return (
            (function _createClass(t, r, a) {
              return (
                r && _defineProperties(t.prototype, r),
                a && _defineProperties(t, a),
                t
              );
            })(Util, null, [
              {
                key: "makeCssRgb",
                value: function makeCssRgb(t, r, a) {
                  return (S[1] = t), (S[3] = r), (S[5] = a), S.join("");
                },
              },
              {
                key: "transform",
                value: function transform(t, r) {
                  return [
                    t[0] * r[0] + t[2] * r[1],
                    t[1] * r[0] + t[3] * r[1],
                    t[0] * r[2] + t[2] * r[3],
                    t[1] * r[2] + t[3] * r[3],
                    t[0] * r[4] + t[2] * r[5] + t[4],
                    t[1] * r[4] + t[3] * r[5] + t[5],
                  ];
                },
              },
              {
                key: "applyTransform",
                value: function applyTransform(t, r) {
                  return [
                    t[0] * r[0] + t[1] * r[2] + r[4],
                    t[0] * r[1] + t[1] * r[3] + r[5],
                  ];
                },
              },
              {
                key: "applyInverseTransform",
                value: function applyInverseTransform(t, r) {
                  var a = r[0] * r[3] - r[1] * r[2];
                  return [
                    (t[0] * r[3] - t[1] * r[2] + r[2] * r[5] - r[4] * r[3]) / a,
                    (-t[0] * r[1] + t[1] * r[0] + r[4] * r[1] - r[5] * r[0]) /
                      a,
                  ];
                },
              },
              {
                key: "getAxialAlignedBoundingBox",
                value: function getAxialAlignedBoundingBox(t, r) {
                  var a = Util.applyTransform(t, r),
                    i = Util.applyTransform(t.slice(2, 4), r),
                    o = Util.applyTransform([t[0], t[3]], r),
                    l = Util.applyTransform([t[2], t[1]], r);
                  return [
                    Math.min(a[0], i[0], o[0], l[0]),
                    Math.min(a[1], i[1], o[1], l[1]),
                    Math.max(a[0], i[0], o[0], l[0]),
                    Math.max(a[1], i[1], o[1], l[1]),
                  ];
                },
              },
              {
                key: "inverseTransform",
                value: function inverseTransform(t) {
                  var r = t[0] * t[3] - t[1] * t[2];
                  return [
                    t[3] / r,
                    -t[1] / r,
                    -t[2] / r,
                    t[0] / r,
                    (t[2] * t[5] - t[4] * t[3]) / r,
                    (t[4] * t[1] - t[5] * t[0]) / r,
                  ];
                },
              },
              {
                key: "apply3dTransform",
                value: function apply3dTransform(t, r) {
                  return [
                    t[0] * r[0] + t[1] * r[1] + t[2] * r[2],
                    t[3] * r[0] + t[4] * r[1] + t[5] * r[2],
                    t[6] * r[0] + t[7] * r[1] + t[8] * r[2],
                  ];
                },
              },
              {
                key: "singularValueDecompose2dScale",
                value: function singularValueDecompose2dScale(t) {
                  var r = [t[0], t[2], t[1], t[3]],
                    a = t[0] * r[0] + t[1] * r[2],
                    i = t[0] * r[1] + t[1] * r[3],
                    o = t[2] * r[0] + t[3] * r[2],
                    l = t[2] * r[1] + t[3] * r[3],
                    c = (a + l) / 2,
                    u = Math.sqrt((a + l) * (a + l) - 4 * (a * l - o * i)) / 2,
                    h = c + u || 1,
                    d = c - u || 1;
                  return [Math.sqrt(h), Math.sqrt(d)];
                },
              },
              {
                key: "normalizeRect",
                value: function normalizeRect(t) {
                  var r = t.slice(0);
                  return (
                    t[0] > t[2] && ((r[0] = t[2]), (r[2] = t[0])),
                    t[1] > t[3] && ((r[1] = t[3]), (r[3] = t[1])),
                    r
                  );
                },
              },
              {
                key: "intersect",
                value: function intersect(t, r) {
                  function compare(t, r) {
                    return t - r;
                  }
                  var a = [t[0], t[2], r[0], r[2]].sort(compare),
                    i = [t[1], t[3], r[1], r[3]].sort(compare),
                    o = [];
                  return (
                    (t = Util.normalizeRect(t)),
                    (r = Util.normalizeRect(r)),
                    (a[0] === t[0] && a[1] === r[0]) ||
                    (a[0] === r[0] && a[1] === t[0])
                      ? ((o[0] = a[1]),
                        (o[2] = a[2]),
                        (i[0] === t[1] && i[1] === r[1]) ||
                        (i[0] === r[1] && i[1] === t[1])
                          ? ((o[1] = i[1]), (o[3] = i[2]), o)
                          : null)
                      : null
                  );
                },
              },
            ]),
            Util
          );
        })();
      r.Util = k;
      var w = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212,
        8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217,
        8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353,
        382, 0, 8364,
      ];
      var C = (function createObjectURLClosure() {
        var t =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        return function createObjectURL(r, a) {
          var i =
            arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          if (!i && URL.createObjectURL) {
            var o = new Blob([r], { type: a });
            return URL.createObjectURL(o);
          }
          for (
            var l = "data:".concat(a, ";base64,"), c = 0, u = r.length;
            c < u;
            c += 3
          ) {
            var h = 255 & r[c],
              d = 255 & r[c + 1],
              p = 255 & r[c + 2],
              m = h >> 2,
              g = ((3 & h) << 4) | (d >> 4),
              b = c + 1 < u ? ((15 & d) << 2) | (p >> 6) : 64,
              y = c + 2 < u ? 63 & p : 64;
            l += t[m] + t[g] + t[b] + t[y];
          }
          return l;
        };
      })();
      r.createObjectURL = C;
    },
    function (t, r, a) {
      "use strict";
      var i = a(7);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      if (
        "undefined" == typeof globalThis ||
        !globalThis._pdfjsCompatibilityChecked
      ) {
        ("undefined" != typeof globalThis && globalThis.Math === Math) ||
          (globalThis = a(8)),
          (globalThis._pdfjsCompatibilityChecked = !0);
        var o =
            "object" ===
              ("undefined" == typeof window ? "undefined" : _typeof(window)) &&
            "object" ===
              ("undefined" == typeof document
                ? "undefined"
                : _typeof(document)),
          l = ("undefined" != typeof navigator && navigator.userAgent) || "",
          c = /Trident/.test(l);
        !(function checkNodeBtoa() {
          !globalThis.btoa &&
            i.isNodeJS &&
            (globalThis.btoa = function (t) {
              return Buffer.from(t, "binary").toString("base64");
            });
        })(),
          (function checkNodeAtob() {
            !globalThis.atob &&
              i.isNodeJS &&
              (globalThis.atob = function (t) {
                return Buffer.from(t, "base64").toString("binary");
              });
          })(),
          (function checkChildNodeRemove() {
            o &&
              void 0 === Element.prototype.remove &&
              (Element.prototype.remove = function () {
                this.parentNode && this.parentNode.removeChild(this);
              });
          })(),
          (function checkDOMTokenListAddRemove() {
            if (o && !i.isNodeJS) {
              var t = document.createElement("div");
              if (
                (t.classList.add("testOne", "testTwo"),
                !0 !== t.classList.contains("testOne") ||
                  !0 !== t.classList.contains("testTwo"))
              ) {
                var r = DOMTokenList.prototype.add,
                  a = DOMTokenList.prototype.remove;
                (DOMTokenList.prototype.add = function () {
                  for (
                    var t = arguments.length, a = new Array(t), i = 0;
                    i < t;
                    i++
                  )
                    a[i] = arguments[i];
                  for (var o = 0, l = a; o < l.length; o++) {
                    var c = l[o];
                    r.call(this, c);
                  }
                }),
                  (DOMTokenList.prototype.remove = function () {
                    for (
                      var t = arguments.length, r = new Array(t), i = 0;
                      i < t;
                      i++
                    )
                      r[i] = arguments[i];
                    for (var o = 0, l = r; o < l.length; o++) {
                      var c = l[o];
                      a.call(this, c);
                    }
                  });
              }
            }
          })(),
          (function checkDOMTokenListToggle() {
            o &&
              !i.isNodeJS &&
              !1 !==
                document.createElement("div").classList.toggle("test", 0) &&
              (DOMTokenList.prototype.toggle = function (t) {
                var r =
                  arguments.length > 1 ? !!arguments[1] : !this.contains(t);
                return this[r ? "add" : "remove"](t), r;
              });
          })(),
          (function checkWindowHistoryPushStateReplaceState() {
            if (o && c) {
              var t = window.history.pushState,
                r = window.history.replaceState;
              (window.history.pushState = function (r, a, i) {
                var o = void 0 === i ? [r, a] : [r, a, i];
                t.apply(this, o);
              }),
                (window.history.replaceState = function (t, a, i) {
                  var o = void 0 === i ? [t, a] : [t, a, i];
                  r.apply(this, o);
                });
            }
          })(),
          (function checkStringStartsWith() {
            String.prototype.startsWith || a(53);
          })(),
          (function checkStringEndsWith() {
            String.prototype.endsWith || a(64);
          })(),
          (function checkStringIncludes() {
            String.prototype.includes || a(66);
          })(),
          (function checkArrayIncludes() {
            Array.prototype.includes || a(68);
          })(),
          (function checkArrayFrom() {
            Array.from || a(76);
          })(),
          (function checkObjectAssign() {
            Object.assign || a(98);
          })(),
          (function checkMathLog2() {
            Math.log2 || (Math.log2 = a(101));
          })(),
          (function checkNumberIsNaN() {
            Number.isNaN || (Number.isNaN = a(103));
          })(),
          (function checkNumberIsInteger() {
            Number.isInteger || (Number.isInteger = a(105));
          })(),
          (function checkTypedArraySlice() {
            Uint8Array.prototype.slice || a(108);
          })(),
          (function checkPromise() {
            (globalThis.Promise && globalThis.Promise.allSettled) ||
              (globalThis.Promise = a(113));
          })(),
          (function checkURL() {
            globalThis.URL = a(136);
          })(),
          (function checkReadableStream() {
            var t = !1;
            if ("undefined" != typeof ReadableStream)
              try {
                new ReadableStream({
                  start: function start(t) {
                    t.close();
                  },
                }),
                  (t = !0);
              } catch (t) {}
            t || (globalThis.ReadableStream = a(143).ReadableStream);
          })(),
          (function checkMapEntries() {
            (globalThis.Map && globalThis.Map.prototype.entries) ||
              (globalThis.Map = a(144));
          })(),
          (function checkSetEntries() {
            (globalThis.Set && globalThis.Set.prototype.entries) ||
              (globalThis.Set = a(151));
          })(),
          (function checkWeakMap() {
            globalThis.WeakMap || (globalThis.WeakMap = a(153));
          })(),
          (function checkWeakSet() {
            globalThis.WeakSet || (globalThis.WeakSet = a(159));
          })(),
          (function checkStringCodePointAt() {
            String.prototype.codePointAt || a(161);
          })(),
          (function checkStringFromCodePoint() {
            String.fromCodePoint || (String.fromCodePoint = a(163));
          })(),
          (function checkSymbol() {
            globalThis.Symbol || a(165);
          })(),
          (function checkStringPadStart() {
            String.prototype.padStart || a(188);
          })(),
          (function checkStringPadEnd() {
            String.prototype.padEnd || a(193);
          })(),
          (function checkObjectValues() {
            Object.values || (Object.values = a(195));
          })();
      }
    },
    function (t, r, a) {
      "use strict";
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.isNodeJS = void 0);
      var i =
        "object" ===
          ("undefined" == typeof process ? "undefined" : _typeof(process)) &&
        process + "" == "[object process]" &&
        !process.versions.nw &&
        !process.versions.electron;
      r.isNodeJS = i;
    },
    function (t, r, a) {
      a(9), (t.exports = a(11));
    },
    function (t, r, a) {
      a(10)({ global: !0 }, { globalThis: a(11) });
    },
    function (t, r, a) {
      var i = a(11),
        o = a(12).f,
        l = a(26),
        c = a(29),
        u = a(30),
        h = a(40),
        d = a(52);
      t.exports = function (t, r) {
        var a,
          p,
          m,
          g,
          b,
          y = t.target,
          v = t.global,
          S = t.stat;
        if ((a = v ? i : S ? i[y] || u(y, {}) : (i[y] || {}).prototype))
          for (p in r) {
            if (
              ((g = r[p]),
              (m = t.noTargetGet ? (b = o(a, p)) && b.value : a[p]),
              !d(v ? p : y + (S ? "." : "#") + p, t.forced) && void 0 !== m)
            ) {
              if (typeof g == typeof m) continue;
              h(g, m);
            }
            (t.sham || (m && m.sham)) && l(g, "sham", !0), c(a, p, g, t);
          }
      };
    },
    function (t, r) {
      var check = function (t) {
        return t && t.Math == Math && t;
      };
      t.exports =
        check("object" == typeof globalThis && globalThis) ||
        check("object" == typeof window && window) ||
        check("object" == typeof self && self) ||
        check("object" == typeof global && global) ||
        Function("return this")();
    },
    function (t, r, a) {
      var i = a(13),
        o = a(15),
        l = a(16),
        c = a(17),
        u = a(21),
        h = a(23),
        d = a(24),
        p = Object.getOwnPropertyDescriptor;
      r.f = i
        ? p
        : function getOwnPropertyDescriptor(t, r) {
            if (((t = c(t)), (r = u(r, !0)), d))
              try {
                return p(t, r);
              } catch (t) {}
            if (h(t, r)) return l(!o.f.call(t, r), t[r]);
          };
    },
    function (t, r, a) {
      var i = a(14);
      t.exports = !i(function () {
        return (
          7 !=
          Object.defineProperty({}, 1, {
            get: function () {
              return 7;
            },
          })[1]
        );
      });
    },
    function (t, r) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (t) {
          return !0;
        }
      };
    },
    function (t, r, a) {
      "use strict";
      var i = {}.propertyIsEnumerable,
        o = Object.getOwnPropertyDescriptor,
        l = o && !i.call({ 1: 2 }, 1);
      r.f = l
        ? function propertyIsEnumerable(t) {
            var r = o(this, t);
            return !!r && r.enumerable;
          }
        : i;
    },
    function (t, r) {
      t.exports = function (t, r) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: r,
        };
      };
    },
    function (t, r, a) {
      var i = a(18),
        o = a(20);
      t.exports = function (t) {
        return i(o(t));
      };
    },
    function (t, r, a) {
      var i = a(14),
        o = a(19),
        l = "".split;
      t.exports = i(function () {
        return !Object("z").propertyIsEnumerable(0);
      })
        ? function (t) {
            return "String" == o(t) ? l.call(t, "") : Object(t);
          }
        : Object;
    },
    function (t, r) {
      var a = {}.toString;
      t.exports = function (t) {
        return a.call(t).slice(8, -1);
      };
    },
    function (t, r) {
      t.exports = function (t) {
        if (null == t) throw TypeError("Can't call method on " + t);
        return t;
      };
    },
    function (t, r, a) {
      var i = a(22);
      t.exports = function (t, r) {
        if (!i(t)) return t;
        var a, o;
        if (r && "function" == typeof (a = t.toString) && !i((o = a.call(t))))
          return o;
        if ("function" == typeof (a = t.valueOf) && !i((o = a.call(t))))
          return o;
        if (!r && "function" == typeof (a = t.toString) && !i((o = a.call(t))))
          return o;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    function (t, r) {
      t.exports = function (t) {
        return "object" == typeof t ? null !== t : "function" == typeof t;
      };
    },
    function (t, r) {
      var a = {}.hasOwnProperty;
      t.exports = function (t, r) {
        return a.call(t, r);
      };
    },
    function (t, r, a) {
      var i = a(13),
        o = a(14),
        l = a(25);
      t.exports =
        !i &&
        !o(function () {
          return (
            7 !=
            Object.defineProperty(l("div"), "a", {
              get: function () {
                return 7;
              },
            }).a
          );
        });
    },
    function (t, r, a) {
      var i = a(11),
        o = a(22),
        l = i.document,
        c = o(l) && o(l.createElement);
      t.exports = function (t) {
        return c ? l.createElement(t) : {};
      };
    },
    function (t, r, a) {
      var i = a(13),
        o = a(27),
        l = a(16);
      t.exports = i
        ? function (t, r, a) {
            return o.f(t, r, l(1, a));
          }
        : function (t, r, a) {
            return (t[r] = a), t;
          };
    },
    function (t, r, a) {
      var i = a(13),
        o = a(24),
        l = a(28),
        c = a(21),
        u = Object.defineProperty;
      r.f = i
        ? u
        : function defineProperty(t, r, a) {
            if ((l(t), (r = c(r, !0)), l(a), o))
              try {
                return u(t, r, a);
              } catch (t) {}
            if ("get" in a || "set" in a)
              throw TypeError("Accessors not supported");
            return "value" in a && (t[r] = a.value), t;
          };
    },
    function (t, r, a) {
      var i = a(22);
      t.exports = function (t) {
        if (!i(t)) throw TypeError(String(t) + " is not an object");
        return t;
      };
    },
    function (t, r, a) {
      var i = a(11),
        o = a(26),
        l = a(23),
        c = a(30),
        u = a(31),
        h = a(33),
        d = h.get,
        p = h.enforce,
        m = String(String).split("String");
      (t.exports = function (t, r, a, u) {
        var h = !!u && !!u.unsafe,
          d = !!u && !!u.enumerable,
          g = !!u && !!u.noTargetGet;
        "function" == typeof a &&
          ("string" != typeof r || l(a, "name") || o(a, "name", r),
          (p(a).source = m.join("string" == typeof r ? r : ""))),
          t !== i
            ? (h ? !g && t[r] && (d = !0) : delete t[r],
              d ? (t[r] = a) : o(t, r, a))
            : d
            ? (t[r] = a)
            : c(r, a);
      })(Function.prototype, "toString", function toString() {
        return ("function" == typeof this && d(this).source) || u(this);
      });
    },
    function (t, r, a) {
      var i = a(11),
        o = a(26);
      t.exports = function (t, r) {
        try {
          o(i, t, r);
        } catch (a) {
          i[t] = r;
        }
        return r;
      };
    },
    function (t, r, a) {
      var i = a(32),
        o = Function.toString;
      "function" != typeof i.inspectSource &&
        (i.inspectSource = function (t) {
          return o.call(t);
        }),
        (t.exports = i.inspectSource);
    },
    function (t, r, a) {
      var i = a(11),
        o = a(30),
        l = "__core-js_shared__",
        c = i[l] || o(l, {});
      t.exports = c;
    },
    function (t, r, a) {
      var i,
        o,
        l,
        c = a(34),
        u = a(11),
        h = a(22),
        d = a(26),
        p = a(23),
        m = a(35),
        g = a(39),
        b = u.WeakMap;
      if (c) {
        var y = new b(),
          v = y.get,
          S = y.has,
          k = y.set;
        (i = function (t, r) {
          return k.call(y, t, r), r;
        }),
          (o = function (t) {
            return v.call(y, t) || {};
          }),
          (l = function (t) {
            return S.call(y, t);
          });
      } else {
        var w = m("state");
        (g[w] = !0),
          (i = function (t, r) {
            return d(t, w, r), r;
          }),
          (o = function (t) {
            return p(t, w) ? t[w] : {};
          }),
          (l = function (t) {
            return p(t, w);
          });
      }
      t.exports = {
        set: i,
        get: o,
        has: l,
        enforce: function (t) {
          return l(t) ? o(t) : i(t, {});
        },
        getterFor: function (t) {
          return function (r) {
            var a;
            if (!h(r) || (a = o(r)).type !== t)
              throw TypeError("Incompatible receiver, " + t + " required");
            return a;
          };
        },
      };
    },
    function (t, r, a) {
      var i = a(11),
        o = a(31),
        l = i.WeakMap;
      t.exports = "function" == typeof l && /native code/.test(o(l));
    },
    function (t, r, a) {
      var i = a(36),
        o = a(38),
        l = i("keys");
      t.exports = function (t) {
        return l[t] || (l[t] = o(t));
      };
    },
    function (t, r, a) {
      var i = a(37),
        o = a(32);
      (t.exports = function (t, r) {
        return o[t] || (o[t] = void 0 !== r ? r : {});
      })("versions", []).push({
        version: "3.6.5",
        mode: i ? "pure" : "global",
        copyright: "© 2020 Denis Pushkarev (zloirock.ru)",
      });
    },
    function (t, r) {
      t.exports = !1;
    },
    function (t, r) {
      var a = 0,
        i = Math.random();
      t.exports = function (t) {
        return (
          "Symbol(" +
          String(void 0 === t ? "" : t) +
          ")_" +
          (++a + i).toString(36)
        );
      };
    },
    function (t, r) {
      t.exports = {};
    },
    function (t, r, a) {
      var i = a(23),
        o = a(41),
        l = a(12),
        c = a(27);
      t.exports = function (t, r) {
        for (var a = o(r), u = c.f, h = l.f, d = 0; d < a.length; d++) {
          var p = a[d];
          i(t, p) || u(t, p, h(r, p));
        }
      };
    },
    function (t, r, a) {
      var i = a(42),
        o = a(44),
        l = a(51),
        c = a(28);
      t.exports =
        i("Reflect", "ownKeys") ||
        function ownKeys(t) {
          var r = o.f(c(t)),
            a = l.f;
          return a ? r.concat(a(t)) : r;
        };
    },
    function (t, r, a) {
      var i = a(43),
        o = a(11),
        aFunction = function (t) {
          return "function" == typeof t ? t : void 0;
        };
      t.exports = function (t, r) {
        return arguments.length < 2
          ? aFunction(i[t]) || aFunction(o[t])
          : (i[t] && i[t][r]) || (o[t] && o[t][r]);
      };
    },
    function (t, r, a) {
      var i = a(11);
      t.exports = i;
    },
    function (t, r, a) {
      var i = a(45),
        o = a(50).concat("length", "prototype");
      r.f =
        Object.getOwnPropertyNames ||
        function getOwnPropertyNames(t) {
          return i(t, o);
        };
    },
    function (t, r, a) {
      var i = a(23),
        o = a(17),
        l = a(46).indexOf,
        c = a(39);
      t.exports = function (t, r) {
        var a,
          u = o(t),
          h = 0,
          d = [];
        for (a in u) !i(c, a) && i(u, a) && d.push(a);
        for (; r.length > h; ) i(u, (a = r[h++])) && (~l(d, a) || d.push(a));
        return d;
      };
    },
    function (t, r, a) {
      var i = a(17),
        o = a(47),
        l = a(49),
        createMethod = function (t) {
          return function (r, a, c) {
            var u,
              h = i(r),
              d = o(h.length),
              p = l(c, d);
            if (t && a != a) {
              for (; d > p; ) if ((u = h[p++]) != u) return !0;
            } else
              for (; d > p; p++)
                if ((t || p in h) && h[p] === a) return t || p || 0;
            return !t && -1;
          };
        };
      t.exports = { includes: createMethod(!0), indexOf: createMethod(!1) };
    },
    function (t, r, a) {
      var i = a(48),
        o = Math.min;
      t.exports = function (t) {
        return t > 0 ? o(i(t), 9007199254740991) : 0;
      };
    },
    function (t, r) {
      var a = Math.ceil,
        i = Math.floor;
      t.exports = function (t) {
        return isNaN((t = +t)) ? 0 : (t > 0 ? i : a)(t);
      };
    },
    function (t, r, a) {
      var i = a(48),
        o = Math.max,
        l = Math.min;
      t.exports = function (t, r) {
        var a = i(t);
        return a < 0 ? o(a + r, 0) : l(a, r);
      };
    },
    function (t, r) {
      t.exports = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf",
      ];
    },
    function (t, r) {
      r.f = Object.getOwnPropertySymbols;
    },
    function (t, r, a) {
      var i = a(14),
        o = /#|\.prototype\./,
        isForced = function (t, r) {
          var a = c[l(t)];
          return a == h || (a != u && ("function" == typeof r ? i(r) : !!r));
        },
        l = (isForced.normalize = function (t) {
          return String(t).replace(o, ".").toLowerCase();
        }),
        c = (isForced.data = {}),
        u = (isForced.NATIVE = "N"),
        h = (isForced.POLYFILL = "P");
      t.exports = isForced;
    },
    function (t, r, a) {
      a(54);
      var i = a(61);
      t.exports = i("String", "startsWith");
    },
    function (t, r, a) {
      "use strict";
      var i,
        o = a(10),
        l = a(12).f,
        c = a(47),
        u = a(55),
        h = a(20),
        d = a(60),
        p = a(37),
        m = "".startsWith,
        g = Math.min,
        b = d("startsWith");
      o(
        {
          target: "String",
          proto: !0,
          forced:
            !!(
              p ||
              b ||
              ((i = l(String.prototype, "startsWith")), !i || i.writable)
            ) && !b,
        },
        {
          startsWith: function startsWith(t) {
            var r = String(h(this));
            u(t);
            var a = c(
                g(arguments.length > 1 ? arguments[1] : void 0, r.length),
              ),
              i = String(t);
            return m ? m.call(r, i, a) : r.slice(a, a + i.length) === i;
          },
        },
      );
    },
    function (t, r, a) {
      var i = a(56);
      t.exports = function (t) {
        if (i(t))
          throw TypeError("The method doesn't accept regular expressions");
        return t;
      };
    },
    function (t, r, a) {
      var i = a(22),
        o = a(19),
        l = a(57)("match");
      t.exports = function (t) {
        var r;
        return i(t) && (void 0 !== (r = t[l]) ? !!r : "RegExp" == o(t));
      };
    },
    function (t, r, a) {
      var i = a(11),
        o = a(36),
        l = a(23),
        c = a(38),
        u = a(58),
        h = a(59),
        d = o("wks"),
        p = i.Symbol,
        m = h ? p : (p && p.withoutSetter) || c;
      t.exports = function (t) {
        return (
          l(d, t) || (u && l(p, t) ? (d[t] = p[t]) : (d[t] = m("Symbol." + t))),
          d[t]
        );
      };
    },
    function (t, r, a) {
      var i = a(14);
      t.exports =
        !!Object.getOwnPropertySymbols &&
        !i(function () {
          return !String(Symbol());
        });
    },
    function (t, r, a) {
      var i = a(58);
      t.exports = i && !Symbol.sham && "symbol" == typeof Symbol.iterator;
    },
    function (t, r, a) {
      var i = a(57)("match");
      t.exports = function (t) {
        var r = /./;
        try {
          "/./"[t](r);
        } catch (a) {
          try {
            return (r[i] = !1), "/./"[t](r);
          } catch (t) {}
        }
        return !1;
      };
    },
    function (t, r, a) {
      var i = a(11),
        o = a(62),
        l = Function.call;
      t.exports = function (t, r, a) {
        return o(l, i[t].prototype[r], a);
      };
    },
    function (t, r, a) {
      var i = a(63);
      t.exports = function (t, r, a) {
        if ((i(t), void 0 === r)) return t;
        switch (a) {
          case 0:
            return function () {
              return t.call(r);
            };
          case 1:
            return function (a) {
              return t.call(r, a);
            };
          case 2:
            return function (a, i) {
              return t.call(r, a, i);
            };
          case 3:
            return function (a, i, o) {
              return t.call(r, a, i, o);
            };
        }
        return function () {
          return t.apply(r, arguments);
        };
      };
    },
    function (t, r) {
      t.exports = function (t) {
        if ("function" != typeof t)
          throw TypeError(String(t) + " is not a function");
        return t;
      };
    },
    function (t, r, a) {
      a(65);
      var i = a(61);
      t.exports = i("String", "endsWith");
    },
    function (t, r, a) {
      "use strict";
      var i,
        o = a(10),
        l = a(12).f,
        c = a(47),
        u = a(55),
        h = a(20),
        d = a(60),
        p = a(37),
        m = "".endsWith,
        g = Math.min,
        b = d("endsWith");
      o(
        {
          target: "String",
          proto: !0,
          forced:
            !!(
              p ||
              b ||
              ((i = l(String.prototype, "endsWith")), !i || i.writable)
            ) && !b,
        },
        {
          endsWith: function endsWith(t) {
            var r = String(h(this));
            u(t);
            var a = arguments.length > 1 ? arguments[1] : void 0,
              i = c(r.length),
              o = void 0 === a ? i : g(c(a), i),
              l = String(t);
            return m ? m.call(r, l, o) : r.slice(o - l.length, o) === l;
          },
        },
      );
    },
    function (t, r, a) {
      a(67);
      var i = a(61);
      t.exports = i("String", "includes");
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(55),
        l = a(20);
      i(
        { target: "String", proto: !0, forced: !a(60)("includes") },
        {
          includes: function includes(t) {
            return !!~String(l(this)).indexOf(
              o(t),
              arguments.length > 1 ? arguments[1] : void 0,
            );
          },
        },
      );
    },
    function (t, r, a) {
      a(69);
      var i = a(61);
      t.exports = i("Array", "includes");
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(46).includes,
        l = a(70);
      i(
        {
          target: "Array",
          proto: !0,
          forced: !a(75)("indexOf", { ACCESSORS: !0, 1: 0 }),
        },
        {
          includes: function includes(t) {
            return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
          },
        },
      ),
        l("includes");
    },
    function (t, r, a) {
      var i = a(57),
        o = a(71),
        l = a(27),
        c = i("unscopables"),
        u = Array.prototype;
      null == u[c] && l.f(u, c, { configurable: !0, value: o(null) }),
        (t.exports = function (t) {
          u[c][t] = !0;
        });
    },
    function (t, r, a) {
      var i,
        o = a(28),
        l = a(72),
        c = a(50),
        u = a(39),
        h = a(74),
        d = a(25),
        p = a(35),
        m = p("IE_PROTO"),
        EmptyConstructor = function () {},
        scriptTag = function (t) {
          return "<script>" + t + "</" + "script>";
        },
        NullProtoObject = function () {
          try {
            i = document.domain && new ActiveXObject("htmlfile");
          } catch (t) {}
          var t, r;
          NullProtoObject = i
            ? (function (t) {
                t.write(scriptTag("")), t.close();
                var r = t.parentWindow.Object;
                return (t = null), r;
              })(i)
            : (((r = d("iframe")).style.display = "none"),
              h.appendChild(r),
              (r.src = String("javascript:")),
              (t = r.contentWindow.document).open(),
              t.write(scriptTag("document.F=Object")),
              t.close(),
              t.F);
          for (var a = c.length; a--; ) delete NullProtoObject.prototype[c[a]];
          return NullProtoObject();
        };
      (u[m] = !0),
        (t.exports =
          Object.create ||
          function create(t, r) {
            var a;
            return (
              null !== t
                ? ((EmptyConstructor.prototype = o(t)),
                  (a = new EmptyConstructor()),
                  (EmptyConstructor.prototype = null),
                  (a[m] = t))
                : (a = NullProtoObject()),
              void 0 === r ? a : l(a, r)
            );
          });
    },
    function (t, r, a) {
      var i = a(13),
        o = a(27),
        l = a(28),
        c = a(73);
      t.exports = i
        ? Object.defineProperties
        : function defineProperties(t, r) {
            l(t);
            for (var a, i = c(r), u = i.length, h = 0; u > h; )
              o.f(t, (a = i[h++]), r[a]);
            return t;
          };
    },
    function (t, r, a) {
      var i = a(45),
        o = a(50);
      t.exports =
        Object.keys ||
        function keys(t) {
          return i(t, o);
        };
    },
    function (t, r, a) {
      var i = a(42);
      t.exports = i("document", "documentElement");
    },
    function (t, r, a) {
      var i = a(13),
        o = a(14),
        l = a(23),
        c = Object.defineProperty,
        u = {},
        thrower = function (t) {
          throw t;
        };
      t.exports = function (t, r) {
        if (l(u, t)) return u[t];
        r || (r = {});
        var a = [][t],
          h = !!l(r, "ACCESSORS") && r.ACCESSORS,
          d = l(r, 0) ? r[0] : thrower,
          p = l(r, 1) ? r[1] : void 0;
        return (u[t] =
          !!a &&
          !o(function () {
            if (h && !i) return !0;
            var t = { length: -1 };
            h ? c(t, 1, { enumerable: !0, get: thrower }) : (t[1] = 1),
              a.call(t, d, p);
          }));
      };
    },
    function (t, r, a) {
      a(77), a(89);
      var i = a(43);
      t.exports = i.Array.from;
    },
    function (t, r, a) {
      "use strict";
      var i = a(78).charAt,
        o = a(33),
        l = a(79),
        c = "String Iterator",
        u = o.set,
        h = o.getterFor(c);
      l(
        String,
        "String",
        function (t) {
          u(this, { type: c, string: String(t), index: 0 });
        },
        function next() {
          var t,
            r = h(this),
            a = r.string,
            o = r.index;
          return o >= a.length
            ? { value: void 0, done: !0 }
            : ((t = i(a, o)), (r.index += t.length), { value: t, done: !1 });
        },
      );
    },
    function (t, r, a) {
      var i = a(48),
        o = a(20),
        createMethod = function (t) {
          return function (r, a) {
            var l,
              c,
              u = String(o(r)),
              h = i(a),
              d = u.length;
            return h < 0 || h >= d
              ? t
                ? ""
                : void 0
              : (l = u.charCodeAt(h)) < 55296 ||
                l > 56319 ||
                h + 1 === d ||
                (c = u.charCodeAt(h + 1)) < 56320 ||
                c > 57343
              ? t
                ? u.charAt(h)
                : l
              : t
              ? u.slice(h, h + 2)
              : c - 56320 + ((l - 55296) << 10) + 65536;
          };
        };
      t.exports = { codeAt: createMethod(!1), charAt: createMethod(!0) };
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(80),
        l = a(82),
        c = a(87),
        u = a(85),
        h = a(26),
        d = a(29),
        p = a(57),
        m = a(37),
        g = a(86),
        b = a(81),
        y = b.IteratorPrototype,
        v = b.BUGGY_SAFARI_ITERATORS,
        S = p("iterator"),
        k = "keys",
        w = "values",
        C = "entries",
        returnThis = function () {
          return this;
        };
      t.exports = function (t, r, a, p, b, x, _) {
        o(a, r, p);
        var A,
          R,
          T,
          getIterationMethod = function (t) {
            if (t === b && B) return B;
            if (!v && t in O) return O[t];
            switch (t) {
              case k:
                return function keys() {
                  return new a(this, t);
                };
              case w:
                return function values() {
                  return new a(this, t);
                };
              case C:
                return function entries() {
                  return new a(this, t);
                };
            }
            return function () {
              return new a(this);
            };
          },
          I = r + " Iterator",
          P = !1,
          O = t.prototype,
          E = O[S] || O["@@iterator"] || (b && O[b]),
          B = (!v && E) || getIterationMethod(b),
          D = ("Array" == r && O.entries) || E;
        if (
          (D &&
            ((A = l(D.call(new t()))),
            y !== Object.prototype &&
              A.next &&
              (m ||
                l(A) === y ||
                (c
                  ? c(A, y)
                  : "function" != typeof A[S] && h(A, S, returnThis)),
              u(A, I, !0, !0),
              m && (g[I] = returnThis))),
          b == w &&
            E &&
            E.name !== w &&
            ((P = !0),
            (B = function values() {
              return E.call(this);
            })),
          (m && !_) || O[S] === B || h(O, S, B),
          (g[r] = B),
          b)
        )
          if (
            ((R = {
              values: getIterationMethod(w),
              keys: x ? B : getIterationMethod(k),
              entries: getIterationMethod(C),
            }),
            _)
          )
            for (T in R) (v || P || !(T in O)) && d(O, T, R[T]);
          else i({ target: r, proto: !0, forced: v || P }, R);
        return R;
      };
    },
    function (t, r, a) {
      "use strict";
      var i = a(81).IteratorPrototype,
        o = a(71),
        l = a(16),
        c = a(85),
        u = a(86),
        returnThis = function () {
          return this;
        };
      t.exports = function (t, r, a) {
        var h = r + " Iterator";
        return (
          (t.prototype = o(i, { next: l(1, a) })),
          c(t, h, !1, !0),
          (u[h] = returnThis),
          t
        );
      };
    },
    function (t, r, a) {
      "use strict";
      var i,
        o,
        l,
        c = a(82),
        u = a(26),
        h = a(23),
        d = a(57),
        p = a(37),
        m = d("iterator"),
        g = !1;
      [].keys &&
        ("next" in (l = [].keys())
          ? (o = c(c(l))) !== Object.prototype && (i = o)
          : (g = !0)),
        null == i && (i = {}),
        p ||
          h(i, m) ||
          u(i, m, function () {
            return this;
          }),
        (t.exports = { IteratorPrototype: i, BUGGY_SAFARI_ITERATORS: g });
    },
    function (t, r, a) {
      var i = a(23),
        o = a(83),
        l = a(35),
        c = a(84),
        u = l("IE_PROTO"),
        h = Object.prototype;
      t.exports = c
        ? Object.getPrototypeOf
        : function (t) {
            return (
              (t = o(t)),
              i(t, u)
                ? t[u]
                : "function" == typeof t.constructor &&
                  t instanceof t.constructor
                ? t.constructor.prototype
                : t instanceof Object
                ? h
                : null
            );
          };
    },
    function (t, r, a) {
      var i = a(20);
      t.exports = function (t) {
        return Object(i(t));
      };
    },
    function (t, r, a) {
      var i = a(14);
      t.exports = !i(function () {
        function F() {}
        return (
          (F.prototype.constructor = null),
          Object.getPrototypeOf(new F()) !== F.prototype
        );
      });
    },
    function (t, r, a) {
      var i = a(27).f,
        o = a(23),
        l = a(57)("toStringTag");
      t.exports = function (t, r, a) {
        t &&
          !o((t = a ? t : t.prototype), l) &&
          i(t, l, { configurable: !0, value: r });
      };
    },
    function (t, r) {
      t.exports = {};
    },
    function (t, r, a) {
      var i = a(28),
        o = a(88);
      t.exports =
        Object.setPrototypeOf ||
        ("__proto__" in {}
          ? (function () {
              var t,
                r = !1,
                a = {};
              try {
                (t = Object.getOwnPropertyDescriptor(
                  Object.prototype,
                  "__proto__",
                ).set).call(a, []),
                  (r = a instanceof Array);
              } catch (t) {}
              return function setPrototypeOf(a, l) {
                return i(a), o(l), r ? t.call(a, l) : (a.__proto__ = l), a;
              };
            })()
          : void 0);
    },
    function (t, r, a) {
      var i = a(22);
      t.exports = function (t) {
        if (!i(t) && null !== t)
          throw TypeError("Can't set " + String(t) + " as a prototype");
        return t;
      };
    },
    function (t, r, a) {
      var i = a(10),
        o = a(90);
      i(
        {
          target: "Array",
          stat: !0,
          forced: !a(97)(function (t) {
            Array.from(t);
          }),
        },
        { from: o },
      );
    },
    function (t, r, a) {
      "use strict";
      var i = a(62),
        o = a(83),
        l = a(91),
        c = a(92),
        u = a(47),
        h = a(93),
        d = a(94);
      t.exports = function from(t) {
        var r,
          a,
          p,
          m,
          g,
          b,
          y = o(t),
          v = "function" == typeof this ? this : Array,
          S = arguments.length,
          k = S > 1 ? arguments[1] : void 0,
          w = void 0 !== k,
          C = d(y),
          x = 0;
        if (
          (w && (k = i(k, S > 2 ? arguments[2] : void 0, 2)),
          null == C || (v == Array && c(C)))
        )
          for (a = new v((r = u(y.length))); r > x; x++)
            (b = w ? k(y[x], x) : y[x]), h(a, x, b);
        else
          for (
            g = (m = C.call(y)).next, a = new v();
            !(p = g.call(m)).done;
            x++
          )
            (b = w ? l(m, k, [p.value, x], !0) : p.value), h(a, x, b);
        return (a.length = x), a;
      };
    },
    function (t, r, a) {
      var i = a(28);
      t.exports = function (t, r, a, o) {
        try {
          return o ? r(i(a)[0], a[1]) : r(a);
        } catch (r) {
          var l = t.return;
          throw (void 0 !== l && i(l.call(t)), r);
        }
      };
    },
    function (t, r, a) {
      var i = a(57),
        o = a(86),
        l = i("iterator"),
        c = Array.prototype;
      t.exports = function (t) {
        return void 0 !== t && (o.Array === t || c[l] === t);
      };
    },
    function (t, r, a) {
      "use strict";
      var i = a(21),
        o = a(27),
        l = a(16);
      t.exports = function (t, r, a) {
        var c = i(r);
        c in t ? o.f(t, c, l(0, a)) : (t[c] = a);
      };
    },
    function (t, r, a) {
      var i = a(95),
        o = a(86),
        l = a(57)("iterator");
      t.exports = function (t) {
        if (null != t) return t[l] || t["@@iterator"] || o[i(t)];
      };
    },
    function (t, r, a) {
      var i = a(96),
        o = a(19),
        l = a(57)("toStringTag"),
        c =
          "Arguments" ==
          o(
            (function () {
              return arguments;
            })(),
          );
      t.exports = i
        ? o
        : function (t) {
            var r, a, i;
            return void 0 === t
              ? "Undefined"
              : null === t
              ? "Null"
              : "string" ==
                typeof (a = (function (t, r) {
                  try {
                    return t[r];
                  } catch (t) {}
                })((r = Object(t)), l))
              ? a
              : c
              ? o(r)
              : "Object" == (i = o(r)) && "function" == typeof r.callee
              ? "Arguments"
              : i;
          };
    },
    function (t, r, a) {
      var i = {};
      (i[a(57)("toStringTag")] = "z"), (t.exports = "[object z]" === String(i));
    },
    function (t, r, a) {
      var i = a(57)("iterator"),
        o = !1;
      try {
        var l = 0,
          c = {
            next: function () {
              return { done: !!l++ };
            },
            return: function () {
              o = !0;
            },
          };
        (c[i] = function () {
          return this;
        }),
          Array.from(c, function () {
            throw 2;
          });
      } catch (t) {}
      t.exports = function (t, r) {
        if (!r && !o) return !1;
        var a = !1;
        try {
          var l = {};
          (l[i] = function () {
            return {
              next: function () {
                return { done: (a = !0) };
              },
            };
          }),
            t(l);
        } catch (t) {}
        return a;
      };
    },
    function (t, r, a) {
      a(99);
      var i = a(43);
      t.exports = i.Object.assign;
    },
    function (t, r, a) {
      var i = a(10),
        o = a(100);
      i(
        { target: "Object", stat: !0, forced: Object.assign !== o },
        { assign: o },
      );
    },
    function (t, r, a) {
      "use strict";
      var i = a(13),
        o = a(14),
        l = a(73),
        c = a(51),
        u = a(15),
        h = a(83),
        d = a(18),
        p = Object.assign,
        m = Object.defineProperty;
      t.exports =
        !p ||
        o(function () {
          if (
            i &&
            1 !==
              p(
                { b: 1 },
                p(
                  m({}, "a", {
                    enumerable: !0,
                    get: function () {
                      m(this, "b", { value: 3, enumerable: !1 });
                    },
                  }),
                  { b: 2 },
                ),
              ).b
          )
            return !0;
          var t = {},
            r = {},
            a = Symbol(),
            o = "abcdefghijklmnopqrst";
          return (
            (t[a] = 7),
            o.split("").forEach(function (t) {
              r[t] = t;
            }),
            7 != p({}, t)[a] || l(p({}, r)).join("") != o
          );
        })
          ? function assign(t, r) {
              for (
                var a = h(t), o = arguments.length, p = 1, m = c.f, g = u.f;
                o > p;

              )
                for (
                  var b,
                    y = d(arguments[p++]),
                    v = m ? l(y).concat(m(y)) : l(y),
                    S = v.length,
                    k = 0;
                  S > k;

                )
                  (b = v[k++]), (i && !g.call(y, b)) || (a[b] = y[b]);
              return a;
            }
          : p;
    },
    function (t, r, a) {
      a(102);
      var i = a(43);
      t.exports = i.Math.log2;
    },
    function (t, r, a) {
      var i = a(10),
        o = Math.log,
        l = Math.LN2;
      i(
        { target: "Math", stat: !0 },
        {
          log2: function log2(t) {
            return o(t) / l;
          },
        },
      );
    },
    function (t, r, a) {
      a(104);
      var i = a(43);
      t.exports = i.Number.isNaN;
    },
    function (t, r, a) {
      a(10)(
        { target: "Number", stat: !0 },
        {
          isNaN: function isNaN(t) {
            return t != t;
          },
        },
      );
    },
    function (t, r, a) {
      a(106);
      var i = a(43);
      t.exports = i.Number.isInteger;
    },
    function (t, r, a) {
      a(10)({ target: "Number", stat: !0 }, { isInteger: a(107) });
    },
    function (t, r, a) {
      var i = a(22),
        o = Math.floor;
      t.exports = function isInteger(t) {
        return !i(t) && isFinite(t) && o(t) === t;
      };
    },
    function (t, r, a) {
      a(109);
    },
    function (t, r, a) {
      "use strict";
      var i = a(110),
        o = a(112),
        l = a(14),
        c = i.aTypedArray,
        u = i.aTypedArrayConstructor,
        h = i.exportTypedArrayMethod,
        d = [].slice;
      h(
        "slice",
        function slice(t, r) {
          for (
            var a = d.call(c(this), t, r),
              i = o(this, this.constructor),
              l = 0,
              h = a.length,
              p = new (u(i))(h);
            h > l;

          )
            p[l] = a[l++];
          return p;
        },
        l(function () {
          new Int8Array(1).slice();
        }),
      );
    },
    function (t, r, a) {
      "use strict";
      var i,
        o = a(111),
        l = a(13),
        c = a(11),
        u = a(22),
        h = a(23),
        d = a(95),
        p = a(26),
        m = a(29),
        g = a(27).f,
        b = a(82),
        y = a(87),
        v = a(57),
        S = a(38),
        k = c.Int8Array,
        w = k && k.prototype,
        C = c.Uint8ClampedArray,
        x = C && C.prototype,
        _ = k && b(k),
        A = w && b(w),
        R = Object.prototype,
        T = R.isPrototypeOf,
        I = v("toStringTag"),
        P = S("TYPED_ARRAY_TAG"),
        O = o && !!y && "Opera" !== d(c.opera),
        E = !1,
        B = {
          Int8Array: 1,
          Uint8Array: 1,
          Uint8ClampedArray: 1,
          Int16Array: 2,
          Uint16Array: 2,
          Int32Array: 4,
          Uint32Array: 4,
          Float32Array: 4,
          Float64Array: 8,
        },
        isTypedArray = function (t) {
          return u(t) && h(B, d(t));
        };
      for (i in B) c[i] || (O = !1);
      if (
        (!O || "function" != typeof _ || _ === Function.prototype) &&
        ((_ = function TypedArray() {
          throw TypeError("Incorrect invocation");
        }),
        O)
      )
        for (i in B) c[i] && y(c[i], _);
      if ((!O || !A || A === R) && ((A = _.prototype), O))
        for (i in B) c[i] && y(c[i].prototype, A);
      if ((O && b(x) !== A && y(x, A), l && !h(A, I)))
        for (i in ((E = !0),
        g(A, I, {
          get: function () {
            return u(this) ? this[P] : void 0;
          },
        }),
        B))
          c[i] && p(c[i], P, i);
      t.exports = {
        NATIVE_ARRAY_BUFFER_VIEWS: O,
        TYPED_ARRAY_TAG: E && P,
        aTypedArray: function (t) {
          if (isTypedArray(t)) return t;
          throw TypeError("Target is not a typed array");
        },
        aTypedArrayConstructor: function (t) {
          if (y) {
            if (T.call(_, t)) return t;
          } else
            for (var r in B)
              if (h(B, i)) {
                var a = c[r];
                if (a && (t === a || T.call(a, t))) return t;
              }
          throw TypeError("Target is not a typed array constructor");
        },
        exportTypedArrayMethod: function (t, r, a) {
          if (l) {
            if (a)
              for (var i in B) {
                var o = c[i];
                o && h(o.prototype, t) && delete o.prototype[t];
              }
            (A[t] && !a) || m(A, t, a ? r : (O && w[t]) || r);
          }
        },
        exportTypedArrayStaticMethod: function (t, r, a) {
          var i, o;
          if (l) {
            if (y) {
              if (a) for (i in B) (o = c[i]) && h(o, t) && delete o[t];
              if (_[t] && !a) return;
              try {
                return m(_, t, a ? r : (O && k[t]) || r);
              } catch (t) {}
            }
            for (i in B) !(o = c[i]) || (o[t] && !a) || m(o, t, r);
          }
        },
        isView: function isView(t) {
          var r = d(t);
          return "DataView" === r || h(B, r);
        },
        isTypedArray: isTypedArray,
        TypedArray: _,
        TypedArrayPrototype: A,
      };
    },
    function (t, r) {
      t.exports =
        "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView;
    },
    function (t, r, a) {
      var i = a(28),
        o = a(63),
        l = a(57)("species");
      t.exports = function (t, r) {
        var a,
          c = i(t).constructor;
        return void 0 === c || null == (a = i(c)[l]) ? r : o(a);
      };
    },
    function (t, r, a) {
      a(114), a(77), a(116), a(119), a(134), a(135);
      var i = a(43);
      t.exports = i.Promise;
    },
    function (t, r, a) {
      var i = a(96),
        o = a(29),
        l = a(115);
      i || o(Object.prototype, "toString", l, { unsafe: !0 });
    },
    function (t, r, a) {
      "use strict";
      var i = a(96),
        o = a(95);
      t.exports = i
        ? {}.toString
        : function toString() {
            return "[object " + o(this) + "]";
          };
    },
    function (t, r, a) {
      var i = a(11),
        o = a(117),
        l = a(118),
        c = a(26),
        u = a(57),
        h = u("iterator"),
        d = u("toStringTag"),
        p = l.values;
      for (var m in o) {
        var g = i[m],
          b = g && g.prototype;
        if (b) {
          if (b[h] !== p)
            try {
              c(b, h, p);
            } catch (t) {
              b[h] = p;
            }
          if ((b[d] || c(b, d, m), o[m]))
            for (var y in l)
              if (b[y] !== l[y])
                try {
                  c(b, y, l[y]);
                } catch (t) {
                  b[y] = l[y];
                }
        }
      }
    },
    function (t, r) {
      t.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0,
      };
    },
    function (t, r, a) {
      "use strict";
      var i = a(17),
        o = a(70),
        l = a(86),
        c = a(33),
        u = a(79),
        h = "Array Iterator",
        d = c.set,
        p = c.getterFor(h);
      (t.exports = u(
        Array,
        "Array",
        function (t, r) {
          d(this, { type: h, target: i(t), index: 0, kind: r });
        },
        function () {
          var t = p(this),
            r = t.target,
            a = t.kind,
            i = t.index++;
          return !r || i >= r.length
            ? ((t.target = void 0), { value: void 0, done: !0 })
            : "keys" == a
            ? { value: i, done: !1 }
            : "values" == a
            ? { value: r[i], done: !1 }
            : { value: [i, r[i]], done: !1 };
        },
        "values",
      )),
        (l.Arguments = l.Array),
        o("keys"),
        o("values"),
        o("entries");
    },
    function (t, r, a) {
      "use strict";
      var i,
        o,
        l,
        c,
        u = a(10),
        h = a(37),
        d = a(11),
        p = a(42),
        m = a(120),
        g = a(29),
        b = a(121),
        y = a(85),
        v = a(122),
        S = a(22),
        k = a(63),
        w = a(123),
        C = a(19),
        x = a(31),
        _ = a(124),
        A = a(97),
        R = a(112),
        T = a(125).set,
        I = a(128),
        P = a(129),
        O = a(131),
        E = a(130),
        B = a(132),
        D = a(33),
        M = a(52),
        L = a(57),
        N = a(133),
        U = L("species"),
        j = "Promise",
        q = D.get,
        W = D.set,
        z = D.getterFor(j),
        G = m,
        H = d.TypeError,
        X = d.document,
        V = d.process,
        Y = p("fetch"),
        K = E.f,
        J = K,
        Z = "process" == C(V),
        Q = !!(X && X.createEvent && d.dispatchEvent),
        $ = "unhandledrejection",
        ee = M(j, function () {
          if (!(x(G) !== String(G))) {
            if (66 === N) return !0;
            if (!Z && "function" != typeof PromiseRejectionEvent) return !0;
          }
          if (h && !G.prototype.finally) return !0;
          if (N >= 51 && /native code/.test(G)) return !1;
          var t = G.resolve(1),
            FakePromise = function (t) {
              t(
                function () {},
                function () {},
              );
            };
          return (
            ((t.constructor = {})[U] = FakePromise),
            !(t.then(function () {}) instanceof FakePromise)
          );
        }),
        te =
          ee ||
          !A(function (t) {
            G.all(t).catch(function () {});
          }),
        isThenable = function (t) {
          var r;
          return !(!S(t) || "function" != typeof (r = t.then)) && r;
        },
        notify = function (t, r, a) {
          if (!r.notified) {
            r.notified = !0;
            var i = r.reactions;
            I(function () {
              for (var o = r.value, l = 1 == r.state, c = 0; i.length > c; ) {
                var u,
                  h,
                  d,
                  p = i[c++],
                  m = l ? p.ok : p.fail,
                  g = p.resolve,
                  b = p.reject,
                  y = p.domain;
                try {
                  m
                    ? (l ||
                        (2 === r.rejection && onHandleUnhandled(t, r),
                        (r.rejection = 1)),
                      !0 === m
                        ? (u = o)
                        : (y && y.enter(),
                          (u = m(o)),
                          y && (y.exit(), (d = !0))),
                      u === p.promise
                        ? b(H("Promise-chain cycle"))
                        : (h = isThenable(u))
                        ? h.call(u, g, b)
                        : g(u))
                    : b(o);
                } catch (t) {
                  y && !d && y.exit(), b(t);
                }
              }
              (r.reactions = []),
                (r.notified = !1),
                a && !r.rejection && onUnhandled(t, r);
            });
          }
        },
        dispatchEvent = function (t, r, a) {
          var i, o;
          Q
            ? (((i = X.createEvent("Event")).promise = r),
              (i.reason = a),
              i.initEvent(t, !1, !0),
              d.dispatchEvent(i))
            : (i = { promise: r, reason: a }),
            (o = d["on" + t])
              ? o(i)
              : t === $ && O("Unhandled promise rejection", a);
        },
        onUnhandled = function (t, r) {
          T.call(d, function () {
            var a,
              i = r.value;
            if (
              isUnhandled(r) &&
              ((a = B(function () {
                Z ? V.emit("unhandledRejection", i, t) : dispatchEvent($, t, i);
              })),
              (r.rejection = Z || isUnhandled(r) ? 2 : 1),
              a.error)
            )
              throw a.value;
          });
        },
        isUnhandled = function (t) {
          return 1 !== t.rejection && !t.parent;
        },
        onHandleUnhandled = function (t, r) {
          T.call(d, function () {
            Z
              ? V.emit("rejectionHandled", t)
              : dispatchEvent("rejectionhandled", t, r.value);
          });
        },
        bind = function (t, r, a, i) {
          return function (o) {
            t(r, a, o, i);
          };
        },
        internalReject = function (t, r, a, i) {
          r.done ||
            ((r.done = !0),
            i && (r = i),
            (r.value = a),
            (r.state = 2),
            notify(t, r, !0));
        },
        internalResolve = function (t, r, a, i) {
          if (!r.done) {
            (r.done = !0), i && (r = i);
            try {
              if (t === a) throw H("Promise can't be resolved itself");
              var o = isThenable(a);
              o
                ? I(function () {
                    var i = { done: !1 };
                    try {
                      o.call(
                        a,
                        bind(internalResolve, t, i, r),
                        bind(internalReject, t, i, r),
                      );
                    } catch (a) {
                      internalReject(t, i, a, r);
                    }
                  })
                : ((r.value = a), (r.state = 1), notify(t, r, !1));
            } catch (a) {
              internalReject(t, { done: !1 }, a, r);
            }
          }
        };
      ee &&
        ((G = function Promise(t) {
          w(this, G, j), k(t), i.call(this);
          var r = q(this);
          try {
            t(bind(internalResolve, this, r), bind(internalReject, this, r));
          } catch (t) {
            internalReject(this, r, t);
          }
        }),
        ((i = function Promise(t) {
          W(this, {
            type: j,
            done: !1,
            notified: !1,
            parent: !1,
            reactions: [],
            rejection: !1,
            state: 0,
            value: void 0,
          });
        }).prototype = b(G.prototype, {
          then: function then(t, r) {
            var a = z(this),
              i = K(R(this, G));
            return (
              (i.ok = "function" != typeof t || t),
              (i.fail = "function" == typeof r && r),
              (i.domain = Z ? V.domain : void 0),
              (a.parent = !0),
              a.reactions.push(i),
              0 != a.state && notify(this, a, !1),
              i.promise
            );
          },
          catch: function (t) {
            return this.then(void 0, t);
          },
        })),
        (o = function () {
          var t = new i(),
            r = q(t);
          (this.promise = t),
            (this.resolve = bind(internalResolve, t, r)),
            (this.reject = bind(internalReject, t, r));
        }),
        (E.f = K =
          function (t) {
            return t === G || t === l ? new o(t) : J(t);
          }),
        h ||
          "function" != typeof m ||
          ((c = m.prototype.then),
          g(
            m.prototype,
            "then",
            function then(t, r) {
              var a = this;
              return new G(function (t, r) {
                c.call(a, t, r);
              }).then(t, r);
            },
            { unsafe: !0 },
          ),
          "function" == typeof Y &&
            u(
              { global: !0, enumerable: !0, forced: !0 },
              {
                fetch: function fetch(t) {
                  return P(G, Y.apply(d, arguments));
                },
              },
            ))),
        u({ global: !0, wrap: !0, forced: ee }, { Promise: G }),
        y(G, j, !1, !0),
        v(j),
        (l = p(j)),
        u(
          { target: j, stat: !0, forced: ee },
          {
            reject: function reject(t) {
              var r = K(this);
              return r.reject.call(void 0, t), r.promise;
            },
          },
        ),
        u(
          { target: j, stat: !0, forced: h || ee },
          {
            resolve: function resolve(t) {
              return P(h && this === l ? G : this, t);
            },
          },
        ),
        u(
          { target: j, stat: !0, forced: te },
          {
            all: function all(t) {
              var r = this,
                a = K(r),
                i = a.resolve,
                o = a.reject,
                l = B(function () {
                  var a = k(r.resolve),
                    l = [],
                    c = 0,
                    u = 1;
                  _(t, function (t) {
                    var h = c++,
                      d = !1;
                    l.push(void 0),
                      u++,
                      a.call(r, t).then(function (t) {
                        d || ((d = !0), (l[h] = t), --u || i(l));
                      }, o);
                  }),
                    --u || i(l);
                });
              return l.error && o(l.value), a.promise;
            },
            race: function race(t) {
              var r = this,
                a = K(r),
                i = a.reject,
                o = B(function () {
                  var o = k(r.resolve);
                  _(t, function (t) {
                    o.call(r, t).then(a.resolve, i);
                  });
                });
              return o.error && i(o.value), a.promise;
            },
          },
        );
    },
    function (t, r, a) {
      var i = a(11);
      t.exports = i.Promise;
    },
    function (t, r, a) {
      var i = a(29);
      t.exports = function (t, r, a) {
        for (var o in r) i(t, o, r[o], a);
        return t;
      };
    },
    function (t, r, a) {
      "use strict";
      var i = a(42),
        o = a(27),
        l = a(57),
        c = a(13),
        u = l("species");
      t.exports = function (t) {
        var r = i(t),
          a = o.f;
        c &&
          r &&
          !r[u] &&
          a(r, u, {
            configurable: !0,
            get: function () {
              return this;
            },
          });
      };
    },
    function (t, r) {
      t.exports = function (t, r, a) {
        if (!(t instanceof r))
          throw TypeError("Incorrect " + (a ? a + " " : "") + "invocation");
        return t;
      };
    },
    function (t, r, a) {
      var i = a(28),
        o = a(92),
        l = a(47),
        c = a(62),
        u = a(94),
        h = a(91),
        Result = function (t, r) {
          (this.stopped = t), (this.result = r);
        };
      (t.exports = function (t, r, a, d, p) {
        var m,
          g,
          b,
          y,
          v,
          S,
          k,
          w = c(r, a, d ? 2 : 1);
        if (p) m = t;
        else {
          if ("function" != typeof (g = u(t)))
            throw TypeError("Target is not iterable");
          if (o(g)) {
            for (b = 0, y = l(t.length); y > b; b++)
              if (
                (v = d ? w(i((k = t[b]))[0], k[1]) : w(t[b])) &&
                v instanceof Result
              )
                return v;
            return new Result(!1);
          }
          m = g.call(t);
        }
        for (S = m.next; !(k = S.call(m)).done; )
          if (
            "object" == typeof (v = h(m, w, k.value, d)) &&
            v &&
            v instanceof Result
          )
            return v;
        return new Result(!1);
      }).stop = function (t) {
        return new Result(!0, t);
      };
    },
    function (t, r, a) {
      var i,
        o,
        l,
        c = a(11),
        u = a(14),
        h = a(19),
        d = a(62),
        p = a(74),
        m = a(25),
        g = a(126),
        b = c.location,
        y = c.setImmediate,
        v = c.clearImmediate,
        S = c.process,
        k = c.MessageChannel,
        w = c.Dispatch,
        C = 0,
        x = {},
        _ = "onreadystatechange",
        run = function (t) {
          if (x.hasOwnProperty(t)) {
            var r = x[t];
            delete x[t], r();
          }
        },
        runner = function (t) {
          return function () {
            run(t);
          };
        },
        listener = function (t) {
          run(t.data);
        },
        post = function (t) {
          c.postMessage(t + "", b.protocol + "//" + b.host);
        };
      (y && v) ||
        ((y = function setImmediate(t) {
          for (var r = [], a = 1; arguments.length > a; )
            r.push(arguments[a++]);
          return (
            (x[++C] = function () {
              ("function" == typeof t ? t : Function(t)).apply(void 0, r);
            }),
            i(C),
            C
          );
        }),
        (v = function clearImmediate(t) {
          delete x[t];
        }),
        "process" == h(S)
          ? (i = function (t) {
              S.nextTick(runner(t));
            })
          : w && w.now
          ? (i = function (t) {
              w.now(runner(t));
            })
          : k && !g
          ? ((l = (o = new k()).port2),
            (o.port1.onmessage = listener),
            (i = d(l.postMessage, l, 1)))
          : !c.addEventListener ||
            "function" != typeof postMessage ||
            c.importScripts ||
            u(post) ||
            "file:" === b.protocol
          ? (i =
              _ in m("script")
                ? function (t) {
                    p.appendChild(m("script")).onreadystatechange =
                      function () {
                        p.removeChild(this), run(t);
                      };
                  }
                : function (t) {
                    setTimeout(runner(t), 0);
                  })
          : ((i = post), c.addEventListener("message", listener, !1))),
        (t.exports = { set: y, clear: v });
    },
    function (t, r, a) {
      var i = a(127);
      t.exports = /(iphone|ipod|ipad).*applewebkit/i.test(i);
    },
    function (t, r, a) {
      var i = a(42);
      t.exports = i("navigator", "userAgent") || "";
    },
    function (t, r, a) {
      var i,
        o,
        l,
        c,
        u,
        h,
        d,
        p,
        m = a(11),
        g = a(12).f,
        b = a(19),
        y = a(125).set,
        v = a(126),
        S = m.MutationObserver || m.WebKitMutationObserver,
        k = m.process,
        w = m.Promise,
        C = "process" == b(k),
        x = g(m, "queueMicrotask"),
        _ = x && x.value;
      _ ||
        ((i = function () {
          var t, r;
          for (C && (t = k.domain) && t.exit(); o; ) {
            (r = o.fn), (o = o.next);
            try {
              r();
            } catch (t) {
              throw (o ? c() : (l = void 0), t);
            }
          }
          (l = void 0), t && t.enter();
        }),
        C
          ? (c = function () {
              k.nextTick(i);
            })
          : S && !v
          ? ((u = !0),
            (h = document.createTextNode("")),
            new S(i).observe(h, { characterData: !0 }),
            (c = function () {
              h.data = u = !u;
            }))
          : w && w.resolve
          ? ((d = w.resolve(void 0)),
            (p = d.then),
            (c = function () {
              p.call(d, i);
            }))
          : (c = function () {
              y.call(m, i);
            })),
        (t.exports =
          _ ||
          function (t) {
            var r = { fn: t, next: void 0 };
            l && (l.next = r), o || ((o = r), c()), (l = r);
          });
    },
    function (t, r, a) {
      var i = a(28),
        o = a(22),
        l = a(130);
      t.exports = function (t, r) {
        if ((i(t), o(r) && r.constructor === t)) return r;
        var a = l.f(t);
        return (0, a.resolve)(r), a.promise;
      };
    },
    function (t, r, a) {
      "use strict";
      var i = a(63),
        PromiseCapability = function (t) {
          var r, a;
          (this.promise = new t(function (t, i) {
            if (void 0 !== r || void 0 !== a)
              throw TypeError("Bad Promise constructor");
            (r = t), (a = i);
          })),
            (this.resolve = i(r)),
            (this.reject = i(a));
        };
      t.exports.f = function (t) {
        return new PromiseCapability(t);
      };
    },
    function (t, r, a) {
      var i = a(11);
      t.exports = function (t, r) {
        var a = i.console;
        a && a.error && (1 === arguments.length ? a.error(t) : a.error(t, r));
      };
    },
    function (t, r) {
      t.exports = function (t) {
        try {
          return { error: !1, value: t() };
        } catch (t) {
          return { error: !0, value: t };
        }
      };
    },
    function (t, r, a) {
      var i,
        o,
        l = a(11),
        c = a(127),
        u = l.process,
        h = u && u.versions,
        d = h && h.v8;
      d
        ? (o = (i = d.split("."))[0] + i[1])
        : c &&
          (!(i = c.match(/Edge\/(\d+)/)) || i[1] >= 74) &&
          (i = c.match(/Chrome\/(\d+)/)) &&
          (o = i[1]),
        (t.exports = o && +o);
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(63),
        l = a(130),
        c = a(132),
        u = a(124);
      i(
        { target: "Promise", stat: !0 },
        {
          allSettled: function allSettled(t) {
            var r = this,
              a = l.f(r),
              i = a.resolve,
              h = a.reject,
              d = c(function () {
                var a = o(r.resolve),
                  l = [],
                  c = 0,
                  h = 1;
                u(t, function (t) {
                  var o = c++,
                    u = !1;
                  l.push(void 0),
                    h++,
                    a.call(r, t).then(
                      function (t) {
                        u ||
                          ((u = !0),
                          (l[o] = { status: "fulfilled", value: t }),
                          --h || i(l));
                      },
                      function (t) {
                        u ||
                          ((u = !0),
                          (l[o] = { status: "rejected", reason: t }),
                          --h || i(l));
                      },
                    );
                }),
                  --h || i(l);
              });
            return d.error && h(d.value), a.promise;
          },
        },
      );
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(37),
        l = a(120),
        c = a(14),
        u = a(42),
        h = a(112),
        d = a(129),
        p = a(29);
      i(
        {
          target: "Promise",
          proto: !0,
          real: !0,
          forced:
            !!l &&
            c(function () {
              l.prototype.finally.call(
                { then: function () {} },
                function () {},
              );
            }),
        },
        {
          finally: function (t) {
            var r = h(this, u("Promise")),
              a = "function" == typeof t;
            return this.then(
              a
                ? function (a) {
                    return d(r, t()).then(function () {
                      return a;
                    });
                  }
                : t,
              a
                ? function (a) {
                    return d(r, t()).then(function () {
                      throw a;
                    });
                  }
                : t,
            );
          },
        },
      ),
        o ||
          "function" != typeof l ||
          l.prototype.finally ||
          p(l.prototype, "finally", u("Promise").prototype.finally);
    },
    function (t, r, a) {
      a(137), a(142), a(140);
      var i = a(43);
      t.exports = i.URL;
    },
    function (t, r, a) {
      "use strict";
      a(77);
      var i,
        o = a(10),
        l = a(13),
        c = a(138),
        u = a(11),
        h = a(72),
        d = a(29),
        p = a(123),
        m = a(23),
        g = a(100),
        b = a(90),
        y = a(78).codeAt,
        v = a(139),
        S = a(85),
        k = a(140),
        w = a(33),
        C = u.URL,
        x = k.URLSearchParams,
        _ = k.getState,
        A = w.set,
        R = w.getterFor("URL"),
        T = Math.floor,
        I = Math.pow,
        P = "Invalid scheme",
        O = "Invalid host",
        E = "Invalid port",
        B = /[A-Za-z]/,
        D = /[\d+-.A-Za-z]/,
        M = /\d/,
        L = /^(0x|0X)/,
        N = /^[0-7]+$/,
        U = /^\d+$/,
        j = /^[\dA-Fa-f]+$/,
        q = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/,
        W = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/,
        z = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
        G = /[\u0009\u000A\u000D]/g,
        parseHost = function (t, r) {
          var a, i, o;
          if ("[" == r.charAt(0)) {
            if ("]" != r.charAt(r.length - 1)) return O;
            if (!(a = parseIPv6(r.slice(1, -1)))) return O;
            t.host = a;
          } else if (isSpecial(t)) {
            if (((r = v(r)), q.test(r))) return O;
            if (null === (a = parseIPv4(r))) return O;
            t.host = a;
          } else {
            if (W.test(r)) return O;
            for (a = "", i = b(r), o = 0; o < i.length; o++)
              a += percentEncode(i[o], H);
            t.host = a;
          }
        },
        parseIPv4 = function (t) {
          var r,
            a,
            i,
            o,
            l,
            c,
            u,
            h = t.split(".");
          if (
            (h.length && "" == h[h.length - 1] && h.pop(), (r = h.length) > 4)
          )
            return t;
          for (a = [], i = 0; i < r; i++) {
            if ("" == (o = h[i])) return t;
            if (
              ((l = 10),
              o.length > 1 &&
                "0" == o.charAt(0) &&
                ((l = L.test(o) ? 16 : 8), (o = o.slice(8 == l ? 1 : 2))),
              "" === o)
            )
              c = 0;
            else {
              if (!(10 == l ? U : 8 == l ? N : j).test(o)) return t;
              c = parseInt(o, l);
            }
            a.push(c);
          }
          for (i = 0; i < r; i++)
            if (((c = a[i]), i == r - 1)) {
              if (c >= I(256, 5 - r)) return null;
            } else if (c > 255) return null;
          for (u = a.pop(), i = 0; i < a.length; i++) u += a[i] * I(256, 3 - i);
          return u;
        },
        parseIPv6 = function (t) {
          var r,
            a,
            i,
            o,
            l,
            c,
            u,
            h = [0, 0, 0, 0, 0, 0, 0, 0],
            d = 0,
            p = null,
            m = 0,
            char = function () {
              return t.charAt(m);
            };
          if (":" == char()) {
            if (":" != t.charAt(1)) return;
            (m += 2), (p = ++d);
          }
          for (; char(); ) {
            if (8 == d) return;
            if (":" != char()) {
              for (r = a = 0; a < 4 && j.test(char()); )
                (r = 16 * r + parseInt(char(), 16)), m++, a++;
              if ("." == char()) {
                if (0 == a) return;
                if (((m -= a), d > 6)) return;
                for (i = 0; char(); ) {
                  if (((o = null), i > 0)) {
                    if (!("." == char() && i < 4)) return;
                    m++;
                  }
                  if (!M.test(char())) return;
                  for (; M.test(char()); ) {
                    if (((l = parseInt(char(), 10)), null === o)) o = l;
                    else {
                      if (0 == o) return;
                      o = 10 * o + l;
                    }
                    if (o > 255) return;
                    m++;
                  }
                  (h[d] = 256 * h[d] + o), (2 != ++i && 4 != i) || d++;
                }
                if (4 != i) return;
                break;
              }
              if (":" == char()) {
                if ((m++, !char())) return;
              } else if (char()) return;
              h[d++] = r;
            } else {
              if (null !== p) return;
              m++, (p = ++d);
            }
          }
          if (null !== p)
            for (c = d - p, d = 7; 0 != d && c > 0; )
              (u = h[d]), (h[d--] = h[p + c - 1]), (h[p + --c] = u);
          else if (8 != d) return;
          return h;
        },
        serializeHost = function (t) {
          var r, a, i, o;
          if ("number" == typeof t) {
            for (r = [], a = 0; a < 4; a++)
              r.unshift(t % 256), (t = T(t / 256));
            return r.join(".");
          }
          if ("object" == typeof t) {
            for (
              r = "",
                i = (function (t) {
                  for (var r = null, a = 1, i = null, o = 0, l = 0; l < 8; l++)
                    0 !== t[l]
                      ? (o > a && ((r = i), (a = o)), (i = null), (o = 0))
                      : (null === i && (i = l), ++o);
                  return o > a && ((r = i), (a = o)), r;
                })(t),
                a = 0;
              a < 8;
              a++
            )
              (o && 0 === t[a]) ||
                (o && (o = !1),
                i === a
                  ? ((r += a ? ":" : "::"), (o = !0))
                  : ((r += t[a].toString(16)), a < 7 && (r += ":")));
            return "[" + r + "]";
          }
          return t;
        },
        H = {},
        X = g({}, H, { " ": 1, '"': 1, "<": 1, ">": 1, "`": 1 }),
        V = g({}, X, { "#": 1, "?": 1, "{": 1, "}": 1 }),
        Y = g({}, V, {
          "/": 1,
          ":": 1,
          ";": 1,
          "=": 1,
          "@": 1,
          "[": 1,
          "\\": 1,
          "]": 1,
          "^": 1,
          "|": 1,
        }),
        percentEncode = function (t, r) {
          var a = y(t, 0);
          return a > 32 && a < 127 && !m(r, t) ? t : encodeURIComponent(t);
        },
        K = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 },
        isSpecial = function (t) {
          return m(K, t.scheme);
        },
        includesCredentials = function (t) {
          return "" != t.username || "" != t.password;
        },
        cannotHaveUsernamePasswordPort = function (t) {
          return !t.host || t.cannotBeABaseURL || "file" == t.scheme;
        },
        isWindowsDriveLetter = function (t, r) {
          var a;
          return (
            2 == t.length &&
            B.test(t.charAt(0)) &&
            (":" == (a = t.charAt(1)) || (!r && "|" == a))
          );
        },
        startsWithWindowsDriveLetter = function (t) {
          var r;
          return (
            t.length > 1 &&
            isWindowsDriveLetter(t.slice(0, 2)) &&
            (2 == t.length ||
              "/" === (r = t.charAt(2)) ||
              "\\" === r ||
              "?" === r ||
              "#" === r)
          );
        },
        shortenURLsPath = function (t) {
          var r = t.path,
            a = r.length;
          !a ||
            ("file" == t.scheme && 1 == a && isWindowsDriveLetter(r[0], !0)) ||
            r.pop();
        },
        isSingleDot = function (t) {
          return "." === t || "%2e" === t.toLowerCase();
        },
        J = {},
        Z = {},
        Q = {},
        $ = {},
        ee = {},
        te = {},
        re = {},
        ae = {},
        ne = {},
        ie = {},
        oe = {},
        se = {},
        le = {},
        ce = {},
        ue = {},
        he = {},
        fe = {},
        de = {},
        pe = {},
        me = {},
        ge = {},
        parseURL = function (t, r, a, o) {
          var l,
            c,
            u,
            h,
            d,
            p = a || J,
            g = 0,
            y = "",
            v = !1,
            S = !1,
            k = !1;
          for (
            a ||
              ((t.scheme = ""),
              (t.username = ""),
              (t.password = ""),
              (t.host = null),
              (t.port = null),
              (t.path = []),
              (t.query = null),
              (t.fragment = null),
              (t.cannotBeABaseURL = !1),
              (r = r.replace(z, ""))),
              r = r.replace(G, ""),
              l = b(r);
            g <= l.length;

          ) {
            switch (((c = l[g]), p)) {
              case J:
                if (!c || !B.test(c)) {
                  if (a) return P;
                  p = Q;
                  continue;
                }
                (y += c.toLowerCase()), (p = Z);
                break;
              case Z:
                if (c && (D.test(c) || "+" == c || "-" == c || "." == c))
                  y += c.toLowerCase();
                else {
                  if (":" != c) {
                    if (a) return P;
                    (y = ""), (p = Q), (g = 0);
                    continue;
                  }
                  if (
                    a &&
                    (isSpecial(t) != m(K, y) ||
                      ("file" == y &&
                        (includesCredentials(t) || null !== t.port)) ||
                      ("file" == t.scheme && !t.host))
                  )
                    return;
                  if (((t.scheme = y), a))
                    return void (
                      isSpecial(t) &&
                      K[t.scheme] == t.port &&
                      (t.port = null)
                    );
                  (y = ""),
                    "file" == t.scheme
                      ? (p = ce)
                      : isSpecial(t) && o && o.scheme == t.scheme
                      ? (p = $)
                      : isSpecial(t)
                      ? (p = ae)
                      : "/" == l[g + 1]
                      ? ((p = ee), g++)
                      : ((t.cannotBeABaseURL = !0), t.path.push(""), (p = pe));
                }
                break;
              case Q:
                if (!o || (o.cannotBeABaseURL && "#" != c)) return P;
                if (o.cannotBeABaseURL && "#" == c) {
                  (t.scheme = o.scheme),
                    (t.path = o.path.slice()),
                    (t.query = o.query),
                    (t.fragment = ""),
                    (t.cannotBeABaseURL = !0),
                    (p = ge);
                  break;
                }
                p = "file" == o.scheme ? ce : te;
                continue;
              case $:
                if ("/" != c || "/" != l[g + 1]) {
                  p = te;
                  continue;
                }
                (p = ne), g++;
                break;
              case ee:
                if ("/" == c) {
                  p = ie;
                  break;
                }
                p = de;
                continue;
              case te:
                if (((t.scheme = o.scheme), c == i))
                  (t.username = o.username),
                    (t.password = o.password),
                    (t.host = o.host),
                    (t.port = o.port),
                    (t.path = o.path.slice()),
                    (t.query = o.query);
                else if ("/" == c || ("\\" == c && isSpecial(t))) p = re;
                else if ("?" == c)
                  (t.username = o.username),
                    (t.password = o.password),
                    (t.host = o.host),
                    (t.port = o.port),
                    (t.path = o.path.slice()),
                    (t.query = ""),
                    (p = me);
                else {
                  if ("#" != c) {
                    (t.username = o.username),
                      (t.password = o.password),
                      (t.host = o.host),
                      (t.port = o.port),
                      (t.path = o.path.slice()),
                      t.path.pop(),
                      (p = de);
                    continue;
                  }
                  (t.username = o.username),
                    (t.password = o.password),
                    (t.host = o.host),
                    (t.port = o.port),
                    (t.path = o.path.slice()),
                    (t.query = o.query),
                    (t.fragment = ""),
                    (p = ge);
                }
                break;
              case re:
                if (!isSpecial(t) || ("/" != c && "\\" != c)) {
                  if ("/" != c) {
                    (t.username = o.username),
                      (t.password = o.password),
                      (t.host = o.host),
                      (t.port = o.port),
                      (p = de);
                    continue;
                  }
                  p = ie;
                } else p = ne;
                break;
              case ae:
                if (((p = ne), "/" != c || "/" != y.charAt(g + 1))) continue;
                g++;
                break;
              case ne:
                if ("/" != c && "\\" != c) {
                  p = ie;
                  continue;
                }
                break;
              case ie:
                if ("@" == c) {
                  v && (y = "%40" + y), (v = !0), (u = b(y));
                  for (var w = 0; w < u.length; w++) {
                    var C = u[w];
                    if (":" != C || k) {
                      var x = percentEncode(C, Y);
                      k ? (t.password += x) : (t.username += x);
                    } else k = !0;
                  }
                  y = "";
                } else if (
                  c == i ||
                  "/" == c ||
                  "?" == c ||
                  "#" == c ||
                  ("\\" == c && isSpecial(t))
                ) {
                  if (v && "" == y) return "Invalid authority";
                  (g -= b(y).length + 1), (y = ""), (p = oe);
                } else y += c;
                break;
              case oe:
              case se:
                if (a && "file" == t.scheme) {
                  p = he;
                  continue;
                }
                if (":" != c || S) {
                  if (
                    c == i ||
                    "/" == c ||
                    "?" == c ||
                    "#" == c ||
                    ("\\" == c && isSpecial(t))
                  ) {
                    if (isSpecial(t) && "" == y) return O;
                    if (
                      a &&
                      "" == y &&
                      (includesCredentials(t) || null !== t.port)
                    )
                      return;
                    if ((h = parseHost(t, y))) return h;
                    if (((y = ""), (p = fe), a)) return;
                    continue;
                  }
                  "[" == c ? (S = !0) : "]" == c && (S = !1), (y += c);
                } else {
                  if ("" == y) return O;
                  if ((h = parseHost(t, y))) return h;
                  if (((y = ""), (p = le), a == se)) return;
                }
                break;
              case le:
                if (!M.test(c)) {
                  if (
                    c == i ||
                    "/" == c ||
                    "?" == c ||
                    "#" == c ||
                    ("\\" == c && isSpecial(t)) ||
                    a
                  ) {
                    if ("" != y) {
                      var _ = parseInt(y, 10);
                      if (_ > 65535) return E;
                      (t.port = isSpecial(t) && _ === K[t.scheme] ? null : _),
                        (y = "");
                    }
                    if (a) return;
                    p = fe;
                    continue;
                  }
                  return E;
                }
                y += c;
                break;
              case ce:
                if (((t.scheme = "file"), "/" == c || "\\" == c)) p = ue;
                else {
                  if (!o || "file" != o.scheme) {
                    p = de;
                    continue;
                  }
                  if (c == i)
                    (t.host = o.host),
                      (t.path = o.path.slice()),
                      (t.query = o.query);
                  else if ("?" == c)
                    (t.host = o.host),
                      (t.path = o.path.slice()),
                      (t.query = ""),
                      (p = me);
                  else {
                    if ("#" != c) {
                      startsWithWindowsDriveLetter(l.slice(g).join("")) ||
                        ((t.host = o.host),
                        (t.path = o.path.slice()),
                        shortenURLsPath(t)),
                        (p = de);
                      continue;
                    }
                    (t.host = o.host),
                      (t.path = o.path.slice()),
                      (t.query = o.query),
                      (t.fragment = ""),
                      (p = ge);
                  }
                }
                break;
              case ue:
                if ("/" == c || "\\" == c) {
                  p = he;
                  break;
                }
                o &&
                  "file" == o.scheme &&
                  !startsWithWindowsDriveLetter(l.slice(g).join("")) &&
                  (isWindowsDriveLetter(o.path[0], !0)
                    ? t.path.push(o.path[0])
                    : (t.host = o.host)),
                  (p = de);
                continue;
              case he:
                if (c == i || "/" == c || "\\" == c || "?" == c || "#" == c) {
                  if (!a && isWindowsDriveLetter(y)) p = de;
                  else if ("" == y) {
                    if (((t.host = ""), a)) return;
                    p = fe;
                  } else {
                    if ((h = parseHost(t, y))) return h;
                    if (("localhost" == t.host && (t.host = ""), a)) return;
                    (y = ""), (p = fe);
                  }
                  continue;
                }
                y += c;
                break;
              case fe:
                if (isSpecial(t)) {
                  if (((p = de), "/" != c && "\\" != c)) continue;
                } else if (a || "?" != c)
                  if (a || "#" != c) {
                    if (c != i && ((p = de), "/" != c)) continue;
                  } else (t.fragment = ""), (p = ge);
                else (t.query = ""), (p = me);
                break;
              case de:
                if (
                  c == i ||
                  "/" == c ||
                  ("\\" == c && isSpecial(t)) ||
                  (!a && ("?" == c || "#" == c))
                ) {
                  if (
                    (".." === (d = (d = y).toLowerCase()) ||
                    "%2e." === d ||
                    ".%2e" === d ||
                    "%2e%2e" === d
                      ? (shortenURLsPath(t),
                        "/" == c ||
                          ("\\" == c && isSpecial(t)) ||
                          t.path.push(""))
                      : isSingleDot(y)
                      ? "/" == c ||
                        ("\\" == c && isSpecial(t)) ||
                        t.path.push("")
                      : ("file" == t.scheme &&
                          !t.path.length &&
                          isWindowsDriveLetter(y) &&
                          (t.host && (t.host = ""), (y = y.charAt(0) + ":")),
                        t.path.push(y)),
                    (y = ""),
                    "file" == t.scheme && (c == i || "?" == c || "#" == c))
                  )
                    for (; t.path.length > 1 && "" === t.path[0]; )
                      t.path.shift();
                  "?" == c
                    ? ((t.query = ""), (p = me))
                    : "#" == c && ((t.fragment = ""), (p = ge));
                } else y += percentEncode(c, V);
                break;
              case pe:
                "?" == c
                  ? ((t.query = ""), (p = me))
                  : "#" == c
                  ? ((t.fragment = ""), (p = ge))
                  : c != i && (t.path[0] += percentEncode(c, H));
                break;
              case me:
                a || "#" != c
                  ? c != i &&
                    ("'" == c && isSpecial(t)
                      ? (t.query += "%27")
                      : (t.query += "#" == c ? "%23" : percentEncode(c, H)))
                  : ((t.fragment = ""), (p = ge));
                break;
              case ge:
                c != i && (t.fragment += percentEncode(c, X));
            }
            g++;
          }
        },
        be = function URL(t) {
          var r,
            a,
            i = p(this, be, "URL"),
            o = arguments.length > 1 ? arguments[1] : void 0,
            c = String(t),
            u = A(i, { type: "URL" });
          if (void 0 !== o)
            if (o instanceof be) r = R(o);
            else if ((a = parseURL((r = {}), String(o)))) throw TypeError(a);
          if ((a = parseURL(u, c, null, r))) throw TypeError(a);
          var h = (u.searchParams = new x()),
            d = _(h);
          d.updateSearchParams(u.query),
            (d.updateURL = function () {
              u.query = String(h) || null;
            }),
            l ||
              ((i.href = serializeURL.call(i)),
              (i.origin = getOrigin.call(i)),
              (i.protocol = getProtocol.call(i)),
              (i.username = getUsername.call(i)),
              (i.password = getPassword.call(i)),
              (i.host = getHost.call(i)),
              (i.hostname = getHostname.call(i)),
              (i.port = getPort.call(i)),
              (i.pathname = getPathname.call(i)),
              (i.search = getSearch.call(i)),
              (i.searchParams = getSearchParams.call(i)),
              (i.hash = getHash.call(i)));
        },
        ye = be.prototype,
        serializeURL = function () {
          var t = R(this),
            r = t.scheme,
            a = t.username,
            i = t.password,
            o = t.host,
            l = t.port,
            c = t.path,
            u = t.query,
            h = t.fragment,
            d = r + ":";
          return (
            null !== o
              ? ((d += "//"),
                includesCredentials(t) && (d += a + (i ? ":" + i : "") + "@"),
                (d += serializeHost(o)),
                null !== l && (d += ":" + l))
              : "file" == r && (d += "//"),
            (d += t.cannotBeABaseURL
              ? c[0]
              : c.length
              ? "/" + c.join("/")
              : ""),
            null !== u && (d += "?" + u),
            null !== h && (d += "#" + h),
            d
          );
        },
        getOrigin = function () {
          var t = R(this),
            r = t.scheme,
            a = t.port;
          if ("blob" == r)
            try {
              return new URL(r.path[0]).origin;
            } catch (t) {
              return "null";
            }
          return "file" != r && isSpecial(t)
            ? r + "://" + serializeHost(t.host) + (null !== a ? ":" + a : "")
            : "null";
        },
        getProtocol = function () {
          return R(this).scheme + ":";
        },
        getUsername = function () {
          return R(this).username;
        },
        getPassword = function () {
          return R(this).password;
        },
        getHost = function () {
          var t = R(this),
            r = t.host,
            a = t.port;
          return null === r
            ? ""
            : null === a
            ? serializeHost(r)
            : serializeHost(r) + ":" + a;
        },
        getHostname = function () {
          var t = R(this).host;
          return null === t ? "" : serializeHost(t);
        },
        getPort = function () {
          var t = R(this).port;
          return null === t ? "" : String(t);
        },
        getPathname = function () {
          var t = R(this),
            r = t.path;
          return t.cannotBeABaseURL ? r[0] : r.length ? "/" + r.join("/") : "";
        },
        getSearch = function () {
          var t = R(this).query;
          return t ? "?" + t : "";
        },
        getSearchParams = function () {
          return R(this).searchParams;
        },
        getHash = function () {
          var t = R(this).fragment;
          return t ? "#" + t : "";
        },
        accessorDescriptor = function (t, r) {
          return { get: t, set: r, configurable: !0, enumerable: !0 };
        };
      if (
        (l &&
          h(ye, {
            href: accessorDescriptor(serializeURL, function (t) {
              var r = R(this),
                a = String(t),
                i = parseURL(r, a);
              if (i) throw TypeError(i);
              _(r.searchParams).updateSearchParams(r.query);
            }),
            origin: accessorDescriptor(getOrigin),
            protocol: accessorDescriptor(getProtocol, function (t) {
              var r = R(this);
              parseURL(r, String(t) + ":", J);
            }),
            username: accessorDescriptor(getUsername, function (t) {
              var r = R(this),
                a = b(String(t));
              if (!cannotHaveUsernamePasswordPort(r)) {
                r.username = "";
                for (var i = 0; i < a.length; i++)
                  r.username += percentEncode(a[i], Y);
              }
            }),
            password: accessorDescriptor(getPassword, function (t) {
              var r = R(this),
                a = b(String(t));
              if (!cannotHaveUsernamePasswordPort(r)) {
                r.password = "";
                for (var i = 0; i < a.length; i++)
                  r.password += percentEncode(a[i], Y);
              }
            }),
            host: accessorDescriptor(getHost, function (t) {
              var r = R(this);
              r.cannotBeABaseURL || parseURL(r, String(t), oe);
            }),
            hostname: accessorDescriptor(getHostname, function (t) {
              var r = R(this);
              r.cannotBeABaseURL || parseURL(r, String(t), se);
            }),
            port: accessorDescriptor(getPort, function (t) {
              var r = R(this);
              cannotHaveUsernamePasswordPort(r) ||
                ("" == (t = String(t)) ? (r.port = null) : parseURL(r, t, le));
            }),
            pathname: accessorDescriptor(getPathname, function (t) {
              var r = R(this);
              r.cannotBeABaseURL || ((r.path = []), parseURL(r, t + "", fe));
            }),
            search: accessorDescriptor(getSearch, function (t) {
              var r = R(this);
              "" == (t = String(t))
                ? (r.query = null)
                : ("?" == t.charAt(0) && (t = t.slice(1)),
                  (r.query = ""),
                  parseURL(r, t, me)),
                _(r.searchParams).updateSearchParams(r.query);
            }),
            searchParams: accessorDescriptor(getSearchParams),
            hash: accessorDescriptor(getHash, function (t) {
              var r = R(this);
              "" != (t = String(t))
                ? ("#" == t.charAt(0) && (t = t.slice(1)),
                  (r.fragment = ""),
                  parseURL(r, t, ge))
                : (r.fragment = null);
            }),
          }),
        d(
          ye,
          "toJSON",
          function toJSON() {
            return serializeURL.call(this);
          },
          { enumerable: !0 },
        ),
        d(
          ye,
          "toString",
          function toString() {
            return serializeURL.call(this);
          },
          { enumerable: !0 },
        ),
        C)
      ) {
        var ve = C.createObjectURL,
          Se = C.revokeObjectURL;
        ve &&
          d(be, "createObjectURL", function createObjectURL(t) {
            return ve.apply(C, arguments);
          }),
          Se &&
            d(be, "revokeObjectURL", function revokeObjectURL(t) {
              return Se.apply(C, arguments);
            });
      }
      S(be, "URL"), o({ global: !0, forced: !c, sham: !l }, { URL: be });
    },
    function (t, r, a) {
      var i = a(14),
        o = a(57),
        l = a(37),
        c = o("iterator");
      t.exports = !i(function () {
        var t = new URL("b?a=1&b=2&c=3", "http://a"),
          r = t.searchParams,
          a = "";
        return (
          (t.pathname = "c%20d"),
          r.forEach(function (t, i) {
            r.delete("b"), (a += i + t);
          }),
          (l && !t.toJSON) ||
            !r.sort ||
            "http://a/c%20d?a=1&c=3" !== t.href ||
            "3" !== r.get("c") ||
            "a=1" !== String(new URLSearchParams("?a=1")) ||
            !r[c] ||
            "a" !== new URL("https://a@b").username ||
            "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") ||
            "xn--e1aybc" !== new URL("http://тест").host ||
            "#%D0%B1" !== new URL("http://a#б").hash ||
            "a1c3" !== a ||
            "x" !== new URL("http://x", void 0).host
        );
      });
    },
    function (t, r, a) {
      "use strict";
      var i = 2147483647,
        o = /[^\0-\u007E]/,
        l = /[.\u3002\uFF0E\uFF61]/g,
        c = "Overflow: input needs wider integers to process",
        u = Math.floor,
        h = String.fromCharCode,
        digitToBasic = function (t) {
          return t + 22 + 75 * (t < 26);
        },
        adapt = function (t, r, a) {
          var i = 0;
          for (t = a ? u(t / 700) : t >> 1, t += u(t / r); t > 455; i += 36)
            t = u(t / 35);
          return u(i + (36 * t) / (t + 38));
        },
        encode = function (t) {
          var r,
            a,
            o = [],
            l = (t = (function (t) {
              for (var r = [], a = 0, i = t.length; a < i; ) {
                var o = t.charCodeAt(a++);
                if (o >= 55296 && o <= 56319 && a < i) {
                  var l = t.charCodeAt(a++);
                  56320 == (64512 & l)
                    ? r.push(((1023 & o) << 10) + (1023 & l) + 65536)
                    : (r.push(o), a--);
                } else r.push(o);
              }
              return r;
            })(t)).length,
            d = 128,
            p = 0,
            m = 72;
          for (r = 0; r < t.length; r++) (a = t[r]) < 128 && o.push(h(a));
          var g = o.length,
            b = g;
          for (g && o.push("-"); b < l; ) {
            var y = i;
            for (r = 0; r < t.length; r++) (a = t[r]) >= d && a < y && (y = a);
            var v = b + 1;
            if (y - d > u((i - p) / v)) throw RangeError(c);
            for (p += (y - d) * v, d = y, r = 0; r < t.length; r++) {
              if ((a = t[r]) < d && ++p > i) throw RangeError(c);
              if (a == d) {
                for (var S = p, k = 36; ; k += 36) {
                  var w = k <= m ? 1 : k >= m + 26 ? 26 : k - m;
                  if (S < w) break;
                  var C = S - w,
                    x = 36 - w;
                  o.push(h(digitToBasic(w + (C % x)))), (S = u(C / x));
                }
                o.push(h(digitToBasic(S))),
                  (m = adapt(p, v, b == g)),
                  (p = 0),
                  ++b;
              }
            }
            ++p, ++d;
          }
          return o.join("");
        };
      t.exports = function (t) {
        var r,
          a,
          i = [],
          c = t.toLowerCase().replace(l, ".").split(".");
        for (r = 0; r < c.length; r++)
          (a = c[r]), i.push(o.test(a) ? "xn--" + encode(a) : a);
        return i.join(".");
      };
    },
    function (t, r, a) {
      "use strict";
      a(118);
      var i = a(10),
        o = a(42),
        l = a(138),
        c = a(29),
        u = a(121),
        h = a(85),
        d = a(80),
        p = a(33),
        m = a(123),
        g = a(23),
        b = a(62),
        y = a(95),
        v = a(28),
        S = a(22),
        k = a(71),
        w = a(16),
        C = a(141),
        x = a(94),
        _ = a(57),
        A = o("fetch"),
        R = o("Headers"),
        T = _("iterator"),
        I = "URLSearchParams",
        P = "URLSearchParamsIterator",
        O = p.set,
        E = p.getterFor(I),
        B = p.getterFor(P),
        D = /\+/g,
        M = Array(4),
        percentSequence = function (t) {
          return (
            M[t - 1] ||
            (M[t - 1] = RegExp("((?:%[\\da-f]{2}){" + t + "})", "gi"))
          );
        },
        percentDecode = function (t) {
          try {
            return decodeURIComponent(t);
          } catch (r) {
            return t;
          }
        },
        deserialize = function (t) {
          var r = t.replace(D, " "),
            a = 4;
          try {
            return decodeURIComponent(r);
          } catch (t) {
            for (; a; ) r = r.replace(percentSequence(a--), percentDecode);
            return r;
          }
        },
        L = /[!'()~]|%20/g,
        N = {
          "!": "%21",
          "'": "%27",
          "(": "%28",
          ")": "%29",
          "~": "%7E",
          "%20": "+",
        },
        replacer = function (t) {
          return N[t];
        },
        serialize = function (t) {
          return encodeURIComponent(t).replace(L, replacer);
        },
        parseSearchParams = function (t, r) {
          if (r)
            for (var a, i, o = r.split("&"), l = 0; l < o.length; )
              (a = o[l++]).length &&
                ((i = a.split("=")),
                t.push({
                  key: deserialize(i.shift()),
                  value: deserialize(i.join("=")),
                }));
        },
        updateSearchParams = function (t) {
          (this.entries.length = 0), parseSearchParams(this.entries, t);
        },
        validateArgumentsLength = function (t, r) {
          if (t < r) throw TypeError("Not enough arguments");
        },
        U = d(
          function Iterator(t, r) {
            O(this, { type: P, iterator: C(E(t).entries), kind: r });
          },
          "Iterator",
          function next() {
            var t = B(this),
              r = t.kind,
              a = t.iterator.next(),
              i = a.value;
            return (
              a.done ||
                (a.value =
                  "keys" === r
                    ? i.key
                    : "values" === r
                    ? i.value
                    : [i.key, i.value]),
              a
            );
          },
        ),
        j = function URLSearchParams() {
          m(this, j, I);
          var t,
            r,
            a,
            i,
            o,
            l,
            c,
            u,
            h,
            d = arguments.length > 0 ? arguments[0] : void 0,
            p = this,
            b = [];
          if (
            (O(p, {
              type: I,
              entries: b,
              updateURL: function () {},
              updateSearchParams: updateSearchParams,
            }),
            void 0 !== d)
          )
            if (S(d))
              if ("function" == typeof (t = x(d)))
                for (a = (r = t.call(d)).next; !(i = a.call(r)).done; ) {
                  if (
                    (c = (l = (o = C(v(i.value))).next).call(o)).done ||
                    (u = l.call(o)).done ||
                    !l.call(o).done
                  )
                    throw TypeError("Expected sequence with length 2");
                  b.push({ key: c.value + "", value: u.value + "" });
                }
              else for (h in d) g(d, h) && b.push({ key: h, value: d[h] + "" });
            else
              parseSearchParams(
                b,
                "string" == typeof d
                  ? "?" === d.charAt(0)
                    ? d.slice(1)
                    : d
                  : d + "",
              );
        },
        q = j.prototype;
      u(
        q,
        {
          append: function append(t, r) {
            validateArgumentsLength(arguments.length, 2);
            var a = E(this);
            a.entries.push({ key: t + "", value: r + "" }), a.updateURL();
          },
          delete: function (t) {
            validateArgumentsLength(arguments.length, 1);
            for (
              var r = E(this), a = r.entries, i = t + "", o = 0;
              o < a.length;

            )
              a[o].key === i ? a.splice(o, 1) : o++;
            r.updateURL();
          },
          get: function get(t) {
            validateArgumentsLength(arguments.length, 1);
            for (var r = E(this).entries, a = t + "", i = 0; i < r.length; i++)
              if (r[i].key === a) return r[i].value;
            return null;
          },
          getAll: function getAll(t) {
            validateArgumentsLength(arguments.length, 1);
            for (
              var r = E(this).entries, a = t + "", i = [], o = 0;
              o < r.length;
              o++
            )
              r[o].key === a && i.push(r[o].value);
            return i;
          },
          has: function has(t) {
            validateArgumentsLength(arguments.length, 1);
            for (var r = E(this).entries, a = t + "", i = 0; i < r.length; )
              if (r[i++].key === a) return !0;
            return !1;
          },
          set: function set(t, r) {
            validateArgumentsLength(arguments.length, 1);
            for (
              var a,
                i = E(this),
                o = i.entries,
                l = !1,
                c = t + "",
                u = r + "",
                h = 0;
              h < o.length;
              h++
            )
              (a = o[h]).key === c &&
                (l ? o.splice(h--, 1) : ((l = !0), (a.value = u)));
            l || o.push({ key: c, value: u }), i.updateURL();
          },
          sort: function sort() {
            var t,
              r,
              a,
              i = E(this),
              o = i.entries,
              l = o.slice();
            for (o.length = 0, a = 0; a < l.length; a++) {
              for (t = l[a], r = 0; r < a; r++)
                if (o[r].key > t.key) {
                  o.splice(r, 0, t);
                  break;
                }
              r === a && o.push(t);
            }
            i.updateURL();
          },
          forEach: function forEach(t) {
            for (
              var r,
                a = E(this).entries,
                i = b(t, arguments.length > 1 ? arguments[1] : void 0, 3),
                o = 0;
              o < a.length;

            )
              i((r = a[o++]).value, r.key, this);
          },
          keys: function keys() {
            return new U(this, "keys");
          },
          values: function values() {
            return new U(this, "values");
          },
          entries: function entries() {
            return new U(this, "entries");
          },
        },
        { enumerable: !0 },
      ),
        c(q, T, q.entries),
        c(
          q,
          "toString",
          function toString() {
            for (var t, r = E(this).entries, a = [], i = 0; i < r.length; )
              (t = r[i++]), a.push(serialize(t.key) + "=" + serialize(t.value));
            return a.join("&");
          },
          { enumerable: !0 },
        ),
        h(j, I),
        i({ global: !0, forced: !l }, { URLSearchParams: j }),
        l ||
          "function" != typeof A ||
          "function" != typeof R ||
          i(
            { global: !0, enumerable: !0, forced: !0 },
            {
              fetch: function fetch(t) {
                var r,
                  a,
                  i,
                  o = [t];
                return (
                  arguments.length > 1 &&
                    (S((r = arguments[1])) &&
                      ((a = r.body),
                      y(a) === I &&
                        ((i = r.headers ? new R(r.headers) : new R()).has(
                          "content-type",
                        ) ||
                          i.set(
                            "content-type",
                            "application/x-www-form-urlencoded;charset=UTF-8",
                          ),
                        (r = k(r, {
                          body: w(0, String(a)),
                          headers: w(0, i),
                        })))),
                    o.push(r)),
                  A.apply(this, o)
                );
              },
            },
          ),
        (t.exports = { URLSearchParams: j, getState: E });
    },
    function (t, r, a) {
      var i = a(28),
        o = a(94);
      t.exports = function (t) {
        var r = o(t);
        if ("function" != typeof r)
          throw TypeError(String(t) + " is not iterable");
        return i(r.call(t));
      };
    },
    function (t, r, a) {
      "use strict";
      a(10)(
        { target: "URL", proto: !0, enumerable: !0 },
        {
          toJSON: function toJSON() {
            return URL.prototype.toString.call(this);
          },
        },
      );
    },
    function (t, r, a) {
      !(function (t) {
        "use strict";
        var r =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? Symbol
            : function (t) {
                return "Symbol(" + t + ")";
              };
        function noop() {}
        var a =
            Number.isNaN ||
            function (t) {
              return t != t;
            },
          i = noop;
        function typeIsObject(t) {
          return ("object" == typeof t && null !== t) || "function" == typeof t;
        }
        function createArrayFromList(t) {
          return t.slice();
        }
        function ArrayBufferCopy(t, r, a, i, o) {
          new Uint8Array(t).set(new Uint8Array(a, i, o), r);
        }
        function IsFiniteNonNegativeNumber(t) {
          return !1 !== IsNonNegativeNumber(t) && t !== 1 / 0;
        }
        function IsNonNegativeNumber(t) {
          return !("number" != typeof t || a(t) || t < 0);
        }
        function Call(t, r, a) {
          if ("function" != typeof t)
            throw new TypeError("Argument is not a function");
          return Function.prototype.apply.call(t, r, a);
        }
        function CreateAlgorithmFromUnderlyingMethod(t, r, a, i) {
          var o = t[r];
          if (void 0 !== o) {
            if ("function" != typeof o)
              throw new TypeError(o + " is not a method");
            switch (a) {
              case 0:
                return function () {
                  return PromiseCall(o, t, i);
                };
              case 1:
                return function (r) {
                  var a = [r].concat(i);
                  return PromiseCall(o, t, a);
                };
            }
          }
          return function () {
            return promiseResolvedWith(void 0);
          };
        }
        function InvokeOrNoop(t, r, a) {
          var i = t[r];
          if (void 0 !== i) return Call(i, t, a);
        }
        function PromiseCall(t, r, a) {
          try {
            return promiseResolvedWith(Call(t, r, a));
          } catch (t) {
            return promiseRejectedWith(t);
          }
        }
        function TransferArrayBuffer(t) {
          return t;
        }
        function IsDetachedBuffer(t) {
          return !1;
        }
        function ValidateAndNormalizeHighWaterMark(t) {
          if (((t = Number(t)), a(t) || t < 0))
            throw new RangeError(
              "highWaterMark property of a queuing strategy must be non-negative and non-NaN",
            );
          return t;
        }
        function MakeSizeAlgorithmFromSizeFunction(t) {
          if (void 0 === t)
            return function () {
              return 1;
            };
          if ("function" != typeof t)
            throw new TypeError(
              "size property of a queuing strategy must be a function",
            );
          return function (r) {
            return t(r);
          };
        }
        var o = Promise,
          l = Promise.prototype.then,
          c = Promise.resolve.bind(o),
          u = Promise.reject.bind(o);
        function newPromise(t) {
          return new o(t);
        }
        function promiseResolvedWith(t) {
          return c(t);
        }
        function promiseRejectedWith(t) {
          return u(t);
        }
        function PerformPromiseThen(t, r, a) {
          return l.call(t, r, a);
        }
        function uponPromise(t, r, a) {
          PerformPromiseThen(PerformPromiseThen(t, r, a), void 0, i);
        }
        function uponFulfillment(t, r) {
          uponPromise(t, r);
        }
        function uponRejection(t, r) {
          uponPromise(t, void 0, r);
        }
        function transformPromiseWith(t, r, a) {
          return PerformPromiseThen(t, r, a);
        }
        function setPromiseIsHandledToTrue(t) {
          PerformPromiseThen(t, void 0, i);
        }
        var h = 16384,
          d = (function () {
            function SimpleQueue() {
              (this._cursor = 0),
                (this._size = 0),
                (this._front = { _elements: [], _next: void 0 }),
                (this._back = this._front),
                (this._cursor = 0),
                (this._size = 0);
            }
            return (
              Object.defineProperty(SimpleQueue.prototype, "length", {
                get: function () {
                  return this._size;
                },
                enumerable: !0,
                configurable: !0,
              }),
              (SimpleQueue.prototype.push = function (t) {
                var r = this._back,
                  a = r;
                r._elements.length === h - 1 &&
                  (a = { _elements: [], _next: void 0 }),
                  r._elements.push(t),
                  a !== r && ((this._back = a), (r._next = a)),
                  ++this._size;
              }),
              (SimpleQueue.prototype.shift = function () {
                var t = this._front,
                  r = t,
                  a = this._cursor,
                  i = a + 1,
                  o = t._elements,
                  l = o[a];
                return (
                  i === h && ((r = t._next), (i = 0)),
                  --this._size,
                  (this._cursor = i),
                  t !== r && (this._front = r),
                  (o[a] = void 0),
                  l
                );
              }),
              (SimpleQueue.prototype.forEach = function (t) {
                for (
                  var r = this._cursor, a = this._front, i = a._elements;
                  !(
                    (r === i.length && void 0 === a._next) ||
                    (r === i.length &&
                      ((r = 0), 0 === (i = (a = a._next)._elements).length))
                  );

                )
                  t(i[r]), ++r;
              }),
              (SimpleQueue.prototype.peek = function () {
                var t = this._front,
                  r = this._cursor;
                return t._elements[r];
              }),
              SimpleQueue
            );
          })();
        function ReadableStreamCreateReadResult(t, r, a) {
          var i = null;
          !0 === a && (i = Object.prototype);
          var o = Object.create(i);
          return (o.value = t), (o.done = r), o;
        }
        function ReadableStreamReaderGenericInitialize(t, r) {
          (t._forAuthorCode = !0),
            (t._ownerReadableStream = r),
            (r._reader = t),
            "readable" === r._state
              ? defaultReaderClosedPromiseInitialize(t)
              : "closed" === r._state
              ? defaultReaderClosedPromiseInitializeAsResolved(t)
              : defaultReaderClosedPromiseInitializeAsRejected(
                  t,
                  r._storedError,
                );
        }
        function ReadableStreamReaderGenericCancel(t, r) {
          return ReadableStreamCancel(t._ownerReadableStream, r);
        }
        function ReadableStreamReaderGenericRelease(t) {
          "readable" === t._ownerReadableStream._state
            ? defaultReaderClosedPromiseReject(
                t,
                new TypeError(
                  "Reader was released and can no longer be used to monitor the stream's closedness",
                ),
              )
            : defaultReaderClosedPromiseResetToRejected(
                t,
                new TypeError(
                  "Reader was released and can no longer be used to monitor the stream's closedness",
                ),
              ),
            (t._ownerReadableStream._reader = void 0),
            (t._ownerReadableStream = void 0);
        }
        function readerLockException(t) {
          return new TypeError(
            "Cannot " + t + " a stream using a released reader",
          );
        }
        function defaultReaderClosedPromiseInitialize(t) {
          t._closedPromise = newPromise(function (r, a) {
            (t._closedPromise_resolve = r), (t._closedPromise_reject = a);
          });
        }
        function defaultReaderClosedPromiseInitializeAsRejected(t, r) {
          defaultReaderClosedPromiseInitialize(t),
            defaultReaderClosedPromiseReject(t, r);
        }
        function defaultReaderClosedPromiseInitializeAsResolved(t) {
          defaultReaderClosedPromiseInitialize(t),
            defaultReaderClosedPromiseResolve(t);
        }
        function defaultReaderClosedPromiseReject(t, r) {
          setPromiseIsHandledToTrue(t._closedPromise),
            t._closedPromise_reject(r),
            (t._closedPromise_resolve = void 0),
            (t._closedPromise_reject = void 0);
        }
        function defaultReaderClosedPromiseResetToRejected(t, r) {
          defaultReaderClosedPromiseInitializeAsRejected(t, r);
        }
        function defaultReaderClosedPromiseResolve(t) {
          t._closedPromise_resolve(void 0),
            (t._closedPromise_resolve = void 0),
            (t._closedPromise_reject = void 0);
        }
        var p = r("[[CancelSteps]]"),
          m = r("[[PullSteps]]");
        function AcquireReadableStreamDefaultReader(t, r) {
          void 0 === r && (r = !1);
          var a = new y(t);
          return (a._forAuthorCode = r), a;
        }
        function ReadableStreamAddReadRequest(t) {
          return newPromise(function (r, a) {
            var i = { _resolve: r, _reject: a };
            t._reader._readRequests.push(i);
          });
        }
        function ReadableStreamFulfillReadRequest(t, r, a) {
          var i = t._reader;
          i._readRequests
            .shift()
            ._resolve(ReadableStreamCreateReadResult(r, a, i._forAuthorCode));
        }
        function ReadableStreamGetNumReadRequests(t) {
          return t._reader._readRequests.length;
        }
        function ReadableStreamHasDefaultReader(t) {
          var r = t._reader;
          return void 0 !== r && !!IsReadableStreamDefaultReader(r);
        }
        var g,
          b,
          y = (function () {
            function ReadableStreamDefaultReader(t) {
              if (!1 === IsReadableStream(t))
                throw new TypeError(
                  "ReadableStreamDefaultReader can only be constructed with a ReadableStream instance",
                );
              if (!0 === IsReadableStreamLocked(t))
                throw new TypeError(
                  "This stream has already been locked for exclusive reading by another reader",
                );
              ReadableStreamReaderGenericInitialize(this, t),
                (this._readRequests = new d());
            }
            return (
              Object.defineProperty(
                ReadableStreamDefaultReader.prototype,
                "closed",
                {
                  get: function () {
                    return IsReadableStreamDefaultReader(this)
                      ? this._closedPromise
                      : promiseRejectedWith(
                          defaultReaderBrandCheckException("closed"),
                        );
                  },
                  enumerable: !0,
                  configurable: !0,
                },
              ),
              (ReadableStreamDefaultReader.prototype.cancel = function (t) {
                return IsReadableStreamDefaultReader(this)
                  ? void 0 === this._ownerReadableStream
                    ? promiseRejectedWith(readerLockException("cancel"))
                    : ReadableStreamReaderGenericCancel(this, t)
                  : promiseRejectedWith(
                      defaultReaderBrandCheckException("cancel"),
                    );
              }),
              (ReadableStreamDefaultReader.prototype.read = function () {
                return IsReadableStreamDefaultReader(this)
                  ? void 0 === this._ownerReadableStream
                    ? promiseRejectedWith(readerLockException("read from"))
                    : ReadableStreamDefaultReaderRead(this)
                  : promiseRejectedWith(
                      defaultReaderBrandCheckException("read"),
                    );
              }),
              (ReadableStreamDefaultReader.prototype.releaseLock = function () {
                if (!IsReadableStreamDefaultReader(this))
                  throw defaultReaderBrandCheckException("releaseLock");
                if (void 0 !== this._ownerReadableStream) {
                  if (this._readRequests.length > 0)
                    throw new TypeError(
                      "Tried to release a reader lock when that reader has pending read() calls un-settled",
                    );
                  ReadableStreamReaderGenericRelease(this);
                }
              }),
              ReadableStreamDefaultReader
            );
          })();
        function IsReadableStreamDefaultReader(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(t, "_readRequests")
          );
        }
        function ReadableStreamDefaultReaderRead(t) {
          var r = t._ownerReadableStream;
          return (
            (r._disturbed = !0),
            "closed" === r._state
              ? promiseResolvedWith(
                  ReadableStreamCreateReadResult(void 0, !0, t._forAuthorCode),
                )
              : "errored" === r._state
              ? promiseRejectedWith(r._storedError)
              : r._readableStreamController[m]()
          );
        }
        function defaultReaderBrandCheckException(t) {
          return new TypeError(
            "ReadableStreamDefaultReader.prototype." +
              t +
              " can only be used on a ReadableStreamDefaultReader",
          );
        }
        "symbol" == typeof r.asyncIterator &&
          (((g = {})[r.asyncIterator] = function () {
            return this;
          }),
          (b = g),
          Object.defineProperty(b, r.asyncIterator, { enumerable: !1 }));
        var v = {
          next: function () {
            if (!1 === IsReadableStreamAsyncIterator(this))
              return promiseRejectedWith(
                streamAsyncIteratorBrandCheckException("next"),
              );
            var t = this._asyncIteratorReader;
            return void 0 === t._ownerReadableStream
              ? promiseRejectedWith(readerLockException("iterate"))
              : transformPromiseWith(
                  ReadableStreamDefaultReaderRead(t),
                  function (r) {
                    var a = r.done;
                    return (
                      a && ReadableStreamReaderGenericRelease(t),
                      ReadableStreamCreateReadResult(r.value, a, !0)
                    );
                  },
                );
          },
          return: function (t) {
            if (!1 === IsReadableStreamAsyncIterator(this))
              return promiseRejectedWith(
                streamAsyncIteratorBrandCheckException("next"),
              );
            var r = this._asyncIteratorReader;
            if (void 0 === r._ownerReadableStream)
              return promiseRejectedWith(
                readerLockException("finish iterating"),
              );
            if (r._readRequests.length > 0)
              return promiseRejectedWith(
                new TypeError(
                  "Tried to release a reader lock when that reader has pending read() calls un-settled",
                ),
              );
            if (!1 === this._preventCancel) {
              var a = ReadableStreamReaderGenericCancel(r, t);
              return (
                ReadableStreamReaderGenericRelease(r),
                transformPromiseWith(a, function () {
                  return ReadableStreamCreateReadResult(t, !0, !0);
                })
              );
            }
            return (
              ReadableStreamReaderGenericRelease(r),
              promiseResolvedWith(ReadableStreamCreateReadResult(t, !0, !0))
            );
          },
        };
        function AcquireReadableStreamAsyncIterator(t, r) {
          void 0 === r && (r = !1);
          var a = AcquireReadableStreamDefaultReader(t),
            i = Object.create(v);
          return (
            (i._asyncIteratorReader = a), (i._preventCancel = Boolean(r)), i
          );
        }
        function IsReadableStreamAsyncIterator(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(t, "_asyncIteratorReader")
          );
        }
        function streamAsyncIteratorBrandCheckException(t) {
          return new TypeError(
            "ReadableStreamAsyncIterator." +
              t +
              " can only be used on a ReadableSteamAsyncIterator",
          );
        }
        function DequeueValue(t) {
          var r = t._queue.shift();
          return (
            (t._queueTotalSize -= r.size),
            t._queueTotalSize < 0 && (t._queueTotalSize = 0),
            r.value
          );
        }
        function EnqueueValueWithSize(t, r, a) {
          if (!IsFiniteNonNegativeNumber((a = Number(a))))
            throw new RangeError(
              "Size must be a finite, non-NaN, non-negative number.",
            );
          t._queue.push({ value: r, size: a }), (t._queueTotalSize += a);
        }
        function PeekQueueValue(t) {
          return t._queue.peek().value;
        }
        function ResetQueue(t) {
          (t._queue = new d()), (t._queueTotalSize = 0);
        }
        void 0 !== b && Object.setPrototypeOf(v, b),
          Object.defineProperty(v, "next", { enumerable: !1 }),
          Object.defineProperty(v, "return", { enumerable: !1 });
        var S = r("[[AbortSteps]]"),
          k = r("[[ErrorSteps]]"),
          w = (function () {
            function WritableStream(t, r) {
              void 0 === t && (t = {}),
                void 0 === r && (r = {}),
                InitializeWritableStream(this);
              var a = r.size,
                i = r.highWaterMark;
              if (void 0 !== t.type)
                throw new RangeError("Invalid type is specified");
              var o = MakeSizeAlgorithmFromSizeFunction(a);
              void 0 === i && (i = 1),
                SetUpWritableStreamDefaultControllerFromUnderlyingSink(
                  this,
                  t,
                  (i = ValidateAndNormalizeHighWaterMark(i)),
                  o,
                );
            }
            return (
              Object.defineProperty(WritableStream.prototype, "locked", {
                get: function () {
                  if (!1 === IsWritableStream(this))
                    throw streamBrandCheckException("locked");
                  return IsWritableStreamLocked(this);
                },
                enumerable: !0,
                configurable: !0,
              }),
              (WritableStream.prototype.abort = function (t) {
                return !1 === IsWritableStream(this)
                  ? promiseRejectedWith(streamBrandCheckException("abort"))
                  : !0 === IsWritableStreamLocked(this)
                  ? promiseRejectedWith(
                      new TypeError(
                        "Cannot abort a stream that already has a writer",
                      ),
                    )
                  : WritableStreamAbort(this, t);
              }),
              (WritableStream.prototype.close = function () {
                return !1 === IsWritableStream(this)
                  ? promiseRejectedWith(streamBrandCheckException("close"))
                  : !0 === IsWritableStreamLocked(this)
                  ? promiseRejectedWith(
                      new TypeError(
                        "Cannot close a stream that already has a writer",
                      ),
                    )
                  : !0 === WritableStreamCloseQueuedOrInFlight(this)
                  ? promiseRejectedWith(
                      new TypeError("Cannot close an already-closing stream"),
                    )
                  : WritableStreamClose(this);
              }),
              (WritableStream.prototype.getWriter = function () {
                if (!1 === IsWritableStream(this))
                  throw streamBrandCheckException("getWriter");
                return AcquireWritableStreamDefaultWriter(this);
              }),
              WritableStream
            );
          })();
        function AcquireWritableStreamDefaultWriter(t) {
          return new C(t);
        }
        function CreateWritableStream(t, r, a, i, o, l) {
          void 0 === o && (o = 1),
            void 0 === l &&
              (l = function () {
                return 1;
              });
          var c = Object.create(w.prototype);
          return (
            InitializeWritableStream(c),
            SetUpWritableStreamDefaultController(
              c,
              Object.create(x.prototype),
              t,
              r,
              a,
              i,
              o,
              l,
            ),
            c
          );
        }
        function InitializeWritableStream(t) {
          (t._state = "writable"),
            (t._storedError = void 0),
            (t._writer = void 0),
            (t._writableStreamController = void 0),
            (t._writeRequests = new d()),
            (t._inFlightWriteRequest = void 0),
            (t._closeRequest = void 0),
            (t._inFlightCloseRequest = void 0),
            (t._pendingAbortRequest = void 0),
            (t._backpressure = !1);
        }
        function IsWritableStream(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(
              t,
              "_writableStreamController",
            )
          );
        }
        function IsWritableStreamLocked(t) {
          return void 0 !== t._writer;
        }
        function WritableStreamAbort(t, r) {
          var a = t._state;
          if ("closed" === a || "errored" === a)
            return promiseResolvedWith(void 0);
          if (void 0 !== t._pendingAbortRequest)
            return t._pendingAbortRequest._promise;
          var i = !1;
          "erroring" === a && ((i = !0), (r = void 0));
          var o = newPromise(function (a, o) {
            t._pendingAbortRequest = {
              _promise: void 0,
              _resolve: a,
              _reject: o,
              _reason: r,
              _wasAlreadyErroring: i,
            };
          });
          return (
            (t._pendingAbortRequest._promise = o),
            !1 === i && WritableStreamStartErroring(t, r),
            o
          );
        }
        function WritableStreamClose(t) {
          var r = t._state;
          if ("closed" === r || "errored" === r)
            return promiseRejectedWith(
              new TypeError(
                "The stream (in " +
                  r +
                  " state) is not in the writable state and cannot be closed",
              ),
            );
          var a = newPromise(function (r, a) {
              var i = { _resolve: r, _reject: a };
              t._closeRequest = i;
            }),
            i = t._writer;
          return (
            void 0 !== i &&
              !0 === t._backpressure &&
              "writable" === r &&
              defaultWriterReadyPromiseResolve(i),
            WritableStreamDefaultControllerClose(t._writableStreamController),
            a
          );
        }
        function WritableStreamAddWriteRequest(t) {
          return newPromise(function (r, a) {
            var i = { _resolve: r, _reject: a };
            t._writeRequests.push(i);
          });
        }
        function WritableStreamDealWithRejection(t, r) {
          "writable" !== t._state
            ? WritableStreamFinishErroring(t)
            : WritableStreamStartErroring(t, r);
        }
        function WritableStreamStartErroring(t, r) {
          var a = t._writableStreamController;
          (t._state = "erroring"), (t._storedError = r);
          var i = t._writer;
          void 0 !== i &&
            WritableStreamDefaultWriterEnsureReadyPromiseRejected(i, r),
            !1 === WritableStreamHasOperationMarkedInFlight(t) &&
              !0 === a._started &&
              WritableStreamFinishErroring(t);
        }
        function WritableStreamFinishErroring(t) {
          (t._state = "errored"), t._writableStreamController[k]();
          var r = t._storedError;
          if (
            (t._writeRequests.forEach(function (t) {
              t._reject(r);
            }),
            (t._writeRequests = new d()),
            void 0 !== t._pendingAbortRequest)
          ) {
            var a = t._pendingAbortRequest;
            if (
              ((t._pendingAbortRequest = void 0), !0 === a._wasAlreadyErroring)
            )
              return (
                a._reject(r),
                void WritableStreamRejectCloseAndClosedPromiseIfNeeded(t)
              );
            uponPromise(
              t._writableStreamController[S](a._reason),
              function () {
                a._resolve(),
                  WritableStreamRejectCloseAndClosedPromiseIfNeeded(t);
              },
              function (r) {
                a._reject(r),
                  WritableStreamRejectCloseAndClosedPromiseIfNeeded(t);
              },
            );
          } else WritableStreamRejectCloseAndClosedPromiseIfNeeded(t);
        }
        function WritableStreamFinishInFlightWrite(t) {
          t._inFlightWriteRequest._resolve(void 0),
            (t._inFlightWriteRequest = void 0);
        }
        function WritableStreamFinishInFlightWriteWithError(t, r) {
          t._inFlightWriteRequest._reject(r),
            (t._inFlightWriteRequest = void 0),
            WritableStreamDealWithRejection(t, r);
        }
        function WritableStreamFinishInFlightClose(t) {
          t._inFlightCloseRequest._resolve(void 0),
            (t._inFlightCloseRequest = void 0),
            "erroring" === t._state &&
              ((t._storedError = void 0),
              void 0 !== t._pendingAbortRequest &&
                (t._pendingAbortRequest._resolve(),
                (t._pendingAbortRequest = void 0))),
            (t._state = "closed");
          var r = t._writer;
          void 0 !== r && defaultWriterClosedPromiseResolve(r);
        }
        function WritableStreamFinishInFlightCloseWithError(t, r) {
          t._inFlightCloseRequest._reject(r),
            (t._inFlightCloseRequest = void 0),
            void 0 !== t._pendingAbortRequest &&
              (t._pendingAbortRequest._reject(r),
              (t._pendingAbortRequest = void 0)),
            WritableStreamDealWithRejection(t, r);
        }
        function WritableStreamCloseQueuedOrInFlight(t) {
          return (
            void 0 !== t._closeRequest || void 0 !== t._inFlightCloseRequest
          );
        }
        function WritableStreamHasOperationMarkedInFlight(t) {
          return (
            void 0 !== t._inFlightWriteRequest ||
            void 0 !== t._inFlightCloseRequest
          );
        }
        function WritableStreamMarkCloseRequestInFlight(t) {
          (t._inFlightCloseRequest = t._closeRequest),
            (t._closeRequest = void 0);
        }
        function WritableStreamMarkFirstWriteRequestInFlight(t) {
          t._inFlightWriteRequest = t._writeRequests.shift();
        }
        function WritableStreamRejectCloseAndClosedPromiseIfNeeded(t) {
          void 0 !== t._closeRequest &&
            (t._closeRequest._reject(t._storedError),
            (t._closeRequest = void 0));
          var r = t._writer;
          void 0 !== r && defaultWriterClosedPromiseReject(r, t._storedError);
        }
        function WritableStreamUpdateBackpressure(t, r) {
          var a = t._writer;
          void 0 !== a &&
            r !== t._backpressure &&
            (!0 === r
              ? defaultWriterReadyPromiseReset(a)
              : defaultWriterReadyPromiseResolve(a)),
            (t._backpressure = r);
        }
        var C = (function () {
          function WritableStreamDefaultWriter(t) {
            if (!1 === IsWritableStream(t))
              throw new TypeError(
                "WritableStreamDefaultWriter can only be constructed with a WritableStream instance",
              );
            if (!0 === IsWritableStreamLocked(t))
              throw new TypeError(
                "This stream has already been locked for exclusive writing by another writer",
              );
            (this._ownerWritableStream = t), (t._writer = this);
            var r = t._state;
            if ("writable" === r)
              !1 === WritableStreamCloseQueuedOrInFlight(t) &&
              !0 === t._backpressure
                ? defaultWriterReadyPromiseInitialize(this)
                : defaultWriterReadyPromiseInitializeAsResolved(this),
                defaultWriterClosedPromiseInitialize(this);
            else if ("erroring" === r)
              defaultWriterReadyPromiseInitializeAsRejected(
                this,
                t._storedError,
              ),
                defaultWriterClosedPromiseInitialize(this);
            else if ("closed" === r)
              defaultWriterReadyPromiseInitializeAsResolved(this),
                defaultWriterClosedPromiseInitializeAsResolved(this);
            else {
              var a = t._storedError;
              defaultWriterReadyPromiseInitializeAsRejected(this, a),
                defaultWriterClosedPromiseInitializeAsRejected(this, a);
            }
          }
          return (
            Object.defineProperty(
              WritableStreamDefaultWriter.prototype,
              "closed",
              {
                get: function () {
                  return !1 === IsWritableStreamDefaultWriter(this)
                    ? promiseRejectedWith(
                        defaultWriterBrandCheckException("closed"),
                      )
                    : this._closedPromise;
                },
                enumerable: !0,
                configurable: !0,
              },
            ),
            Object.defineProperty(
              WritableStreamDefaultWriter.prototype,
              "desiredSize",
              {
                get: function () {
                  if (!1 === IsWritableStreamDefaultWriter(this))
                    throw defaultWriterBrandCheckException("desiredSize");
                  if (void 0 === this._ownerWritableStream)
                    throw defaultWriterLockException("desiredSize");
                  return WritableStreamDefaultWriterGetDesiredSize(this);
                },
                enumerable: !0,
                configurable: !0,
              },
            ),
            Object.defineProperty(
              WritableStreamDefaultWriter.prototype,
              "ready",
              {
                get: function () {
                  return !1 === IsWritableStreamDefaultWriter(this)
                    ? promiseRejectedWith(
                        defaultWriterBrandCheckException("ready"),
                      )
                    : this._readyPromise;
                },
                enumerable: !0,
                configurable: !0,
              },
            ),
            (WritableStreamDefaultWriter.prototype.abort = function (t) {
              return !1 === IsWritableStreamDefaultWriter(this)
                ? promiseRejectedWith(defaultWriterBrandCheckException("abort"))
                : void 0 === this._ownerWritableStream
                ? promiseRejectedWith(defaultWriterLockException("abort"))
                : WritableStreamDefaultWriterAbort(this, t);
            }),
            (WritableStreamDefaultWriter.prototype.close = function () {
              if (!1 === IsWritableStreamDefaultWriter(this))
                return promiseRejectedWith(
                  defaultWriterBrandCheckException("close"),
                );
              var t = this._ownerWritableStream;
              return void 0 === t
                ? promiseRejectedWith(defaultWriterLockException("close"))
                : !0 === WritableStreamCloseQueuedOrInFlight(t)
                ? promiseRejectedWith(
                    new TypeError("Cannot close an already-closing stream"),
                  )
                : WritableStreamDefaultWriterClose(this);
            }),
            (WritableStreamDefaultWriter.prototype.releaseLock = function () {
              if (!1 === IsWritableStreamDefaultWriter(this))
                throw defaultWriterBrandCheckException("releaseLock");
              void 0 !== this._ownerWritableStream &&
                WritableStreamDefaultWriterRelease(this);
            }),
            (WritableStreamDefaultWriter.prototype.write = function (t) {
              return !1 === IsWritableStreamDefaultWriter(this)
                ? promiseRejectedWith(defaultWriterBrandCheckException("write"))
                : void 0 === this._ownerWritableStream
                ? promiseRejectedWith(defaultWriterLockException("write to"))
                : WritableStreamDefaultWriterWrite(this, t);
            }),
            WritableStreamDefaultWriter
          );
        })();
        function IsWritableStreamDefaultWriter(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(t, "_ownerWritableStream")
          );
        }
        function WritableStreamDefaultWriterAbort(t, r) {
          return WritableStreamAbort(t._ownerWritableStream, r);
        }
        function WritableStreamDefaultWriterClose(t) {
          return WritableStreamClose(t._ownerWritableStream);
        }
        function WritableStreamDefaultWriterCloseWithErrorPropagation(t) {
          var r = t._ownerWritableStream,
            a = r._state;
          return !0 === WritableStreamCloseQueuedOrInFlight(r) || "closed" === a
            ? promiseResolvedWith(void 0)
            : "errored" === a
            ? promiseRejectedWith(r._storedError)
            : WritableStreamDefaultWriterClose(t);
        }
        function WritableStreamDefaultWriterEnsureClosedPromiseRejected(t, r) {
          "pending" === t._closedPromiseState
            ? defaultWriterClosedPromiseReject(t, r)
            : defaultWriterClosedPromiseResetToRejected(t, r);
        }
        function WritableStreamDefaultWriterEnsureReadyPromiseRejected(t, r) {
          "pending" === t._readyPromiseState
            ? defaultWriterReadyPromiseReject(t, r)
            : defaultWriterReadyPromiseResetToRejected(t, r);
        }
        function WritableStreamDefaultWriterGetDesiredSize(t) {
          var r = t._ownerWritableStream,
            a = r._state;
          return "errored" === a || "erroring" === a
            ? null
            : "closed" === a
            ? 0
            : WritableStreamDefaultControllerGetDesiredSize(
                r._writableStreamController,
              );
        }
        function WritableStreamDefaultWriterRelease(t) {
          var r = t._ownerWritableStream,
            a = new TypeError(
              "Writer was released and can no longer be used to monitor the stream's closedness",
            );
          WritableStreamDefaultWriterEnsureReadyPromiseRejected(t, a),
            WritableStreamDefaultWriterEnsureClosedPromiseRejected(t, a),
            (r._writer = void 0),
            (t._ownerWritableStream = void 0);
        }
        function WritableStreamDefaultWriterWrite(t, r) {
          var a = t._ownerWritableStream,
            i = a._writableStreamController,
            o = WritableStreamDefaultControllerGetChunkSize(i, r);
          if (a !== t._ownerWritableStream)
            return promiseRejectedWith(defaultWriterLockException("write to"));
          var l = a._state;
          if ("errored" === l) return promiseRejectedWith(a._storedError);
          if (!0 === WritableStreamCloseQueuedOrInFlight(a) || "closed" === l)
            return promiseRejectedWith(
              new TypeError(
                "The stream is closing or closed and cannot be written to",
              ),
            );
          if ("erroring" === l) return promiseRejectedWith(a._storedError);
          var c = WritableStreamAddWriteRequest(a);
          return WritableStreamDefaultControllerWrite(i, r, o), c;
        }
        var x = (function () {
          function WritableStreamDefaultController() {
            throw new TypeError(
              "WritableStreamDefaultController cannot be constructed explicitly",
            );
          }
          return (
            (WritableStreamDefaultController.prototype.error = function (t) {
              if (!1 === IsWritableStreamDefaultController(this))
                throw new TypeError(
                  "WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController",
                );
              "writable" === this._controlledWritableStream._state &&
                WritableStreamDefaultControllerError(this, t);
            }),
            (WritableStreamDefaultController.prototype[S] = function (t) {
              var r = this._abortAlgorithm(t);
              return WritableStreamDefaultControllerClearAlgorithms(this), r;
            }),
            (WritableStreamDefaultController.prototype[k] = function () {
              ResetQueue(this);
            }),
            WritableStreamDefaultController
          );
        })();
        function IsWritableStreamDefaultController(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(
              t,
              "_controlledWritableStream",
            )
          );
        }
        function SetUpWritableStreamDefaultController(t, r, a, i, o, l, c, u) {
          (r._controlledWritableStream = t),
            (t._writableStreamController = r),
            (r._queue = void 0),
            (r._queueTotalSize = void 0),
            ResetQueue(r),
            (r._started = !1),
            (r._strategySizeAlgorithm = u),
            (r._strategyHWM = c),
            (r._writeAlgorithm = i),
            (r._closeAlgorithm = o),
            (r._abortAlgorithm = l);
          var h = WritableStreamDefaultControllerGetBackpressure(r);
          WritableStreamUpdateBackpressure(t, h),
            uponPromise(
              promiseResolvedWith(a()),
              function () {
                (r._started = !0),
                  WritableStreamDefaultControllerAdvanceQueueIfNeeded(r);
              },
              function (a) {
                (r._started = !0), WritableStreamDealWithRejection(t, a);
              },
            );
        }
        function SetUpWritableStreamDefaultControllerFromUnderlyingSink(
          t,
          r,
          a,
          i,
        ) {
          var o = Object.create(x.prototype);
          function startAlgorithm() {
            return InvokeOrNoop(r, "start", [o]);
          }
          var l = CreateAlgorithmFromUnderlyingMethod(r, "write", 1, [o]),
            c = CreateAlgorithmFromUnderlyingMethod(r, "close", 0, []),
            u = CreateAlgorithmFromUnderlyingMethod(r, "abort", 1, []);
          SetUpWritableStreamDefaultController(
            t,
            o,
            startAlgorithm,
            l,
            c,
            u,
            a,
            i,
          );
        }
        function WritableStreamDefaultControllerClearAlgorithms(t) {
          (t._writeAlgorithm = void 0),
            (t._closeAlgorithm = void 0),
            (t._abortAlgorithm = void 0),
            (t._strategySizeAlgorithm = void 0);
        }
        function WritableStreamDefaultControllerClose(t) {
          EnqueueValueWithSize(t, "close", 0),
            WritableStreamDefaultControllerAdvanceQueueIfNeeded(t);
        }
        function WritableStreamDefaultControllerGetChunkSize(t, r) {
          try {
            return t._strategySizeAlgorithm(r);
          } catch (r) {
            return WritableStreamDefaultControllerErrorIfNeeded(t, r), 1;
          }
        }
        function WritableStreamDefaultControllerGetDesiredSize(t) {
          return t._strategyHWM - t._queueTotalSize;
        }
        function WritableStreamDefaultControllerWrite(t, r, a) {
          var i = { chunk: r };
          try {
            EnqueueValueWithSize(t, i, a);
          } catch (r) {
            return void WritableStreamDefaultControllerErrorIfNeeded(t, r);
          }
          var o = t._controlledWritableStream;
          !1 === WritableStreamCloseQueuedOrInFlight(o) &&
            "writable" === o._state &&
            WritableStreamUpdateBackpressure(
              o,
              WritableStreamDefaultControllerGetBackpressure(t),
            ),
            WritableStreamDefaultControllerAdvanceQueueIfNeeded(t);
        }
        function WritableStreamDefaultControllerAdvanceQueueIfNeeded(t) {
          var r = t._controlledWritableStream;
          if (!1 !== t._started && void 0 === r._inFlightWriteRequest)
            if ("erroring" !== r._state) {
              if (0 !== t._queue.length) {
                var a = PeekQueueValue(t);
                "close" === a
                  ? WritableStreamDefaultControllerProcessClose(t)
                  : WritableStreamDefaultControllerProcessWrite(t, a.chunk);
              }
            } else WritableStreamFinishErroring(r);
        }
        function WritableStreamDefaultControllerErrorIfNeeded(t, r) {
          "writable" === t._controlledWritableStream._state &&
            WritableStreamDefaultControllerError(t, r);
        }
        function WritableStreamDefaultControllerProcessClose(t) {
          var r = t._controlledWritableStream;
          WritableStreamMarkCloseRequestInFlight(r), DequeueValue(t);
          var a = t._closeAlgorithm();
          WritableStreamDefaultControllerClearAlgorithms(t),
            uponPromise(
              a,
              function () {
                WritableStreamFinishInFlightClose(r);
              },
              function (t) {
                WritableStreamFinishInFlightCloseWithError(r, t);
              },
            );
        }
        function WritableStreamDefaultControllerProcessWrite(t, r) {
          var a = t._controlledWritableStream;
          WritableStreamMarkFirstWriteRequestInFlight(a),
            uponPromise(
              t._writeAlgorithm(r),
              function () {
                WritableStreamFinishInFlightWrite(a);
                var r = a._state;
                if (
                  (DequeueValue(t),
                  !1 === WritableStreamCloseQueuedOrInFlight(a) &&
                    "writable" === r)
                ) {
                  var i = WritableStreamDefaultControllerGetBackpressure(t);
                  WritableStreamUpdateBackpressure(a, i);
                }
                WritableStreamDefaultControllerAdvanceQueueIfNeeded(t);
              },
              function (r) {
                "writable" === a._state &&
                  WritableStreamDefaultControllerClearAlgorithms(t),
                  WritableStreamFinishInFlightWriteWithError(a, r);
              },
            );
        }
        function WritableStreamDefaultControllerGetBackpressure(t) {
          return WritableStreamDefaultControllerGetDesiredSize(t) <= 0;
        }
        function WritableStreamDefaultControllerError(t, r) {
          var a = t._controlledWritableStream;
          WritableStreamDefaultControllerClearAlgorithms(t),
            WritableStreamStartErroring(a, r);
        }
        function streamBrandCheckException(t) {
          return new TypeError(
            "WritableStream.prototype." +
              t +
              " can only be used on a WritableStream",
          );
        }
        function defaultWriterBrandCheckException(t) {
          return new TypeError(
            "WritableStreamDefaultWriter.prototype." +
              t +
              " can only be used on a WritableStreamDefaultWriter",
          );
        }
        function defaultWriterLockException(t) {
          return new TypeError(
            "Cannot " + t + " a stream using a released writer",
          );
        }
        function defaultWriterClosedPromiseInitialize(t) {
          t._closedPromise = newPromise(function (r, a) {
            (t._closedPromise_resolve = r),
              (t._closedPromise_reject = a),
              (t._closedPromiseState = "pending");
          });
        }
        function defaultWriterClosedPromiseInitializeAsRejected(t, r) {
          defaultWriterClosedPromiseInitialize(t),
            defaultWriterClosedPromiseReject(t, r);
        }
        function defaultWriterClosedPromiseInitializeAsResolved(t) {
          defaultWriterClosedPromiseInitialize(t),
            defaultWriterClosedPromiseResolve(t);
        }
        function defaultWriterClosedPromiseReject(t, r) {
          setPromiseIsHandledToTrue(t._closedPromise),
            t._closedPromise_reject(r),
            (t._closedPromise_resolve = void 0),
            (t._closedPromise_reject = void 0),
            (t._closedPromiseState = "rejected");
        }
        function defaultWriterClosedPromiseResetToRejected(t, r) {
          defaultWriterClosedPromiseInitializeAsRejected(t, r);
        }
        function defaultWriterClosedPromiseResolve(t) {
          t._closedPromise_resolve(void 0),
            (t._closedPromise_resolve = void 0),
            (t._closedPromise_reject = void 0),
            (t._closedPromiseState = "resolved");
        }
        function defaultWriterReadyPromiseInitialize(t) {
          (t._readyPromise = newPromise(function (r, a) {
            (t._readyPromise_resolve = r), (t._readyPromise_reject = a);
          })),
            (t._readyPromiseState = "pending");
        }
        function defaultWriterReadyPromiseInitializeAsRejected(t, r) {
          defaultWriterReadyPromiseInitialize(t),
            defaultWriterReadyPromiseReject(t, r);
        }
        function defaultWriterReadyPromiseInitializeAsResolved(t) {
          defaultWriterReadyPromiseInitialize(t),
            defaultWriterReadyPromiseResolve(t);
        }
        function defaultWriterReadyPromiseReject(t, r) {
          setPromiseIsHandledToTrue(t._readyPromise),
            t._readyPromise_reject(r),
            (t._readyPromise_resolve = void 0),
            (t._readyPromise_reject = void 0),
            (t._readyPromiseState = "rejected");
        }
        function defaultWriterReadyPromiseReset(t) {
          defaultWriterReadyPromiseInitialize(t);
        }
        function defaultWriterReadyPromiseResetToRejected(t, r) {
          defaultWriterReadyPromiseInitializeAsRejected(t, r);
        }
        function defaultWriterReadyPromiseResolve(t) {
          t._readyPromise_resolve(void 0),
            (t._readyPromise_resolve = void 0),
            (t._readyPromise_reject = void 0),
            (t._readyPromiseState = "fulfilled");
        }
        function isAbortSignal(t) {
          if ("object" != typeof t || null === t) return !1;
          try {
            return "boolean" == typeof t.aborted;
          } catch (t) {
            return !1;
          }
        }
        var _ = "undefined" != typeof DOMException ? DOMException : void 0;
        function isDOMExceptionConstructor(t) {
          if ("function" != typeof t && "object" != typeof t) return !1;
          try {
            return new t(), !0;
          } catch (t) {
            return !1;
          }
        }
        function createDOMExceptionPolyfill() {
          var t = function DOMException(t, r) {
            (this.message = t || ""),
              (this.name = r || "Error"),
              Error.captureStackTrace &&
                Error.captureStackTrace(this, this.constructor);
          };
          return (
            (t.prototype = Object.create(Error.prototype)),
            Object.defineProperty(t.prototype, "constructor", {
              value: t,
              writable: !0,
              configurable: !0,
            }),
            t
          );
        }
        var A = isDOMExceptionConstructor(_) ? _ : createDOMExceptionPolyfill();
        function ReadableStreamPipeTo(t, r, a, i, o, l) {
          var c = AcquireReadableStreamDefaultReader(t),
            u = AcquireWritableStreamDefaultWriter(r);
          t._disturbed = !0;
          var h = !1,
            d = promiseResolvedWith(void 0);
          return newPromise(function (p, m) {
            var g;
            if (void 0 !== l) {
              if (
                ((g = function () {
                  var a = new A("Aborted", "AbortError"),
                    l = [];
                  !1 === i &&
                    l.push(function () {
                      return "writable" === r._state
                        ? WritableStreamAbort(r, a)
                        : promiseResolvedWith(void 0);
                    }),
                    !1 === o &&
                      l.push(function () {
                        return "readable" === t._state
                          ? ReadableStreamCancel(t, a)
                          : promiseResolvedWith(void 0);
                      }),
                    shutdownWithAction(
                      function () {
                        return Promise.all(
                          l.map(function (t) {
                            return t();
                          }),
                        );
                      },
                      !0,
                      a,
                    );
                }),
                !0 === l.aborted)
              )
                return void g();
              l.addEventListener("abort", g);
            }
            function pipeLoop() {
              return newPromise(function (t, r) {
                function next(a) {
                  a ? t() : PerformPromiseThen(pipeStep(), next, r);
                }
                next(!1);
              });
            }
            function pipeStep() {
              return !0 === h
                ? promiseResolvedWith(!0)
                : PerformPromiseThen(u._readyPromise, function () {
                    return PerformPromiseThen(
                      ReadableStreamDefaultReaderRead(c),
                      function (t) {
                        return (
                          !0 === t.done ||
                          ((d = PerformPromiseThen(
                            WritableStreamDefaultWriterWrite(u, t.value),
                            void 0,
                            noop,
                          )),
                          !1)
                        );
                      },
                    );
                  });
            }
            if (
              (isOrBecomesErrored(t, c._closedPromise, function (t) {
                !1 === i
                  ? shutdownWithAction(
                      function () {
                        return WritableStreamAbort(r, t);
                      },
                      !0,
                      t,
                    )
                  : shutdown(!0, t);
              }),
              isOrBecomesErrored(r, u._closedPromise, function (r) {
                !1 === o
                  ? shutdownWithAction(
                      function () {
                        return ReadableStreamCancel(t, r);
                      },
                      !0,
                      r,
                    )
                  : shutdown(!0, r);
              }),
              isOrBecomesClosed(t, c._closedPromise, function () {
                !1 === a
                  ? shutdownWithAction(function () {
                      return WritableStreamDefaultWriterCloseWithErrorPropagation(
                        u,
                      );
                    })
                  : shutdown();
              }),
              !0 === WritableStreamCloseQueuedOrInFlight(r) ||
                "closed" === r._state)
            ) {
              var b = new TypeError(
                "the destination writable stream closed before all data could be piped to it",
              );
              !1 === o
                ? shutdownWithAction(
                    function () {
                      return ReadableStreamCancel(t, b);
                    },
                    !0,
                    b,
                  )
                : shutdown(!0, b);
            }
            function waitForWritesToFinish() {
              var t = d;
              return PerformPromiseThen(d, function () {
                return t !== d ? waitForWritesToFinish() : void 0;
              });
            }
            function isOrBecomesErrored(t, r, a) {
              "errored" === t._state ? a(t._storedError) : uponRejection(r, a);
            }
            function isOrBecomesClosed(t, r, a) {
              "closed" === t._state ? a() : uponFulfillment(r, a);
            }
            function shutdownWithAction(t, a, i) {
              function doTheRest() {
                uponPromise(
                  t(),
                  function () {
                    return finalize(a, i);
                  },
                  function (t) {
                    return finalize(!0, t);
                  },
                );
              }
              !0 !== h &&
                ((h = !0),
                "writable" === r._state &&
                !1 === WritableStreamCloseQueuedOrInFlight(r)
                  ? uponFulfillment(waitForWritesToFinish(), doTheRest)
                  : doTheRest());
            }
            function shutdown(t, a) {
              !0 !== h &&
                ((h = !0),
                "writable" === r._state &&
                !1 === WritableStreamCloseQueuedOrInFlight(r)
                  ? uponFulfillment(waitForWritesToFinish(), function () {
                      return finalize(t, a);
                    })
                  : finalize(t, a));
            }
            function finalize(t, r) {
              WritableStreamDefaultWriterRelease(u),
                ReadableStreamReaderGenericRelease(c),
                void 0 !== l && l.removeEventListener("abort", g),
                t ? m(r) : p(void 0);
            }
            setPromiseIsHandledToTrue(pipeLoop());
          });
        }
        var R = (function () {
          function ReadableStreamDefaultController() {
            throw new TypeError();
          }
          return (
            Object.defineProperty(
              ReadableStreamDefaultController.prototype,
              "desiredSize",
              {
                get: function () {
                  if (!1 === IsReadableStreamDefaultController(this))
                    throw defaultControllerBrandCheckException("desiredSize");
                  return ReadableStreamDefaultControllerGetDesiredSize(this);
                },
                enumerable: !0,
                configurable: !0,
              },
            ),
            (ReadableStreamDefaultController.prototype.close = function () {
              if (!1 === IsReadableStreamDefaultController(this))
                throw defaultControllerBrandCheckException("close");
              if (!1 === ReadableStreamDefaultControllerCanCloseOrEnqueue(this))
                throw new TypeError(
                  "The stream is not in a state that permits close",
                );
              ReadableStreamDefaultControllerClose(this);
            }),
            (ReadableStreamDefaultController.prototype.enqueue = function (t) {
              if (!1 === IsReadableStreamDefaultController(this))
                throw defaultControllerBrandCheckException("enqueue");
              if (!1 === ReadableStreamDefaultControllerCanCloseOrEnqueue(this))
                throw new TypeError(
                  "The stream is not in a state that permits enqueue",
                );
              return ReadableStreamDefaultControllerEnqueue(this, t);
            }),
            (ReadableStreamDefaultController.prototype.error = function (t) {
              if (!1 === IsReadableStreamDefaultController(this))
                throw defaultControllerBrandCheckException("error");
              ReadableStreamDefaultControllerError(this, t);
            }),
            (ReadableStreamDefaultController.prototype[p] = function (t) {
              ResetQueue(this);
              var r = this._cancelAlgorithm(t);
              return ReadableStreamDefaultControllerClearAlgorithms(this), r;
            }),
            (ReadableStreamDefaultController.prototype[m] = function () {
              var t = this._controlledReadableStream;
              if (this._queue.length > 0) {
                var r = DequeueValue(this);
                return (
                  !0 === this._closeRequested && 0 === this._queue.length
                    ? (ReadableStreamDefaultControllerClearAlgorithms(this),
                      ReadableStreamClose(t))
                    : ReadableStreamDefaultControllerCallPullIfNeeded(this),
                  promiseResolvedWith(
                    ReadableStreamCreateReadResult(
                      r,
                      !1,
                      t._reader._forAuthorCode,
                    ),
                  )
                );
              }
              var a = ReadableStreamAddReadRequest(t);
              return ReadableStreamDefaultControllerCallPullIfNeeded(this), a;
            }),
            ReadableStreamDefaultController
          );
        })();
        function IsReadableStreamDefaultController(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(
              t,
              "_controlledReadableStream",
            )
          );
        }
        function ReadableStreamDefaultControllerCallPullIfNeeded(t) {
          !1 !== ReadableStreamDefaultControllerShouldCallPull(t) &&
            (!0 !== t._pulling
              ? ((t._pulling = !0),
                uponPromise(
                  t._pullAlgorithm(),
                  function () {
                    (t._pulling = !1),
                      !0 === t._pullAgain &&
                        ((t._pullAgain = !1),
                        ReadableStreamDefaultControllerCallPullIfNeeded(t));
                  },
                  function (r) {
                    ReadableStreamDefaultControllerError(t, r);
                  },
                ))
              : (t._pullAgain = !0));
        }
        function ReadableStreamDefaultControllerShouldCallPull(t) {
          var r = t._controlledReadableStream;
          return (
            !1 !== ReadableStreamDefaultControllerCanCloseOrEnqueue(t) &&
            !1 !== t._started &&
            ((!0 === IsReadableStreamLocked(r) &&
              ReadableStreamGetNumReadRequests(r) > 0) ||
              ReadableStreamDefaultControllerGetDesiredSize(t) > 0)
          );
        }
        function ReadableStreamDefaultControllerClearAlgorithms(t) {
          (t._pullAlgorithm = void 0),
            (t._cancelAlgorithm = void 0),
            (t._strategySizeAlgorithm = void 0);
        }
        function ReadableStreamDefaultControllerClose(t) {
          var r = t._controlledReadableStream;
          (t._closeRequested = !0),
            0 === t._queue.length &&
              (ReadableStreamDefaultControllerClearAlgorithms(t),
              ReadableStreamClose(r));
        }
        function ReadableStreamDefaultControllerEnqueue(t, r) {
          var a = t._controlledReadableStream;
          if (
            !0 === IsReadableStreamLocked(a) &&
            ReadableStreamGetNumReadRequests(a) > 0
          )
            ReadableStreamFulfillReadRequest(a, r, !1);
          else {
            var i = void 0;
            try {
              i = t._strategySizeAlgorithm(r);
            } catch (r) {
              throw (ReadableStreamDefaultControllerError(t, r), r);
            }
            try {
              EnqueueValueWithSize(t, r, i);
            } catch (r) {
              throw (ReadableStreamDefaultControllerError(t, r), r);
            }
          }
          ReadableStreamDefaultControllerCallPullIfNeeded(t);
        }
        function ReadableStreamDefaultControllerError(t, r) {
          var a = t._controlledReadableStream;
          "readable" === a._state &&
            (ResetQueue(t),
            ReadableStreamDefaultControllerClearAlgorithms(t),
            ReadableStreamError(a, r));
        }
        function ReadableStreamDefaultControllerGetDesiredSize(t) {
          var r = t._controlledReadableStream._state;
          return "errored" === r
            ? null
            : "closed" === r
            ? 0
            : t._strategyHWM - t._queueTotalSize;
        }
        function ReadableStreamDefaultControllerHasBackpressure(t) {
          return !0 !== ReadableStreamDefaultControllerShouldCallPull(t);
        }
        function ReadableStreamDefaultControllerCanCloseOrEnqueue(t) {
          var r = t._controlledReadableStream._state;
          return !1 === t._closeRequested && "readable" === r;
        }
        function SetUpReadableStreamDefaultController(t, r, a, i, o, l, c) {
          (r._controlledReadableStream = t),
            (r._queue = void 0),
            (r._queueTotalSize = void 0),
            ResetQueue(r),
            (r._started = !1),
            (r._closeRequested = !1),
            (r._pullAgain = !1),
            (r._pulling = !1),
            (r._strategySizeAlgorithm = c),
            (r._strategyHWM = l),
            (r._pullAlgorithm = i),
            (r._cancelAlgorithm = o),
            (t._readableStreamController = r),
            uponPromise(
              promiseResolvedWith(a()),
              function () {
                (r._started = !0),
                  ReadableStreamDefaultControllerCallPullIfNeeded(r);
              },
              function (t) {
                ReadableStreamDefaultControllerError(r, t);
              },
            );
        }
        function SetUpReadableStreamDefaultControllerFromUnderlyingSource(
          t,
          r,
          a,
          i,
        ) {
          var o = Object.create(R.prototype);
          function startAlgorithm() {
            return InvokeOrNoop(r, "start", [o]);
          }
          var l = CreateAlgorithmFromUnderlyingMethod(r, "pull", 0, [o]),
            c = CreateAlgorithmFromUnderlyingMethod(r, "cancel", 1, []);
          SetUpReadableStreamDefaultController(
            t,
            o,
            startAlgorithm,
            l,
            c,
            a,
            i,
          );
        }
        function defaultControllerBrandCheckException(t) {
          return new TypeError(
            "ReadableStreamDefaultController.prototype." +
              t +
              " can only be used on a ReadableStreamDefaultController",
          );
        }
        function ReadableStreamTee(t, r) {
          var a,
            i,
            o,
            l,
            c,
            u = AcquireReadableStreamDefaultReader(t),
            h = !1,
            d = !1,
            p = !1,
            m = newPromise(function (t) {
              c = t;
            });
          function pullAlgorithm() {
            return (
              !0 === h ||
                ((h = !0),
                setPromiseIsHandledToTrue(
                  transformPromiseWith(
                    ReadableStreamDefaultReaderRead(u),
                    function (t) {
                      if (((h = !1), !0 === t.done))
                        return (
                          !1 === d &&
                            ReadableStreamDefaultControllerClose(
                              o._readableStreamController,
                            ),
                          void (
                            !1 === p &&
                            ReadableStreamDefaultControllerClose(
                              l._readableStreamController,
                            )
                          )
                        );
                      var r = t.value,
                        a = r,
                        i = r;
                      !1 === d &&
                        ReadableStreamDefaultControllerEnqueue(
                          o._readableStreamController,
                          a,
                        ),
                        !1 === p &&
                          ReadableStreamDefaultControllerEnqueue(
                            l._readableStreamController,
                            i,
                          );
                    },
                  ),
                )),
              promiseResolvedWith(void 0)
            );
          }
          function cancel1Algorithm(r) {
            if (((d = !0), (a = r), !0 === p)) {
              var o = createArrayFromList([a, i]),
                l = ReadableStreamCancel(t, o);
              c(l);
            }
            return m;
          }
          function cancel2Algorithm(r) {
            if (((p = !0), (i = r), !0 === d)) {
              var o = createArrayFromList([a, i]),
                l = ReadableStreamCancel(t, o);
              c(l);
            }
            return m;
          }
          function startAlgorithm() {}
          return (
            (o = CreateReadableStream(
              startAlgorithm,
              pullAlgorithm,
              cancel1Algorithm,
            )),
            (l = CreateReadableStream(
              startAlgorithm,
              pullAlgorithm,
              cancel2Algorithm,
            )),
            uponRejection(u._closedPromise, function (t) {
              ReadableStreamDefaultControllerError(
                o._readableStreamController,
                t,
              ),
                ReadableStreamDefaultControllerError(
                  l._readableStreamController,
                  t,
                );
            }),
            [o, l]
          );
        }
        var T =
            Number.isInteger ||
            function (t) {
              return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
            },
          I = (function () {
            function ReadableStreamBYOBRequest() {
              throw new TypeError(
                "ReadableStreamBYOBRequest cannot be used directly",
              );
            }
            return (
              Object.defineProperty(
                ReadableStreamBYOBRequest.prototype,
                "view",
                {
                  get: function () {
                    if (!1 === IsReadableStreamBYOBRequest(this))
                      throw byobRequestBrandCheckException("view");
                    return this._view;
                  },
                  enumerable: !0,
                  configurable: !0,
                },
              ),
              (ReadableStreamBYOBRequest.prototype.respond = function (t) {
                if (!1 === IsReadableStreamBYOBRequest(this))
                  throw byobRequestBrandCheckException("respond");
                if (void 0 === this._associatedReadableByteStreamController)
                  throw new TypeError("This BYOB request has been invalidated");
                IsDetachedBuffer(this._view.buffer),
                  ReadableByteStreamControllerRespond(
                    this._associatedReadableByteStreamController,
                    t,
                  );
              }),
              (ReadableStreamBYOBRequest.prototype.respondWithNewView =
                function (t) {
                  if (!1 === IsReadableStreamBYOBRequest(this))
                    throw byobRequestBrandCheckException("respond");
                  if (void 0 === this._associatedReadableByteStreamController)
                    throw new TypeError(
                      "This BYOB request has been invalidated",
                    );
                  if (!ArrayBuffer.isView(t))
                    throw new TypeError(
                      "You can only respond with array buffer views",
                    );
                  IsDetachedBuffer(t.buffer),
                    ReadableByteStreamControllerRespondWithNewView(
                      this._associatedReadableByteStreamController,
                      t,
                    );
                }),
              ReadableStreamBYOBRequest
            );
          })(),
          P = (function () {
            function ReadableByteStreamController() {
              throw new TypeError(
                "ReadableByteStreamController constructor cannot be used directly",
              );
            }
            return (
              Object.defineProperty(
                ReadableByteStreamController.prototype,
                "byobRequest",
                {
                  get: function () {
                    if (!1 === IsReadableByteStreamController(this))
                      throw byteStreamControllerBrandCheckException(
                        "byobRequest",
                      );
                    if (
                      void 0 === this._byobRequest &&
                      this._pendingPullIntos.length > 0
                    ) {
                      var t = this._pendingPullIntos.peek(),
                        r = new Uint8Array(
                          t.buffer,
                          t.byteOffset + t.bytesFilled,
                          t.byteLength - t.bytesFilled,
                        ),
                        a = Object.create(I.prototype);
                      SetUpReadableStreamBYOBRequest(a, this, r),
                        (this._byobRequest = a);
                    }
                    return this._byobRequest;
                  },
                  enumerable: !0,
                  configurable: !0,
                },
              ),
              Object.defineProperty(
                ReadableByteStreamController.prototype,
                "desiredSize",
                {
                  get: function () {
                    if (!1 === IsReadableByteStreamController(this))
                      throw byteStreamControllerBrandCheckException(
                        "desiredSize",
                      );
                    return ReadableByteStreamControllerGetDesiredSize(this);
                  },
                  enumerable: !0,
                  configurable: !0,
                },
              ),
              (ReadableByteStreamController.prototype.close = function () {
                if (!1 === IsReadableByteStreamController(this))
                  throw byteStreamControllerBrandCheckException("close");
                if (!0 === this._closeRequested)
                  throw new TypeError(
                    "The stream has already been closed; do not close it again!",
                  );
                var t = this._controlledReadableByteStream._state;
                if ("readable" !== t)
                  throw new TypeError(
                    "The stream (in " +
                      t +
                      " state) is not in the readable state and cannot be closed",
                  );
                ReadableByteStreamControllerClose(this);
              }),
              (ReadableByteStreamController.prototype.enqueue = function (t) {
                if (!1 === IsReadableByteStreamController(this))
                  throw byteStreamControllerBrandCheckException("enqueue");
                if (!0 === this._closeRequested)
                  throw new TypeError("stream is closed or draining");
                var r = this._controlledReadableByteStream._state;
                if ("readable" !== r)
                  throw new TypeError(
                    "The stream (in " +
                      r +
                      " state) is not in the readable state and cannot be enqueued to",
                  );
                if (!ArrayBuffer.isView(t))
                  throw new TypeError(
                    "You can only enqueue array buffer views when using a ReadableByteStreamController",
                  );
                IsDetachedBuffer(t.buffer),
                  ReadableByteStreamControllerEnqueue(this, t);
              }),
              (ReadableByteStreamController.prototype.error = function (t) {
                if (!1 === IsReadableByteStreamController(this))
                  throw byteStreamControllerBrandCheckException("error");
                ReadableByteStreamControllerError(this, t);
              }),
              (ReadableByteStreamController.prototype[p] = function (t) {
                this._pendingPullIntos.length > 0 &&
                  (this._pendingPullIntos.peek().bytesFilled = 0),
                  ResetQueue(this);
                var r = this._cancelAlgorithm(t);
                return ReadableByteStreamControllerClearAlgorithms(this), r;
              }),
              (ReadableByteStreamController.prototype[m] = function () {
                var t = this._controlledReadableByteStream;
                if (this._queueTotalSize > 0) {
                  var r = this._queue.shift();
                  (this._queueTotalSize -= r.byteLength),
                    ReadableByteStreamControllerHandleQueueDrain(this);
                  var a = void 0;
                  try {
                    a = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
                  } catch (t) {
                    return promiseRejectedWith(t);
                  }
                  return promiseResolvedWith(
                    ReadableStreamCreateReadResult(
                      a,
                      !1,
                      t._reader._forAuthorCode,
                    ),
                  );
                }
                var i = this._autoAllocateChunkSize;
                if (void 0 !== i) {
                  var o = void 0;
                  try {
                    o = new ArrayBuffer(i);
                  } catch (t) {
                    return promiseRejectedWith(t);
                  }
                  var l = {
                    buffer: o,
                    byteOffset: 0,
                    byteLength: i,
                    bytesFilled: 0,
                    elementSize: 1,
                    ctor: Uint8Array,
                    readerType: "default",
                  };
                  this._pendingPullIntos.push(l);
                }
                var c = ReadableStreamAddReadRequest(t);
                return ReadableByteStreamControllerCallPullIfNeeded(this), c;
              }),
              ReadableByteStreamController
            );
          })();
        function IsReadableByteStreamController(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(
              t,
              "_controlledReadableByteStream",
            )
          );
        }
        function IsReadableStreamBYOBRequest(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(
              t,
              "_associatedReadableByteStreamController",
            )
          );
        }
        function ReadableByteStreamControllerCallPullIfNeeded(t) {
          !1 !== ReadableByteStreamControllerShouldCallPull(t) &&
            (!0 !== t._pulling
              ? ((t._pulling = !0),
                uponPromise(
                  t._pullAlgorithm(),
                  function () {
                    (t._pulling = !1),
                      !0 === t._pullAgain &&
                        ((t._pullAgain = !1),
                        ReadableByteStreamControllerCallPullIfNeeded(t));
                  },
                  function (r) {
                    ReadableByteStreamControllerError(t, r);
                  },
                ))
              : (t._pullAgain = !0));
        }
        function ReadableByteStreamControllerClearPendingPullIntos(t) {
          ReadableByteStreamControllerInvalidateBYOBRequest(t),
            (t._pendingPullIntos = new d());
        }
        function ReadableByteStreamControllerCommitPullIntoDescriptor(t, r) {
          var a = !1;
          "closed" === t._state && (a = !0);
          var i = ReadableByteStreamControllerConvertPullIntoDescriptor(r);
          "default" === r.readerType
            ? ReadableStreamFulfillReadRequest(t, i, a)
            : ReadableStreamFulfillReadIntoRequest(t, i, a);
        }
        function ReadableByteStreamControllerConvertPullIntoDescriptor(t) {
          var r = t.bytesFilled,
            a = t.elementSize;
          return new t.ctor(t.buffer, t.byteOffset, r / a);
        }
        function ReadableByteStreamControllerEnqueueChunkToQueue(t, r, a, i) {
          t._queue.push({ buffer: r, byteOffset: a, byteLength: i }),
            (t._queueTotalSize += i);
        }
        function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(
          t,
          r,
        ) {
          var a = r.elementSize,
            i = r.bytesFilled - (r.bytesFilled % a),
            o = Math.min(t._queueTotalSize, r.byteLength - r.bytesFilled),
            l = r.bytesFilled + o,
            c = l - (l % a),
            u = o,
            h = !1;
          c > i && ((u = c - r.bytesFilled), (h = !0));
          for (var d = t._queue; u > 0; ) {
            var p = d.peek(),
              m = Math.min(u, p.byteLength),
              g = r.byteOffset + r.bytesFilled;
            ArrayBufferCopy(r.buffer, g, p.buffer, p.byteOffset, m),
              p.byteLength === m
                ? d.shift()
                : ((p.byteOffset += m), (p.byteLength -= m)),
              (t._queueTotalSize -= m),
              ReadableByteStreamControllerFillHeadPullIntoDescriptor(t, m, r),
              (u -= m);
          }
          return h;
        }
        function ReadableByteStreamControllerFillHeadPullIntoDescriptor(
          t,
          r,
          a,
        ) {
          ReadableByteStreamControllerInvalidateBYOBRequest(t),
            (a.bytesFilled += r);
        }
        function ReadableByteStreamControllerHandleQueueDrain(t) {
          0 === t._queueTotalSize && !0 === t._closeRequested
            ? (ReadableByteStreamControllerClearAlgorithms(t),
              ReadableStreamClose(t._controlledReadableByteStream))
            : ReadableByteStreamControllerCallPullIfNeeded(t);
        }
        function ReadableByteStreamControllerInvalidateBYOBRequest(t) {
          void 0 !== t._byobRequest &&
            ((t._byobRequest._associatedReadableByteStreamController = void 0),
            (t._byobRequest._view = void 0),
            (t._byobRequest = void 0));
        }
        function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(
          t,
        ) {
          for (; t._pendingPullIntos.length > 0; ) {
            if (0 === t._queueTotalSize) return;
            var r = t._pendingPullIntos.peek();
            !0 ===
              ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(
                t,
                r,
              ) &&
              (ReadableByteStreamControllerShiftPendingPullInto(t),
              ReadableByteStreamControllerCommitPullIntoDescriptor(
                t._controlledReadableByteStream,
                r,
              ));
          }
        }
        function ReadableByteStreamControllerPullInto(t, r) {
          var a = t._controlledReadableByteStream,
            i = 1;
          r.constructor !== DataView && (i = r.constructor.BYTES_PER_ELEMENT);
          var o = r.constructor,
            l = {
              buffer: TransferArrayBuffer(r.buffer),
              byteOffset: r.byteOffset,
              byteLength: r.byteLength,
              bytesFilled: 0,
              elementSize: i,
              ctor: o,
              readerType: "byob",
            };
          if (t._pendingPullIntos.length > 0)
            return (
              t._pendingPullIntos.push(l), ReadableStreamAddReadIntoRequest(a)
            );
          if ("closed" === a._state)
            return promiseResolvedWith(
              ReadableStreamCreateReadResult(
                new o(l.buffer, l.byteOffset, 0),
                !0,
                a._reader._forAuthorCode,
              ),
            );
          if (t._queueTotalSize > 0) {
            if (
              !0 ===
              ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(t, l)
            ) {
              var c = ReadableByteStreamControllerConvertPullIntoDescriptor(l);
              return (
                ReadableByteStreamControllerHandleQueueDrain(t),
                promiseResolvedWith(
                  ReadableStreamCreateReadResult(
                    c,
                    !1,
                    a._reader._forAuthorCode,
                  ),
                )
              );
            }
            if (!0 === t._closeRequested) {
              var u = new TypeError(
                "Insufficient bytes to fill elements in the given buffer",
              );
              return (
                ReadableByteStreamControllerError(t, u), promiseRejectedWith(u)
              );
            }
          }
          t._pendingPullIntos.push(l);
          var h = ReadableStreamAddReadIntoRequest(a);
          return ReadableByteStreamControllerCallPullIfNeeded(t), h;
        }
        function ReadableByteStreamControllerRespondInClosedState(t, r) {
          r.buffer = TransferArrayBuffer(r.buffer);
          var a = t._controlledReadableByteStream;
          if (!0 === ReadableStreamHasBYOBReader(a))
            for (; ReadableStreamGetNumReadIntoRequests(a) > 0; )
              ReadableByteStreamControllerCommitPullIntoDescriptor(
                a,
                ReadableByteStreamControllerShiftPendingPullInto(t),
              );
        }
        function ReadableByteStreamControllerRespondInReadableState(t, r, a) {
          if (a.bytesFilled + r > a.byteLength)
            throw new RangeError("bytesWritten out of range");
          if (
            (ReadableByteStreamControllerFillHeadPullIntoDescriptor(t, r, a),
            !(a.bytesFilled < a.elementSize))
          ) {
            ReadableByteStreamControllerShiftPendingPullInto(t);
            var i = a.bytesFilled % a.elementSize;
            if (i > 0) {
              var o = a.byteOffset + a.bytesFilled,
                l = a.buffer.slice(o - i, o);
              ReadableByteStreamControllerEnqueueChunkToQueue(
                t,
                l,
                0,
                l.byteLength,
              );
            }
            (a.buffer = TransferArrayBuffer(a.buffer)),
              (a.bytesFilled -= i),
              ReadableByteStreamControllerCommitPullIntoDescriptor(
                t._controlledReadableByteStream,
                a,
              ),
              ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(
                t,
              );
          }
        }
        function ReadableByteStreamControllerRespondInternal(t, r) {
          var a = t._pendingPullIntos.peek();
          if ("closed" === t._controlledReadableByteStream._state) {
            if (0 !== r)
              throw new TypeError(
                "bytesWritten must be 0 when calling respond() on a closed stream",
              );
            ReadableByteStreamControllerRespondInClosedState(t, a);
          } else ReadableByteStreamControllerRespondInReadableState(t, r, a);
          ReadableByteStreamControllerCallPullIfNeeded(t);
        }
        function ReadableByteStreamControllerShiftPendingPullInto(t) {
          var r = t._pendingPullIntos.shift();
          return ReadableByteStreamControllerInvalidateBYOBRequest(t), r;
        }
        function ReadableByteStreamControllerShouldCallPull(t) {
          var r = t._controlledReadableByteStream;
          return (
            "readable" === r._state &&
            !0 !== t._closeRequested &&
            !1 !== t._started &&
            ((!0 === ReadableStreamHasDefaultReader(r) &&
              ReadableStreamGetNumReadRequests(r) > 0) ||
              (!0 === ReadableStreamHasBYOBReader(r) &&
                ReadableStreamGetNumReadIntoRequests(r) > 0) ||
              ReadableByteStreamControllerGetDesiredSize(t) > 0)
          );
        }
        function ReadableByteStreamControllerClearAlgorithms(t) {
          (t._pullAlgorithm = void 0), (t._cancelAlgorithm = void 0);
        }
        function ReadableByteStreamControllerClose(t) {
          var r = t._controlledReadableByteStream;
          if (t._queueTotalSize > 0) t._closeRequested = !0;
          else {
            if (
              t._pendingPullIntos.length > 0 &&
              t._pendingPullIntos.peek().bytesFilled > 0
            ) {
              var a = new TypeError(
                "Insufficient bytes to fill elements in the given buffer",
              );
              throw (ReadableByteStreamControllerError(t, a), a);
            }
            ReadableByteStreamControllerClearAlgorithms(t),
              ReadableStreamClose(r);
          }
        }
        function ReadableByteStreamControllerEnqueue(t, r) {
          var a = t._controlledReadableByteStream,
            i = r.buffer,
            o = r.byteOffset,
            l = r.byteLength,
            c = TransferArrayBuffer(i);
          !0 === ReadableStreamHasDefaultReader(a)
            ? 0 === ReadableStreamGetNumReadRequests(a)
              ? ReadableByteStreamControllerEnqueueChunkToQueue(t, c, o, l)
              : ReadableStreamFulfillReadRequest(a, new Uint8Array(c, o, l), !1)
            : !0 === ReadableStreamHasBYOBReader(a)
            ? (ReadableByteStreamControllerEnqueueChunkToQueue(t, c, o, l),
              ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(
                t,
              ))
            : ReadableByteStreamControllerEnqueueChunkToQueue(t, c, o, l),
            ReadableByteStreamControllerCallPullIfNeeded(t);
        }
        function ReadableByteStreamControllerError(t, r) {
          var a = t._controlledReadableByteStream;
          "readable" === a._state &&
            (ReadableByteStreamControllerClearPendingPullIntos(t),
            ResetQueue(t),
            ReadableByteStreamControllerClearAlgorithms(t),
            ReadableStreamError(a, r));
        }
        function ReadableByteStreamControllerGetDesiredSize(t) {
          var r = t._controlledReadableByteStream._state;
          return "errored" === r
            ? null
            : "closed" === r
            ? 0
            : t._strategyHWM - t._queueTotalSize;
        }
        function ReadableByteStreamControllerRespond(t, r) {
          if (!1 === IsFiniteNonNegativeNumber((r = Number(r))))
            throw new RangeError("bytesWritten must be a finite");
          ReadableByteStreamControllerRespondInternal(t, r);
        }
        function ReadableByteStreamControllerRespondWithNewView(t, r) {
          var a = t._pendingPullIntos.peek();
          if (a.byteOffset + a.bytesFilled !== r.byteOffset)
            throw new RangeError(
              "The region specified by view does not match byobRequest",
            );
          if (a.byteLength !== r.byteLength)
            throw new RangeError(
              "The buffer of view has different capacity than byobRequest",
            );
          (a.buffer = r.buffer),
            ReadableByteStreamControllerRespondInternal(t, r.byteLength);
        }
        function SetUpReadableByteStreamController(t, r, a, i, o, l, c) {
          (r._controlledReadableByteStream = t),
            (r._pullAgain = !1),
            (r._pulling = !1),
            (r._byobRequest = void 0),
            (r._queue = r._queueTotalSize = void 0),
            ResetQueue(r),
            (r._closeRequested = !1),
            (r._started = !1),
            (r._strategyHWM = ValidateAndNormalizeHighWaterMark(l)),
            (r._pullAlgorithm = i),
            (r._cancelAlgorithm = o),
            (r._autoAllocateChunkSize = c),
            (r._pendingPullIntos = new d()),
            (t._readableStreamController = r),
            uponPromise(
              promiseResolvedWith(a()),
              function () {
                (r._started = !0),
                  ReadableByteStreamControllerCallPullIfNeeded(r);
              },
              function (t) {
                ReadableByteStreamControllerError(r, t);
              },
            );
        }
        function SetUpReadableByteStreamControllerFromUnderlyingSource(
          t,
          r,
          a,
        ) {
          var i = Object.create(P.prototype);
          function startAlgorithm() {
            return InvokeOrNoop(r, "start", [i]);
          }
          var o = CreateAlgorithmFromUnderlyingMethod(r, "pull", 0, [i]),
            l = CreateAlgorithmFromUnderlyingMethod(r, "cancel", 1, []),
            c = r.autoAllocateChunkSize;
          if (void 0 !== c && ((c = Number(c)), !1 === T(c) || c <= 0))
            throw new RangeError(
              "autoAllocateChunkSize must be a positive integer",
            );
          SetUpReadableByteStreamController(t, i, startAlgorithm, o, l, a, c);
        }
        function SetUpReadableStreamBYOBRequest(t, r, a) {
          (t._associatedReadableByteStreamController = r), (t._view = a);
        }
        function byobRequestBrandCheckException(t) {
          return new TypeError(
            "ReadableStreamBYOBRequest.prototype." +
              t +
              " can only be used on a ReadableStreamBYOBRequest",
          );
        }
        function byteStreamControllerBrandCheckException(t) {
          return new TypeError(
            "ReadableByteStreamController.prototype." +
              t +
              " can only be used on a ReadableByteStreamController",
          );
        }
        function AcquireReadableStreamBYOBReader(t, r) {
          void 0 === r && (r = !1);
          var a = new O(t);
          return (a._forAuthorCode = r), a;
        }
        function ReadableStreamAddReadIntoRequest(t) {
          return newPromise(function (r, a) {
            var i = { _resolve: r, _reject: a };
            t._reader._readIntoRequests.push(i);
          });
        }
        function ReadableStreamFulfillReadIntoRequest(t, r, a) {
          var i = t._reader;
          i._readIntoRequests
            .shift()
            ._resolve(ReadableStreamCreateReadResult(r, a, i._forAuthorCode));
        }
        function ReadableStreamGetNumReadIntoRequests(t) {
          return t._reader._readIntoRequests.length;
        }
        function ReadableStreamHasBYOBReader(t) {
          var r = t._reader;
          return void 0 !== r && !!IsReadableStreamBYOBReader(r);
        }
        var O = (function () {
          function ReadableStreamBYOBReader(t) {
            if (!IsReadableStream(t))
              throw new TypeError(
                "ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a byte source",
              );
            if (
              !1 === IsReadableByteStreamController(t._readableStreamController)
            )
              throw new TypeError(
                "Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source",
              );
            if (IsReadableStreamLocked(t))
              throw new TypeError(
                "This stream has already been locked for exclusive reading by another reader",
              );
            ReadableStreamReaderGenericInitialize(this, t),
              (this._readIntoRequests = new d());
          }
          return (
            Object.defineProperty(
              ReadableStreamBYOBReader.prototype,
              "closed",
              {
                get: function () {
                  return IsReadableStreamBYOBReader(this)
                    ? this._closedPromise
                    : promiseRejectedWith(
                        byobReaderBrandCheckException("closed"),
                      );
                },
                enumerable: !0,
                configurable: !0,
              },
            ),
            (ReadableStreamBYOBReader.prototype.cancel = function (t) {
              return IsReadableStreamBYOBReader(this)
                ? void 0 === this._ownerReadableStream
                  ? promiseRejectedWith(readerLockException("cancel"))
                  : ReadableStreamReaderGenericCancel(this, t)
                : promiseRejectedWith(byobReaderBrandCheckException("cancel"));
            }),
            (ReadableStreamBYOBReader.prototype.read = function (t) {
              return IsReadableStreamBYOBReader(this)
                ? void 0 === this._ownerReadableStream
                  ? promiseRejectedWith(readerLockException("read from"))
                  : ArrayBuffer.isView(t)
                  ? (IsDetachedBuffer(t.buffer),
                    0 === t.byteLength
                      ? promiseRejectedWith(
                          new TypeError("view must have non-zero byteLength"),
                        )
                      : ReadableStreamBYOBReaderRead(this, t))
                  : promiseRejectedWith(
                      new TypeError("view must be an array buffer view"),
                    )
                : promiseRejectedWith(byobReaderBrandCheckException("read"));
            }),
            (ReadableStreamBYOBReader.prototype.releaseLock = function () {
              if (!IsReadableStreamBYOBReader(this))
                throw byobReaderBrandCheckException("releaseLock");
              if (void 0 !== this._ownerReadableStream) {
                if (this._readIntoRequests.length > 0)
                  throw new TypeError(
                    "Tried to release a reader lock when that reader has pending read() calls un-settled",
                  );
                ReadableStreamReaderGenericRelease(this);
              }
            }),
            ReadableStreamBYOBReader
          );
        })();
        function IsReadableStreamBYOBReader(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(t, "_readIntoRequests")
          );
        }
        function ReadableStreamBYOBReaderRead(t, r) {
          var a = t._ownerReadableStream;
          return (
            (a._disturbed = !0),
            "errored" === a._state
              ? promiseRejectedWith(a._storedError)
              : ReadableByteStreamControllerPullInto(
                  a._readableStreamController,
                  r,
                )
          );
        }
        function byobReaderBrandCheckException(t) {
          return new TypeError(
            "ReadableStreamBYOBReader.prototype." +
              t +
              " can only be used on a ReadableStreamBYOBReader",
          );
        }
        var E = (function () {
          function ReadableStream(t, r) {
            void 0 === t && (t = {}),
              void 0 === r && (r = {}),
              InitializeReadableStream(this);
            var a = r.size,
              i = r.highWaterMark,
              o = t.type;
            if ("bytes" === String(o)) {
              if (void 0 !== a)
                throw new RangeError(
                  "The strategy for a byte stream cannot have a size function",
                );
              void 0 === i && (i = 0),
                SetUpReadableByteStreamControllerFromUnderlyingSource(
                  this,
                  t,
                  (i = ValidateAndNormalizeHighWaterMark(i)),
                );
            } else {
              if (void 0 !== o)
                throw new RangeError("Invalid type is specified");
              var l = MakeSizeAlgorithmFromSizeFunction(a);
              void 0 === i && (i = 1),
                SetUpReadableStreamDefaultControllerFromUnderlyingSource(
                  this,
                  t,
                  (i = ValidateAndNormalizeHighWaterMark(i)),
                  l,
                );
            }
          }
          return (
            Object.defineProperty(ReadableStream.prototype, "locked", {
              get: function () {
                if (!1 === IsReadableStream(this))
                  throw streamBrandCheckException$1("locked");
                return IsReadableStreamLocked(this);
              },
              enumerable: !0,
              configurable: !0,
            }),
            (ReadableStream.prototype.cancel = function (t) {
              return !1 === IsReadableStream(this)
                ? promiseRejectedWith(streamBrandCheckException$1("cancel"))
                : !0 === IsReadableStreamLocked(this)
                ? promiseRejectedWith(
                    new TypeError(
                      "Cannot cancel a stream that already has a reader",
                    ),
                  )
                : ReadableStreamCancel(this, t);
            }),
            (ReadableStream.prototype.getReader = function (t) {
              var r = (void 0 === t ? {} : t).mode;
              if (!1 === IsReadableStream(this))
                throw streamBrandCheckException$1("getReader");
              if (void 0 === r)
                return AcquireReadableStreamDefaultReader(this, !0);
              if ("byob" === (r = String(r)))
                return AcquireReadableStreamBYOBReader(this, !0);
              throw new RangeError("Invalid mode is specified");
            }),
            (ReadableStream.prototype.pipeThrough = function (t, r) {
              var a = t.writable,
                i = t.readable,
                o = void 0 === r ? {} : r,
                l = o.preventClose,
                c = o.preventAbort,
                u = o.preventCancel,
                h = o.signal;
              if (!1 === IsReadableStream(this))
                throw streamBrandCheckException$1("pipeThrough");
              if (!1 === IsWritableStream(a))
                throw new TypeError(
                  "writable argument to pipeThrough must be a WritableStream",
                );
              if (!1 === IsReadableStream(i))
                throw new TypeError(
                  "readable argument to pipeThrough must be a ReadableStream",
                );
              if (
                ((l = Boolean(l)),
                (c = Boolean(c)),
                (u = Boolean(u)),
                void 0 !== h && !isAbortSignal(h))
              )
                throw new TypeError(
                  "ReadableStream.prototype.pipeThrough's signal option must be an AbortSignal",
                );
              if (!0 === IsReadableStreamLocked(this))
                throw new TypeError(
                  "ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream",
                );
              if (!0 === IsWritableStreamLocked(a))
                throw new TypeError(
                  "ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream",
                );
              return (
                setPromiseIsHandledToTrue(
                  ReadableStreamPipeTo(this, a, l, c, u, h),
                ),
                i
              );
            }),
            (ReadableStream.prototype.pipeTo = function (t, r) {
              var a = void 0 === r ? {} : r,
                i = a.preventClose,
                o = a.preventAbort,
                l = a.preventCancel,
                c = a.signal;
              return !1 === IsReadableStream(this)
                ? promiseRejectedWith(streamBrandCheckException$1("pipeTo"))
                : !1 === IsWritableStream(t)
                ? promiseRejectedWith(
                    new TypeError(
                      "ReadableStream.prototype.pipeTo's first argument must be a WritableStream",
                    ),
                  )
                : ((i = Boolean(i)),
                  (o = Boolean(o)),
                  (l = Boolean(l)),
                  void 0 === c || isAbortSignal(c)
                    ? !0 === IsReadableStreamLocked(this)
                      ? promiseRejectedWith(
                          new TypeError(
                            "ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream",
                          ),
                        )
                      : !0 === IsWritableStreamLocked(t)
                      ? promiseRejectedWith(
                          new TypeError(
                            "ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream",
                          ),
                        )
                      : ReadableStreamPipeTo(this, t, i, o, l, c)
                    : promiseRejectedWith(
                        new TypeError(
                          "ReadableStream.prototype.pipeTo's signal option must be an AbortSignal",
                        ),
                      ));
            }),
            (ReadableStream.prototype.tee = function () {
              if (!1 === IsReadableStream(this))
                throw streamBrandCheckException$1("tee");
              return createArrayFromList(ReadableStreamTee(this));
            }),
            (ReadableStream.prototype.getIterator = function (t) {
              var r = (void 0 === t ? {} : t).preventCancel,
                a = void 0 !== r && r;
              if (!1 === IsReadableStream(this))
                throw streamBrandCheckException$1("getIterator");
              return AcquireReadableStreamAsyncIterator(this, a);
            }),
            ReadableStream
          );
        })();
        function CreateReadableStream(t, r, a, i, o) {
          void 0 === i && (i = 1),
            void 0 === o &&
              (o = function () {
                return 1;
              });
          var l = Object.create(E.prototype);
          return (
            InitializeReadableStream(l),
            SetUpReadableStreamDefaultController(
              l,
              Object.create(R.prototype),
              t,
              r,
              a,
              i,
              o,
            ),
            l
          );
        }
        function InitializeReadableStream(t) {
          (t._state = "readable"),
            (t._reader = void 0),
            (t._storedError = void 0),
            (t._disturbed = !1);
        }
        function IsReadableStream(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(
              t,
              "_readableStreamController",
            )
          );
        }
        function IsReadableStreamLocked(t) {
          return void 0 !== t._reader;
        }
        function ReadableStreamCancel(t, r) {
          return (
            (t._disturbed = !0),
            "closed" === t._state
              ? promiseResolvedWith(void 0)
              : "errored" === t._state
              ? promiseRejectedWith(t._storedError)
              : (ReadableStreamClose(t),
                transformPromiseWith(t._readableStreamController[p](r), noop))
          );
        }
        function ReadableStreamClose(t) {
          t._state = "closed";
          var r = t._reader;
          void 0 !== r &&
            (IsReadableStreamDefaultReader(r) &&
              (r._readRequests.forEach(function (t) {
                t._resolve(
                  ReadableStreamCreateReadResult(void 0, !0, r._forAuthorCode),
                );
              }),
              (r._readRequests = new d())),
            defaultReaderClosedPromiseResolve(r));
        }
        function ReadableStreamError(t, r) {
          (t._state = "errored"), (t._storedError = r);
          var a = t._reader;
          void 0 !== a &&
            (IsReadableStreamDefaultReader(a)
              ? (a._readRequests.forEach(function (t) {
                  t._reject(r);
                }),
                (a._readRequests = new d()))
              : (a._readIntoRequests.forEach(function (t) {
                  t._reject(r);
                }),
                (a._readIntoRequests = new d())),
            defaultReaderClosedPromiseReject(a, r));
        }
        function streamBrandCheckException$1(t) {
          return new TypeError(
            "ReadableStream.prototype." +
              t +
              " can only be used on a ReadableStream",
          );
        }
        "symbol" == typeof r.asyncIterator &&
          Object.defineProperty(E.prototype, r.asyncIterator, {
            value: E.prototype.getIterator,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          });
        var B = (function () {
            function ByteLengthQueuingStrategy(t) {
              var r = t.highWaterMark;
              this.highWaterMark = r;
            }
            return (
              (ByteLengthQueuingStrategy.prototype.size = function (t) {
                return t.byteLength;
              }),
              ByteLengthQueuingStrategy
            );
          })(),
          D = (function () {
            function CountQueuingStrategy(t) {
              var r = t.highWaterMark;
              this.highWaterMark = r;
            }
            return (
              (CountQueuingStrategy.prototype.size = function () {
                return 1;
              }),
              CountQueuingStrategy
            );
          })(),
          M = (function () {
            function TransformStream(t, r, a) {
              void 0 === t && (t = {}),
                void 0 === r && (r = {}),
                void 0 === a && (a = {});
              var i = r.size,
                o = r.highWaterMark,
                l = a.size,
                c = a.highWaterMark;
              if (void 0 !== t.writableType)
                throw new RangeError("Invalid writable type specified");
              var u = MakeSizeAlgorithmFromSizeFunction(i);
              if (
                (void 0 === o && (o = 1),
                (o = ValidateAndNormalizeHighWaterMark(o)),
                void 0 !== t.readableType)
              )
                throw new RangeError("Invalid readable type specified");
              var h,
                d = MakeSizeAlgorithmFromSizeFunction(l);
              void 0 === c && (c = 0),
                (c = ValidateAndNormalizeHighWaterMark(c)),
                InitializeTransformStream(
                  this,
                  newPromise(function (t) {
                    h = t;
                  }),
                  o,
                  u,
                  c,
                  d,
                ),
                SetUpTransformStreamDefaultControllerFromTransformer(this, t);
              var p = InvokeOrNoop(t, "start", [
                this._transformStreamController,
              ]);
              h(p);
            }
            return (
              Object.defineProperty(TransformStream.prototype, "readable", {
                get: function () {
                  if (!1 === IsTransformStream(this))
                    throw streamBrandCheckException$2("readable");
                  return this._readable;
                },
                enumerable: !0,
                configurable: !0,
              }),
              Object.defineProperty(TransformStream.prototype, "writable", {
                get: function () {
                  if (!1 === IsTransformStream(this))
                    throw streamBrandCheckException$2("writable");
                  return this._writable;
                },
                enumerable: !0,
                configurable: !0,
              }),
              TransformStream
            );
          })();
        function InitializeTransformStream(t, r, a, i, o, l) {
          function startAlgorithm() {
            return r;
          }
          function writeAlgorithm(r) {
            return TransformStreamDefaultSinkWriteAlgorithm(t, r);
          }
          function abortAlgorithm(r) {
            return TransformStreamDefaultSinkAbortAlgorithm(t, r);
          }
          function closeAlgorithm() {
            return TransformStreamDefaultSinkCloseAlgorithm(t);
          }
          function pullAlgorithm() {
            return TransformStreamDefaultSourcePullAlgorithm(t);
          }
          function cancelAlgorithm(r) {
            return (
              TransformStreamErrorWritableAndUnblockWrite(t, r),
              promiseResolvedWith(void 0)
            );
          }
          (t._writable = CreateWritableStream(
            startAlgorithm,
            writeAlgorithm,
            closeAlgorithm,
            abortAlgorithm,
            a,
            i,
          )),
            (t._readable = CreateReadableStream(
              startAlgorithm,
              pullAlgorithm,
              cancelAlgorithm,
              o,
              l,
            )),
            (t._backpressure = void 0),
            (t._backpressureChangePromise = void 0),
            (t._backpressureChangePromise_resolve = void 0),
            TransformStreamSetBackpressure(t, !0),
            (t._transformStreamController = void 0);
        }
        function IsTransformStream(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(
              t,
              "_transformStreamController",
            )
          );
        }
        function TransformStreamError(t, r) {
          ReadableStreamDefaultControllerError(
            t._readable._readableStreamController,
            r,
          ),
            TransformStreamErrorWritableAndUnblockWrite(t, r);
        }
        function TransformStreamErrorWritableAndUnblockWrite(t, r) {
          TransformStreamDefaultControllerClearAlgorithms(
            t._transformStreamController,
          ),
            WritableStreamDefaultControllerErrorIfNeeded(
              t._writable._writableStreamController,
              r,
            ),
            !0 === t._backpressure && TransformStreamSetBackpressure(t, !1);
        }
        function TransformStreamSetBackpressure(t, r) {
          void 0 !== t._backpressureChangePromise &&
            t._backpressureChangePromise_resolve(),
            (t._backpressureChangePromise = newPromise(function (r) {
              t._backpressureChangePromise_resolve = r;
            })),
            (t._backpressure = r);
        }
        var L = (function () {
          function TransformStreamDefaultController() {
            throw new TypeError(
              "TransformStreamDefaultController instances cannot be created directly",
            );
          }
          return (
            Object.defineProperty(
              TransformStreamDefaultController.prototype,
              "desiredSize",
              {
                get: function () {
                  if (!1 === IsTransformStreamDefaultController(this))
                    throw defaultControllerBrandCheckException$1("desiredSize");
                  return ReadableStreamDefaultControllerGetDesiredSize(
                    this._controlledTransformStream._readable
                      ._readableStreamController,
                  );
                },
                enumerable: !0,
                configurable: !0,
              },
            ),
            (TransformStreamDefaultController.prototype.enqueue = function (t) {
              if (!1 === IsTransformStreamDefaultController(this))
                throw defaultControllerBrandCheckException$1("enqueue");
              TransformStreamDefaultControllerEnqueue(this, t);
            }),
            (TransformStreamDefaultController.prototype.error = function (t) {
              if (!1 === IsTransformStreamDefaultController(this))
                throw defaultControllerBrandCheckException$1("error");
              TransformStreamDefaultControllerError(this, t);
            }),
            (TransformStreamDefaultController.prototype.terminate =
              function () {
                if (!1 === IsTransformStreamDefaultController(this))
                  throw defaultControllerBrandCheckException$1("terminate");
                TransformStreamDefaultControllerTerminate(this);
              }),
            TransformStreamDefaultController
          );
        })();
        function IsTransformStreamDefaultController(t) {
          return (
            !!typeIsObject(t) &&
            !!Object.prototype.hasOwnProperty.call(
              t,
              "_controlledTransformStream",
            )
          );
        }
        function SetUpTransformStreamDefaultController(t, r, a, i) {
          (r._controlledTransformStream = t),
            (t._transformStreamController = r),
            (r._transformAlgorithm = a),
            (r._flushAlgorithm = i);
        }
        function SetUpTransformStreamDefaultControllerFromTransformer(t, r) {
          var a = Object.create(L.prototype),
            transformAlgorithm = function (t) {
              try {
                return (
                  TransformStreamDefaultControllerEnqueue(a, t),
                  promiseResolvedWith(void 0)
                );
              } catch (t) {
                return promiseRejectedWith(t);
              }
            },
            i = r.transform;
          if (void 0 !== i) {
            if ("function" != typeof i)
              throw new TypeError("transform is not a method");
            transformAlgorithm = function (t) {
              return PromiseCall(i, r, [t, a]);
            };
          }
          var o = CreateAlgorithmFromUnderlyingMethod(r, "flush", 0, [a]);
          SetUpTransformStreamDefaultController(t, a, transformAlgorithm, o);
        }
        function TransformStreamDefaultControllerClearAlgorithms(t) {
          (t._transformAlgorithm = void 0), (t._flushAlgorithm = void 0);
        }
        function TransformStreamDefaultControllerEnqueue(t, r) {
          var a = t._controlledTransformStream,
            i = a._readable._readableStreamController;
          if (!1 === ReadableStreamDefaultControllerCanCloseOrEnqueue(i))
            throw new TypeError(
              "Readable side is not in a state that permits enqueue",
            );
          try {
            ReadableStreamDefaultControllerEnqueue(i, r);
          } catch (t) {
            throw (
              (TransformStreamErrorWritableAndUnblockWrite(a, t),
              a._readable._storedError)
            );
          }
          ReadableStreamDefaultControllerHasBackpressure(i) !==
            a._backpressure && TransformStreamSetBackpressure(a, !0);
        }
        function TransformStreamDefaultControllerError(t, r) {
          TransformStreamError(t._controlledTransformStream, r);
        }
        function TransformStreamDefaultControllerPerformTransform(t, r) {
          return transformPromiseWith(
            t._transformAlgorithm(r),
            void 0,
            function (r) {
              throw (TransformStreamError(t._controlledTransformStream, r), r);
            },
          );
        }
        function TransformStreamDefaultControllerTerminate(t) {
          var r = t._controlledTransformStream,
            a = r._readable._readableStreamController;
          !0 === ReadableStreamDefaultControllerCanCloseOrEnqueue(a) &&
            ReadableStreamDefaultControllerClose(a),
            TransformStreamErrorWritableAndUnblockWrite(
              r,
              new TypeError("TransformStream terminated"),
            );
        }
        function TransformStreamDefaultSinkWriteAlgorithm(t, r) {
          var a = t._transformStreamController;
          return !0 === t._backpressure
            ? transformPromiseWith(t._backpressureChangePromise, function () {
                var i = t._writable;
                if ("erroring" === i._state) throw i._storedError;
                return TransformStreamDefaultControllerPerformTransform(a, r);
              })
            : TransformStreamDefaultControllerPerformTransform(a, r);
        }
        function TransformStreamDefaultSinkAbortAlgorithm(t, r) {
          return TransformStreamError(t, r), promiseResolvedWith(void 0);
        }
        function TransformStreamDefaultSinkCloseAlgorithm(t) {
          var r = t._readable,
            a = t._transformStreamController,
            i = a._flushAlgorithm();
          return (
            TransformStreamDefaultControllerClearAlgorithms(a),
            transformPromiseWith(
              i,
              function () {
                if ("errored" === r._state) throw r._storedError;
                var t = r._readableStreamController;
                !0 === ReadableStreamDefaultControllerCanCloseOrEnqueue(t) &&
                  ReadableStreamDefaultControllerClose(t);
              },
              function (a) {
                throw (TransformStreamError(t, a), r._storedError);
              },
            )
          );
        }
        function TransformStreamDefaultSourcePullAlgorithm(t) {
          return (
            TransformStreamSetBackpressure(t, !1), t._backpressureChangePromise
          );
        }
        function defaultControllerBrandCheckException$1(t) {
          return new TypeError(
            "TransformStreamDefaultController.prototype." +
              t +
              " can only be used on a TransformStreamDefaultController",
          );
        }
        function streamBrandCheckException$2(t) {
          return new TypeError(
            "TransformStream.prototype." +
              t +
              " can only be used on a TransformStream",
          );
        }
        (t.ByteLengthQueuingStrategy = B),
          (t.CountQueuingStrategy = D),
          (t.ReadableStream = E),
          (t.TransformStream = M),
          (t.WritableStream = w),
          Object.defineProperty(t, "__esModule", { value: !0 });
      })(r);
    },
    function (t, r, a) {
      a(145), a(114), a(77), a(116);
      var i = a(43);
      t.exports = i.Map;
    },
    function (t, r, a) {
      "use strict";
      var i = a(146),
        o = a(150);
      t.exports = i(
        "Map",
        function (t) {
          return function Map() {
            return t(this, arguments.length ? arguments[0] : void 0);
          };
        },
        o,
      );
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(11),
        l = a(52),
        c = a(29),
        u = a(147),
        h = a(124),
        d = a(123),
        p = a(22),
        m = a(14),
        g = a(97),
        b = a(85),
        y = a(149);
      t.exports = function (t, r, a) {
        var v = -1 !== t.indexOf("Map"),
          S = -1 !== t.indexOf("Weak"),
          k = v ? "set" : "add",
          w = o[t],
          C = w && w.prototype,
          x = w,
          _ = {},
          fixMethod = function (t) {
            var r = C[t];
            c(
              C,
              t,
              "add" == t
                ? function add(t) {
                    return r.call(this, 0 === t ? 0 : t), this;
                  }
                : "delete" == t
                ? function (t) {
                    return !(S && !p(t)) && r.call(this, 0 === t ? 0 : t);
                  }
                : "get" == t
                ? function get(t) {
                    return S && !p(t) ? void 0 : r.call(this, 0 === t ? 0 : t);
                  }
                : "has" == t
                ? function has(t) {
                    return !(S && !p(t)) && r.call(this, 0 === t ? 0 : t);
                  }
                : function set(t, a) {
                    return r.call(this, 0 === t ? 0 : t, a), this;
                  },
            );
          };
        if (
          l(
            t,
            "function" != typeof w ||
              !(
                S ||
                (C.forEach &&
                  !m(function () {
                    new w().entries().next();
                  }))
              ),
          )
        )
          (x = a.getConstructor(r, t, v, k)), (u.REQUIRED = !0);
        else if (l(t, !0)) {
          var A = new x(),
            R = A[k](S ? {} : -0, 1) != A,
            T = m(function () {
              A.has(1);
            }),
            I = g(function (t) {
              new w(t);
            }),
            P =
              !S &&
              m(function () {
                for (var t = new w(), r = 5; r--; ) t[k](r, r);
                return !t.has(-0);
              });
          I ||
            (((x = r(function (r, a) {
              d(r, x, t);
              var i = y(new w(), r, x);
              return null != a && h(a, i[k], i, v), i;
            })).prototype = C),
            (C.constructor = x)),
            (T || P) &&
              (fixMethod("delete"), fixMethod("has"), v && fixMethod("get")),
            (P || R) && fixMethod(k),
            S && C.clear && delete C.clear;
        }
        return (
          (_[t] = x),
          i({ global: !0, forced: x != w }, _),
          b(x, t),
          S || a.setStrong(x, t, v),
          x
        );
      };
    },
    function (t, r, a) {
      var i = a(39),
        o = a(22),
        l = a(23),
        c = a(27).f,
        u = a(38),
        h = a(148),
        d = u("meta"),
        p = 0,
        m =
          Object.isExtensible ||
          function () {
            return !0;
          },
        setMetadata = function (t) {
          c(t, d, { value: { objectID: "O" + ++p, weakData: {} } });
        },
        g = (t.exports = {
          REQUIRED: !1,
          fastKey: function (t, r) {
            if (!o(t))
              return "symbol" == typeof t
                ? t
                : ("string" == typeof t ? "S" : "P") + t;
            if (!l(t, d)) {
              if (!m(t)) return "F";
              if (!r) return "E";
              setMetadata(t);
            }
            return t[d].objectID;
          },
          getWeakData: function (t, r) {
            if (!l(t, d)) {
              if (!m(t)) return !0;
              if (!r) return !1;
              setMetadata(t);
            }
            return t[d].weakData;
          },
          onFreeze: function (t) {
            return h && g.REQUIRED && m(t) && !l(t, d) && setMetadata(t), t;
          },
        });
      i[d] = !0;
    },
    function (t, r, a) {
      var i = a(14);
      t.exports = !i(function () {
        return Object.isExtensible(Object.preventExtensions({}));
      });
    },
    function (t, r, a) {
      var i = a(22),
        o = a(87);
      t.exports = function (t, r, a) {
        var l, c;
        return (
          o &&
            "function" == typeof (l = r.constructor) &&
            l !== a &&
            i((c = l.prototype)) &&
            c !== a.prototype &&
            o(t, c),
          t
        );
      };
    },
    function (t, r, a) {
      "use strict";
      var i = a(27).f,
        o = a(71),
        l = a(121),
        c = a(62),
        u = a(123),
        h = a(124),
        d = a(79),
        p = a(122),
        m = a(13),
        g = a(147).fastKey,
        b = a(33),
        y = b.set,
        v = b.getterFor;
      t.exports = {
        getConstructor: function (t, r, a, d) {
          var p = t(function (t, i) {
              u(t, p, r),
                y(t, {
                  type: r,
                  index: o(null),
                  first: void 0,
                  last: void 0,
                  size: 0,
                }),
                m || (t.size = 0),
                null != i && h(i, t[d], t, a);
            }),
            b = v(r),
            define = function (t, r, a) {
              var i,
                o,
                l = b(t),
                c = getEntry(t, r);
              return (
                c
                  ? (c.value = a)
                  : ((l.last = c =
                      {
                        index: (o = g(r, !0)),
                        key: r,
                        value: a,
                        previous: (i = l.last),
                        next: void 0,
                        removed: !1,
                      }),
                    l.first || (l.first = c),
                    i && (i.next = c),
                    m ? l.size++ : t.size++,
                    "F" !== o && (l.index[o] = c)),
                t
              );
            },
            getEntry = function (t, r) {
              var a,
                i = b(t),
                o = g(r);
              if ("F" !== o) return i.index[o];
              for (a = i.first; a; a = a.next) if (a.key == r) return a;
            };
          return (
            l(p.prototype, {
              clear: function clear() {
                for (var t = b(this), r = t.index, a = t.first; a; )
                  (a.removed = !0),
                    a.previous && (a.previous = a.previous.next = void 0),
                    delete r[a.index],
                    (a = a.next);
                (t.first = t.last = void 0), m ? (t.size = 0) : (this.size = 0);
              },
              delete: function (t) {
                var r = this,
                  a = b(r),
                  i = getEntry(r, t);
                if (i) {
                  var o = i.next,
                    l = i.previous;
                  delete a.index[i.index],
                    (i.removed = !0),
                    l && (l.next = o),
                    o && (o.previous = l),
                    a.first == i && (a.first = o),
                    a.last == i && (a.last = l),
                    m ? a.size-- : r.size--;
                }
                return !!i;
              },
              forEach: function forEach(t) {
                for (
                  var r,
                    a = b(this),
                    i = c(t, arguments.length > 1 ? arguments[1] : void 0, 3);
                  (r = r ? r.next : a.first);

                )
                  for (i(r.value, r.key, this); r && r.removed; )
                    r = r.previous;
              },
              has: function has(t) {
                return !!getEntry(this, t);
              },
            }),
            l(
              p.prototype,
              a
                ? {
                    get: function get(t) {
                      var r = getEntry(this, t);
                      return r && r.value;
                    },
                    set: function set(t, r) {
                      return define(this, 0 === t ? 0 : t, r);
                    },
                  }
                : {
                    add: function add(t) {
                      return define(this, (t = 0 === t ? 0 : t), t);
                    },
                  },
            ),
            m &&
              i(p.prototype, "size", {
                get: function () {
                  return b(this).size;
                },
              }),
            p
          );
        },
        setStrong: function (t, r, a) {
          var i = r + " Iterator",
            o = v(r),
            l = v(i);
          d(
            t,
            r,
            function (t, r) {
              y(this, {
                type: i,
                target: t,
                state: o(t),
                kind: r,
                last: void 0,
              });
            },
            function () {
              for (var t = l(this), r = t.kind, a = t.last; a && a.removed; )
                a = a.previous;
              return t.target && (t.last = a = a ? a.next : t.state.first)
                ? "keys" == r
                  ? { value: a.key, done: !1 }
                  : "values" == r
                  ? { value: a.value, done: !1 }
                  : { value: [a.key, a.value], done: !1 }
                : ((t.target = void 0), { value: void 0, done: !0 });
            },
            a ? "entries" : "values",
            !a,
            !0,
          ),
            p(r);
        },
      };
    },
    function (t, r, a) {
      a(152), a(114), a(77), a(116);
      var i = a(43);
      t.exports = i.Set;
    },
    function (t, r, a) {
      "use strict";
      var i = a(146),
        o = a(150);
      t.exports = i(
        "Set",
        function (t) {
          return function Set() {
            return t(this, arguments.length ? arguments[0] : void 0);
          };
        },
        o,
      );
    },
    function (t, r, a) {
      a(114), a(154), a(116);
      var i = a(43);
      t.exports = i.WeakMap;
    },
    function (t, r, a) {
      "use strict";
      var i,
        o = a(11),
        l = a(121),
        c = a(147),
        u = a(146),
        h = a(155),
        d = a(22),
        p = a(33).enforce,
        m = a(34),
        g = !o.ActiveXObject && "ActiveXObject" in o,
        b = Object.isExtensible,
        wrapper = function (t) {
          return function WeakMap() {
            return t(this, arguments.length ? arguments[0] : void 0);
          };
        },
        y = (t.exports = u("WeakMap", wrapper, h));
      if (m && g) {
        (i = h.getConstructor(wrapper, "WeakMap", !0)), (c.REQUIRED = !0);
        var v = y.prototype,
          S = v.delete,
          k = v.has,
          w = v.get,
          C = v.set;
        l(v, {
          delete: function (t) {
            if (d(t) && !b(t)) {
              var r = p(this);
              return (
                r.frozen || (r.frozen = new i()),
                S.call(this, t) || r.frozen.delete(t)
              );
            }
            return S.call(this, t);
          },
          has: function has(t) {
            if (d(t) && !b(t)) {
              var r = p(this);
              return (
                r.frozen || (r.frozen = new i()),
                k.call(this, t) || r.frozen.has(t)
              );
            }
            return k.call(this, t);
          },
          get: function get(t) {
            if (d(t) && !b(t)) {
              var r = p(this);
              return (
                r.frozen || (r.frozen = new i()),
                k.call(this, t) ? w.call(this, t) : r.frozen.get(t)
              );
            }
            return w.call(this, t);
          },
          set: function set(t, r) {
            if (d(t) && !b(t)) {
              var a = p(this);
              a.frozen || (a.frozen = new i()),
                k.call(this, t) ? C.call(this, t, r) : a.frozen.set(t, r);
            } else C.call(this, t, r);
            return this;
          },
        });
      }
    },
    function (t, r, a) {
      "use strict";
      var i = a(121),
        o = a(147).getWeakData,
        l = a(28),
        c = a(22),
        u = a(123),
        h = a(124),
        d = a(156),
        p = a(23),
        m = a(33),
        g = m.set,
        b = m.getterFor,
        y = d.find,
        v = d.findIndex,
        S = 0,
        uncaughtFrozenStore = function (t) {
          return t.frozen || (t.frozen = new UncaughtFrozenStore());
        },
        UncaughtFrozenStore = function () {
          this.entries = [];
        },
        findUncaughtFrozen = function (t, r) {
          return y(t.entries, function (t) {
            return t[0] === r;
          });
        };
      (UncaughtFrozenStore.prototype = {
        get: function (t) {
          var r = findUncaughtFrozen(this, t);
          if (r) return r[1];
        },
        has: function (t) {
          return !!findUncaughtFrozen(this, t);
        },
        set: function (t, r) {
          var a = findUncaughtFrozen(this, t);
          a ? (a[1] = r) : this.entries.push([t, r]);
        },
        delete: function (t) {
          var r = v(this.entries, function (r) {
            return r[0] === t;
          });
          return ~r && this.entries.splice(r, 1), !!~r;
        },
      }),
        (t.exports = {
          getConstructor: function (t, r, a, d) {
            var m = t(function (t, i) {
                u(t, m, r),
                  g(t, { type: r, id: S++, frozen: void 0 }),
                  null != i && h(i, t[d], t, a);
              }),
              y = b(r),
              define = function (t, r, a) {
                var i = y(t),
                  c = o(l(r), !0);
                return (
                  !0 === c ? uncaughtFrozenStore(i).set(r, a) : (c[i.id] = a), t
                );
              };
            return (
              i(m.prototype, {
                delete: function (t) {
                  var r = y(this);
                  if (!c(t)) return !1;
                  var a = o(t);
                  return !0 === a
                    ? uncaughtFrozenStore(r).delete(t)
                    : a && p(a, r.id) && delete a[r.id];
                },
                has: function has(t) {
                  var r = y(this);
                  if (!c(t)) return !1;
                  var a = o(t);
                  return !0 === a
                    ? uncaughtFrozenStore(r).has(t)
                    : a && p(a, r.id);
                },
              }),
              i(
                m.prototype,
                a
                  ? {
                      get: function get(t) {
                        var r = y(this);
                        if (c(t)) {
                          var a = o(t);
                          return !0 === a
                            ? uncaughtFrozenStore(r).get(t)
                            : a
                            ? a[r.id]
                            : void 0;
                        }
                      },
                      set: function set(t, r) {
                        return define(this, t, r);
                      },
                    }
                  : {
                      add: function add(t) {
                        return define(this, t, !0);
                      },
                    },
              ),
              m
            );
          },
        });
    },
    function (t, r, a) {
      var i = a(62),
        o = a(18),
        l = a(83),
        c = a(47),
        u = a(157),
        h = [].push,
        createMethod = function (t) {
          var r = 1 == t,
            a = 2 == t,
            d = 3 == t,
            p = 4 == t,
            m = 6 == t,
            g = 5 == t || m;
          return function (b, y, v, S) {
            for (
              var k,
                w,
                C = l(b),
                x = o(C),
                _ = i(y, v, 3),
                A = c(x.length),
                R = 0,
                T = S || u,
                I = r ? T(b, A) : a ? T(b, 0) : void 0;
              A > R;
              R++
            )
              if ((g || R in x) && ((w = _((k = x[R]), R, C)), t))
                if (r) I[R] = w;
                else if (w)
                  switch (t) {
                    case 3:
                      return !0;
                    case 5:
                      return k;
                    case 6:
                      return R;
                    case 2:
                      h.call(I, k);
                  }
                else if (p) return !1;
            return m ? -1 : d || p ? p : I;
          };
        };
      t.exports = {
        forEach: createMethod(0),
        map: createMethod(1),
        filter: createMethod(2),
        some: createMethod(3),
        every: createMethod(4),
        find: createMethod(5),
        findIndex: createMethod(6),
      };
    },
    function (t, r, a) {
      var i = a(22),
        o = a(158),
        l = a(57)("species");
      t.exports = function (t, r) {
        var a;
        return (
          o(t) &&
            ("function" != typeof (a = t.constructor) ||
            (a !== Array && !o(a.prototype))
              ? i(a) && null === (a = a[l]) && (a = void 0)
              : (a = void 0)),
          new (void 0 === a ? Array : a)(0 === r ? 0 : r)
        );
      };
    },
    function (t, r, a) {
      var i = a(19);
      t.exports =
        Array.isArray ||
        function isArray(t) {
          return "Array" == i(t);
        };
    },
    function (t, r, a) {
      a(114), a(160), a(116);
      var i = a(43);
      t.exports = i.WeakSet;
    },
    function (t, r, a) {
      "use strict";
      a(146)(
        "WeakSet",
        function (t) {
          return function WeakSet() {
            return t(this, arguments.length ? arguments[0] : void 0);
          };
        },
        a(155),
      );
    },
    function (t, r, a) {
      a(162);
      var i = a(61);
      t.exports = i("String", "codePointAt");
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(78).codeAt;
      i(
        { target: "String", proto: !0 },
        {
          codePointAt: function codePointAt(t) {
            return o(this, t);
          },
        },
      );
    },
    function (t, r, a) {
      a(164);
      var i = a(43);
      t.exports = i.String.fromCodePoint;
    },
    function (t, r, a) {
      var i = a(10),
        o = a(49),
        l = String.fromCharCode,
        c = String.fromCodePoint;
      i(
        { target: "String", stat: !0, forced: !!c && 1 != c.length },
        {
          fromCodePoint: function fromCodePoint(t) {
            for (var r, a = [], i = arguments.length, c = 0; i > c; ) {
              if (((r = +arguments[c++]), o(r, 1114111) !== r))
                throw RangeError(r + " is not a valid code point");
              a.push(
                r < 65536
                  ? l(r)
                  : l(55296 + ((r -= 65536) >> 10), (r % 1024) + 56320),
              );
            }
            return a.join("");
          },
        },
      );
    },
    function (t, r, a) {
      a(166),
        a(114),
        a(168),
        a(172),
        a(173),
        a(174),
        a(175),
        a(176),
        a(177),
        a(178),
        a(179),
        a(180),
        a(181),
        a(182),
        a(183),
        a(184),
        a(185),
        a(186),
        a(187);
      var i = a(43);
      t.exports = i.Symbol;
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(14),
        l = a(158),
        c = a(22),
        u = a(83),
        h = a(47),
        d = a(93),
        p = a(157),
        m = a(167),
        g = a(57),
        b = a(133),
        y = g("isConcatSpreadable"),
        v = 9007199254740991,
        S = "Maximum allowed index exceeded",
        k =
          b >= 51 ||
          !o(function () {
            var t = [];
            return (t[y] = !1), t.concat()[0] !== t;
          }),
        w = m("concat"),
        isConcatSpreadable = function (t) {
          if (!c(t)) return !1;
          var r = t[y];
          return void 0 !== r ? !!r : l(t);
        };
      i(
        { target: "Array", proto: !0, forced: !k || !w },
        {
          concat: function concat(t) {
            var r,
              a,
              i,
              o,
              l,
              c = u(this),
              m = p(c, 0),
              g = 0;
            for (r = -1, i = arguments.length; r < i; r++)
              if (isConcatSpreadable((l = -1 === r ? c : arguments[r]))) {
                if (g + (o = h(l.length)) > v) throw TypeError(S);
                for (a = 0; a < o; a++, g++) a in l && d(m, g, l[a]);
              } else {
                if (g >= v) throw TypeError(S);
                d(m, g++, l);
              }
            return (m.length = g), m;
          },
        },
      );
    },
    function (t, r, a) {
      var i = a(14),
        o = a(57),
        l = a(133),
        c = o("species");
      t.exports = function (t) {
        return (
          l >= 51 ||
          !i(function () {
            var r = [];
            return (
              ((r.constructor = {})[c] = function () {
                return { foo: 1 };
              }),
              1 !== r[t](Boolean).foo
            );
          })
        );
      };
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(11),
        l = a(42),
        c = a(37),
        u = a(13),
        h = a(58),
        d = a(59),
        p = a(14),
        m = a(23),
        g = a(158),
        b = a(22),
        y = a(28),
        v = a(83),
        S = a(17),
        k = a(21),
        w = a(16),
        C = a(71),
        x = a(73),
        _ = a(44),
        A = a(169),
        R = a(51),
        T = a(12),
        I = a(27),
        P = a(15),
        O = a(26),
        E = a(29),
        B = a(36),
        D = a(35),
        M = a(39),
        L = a(38),
        N = a(57),
        U = a(170),
        j = a(171),
        q = a(85),
        W = a(33),
        z = a(156).forEach,
        G = D("hidden"),
        H = "Symbol",
        X = N("toPrimitive"),
        V = W.set,
        Y = W.getterFor(H),
        K = Object.prototype,
        J = o.Symbol,
        Z = l("JSON", "stringify"),
        Q = T.f,
        $ = I.f,
        ee = A.f,
        te = P.f,
        re = B("symbols"),
        ae = B("op-symbols"),
        ne = B("string-to-symbol-registry"),
        ie = B("symbol-to-string-registry"),
        oe = B("wks"),
        se = o.QObject,
        le = !se || !se.prototype || !se.prototype.findChild,
        ce =
          u &&
          p(function () {
            return (
              7 !=
              C(
                $({}, "a", {
                  get: function () {
                    return $(this, "a", { value: 7 }).a;
                  },
                }),
              ).a
            );
          })
            ? function (t, r, a) {
                var i = Q(K, r);
                i && delete K[r], $(t, r, a), i && t !== K && $(K, r, i);
              }
            : $,
        wrap = function (t, r) {
          var a = (re[t] = C(J.prototype));
          return (
            V(a, { type: H, tag: t, description: r }),
            u || (a.description = r),
            a
          );
        },
        ue = d
          ? function (t) {
              return "symbol" == typeof t;
            }
          : function (t) {
              return Object(t) instanceof J;
            },
        he = function defineProperty(t, r, a) {
          t === K && he(ae, r, a), y(t);
          var i = k(r, !0);
          return (
            y(a),
            m(re, i)
              ? (a.enumerable
                  ? (m(t, G) && t[G][i] && (t[G][i] = !1),
                    (a = C(a, { enumerable: w(0, !1) })))
                  : (m(t, G) || $(t, G, w(1, {})), (t[G][i] = !0)),
                ce(t, i, a))
              : $(t, i, a)
          );
        },
        fe = function defineProperties(t, r) {
          y(t);
          var a = S(r),
            i = x(a).concat(ge(a));
          return (
            z(i, function (r) {
              (u && !de.call(a, r)) || he(t, r, a[r]);
            }),
            t
          );
        },
        de = function propertyIsEnumerable(t) {
          var r = k(t, !0),
            a = te.call(this, r);
          return (
            !(this === K && m(re, r) && !m(ae, r)) &&
            (!(a || !m(this, r) || !m(re, r) || (m(this, G) && this[G][r])) ||
              a)
          );
        },
        pe = function getOwnPropertyDescriptor(t, r) {
          var a = S(t),
            i = k(r, !0);
          if (a !== K || !m(re, i) || m(ae, i)) {
            var o = Q(a, i);
            return (
              !o || !m(re, i) || (m(a, G) && a[G][i]) || (o.enumerable = !0), o
            );
          }
        },
        me = function getOwnPropertyNames(t) {
          var r = ee(S(t)),
            a = [];
          return (
            z(r, function (t) {
              m(re, t) || m(M, t) || a.push(t);
            }),
            a
          );
        },
        ge = function getOwnPropertySymbols(t) {
          var r = t === K,
            a = ee(r ? ae : S(t)),
            i = [];
          return (
            z(a, function (t) {
              !m(re, t) || (r && !m(K, t)) || i.push(re[t]);
            }),
            i
          );
        };
      (h ||
        (E(
          (J = function Symbol() {
            if (this instanceof J)
              throw TypeError("Symbol is not a constructor");
            var t =
                arguments.length && void 0 !== arguments[0]
                  ? String(arguments[0])
                  : void 0,
              r = L(t),
              setter = function (t) {
                this === K && setter.call(ae, t),
                  m(this, G) && m(this[G], r) && (this[G][r] = !1),
                  ce(this, r, w(1, t));
              };
            return (
              u && le && ce(K, r, { configurable: !0, set: setter }), wrap(r, t)
            );
          }).prototype,
          "toString",
          function toString() {
            return Y(this).tag;
          },
        ),
        E(J, "withoutSetter", function (t) {
          return wrap(L(t), t);
        }),
        (P.f = de),
        (I.f = he),
        (T.f = pe),
        (_.f = A.f = me),
        (R.f = ge),
        (U.f = function (t) {
          return wrap(N(t), t);
        }),
        u &&
          ($(J.prototype, "description", {
            configurable: !0,
            get: function description() {
              return Y(this).description;
            },
          }),
          c || E(K, "propertyIsEnumerable", de, { unsafe: !0 }))),
      i({ global: !0, wrap: !0, forced: !h, sham: !h }, { Symbol: J }),
      z(x(oe), function (t) {
        j(t);
      }),
      i(
        { target: H, stat: !0, forced: !h },
        {
          for: function (t) {
            var r = String(t);
            if (m(ne, r)) return ne[r];
            var a = J(r);
            return (ne[r] = a), (ie[a] = r), a;
          },
          keyFor: function keyFor(t) {
            if (!ue(t)) throw TypeError(t + " is not a symbol");
            if (m(ie, t)) return ie[t];
          },
          useSetter: function () {
            le = !0;
          },
          useSimple: function () {
            le = !1;
          },
        },
      ),
      i(
        { target: "Object", stat: !0, forced: !h, sham: !u },
        {
          create: function create(t, r) {
            return void 0 === r ? C(t) : fe(C(t), r);
          },
          defineProperty: he,
          defineProperties: fe,
          getOwnPropertyDescriptor: pe,
        },
      ),
      i(
        { target: "Object", stat: !0, forced: !h },
        { getOwnPropertyNames: me, getOwnPropertySymbols: ge },
      ),
      i(
        {
          target: "Object",
          stat: !0,
          forced: p(function () {
            R.f(1);
          }),
        },
        {
          getOwnPropertySymbols: function getOwnPropertySymbols(t) {
            return R.f(v(t));
          },
        },
      ),
      Z) &&
        i(
          {
            target: "JSON",
            stat: !0,
            forced:
              !h ||
              p(function () {
                var t = J();
                return (
                  "[null]" != Z([t]) ||
                  "{}" != Z({ a: t }) ||
                  "{}" != Z(Object(t))
                );
              }),
          },
          {
            stringify: function stringify(t, r, a) {
              for (var i, o = [t], l = 1; arguments.length > l; )
                o.push(arguments[l++]);
              if (((i = r), (b(r) || void 0 !== t) && !ue(t)))
                return (
                  g(r) ||
                    (r = function (t, r) {
                      if (
                        ("function" == typeof i && (r = i.call(this, t, r)),
                        !ue(r))
                      )
                        return r;
                    }),
                  (o[1] = r),
                  Z.apply(null, o)
                );
            },
          },
        );
      J.prototype[X] || O(J.prototype, X, J.prototype.valueOf),
        q(J, H),
        (M[G] = !0);
    },
    function (t, r, a) {
      var i = a(17),
        o = a(44).f,
        l = {}.toString,
        c =
          "object" == typeof window && window && Object.getOwnPropertyNames
            ? Object.getOwnPropertyNames(window)
            : [];
      t.exports.f = function getOwnPropertyNames(t) {
        return c && "[object Window]" == l.call(t)
          ? (function (t) {
              try {
                return o(t);
              } catch (t) {
                return c.slice();
              }
            })(t)
          : o(i(t));
      };
    },
    function (t, r, a) {
      var i = a(57);
      r.f = i;
    },
    function (t, r, a) {
      var i = a(43),
        o = a(23),
        l = a(170),
        c = a(27).f;
      t.exports = function (t) {
        var r = i.Symbol || (i.Symbol = {});
        o(r, t) || c(r, t, { value: l.f(t) });
      };
    },
    function (t, r, a) {
      a(171)("asyncIterator");
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(13),
        l = a(11),
        c = a(23),
        u = a(22),
        h = a(27).f,
        d = a(40),
        p = l.Symbol;
      if (
        o &&
        "function" == typeof p &&
        (!("description" in p.prototype) || void 0 !== p().description)
      ) {
        var m = {},
          g = function Symbol() {
            var t =
                arguments.length < 1 || void 0 === arguments[0]
                  ? void 0
                  : String(arguments[0]),
              r = this instanceof g ? new p(t) : void 0 === t ? p() : p(t);
            return "" === t && (m[r] = !0), r;
          };
        d(g, p);
        var b = (g.prototype = p.prototype);
        b.constructor = g;
        var y = b.toString,
          v = "Symbol(test)" == String(p("test")),
          S = /^Symbol\((.*)\)[^)]+$/;
        h(b, "description", {
          configurable: !0,
          get: function description() {
            var t = u(this) ? this.valueOf() : this,
              r = y.call(t);
            if (c(m, t)) return "";
            var a = v ? r.slice(7, -1) : r.replace(S, "$1");
            return "" === a ? void 0 : a;
          },
        }),
          i({ global: !0, forced: !0 }, { Symbol: g });
      }
    },
    function (t, r, a) {
      a(171)("hasInstance");
    },
    function (t, r, a) {
      a(171)("isConcatSpreadable");
    },
    function (t, r, a) {
      a(171)("iterator");
    },
    function (t, r, a) {
      a(171)("match");
    },
    function (t, r, a) {
      a(171)("matchAll");
    },
    function (t, r, a) {
      a(171)("replace");
    },
    function (t, r, a) {
      a(171)("search");
    },
    function (t, r, a) {
      a(171)("species");
    },
    function (t, r, a) {
      a(171)("split");
    },
    function (t, r, a) {
      a(171)("toPrimitive");
    },
    function (t, r, a) {
      a(171)("toStringTag");
    },
    function (t, r, a) {
      a(171)("unscopables");
    },
    function (t, r, a) {
      a(85)(Math, "Math", !0);
    },
    function (t, r, a) {
      var i = a(11);
      a(85)(i.JSON, "JSON", !0);
    },
    function (t, r, a) {
      a(189);
      var i = a(61);
      t.exports = i("String", "padStart");
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(190).start;
      i(
        { target: "String", proto: !0, forced: a(192) },
        {
          padStart: function padStart(t) {
            return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
          },
        },
      );
    },
    function (t, r, a) {
      var i = a(47),
        o = a(191),
        l = a(20),
        c = Math.ceil,
        createMethod = function (t) {
          return function (r, a, u) {
            var h,
              d,
              p = String(l(r)),
              m = p.length,
              g = void 0 === u ? " " : String(u),
              b = i(a);
            return b <= m || "" == g
              ? p
              : ((h = b - m),
                (d = o.call(g, c(h / g.length))).length > h &&
                  (d = d.slice(0, h)),
                t ? p + d : d + p);
          };
        };
      t.exports = { start: createMethod(!1), end: createMethod(!0) };
    },
    function (t, r, a) {
      "use strict";
      var i = a(48),
        o = a(20);
      t.exports =
        "".repeat ||
        function repeat(t) {
          var r = String(o(this)),
            a = "",
            l = i(t);
          if (l < 0 || l == 1 / 0)
            throw RangeError("Wrong number of repetitions");
          for (; l > 0; (l >>>= 1) && (r += r)) 1 & l && (a += r);
          return a;
        };
    },
    function (t, r, a) {
      var i = a(127);
      t.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(i);
    },
    function (t, r, a) {
      a(194);
      var i = a(61);
      t.exports = i("String", "padEnd");
    },
    function (t, r, a) {
      "use strict";
      var i = a(10),
        o = a(190).end;
      i(
        { target: "String", proto: !0, forced: a(192) },
        {
          padEnd: function padEnd(t) {
            return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
          },
        },
      );
    },
    function (t, r, a) {
      a(196);
      var i = a(43);
      t.exports = i.Object.values;
    },
    function (t, r, a) {
      var i = a(10),
        o = a(197).values;
      i(
        { target: "Object", stat: !0 },
        {
          values: function values(t) {
            return o(t);
          },
        },
      );
    },
    function (t, r, a) {
      var i = a(13),
        o = a(73),
        l = a(17),
        c = a(15).f,
        createMethod = function (t) {
          return function (r) {
            for (
              var a, u = l(r), h = o(u), d = h.length, p = 0, m = [];
              d > p;

            )
              (a = h[p++]),
                (i && !c.call(u, a)) || m.push(t ? [a, u[a]] : u[a]);
            return m;
          };
        };
      t.exports = { entries: createMethod(!0), values: createMethod(!1) };
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.clearPrimitiveCaches = function clearPrimitiveCaches() {
          c._clearCache(), l._clearCache(), h._clearCache();
        }),
        (r.isEOF = function isEOF(t) {
          return t === o;
        }),
        (r.isCmd = function isCmd(t, r) {
          return t instanceof c && (void 0 === r || t.cmd === r);
        }),
        (r.isDict = isDict),
        (r.isName = isName),
        (r.isRef = function isRef(t) {
          return t instanceof h;
        }),
        (r.isRefsEqual = function isRefsEqual(t, r) {
          return t.num === r.num && t.gen === r.gen;
        }),
        (r.isStream = function isStream(t) {
          return "object" === _typeof(t) && null !== t && void 0 !== t.getBytes;
        }),
        (r.RefSetCache =
          r.RefSet =
          r.Ref =
          r.Name =
          r.Dict =
          r.Cmd =
          r.EOF =
            void 0);
      var i = (function _interopRequireDefault(t) {
        return t && t.__esModule ? t : { default: t };
      })(a(2));
      a(5);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function asyncGeneratorStep(t, r, a, i, o, l, c) {
        try {
          var u = t[l](c),
            h = u.value;
        } catch (t) {
          return void a(t);
        }
        u.done ? r(h) : Promise.resolve(h).then(i, o);
      }
      var o = {};
      r.EOF = o;
      var l = (function NameClosure() {
        var t = Object.create(null);
        function Name(t) {
          this.name = t;
        }
        return (
          (Name.prototype = {}),
          (Name.get = function Name_get(r) {
            var a = t[r];
            return a || (t[r] = new Name(r));
          }),
          (Name._clearCache = function () {
            t = Object.create(null);
          }),
          Name
        );
      })();
      r.Name = l;
      var c = (function CmdClosure() {
        var t = Object.create(null);
        function Cmd(t) {
          this.cmd = t;
        }
        return (
          (Cmd.prototype = {}),
          (Cmd.get = function Cmd_get(r) {
            var a = t[r];
            return a || (t[r] = new Cmd(r));
          }),
          (Cmd._clearCache = function () {
            t = Object.create(null);
          }),
          Cmd
        );
      })();
      r.Cmd = c;
      var u = (function DictClosure() {
        var t = function nonSerializableClosure() {
          return t;
        };
        function Dict(r) {
          (this._map = Object.create(null)),
            (this.xref = r),
            (this.objId = null),
            (this.suppressEncryption = !1),
            (this.__nonSerializable__ = t);
        }
        return (
          (Dict.prototype = {
            assignXref: function Dict_assignXref(t) {
              this.xref = t;
            },
            get: function get(t, r, a) {
              var i = this._map[t];
              return (
                void 0 === i &&
                  void 0 !== r &&
                  void 0 === (i = this._map[r]) &&
                  void 0 !== a &&
                  (i = this._map[a]),
                i instanceof h && this.xref
                  ? this.xref.fetch(i, this.suppressEncryption)
                  : i
              );
            },
            getAsync: function getAsync(t, r, a) {
              var o = this;
              return (function _asyncToGenerator(t) {
                return function () {
                  var r = this,
                    a = arguments;
                  return new Promise(function (i, o) {
                    var l = t.apply(r, a);
                    function _next(t) {
                      asyncGeneratorStep(l, i, o, _next, _throw, "next", t);
                    }
                    function _throw(t) {
                      asyncGeneratorStep(l, i, o, _next, _throw, "throw", t);
                    }
                    _next(void 0);
                  });
                };
              })(
                i.default.mark(function _callee() {
                  var l;
                  return i.default.wrap(function _callee$(i) {
                    for (;;)
                      switch ((i.prev = i.next)) {
                        case 0:
                          if (
                            (void 0 === (l = o._map[t]) &&
                              void 0 !== r &&
                              void 0 === (l = o._map[r]) &&
                              void 0 !== a &&
                              (l = o._map[a]),
                            !(l instanceof h && o.xref))
                          ) {
                            i.next = 4;
                            break;
                          }
                          return i.abrupt(
                            "return",
                            o.xref.fetchAsync(l, o.suppressEncryption),
                          );
                        case 4:
                          return i.abrupt("return", l);
                        case 5:
                        case "end":
                          return i.stop();
                      }
                  }, _callee);
                }),
              )();
            },
            getArray: function getArray(t, r, a) {
              var i = this.get(t, r, a);
              if (!Array.isArray(i) || !this.xref) return i;
              for (var o = 0, l = (i = i.slice()).length; o < l; o++)
                i[o] instanceof h &&
                  (i[o] = this.xref.fetch(i[o], this.suppressEncryption));
              return i;
            },
            getRaw: function Dict_getRaw(t) {
              return this._map[t];
            },
            getKeys: function Dict_getKeys() {
              return Object.keys(this._map);
            },
            set: function Dict_set(t, r) {
              this._map[t] = r;
            },
            has: function Dict_has(t) {
              return void 0 !== this._map[t];
            },
            forEach: function Dict_forEach(t) {
              for (var r in this._map) t(r, this.get(r));
            },
          }),
          (Dict.empty = new Dict(null)),
          (Dict.merge = function (t, r) {
            for (var a = new Dict(t), i = 0, o = r.length; i < o; i++) {
              var l = r[i];
              if (isDict(l))
                for (var c in l._map)
                  void 0 === a._map[c] && (a._map[c] = l._map[c]);
            }
            return a;
          }),
          Dict
        );
      })();
      r.Dict = u;
      var h = (function RefClosure() {
        var t = Object.create(null);
        function Ref(t, r) {
          (this.num = t), (this.gen = r);
        }
        return (
          (Ref.prototype = {
            toString: function Ref_toString() {
              return 0 === this.gen
                ? "".concat(this.num, "R")
                : "".concat(this.num, "R").concat(this.gen);
            },
          }),
          (Ref.get = function (r, a) {
            var i = 0 === a ? "".concat(r, "R") : "".concat(r, "R").concat(a),
              o = t[i];
            return o || (t[i] = new Ref(r, a));
          }),
          (Ref._clearCache = function () {
            t = Object.create(null);
          }),
          Ref
        );
      })();
      r.Ref = h;
      var d = (function RefSetClosure() {
        function RefSet() {
          this.dict = Object.create(null);
        }
        return (
          (RefSet.prototype = {
            has: function RefSet_has(t) {
              return t.toString() in this.dict;
            },
            put: function RefSet_put(t) {
              this.dict[t.toString()] = !0;
            },
            remove: function RefSet_remove(t) {
              delete this.dict[t.toString()];
            },
          }),
          RefSet
        );
      })();
      r.RefSet = d;
      var p = (function RefSetCacheClosure() {
        function RefSetCache() {
          this.dict = Object.create(null);
        }
        return (
          (RefSetCache.prototype = {
            get size() {
              return Object.keys(this.dict).length;
            },
            get: function RefSetCache_get(t) {
              return this.dict[t.toString()];
            },
            has: function RefSetCache_has(t) {
              return t.toString() in this.dict;
            },
            put: function RefSetCache_put(t, r) {
              this.dict[t.toString()] = r;
            },
            putAlias: function RefSetCache_putAlias(t, r) {
              this.dict[t.toString()] = this.get(r);
            },
            forEach: function RefSetCache_forEach(t) {
              for (var r in this.dict) t(this.dict[r]);
            },
            clear: function RefSetCache_clear() {
              this.dict = Object.create(null);
            },
          }),
          RefSetCache
        );
      })();
      function isName(t, r) {
        return t instanceof l && (void 0 === r || t.name === r);
      }
      function isDict(t, r) {
        return t instanceof u && (void 0 === r || isName(t.get("Type"), r));
      }
      r.RefSetCache = p;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.NetworkPdfManager = r.LocalPdfManager = void 0);
      var i = (function _interopRequireDefault(t) {
          return t && t.__esModule ? t : { default: t };
        })(a(2)),
        o = a(5),
        l = a(200),
        c = a(201),
        u = a(202),
        h = a(205);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _inherits(t, r) {
        if ("function" != typeof r && null !== r)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (t.prototype = Object.create(r && r.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          r && _setPrototypeOf(t, r);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? _assertThisInitialized(t)
          : r;
      }
      function _assertThisInitialized(t) {
        if (void 0 === t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
          );
        return t;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function asyncGeneratorStep(t, r, a, i, o, l, c) {
        try {
          var u = t[l](c),
            h = u.value;
        } catch (t) {
          return void a(t);
        }
        u.done ? r(h) : Promise.resolve(h).then(i, o);
      }
      function _asyncToGenerator(t) {
        return function () {
          var r = this,
            a = arguments;
          return new Promise(function (i, o) {
            var l = t.apply(r, a);
            function _next(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "next", t);
            }
            function _throw(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "throw", t);
            }
            _next(void 0);
          });
        };
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var d = (function () {
          function BasePdfManager() {
            _classCallCheck(this, BasePdfManager),
              this.constructor === BasePdfManager &&
                (0, o.unreachable)("Cannot initialize BasePdfManager.");
          }
          var t;
          return (
            _createClass(BasePdfManager, [
              {
                key: "onLoadedStream",
                value: function onLoadedStream() {
                  (0, o.unreachable)("Abstract method `onLoadedStream` called");
                },
              },
              {
                key: "ensureDoc",
                value: function ensureDoc(t, r) {
                  return this.ensure(this.pdfDocument, t, r);
                },
              },
              {
                key: "ensureXRef",
                value: function ensureXRef(t, r) {
                  return this.ensure(this.pdfDocument.xref, t, r);
                },
              },
              {
                key: "ensureCatalog",
                value: function ensureCatalog(t, r) {
                  return this.ensure(this.pdfDocument.catalog, t, r);
                },
              },
              {
                key: "getPage",
                value: function getPage(t) {
                  return this.pdfDocument.getPage(t);
                },
              },
              {
                key: "fontFallback",
                value: function fontFallback(t, r) {
                  return this.pdfDocument.fontFallback(t, r);
                },
              },
              {
                key: "cleanup",
                value: function cleanup() {
                  var t =
                    arguments.length > 0 &&
                    void 0 !== arguments[0] &&
                    arguments[0];
                  return this.pdfDocument.cleanup(t);
                },
              },
              {
                key: "ensure",
                value:
                  ((t = _asyncToGenerator(
                    i.default.mark(function _callee(t, r, a) {
                      return i.default.wrap(function _callee$(t) {
                        for (;;)
                          switch ((t.prev = t.next)) {
                            case 0:
                              (0, o.unreachable)(
                                "Abstract method `ensure` called",
                              );
                            case 1:
                            case "end":
                              return t.stop();
                          }
                      }, _callee);
                    }),
                  )),
                  function ensure(r, a, i) {
                    return t.apply(this, arguments);
                  }),
              },
              {
                key: "requestRange",
                value: function requestRange(t, r) {
                  (0, o.unreachable)("Abstract method `requestRange` called");
                },
              },
              {
                key: "requestLoadedStream",
                value: function requestLoadedStream() {
                  (0, o.unreachable)(
                    "Abstract method `requestLoadedStream` called",
                  );
                },
              },
              {
                key: "sendProgressiveData",
                value: function sendProgressiveData(t) {
                  (0, o.unreachable)(
                    "Abstract method `sendProgressiveData` called",
                  );
                },
              },
              {
                key: "updatePassword",
                value: function updatePassword(t) {
                  this._password = t;
                },
              },
              {
                key: "terminate",
                value: function terminate(t) {
                  (0, o.unreachable)("Abstract method `terminate` called");
                },
              },
              {
                key: "docId",
                get: function get() {
                  return this._docId;
                },
              },
              {
                key: "password",
                get: function get() {
                  return this._password;
                },
              },
              {
                key: "docBaseUrl",
                get: function get() {
                  var t = null;
                  if (this._docBaseUrl) {
                    var r = (0, o.createValidAbsoluteUrl)(this._docBaseUrl);
                    r
                      ? (t = r.href)
                      : (0, o.warn)(
                          'Invalid absolute docBaseUrl: "'.concat(
                            this._docBaseUrl,
                            '".',
                          ),
                        );
                  }
                  return (0, o.shadow)(this, "docBaseUrl", t);
                },
              },
            ]),
            BasePdfManager
          );
        })(),
        p = (function (t) {
          _inherits(LocalPdfManager, t);
          var r,
            a = _createSuper(LocalPdfManager);
          function LocalPdfManager(t, r, i, o, l) {
            var c;
            _classCallCheck(this, LocalPdfManager),
              ((c = a.call(this))._docId = t),
              (c._password = i),
              (c._docBaseUrl = l),
              (c.evaluatorOptions = o);
            var d = new h.Stream(r);
            return (
              (c.pdfDocument = new u.PDFDocument(_assertThisInitialized(c), d)),
              (c._loadedStreamPromise = Promise.resolve(d)),
              c
            );
          }
          return (
            _createClass(LocalPdfManager, [
              {
                key: "ensure",
                value:
                  ((r = _asyncToGenerator(
                    i.default.mark(function _callee2(t, r, a) {
                      var o;
                      return i.default.wrap(function _callee2$(i) {
                        for (;;)
                          switch ((i.prev = i.next)) {
                            case 0:
                              if ("function" != typeof (o = t[r])) {
                                i.next = 3;
                                break;
                              }
                              return i.abrupt("return", o.apply(t, a));
                            case 3:
                              return i.abrupt("return", o);
                            case 4:
                            case "end":
                              return i.stop();
                          }
                      }, _callee2);
                    }),
                  )),
                  function ensure(t, a, i) {
                    return r.apply(this, arguments);
                  }),
              },
              {
                key: "requestRange",
                value: function requestRange(t, r) {
                  return Promise.resolve();
                },
              },
              {
                key: "requestLoadedStream",
                value: function requestLoadedStream() {},
              },
              {
                key: "onLoadedStream",
                value: function onLoadedStream() {
                  return this._loadedStreamPromise;
                },
              },
              { key: "terminate", value: function terminate(t) {} },
            ]),
            LocalPdfManager
          );
        })(d);
      r.LocalPdfManager = p;
      var m = (function (t) {
        _inherits(NetworkPdfManager, t);
        var r,
          a = _createSuper(NetworkPdfManager);
        function NetworkPdfManager(t, r, i, o, c) {
          var h;
          return (
            _classCallCheck(this, NetworkPdfManager),
            ((h = a.call(this))._docId = t),
            (h._password = i.password),
            (h._docBaseUrl = c),
            (h.msgHandler = i.msgHandler),
            (h.evaluatorOptions = o),
            (h.streamManager = new l.ChunkedStreamManager(r, {
              msgHandler: i.msgHandler,
              length: i.length,
              disableAutoFetch: i.disableAutoFetch,
              rangeChunkSize: i.rangeChunkSize,
            })),
            (h.pdfDocument = new u.PDFDocument(
              _assertThisInitialized(h),
              h.streamManager.getStream(),
            )),
            h
          );
        }
        return (
          _createClass(NetworkPdfManager, [
            {
              key: "ensure",
              value:
                ((r = _asyncToGenerator(
                  i.default.mark(function _callee3(t, r, a) {
                    var o;
                    return i.default.wrap(
                      function _callee3$(i) {
                        for (;;)
                          switch ((i.prev = i.next)) {
                            case 0:
                              if (
                                ((i.prev = 0), "function" != typeof (o = t[r]))
                              ) {
                                i.next = 4;
                                break;
                              }
                              return i.abrupt("return", o.apply(t, a));
                            case 4:
                              return i.abrupt("return", o);
                            case 7:
                              if (
                                ((i.prev = 7),
                                (i.t0 = i.catch(0)),
                                i.t0 instanceof c.MissingDataException)
                              ) {
                                i.next = 11;
                                break;
                              }
                              throw i.t0;
                            case 11:
                              return (
                                (i.next = 13),
                                this.requestRange(i.t0.begin, i.t0.end)
                              );
                            case 13:
                              return i.abrupt("return", this.ensure(t, r, a));
                            case 14:
                            case "end":
                              return i.stop();
                          }
                      },
                      _callee3,
                      this,
                      [[0, 7]],
                    );
                  }),
                )),
                function ensure(t, a, i) {
                  return r.apply(this, arguments);
                }),
            },
            {
              key: "requestRange",
              value: function requestRange(t, r) {
                return this.streamManager.requestRange(t, r);
              },
            },
            {
              key: "requestLoadedStream",
              value: function requestLoadedStream() {
                this.streamManager.requestAllChunks();
              },
            },
            {
              key: "sendProgressiveData",
              value: function sendProgressiveData(t) {
                this.streamManager.onReceiveData({ chunk: t });
              },
            },
            {
              key: "onLoadedStream",
              value: function onLoadedStream() {
                return this.streamManager.onLoadedStream();
              },
            },
            {
              key: "terminate",
              value: function terminate(t) {
                this.streamManager.abort(t);
              },
            },
          ]),
          NetworkPdfManager
        );
      })(d);
      r.NetworkPdfManager = m;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.ChunkedStreamManager = r.ChunkedStream = void 0);
      var i = a(5),
        o = a(201);
      function _createForOfIteratorHelper(t, r) {
        var a;
        if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
          if (
            Array.isArray(t) ||
            (a = (function _unsupportedIterableToArray(t, r) {
              if (!t) return;
              if ("string" == typeof t) return _arrayLikeToArray(t, r);
              var a = Object.prototype.toString.call(t).slice(8, -1);
              "Object" === a && t.constructor && (a = t.constructor.name);
              if ("Map" === a || "Set" === a) return Array.from(t);
              if (
                "Arguments" === a ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
              )
                return _arrayLikeToArray(t, r);
            })(t)) ||
            (r && t && "number" == typeof t.length)
          ) {
            a && (t = a);
            var i = 0,
              o = function F() {};
            return {
              s: o,
              n: function n() {
                return i >= t.length
                  ? { done: !0 }
                  : { done: !1, value: t[i++] };
              },
              e: function e(t) {
                throw t;
              },
              f: o,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var l,
          c = !0,
          u = !1;
        return {
          s: function s() {
            a = t[Symbol.iterator]();
          },
          n: function n() {
            var t = a.next();
            return (c = t.done), t;
          },
          e: function e(t) {
            (u = !0), (l = t);
          },
          f: function f() {
            try {
              c || null == a.return || a.return();
            } finally {
              if (u) throw l;
            }
          },
        };
      }
      function _arrayLikeToArray(t, r) {
        (null == r || r > t.length) && (r = t.length);
        for (var a = 0, i = new Array(r); a < r; a++) i[a] = t[a];
        return i;
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var l = (function () {
        function ChunkedStream(t, r, a) {
          _classCallCheck(this, ChunkedStream),
            (this.bytes = new Uint8Array(t)),
            (this.start = 0),
            (this.pos = 0),
            (this.end = t),
            (this.chunkSize = r),
            (this.loadedChunks = []),
            (this.numChunksLoaded = 0),
            (this.numChunks = Math.ceil(t / r)),
            (this.manager = a),
            (this.progressiveDataLength = 0),
            (this.lastSuccessfulEnsureByteChunk = -1);
        }
        return (
          _createClass(ChunkedStream, [
            {
              key: "getMissingChunks",
              value: function getMissingChunks() {
                for (var t = [], r = 0, a = this.numChunks; r < a; ++r)
                  this.loadedChunks[r] || t.push(r);
                return t;
              },
            },
            {
              key: "getBaseStreams",
              value: function getBaseStreams() {
                return [this];
              },
            },
            {
              key: "allChunksLoaded",
              value: function allChunksLoaded() {
                return this.numChunksLoaded === this.numChunks;
              },
            },
            {
              key: "onReceiveData",
              value: function onReceiveData(t, r) {
                var a = this.chunkSize;
                if (t % a != 0) throw new Error("Bad begin offset: ".concat(t));
                var i = t + r.byteLength;
                if (i % a != 0 && i !== this.bytes.length)
                  throw new Error("Bad end offset: ".concat(i));
                this.bytes.set(new Uint8Array(r), t);
                for (
                  var o = Math.floor(t / a),
                    l = Math.floor((i - 1) / a) + 1,
                    c = o;
                  c < l;
                  ++c
                )
                  this.loadedChunks[c] ||
                    ((this.loadedChunks[c] = !0), ++this.numChunksLoaded);
              },
            },
            {
              key: "onReceiveProgressiveData",
              value: function onReceiveProgressiveData(t) {
                var r = this.progressiveDataLength,
                  a = Math.floor(r / this.chunkSize);
                this.bytes.set(new Uint8Array(t), r),
                  (r += t.byteLength),
                  (this.progressiveDataLength = r);
                for (
                  var i =
                      r >= this.end
                        ? this.numChunks
                        : Math.floor(r / this.chunkSize),
                    o = a;
                  o < i;
                  ++o
                )
                  this.loadedChunks[o] ||
                    ((this.loadedChunks[o] = !0), ++this.numChunksLoaded);
              },
            },
            {
              key: "ensureByte",
              value: function ensureByte(t) {
                if (!(t < this.progressiveDataLength)) {
                  var r = Math.floor(t / this.chunkSize);
                  if (r !== this.lastSuccessfulEnsureByteChunk) {
                    if (!this.loadedChunks[r])
                      throw new o.MissingDataException(t, t + 1);
                    this.lastSuccessfulEnsureByteChunk = r;
                  }
                }
              },
            },
            {
              key: "ensureRange",
              value: function ensureRange(t, r) {
                if (!(t >= r || r <= this.progressiveDataLength))
                  for (
                    var a = this.chunkSize,
                      i = Math.floor(t / a),
                      l = Math.floor((r - 1) / a) + 1,
                      c = i;
                    c < l;
                    ++c
                  )
                    if (!this.loadedChunks[c])
                      throw new o.MissingDataException(t, r);
              },
            },
            {
              key: "nextEmptyChunk",
              value: function nextEmptyChunk(t) {
                for (var r = this.numChunks, a = 0; a < r; ++a) {
                  var i = (t + a) % r;
                  if (!this.loadedChunks[i]) return i;
                }
                return null;
              },
            },
            {
              key: "hasChunk",
              value: function hasChunk(t) {
                return !!this.loadedChunks[t];
              },
            },
            {
              key: "getByte",
              value: function getByte() {
                var t = this.pos;
                return t >= this.end
                  ? -1
                  : (t >= this.progressiveDataLength && this.ensureByte(t),
                    this.bytes[this.pos++]);
              },
            },
            {
              key: "getUint16",
              value: function getUint16() {
                var t = this.getByte(),
                  r = this.getByte();
                return -1 === t || -1 === r ? -1 : (t << 8) + r;
              },
            },
            {
              key: "getInt32",
              value: function getInt32() {
                return (
                  (this.getByte() << 24) +
                  (this.getByte() << 16) +
                  (this.getByte() << 8) +
                  this.getByte()
                );
              },
            },
            {
              key: "getBytes",
              value: function getBytes(t) {
                var r =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1],
                  a = this.bytes,
                  i = this.pos,
                  o = this.end;
                if (!t) {
                  o > this.progressiveDataLength && this.ensureRange(i, o);
                  var l = a.subarray(i, o);
                  return r ? new Uint8ClampedArray(l) : l;
                }
                var c = i + t;
                c > o && (c = o),
                  c > this.progressiveDataLength && this.ensureRange(i, c),
                  (this.pos = c);
                var u = a.subarray(i, c);
                return r ? new Uint8ClampedArray(u) : u;
              },
            },
            {
              key: "peekByte",
              value: function peekByte() {
                var t = this.getByte();
                return -1 !== t && this.pos--, t;
              },
            },
            {
              key: "peekBytes",
              value: function peekBytes(t) {
                var r =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1],
                  a = this.getBytes(t, r);
                return (this.pos -= a.length), a;
              },
            },
            {
              key: "getByteRange",
              value: function getByteRange(t, r) {
                return (
                  t < 0 && (t = 0),
                  r > this.end && (r = this.end),
                  r > this.progressiveDataLength && this.ensureRange(t, r),
                  this.bytes.subarray(t, r)
                );
              },
            },
            {
              key: "skip",
              value: function skip(t) {
                t || (t = 1), (this.pos += t);
              },
            },
            {
              key: "reset",
              value: function reset() {
                this.pos = this.start;
              },
            },
            {
              key: "moveStart",
              value: function moveStart() {
                this.start = this.pos;
              },
            },
            {
              key: "makeSubStream",
              value: function makeSubStream(t, r, a) {
                function ChunkedStreamSubstream() {}
                r
                  ? t + r > this.progressiveDataLength &&
                    this.ensureRange(t, t + r)
                  : t >= this.progressiveDataLength && this.ensureByte(t),
                  (ChunkedStreamSubstream.prototype = Object.create(this)),
                  (ChunkedStreamSubstream.prototype.getMissingChunks =
                    function () {
                      for (
                        var t = this.chunkSize,
                          r = Math.floor(this.start / t),
                          a = Math.floor((this.end - 1) / t) + 1,
                          i = [],
                          o = r;
                        o < a;
                        ++o
                      )
                        this.loadedChunks[o] || i.push(o);
                      return i;
                    }),
                  (ChunkedStreamSubstream.prototype.allChunksLoaded =
                    function () {
                      return (
                        this.numChunksLoaded === this.numChunks ||
                        0 === this.getMissingChunks().length
                      );
                    });
                var i = new ChunkedStreamSubstream();
                return (
                  (i.pos = i.start = t),
                  (i.end = t + r || this.end),
                  (i.dict = a),
                  i
                );
              },
            },
            {
              key: "length",
              get: function get() {
                return this.end - this.start;
              },
            },
            {
              key: "isEmpty",
              get: function get() {
                return 0 === this.length;
              },
            },
          ]),
          ChunkedStream
        );
      })();
      r.ChunkedStream = l;
      var c = (function () {
        function ChunkedStreamManager(t, r) {
          _classCallCheck(this, ChunkedStreamManager),
            (this.length = r.length),
            (this.chunkSize = r.rangeChunkSize),
            (this.stream = new l(this.length, this.chunkSize, this)),
            (this.pdfNetworkStream = t),
            (this.disableAutoFetch = r.disableAutoFetch),
            (this.msgHandler = r.msgHandler),
            (this.currRequestId = 0),
            (this.chunksNeededByRequest = Object.create(null)),
            (this.requestsByChunk = Object.create(null)),
            (this.promisesByRequest = Object.create(null)),
            (this.progressiveDataLength = 0),
            (this.aborted = !1),
            (this._loadedStreamCapability = (0, i.createPromiseCapability)());
        }
        return (
          _createClass(ChunkedStreamManager, [
            {
              key: "onLoadedStream",
              value: function onLoadedStream() {
                return this._loadedStreamCapability.promise;
              },
            },
            {
              key: "sendRequest",
              value: function sendRequest(t, r) {
                var a = this,
                  o = this.pdfNetworkStream.getRangeReader(t, r);
                o.isStreamingSupported ||
                  (o.onProgress = this.onProgress.bind(this));
                var l = [],
                  c = 0;
                new Promise(function (t, r) {
                  o.read().then(function readChunk(u) {
                    try {
                      if (!u.done) {
                        var h = u.value;
                        return (
                          l.push(h),
                          (c += (0, i.arrayByteLength)(h)),
                          o.isStreamingSupported && a.onProgress({ loaded: c }),
                          void o.read().then(readChunk, r)
                        );
                      }
                      var d = (0, i.arraysToBytes)(l);
                      (l = null), t(d);
                    } catch (t) {
                      r(t);
                    }
                  }, r);
                }).then(function (r) {
                  a.aborted || a.onReceiveData({ chunk: r, begin: t });
                });
              },
            },
            {
              key: "requestAllChunks",
              value: function requestAllChunks() {
                var t = this.stream.getMissingChunks();
                return (
                  this._requestChunks(t), this._loadedStreamCapability.promise
                );
              },
            },
            {
              key: "_requestChunks",
              value: function _requestChunks(t) {
                var r = this.currRequestId++,
                  a = Object.create(null);
                this.chunksNeededByRequest[r] = a;
                var o,
                  l = _createForOfIteratorHelper(t);
                try {
                  for (l.s(); !(o = l.n()).done; ) {
                    var c = o.value;
                    this.stream.hasChunk(c) || (a[c] = !0);
                  }
                } catch (t) {
                  l.e(t);
                } finally {
                  l.f();
                }
                if ((0, i.isEmptyObj)(a)) return Promise.resolve();
                var u = (0, i.createPromiseCapability)();
                this.promisesByRequest[r] = u;
                var h = [];
                for (var d in a)
                  (d |= 0) in this.requestsByChunk ||
                    ((this.requestsByChunk[d] = []), h.push(d)),
                    this.requestsByChunk[d].push(r);
                if (!h.length) return u.promise;
                var p,
                  m = _createForOfIteratorHelper(this.groupChunks(h));
                try {
                  for (m.s(); !(p = m.n()).done; ) {
                    var g = p.value,
                      b = g.beginChunk * this.chunkSize,
                      y = Math.min(g.endChunk * this.chunkSize, this.length);
                    this.sendRequest(b, y);
                  }
                } catch (t) {
                  m.e(t);
                } finally {
                  m.f();
                }
                return u.promise;
              },
            },
            {
              key: "getStream",
              value: function getStream() {
                return this.stream;
              },
            },
            {
              key: "requestRange",
              value: function requestRange(t, r) {
                r = Math.min(r, this.length);
                for (
                  var a = this.getBeginChunk(t),
                    i = this.getEndChunk(r),
                    o = [],
                    l = a;
                  l < i;
                  ++l
                )
                  o.push(l);
                return this._requestChunks(o);
              },
            },
            {
              key: "requestRanges",
              value: function requestRanges() {
                var t,
                  r =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : [],
                  a = [],
                  i = _createForOfIteratorHelper(r);
                try {
                  for (i.s(); !(t = i.n()).done; )
                    for (
                      var o = t.value,
                        l = this.getBeginChunk(o.begin),
                        c = this.getEndChunk(o.end),
                        u = l;
                      u < c;
                      ++u
                    )
                      a.includes(u) || a.push(u);
                } catch (t) {
                  i.e(t);
                } finally {
                  i.f();
                }
                return (
                  a.sort(function (t, r) {
                    return t - r;
                  }),
                  this._requestChunks(a)
                );
              },
            },
            {
              key: "groupChunks",
              value: function groupChunks(t) {
                for (
                  var r = [], a = -1, i = -1, o = 0, l = t.length;
                  o < l;
                  ++o
                ) {
                  var c = t[o];
                  a < 0 && (a = c),
                    i >= 0 &&
                      i + 1 !== c &&
                      (r.push({ beginChunk: a, endChunk: i + 1 }), (a = c)),
                    o + 1 === t.length &&
                      r.push({ beginChunk: a, endChunk: c + 1 }),
                    (i = c);
                }
                return r;
              },
            },
            {
              key: "onProgress",
              value: function onProgress(t) {
                this.msgHandler.send("DocProgress", {
                  loaded:
                    this.stream.numChunksLoaded * this.chunkSize + t.loaded,
                  total: this.length,
                });
              },
            },
            {
              key: "onReceiveData",
              value: function onReceiveData(t) {
                var r = t.chunk,
                  a = void 0 === t.begin,
                  o = a ? this.progressiveDataLength : t.begin,
                  l = o + r.byteLength,
                  c = Math.floor(o / this.chunkSize),
                  u =
                    l < this.length
                      ? Math.floor(l / this.chunkSize)
                      : Math.ceil(l / this.chunkSize);
                a
                  ? (this.stream.onReceiveProgressiveData(r),
                    (this.progressiveDataLength = l))
                  : this.stream.onReceiveData(o, r),
                  this.stream.allChunksLoaded() &&
                    this._loadedStreamCapability.resolve(this.stream);
                for (var h = [], d = c; d < u; ++d) {
                  var p = this.requestsByChunk[d] || [];
                  delete this.requestsByChunk[d];
                  var m,
                    g = _createForOfIteratorHelper(p);
                  try {
                    for (g.s(); !(m = g.n()).done; ) {
                      var b = m.value,
                        y = this.chunksNeededByRequest[b];
                      d in y && delete y[d], (0, i.isEmptyObj)(y) && h.push(b);
                    }
                  } catch (t) {
                    g.e(t);
                  } finally {
                    g.f();
                  }
                }
                if (
                  !this.disableAutoFetch &&
                  (0, i.isEmptyObj)(this.requestsByChunk)
                ) {
                  var v;
                  if (1 === this.stream.numChunksLoaded) {
                    var S = this.stream.numChunks - 1;
                    this.stream.hasChunk(S) || (v = S);
                  } else v = this.stream.nextEmptyChunk(u);
                  Number.isInteger(v) && this._requestChunks([v]);
                }
                for (var k = 0, w = h; k < w.length; k++) {
                  var C = w[k],
                    x = this.promisesByRequest[C];
                  delete this.promisesByRequest[C], x.resolve();
                }
                this.msgHandler.send("DocProgress", {
                  loaded: this.stream.numChunksLoaded * this.chunkSize,
                  total: this.length,
                });
              },
            },
            {
              key: "onError",
              value: function onError(t) {
                this._loadedStreamCapability.reject(t);
              },
            },
            {
              key: "getBeginChunk",
              value: function getBeginChunk(t) {
                return Math.floor(t / this.chunkSize);
              },
            },
            {
              key: "getEndChunk",
              value: function getEndChunk(t) {
                return Math.floor((t - 1) / this.chunkSize) + 1;
              },
            },
            {
              key: "abort",
              value: function abort(t) {
                for (var r in ((this.aborted = !0),
                this.pdfNetworkStream &&
                  this.pdfNetworkStream.cancelAllRequests(t),
                this.promisesByRequest))
                  this.promisesByRequest[r].reject(t);
              },
            },
          ]),
          ChunkedStreamManager
        );
      })();
      r.ChunkedStreamManager = c;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.getLookupTableFactory = function getLookupTableFactory(t) {
          var r;
          return function () {
            return t && ((r = Object.create(null)), t(r), (t = null)), r;
          };
        }),
        (r.getInheritableProperty = function getInheritableProperty(t) {
          var r,
            a = t.dict,
            o = t.key,
            l = t.getArray,
            c = void 0 !== l && l,
            u = t.stopWhenFound,
            h = void 0 === u || u,
            d = 0;
          for (; a; ) {
            var p = c ? a.getArray(o) : a.get(o);
            if (void 0 !== p) {
              if (h) return p;
              r || (r = []), r.push(p);
            }
            if (++d > 100) {
              (0, i.warn)(
                'getInheritableProperty: maximum loop count exceeded for "'.concat(
                  o,
                  '"',
                ),
              );
              break;
            }
            a = a.get("Parent");
          }
          return r;
        }),
        (r.toRomanNumerals = function toRomanNumerals(t) {
          var r =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          (0, i.assert)(
            Number.isInteger(t) && t > 0,
            "The number should be a positive integer.",
          );
          var a,
            o = [];
          for (; t >= 1e3; ) (t -= 1e3), o.push("M");
          (a = (t / 100) | 0),
            (t %= 100),
            o.push(u[a]),
            (a = (t / 10) | 0),
            (t %= 10),
            o.push(u[10 + a]),
            o.push(u[20 + t]);
          var l = o.join("");
          return r ? l.toLowerCase() : l;
        }),
        (r.log2 = function log2(t) {
          if (t <= 0) return 0;
          return Math.ceil(Math.log2(t));
        }),
        (r.readInt8 = function readInt8(t, r) {
          return (t[r] << 24) >> 24;
        }),
        (r.readUint16 = function readUint16(t, r) {
          return (t[r] << 8) | t[r + 1];
        }),
        (r.readUint32 = function readUint32(t, r) {
          return (
            ((t[r] << 24) | (t[r + 1] << 16) | (t[r + 2] << 8) | t[r + 3]) >>> 0
          );
        }),
        (r.isWhiteSpace = function isWhiteSpace(t) {
          return 32 === t || 9 === t || 13 === t || 10 === t;
        }),
        (r.XRefParseException =
          r.XRefEntryException =
          r.MissingDataException =
            void 0);
      var i = a(5);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _inherits(t, r) {
        if ("function" != typeof r && null !== r)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (t.prototype = Object.create(r && r.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          r && _setPrototypeOf(t, r);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      var o = (function (t) {
        _inherits(MissingDataException, t);
        var r = _createSuper(MissingDataException);
        function MissingDataException(t, a) {
          var i;
          return (
            _classCallCheck(this, MissingDataException),
            ((i = r.call(
              this,
              "Missing data [".concat(t, ", ").concat(a, ")"),
            )).begin = t),
            (i.end = a),
            i
          );
        }
        return MissingDataException;
      })(i.BaseException);
      r.MissingDataException = o;
      var l = (function (t) {
        _inherits(XRefEntryException, t);
        var r = _createSuper(XRefEntryException);
        function XRefEntryException() {
          return (
            _classCallCheck(this, XRefEntryException), r.apply(this, arguments)
          );
        }
        return XRefEntryException;
      })(i.BaseException);
      r.XRefEntryException = l;
      var c = (function (t) {
        _inherits(XRefParseException, t);
        var r = _createSuper(XRefParseException);
        function XRefParseException() {
          return (
            _classCallCheck(this, XRefParseException), r.apply(this, arguments)
          );
        }
        return XRefParseException;
      })(i.BaseException);
      r.XRefParseException = c;
      var u = [
        "",
        "C",
        "CC",
        "CCC",
        "CD",
        "D",
        "DC",
        "DCC",
        "DCCC",
        "CM",
        "",
        "X",
        "XX",
        "XXX",
        "XL",
        "L",
        "LX",
        "LXX",
        "LXXX",
        "XC",
        "",
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
      ];
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.PDFDocument = r.Page = void 0);
      var i = (function _interopRequireDefault(t) {
          return t && t.__esModule ? t : { default: t };
        })(a(2)),
        o = a(5),
        l = a(203),
        c = a(198),
        u = a(201),
        h = a(205),
        d = a(218),
        p = a(215),
        m = a(204),
        g = a(219),
        b = a(220),
        y = a(234);
      function asyncGeneratorStep(t, r, a, i, o, l, c) {
        try {
          var u = t[l](c),
            h = u.value;
        } catch (t) {
          return void a(t);
        }
        u.done ? r(h) : Promise.resolve(h).then(i, o);
      }
      function _asyncToGenerator(t) {
        return function () {
          var r = this,
            a = arguments;
          return new Promise(function (i, o) {
            var l = t.apply(r, a);
            function _next(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "next", t);
            }
            function _throw(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "throw", t);
            }
            _next(void 0);
          });
        };
      }
      function _slicedToArray(t, r) {
        return (
          (function _arrayWithHoles(t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function _iterableToArrayLimit(t, r) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var a = [],
              i = !0,
              o = !1,
              l = void 0;
            try {
              for (
                var c, u = t[Symbol.iterator]();
                !(i = (c = u.next()).done) &&
                (a.push(c.value), !r || a.length !== r);
                i = !0
              );
            } catch (t) {
              (o = !0), (l = t);
            } finally {
              try {
                i || null == u.return || u.return();
              } finally {
                if (o) throw l;
              }
            }
            return a;
          })(t, r) ||
          _unsupportedIterableToArray(t, r) ||
          (function _nonIterableRest() {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function _createForOfIteratorHelper(t, r) {
        var a;
        if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
          if (
            Array.isArray(t) ||
            (a = _unsupportedIterableToArray(t)) ||
            (r && t && "number" == typeof t.length)
          ) {
            a && (t = a);
            var i = 0,
              o = function F() {};
            return {
              s: o,
              n: function n() {
                return i >= t.length
                  ? { done: !0 }
                  : { done: !1, value: t[i++] };
              },
              e: function e(t) {
                throw t;
              },
              f: o,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var l,
          c = !0,
          u = !1;
        return {
          s: function s() {
            a = t[Symbol.iterator]();
          },
          n: function n() {
            var t = a.next();
            return (c = t.done), t;
          },
          e: function e(t) {
            (u = !0), (l = t);
          },
          f: function f() {
            try {
              c || null == a.return || a.return();
            } finally {
              if (u) throw l;
            }
          },
        };
      }
      function _unsupportedIterableToArray(t, r) {
        if (t) {
          if ("string" == typeof t) return _arrayLikeToArray(t, r);
          var a = Object.prototype.toString.call(t).slice(8, -1);
          return (
            "Object" === a && t.constructor && (a = t.constructor.name),
            "Map" === a || "Set" === a
              ? Array.from(t)
              : "Arguments" === a ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
              ? _arrayLikeToArray(t, r)
              : void 0
          );
        }
      }
      function _arrayLikeToArray(t, r) {
        (null == r || r > t.length) && (r = t.length);
        for (var a = 0, i = new Array(r); a < r; a++) i[a] = t[a];
        return i;
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var v = [0, 0, 612, 792];
      function isAnnotationRenderable(t, r) {
        return (
          ("display" === r && t.viewable) || ("print" === r && t.printable)
        );
      }
      var S = (function () {
        function Page(t) {
          var r = t.pdfManager,
            a = t.xref,
            i = t.pageIndex,
            o = t.pageDict,
            l = t.ref,
            c = t.fontCache,
            u = t.builtInCMapCache,
            h = t.globalImageCache,
            d = t.pdfFunctionFactory;
          _classCallCheck(this, Page),
            (this.pdfManager = r),
            (this.pageIndex = i),
            (this.pageDict = o),
            (this.xref = a),
            (this.ref = l),
            (this.fontCache = c),
            (this.builtInCMapCache = u),
            (this.globalImageCache = h),
            (this.pdfFunctionFactory = d),
            (this.evaluatorOptions = r.evaluatorOptions),
            (this.resourcesPromise = null);
          var p = { obj: 0 };
          this.idFactory = {
            createObjId: function createObjId() {
              return "p".concat(i, "_").concat(++p.obj);
            },
            getDocId: function getDocId() {
              return "g_".concat(r.docId);
            },
          };
        }
        return (
          _createClass(Page, [
            {
              key: "_getInheritableProperty",
              value: function _getInheritableProperty(t) {
                var r =
                    arguments.length > 1 &&
                    void 0 !== arguments[1] &&
                    arguments[1],
                  a = (0, u.getInheritableProperty)({
                    dict: this.pageDict,
                    key: t,
                    getArray: r,
                    stopWhenFound: !1,
                  });
                return Array.isArray(a)
                  ? 1 !== a.length && (0, c.isDict)(a[0])
                    ? c.Dict.merge(this.xref, a)
                    : a[0]
                  : a;
              },
            },
            {
              key: "_getBoundingBox",
              value: function _getBoundingBox(t) {
                var r = this._getInheritableProperty(t, !0);
                if (Array.isArray(r) && 4 === r.length) {
                  if (r[2] - r[0] != 0 && r[3] - r[1] != 0) return r;
                  (0, o.warn)("Empty /".concat(t, " entry."));
                }
                return null;
              },
            },
            {
              key: "getContentStream",
              value: function getContentStream() {
                var t,
                  r = this.content;
                if (Array.isArray(r)) {
                  var a,
                    i = this.xref,
                    o = [],
                    l = _createForOfIteratorHelper(r);
                  try {
                    for (l.s(); !(a = l.n()).done; ) {
                      var u = a.value;
                      o.push(i.fetchIfRef(u));
                    }
                  } catch (t) {
                    l.e(t);
                  } finally {
                    l.f();
                  }
                  t = new h.StreamsSequenceStream(o);
                } else t = (0, c.isStream)(r) ? r : new h.NullStream();
                return t;
              },
            },
            {
              key: "loadResources",
              value: function loadResources(t) {
                var r = this;
                return (
                  this.resourcesPromise ||
                    (this.resourcesPromise = this.pdfManager.ensure(
                      this,
                      "resources",
                    )),
                  this.resourcesPromise.then(function () {
                    return new l.ObjectLoader(r.resources, t, r.xref).load();
                  })
                );
              },
            },
            {
              key: "getOperatorList",
              value: function getOperatorList(t) {
                var r = this,
                  a = t.handler,
                  i = t.sink,
                  l = t.task,
                  c = t.intent,
                  u = t.renderInteractiveForms,
                  h = this.pdfManager.ensure(this, "getContentStream"),
                  d = this.loadResources([
                    "ExtGState",
                    "ColorSpace",
                    "Pattern",
                    "Shading",
                    "XObject",
                    "Font",
                  ]),
                  p = new b.PartialEvaluator({
                    xref: this.xref,
                    handler: a,
                    pageIndex: this.pageIndex,
                    idFactory: this.idFactory,
                    fontCache: this.fontCache,
                    builtInCMapCache: this.builtInCMapCache,
                    globalImageCache: this.globalImageCache,
                    options: this.evaluatorOptions,
                    pdfFunctionFactory: this.pdfFunctionFactory,
                  }),
                  m = Promise.all([h, d]).then(function (t) {
                    var o = _slicedToArray(t, 1)[0],
                      u = new g.OperatorList(c, i, r.pageIndex);
                    return (
                      a.send("StartRenderPage", {
                        transparency: p.hasBlendModes(r.resources),
                        pageIndex: r.pageIndex,
                        intent: c,
                      }),
                      p
                        .getOperatorList({
                          stream: o,
                          task: l,
                          resources: r.resources,
                          operatorList: u,
                        })
                        .then(function () {
                          return u;
                        })
                    );
                  });
                return Promise.all([m, this._parsedAnnotations]).then(
                  function (t) {
                    var r = _slicedToArray(t, 2),
                      a = r[0],
                      i = r[1];
                    if (0 === i.length)
                      return a.flush(!0), { length: a.totalLength };
                    var h,
                      d = [],
                      m = _createForOfIteratorHelper(i);
                    try {
                      for (m.s(); !(h = m.n()).done; ) {
                        var g = h.value;
                        isAnnotationRenderable(g, c) &&
                          d.push(
                            g.getOperatorList(p, l, u).catch(function (t) {
                              return (
                                (0, o.warn)(
                                  "getOperatorList - ignoring annotation data during " +
                                    '"'
                                      .concat(l.name, '" task: "')
                                      .concat(t, '".'),
                                ),
                                null
                              );
                            }),
                          );
                      }
                    } catch (t) {
                      m.e(t);
                    } finally {
                      m.f();
                    }
                    return Promise.all(d).then(function (t) {
                      a.addOp(o.OPS.beginAnnotations, []);
                      var r,
                        i = _createForOfIteratorHelper(t);
                      try {
                        for (i.s(); !(r = i.n()).done; ) {
                          var l = r.value;
                          a.addOpList(l);
                        }
                      } catch (t) {
                        i.e(t);
                      } finally {
                        i.f();
                      }
                      return (
                        a.addOp(o.OPS.endAnnotations, []),
                        a.flush(!0),
                        { length: a.totalLength }
                      );
                    });
                  },
                );
              },
            },
            {
              key: "extractTextContent",
              value: function extractTextContent(t) {
                var r = this,
                  a = t.handler,
                  i = t.task,
                  o = t.normalizeWhitespace,
                  l = t.sink,
                  c = t.combineTextItems,
                  u = this.pdfManager.ensure(this, "getContentStream"),
                  h = this.loadResources(["ExtGState", "XObject", "Font"]);
                return Promise.all([u, h]).then(function (t) {
                  var u = _slicedToArray(t, 1)[0];
                  return new b.PartialEvaluator({
                    xref: r.xref,
                    handler: a,
                    pageIndex: r.pageIndex,
                    idFactory: r.idFactory,
                    fontCache: r.fontCache,
                    builtInCMapCache: r.builtInCMapCache,
                    globalImageCache: r.globalImageCache,
                    options: r.evaluatorOptions,
                    pdfFunctionFactory: r.pdfFunctionFactory,
                  }).getTextContent({
                    stream: u,
                    task: i,
                    resources: r.resources,
                    normalizeWhitespace: o,
                    combineTextItems: c,
                    sink: l,
                  });
                });
              },
            },
            {
              key: "getAnnotationsData",
              value: function getAnnotationsData(t) {
                return this._parsedAnnotations.then(function (r) {
                  for (var a = [], i = 0, o = r.length; i < o; i++)
                    (t && !isAnnotationRenderable(r[i], t)) ||
                      a.push(r[i].data);
                  return a;
                });
              },
            },
            {
              key: "content",
              get: function get() {
                return this.pageDict.get("Contents");
              },
            },
            {
              key: "resources",
              get: function get() {
                return (0, o.shadow)(
                  this,
                  "resources",
                  this._getInheritableProperty("Resources") || c.Dict.empty,
                );
              },
            },
            {
              key: "mediaBox",
              get: function get() {
                return (0, o.shadow)(
                  this,
                  "mediaBox",
                  this._getBoundingBox("MediaBox") || v,
                );
              },
            },
            {
              key: "cropBox",
              get: function get() {
                return (0, o.shadow)(
                  this,
                  "cropBox",
                  this._getBoundingBox("CropBox") || this.mediaBox,
                );
              },
            },
            {
              key: "userUnit",
              get: function get() {
                var t = this.pageDict.get("UserUnit");
                return (
                  (!(0, o.isNum)(t) || t <= 0) && (t = 1),
                  (0, o.shadow)(this, "userUnit", t)
                );
              },
            },
            {
              key: "view",
              get: function get() {
                var t,
                  r = this.cropBox,
                  a = this.mediaBox;
                if (r === a || (0, o.isArrayEqual)(r, a)) t = a;
                else {
                  var i = o.Util.intersect(r, a);
                  i && i[2] - i[0] != 0 && i[3] - i[1] != 0
                    ? (t = i)
                    : (0, o.warn)("Empty /CropBox and /MediaBox intersection.");
                }
                return (0, o.shadow)(this, "view", t || a);
              },
            },
            {
              key: "rotate",
              get: function get() {
                var t = this._getInheritableProperty("Rotate") || 0;
                return (
                  t % 90 != 0
                    ? (t = 0)
                    : t >= 360
                    ? (t %= 360)
                    : t < 0 && (t = ((t % 360) + 360) % 360),
                  (0, o.shadow)(this, "rotate", t)
                );
              },
            },
            {
              key: "annotations",
              get: function get() {
                return (0, o.shadow)(
                  this,
                  "annotations",
                  this._getInheritableProperty("Annots") || [],
                );
              },
            },
            {
              key: "_parsedAnnotations",
              get: function get() {
                var t = this,
                  r = this.pdfManager
                    .ensure(this, "annotations")
                    .then(function () {
                      var r,
                        a = [],
                        i = _createForOfIteratorHelper(t.annotations);
                      try {
                        for (i.s(); !(r = i.n()).done; ) {
                          var l = r.value;
                          a.push(
                            d.AnnotationFactory.create(
                              t.xref,
                              l,
                              t.pdfManager,
                              t.idFactory,
                            ).catch(function (t) {
                              return (
                                (0, o.warn)(
                                  '_parsedAnnotations: "'.concat(t, '".'),
                                ),
                                null
                              );
                            }),
                          );
                        }
                      } catch (t) {
                        i.e(t);
                      } finally {
                        i.f();
                      }
                      return Promise.all(a).then(function (t) {
                        return t.filter(function (t) {
                          return !!t;
                        });
                      });
                    });
                return (0, o.shadow)(this, "_parsedAnnotations", r);
              },
            },
          ]),
          Page
        );
      })();
      r.Page = S;
      var k = new Uint8Array([37, 80, 68, 70, 45]),
        w = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]),
        C = new Uint8Array([101, 110, 100, 111, 98, 106]),
        x = /^[1-9]\.[0-9]$/;
      function find(t, r) {
        var a =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : 1024,
          i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
          o = r.length,
          l = t.peekBytes(a),
          c = l.length - o;
        if (c <= 0) return !1;
        if (i)
          for (var u = o - 1, h = l.length - 1; h >= u; ) {
            for (var d = 0; d < o && l[h - d] === r[u - d]; ) d++;
            if (d >= o) return (t.pos += h - u), !0;
            h--;
          }
        else
          for (var p = 0; p <= c; ) {
            for (var m = 0; m < o && l[p + m] === r[m]; ) m++;
            if (m >= o) return (t.pos += p), !0;
            p++;
          }
        return !1;
      }
      var _ = (function () {
        function PDFDocument(t, r) {
          var a;
          if ((_classCallCheck(this, PDFDocument), (0, c.isStream)(r))) a = r;
          else {
            if (!(0, o.isArrayBuffer)(r))
              throw new Error("PDFDocument: Unknown argument type");
            a = new h.Stream(r);
          }
          if (a.length <= 0)
            throw new o.InvalidPDFException(
              "The PDF file is empty, i.e. its size is zero bytes.",
            );
          (this.pdfManager = t),
            (this.stream = a),
            (this.xref = new l.XRef(a, t)),
            (this.pdfFunctionFactory = new y.PDFFunctionFactory({
              xref: this.xref,
              isEvalSupported: t.evaluatorOptions.isEvalSupported,
            })),
            (this._pagePromises = []);
        }
        var t;
        return (
          _createClass(PDFDocument, [
            {
              key: "parse",
              value: function parse(t) {
                this.setup(t);
                var r = this.catalog.catDict.get("Version");
                (0, c.isName)(r) && (this.pdfFormatVersion = r.name);
                try {
                  if (
                    ((this.acroForm = this.catalog.catDict.get("AcroForm")),
                    this.acroForm)
                  ) {
                    this.xfa = this.acroForm.get("XFA");
                    var a = this.acroForm.get("Fields");
                    (Array.isArray(a) && 0 !== a.length) ||
                      this.xfa ||
                      (this.acroForm = null);
                  }
                } catch (t) {
                  if (t instanceof u.MissingDataException) throw t;
                  (0, o.info)(
                    "Cannot fetch AcroForm entry; assuming no AcroForms are present",
                  ),
                    (this.acroForm = null);
                }
                try {
                  var i = this.catalog.catDict.get("Collection");
                  (0, c.isDict)(i) &&
                    i.getKeys().length > 0 &&
                    (this.collection = i);
                } catch (t) {
                  if (t instanceof u.MissingDataException) throw t;
                  (0, o.info)("Cannot fetch Collection dictionary.");
                }
              },
            },
            {
              key: "checkHeader",
              value: function checkHeader() {
                var t = this.stream;
                if ((t.reset(), find(t, k))) {
                  t.moveStart();
                  for (
                    var r, a = "";
                    (r = t.getByte()) > 32 && !(a.length >= 12);

                  )
                    a += String.fromCharCode(r);
                  this.pdfFormatVersion ||
                    (this.pdfFormatVersion = a.substring(5));
                }
              },
            },
            {
              key: "parseStartXRef",
              value: function parseStartXRef() {
                this.xref.setStartXRef(this.startXRef);
              },
            },
            {
              key: "setup",
              value: function setup(t) {
                this.xref.parse(t),
                  (this.catalog = new l.Catalog(this.pdfManager, this.xref));
              },
            },
            {
              key: "_getLinearizationPage",
              value: function _getLinearizationPage(t) {
                var r = this.catalog,
                  a = this.linearization,
                  i = c.Ref.get(a.objectNumberFirst, 0);
                return this.xref
                  .fetchAsync(i)
                  .then(function (t) {
                    if (
                      (0, c.isDict)(t, "Page") ||
                      ((0, c.isDict)(t) && !t.has("Type") && t.has("Contents"))
                    )
                      return (
                        i &&
                          !r.pageKidsCountCache.has(i) &&
                          r.pageKidsCountCache.put(i, 1),
                        [t, i]
                      );
                    throw new o.FormatError(
                      "The Linearization dictionary doesn't point to a valid Page dictionary.",
                    );
                  })
                  .catch(function (a) {
                    return (0, o.info)(a), r.getPageDict(t);
                  });
              },
            },
            {
              key: "getPage",
              value: function getPage(t) {
                var r = this;
                if (void 0 !== this._pagePromises[t])
                  return this._pagePromises[t];
                var a = this.catalog,
                  i = this.linearization,
                  o =
                    i && i.pageFirst === t
                      ? this._getLinearizationPage(t)
                      : a.getPageDict(t);
                return (this._pagePromises[t] = o.then(function (i) {
                  var o = _slicedToArray(i, 2),
                    l = o[0],
                    c = o[1];
                  return new S({
                    pdfManager: r.pdfManager,
                    xref: r.xref,
                    pageIndex: t,
                    pageDict: l,
                    ref: c,
                    fontCache: a.fontCache,
                    builtInCMapCache: a.builtInCMapCache,
                    globalImageCache: a.globalImageCache,
                    pdfFunctionFactory: r.pdfFunctionFactory,
                  });
                }));
              },
            },
            {
              key: "checkFirstPage",
              value: function checkFirstPage() {
                var t = this;
                return this.getPage(0).catch(
                  (function () {
                    var r = _asyncToGenerator(
                      i.default.mark(function _callee(r) {
                        return i.default.wrap(function _callee$(a) {
                          for (;;)
                            switch ((a.prev = a.next)) {
                              case 0:
                                if (!(r instanceof u.XRefEntryException)) {
                                  a.next = 5;
                                  break;
                                }
                                return (
                                  (t._pagePromises.length = 0),
                                  (a.next = 4),
                                  t.cleanup()
                                );
                              case 4:
                                throw new u.XRefParseException();
                              case 5:
                              case "end":
                                return a.stop();
                            }
                        }, _callee);
                      }),
                    );
                    return function (t) {
                      return r.apply(this, arguments);
                    };
                  })(),
                );
              },
            },
            {
              key: "fontFallback",
              value: function fontFallback(t, r) {
                return this.catalog.fontFallback(t, r);
              },
            },
            {
              key: "cleanup",
              value:
                ((t = _asyncToGenerator(
                  i.default.mark(function _callee2() {
                    var t,
                      r = arguments;
                    return i.default.wrap(
                      function _callee2$(a) {
                        for (;;)
                          switch ((a.prev = a.next)) {
                            case 0:
                              return (
                                (t = r.length > 0 && void 0 !== r[0] && r[0]),
                                a.abrupt(
                                  "return",
                                  this.catalog
                                    ? this.catalog.cleanup(t)
                                    : (0, c.clearPrimitiveCaches)(),
                                )
                              );
                            case 2:
                            case "end":
                              return a.stop();
                          }
                      },
                      _callee2,
                      this,
                    );
                  }),
                )),
                function cleanup() {
                  return t.apply(this, arguments);
                }),
            },
            {
              key: "linearization",
              get: function get() {
                var t = null;
                try {
                  t = m.Linearization.create(this.stream);
                } catch (t) {
                  if (t instanceof u.MissingDataException) throw t;
                  (0, o.info)(t);
                }
                return (0, o.shadow)(this, "linearization", t);
              },
            },
            {
              key: "startXRef",
              get: function get() {
                var t = this.stream,
                  r = 0;
                if (this.linearization)
                  t.reset(), find(t, C) && (r = t.pos + 6 - t.start);
                else {
                  for (var a = w.length, i = !1, l = t.end; !i && l > 0; )
                    (l -= 1024 - a) < 0 && (l = 0),
                      (t.pos = l),
                      (i = find(t, w, 1024, !0));
                  if (i) {
                    var c;
                    t.skip(9);
                    do {
                      c = t.getByte();
                    } while ((0, u.isWhiteSpace)(c));
                    for (var h = ""; c >= 32 && c <= 57; )
                      (h += String.fromCharCode(c)), (c = t.getByte());
                    (r = parseInt(h, 10)), isNaN(r) && (r = 0);
                  }
                }
                return (0, o.shadow)(this, "startXRef", r);
              },
            },
            {
              key: "numPages",
              get: function get() {
                var t = this.linearization,
                  r = t ? t.numPages : this.catalog.numPages;
                return (0, o.shadow)(this, "numPages", r);
              },
            },
            {
              key: "documentInfo",
              get: function get() {
                var t = {
                    Title: o.isString,
                    Author: o.isString,
                    Subject: o.isString,
                    Keywords: o.isString,
                    Creator: o.isString,
                    Producer: o.isString,
                    CreationDate: o.isString,
                    ModDate: o.isString,
                    Trapped: c.isName,
                  },
                  r = this.pdfFormatVersion;
                ("string" == typeof r && x.test(r)) ||
                  ((0, o.warn)("Invalid PDF header version number: ".concat(r)),
                  (r = null));
                var a,
                  i = {
                    PDFFormatVersion: r,
                    IsLinearized: !!this.linearization,
                    IsAcroFormPresent: !!this.acroForm,
                    IsXFAPresent: !!this.xfa,
                    IsCollectionPresent: !!this.collection,
                  };
                try {
                  a = this.xref.trailer.get("Info");
                } catch (t) {
                  if (t instanceof u.MissingDataException) throw t;
                  (0, o.info)(
                    "The document information dictionary is invalid.",
                  );
                }
                if ((0, c.isDict)(a)) {
                  var l,
                    h = _createForOfIteratorHelper(a.getKeys());
                  try {
                    for (h.s(); !(l = h.n()).done; ) {
                      var d = l.value,
                        p = a.get(d);
                      if (t[d])
                        t[d](p)
                          ? (i[d] =
                              "string" != typeof p
                                ? p
                                : (0, o.stringToPDFString)(p))
                          : (0, o.info)(
                              'Bad value in document info for "'.concat(
                                d,
                                '".',
                              ),
                            );
                      else if ("string" == typeof d) {
                        var m = void 0;
                        if ((0, o.isString)(p)) m = (0, o.stringToPDFString)(p);
                        else {
                          if (
                            !(
                              (0, c.isName)(p) ||
                              (0, o.isNum)(p) ||
                              (0, o.isBool)(p)
                            )
                          ) {
                            (0, o.info)(
                              'Unsupported value in document info for (custom) "'.concat(
                                d,
                                '".',
                              ),
                            );
                            continue;
                          }
                          m = p;
                        }
                        i.Custom || (i.Custom = Object.create(null)),
                          (i.Custom[d] = m);
                      }
                    }
                  } catch (t) {
                    h.e(t);
                  } finally {
                    h.f();
                  }
                }
                return (0, o.shadow)(this, "documentInfo", i);
              },
            },
            {
              key: "fingerprint",
              get: function get() {
                for (
                  var t,
                    r = this.xref.trailer.get("ID"),
                    a = [],
                    i = 0,
                    l = (t =
                      Array.isArray(r) &&
                      r[0] &&
                      (0, o.isString)(r[0]) &&
                      "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0" !== r[0]
                        ? (0, o.stringToBytes)(r[0])
                        : (0, p.calculateMD5)(
                            this.stream.getByteRange(0, 1024),
                            0,
                            1024,
                          )).length;
                  i < l;
                  i++
                ) {
                  var c = t[i].toString(16);
                  a.push(c.padStart(2, "0"));
                }
                return (0, o.shadow)(this, "fingerprint", a.join(""));
              },
            },
          ]),
          PDFDocument
        );
      })();
      r.PDFDocument = _;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.FileSpec = r.XRef = r.ObjectLoader = r.Catalog = void 0);
      var i = (function _interopRequireDefault(t) {
          return t && t.__esModule ? t : { default: t };
        })(a(2)),
        o = a(5),
        l = a(198),
        c = a(204),
        u = a(201),
        h = a(215),
        d = a(216),
        p = a(217);
      function _inherits(t, r) {
        if ("function" != typeof r && null !== r)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (t.prototype = Object.create(r && r.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          r && _setPrototypeOf(t, r);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function asyncGeneratorStep(t, r, a, i, o, l, c) {
        try {
          var u = t[l](c),
            h = u.value;
        } catch (t) {
          return void a(t);
        }
        u.done ? r(h) : Promise.resolve(h).then(i, o);
      }
      function _asyncToGenerator(t) {
        return function () {
          var r = this,
            a = arguments;
          return new Promise(function (i, o) {
            var l = t.apply(r, a);
            function _next(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "next", t);
            }
            function _throw(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "throw", t);
            }
            _next(void 0);
          });
        };
      }
      function _slicedToArray(t, r) {
        return (
          (function _arrayWithHoles(t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function _iterableToArrayLimit(t, r) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var a = [],
              i = !0,
              o = !1,
              l = void 0;
            try {
              for (
                var c, u = t[Symbol.iterator]();
                !(i = (c = u.next()).done) &&
                (a.push(c.value), !r || a.length !== r);
                i = !0
              );
            } catch (t) {
              (o = !0), (l = t);
            } finally {
              try {
                i || null == u.return || u.return();
              } finally {
                if (o) throw l;
              }
            }
            return a;
          })(t, r) ||
          _unsupportedIterableToArray(t, r) ||
          (function _nonIterableRest() {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _createForOfIteratorHelper(t, r) {
        var a;
        if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
          if (
            Array.isArray(t) ||
            (a = _unsupportedIterableToArray(t)) ||
            (r && t && "number" == typeof t.length)
          ) {
            a && (t = a);
            var i = 0,
              o = function F() {};
            return {
              s: o,
              n: function n() {
                return i >= t.length
                  ? { done: !0 }
                  : { done: !1, value: t[i++] };
              },
              e: function e(t) {
                throw t;
              },
              f: o,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var l,
          c = !0,
          u = !1;
        return {
          s: function s() {
            a = t[Symbol.iterator]();
          },
          n: function n() {
            var t = a.next();
            return (c = t.done), t;
          },
          e: function e(t) {
            (u = !0), (l = t);
          },
          f: function f() {
            try {
              c || null == a.return || a.return();
            } finally {
              if (u) throw l;
            }
          },
        };
      }
      function _unsupportedIterableToArray(t, r) {
        if (t) {
          if ("string" == typeof t) return _arrayLikeToArray(t, r);
          var a = Object.prototype.toString.call(t).slice(8, -1);
          return (
            "Object" === a && t.constructor && (a = t.constructor.name),
            "Map" === a || "Set" === a
              ? Array.from(t)
              : "Arguments" === a ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
              ? _arrayLikeToArray(t, r)
              : void 0
          );
        }
      }
      function _arrayLikeToArray(t, r) {
        (null == r || r > t.length) && (r = t.length);
        for (var a = 0, i = new Array(r); a < r; a++) i[a] = t[a];
        return i;
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      function fetchDestination(t) {
        return (0, l.isDict)(t) ? t.get("D") : t;
      }
      var m = (function () {
        function Catalog(t, r) {
          if (
            (_classCallCheck(this, Catalog),
            (this.pdfManager = t),
            (this.xref = r),
            (this.catDict = r.getCatalogObj()),
            !(0, l.isDict)(this.catDict))
          )
            throw new o.FormatError("Catalog object is not a dictionary.");
          (this.fontCache = new l.RefSetCache()),
            (this.builtInCMapCache = new Map()),
            (this.globalImageCache = new p.GlobalImageCache()),
            (this.pageKidsCountCache = new l.RefSetCache());
        }
        return (
          _createClass(
            Catalog,
            [
              {
                key: "_readDocumentOutline",
                value: function _readDocumentOutline() {
                  var t = this.catDict.get("Outlines");
                  if (!(0, l.isDict)(t)) return null;
                  if (((t = t.getRaw("First")), !(0, l.isRef)(t))) return null;
                  var r = { items: [] },
                    a = [{ obj: t, parent: r }],
                    i = new l.RefSet();
                  i.put(t);
                  for (
                    var c = this.xref, u = new Uint8ClampedArray(3);
                    a.length > 0;

                  ) {
                    var h = a.shift(),
                      p = c.fetchIfRef(h.obj);
                    if (null !== p) {
                      if (!p.has("Title"))
                        throw new o.FormatError(
                          "Invalid outline item encountered.",
                        );
                      var m = { url: null, dest: null };
                      Catalog.parseDestDictionary({
                        destDict: p,
                        resultObj: m,
                        docBaseUrl: this.pdfManager.docBaseUrl,
                      });
                      var g = p.get("Title"),
                        b = p.get("F") || 0,
                        y = p.getArray("C"),
                        v = p.get("Count"),
                        S = u;
                      !Array.isArray(y) ||
                        3 !== y.length ||
                        (0 === y[0] && 0 === y[1] && 0 === y[2]) ||
                        (S = d.ColorSpace.singletons.rgb.getRgb(y, 0));
                      var k = {
                        dest: m.dest,
                        url: m.url,
                        unsafeUrl: m.unsafeUrl,
                        newWindow: m.newWindow,
                        title: (0, o.stringToPDFString)(g),
                        color: S,
                        count: Number.isInteger(v) ? v : void 0,
                        bold: !!(2 & b),
                        italic: !!(1 & b),
                        items: [],
                      };
                      h.parent.items.push(k),
                        (t = p.getRaw("First")),
                        (0, l.isRef)(t) &&
                          !i.has(t) &&
                          (a.push({ obj: t, parent: k }), i.put(t)),
                        (t = p.getRaw("Next")),
                        (0, l.isRef)(t) &&
                          !i.has(t) &&
                          (a.push({ obj: t, parent: h.parent }), i.put(t));
                    }
                  }
                  return r.items.length > 0 ? r.items : null;
                },
              },
              {
                key: "_readPermissions",
                value: function _readPermissions() {
                  var t = this.xref.trailer.get("Encrypt");
                  if (!(0, l.isDict)(t)) return null;
                  var r = t.get("P");
                  if (!(0, o.isNum)(r)) return null;
                  r += Math.pow(2, 32);
                  var a = [];
                  for (var i in o.PermissionFlag) {
                    var c = o.PermissionFlag[i];
                    r & c && a.push(c);
                  }
                  return a;
                },
              },
              {
                key: "getDestination",
                value: function getDestination(t) {
                  var r = this._readDests();
                  return r instanceof y || r instanceof l.Dict
                    ? fetchDestination(r.get(t) || null)
                    : null;
                },
              },
              {
                key: "_readDests",
                value: function _readDests() {
                  var t = this.catDict.get("Names");
                  return t && t.has("Dests")
                    ? new y(t.getRaw("Dests"), this.xref)
                    : this.catDict.has("Dests")
                    ? this.catDict.get("Dests")
                    : void 0;
                },
              },
              {
                key: "_readPageLabels",
                value: function _readPageLabels() {
                  var t = this.catDict.getRaw("PageLabels");
                  if (!t) return null;
                  for (
                    var r = new Array(this.numPages),
                      a = null,
                      i = "",
                      c = new v(t, this.xref).getAll(),
                      h = "",
                      d = 1,
                      p = 0,
                      m = this.numPages;
                    p < m;
                    p++
                  ) {
                    if (p in c) {
                      var g = c[p];
                      if (!(0, l.isDict)(g))
                        throw new o.FormatError(
                          "PageLabel is not a dictionary.",
                        );
                      if (
                        g.has("Type") &&
                        !(0, l.isName)(g.get("Type"), "PageLabel")
                      )
                        throw new o.FormatError(
                          "Invalid type in PageLabel dictionary.",
                        );
                      if (g.has("S")) {
                        var b = g.get("S");
                        if (!(0, l.isName)(b))
                          throw new o.FormatError(
                            "Invalid style in PageLabel dictionary.",
                          );
                        a = b.name;
                      } else a = null;
                      if (g.has("P")) {
                        var y = g.get("P");
                        if (!(0, o.isString)(y))
                          throw new o.FormatError(
                            "Invalid prefix in PageLabel dictionary.",
                          );
                        i = (0, o.stringToPDFString)(y);
                      } else i = "";
                      if (g.has("St")) {
                        var S = g.get("St");
                        if (!(Number.isInteger(S) && S >= 1))
                          throw new o.FormatError(
                            "Invalid start in PageLabel dictionary.",
                          );
                        d = S;
                      } else d = 1;
                    }
                    switch (a) {
                      case "D":
                        h = d;
                        break;
                      case "R":
                      case "r":
                        h = (0, u.toRomanNumerals)(d, "r" === a);
                        break;
                      case "A":
                      case "a":
                        for (
                          var k = "a" === a ? 97 : 65,
                            w = d - 1,
                            C = String.fromCharCode(k + (w % 26)),
                            x = [],
                            _ = 0,
                            A = (w / 26) | 0;
                          _ <= A;
                          _++
                        )
                          x.push(C);
                        h = x.join("");
                        break;
                      default:
                        if (a)
                          throw new o.FormatError(
                            'Invalid style "'.concat(
                              a,
                              '" in PageLabel dictionary.',
                            ),
                          );
                        h = "";
                    }
                    (r[p] = i + h), d++;
                  }
                  return r;
                },
              },
              {
                key: "fontFallback",
                value: function fontFallback(t, r) {
                  var a = [];
                  return (
                    this.fontCache.forEach(function (t) {
                      a.push(t);
                    }),
                    Promise.all(a).then(function (a) {
                      var i,
                        o = _createForOfIteratorHelper(a);
                      try {
                        for (o.s(); !(i = o.n()).done; ) {
                          var l = i.value;
                          if (l.loadedName === t) return void l.fallback(r);
                        }
                      } catch (t) {
                        o.e(t);
                      } finally {
                        o.f();
                      }
                    })
                  );
                },
              },
              {
                key: "cleanup",
                value: function cleanup() {
                  var t = this,
                    r =
                      arguments.length > 0 &&
                      void 0 !== arguments[0] &&
                      arguments[0];
                  (0, l.clearPrimitiveCaches)(),
                    this.globalImageCache.clear(r),
                    this.pageKidsCountCache.clear();
                  var a = [];
                  return (
                    this.fontCache.forEach(function (t) {
                      a.push(t);
                    }),
                    Promise.all(a).then(function (r) {
                      var a,
                        i = _createForOfIteratorHelper(r);
                      try {
                        for (i.s(); !(a = i.n()).done; ) {
                          delete a.value.dict.translated;
                        }
                      } catch (t) {
                        i.e(t);
                      } finally {
                        i.f();
                      }
                      t.fontCache.clear(), t.builtInCMapCache.clear();
                    })
                  );
                },
              },
              {
                key: "getPageDict",
                value: function getPageDict(t) {
                  var r,
                    a = (0, o.createPromiseCapability)(),
                    i = [this.catDict.getRaw("Pages")],
                    c = new l.RefSet(),
                    u = this.xref,
                    h = this.pageKidsCountCache,
                    d = 0;
                  return (
                    (function next() {
                      for (
                        var p = function _loop() {
                          var p = i.pop();
                          if ((0, l.isRef)(p))
                            return (r = h.get(p)) > 0 && d + r < t
                              ? ((d += r), "continue")
                              : c.has(p)
                              ? (a.reject(
                                  new o.FormatError(
                                    "Pages tree contains circular reference.",
                                  ),
                                ),
                                { v: void 0 })
                              : (c.put(p),
                                u.fetchAsync(p).then(function (r) {
                                  (0, l.isDict)(r, "Page") ||
                                  ((0, l.isDict)(r) && !r.has("Kids"))
                                    ? t === d
                                      ? (p && !h.has(p) && h.put(p, 1),
                                        a.resolve([r, p]))
                                      : (d++, next())
                                    : (i.push(r), next());
                                }, a.reject),
                                { v: void 0 });
                          if (!(0, l.isDict)(p))
                            return (
                              a.reject(
                                new o.FormatError(
                                  "Page dictionary kid reference points to wrong type of object.",
                                ),
                              ),
                              { v: void 0 }
                            );
                          if (
                            ((r = p.get("Count")),
                            Number.isInteger(r) && r >= 0)
                          ) {
                            var m = p.objId;
                            if ((m && !h.has(m) && h.put(m, r), d + r <= t))
                              return (d += r), "continue";
                          }
                          var g = p.get("Kids");
                          if (!Array.isArray(g))
                            return (0, l.isName)(p.get("Type"), "Page") ||
                              (!p.has("Type") && p.has("Contents"))
                              ? d === t
                                ? (a.resolve([p, null]), { v: void 0 })
                                : (d++, "continue")
                              : (a.reject(
                                  new o.FormatError(
                                    "Page dictionary kids object is not an array.",
                                  ),
                                ),
                                { v: void 0 });
                          for (var b = g.length - 1; b >= 0; b--) i.push(g[b]);
                        };
                        i.length;

                      ) {
                        var m = p();
                        switch (m) {
                          case "continue":
                            continue;
                          default:
                            if ("object" === _typeof(m)) return m.v;
                        }
                      }
                      a.reject(
                        new Error("Page index ".concat(t, " not found.")),
                      );
                    })(),
                    a.promise
                  );
                },
              },
              {
                key: "getPageIndex",
                value: function getPageIndex(t) {
                  var r = this.xref;
                  var a = 0;
                  return (function next(i) {
                    return (function pagesBeforeRef(a) {
                      var i,
                        c = 0;
                      return r
                        .fetchAsync(a)
                        .then(function (r) {
                          if (
                            (0, l.isRefsEqual)(a, t) &&
                            !(0, l.isDict)(r, "Page") &&
                            (!(0, l.isDict)(r) ||
                              r.has("Type") ||
                              !r.has("Contents"))
                          )
                            throw new o.FormatError(
                              "The reference does not point to a /Page dictionary.",
                            );
                          if (!r) return null;
                          if (!(0, l.isDict)(r))
                            throw new o.FormatError(
                              "Node must be a dictionary.",
                            );
                          return (i = r.getRaw("Parent")), r.getAsync("Parent");
                        })
                        .then(function (t) {
                          if (!t) return null;
                          if (!(0, l.isDict)(t))
                            throw new o.FormatError(
                              "Parent must be a dictionary.",
                            );
                          return t.getAsync("Kids");
                        })
                        .then(function (t) {
                          if (!t) return null;
                          for (
                            var u = [], h = !1, d = 0, p = t.length;
                            d < p;
                            d++
                          ) {
                            var m = t[d];
                            if (!(0, l.isRef)(m))
                              throw new o.FormatError(
                                "Kid must be a reference.",
                              );
                            if ((0, l.isRefsEqual)(m, a)) {
                              h = !0;
                              break;
                            }
                            u.push(
                              r.fetchAsync(m).then(function (t) {
                                if (!(0, l.isDict)(t))
                                  throw new o.FormatError(
                                    "Kid node must be a dictionary.",
                                  );
                                t.has("Count") ? (c += t.get("Count")) : c++;
                              }),
                            );
                          }
                          if (!h)
                            throw new o.FormatError(
                              "Kid reference not found in parent's kids.",
                            );
                          return Promise.all(u).then(function () {
                            return [c, i];
                          });
                        });
                    })(i).then(function (t) {
                      if (!t) return a;
                      var r = _slicedToArray(t, 2),
                        i = r[0],
                        o = r[1];
                      return (a += i), next(o);
                    });
                  })(t);
                },
              },
              {
                key: "metadata",
                get: function get() {
                  var t = this.catDict.getRaw("Metadata");
                  if (!(0, l.isRef)(t))
                    return (0, o.shadow)(this, "metadata", null);
                  var r,
                    a = !(
                      this.xref.encrypt && this.xref.encrypt.encryptMetadata
                    ),
                    i = this.xref.fetch(t, a);
                  if (i && (0, l.isDict)(i.dict)) {
                    var c = i.dict.get("Type"),
                      h = i.dict.get("Subtype");
                    if ((0, l.isName)(c, "Metadata") && (0, l.isName)(h, "XML"))
                      try {
                        r = (0, o.stringToUTF8String)(
                          (0, o.bytesToString)(i.getBytes()),
                        );
                      } catch (t) {
                        if (t instanceof u.MissingDataException) throw t;
                        (0, o.info)("Skipping invalid metadata.");
                      }
                  }
                  return (0, o.shadow)(this, "metadata", r);
                },
              },
              {
                key: "toplevelPagesDict",
                get: function get() {
                  var t = this.catDict.get("Pages");
                  if (!(0, l.isDict)(t))
                    throw new o.FormatError(
                      "Invalid top-level pages dictionary.",
                    );
                  return (0, o.shadow)(this, "toplevelPagesDict", t);
                },
              },
              {
                key: "documentOutline",
                get: function get() {
                  var t = null;
                  try {
                    t = this._readDocumentOutline();
                  } catch (t) {
                    if (t instanceof u.MissingDataException) throw t;
                    (0, o.warn)("Unable to read document outline.");
                  }
                  return (0, o.shadow)(this, "documentOutline", t);
                },
              },
              {
                key: "permissions",
                get: function get() {
                  var t = null;
                  try {
                    t = this._readPermissions();
                  } catch (t) {
                    if (t instanceof u.MissingDataException) throw t;
                    (0, o.warn)("Unable to read permissions.");
                  }
                  return (0, o.shadow)(this, "permissions", t);
                },
              },
              {
                key: "numPages",
                get: function get() {
                  var t = this.toplevelPagesDict.get("Count");
                  if (!Number.isInteger(t))
                    throw new o.FormatError(
                      "Page count in top-level pages dictionary is not an integer.",
                    );
                  return (0, o.shadow)(this, "numPages", t);
                },
              },
              {
                key: "destinations",
                get: function get() {
                  var t = this._readDests(),
                    r = Object.create(null);
                  if (t instanceof y) {
                    var a = t.getAll();
                    for (var i in a) r[i] = fetchDestination(a[i]);
                  } else
                    t instanceof l.Dict &&
                      t.forEach(function (t, a) {
                        a && (r[t] = fetchDestination(a));
                      });
                  return (0, o.shadow)(this, "destinations", r);
                },
              },
              {
                key: "pageLabels",
                get: function get() {
                  var t = null;
                  try {
                    t = this._readPageLabels();
                  } catch (t) {
                    if (t instanceof u.MissingDataException) throw t;
                    (0, o.warn)("Unable to read page labels.");
                  }
                  return (0, o.shadow)(this, "pageLabels", t);
                },
              },
              {
                key: "pageLayout",
                get: function get() {
                  var t = this.catDict.get("PageLayout"),
                    r = "";
                  if ((0, l.isName)(t))
                    switch (t.name) {
                      case "SinglePage":
                      case "OneColumn":
                      case "TwoColumnLeft":
                      case "TwoColumnRight":
                      case "TwoPageLeft":
                      case "TwoPageRight":
                        r = t.name;
                    }
                  return (0, o.shadow)(this, "pageLayout", r);
                },
              },
              {
                key: "pageMode",
                get: function get() {
                  var t = this.catDict.get("PageMode"),
                    r = "UseNone";
                  if ((0, l.isName)(t))
                    switch (t.name) {
                      case "UseNone":
                      case "UseOutlines":
                      case "UseThumbs":
                      case "FullScreen":
                      case "UseOC":
                      case "UseAttachments":
                        r = t.name;
                    }
                  return (0, o.shadow)(this, "pageMode", r);
                },
              },
              {
                key: "viewerPreferences",
                get: function get() {
                  var t = this,
                    r = {
                      HideToolbar: o.isBool,
                      HideMenubar: o.isBool,
                      HideWindowUI: o.isBool,
                      FitWindow: o.isBool,
                      CenterWindow: o.isBool,
                      DisplayDocTitle: o.isBool,
                      NonFullScreenPageMode: l.isName,
                      Direction: l.isName,
                      ViewArea: l.isName,
                      ViewClip: l.isName,
                      PrintArea: l.isName,
                      PrintClip: l.isName,
                      PrintScaling: l.isName,
                      Duplex: l.isName,
                      PickTrayByPDFSize: o.isBool,
                      PrintPageRange: Array.isArray,
                      NumCopies: Number.isInteger,
                    },
                    a = this.catDict.get("ViewerPreferences"),
                    i = null;
                  if ((0, l.isDict)(a))
                    for (var c in r)
                      if (a.has(c)) {
                        var u = a.get(c);
                        if (r[c](u)) {
                          var h = void 0;
                          switch (c) {
                            case "NonFullScreenPageMode":
                              switch (u.name) {
                                case "UseNone":
                                case "UseOutlines":
                                case "UseThumbs":
                                case "UseOC":
                                  h = u.name;
                                  break;
                                default:
                                  h = "UseNone";
                              }
                              break;
                            case "Direction":
                              switch (u.name) {
                                case "L2R":
                                case "R2L":
                                  h = u.name;
                                  break;
                                default:
                                  h = "L2R";
                              }
                              break;
                            case "ViewArea":
                            case "ViewClip":
                            case "PrintArea":
                            case "PrintClip":
                              switch (u.name) {
                                case "MediaBox":
                                case "CropBox":
                                case "BleedBox":
                                case "TrimBox":
                                case "ArtBox":
                                  h = u.name;
                                  break;
                                default:
                                  h = "CropBox";
                              }
                              break;
                            case "PrintScaling":
                              switch (u.name) {
                                case "None":
                                case "AppDefault":
                                  h = u.name;
                                  break;
                                default:
                                  h = "AppDefault";
                              }
                              break;
                            case "Duplex":
                              switch (u.name) {
                                case "Simplex":
                                case "DuplexFlipShortEdge":
                                case "DuplexFlipLongEdge":
                                  h = u.name;
                                  break;
                                default:
                                  h = "None";
                              }
                              break;
                            case "PrintPageRange":
                              if (u.length % 2 != 0) break;
                              u.every(function (r, a, i) {
                                return (
                                  Number.isInteger(r) &&
                                  r > 0 &&
                                  (0 === a || r >= i[a - 1]) &&
                                  r <= t.numPages
                                );
                              }) && (h = u);
                              break;
                            case "NumCopies":
                              u > 0 && (h = u);
                              break;
                            default:
                              if ("boolean" != typeof u)
                                throw new o.FormatError(
                                  "viewerPreferences - expected a boolean value for: ".concat(
                                    c,
                                  ),
                                );
                              h = u;
                          }
                          void 0 !== h
                            ? (i || (i = Object.create(null)), (i[c] = h))
                            : (0, o.info)(
                                'Bad value in ViewerPreferences for "'.concat(
                                  c,
                                  '".',
                                ),
                              );
                        } else
                          (0, o.info)(
                            'Bad value in ViewerPreferences for "'.concat(
                              c,
                              '".',
                            ),
                          );
                      }
                  return (0, o.shadow)(this, "viewerPreferences", i);
                },
              },
              {
                key: "openAction",
                get: function get() {
                  var t = this.catDict.get("OpenAction"),
                    r = null;
                  if ((0, l.isDict)(t)) {
                    var a = new l.Dict(this.xref);
                    a.set("A", t);
                    var i = { url: null, dest: null, action: null };
                    Catalog.parseDestDictionary({ destDict: a, resultObj: i }),
                      Array.isArray(i.dest)
                        ? (r || (r = Object.create(null)), (r.dest = i.dest))
                        : i.action &&
                          (r || (r = Object.create(null)),
                          (r.action = i.action));
                  } else
                    Array.isArray(t) &&
                      (r || (r = Object.create(null)), (r.dest = t));
                  return (0, o.shadow)(this, "openAction", r);
                },
              },
              {
                key: "attachments",
                get: function get() {
                  var t = this.catDict.get("Names"),
                    r = null;
                  if (t && t.has("EmbeddedFiles")) {
                    var a = new y(
                      t.getRaw("EmbeddedFiles"),
                      this.xref,
                    ).getAll();
                    for (var i in a) {
                      var l = new S(a[i], this.xref);
                      r || (r = Object.create(null)),
                        (r[(0, o.stringToPDFString)(i)] = l.serializable);
                    }
                  }
                  return (0, o.shadow)(this, "attachments", r);
                },
              },
              {
                key: "javaScript",
                get: function get() {
                  var t = this.catDict.get("Names"),
                    r = null;
                  function appendIfJavaScriptDict(t) {
                    var a = t.get("S");
                    if ((0, l.isName)(a, "JavaScript")) {
                      var i = t.get("JS");
                      if ((0, l.isStream)(i))
                        i = (0, o.bytesToString)(i.getBytes());
                      else if (!(0, o.isString)(i)) return;
                      r || (r = []), r.push((0, o.stringToPDFString)(i));
                    }
                  }
                  if (t && t.has("JavaScript")) {
                    var a = new y(t.getRaw("JavaScript"), this.xref).getAll();
                    for (var i in a) {
                      var c = a[i];
                      (0, l.isDict)(c) && appendIfJavaScriptDict(c);
                    }
                  }
                  var u = this.catDict.get("OpenAction");
                  return (
                    (0, l.isDict)(u) &&
                      (0, l.isName)(u.get("S"), "JavaScript") &&
                      appendIfJavaScriptDict(u),
                    (0, o.shadow)(this, "javaScript", r)
                  );
                },
              },
            ],
            [
              {
                key: "parseDestDictionary",
                value: function parseDestDictionary(t) {
                  var r = t.destDict;
                  if ((0, l.isDict)(r)) {
                    var a = t.resultObj;
                    if ("object" === _typeof(a)) {
                      var i,
                        c,
                        u = t.docBaseUrl || null,
                        h = r.get("A");
                      if (
                        (!(0, l.isDict)(h) &&
                          r.has("Dest") &&
                          (h = r.get("Dest")),
                        (0, l.isDict)(h))
                      ) {
                        var d = h.get("S");
                        if (!(0, l.isName)(d))
                          return void (0, o.warn)(
                            "parseDestDictionary: Invalid type in Action dictionary.",
                          );
                        var p = d.name;
                        switch (p) {
                          case "URI":
                            (i = h.get("URI")),
                              (0, l.isName)(i)
                                ? (i = "/" + i.name)
                                : (0, o.isString)(i) &&
                                  (i = (function addDefaultProtocolToUrl(t) {
                                    return t.startsWith("www.")
                                      ? "http://".concat(t)
                                      : t;
                                  })(i));
                            break;
                          case "GoTo":
                            c = h.get("D");
                            break;
                          case "Launch":
                          case "GoToR":
                            var m = h.get("F");
                            (0, l.isDict)(m)
                              ? (i = m.get("F") || null)
                              : (0, o.isString)(m) && (i = m);
                            var g = h.get("D");
                            if (
                              g &&
                              ((0, l.isName)(g) && (g = g.name),
                              (0, o.isString)(i))
                            ) {
                              var b = i.split("#")[0];
                              (0, o.isString)(g)
                                ? (i = b + "#" + g)
                                : Array.isArray(g) &&
                                  (i = b + "#" + JSON.stringify(g));
                            }
                            var y = h.get("NewWindow");
                            (0, o.isBool)(y) && (a.newWindow = y);
                            break;
                          case "Named":
                            var v = h.get("N");
                            (0, l.isName)(v) && (a.action = v.name);
                            break;
                          case "JavaScript":
                            var S,
                              k = h.get("JS");
                            if (
                              ((0, l.isStream)(k)
                                ? (S = (0, o.bytesToString)(k.getBytes()))
                                : (0, o.isString)(k) && (S = k),
                              S)
                            ) {
                              var w = new RegExp(
                                "^\\s*(" +
                                  ["app.launchURL", "window.open"]
                                    .join("|")
                                    .split(".")
                                    .join("\\.") +
                                  ")\\((?:'|\")([^'\"]*)(?:'|\")(?:,\\s*(\\w+)\\)|\\))",
                                "i",
                              ).exec((0, o.stringToPDFString)(S));
                              if (w && w[2]) {
                                (i = w[2]),
                                  "true" === w[3] &&
                                    "app.launchURL" === w[1] &&
                                    (a.newWindow = !0);
                                break;
                              }
                            }
                          default:
                            (0, o.warn)(
                              'parseDestDictionary: unsupported action type "'.concat(
                                p,
                                '".',
                              ),
                            );
                        }
                      } else r.has("Dest") && (c = r.get("Dest"));
                      if ((0, o.isString)(i)) {
                        i = (function tryConvertUrlEncoding(t) {
                          try {
                            return (0, o.stringToUTF8String)(t);
                          } catch (r) {
                            return t;
                          }
                        })(i);
                        var C = (0, o.createValidAbsoluteUrl)(i, u);
                        C && (a.url = C.href), (a.unsafeUrl = i);
                      }
                      c &&
                        ((0, l.isName)(c) && (c = c.name),
                        ((0, o.isString)(c) || Array.isArray(c)) &&
                          (a.dest = c));
                    } else
                      (0, o.warn)(
                        "parseDestDictionary: `resultObj` must be an object.",
                      );
                  } else
                    (0, o.warn)(
                      "parseDestDictionary: `destDict` must be a dictionary.",
                    );
                },
              },
            ],
          ),
          Catalog
        );
      })();
      r.Catalog = m;
      var g = (function XRefClosure() {
        function XRef(t, r) {
          (this.stream = t),
            (this.pdfManager = r),
            (this.entries = []),
            (this.xrefstms = Object.create(null)),
            (this._cacheMap = new Map()),
            (this.stats = {
              streamTypes: Object.create(null),
              fontTypes: Object.create(null),
            });
        }
        return (
          (XRef.prototype = {
            setStartXRef: function XRef_setStartXRef(t) {
              this.startXRefQueue = [t];
            },
            parse: function XRef_parse(t) {
              var r, a, i;
              t
                ? ((0, o.warn)("Indexing all PDF objects"),
                  (r = this.indexObjects()))
                : (r = this.readXRef()),
                r.assignXref(this),
                (this.trailer = r);
              try {
                a = r.get("Encrypt");
              } catch (t) {
                if (t instanceof u.MissingDataException) throw t;
                (0, o.warn)(
                  'XRef.parse - Invalid "Encrypt" reference: "'.concat(t, '".'),
                );
              }
              if ((0, l.isDict)(a)) {
                var c = r.get("ID"),
                  d = c && c.length ? c[0] : "";
                (a.suppressEncryption = !0),
                  (this.encrypt = new h.CipherTransformFactory(
                    a,
                    d,
                    this.pdfManager.password,
                  ));
              }
              try {
                i = r.get("Root");
              } catch (t) {
                if (t instanceof u.MissingDataException) throw t;
                (0, o.warn)(
                  'XRef.parse - Invalid "Root" reference: "'.concat(t, '".'),
                );
              }
              if (!(0, l.isDict)(i) || !i.has("Pages")) {
                if (!t) throw new u.XRefParseException();
                throw new o.FormatError("Invalid root reference");
              }
              this.root = i;
            },
            processXRefTable: function XRef_processXRefTable(t) {
              "tableState" in this ||
                (this.tableState = {
                  entryNum: 0,
                  streamPos: t.lexer.stream.pos,
                  parserBuf1: t.buf1,
                  parserBuf2: t.buf2,
                });
              var r = this.readXRefTable(t);
              if (!(0, l.isCmd)(r, "trailer"))
                throw new o.FormatError(
                  "Invalid XRef table: could not find trailer dictionary",
                );
              var a = t.getObj();
              if (
                (!(0, l.isDict)(a) && a.dict && (a = a.dict), !(0, l.isDict)(a))
              )
                throw new o.FormatError(
                  "Invalid XRef table: could not parse trailer dictionary",
                );
              return delete this.tableState, a;
            },
            readXRefTable: function XRef_readXRefTable(t) {
              var r,
                a = t.lexer.stream,
                i = this.tableState;
              for (
                a.pos = i.streamPos,
                  t.buf1 = i.parserBuf1,
                  t.buf2 = i.parserBuf2;
                ;

              ) {
                if (!("firstEntryNum" in i) || !("entryCount" in i)) {
                  if ((0, l.isCmd)((r = t.getObj()), "trailer")) break;
                  (i.firstEntryNum = r), (i.entryCount = t.getObj());
                }
                var c = i.firstEntryNum,
                  u = i.entryCount;
                if (!Number.isInteger(c) || !Number.isInteger(u))
                  throw new o.FormatError(
                    "Invalid XRef table: wrong types in subsection header",
                  );
                for (var h = i.entryNum; h < u; h++) {
                  (i.streamPos = a.pos),
                    (i.entryNum = h),
                    (i.parserBuf1 = t.buf1),
                    (i.parserBuf2 = t.buf2);
                  var d = {};
                  (d.offset = t.getObj()), (d.gen = t.getObj());
                  var p = t.getObj();
                  if (p instanceof l.Cmd)
                    switch (p.cmd) {
                      case "f":
                        d.free = !0;
                        break;
                      case "n":
                        d.uncompressed = !0;
                    }
                  if (
                    !Number.isInteger(d.offset) ||
                    !Number.isInteger(d.gen) ||
                    (!d.free && !d.uncompressed)
                  )
                    throw new o.FormatError(
                      "Invalid entry in XRef subsection: "
                        .concat(c, ", ")
                        .concat(u),
                    );
                  0 === h && d.free && 1 === c && (c = 0),
                    this.entries[h + c] || (this.entries[h + c] = d);
                }
                (i.entryNum = 0),
                  (i.streamPos = a.pos),
                  (i.parserBuf1 = t.buf1),
                  (i.parserBuf2 = t.buf2),
                  delete i.firstEntryNum,
                  delete i.entryCount;
              }
              if (this.entries[0] && !this.entries[0].free)
                throw new o.FormatError(
                  "Invalid XRef table: unexpected first object",
                );
              return r;
            },
            processXRefStream: function XRef_processXRefStream(t) {
              if (!("streamState" in this)) {
                var r = t.dict,
                  a = r.get("W"),
                  i = r.get("Index");
                i || (i = [0, r.get("Size")]),
                  (this.streamState = {
                    entryRanges: i,
                    byteWidths: a,
                    entryNum: 0,
                    streamPos: t.pos,
                  });
              }
              return this.readXRefStream(t), delete this.streamState, t.dict;
            },
            readXRefStream: function XRef_readXRefStream(t) {
              var r,
                a,
                i = this.streamState;
              t.pos = i.streamPos;
              for (
                var l = i.byteWidths,
                  c = l[0],
                  u = l[1],
                  h = l[2],
                  d = i.entryRanges;
                d.length > 0;

              ) {
                var p = d[0],
                  m = d[1];
                if (!Number.isInteger(p) || !Number.isInteger(m))
                  throw new o.FormatError(
                    "Invalid XRef range fields: ".concat(p, ", ").concat(m),
                  );
                if (
                  !Number.isInteger(c) ||
                  !Number.isInteger(u) ||
                  !Number.isInteger(h)
                )
                  throw new o.FormatError(
                    "Invalid XRef entry fields length: "
                      .concat(p, ", ")
                      .concat(m),
                  );
                for (r = i.entryNum; r < m; ++r) {
                  (i.entryNum = r), (i.streamPos = t.pos);
                  var g = 0,
                    b = 0,
                    y = 0;
                  for (a = 0; a < c; ++a) g = (g << 8) | t.getByte();
                  for (0 === c && (g = 1), a = 0; a < u; ++a)
                    b = (b << 8) | t.getByte();
                  for (a = 0; a < h; ++a) y = (y << 8) | t.getByte();
                  var v = {};
                  switch (((v.offset = b), (v.gen = y), g)) {
                    case 0:
                      v.free = !0;
                      break;
                    case 1:
                      v.uncompressed = !0;
                      break;
                    case 2:
                      break;
                    default:
                      throw new o.FormatError(
                        "Invalid XRef entry type: ".concat(g),
                      );
                  }
                  this.entries[p + r] || (this.entries[p + r] = v);
                }
                (i.entryNum = 0), (i.streamPos = t.pos), d.splice(0, 2);
              }
            },
            indexObjects: function XRef_indexObjects() {
              function readToken(t, r) {
                for (
                  var a = "", i = t[r];
                  10 !== i && 13 !== i && 60 !== i && !(++r >= t.length);

                )
                  (a += String.fromCharCode(i)), (i = t[r]);
                return a;
              }
              function skipUntil(t, r, a) {
                for (var i = a.length, o = t.length, l = 0; r < o; ) {
                  for (var c = 0; c < i && t[r + c] === a[c]; ) ++c;
                  if (c >= i) break;
                  r++, l++;
                }
                return l;
              }
              var t = /^(\d+)\s+(\d+)\s+obj\b/,
                r = /\bendobj[\b\s]$/,
                a = /\s+(\d+\s+\d+\s+obj[\b\s<])$/,
                i = new Uint8Array([116, 114, 97, 105, 108, 101, 114]),
                h = new Uint8Array([
                  115, 116, 97, 114, 116, 120, 114, 101, 102,
                ]),
                d = new Uint8Array([111, 98, 106]),
                p = new Uint8Array([47, 88, 82, 101, 102]);
              this.entries.length = 0;
              var m = this.stream;
              m.pos = 0;
              for (
                var g,
                  b,
                  y,
                  v = m.getBytes(),
                  S = m.start,
                  k = v.length,
                  w = [],
                  C = [];
                S < k;

              ) {
                var x = v[S];
                if (9 !== x && 10 !== x && 13 !== x && 32 !== x)
                  if (37 !== x) {
                    var _,
                      A = readToken(v, S);
                    if (
                      A.startsWith("xref") &&
                      (4 === A.length || /\s/.test(A[4]))
                    )
                      (S += skipUntil(v, S, i)),
                        w.push(S),
                        (S += skipUntil(v, S, h));
                    else if ((_ = t.exec(A))) {
                      var R = 0 | _[1],
                        T = 0 | _[2];
                      (this.entries[R] && this.entries[R].gen !== T) ||
                        (this.entries[R] = {
                          offset: S - m.start,
                          gen: T,
                          uncompressed: !0,
                        });
                      for (var I = void 0, P = S + A.length; P < v.length; ) {
                        var O = P + skipUntil(v, P, d) + 4;
                        I = O - S;
                        var E = Math.max(O - 25, P),
                          B = (0, o.bytesToString)(v.subarray(E, O));
                        if (r.test(B)) break;
                        var D = a.exec(B);
                        if (D && D[1]) {
                          (0, o.warn)(
                            'indexObjects: Found new "obj" inside of another "obj", caused by missing "endobj" -- trying to recover.',
                          ),
                            (I -= D[1].length);
                          break;
                        }
                        P = O;
                      }
                      var M = v.subarray(S, S + I),
                        L = skipUntil(M, 0, p);
                      L < I &&
                        M[L + 5] < 64 &&
                        (C.push(S - m.start), (this.xrefstms[S - m.start] = 1)),
                        (S += I);
                    } else
                      A.startsWith("trailer") &&
                      (7 === A.length || /\s/.test(A[7]))
                        ? (w.push(S), (S += skipUntil(v, S, h)))
                        : (S += A.length + 1);
                  } else
                    do {
                      if (++S >= k) break;
                      x = v[S];
                    } while (10 !== x && 13 !== x);
                else ++S;
              }
              for (g = 0, b = C.length; g < b; ++g)
                this.startXRefQueue.push(C[g]), this.readXRef(!0);
              for (g = 0, b = w.length; g < b; ++g) {
                m.pos = w[g];
                var N = new c.Parser({
                    lexer: new c.Lexer(m),
                    xref: this,
                    allowStreams: !0,
                    recoveryMode: !0,
                  }),
                  U = N.getObj();
                if ((0, l.isCmd)(U, "trailer")) {
                  var j = N.getObj();
                  if ((0, l.isDict)(j)) {
                    var q = void 0;
                    try {
                      q = j.get("Root");
                    } catch (t) {
                      if (t instanceof u.MissingDataException) throw t;
                      continue;
                    }
                    if ((0, l.isDict)(q) && q.has("Pages")) {
                      if (j.has("ID")) return j;
                      y = j;
                    }
                  }
                }
              }
              if (y) return y;
              throw new o.InvalidPDFException("Invalid PDF structure.");
            },
            readXRef: function XRef_readXRef(t) {
              var r = this.stream,
                a = Object.create(null);
              try {
                for (; this.startXRefQueue.length; ) {
                  var i = this.startXRefQueue[0];
                  if (a[i])
                    (0, o.warn)(
                      "readXRef - skipping XRef table since it was already parsed.",
                    ),
                      this.startXRefQueue.shift();
                  else {
                    (a[i] = !0), (r.pos = i + r.start);
                    var h,
                      d = new c.Parser({
                        lexer: new c.Lexer(r),
                        xref: this,
                        allowStreams: !0,
                      }),
                      p = d.getObj();
                    if ((0, l.isCmd)(p, "xref")) {
                      if (
                        ((h = this.processXRefTable(d)),
                        this.topDict || (this.topDict = h),
                        (p = h.get("XRefStm")),
                        Number.isInteger(p))
                      ) {
                        var m = p;
                        m in this.xrefstms ||
                          ((this.xrefstms[m] = 1), this.startXRefQueue.push(m));
                      }
                    } else {
                      if (!Number.isInteger(p))
                        throw new o.FormatError("Invalid XRef stream header");
                      if (
                        !Number.isInteger(d.getObj()) ||
                        !(0, l.isCmd)(d.getObj(), "obj") ||
                        !(0, l.isStream)((p = d.getObj()))
                      )
                        throw new o.FormatError("Invalid XRef stream");
                      if (
                        ((h = this.processXRefStream(p)),
                        this.topDict || (this.topDict = h),
                        !h)
                      )
                        throw new o.FormatError("Failed to read XRef stream");
                    }
                    (p = h.get("Prev")),
                      Number.isInteger(p)
                        ? this.startXRefQueue.push(p)
                        : (0, l.isRef)(p) && this.startXRefQueue.push(p.num),
                      this.startXRefQueue.shift();
                  }
                }
                return this.topDict;
              } catch (t) {
                if (t instanceof u.MissingDataException) throw t;
                (0, o.info)("(while reading XRef): " + t);
              }
              if (!t) throw new u.XRefParseException();
            },
            getEntry: function XRef_getEntry(t) {
              var r = this.entries[t];
              return r && !r.free && r.offset ? r : null;
            },
            fetchIfRef: function XRef_fetchIfRef(t, r) {
              return t instanceof l.Ref ? this.fetch(t, r) : t;
            },
            fetch: function XRef_fetch(t, r) {
              if (!(t instanceof l.Ref))
                throw new Error("ref object is not a reference");
              var a = t.num,
                i = this._cacheMap.get(a);
              if (void 0 !== i)
                return (
                  i instanceof l.Dict && !i.objId && (i.objId = t.toString()), i
                );
              var o = this.getEntry(a);
              return null === o
                ? (this._cacheMap.set(a, o), o)
                : ((o = o.uncompressed
                    ? this.fetchUncompressed(t, o, r)
                    : this.fetchCompressed(t, o, r)),
                  (0, l.isDict)(o)
                    ? (o.objId = t.toString())
                    : (0, l.isStream)(o) && (o.dict.objId = t.toString()),
                  o);
            },
            fetchUncompressed: function fetchUncompressed(t, r) {
              var a =
                  arguments.length > 2 &&
                  void 0 !== arguments[2] &&
                  arguments[2],
                i = t.gen,
                o = t.num;
              if (r.gen !== i)
                throw new u.XRefEntryException(
                  "Inconsistent generation in XRef: ".concat(t),
                );
              var h = this.stream.makeSubStream(r.offset + this.stream.start),
                d = new c.Parser({
                  lexer: new c.Lexer(h),
                  xref: this,
                  allowStreams: !0,
                }),
                p = d.getObj(),
                m = d.getObj(),
                g = d.getObj();
              if (p !== o || m !== i || !(g instanceof l.Cmd))
                throw new u.XRefEntryException(
                  "Bad (uncompressed) XRef entry: ".concat(t),
                );
              if ("obj" !== g.cmd) {
                if (
                  g.cmd.startsWith("obj") &&
                  ((o = parseInt(g.cmd.substring(3), 10)), !Number.isNaN(o))
                )
                  return o;
                throw new u.XRefEntryException(
                  "Bad (uncompressed) XRef entry: ".concat(t),
                );
              }
              return (
                (r =
                  this.encrypt && !a
                    ? d.getObj(this.encrypt.createCipherTransform(o, i))
                    : d.getObj()),
                (0, l.isStream)(r) || this._cacheMap.set(o, r),
                r
              );
            },
            fetchCompressed: function fetchCompressed(t, r) {
              var a = r.offset,
                i = this.fetch(l.Ref.get(a, 0));
              if (!(0, l.isStream)(i))
                throw new o.FormatError("bad ObjStm stream");
              var h = i.dict.get("First"),
                d = i.dict.get("N");
              if (!Number.isInteger(h) || !Number.isInteger(d))
                throw new o.FormatError(
                  "invalid first and n parameters for ObjStm stream",
                );
              for (
                var p = new c.Parser({
                    lexer: new c.Lexer(i),
                    xref: this,
                    allowStreams: !0,
                  }),
                  m = new Array(d),
                  g = 0;
                g < d;
                ++g
              ) {
                var b = p.getObj();
                if (!Number.isInteger(b))
                  throw new o.FormatError(
                    "invalid object number in the ObjStm stream: ".concat(b),
                  );
                var y = p.getObj();
                if (!Number.isInteger(y))
                  throw new o.FormatError(
                    "invalid object offset in the ObjStm stream: ".concat(y),
                  );
                m[g] = b;
              }
              for (var v = new Array(d), S = 0; S < d; ++S) {
                var k = p.getObj();
                if (
                  ((v[S] = k),
                  p.buf1 instanceof l.Cmd &&
                    "endobj" === p.buf1.cmd &&
                    p.shift(),
                  !(0, l.isStream)(k))
                ) {
                  var w = m[S],
                    C = this.entries[w];
                  C &&
                    C.offset === a &&
                    C.gen === S &&
                    this._cacheMap.set(w, k);
                }
              }
              if (void 0 === (r = v[r.gen]))
                throw new u.XRefEntryException(
                  "Bad (compressed) XRef entry: ".concat(t),
                );
              return r;
            },
            fetchIfRefAsync: function fetchIfRefAsync(t, r) {
              var a = this;
              return _asyncToGenerator(
                i.default.mark(function _callee() {
                  return i.default.wrap(function _callee$(i) {
                    for (;;)
                      switch ((i.prev = i.next)) {
                        case 0:
                          if (!(t instanceof l.Ref)) {
                            i.next = 2;
                            break;
                          }
                          return i.abrupt("return", a.fetchAsync(t, r));
                        case 2:
                          return i.abrupt("return", t);
                        case 3:
                        case "end":
                          return i.stop();
                      }
                  }, _callee);
                }),
              )();
            },
            fetchAsync: function fetchAsync(t, r) {
              var a = this;
              return _asyncToGenerator(
                i.default.mark(function _callee2() {
                  return i.default.wrap(
                    function _callee2$(i) {
                      for (;;)
                        switch ((i.prev = i.next)) {
                          case 0:
                            return (
                              (i.prev = 0), i.abrupt("return", a.fetch(t, r))
                            );
                          case 4:
                            if (
                              ((i.prev = 4),
                              (i.t0 = i.catch(0)),
                              i.t0 instanceof u.MissingDataException)
                            ) {
                              i.next = 8;
                              break;
                            }
                            throw i.t0;
                          case 8:
                            return (
                              (i.next = 10),
                              a.pdfManager.requestRange(i.t0.begin, i.t0.end)
                            );
                          case 10:
                            return i.abrupt("return", a.fetchAsync(t, r));
                          case 11:
                          case "end":
                            return i.stop();
                        }
                    },
                    _callee2,
                    null,
                    [[0, 4]],
                  );
                }),
              )();
            },
            getCatalogObj: function XRef_getCatalogObj() {
              return this.root;
            },
          }),
          XRef
        );
      })();
      r.XRef = g;
      var b = (function () {
          function NameOrNumberTree(t, r, a) {
            _classCallCheck(this, NameOrNumberTree),
              this.constructor === NameOrNumberTree &&
                (0, o.unreachable)("Cannot initialize NameOrNumberTree."),
              (this.root = t),
              (this.xref = r),
              (this._type = a);
          }
          return (
            _createClass(NameOrNumberTree, [
              {
                key: "getAll",
                value: function getAll() {
                  var t = Object.create(null);
                  if (!this.root) return t;
                  var r = this.xref,
                    a = new l.RefSet();
                  a.put(this.root);
                  for (var i = [this.root]; i.length > 0; ) {
                    var c = r.fetchIfRef(i.shift());
                    if ((0, l.isDict)(c))
                      if (c.has("Kids"))
                        for (
                          var u = c.get("Kids"), h = 0, d = u.length;
                          h < d;
                          h++
                        ) {
                          var p = u[h];
                          if (a.has(p))
                            throw new o.FormatError(
                              'Duplicate entry in "'.concat(
                                this._type,
                                '" tree.',
                              ),
                            );
                          i.push(p), a.put(p);
                        }
                      else {
                        var m = c.get(this._type);
                        if (Array.isArray(m))
                          for (var g = 0, b = m.length; g < b; g += 2)
                            t[r.fetchIfRef(m[g])] = r.fetchIfRef(m[g + 1]);
                      }
                  }
                  return t;
                },
              },
              {
                key: "get",
                value: function get(t) {
                  if (!this.root) return null;
                  for (
                    var r = this.xref, a = r.fetchIfRef(this.root), i = 0;
                    a.has("Kids");

                  ) {
                    if (++i > 10)
                      return (
                        (0, o.warn)(
                          'Search depth limit reached for "'.concat(
                            this._type,
                            '" tree.',
                          ),
                        ),
                        null
                      );
                    var l = a.get("Kids");
                    if (!Array.isArray(l)) return null;
                    for (var c = 0, u = l.length - 1; c <= u; ) {
                      var h = (c + u) >> 1,
                        d = r.fetchIfRef(l[h]).get("Limits");
                      if (t < r.fetchIfRef(d[0])) u = h - 1;
                      else {
                        if (!(t > r.fetchIfRef(d[1]))) {
                          a = r.fetchIfRef(l[h]);
                          break;
                        }
                        c = h + 1;
                      }
                    }
                    if (c > u) return null;
                  }
                  var p = a.get(this._type);
                  if (Array.isArray(p)) {
                    for (var m = 0, g = p.length - 2; m <= g; ) {
                      var b = (m + g) >> 1,
                        y = b + (1 & b),
                        v = r.fetchIfRef(p[y]);
                      if (t < v) g = y - 2;
                      else {
                        if (!(t > v)) return r.fetchIfRef(p[y + 1]);
                        m = y + 2;
                      }
                    }
                    (0, o.info)(
                      'Falling back to an exhaustive search, for key "'.concat(
                        t,
                        '", ',
                      ) + 'in "'.concat(this._type, '" tree.'),
                    );
                    for (var S = 0, k = p.length; S < k; S += 2) {
                      if (r.fetchIfRef(p[S]) === t)
                        return (
                          (0, o.warn)(
                            'The "'.concat(
                              t,
                              '" key was found at an incorrect, ',
                            ) +
                              'i.e. out-of-order, position in "'.concat(
                                this._type,
                                '" tree.',
                              ),
                          ),
                          r.fetchIfRef(p[S + 1])
                        );
                    }
                  }
                  return null;
                },
              },
            ]),
            NameOrNumberTree
          );
        })(),
        y = (function (t) {
          _inherits(NameTree, t);
          var r = _createSuper(NameTree);
          function NameTree(t, a) {
            return _classCallCheck(this, NameTree), r.call(this, t, a, "Names");
          }
          return NameTree;
        })(b),
        v = (function (t) {
          _inherits(NumberTree, t);
          var r = _createSuper(NumberTree);
          function NumberTree(t, a) {
            return (
              _classCallCheck(this, NumberTree), r.call(this, t, a, "Nums")
            );
          }
          return NumberTree;
        })(b),
        S = (function FileSpecClosure() {
          function FileSpec(t, r) {
            t &&
              (0, l.isDict)(t) &&
              ((this.xref = r),
              (this.root = t),
              t.has("FS") && (this.fs = t.get("FS")),
              (this.description = t.has("Desc")
                ? (0, o.stringToPDFString)(t.get("Desc"))
                : ""),
              t.has("RF") &&
                (0, o.warn)("Related file specifications are not supported"),
              (this.contentAvailable = !0),
              t.has("EF") ||
                ((this.contentAvailable = !1),
                (0, o.warn)(
                  "Non-embedded file specifications are not supported",
                )));
          }
          function pickPlatformItem(t) {
            return t.has("UF")
              ? t.get("UF")
              : t.has("F")
              ? t.get("F")
              : t.has("Unix")
              ? t.get("Unix")
              : t.has("Mac")
              ? t.get("Mac")
              : t.has("DOS")
              ? t.get("DOS")
              : null;
          }
          return (
            (FileSpec.prototype = {
              get filename() {
                if (!this._filename && this.root) {
                  var t = pickPlatformItem(this.root) || "unnamed";
                  this._filename = (0, o.stringToPDFString)(t)
                    .replace(/\\\\/g, "\\")
                    .replace(/\\\//g, "/")
                    .replace(/\\/g, "/");
                }
                return this._filename;
              },
              get content() {
                if (!this.contentAvailable) return null;
                !this.contentRef &&
                  this.root &&
                  (this.contentRef = pickPlatformItem(this.root.get("EF")));
                var t = null;
                if (this.contentRef) {
                  var r = this.xref.fetchIfRef(this.contentRef);
                  r && (0, l.isStream)(r)
                    ? (t = r.getBytes())
                    : (0, o.warn)(
                        "Embedded file specification points to non-existing/invalid content",
                      );
                } else
                  (0, o.warn)(
                    "Embedded file specification does not have a content",
                  );
                return t;
              },
              get serializable() {
                return { filename: this.filename, content: this.content };
              },
            }),
            FileSpec
          );
        })();
      r.FileSpec = S;
      var k = (function () {
        function mayHaveChildren(t) {
          return (
            t instanceof l.Ref ||
            t instanceof l.Dict ||
            Array.isArray(t) ||
            (0, l.isStream)(t)
          );
        }
        function addChildren(t, r) {
          if (t instanceof l.Dict || (0, l.isStream)(t))
            for (
              var a = t instanceof l.Dict ? t : t.dict,
                i = a.getKeys(),
                o = 0,
                c = i.length;
              o < c;
              o++
            ) {
              var u = a.getRaw(i[o]);
              mayHaveChildren(u) && r.push(u);
            }
          else if (Array.isArray(t))
            for (var h = 0, d = t.length; h < d; h++) {
              var p = t[h];
              mayHaveChildren(p) && r.push(p);
            }
        }
        function ObjectLoader(t, r, a) {
          (this.dict = t),
            (this.keys = r),
            (this.xref = a),
            (this.refSet = null);
        }
        return (
          (ObjectLoader.prototype = {
            load: function load() {
              var t = this;
              return _asyncToGenerator(
                i.default.mark(function _callee3() {
                  var r, a, o, c, u, h;
                  return i.default.wrap(function _callee3$(i) {
                    for (;;)
                      switch ((i.prev = i.next)) {
                        case 0:
                          if (
                            t.xref.stream.allChunksLoaded &&
                            !t.xref.stream.allChunksLoaded()
                          ) {
                            i.next = 2;
                            break;
                          }
                          return i.abrupt("return", void 0);
                        case 2:
                          for (
                            r = t.keys,
                              a = t.dict,
                              t.refSet = new l.RefSet(),
                              o = [],
                              c = 0,
                              u = r.length;
                            c < u;
                            c++
                          )
                            void 0 !== (h = a.getRaw(r[c])) && o.push(h);
                          return i.abrupt("return", t._walk(o));
                        case 7:
                        case "end":
                          return i.stop();
                      }
                  }, _callee3);
                }),
              )();
            },
            _walk: function _walk(t) {
              var r = this;
              return _asyncToGenerator(
                i.default.mark(function _callee4() {
                  var a, o, c, h, d, p, m, g, b, y, v;
                  return i.default.wrap(
                    function _callee4$(i) {
                      for (;;)
                        switch ((i.prev = i.next)) {
                          case 0:
                            (a = []), (o = []);
                          case 2:
                            if (!t.length) {
                              i.next = 22;
                              break;
                            }
                            if (!((c = t.pop()) instanceof l.Ref)) {
                              i.next = 18;
                              break;
                            }
                            if (!r.refSet.has(c)) {
                              i.next = 7;
                              break;
                            }
                            return i.abrupt("continue", 2);
                          case 7:
                            (i.prev = 7),
                              r.refSet.put(c),
                              (c = r.xref.fetch(c)),
                              (i.next = 18);
                            break;
                          case 12:
                            if (
                              ((i.prev = 12),
                              (i.t0 = i.catch(7)),
                              i.t0 instanceof u.MissingDataException)
                            ) {
                              i.next = 16;
                              break;
                            }
                            throw i.t0;
                          case 16:
                            a.push(c),
                              o.push({ begin: i.t0.begin, end: i.t0.end });
                          case 18:
                            if (c && c.getBaseStreams) {
                              for (
                                h = c.getBaseStreams(),
                                  d = !1,
                                  p = 0,
                                  m = h.length;
                                p < m;
                                p++
                              )
                                (g = h[p]).allChunksLoaded &&
                                  !g.allChunksLoaded() &&
                                  ((d = !0),
                                  o.push({ begin: g.start, end: g.end }));
                              d && a.push(c);
                            }
                            addChildren(c, t), (i.next = 2);
                            break;
                          case 22:
                            if (!o.length) {
                              i.next = 27;
                              break;
                            }
                            return (
                              (i.next = 25),
                              r.xref.stream.manager.requestRanges(o)
                            );
                          case 25:
                            for (b = 0, y = a.length; b < y; b++)
                              (v = a[b]) instanceof l.Ref && r.refSet.remove(v);
                            return i.abrupt("return", r._walk(a));
                          case 27:
                            return (
                              (r.refSet = null), i.abrupt("return", void 0)
                            );
                          case 29:
                          case "end":
                            return i.stop();
                        }
                    },
                    _callee4,
                    null,
                    [[7, 12]],
                  );
                }),
              )();
            },
          }),
          ObjectLoader
        );
      })();
      r.ObjectLoader = k;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.Parser = r.Linearization = r.Lexer = void 0);
      var i = a(205),
        o = a(5),
        l = a(198),
        c = a(201),
        u = a(206),
        h = a(208),
        d = a(211),
        p = a(213);
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      function computeAdler32(t) {
        for (var r = t.length, a = 1, i = 0, o = 0; o < r; ++o)
          i += a += 255 & t[o];
        return (i % 65521 << 16) | a % 65521;
      }
      var m = (function () {
        function Parser(t) {
          var r = t.lexer,
            a = t.xref,
            i = t.allowStreams,
            o = void 0 !== i && i,
            l = t.recoveryMode,
            c = void 0 !== l && l;
          _classCallCheck(this, Parser),
            (this.lexer = r),
            (this.xref = a),
            (this.allowStreams = o),
            (this.recoveryMode = c),
            (this.imageCache = Object.create(null)),
            this.refill();
        }
        return (
          _createClass(Parser, [
            {
              key: "refill",
              value: function refill() {
                (this.buf1 = this.lexer.getObj()),
                  (this.buf2 = this.lexer.getObj());
              },
            },
            {
              key: "shift",
              value: function shift() {
                this.buf2 instanceof l.Cmd && "ID" === this.buf2.cmd
                  ? ((this.buf1 = this.buf2), (this.buf2 = null))
                  : ((this.buf1 = this.buf2),
                    (this.buf2 = this.lexer.getObj()));
              },
            },
            {
              key: "tryShift",
              value: function tryShift() {
                try {
                  return this.shift(), !0;
                } catch (t) {
                  if (t instanceof c.MissingDataException) throw t;
                  return !1;
                }
              },
            },
            {
              key: "getObj",
              value: function getObj() {
                var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : null,
                  r = this.buf1;
                if ((this.shift(), r instanceof l.Cmd))
                  switch (r.cmd) {
                    case "BI":
                      return this.makeInlineImage(t);
                    case "[":
                      for (
                        var a = [];
                        !(0, l.isCmd)(this.buf1, "]") &&
                        !(0, l.isEOF)(this.buf1);

                      )
                        a.push(this.getObj(t));
                      if ((0, l.isEOF)(this.buf1)) {
                        if (!this.recoveryMode)
                          throw new o.FormatError("End of file inside array");
                        return a;
                      }
                      return this.shift(), a;
                    case "<<":
                      for (
                        var i = new l.Dict(this.xref);
                        !(0, l.isCmd)(this.buf1, ">>") &&
                        !(0, l.isEOF)(this.buf1);

                      )
                        if ((0, l.isName)(this.buf1)) {
                          var c = this.buf1.name;
                          if ((this.shift(), (0, l.isEOF)(this.buf1))) break;
                          i.set(c, this.getObj(t));
                        } else
                          (0, o.info)(
                            "Malformed dictionary: key must be a name object",
                          ),
                            this.shift();
                      if ((0, l.isEOF)(this.buf1)) {
                        if (!this.recoveryMode)
                          throw new o.FormatError(
                            "End of file inside dictionary",
                          );
                        return i;
                      }
                      return (0, l.isCmd)(this.buf2, "stream")
                        ? this.allowStreams
                          ? this.makeStream(i, t)
                          : i
                        : (this.shift(), i);
                    default:
                      return r;
                  }
                if (Number.isInteger(r)) {
                  if (
                    Number.isInteger(this.buf1) &&
                    (0, l.isCmd)(this.buf2, "R")
                  ) {
                    var u = l.Ref.get(r, this.buf1);
                    return this.shift(), this.shift(), u;
                  }
                  return r;
                }
                return "string" == typeof r && t ? t.decryptString(r) : r;
              },
            },
            {
              key: "findDefaultInlineStreamEnd",
              value: function findDefaultInlineStreamEnd(t) {
                for (var r, a, i = t.pos, l = 0; -1 !== (r = t.getByte()); )
                  if (0 === l) l = 69 === r ? 1 : 0;
                  else if (1 === l) l = 73 === r ? 2 : 0;
                  else if (
                    ((0, o.assert)(
                      2 === l,
                      "findDefaultInlineStreamEnd - invalid state.",
                    ),
                    32 === r || 10 === r || 13 === r)
                  ) {
                    a = t.pos;
                    for (
                      var u = t.peekBytes(10), h = 0, d = u.length;
                      h < d;
                      h++
                    )
                      if (
                        (0 !== (r = u[h]) || 0 === u[h + 1]) &&
                        10 !== r &&
                        13 !== r &&
                        (r < 32 || r > 127)
                      ) {
                        l = 0;
                        break;
                      }
                    if (2 === l) break;
                  } else l = 0;
                -1 === r &&
                  ((0, o.warn)(
                    "findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker",
                  ),
                  a &&
                    ((0, o.warn)(
                      '... trying to recover by using the last "EI" occurrence.',
                    ),
                    t.skip(-(t.pos - a))));
                var p = 4;
                return (
                  t.skip(-p),
                  (r = t.peekByte()),
                  t.skip(p),
                  (0, c.isWhiteSpace)(r) || p--,
                  t.pos - p - i
                );
              },
            },
            {
              key: "findDCTDecodeInlineStreamEnd",
              value: function findDCTDecodeInlineStreamEnd(t) {
                for (var r, a, i = t.pos, l = !1; -1 !== (r = t.getByte()); )
                  if (255 === r) {
                    switch (t.getByte()) {
                      case 0:
                        break;
                      case 255:
                        t.skip(-1);
                        break;
                      case 217:
                        l = !0;
                        break;
                      case 192:
                      case 193:
                      case 194:
                      case 195:
                      case 197:
                      case 198:
                      case 199:
                      case 201:
                      case 202:
                      case 203:
                      case 205:
                      case 206:
                      case 207:
                      case 196:
                      case 204:
                      case 218:
                      case 219:
                      case 220:
                      case 221:
                      case 222:
                      case 223:
                      case 224:
                      case 225:
                      case 226:
                      case 227:
                      case 228:
                      case 229:
                      case 230:
                      case 231:
                      case 232:
                      case 233:
                      case 234:
                      case 235:
                      case 236:
                      case 237:
                      case 238:
                      case 239:
                      case 254:
                        (a = t.getUint16()) > 2 ? t.skip(a - 2) : t.skip(-2);
                    }
                    if (l) break;
                  }
                var c = t.pos - i;
                return -1 === r
                  ? ((0, o.warn)(
                      "Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead.",
                    ),
                    t.skip(-c),
                    this.findDefaultInlineStreamEnd(t))
                  : (this.inlineStreamSkipEI(t), c);
              },
            },
            {
              key: "findASCII85DecodeInlineStreamEnd",
              value: function findASCII85DecodeInlineStreamEnd(t) {
                for (var r, a = t.pos; -1 !== (r = t.getByte()); )
                  if (126 === r) {
                    var i = t.pos;
                    for (r = t.peekByte(); (0, c.isWhiteSpace)(r); )
                      t.skip(), (r = t.peekByte());
                    if (62 === r) {
                      t.skip();
                      break;
                    }
                    if (t.pos > i) {
                      var l = t.peekBytes(2);
                      if (69 === l[0] && 73 === l[1]) break;
                    }
                  }
                var u = t.pos - a;
                return -1 === r
                  ? ((0, o.warn)(
                      "Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead.",
                    ),
                    t.skip(-u),
                    this.findDefaultInlineStreamEnd(t))
                  : (this.inlineStreamSkipEI(t), u);
              },
            },
            {
              key: "findASCIIHexDecodeInlineStreamEnd",
              value: function findASCIIHexDecodeInlineStreamEnd(t) {
                for (var r, a = t.pos; -1 !== (r = t.getByte()) && 62 !== r; );
                var i = t.pos - a;
                return -1 === r
                  ? ((0, o.warn)(
                      "Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead.",
                    ),
                    t.skip(-i),
                    this.findDefaultInlineStreamEnd(t))
                  : (this.inlineStreamSkipEI(t), i);
              },
            },
            {
              key: "inlineStreamSkipEI",
              value: function inlineStreamSkipEI(t) {
                for (var r, a = 0; -1 !== (r = t.getByte()); )
                  if (0 === a) a = 69 === r ? 1 : 0;
                  else if (1 === a) a = 73 === r ? 2 : 0;
                  else if (2 === a) break;
              },
            },
            {
              key: "makeInlineImage",
              value: function makeInlineImage(t) {
                for (
                  var r,
                    a = this.lexer,
                    i = a.stream,
                    c = new l.Dict(this.xref);
                  !(0, l.isCmd)(this.buf1, "ID") && !(0, l.isEOF)(this.buf1);

                ) {
                  if (!(0, l.isName)(this.buf1))
                    throw new o.FormatError(
                      "Dictionary key must be a name object",
                    );
                  var u = this.buf1.name;
                  if ((this.shift(), (0, l.isEOF)(this.buf1))) break;
                  c.set(u, this.getObj(t));
                }
                -1 !== a.beginInlineImagePos &&
                  (r = i.pos - a.beginInlineImagePos);
                var h,
                  d = c.get("Filter", "F");
                if ((0, l.isName)(d)) h = d.name;
                else if (Array.isArray(d)) {
                  var p = this.xref.fetchIfRef(d[0]);
                  (0, l.isName)(p) && (h = p.name);
                }
                var m,
                  g = i.pos;
                m =
                  "DCTDecode" === h || "DCT" === h
                    ? this.findDCTDecodeInlineStreamEnd(i)
                    : "ASCII85Decode" === h || "A85" === h
                    ? this.findASCII85DecodeInlineStreamEnd(i)
                    : "ASCIIHexDecode" === h || "AHx" === h
                    ? this.findASCIIHexDecodeInlineStreamEnd(i)
                    : this.findDefaultInlineStreamEnd(i);
                var b,
                  y = i.makeSubStream(g, m, c);
                if (m < 1e3 && r < 5552) {
                  var v = y.getBytes();
                  y.reset();
                  var S = i.pos;
                  i.pos = a.beginInlineImagePos;
                  var k = i.getBytes(r);
                  (i.pos = S),
                    (b = computeAdler32(v) + "_" + computeAdler32(k));
                  var w = this.imageCache[b];
                  if (void 0 !== w)
                    return (
                      (this.buf2 = l.Cmd.get("EI")), this.shift(), w.reset(), w
                    );
                }
                return (
                  t && (y = t.createStream(y, m)),
                  ((y = this.filter(y, c, m)).dict = c),
                  void 0 !== b &&
                    ((y.cacheKey = "inline_".concat(m, "_").concat(b)),
                    (this.imageCache[b] = y)),
                  (this.buf2 = l.Cmd.get("EI")),
                  this.shift(),
                  y
                );
              },
            },
            {
              key: "_findStreamLength",
              value: function _findStreamLength(t, r) {
                var a = this.lexer.stream;
                a.pos = t;
                for (var i = r.length; a.pos < a.end; ) {
                  var o = a.peekBytes(2048),
                    l = o.length - i;
                  if (l <= 0) break;
                  for (var c = 0; c < l; ) {
                    for (var u = 0; u < i && o[c + u] === r[u]; ) u++;
                    if (u >= i) return (a.pos += c), a.pos - t;
                    c++;
                  }
                  a.pos += l;
                }
                return -1;
              },
            },
            {
              key: "makeStream",
              value: function makeStream(t, r) {
                var a = this.lexer,
                  i = a.stream;
                a.skipToNextLine();
                var u = i.pos - 1,
                  h = t.get("Length");
                if (
                  (Number.isInteger(h) ||
                    ((0, o.info)('Bad length "'.concat(h, '" in stream')),
                    (h = 0)),
                  (i.pos = u + h),
                  a.nextChar(),
                  this.tryShift() && (0, l.isCmd)(this.buf2, "endstream"))
                )
                  this.shift();
                else {
                  var d = new Uint8Array([
                      101, 110, 100, 115, 116, 114, 101, 97, 109,
                    ]),
                    p = this._findStreamLength(u, d);
                  if (p < 0) {
                    for (var m = 1; m <= 1; m++) {
                      var g = d.length - m,
                        b = d.slice(0, g),
                        y = this._findStreamLength(u, b);
                      if (y >= 0) {
                        var v = i.peekBytes(g + 1)[g];
                        if (!(0, c.isWhiteSpace)(v)) break;
                        (0, o.info)(
                          'Found "'.concat((0, o.bytesToString)(b), '" when ') +
                            "searching for endstream command.",
                        ),
                          (p = y);
                        break;
                      }
                    }
                    if (p < 0)
                      throw new o.FormatError("Missing endstream command.");
                  }
                  (h = p), a.nextChar(), this.shift(), this.shift();
                }
                return (
                  this.shift(),
                  (i = i.makeSubStream(u, h, t)),
                  r && (i = r.createStream(i, h)),
                  ((i = this.filter(i, t, h)).dict = t),
                  i
                );
              },
            },
            {
              key: "filter",
              value: function filter(t, r, a) {
                var filter = r.get("Filter", "F"),
                  i = r.get("DecodeParms", "DP");
                if ((0, l.isName)(filter))
                  return (
                    Array.isArray(i) &&
                      (0, o.warn)(
                        "/DecodeParms should not contain an Array, when /Filter contains a Name.",
                      ),
                    this.makeFilter(t, filter.name, a, i)
                  );
                var c = a;
                if (Array.isArray(filter))
                  for (var u = filter, h = i, d = 0, p = u.length; d < p; ++d) {
                    if (
                      ((filter = this.xref.fetchIfRef(u[d])),
                      !(0, l.isName)(filter))
                    )
                      throw new o.FormatError(
                        'Bad filter name "'.concat(filter, '"'),
                      );
                    (i = null),
                      Array.isArray(h) &&
                        d in h &&
                        (i = this.xref.fetchIfRef(h[d])),
                      (t = this.makeFilter(t, filter.name, c, i)),
                      (c = null);
                  }
                return t;
              },
            },
            {
              key: "makeFilter",
              value: function makeFilter(t, r, a, l) {
                if (0 === a)
                  return (
                    (0, o.warn)('Empty "'.concat(r, '" stream.')),
                    new i.NullStream()
                  );
                try {
                  var m = this.xref.stats.streamTypes;
                  if ("FlateDecode" === r || "Fl" === r)
                    return (
                      (m[o.StreamType.FLATE] = !0),
                      l
                        ? new i.PredictorStream(new i.FlateStream(t, a), a, l)
                        : new i.FlateStream(t, a)
                    );
                  if ("LZWDecode" === r || "LZW" === r) {
                    m[o.StreamType.LZW] = !0;
                    var g = 1;
                    return l
                      ? (l.has("EarlyChange") && (g = l.get("EarlyChange")),
                        new i.PredictorStream(new i.LZWStream(t, a, g), a, l))
                      : new i.LZWStream(t, a, g);
                  }
                  return "DCTDecode" === r || "DCT" === r
                    ? ((m[o.StreamType.DCT] = !0),
                      new d.JpegStream(t, a, t.dict, l))
                    : "JPXDecode" === r || "JPX" === r
                    ? ((m[o.StreamType.JPX] = !0),
                      new p.JpxStream(t, a, t.dict, l))
                    : "ASCII85Decode" === r || "A85" === r
                    ? ((m[o.StreamType.A85] = !0), new i.Ascii85Stream(t, a))
                    : "ASCIIHexDecode" === r || "AHx" === r
                    ? ((m[o.StreamType.AHX] = !0), new i.AsciiHexStream(t, a))
                    : "CCITTFaxDecode" === r || "CCF" === r
                    ? ((m[o.StreamType.CCF] = !0),
                      new u.CCITTFaxStream(t, a, l))
                    : "RunLengthDecode" === r || "RL" === r
                    ? ((m[o.StreamType.RLX] = !0), new i.RunLengthStream(t, a))
                    : "JBIG2Decode" === r
                    ? ((m[o.StreamType.JBIG] = !0),
                      new h.Jbig2Stream(t, a, t.dict, l))
                    : ((0, o.warn)('Filter "'.concat(r, '" is not supported.')),
                      t);
                } catch (t) {
                  if (t instanceof c.MissingDataException) throw t;
                  return (
                    (0, o.warn)('Invalid stream: "'.concat(t, '"')),
                    new i.NullStream()
                  );
                }
              },
            },
          ]),
          Parser
        );
      })();
      r.Parser = m;
      var g = [
        1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ];
      function toHexDigit(t) {
        return t >= 48 && t <= 57
          ? 15 & t
          : (t >= 65 && t <= 70) || (t >= 97 && t <= 102)
          ? 9 + (15 & t)
          : -1;
      }
      var b = (function () {
        function Lexer(t) {
          var r =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : null;
          _classCallCheck(this, Lexer),
            (this.stream = t),
            this.nextChar(),
            (this.strBuf = []),
            (this.knownCommands = r),
            (this._hexStringNumWarn = 0),
            (this.beginInlineImagePos = -1);
        }
        return (
          _createClass(Lexer, [
            {
              key: "nextChar",
              value: function nextChar() {
                return (this.currentChar = this.stream.getByte());
              },
            },
            {
              key: "peekChar",
              value: function peekChar() {
                return this.stream.peekByte();
              },
            },
            {
              key: "getNumber",
              value: function getNumber() {
                var t = this.currentChar,
                  r = !1,
                  a = 0,
                  i = 0;
                if (
                  (45 === t
                    ? ((i = -1),
                      45 === (t = this.nextChar()) && (t = this.nextChar()))
                    : 43 === t && ((i = 1), (t = this.nextChar())),
                  10 === t || 13 === t)
                )
                  do {
                    t = this.nextChar();
                  } while (10 === t || 13 === t);
                if (
                  (46 === t && ((a = 10), (t = this.nextChar())),
                  t < 48 || t > 57)
                ) {
                  if (
                    10 === a &&
                    0 === i &&
                    ((0, c.isWhiteSpace)(t) || -1 === t)
                  )
                    return (
                      (0, o.warn)(
                        "Lexer.getNumber - treating a single decimal point as zero.",
                      ),
                      0
                    );
                  throw new o.FormatError(
                    "Invalid number: "
                      .concat(String.fromCharCode(t), " (charCode ")
                      .concat(t, ")"),
                  );
                }
                i = i || 1;
                for (var l = t - 48, u = 0, h = 1; (t = this.nextChar()) >= 0; )
                  if (t >= 48 && t <= 57) {
                    var d = t - 48;
                    r
                      ? (u = 10 * u + d)
                      : (0 !== a && (a *= 10), (l = 10 * l + d));
                  } else if (46 === t) {
                    if (0 !== a) break;
                    a = 1;
                  } else if (45 === t)
                    (0, o.warn)(
                      "Badly formatted number: minus sign in the middle",
                    );
                  else {
                    if (69 !== t && 101 !== t) break;
                    if (43 === (t = this.peekChar()) || 45 === t)
                      (h = 45 === t ? -1 : 1), this.nextChar();
                    else if (t < 48 || t > 57) break;
                    r = !0;
                  }
                return (
                  0 !== a && (l /= a), r && (l *= Math.pow(10, h * u)), i * l
                );
              },
            },
            {
              key: "getString",
              value: function getString() {
                var t = 1,
                  r = !1,
                  a = this.strBuf;
                a.length = 0;
                for (var i = this.nextChar(); ; ) {
                  var l = !1;
                  switch (0 | i) {
                    case -1:
                      (0, o.warn)("Unterminated string"), (r = !0);
                      break;
                    case 40:
                      ++t, a.push("(");
                      break;
                    case 41:
                      0 == --t ? (this.nextChar(), (r = !0)) : a.push(")");
                      break;
                    case 92:
                      switch ((i = this.nextChar())) {
                        case -1:
                          (0, o.warn)("Unterminated string"), (r = !0);
                          break;
                        case 110:
                          a.push("\n");
                          break;
                        case 114:
                          a.push("\r");
                          break;
                        case 116:
                          a.push("\t");
                          break;
                        case 98:
                          a.push("\b");
                          break;
                        case 102:
                          a.push("\f");
                          break;
                        case 92:
                        case 40:
                        case 41:
                          a.push(String.fromCharCode(i));
                          break;
                        case 48:
                        case 49:
                        case 50:
                        case 51:
                        case 52:
                        case 53:
                        case 54:
                        case 55:
                          var c = 15 & i;
                          (l = !0),
                            (i = this.nextChar()) >= 48 &&
                              i <= 55 &&
                              ((c = (c << 3) + (15 & i)),
                              (i = this.nextChar()) >= 48 &&
                                i <= 55 &&
                                ((l = !1), (c = (c << 3) + (15 & i)))),
                            a.push(String.fromCharCode(c));
                          break;
                        case 13:
                          10 === this.peekChar() && this.nextChar();
                          break;
                        case 10:
                          break;
                        default:
                          a.push(String.fromCharCode(i));
                      }
                      break;
                    default:
                      a.push(String.fromCharCode(i));
                  }
                  if (r) break;
                  l || (i = this.nextChar());
                }
                return a.join("");
              },
            },
            {
              key: "getName",
              value: function getName() {
                var t,
                  r,
                  a = this.strBuf;
                for (a.length = 0; (t = this.nextChar()) >= 0 && !g[t]; )
                  if (35 === t) {
                    if (((t = this.nextChar()), g[t])) {
                      (0, o.warn)(
                        "Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number.",
                      ),
                        a.push("#");
                      break;
                    }
                    var i = toHexDigit(t);
                    if (-1 !== i) {
                      r = t;
                      var c = toHexDigit((t = this.nextChar()));
                      if (-1 === c) {
                        if (
                          ((0, o.warn)(
                            "Lexer_getName: Illegal digit (".concat(
                              String.fromCharCode(t),
                              ") ",
                            ) + "in hexadecimal number.",
                          ),
                          a.push("#", String.fromCharCode(r)),
                          g[t])
                        )
                          break;
                        a.push(String.fromCharCode(t));
                        continue;
                      }
                      a.push(String.fromCharCode((i << 4) | c));
                    } else a.push("#", String.fromCharCode(t));
                  } else a.push(String.fromCharCode(t));
                return (
                  a.length > 127 &&
                    (0, o.warn)(
                      "Name token is longer than allowed by the spec: ".concat(
                        a.length,
                      ),
                    ),
                  l.Name.get(a.join(""))
                );
              },
            },
            {
              key: "_hexStringWarn",
              value: function _hexStringWarn(t) {
                5 != this._hexStringNumWarn++
                  ? this._hexStringNumWarn > 5 ||
                    (0, o.warn)(
                      "getHexString - ignoring invalid character: ".concat(t),
                    )
                  : (0, o.warn)(
                      "getHexString - ignoring additional invalid characters.",
                    );
              },
            },
            {
              key: "getHexString",
              value: function getHexString() {
                var t = this.strBuf;
                t.length = 0;
                var r,
                  a,
                  i = this.currentChar,
                  l = !0;
                for (this._hexStringNumWarn = 0; ; ) {
                  if (i < 0) {
                    (0, o.warn)("Unterminated hex string");
                    break;
                  }
                  if (62 === i) {
                    this.nextChar();
                    break;
                  }
                  if (1 !== g[i]) {
                    if (l) {
                      if (-1 === (r = toHexDigit(i))) {
                        this._hexStringWarn(i), (i = this.nextChar());
                        continue;
                      }
                    } else {
                      if (-1 === (a = toHexDigit(i))) {
                        this._hexStringWarn(i), (i = this.nextChar());
                        continue;
                      }
                      t.push(String.fromCharCode((r << 4) | a));
                    }
                    (l = !l), (i = this.nextChar());
                  } else i = this.nextChar();
                }
                return t.join("");
              },
            },
            {
              key: "getObj",
              value: function getObj() {
                for (var t = !1, r = this.currentChar; ; ) {
                  if (r < 0) return l.EOF;
                  if (t) (10 !== r && 13 !== r) || (t = !1);
                  else if (37 === r) t = !0;
                  else if (1 !== g[r]) break;
                  r = this.nextChar();
                }
                switch (0 | r) {
                  case 48:
                  case 49:
                  case 50:
                  case 51:
                  case 52:
                  case 53:
                  case 54:
                  case 55:
                  case 56:
                  case 57:
                  case 43:
                  case 45:
                  case 46:
                    return this.getNumber();
                  case 40:
                    return this.getString();
                  case 47:
                    return this.getName();
                  case 91:
                    return this.nextChar(), l.Cmd.get("[");
                  case 93:
                    return this.nextChar(), l.Cmd.get("]");
                  case 60:
                    return 60 === (r = this.nextChar())
                      ? (this.nextChar(), l.Cmd.get("<<"))
                      : this.getHexString();
                  case 62:
                    return 62 === (r = this.nextChar())
                      ? (this.nextChar(), l.Cmd.get(">>"))
                      : l.Cmd.get(">");
                  case 123:
                    return this.nextChar(), l.Cmd.get("{");
                  case 125:
                    return this.nextChar(), l.Cmd.get("}");
                  case 41:
                    throw (
                      (this.nextChar(),
                      new o.FormatError("Illegal character: ".concat(r)))
                    );
                }
                for (
                  var a = String.fromCharCode(r),
                    i = this.knownCommands,
                    c = i && void 0 !== i[a];
                  (r = this.nextChar()) >= 0 && !g[r];

                ) {
                  var u = a + String.fromCharCode(r);
                  if (c && void 0 === i[u]) break;
                  if (128 === a.length)
                    throw new o.FormatError(
                      "Command token too long: ".concat(a.length),
                    );
                  (a = u), (c = i && void 0 !== i[a]);
                }
                return (
                  "true" === a ||
                  ("false" !== a &&
                    ("null" === a
                      ? null
                      : ("BI" === a &&
                          (this.beginInlineImagePos = this.stream.pos),
                        l.Cmd.get(a))))
                );
              },
            },
            {
              key: "skipToNextLine",
              value: function skipToNextLine() {
                for (var t = this.currentChar; t >= 0; ) {
                  if (13 === t) {
                    10 === (t = this.nextChar()) && this.nextChar();
                    break;
                  }
                  if (10 === t) {
                    this.nextChar();
                    break;
                  }
                  t = this.nextChar();
                }
              },
            },
          ]),
          Lexer
        );
      })();
      r.Lexer = b;
      var y = (function () {
        function Linearization() {
          _classCallCheck(this, Linearization);
        }
        return (
          _createClass(Linearization, null, [
            {
              key: "create",
              value: function create(t) {
                function getInt(t, r) {
                  var a =
                      arguments.length > 2 &&
                      void 0 !== arguments[2] &&
                      arguments[2],
                    i = t.get(r);
                  if (Number.isInteger(i) && (a ? i >= 0 : i > 0)) return i;
                  throw new Error(
                    'The "'.concat(r, '" parameter in the linearization ') +
                      "dictionary is invalid.",
                  );
                }
                var r,
                  a,
                  i = new m({ lexer: new b(t), xref: null }),
                  c = i.getObj(),
                  u = i.getObj(),
                  h = i.getObj(),
                  d = i.getObj();
                if (
                  !(
                    Number.isInteger(c) &&
                    Number.isInteger(u) &&
                    (0, l.isCmd)(h, "obj") &&
                    (0, l.isDict)(d) &&
                    (0, o.isNum)((r = d.get("Linearized"))) &&
                    r > 0
                  )
                )
                  return null;
                if ((a = getInt(d, "L")) !== t.length)
                  throw new Error(
                    'The "L" parameter in the linearization dictionary does not equal the stream length.',
                  );
                return {
                  length: a,
                  hints: (function getHints(t) {
                    var r,
                      a = t.get("H");
                    if (Array.isArray(a) && (2 === (r = a.length) || 4 === r)) {
                      for (var i = 0; i < r; i++) {
                        var o = a[i];
                        if (!(Number.isInteger(o) && o > 0))
                          throw new Error(
                            "Hint (".concat(
                              i,
                              ") in the linearization dictionary is invalid.",
                            ),
                          );
                      }
                      return a;
                    }
                    throw new Error(
                      "Hint array in the linearization dictionary is invalid.",
                    );
                  })(d),
                  objectNumberFirst: getInt(d, "O"),
                  endFirst: getInt(d, "E"),
                  numPages: getInt(d, "N"),
                  mainXRefEntriesOffset: getInt(d, "T"),
                  pageFirst: d.has("P") ? getInt(d, "P", !0) : 0,
                };
              },
            },
          ]),
          Linearization
        );
      })();
      r.Linearization = y;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.LZWStream =
          r.StringStream =
          r.StreamsSequenceStream =
          r.Stream =
          r.RunLengthStream =
          r.PredictorStream =
          r.NullStream =
          r.FlateStream =
          r.DecodeStream =
          r.DecryptStream =
          r.AsciiHexStream =
          r.Ascii85Stream =
            void 0);
      var i = a(5),
        o = a(198),
        l = a(201);
      function _toConsumableArray(t) {
        return (
          (function _arrayWithoutHoles(t) {
            if (Array.isArray(t)) return _arrayLikeToArray(t);
          })(t) ||
          (function _iterableToArray(t) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(t))
              return Array.from(t);
          })(t) ||
          (function _unsupportedIterableToArray(t, r) {
            if (!t) return;
            if ("string" == typeof t) return _arrayLikeToArray(t, r);
            var a = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === a && t.constructor && (a = t.constructor.name);
            if ("Map" === a || "Set" === a) return Array.from(t);
            if (
              "Arguments" === a ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
            )
              return _arrayLikeToArray(t, r);
          })(t) ||
          (function _nonIterableSpread() {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function _arrayLikeToArray(t, r) {
        (null == r || r > t.length) && (r = t.length);
        for (var a = 0, i = new Array(r); a < r; a++) i[a] = t[a];
        return i;
      }
      var c = (function StreamClosure() {
        function Stream(t, r, a, i) {
          (this.bytes = t instanceof Uint8Array ? t : new Uint8Array(t)),
            (this.start = r || 0),
            (this.pos = this.start),
            (this.end = r + a || this.bytes.length),
            (this.dict = i);
        }
        return (
          (Stream.prototype = {
            get length() {
              return this.end - this.start;
            },
            get isEmpty() {
              return 0 === this.length;
            },
            getByte: function Stream_getByte() {
              return this.pos >= this.end ? -1 : this.bytes[this.pos++];
            },
            getUint16: function Stream_getUint16() {
              var t = this.getByte(),
                r = this.getByte();
              return -1 === t || -1 === r ? -1 : (t << 8) + r;
            },
            getInt32: function Stream_getInt32() {
              return (
                (this.getByte() << 24) +
                (this.getByte() << 16) +
                (this.getByte() << 8) +
                this.getByte()
              );
            },
            getBytes: function getBytes(t) {
              var r =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                a = this.bytes,
                i = this.pos,
                o = this.end;
              if (!t) {
                var l = a.subarray(i, o);
                return r ? new Uint8ClampedArray(l) : l;
              }
              var c = i + t;
              c > o && (c = o), (this.pos = c);
              var u = a.subarray(i, c);
              return r ? new Uint8ClampedArray(u) : u;
            },
            peekByte: function Stream_peekByte() {
              var t = this.getByte();
              return -1 !== t && this.pos--, t;
            },
            peekBytes: function peekBytes(t) {
              var r =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                a = this.getBytes(t, r);
              return (this.pos -= a.length), a;
            },
            getByteRange: function getByteRange(t, r) {
              return (
                t < 0 && (t = 0),
                r > this.end && (r = this.end),
                this.bytes.subarray(t, r)
              );
            },
            skip: function Stream_skip(t) {
              t || (t = 1), (this.pos += t);
            },
            reset: function Stream_reset() {
              this.pos = this.start;
            },
            moveStart: function Stream_moveStart() {
              this.start = this.pos;
            },
            makeSubStream: function Stream_makeSubStream(t, r, a) {
              return new Stream(this.bytes.buffer, t, r, a);
            },
          }),
          Stream
        );
      })();
      r.Stream = c;
      var u = (function StringStreamClosure() {
        function StringStream(t) {
          var r = (0, i.stringToBytes)(t);
          c.call(this, r);
        }
        return (StringStream.prototype = c.prototype), StringStream;
      })();
      r.StringStream = u;
      var h = (function DecodeStreamClosure() {
        var t = new Uint8Array(0);
        function DecodeStream(r) {
          if (
            ((this._rawMinBufferLength = r || 0),
            (this.pos = 0),
            (this.bufferLength = 0),
            (this.eof = !1),
            (this.buffer = t),
            (this.minBufferLength = 512),
            r)
          )
            for (; this.minBufferLength < r; ) this.minBufferLength *= 2;
        }
        return (
          (DecodeStream.prototype = {
            get isEmpty() {
              for (; !this.eof && 0 === this.bufferLength; ) this.readBlock();
              return 0 === this.bufferLength;
            },
            ensureBuffer: function DecodeStream_ensureBuffer(t) {
              var r = this.buffer;
              if (t <= r.byteLength) return r;
              for (var a = this.minBufferLength; a < t; ) a *= 2;
              var i = new Uint8Array(a);
              return i.set(r), (this.buffer = i);
            },
            getByte: function DecodeStream_getByte() {
              for (var t = this.pos; this.bufferLength <= t; ) {
                if (this.eof) return -1;
                this.readBlock();
              }
              return this.buffer[this.pos++];
            },
            getUint16: function DecodeStream_getUint16() {
              var t = this.getByte(),
                r = this.getByte();
              return -1 === t || -1 === r ? -1 : (t << 8) + r;
            },
            getInt32: function DecodeStream_getInt32() {
              return (
                (this.getByte() << 24) +
                (this.getByte() << 16) +
                (this.getByte() << 8) +
                this.getByte()
              );
            },
            getBytes: function getBytes(t) {
              var r,
                a =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                i = this.pos;
              if (t) {
                for (
                  this.ensureBuffer(i + t), r = i + t;
                  !this.eof && this.bufferLength < r;

                )
                  this.readBlock();
                var o = this.bufferLength;
                r > o && (r = o);
              } else {
                for (; !this.eof; ) this.readBlock();
                r = this.bufferLength;
              }
              this.pos = r;
              var l = this.buffer.subarray(i, r);
              return !a || l instanceof Uint8ClampedArray
                ? l
                : new Uint8ClampedArray(l);
            },
            peekByte: function DecodeStream_peekByte() {
              var t = this.getByte();
              return -1 !== t && this.pos--, t;
            },
            peekBytes: function peekBytes(t) {
              var r =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                a = this.getBytes(t, r);
              return (this.pos -= a.length), a;
            },
            makeSubStream: function DecodeStream_makeSubStream(t, r, a) {
              for (var i = t + r; this.bufferLength <= i && !this.eof; )
                this.readBlock();
              return new c(this.buffer, t, r, a);
            },
            getByteRange: function getByteRange(t, r) {
              (0, i.unreachable)("Should not call DecodeStream.getByteRange");
            },
            skip: function DecodeStream_skip(t) {
              t || (t = 1), (this.pos += t);
            },
            reset: function DecodeStream_reset() {
              this.pos = 0;
            },
            getBaseStreams: function DecodeStream_getBaseStreams() {
              return this.str && this.str.getBaseStreams
                ? this.str.getBaseStreams()
                : [];
            },
          }),
          DecodeStream
        );
      })();
      r.DecodeStream = h;
      var d = (function StreamsSequenceStreamClosure() {
        function StreamsSequenceStream(t) {
          this.streams = t;
          for (var r = 0, a = 0, i = t.length; a < i; a++) {
            var o = t[a];
            r += o instanceof h ? o._rawMinBufferLength : o.length;
          }
          h.call(this, r);
        }
        return (
          (StreamsSequenceStream.prototype = Object.create(h.prototype)),
          (StreamsSequenceStream.prototype.readBlock =
            function streamSequenceStreamReadBlock() {
              var t = this.streams;
              if (0 !== t.length) {
                var r = t.shift().getBytes(),
                  a = this.bufferLength,
                  i = a + r.length;
                this.ensureBuffer(i).set(r, a), (this.bufferLength = i);
              } else this.eof = !0;
            }),
          (StreamsSequenceStream.prototype.getBaseStreams =
            function StreamsSequenceStream_getBaseStreams() {
              for (var t = [], r = 0, a = this.streams.length; r < a; r++) {
                var i = this.streams[r];
                i.getBaseStreams &&
                  t.push.apply(t, _toConsumableArray(i.getBaseStreams()));
              }
              return t;
            }),
          StreamsSequenceStream
        );
      })();
      r.StreamsSequenceStream = d;
      var p = (function FlateStreamClosure() {
        var t = new Int32Array([
            16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
          ]),
          r = new Int32Array([
            3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095,
            131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227,
            262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258,
          ]),
          a = new Int32Array([
            1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177,
            262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801,
            525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625,
            798721, 868353, 876545,
          ]),
          o = [
            new Int32Array([
              459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016,
              459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048,
              459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032,
              459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064,
              459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024,
              459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056,
              459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040,
              459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072,
              459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020,
              459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052,
              459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036,
              459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068,
              459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028,
              459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060,
              459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044,
              459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076,
              459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018,
              459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050,
              459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034,
              459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066,
              459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026,
              459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058,
              459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042,
              459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074,
              459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022,
              459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054,
              459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038,
              459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070,
              459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030,
              459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062,
              459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046,
              459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078,
              459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017,
              459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049,
              459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033,
              459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065,
              459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025,
              459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057,
              459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041,
              459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073,
              459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021,
              459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053,
              459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037,
              459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069,
              459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029,
              459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061,
              459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045,
              459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077,
              459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019,
              459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051,
              459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035,
              459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067,
              459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027,
              459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059,
              459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043,
              459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075,
              459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023,
              459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055,
              459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039,
              459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071,
              459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031,
              459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063,
              459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047,
              459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079,
            ]),
            9,
          ],
          l = [
            new Int32Array([
              327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708,
              327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681,
              327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683,
              327699, 327691, 327707, 327687, 327703, 327695, 0,
            ]),
            5,
          ];
        function FlateStream(t, r) {
          (this.str = t), (this.dict = t.dict);
          var a = t.getByte(),
            o = t.getByte();
          if (-1 === a || -1 === o)
            throw new i.FormatError(
              "Invalid header in flate stream: ".concat(a, ", ").concat(o),
            );
          if (8 != (15 & a))
            throw new i.FormatError(
              "Unknown compression method in flate stream: "
                .concat(a, ", ")
                .concat(o),
            );
          if (((a << 8) + o) % 31 != 0)
            throw new i.FormatError(
              "Bad FCHECK in flate stream: ".concat(a, ", ").concat(o),
            );
          if (32 & o)
            throw new i.FormatError(
              "FDICT bit set in flate stream: ".concat(a, ", ").concat(o),
            );
          (this.codeSize = 0), (this.codeBuf = 0), h.call(this, r);
        }
        return (
          (FlateStream.prototype = Object.create(h.prototype)),
          (FlateStream.prototype.getBits = function FlateStream_getBits(t) {
            for (
              var r, a = this.str, o = this.codeSize, l = this.codeBuf;
              o < t;

            ) {
              if (-1 === (r = a.getByte()))
                throw new i.FormatError("Bad encoding in flate stream");
              (l |= r << o), (o += 8);
            }
            return (
              (r = l & ((1 << t) - 1)),
              (this.codeBuf = l >> t),
              (this.codeSize = o -= t),
              r
            );
          }),
          (FlateStream.prototype.getCode = function FlateStream_getCode(t) {
            for (
              var r,
                a = this.str,
                o = t[0],
                l = t[1],
                c = this.codeSize,
                u = this.codeBuf;
              c < l && -1 !== (r = a.getByte());

            )
              (u |= r << c), (c += 8);
            var h = o[u & ((1 << l) - 1)],
              d = h >> 16,
              p = 65535 & h;
            if (d < 1 || c < d)
              throw new i.FormatError("Bad encoding in flate stream");
            return (this.codeBuf = u >> d), (this.codeSize = c - d), p;
          }),
          (FlateStream.prototype.generateHuffmanTable =
            function flateStreamGenerateHuffmanTable(t) {
              var r,
                a = t.length,
                i = 0;
              for (r = 0; r < a; ++r) t[r] > i && (i = t[r]);
              for (
                var o = 1 << i, l = new Int32Array(o), c = 1, u = 0, h = 2;
                c <= i;
                ++c, u <<= 1, h <<= 1
              )
                for (var d = 0; d < a; ++d)
                  if (t[d] === c) {
                    var p = 0,
                      m = u;
                    for (r = 0; r < c; ++r) (p = (p << 1) | (1 & m)), (m >>= 1);
                    for (r = p; r < o; r += h) l[r] = (c << 16) | d;
                    ++u;
                  }
              return [l, i];
            }),
          (FlateStream.prototype.readBlock = function FlateStream_readBlock() {
            var c,
              u,
              h = this.str,
              d = this.getBits(3);
            if ((1 & d && (this.eof = !0), 0 !== (d >>= 1))) {
              var p, m;
              if (1 === d) (p = o), (m = l);
              else {
                if (2 !== d)
                  throw new i.FormatError("Unknown block type in flate stream");
                var g,
                  b = this.getBits(5) + 257,
                  y = this.getBits(5) + 1,
                  v = this.getBits(4) + 4,
                  S = new Uint8Array(t.length);
                for (g = 0; g < v; ++g) S[t[g]] = this.getBits(3);
                var k = this.generateHuffmanTable(S);
                (u = 0), (g = 0);
                for (var w, C, x, _ = b + y, A = new Uint8Array(_); g < _; ) {
                  var R = this.getCode(k);
                  if (16 === R) (w = 2), (C = 3), (x = u);
                  else if (17 === R) (w = 3), (C = 3), (x = u = 0);
                  else {
                    if (18 !== R) {
                      A[g++] = u = R;
                      continue;
                    }
                    (w = 7), (C = 11), (x = u = 0);
                  }
                  for (var T = this.getBits(w) + C; T-- > 0; ) A[g++] = x;
                }
                (p = this.generateHuffmanTable(A.subarray(0, b))),
                  (m = this.generateHuffmanTable(A.subarray(b, _)));
              }
              for (
                var I = (c = this.buffer) ? c.length : 0, P = this.bufferLength;
                ;

              ) {
                var O = this.getCode(p);
                if (O < 256)
                  P + 1 >= I && (I = (c = this.ensureBuffer(P + 1)).length),
                    (c[P++] = O);
                else {
                  if (256 === O) return void (this.bufferLength = P);
                  var E = (O = r[(O -= 257)]) >> 16;
                  E > 0 && (E = this.getBits(E)),
                    (u = (65535 & O) + E),
                    (O = this.getCode(m)),
                    (E = (O = a[O]) >> 16) > 0 && (E = this.getBits(E));
                  var B = (65535 & O) + E;
                  P + u >= I && (I = (c = this.ensureBuffer(P + u)).length);
                  for (var D = 0; D < u; ++D, ++P) c[P] = c[P - B];
                }
              }
            } else {
              var M;
              if (-1 === (M = h.getByte()))
                throw new i.FormatError("Bad block header in flate stream");
              var L = M;
              if (-1 === (M = h.getByte()))
                throw new i.FormatError("Bad block header in flate stream");
              if (((L |= M << 8), -1 === (M = h.getByte())))
                throw new i.FormatError("Bad block header in flate stream");
              var N = M;
              if (-1 === (M = h.getByte()))
                throw new i.FormatError("Bad block header in flate stream");
              if ((N |= M << 8) !== (65535 & ~L) && (0 !== L || 0 !== N))
                throw new i.FormatError(
                  "Bad uncompressed block length in flate stream",
                );
              (this.codeBuf = 0), (this.codeSize = 0);
              var U = this.bufferLength,
                j = U + L;
              if (
                ((c = this.ensureBuffer(j)), (this.bufferLength = j), 0 === L)
              )
                -1 === h.peekByte() && (this.eof = !0);
              else {
                var q = h.getBytes(L);
                c.set(q, U), q.length < L && (this.eof = !0);
              }
            }
          }),
          FlateStream
        );
      })();
      r.FlateStream = p;
      var m = (function PredictorStreamClosure() {
        function PredictorStream(t, r, a) {
          if (!(0, o.isDict)(a)) return t;
          var l = (this.predictor = a.get("Predictor") || 1);
          if (l <= 1) return t;
          if (2 !== l && (l < 10 || l > 15))
            throw new i.FormatError("Unsupported predictor: ".concat(l));
          (this.readBlock = 2 === l ? this.readBlockTiff : this.readBlockPng),
            (this.str = t),
            (this.dict = t.dict);
          var c = (this.colors = a.get("Colors") || 1),
            u = (this.bits = a.get("BitsPerComponent") || 8),
            d = (this.columns = a.get("Columns") || 1);
          return (
            (this.pixBytes = (c * u + 7) >> 3),
            (this.rowBytes = (d * c * u + 7) >> 3),
            h.call(this, r),
            this
          );
        }
        return (
          (PredictorStream.prototype = Object.create(h.prototype)),
          (PredictorStream.prototype.readBlockTiff =
            function predictorStreamReadBlockTiff() {
              var t = this.rowBytes,
                r = this.bufferLength,
                a = this.ensureBuffer(r + t),
                i = this.bits,
                o = this.colors,
                l = this.str.getBytes(t);
              if (((this.eof = !l.length), !this.eof)) {
                var c,
                  u = 0,
                  h = 0,
                  d = 0,
                  p = 0,
                  m = r;
                if (1 === i && 1 === o)
                  for (c = 0; c < t; ++c) {
                    var g = l[c] ^ u;
                    (g ^= g >> 1),
                      (g ^= g >> 2),
                      (u = (1 & (g ^= g >> 4)) << 7),
                      (a[m++] = g);
                  }
                else if (8 === i) {
                  for (c = 0; c < o; ++c) a[m++] = l[c];
                  for (; c < t; ++c) (a[m] = a[m - o] + l[c]), m++;
                } else if (16 === i) {
                  var b = 2 * o;
                  for (c = 0; c < b; ++c) a[m++] = l[c];
                  for (; c < t; c += 2) {
                    var y =
                      ((255 & l[c]) << 8) +
                      (255 & l[c + 1]) +
                      ((255 & a[m - b]) << 8) +
                      (255 & a[m - b + 1]);
                    (a[m++] = (y >> 8) & 255), (a[m++] = 255 & y);
                  }
                } else {
                  var v = new Uint8Array(o + 1),
                    S = (1 << i) - 1,
                    k = 0,
                    w = r,
                    C = this.columns;
                  for (c = 0; c < C; ++c)
                    for (var x = 0; x < o; ++x)
                      d < i && ((u = (u << 8) | (255 & l[k++])), (d += 8)),
                        (v[x] = (v[x] + (u >> (d - i))) & S),
                        (d -= i),
                        (h = (h << i) | v[x]),
                        (p += i) >= 8 &&
                          ((a[w++] = (h >> (p - 8)) & 255), (p -= 8));
                  p > 0 &&
                    (a[w++] = (h << (8 - p)) + (u & ((1 << (8 - p)) - 1)));
                }
                this.bufferLength += t;
              }
            }),
          (PredictorStream.prototype.readBlockPng =
            function predictorStreamReadBlockPng() {
              var t = this.rowBytes,
                r = this.pixBytes,
                a = this.str.getByte(),
                o = this.str.getBytes(t);
              if (((this.eof = !o.length), !this.eof)) {
                var l = this.bufferLength,
                  c = this.ensureBuffer(l + t),
                  u = c.subarray(l - t, l);
                0 === u.length && (u = new Uint8Array(t));
                var h,
                  d,
                  p,
                  m = l;
                switch (a) {
                  case 0:
                    for (h = 0; h < t; ++h) c[m++] = o[h];
                    break;
                  case 1:
                    for (h = 0; h < r; ++h) c[m++] = o[h];
                    for (; h < t; ++h) (c[m] = (c[m - r] + o[h]) & 255), m++;
                    break;
                  case 2:
                    for (h = 0; h < t; ++h) c[m++] = (u[h] + o[h]) & 255;
                    break;
                  case 3:
                    for (h = 0; h < r; ++h) c[m++] = (u[h] >> 1) + o[h];
                    for (; h < t; ++h)
                      (c[m] = (((u[h] + c[m - r]) >> 1) + o[h]) & 255), m++;
                    break;
                  case 4:
                    for (h = 0; h < r; ++h)
                      (d = u[h]), (p = o[h]), (c[m++] = d + p);
                    for (; h < t; ++h) {
                      d = u[h];
                      var g = u[h - r],
                        b = c[m - r],
                        y = b + d - g,
                        v = y - b;
                      v < 0 && (v = -v);
                      var S = y - d;
                      S < 0 && (S = -S);
                      var k = y - g;
                      k < 0 && (k = -k),
                        (p = o[h]),
                        (c[m++] =
                          v <= S && v <= k ? b + p : S <= k ? d + p : g + p);
                    }
                    break;
                  default:
                    throw new i.FormatError(
                      "Unsupported predictor: ".concat(a),
                    );
                }
                this.bufferLength += t;
              }
            }),
          PredictorStream
        );
      })();
      r.PredictorStream = m;
      var g = (function DecryptStreamClosure() {
        function DecryptStream(t, r, a) {
          (this.str = t),
            (this.dict = t.dict),
            (this.decrypt = a),
            (this.nextChunk = null),
            (this.initialized = !1),
            h.call(this, r);
        }
        return (
          (DecryptStream.prototype = Object.create(h.prototype)),
          (DecryptStream.prototype.readBlock =
            function DecryptStream_readBlock() {
              var t;
              if (
                (this.initialized
                  ? (t = this.nextChunk)
                  : ((t = this.str.getBytes(512)), (this.initialized = !0)),
                t && 0 !== t.length)
              ) {
                this.nextChunk = this.str.getBytes(512);
                var r = this.nextChunk && this.nextChunk.length > 0;
                t = (0, this.decrypt)(t, !r);
                var a,
                  i = this.bufferLength,
                  o = t.length,
                  l = this.ensureBuffer(i + o);
                for (a = 0; a < o; a++) l[i++] = t[a];
                this.bufferLength = i;
              } else this.eof = !0;
            }),
          DecryptStream
        );
      })();
      r.DecryptStream = g;
      var b = (function Ascii85StreamClosure() {
        function Ascii85Stream(t, r) {
          (this.str = t),
            (this.dict = t.dict),
            (this.input = new Uint8Array(5)),
            r && (r *= 0.8),
            h.call(this, r);
        }
        return (
          (Ascii85Stream.prototype = Object.create(h.prototype)),
          (Ascii85Stream.prototype.readBlock =
            function Ascii85Stream_readBlock() {
              for (var t = this.str, r = t.getByte(); (0, l.isWhiteSpace)(r); )
                r = t.getByte();
              if (-1 !== r && 126 !== r) {
                var a,
                  i,
                  o = this.bufferLength;
                if (122 === r) {
                  for (a = this.ensureBuffer(o + 4), i = 0; i < 4; ++i)
                    a[o + i] = 0;
                  this.bufferLength += 4;
                } else {
                  var c = this.input;
                  for (c[0] = r, i = 1; i < 5; ++i) {
                    for (r = t.getByte(); (0, l.isWhiteSpace)(r); )
                      r = t.getByte();
                    if (((c[i] = r), -1 === r || 126 === r)) break;
                  }
                  if (
                    ((a = this.ensureBuffer(o + i - 1)),
                    (this.bufferLength += i - 1),
                    i < 5)
                  ) {
                    for (; i < 5; ++i) c[i] = 117;
                    this.eof = !0;
                  }
                  var u = 0;
                  for (i = 0; i < 5; ++i) u = 85 * u + (c[i] - 33);
                  for (i = 3; i >= 0; --i) (a[o + i] = 255 & u), (u >>= 8);
                }
              } else this.eof = !0;
            }),
          Ascii85Stream
        );
      })();
      r.Ascii85Stream = b;
      var y = (function AsciiHexStreamClosure() {
        function AsciiHexStream(t, r) {
          (this.str = t),
            (this.dict = t.dict),
            (this.firstDigit = -1),
            r && (r *= 0.5),
            h.call(this, r);
        }
        return (
          (AsciiHexStream.prototype = Object.create(h.prototype)),
          (AsciiHexStream.prototype.readBlock =
            function AsciiHexStream_readBlock() {
              var t = this.str.getBytes(8e3);
              if (t.length) {
                for (
                  var r = (t.length + 1) >> 1,
                    a = this.ensureBuffer(this.bufferLength + r),
                    i = this.bufferLength,
                    o = this.firstDigit,
                    l = 0,
                    c = t.length;
                  l < c;
                  l++
                ) {
                  var u,
                    h = t[l];
                  if (h >= 48 && h <= 57) u = 15 & h;
                  else {
                    if (!((h >= 65 && h <= 70) || (h >= 97 && h <= 102))) {
                      if (62 === h) {
                        this.eof = !0;
                        break;
                      }
                      continue;
                    }
                    u = 9 + (15 & h);
                  }
                  o < 0 ? (o = u) : ((a[i++] = (o << 4) | u), (o = -1));
                }
                o >= 0 && this.eof && ((a[i++] = o << 4), (o = -1)),
                  (this.firstDigit = o),
                  (this.bufferLength = i);
              } else this.eof = !0;
            }),
          AsciiHexStream
        );
      })();
      r.AsciiHexStream = y;
      var v = (function RunLengthStreamClosure() {
        function RunLengthStream(t, r) {
          (this.str = t), (this.dict = t.dict), h.call(this, r);
        }
        return (
          (RunLengthStream.prototype = Object.create(h.prototype)),
          (RunLengthStream.prototype.readBlock =
            function RunLengthStream_readBlock() {
              var t = this.str.getBytes(2);
              if (!t || t.length < 2 || 128 === t[0]) this.eof = !0;
              else {
                var r,
                  a = this.bufferLength,
                  i = t[0];
                if (i < 128) {
                  if (
                    (((r = this.ensureBuffer(a + i + 1))[a++] = t[1]), i > 0)
                  ) {
                    var o = this.str.getBytes(i);
                    r.set(o, a), (a += i);
                  }
                } else {
                  i = 257 - i;
                  var l = t[1];
                  r = this.ensureBuffer(a + i + 1);
                  for (var c = 0; c < i; c++) r[a++] = l;
                }
                this.bufferLength = a;
              }
            }),
          RunLengthStream
        );
      })();
      r.RunLengthStream = v;
      var S = (function LZWStreamClosure() {
        function LZWStream(t, r, a) {
          (this.str = t),
            (this.dict = t.dict),
            (this.cachedData = 0),
            (this.bitsCached = 0);
          for (
            var i = 4096,
              o = {
                earlyChange: a,
                codeLength: 9,
                nextCode: 258,
                dictionaryValues: new Uint8Array(i),
                dictionaryLengths: new Uint16Array(i),
                dictionaryPrevCodes: new Uint16Array(i),
                currentSequence: new Uint8Array(i),
                currentSequenceLength: 0,
              },
              l = 0;
            l < 256;
            ++l
          )
            (o.dictionaryValues[l] = l), (o.dictionaryLengths[l] = 1);
          (this.lzwState = o), h.call(this, r);
        }
        return (
          (LZWStream.prototype = Object.create(h.prototype)),
          (LZWStream.prototype.readBits = function LZWStream_readBits(t) {
            for (var r = this.bitsCached, a = this.cachedData; r < t; ) {
              var i = this.str.getByte();
              if (-1 === i) return (this.eof = !0), null;
              (a = (a << 8) | i), (r += 8);
            }
            return (
              (this.bitsCached = r -= t),
              (this.cachedData = a),
              (this.lastCode = null),
              (a >>> r) & ((1 << t) - 1)
            );
          }),
          (LZWStream.prototype.readBlock = function LZWStream_readBlock() {
            var t,
              r,
              a,
              i = 1024,
              o = this.lzwState;
            if (o) {
              var l = o.earlyChange,
                c = o.nextCode,
                u = o.dictionaryValues,
                h = o.dictionaryLengths,
                d = o.dictionaryPrevCodes,
                p = o.codeLength,
                m = o.prevCode,
                g = o.currentSequence,
                b = o.currentSequenceLength,
                y = 0,
                v = this.bufferLength,
                S = this.ensureBuffer(this.bufferLength + i);
              for (t = 0; t < 512; t++) {
                var k = this.readBits(p),
                  w = b > 0;
                if (k < 256) (g[0] = k), (b = 1);
                else {
                  if (!(k >= 258)) {
                    if (256 === k) {
                      (p = 9), (c = 258), (b = 0);
                      continue;
                    }
                    (this.eof = !0), delete this.lzwState;
                    break;
                  }
                  if (k < c)
                    for (r = (b = h[k]) - 1, a = k; r >= 0; r--)
                      (g[r] = u[a]), (a = d[a]);
                  else g[b++] = g[0];
                }
                if (
                  (w &&
                    ((d[c] = m),
                    (h[c] = h[m] + 1),
                    (u[c] = g[0]),
                    (p =
                      (++c + l) & (c + l - 1)
                        ? p
                        : 0 |
                          Math.min(
                            Math.log(c + l) / 0.6931471805599453 + 1,
                            12,
                          ))),
                  (m = k),
                  i < (y += b))
                ) {
                  do {
                    i += 512;
                  } while (i < y);
                  S = this.ensureBuffer(this.bufferLength + i);
                }
                for (r = 0; r < b; r++) S[v++] = g[r];
              }
              (o.nextCode = c),
                (o.codeLength = p),
                (o.prevCode = m),
                (o.currentSequenceLength = b),
                (this.bufferLength = v);
            }
          }),
          LZWStream
        );
      })();
      r.LZWStream = S;
      var k = (function NullStreamClosure() {
        function NullStream() {
          c.call(this, new Uint8Array(0));
        }
        return (NullStream.prototype = c.prototype), NullStream;
      })();
      r.NullStream = k;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.CCITTFaxStream = void 0);
      var i = a(198),
        o = a(207),
        l = a(205),
        c = (function CCITTFaxStreamClosure() {
          function CCITTFaxStream(t, r, a) {
            (this.str = t),
              (this.dict = t.dict),
              (0, i.isDict)(a) || (a = i.Dict.empty);
            var c = {
              next: function next() {
                return t.getByte();
              },
            };
            (this.ccittFaxDecoder = new o.CCITTFaxDecoder(c, {
              K: a.get("K"),
              EndOfLine: a.get("EndOfLine"),
              EncodedByteAlign: a.get("EncodedByteAlign"),
              Columns: a.get("Columns"),
              Rows: a.get("Rows"),
              EndOfBlock: a.get("EndOfBlock"),
              BlackIs1: a.get("BlackIs1"),
            })),
              l.DecodeStream.call(this, r);
          }
          return (
            (CCITTFaxStream.prototype = Object.create(
              l.DecodeStream.prototype,
            )),
            (CCITTFaxStream.prototype.readBlock = function () {
              for (; !this.eof; ) {
                var t = this.ccittFaxDecoder.readNextChar();
                if (-1 === t) return void (this.eof = !0);
                this.ensureBuffer(this.bufferLength + 1),
                  (this.buffer[this.bufferLength++] = t);
              }
            }),
            CCITTFaxStream
          );
        })();
      r.CCITTFaxStream = c;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.CCITTFaxDecoder = void 0);
      var i = a(5),
        o = (function CCITTFaxDecoder() {
          var t = -1,
            r = [
              [-1, -1],
              [-1, -1],
              [7, 8],
              [7, 7],
              [6, 6],
              [6, 6],
              [6, 5],
              [6, 5],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
            ],
            a = [
              [-1, -1],
              [12, -2],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [11, 1792],
              [11, 1792],
              [12, 1984],
              [12, 2048],
              [12, 2112],
              [12, 2176],
              [12, 2240],
              [12, 2304],
              [11, 1856],
              [11, 1856],
              [11, 1920],
              [11, 1920],
              [12, 2368],
              [12, 2432],
              [12, 2496],
              [12, 2560],
            ],
            o = [
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [8, 29],
              [8, 29],
              [8, 30],
              [8, 30],
              [8, 45],
              [8, 45],
              [8, 46],
              [8, 46],
              [7, 22],
              [7, 22],
              [7, 22],
              [7, 22],
              [7, 23],
              [7, 23],
              [7, 23],
              [7, 23],
              [8, 47],
              [8, 47],
              [8, 48],
              [8, 48],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [7, 20],
              [7, 20],
              [7, 20],
              [7, 20],
              [8, 33],
              [8, 33],
              [8, 34],
              [8, 34],
              [8, 35],
              [8, 35],
              [8, 36],
              [8, 36],
              [8, 37],
              [8, 37],
              [8, 38],
              [8, 38],
              [7, 19],
              [7, 19],
              [7, 19],
              [7, 19],
              [8, 31],
              [8, 31],
              [8, 32],
              [8, 32],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [8, 53],
              [8, 53],
              [8, 54],
              [8, 54],
              [7, 26],
              [7, 26],
              [7, 26],
              [7, 26],
              [8, 39],
              [8, 39],
              [8, 40],
              [8, 40],
              [8, 41],
              [8, 41],
              [8, 42],
              [8, 42],
              [8, 43],
              [8, 43],
              [8, 44],
              [8, 44],
              [7, 21],
              [7, 21],
              [7, 21],
              [7, 21],
              [7, 28],
              [7, 28],
              [7, 28],
              [7, 28],
              [8, 61],
              [8, 61],
              [8, 62],
              [8, 62],
              [8, 63],
              [8, 63],
              [8, 0],
              [8, 0],
              [8, 320],
              [8, 320],
              [8, 384],
              [8, 384],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [7, 27],
              [7, 27],
              [7, 27],
              [7, 27],
              [8, 59],
              [8, 59],
              [8, 60],
              [8, 60],
              [9, 1472],
              [9, 1536],
              [9, 1600],
              [9, 1728],
              [7, 18],
              [7, 18],
              [7, 18],
              [7, 18],
              [7, 24],
              [7, 24],
              [7, 24],
              [7, 24],
              [8, 49],
              [8, 49],
              [8, 50],
              [8, 50],
              [8, 51],
              [8, 51],
              [8, 52],
              [8, 52],
              [7, 25],
              [7, 25],
              [7, 25],
              [7, 25],
              [8, 55],
              [8, 55],
              [8, 56],
              [8, 56],
              [8, 57],
              [8, 57],
              [8, 58],
              [8, 58],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [8, 448],
              [8, 448],
              [8, 512],
              [8, 512],
              [9, 704],
              [9, 768],
              [8, 640],
              [8, 640],
              [8, 576],
              [8, 576],
              [9, 832],
              [9, 896],
              [9, 960],
              [9, 1024],
              [9, 1088],
              [9, 1152],
              [9, 1216],
              [9, 1280],
              [9, 1344],
              [9, 1408],
              [7, 256],
              [7, 256],
              [7, 256],
              [7, 256],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
            ],
            l = [
              [-1, -1],
              [-1, -1],
              [12, -2],
              [12, -2],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [11, 1792],
              [11, 1792],
              [11, 1792],
              [11, 1792],
              [12, 1984],
              [12, 1984],
              [12, 2048],
              [12, 2048],
              [12, 2112],
              [12, 2112],
              [12, 2176],
              [12, 2176],
              [12, 2240],
              [12, 2240],
              [12, 2304],
              [12, 2304],
              [11, 1856],
              [11, 1856],
              [11, 1856],
              [11, 1856],
              [11, 1920],
              [11, 1920],
              [11, 1920],
              [11, 1920],
              [12, 2368],
              [12, 2368],
              [12, 2432],
              [12, 2432],
              [12, 2496],
              [12, 2496],
              [12, 2560],
              [12, 2560],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [12, 52],
              [12, 52],
              [13, 640],
              [13, 704],
              [13, 768],
              [13, 832],
              [12, 55],
              [12, 55],
              [12, 56],
              [12, 56],
              [13, 1280],
              [13, 1344],
              [13, 1408],
              [13, 1472],
              [12, 59],
              [12, 59],
              [12, 60],
              [12, 60],
              [13, 1536],
              [13, 1600],
              [11, 24],
              [11, 24],
              [11, 24],
              [11, 24],
              [11, 25],
              [11, 25],
              [11, 25],
              [11, 25],
              [13, 1664],
              [13, 1728],
              [12, 320],
              [12, 320],
              [12, 384],
              [12, 384],
              [12, 448],
              [12, 448],
              [13, 512],
              [13, 576],
              [12, 53],
              [12, 53],
              [12, 54],
              [12, 54],
              [13, 896],
              [13, 960],
              [13, 1024],
              [13, 1088],
              [13, 1152],
              [13, 1216],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
            ],
            c = [
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [11, 23],
              [11, 23],
              [12, 50],
              [12, 51],
              [12, 44],
              [12, 45],
              [12, 46],
              [12, 47],
              [12, 57],
              [12, 58],
              [12, 61],
              [12, 256],
              [10, 16],
              [10, 16],
              [10, 16],
              [10, 16],
              [10, 17],
              [10, 17],
              [10, 17],
              [10, 17],
              [12, 48],
              [12, 49],
              [12, 62],
              [12, 63],
              [12, 30],
              [12, 31],
              [12, 32],
              [12, 33],
              [12, 40],
              [12, 41],
              [11, 22],
              [11, 22],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [12, 128],
              [12, 192],
              [12, 26],
              [12, 27],
              [12, 28],
              [12, 29],
              [11, 19],
              [11, 19],
              [11, 20],
              [11, 20],
              [12, 34],
              [12, 35],
              [12, 36],
              [12, 37],
              [12, 38],
              [12, 39],
              [11, 21],
              [11, 21],
              [12, 42],
              [12, 43],
              [10, 0],
              [10, 0],
              [10, 0],
              [10, 0],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
            ],
            u = [
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [6, 9],
              [6, 8],
              [5, 7],
              [5, 7],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
            ];
          function CCITTFaxDecoder(t) {
            var r =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
            if (!t || "function" != typeof t.next)
              throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
            (this.source = t),
              (this.eof = !1),
              (this.encoding = r.K || 0),
              (this.eoline = r.EndOfLine || !1),
              (this.byteAlign = r.EncodedByteAlign || !1),
              (this.columns = r.Columns || 1728),
              (this.rows = r.Rows || 0);
            var a,
              i = r.EndOfBlock;
            for (
              null == i && (i = !0),
                this.eoblock = i,
                this.black = r.BlackIs1 || !1,
                this.codingLine = new Uint32Array(this.columns + 1),
                this.refLine = new Uint32Array(this.columns + 2),
                this.codingLine[0] = this.columns,
                this.codingPos = 0,
                this.row = 0,
                this.nextLine2D = this.encoding < 0,
                this.inputBits = 0,
                this.inputBuf = 0,
                this.outputBits = 0,
                this.rowsDone = !1;
              0 === (a = this._lookBits(12));

            )
              this._eatBits(1);
            1 === a && this._eatBits(12),
              this.encoding > 0 &&
                ((this.nextLine2D = !this._lookBits(1)), this._eatBits(1));
          }
          return (
            (CCITTFaxDecoder.prototype = {
              readNextChar: function readNextChar() {
                if (this.eof) return -1;
                var r,
                  a,
                  o,
                  l,
                  c,
                  u = this.refLine,
                  h = this.codingLine,
                  d = this.columns;
                if (0 === this.outputBits) {
                  if ((this.rowsDone && (this.eof = !0), this.eof)) return -1;
                  var p, m, g;
                  if (((this.err = !1), this.nextLine2D)) {
                    for (l = 0; h[l] < d; ++l) u[l] = h[l];
                    for (
                      u[l++] = d,
                        u[l] = d,
                        h[0] = 0,
                        this.codingPos = 0,
                        r = 0,
                        a = 0;
                      h[this.codingPos] < d;

                    )
                      switch ((p = this._getTwoDimCode())) {
                        case 0:
                          this._addPixels(u[r + 1], a),
                            u[r + 1] < d && (r += 2);
                          break;
                        case 1:
                          if (((p = m = 0), a)) {
                            do {
                              p += g = this._getBlackCode();
                            } while (g >= 64);
                            do {
                              m += g = this._getWhiteCode();
                            } while (g >= 64);
                          } else {
                            do {
                              p += g = this._getWhiteCode();
                            } while (g >= 64);
                            do {
                              m += g = this._getBlackCode();
                            } while (g >= 64);
                          }
                          for (
                            this._addPixels(h[this.codingPos] + p, a),
                              h[this.codingPos] < d &&
                                this._addPixels(h[this.codingPos] + m, 1 ^ a);
                            u[r] <= h[this.codingPos] && u[r] < d;

                          )
                            r += 2;
                          break;
                        case 7:
                          if (
                            (this._addPixels(u[r] + 3, a),
                            (a ^= 1),
                            h[this.codingPos] < d)
                          )
                            for (++r; u[r] <= h[this.codingPos] && u[r] < d; )
                              r += 2;
                          break;
                        case 5:
                          if (
                            (this._addPixels(u[r] + 2, a),
                            (a ^= 1),
                            h[this.codingPos] < d)
                          )
                            for (++r; u[r] <= h[this.codingPos] && u[r] < d; )
                              r += 2;
                          break;
                        case 3:
                          if (
                            (this._addPixels(u[r] + 1, a),
                            (a ^= 1),
                            h[this.codingPos] < d)
                          )
                            for (++r; u[r] <= h[this.codingPos] && u[r] < d; )
                              r += 2;
                          break;
                        case 2:
                          if (
                            (this._addPixels(u[r], a),
                            (a ^= 1),
                            h[this.codingPos] < d)
                          )
                            for (++r; u[r] <= h[this.codingPos] && u[r] < d; )
                              r += 2;
                          break;
                        case 8:
                          if (
                            (this._addPixelsNeg(u[r] - 3, a),
                            (a ^= 1),
                            h[this.codingPos] < d)
                          )
                            for (
                              r > 0 ? --r : ++r;
                              u[r] <= h[this.codingPos] && u[r] < d;

                            )
                              r += 2;
                          break;
                        case 6:
                          if (
                            (this._addPixelsNeg(u[r] - 2, a),
                            (a ^= 1),
                            h[this.codingPos] < d)
                          )
                            for (
                              r > 0 ? --r : ++r;
                              u[r] <= h[this.codingPos] && u[r] < d;

                            )
                              r += 2;
                          break;
                        case 4:
                          if (
                            (this._addPixelsNeg(u[r] - 1, a),
                            (a ^= 1),
                            h[this.codingPos] < d)
                          )
                            for (
                              r > 0 ? --r : ++r;
                              u[r] <= h[this.codingPos] && u[r] < d;

                            )
                              r += 2;
                          break;
                        case t:
                          this._addPixels(d, 0), (this.eof = !0);
                          break;
                        default:
                          (0, i.info)("bad 2d code"),
                            this._addPixels(d, 0),
                            (this.err = !0);
                      }
                  } else
                    for (
                      h[0] = 0, this.codingPos = 0, a = 0;
                      h[this.codingPos] < d;

                    ) {
                      if (((p = 0), a))
                        do {
                          p += g = this._getBlackCode();
                        } while (g >= 64);
                      else
                        do {
                          p += g = this._getWhiteCode();
                        } while (g >= 64);
                      this._addPixels(h[this.codingPos] + p, a), (a ^= 1);
                    }
                  var b = !1;
                  if (
                    (this.byteAlign && (this.inputBits &= -8),
                    this.eoblock || this.row !== this.rows - 1)
                  ) {
                    if (((p = this._lookBits(12)), this.eoline))
                      for (; p !== t && 1 !== p; )
                        this._eatBits(1), (p = this._lookBits(12));
                    else
                      for (; 0 === p; )
                        this._eatBits(1), (p = this._lookBits(12));
                    1 === p
                      ? (this._eatBits(12), (b = !0))
                      : p === t && (this.eof = !0);
                  } else this.rowsDone = !0;
                  if (
                    (!this.eof &&
                      this.encoding > 0 &&
                      !this.rowsDone &&
                      ((this.nextLine2D = !this._lookBits(1)),
                      this._eatBits(1)),
                    this.eoblock && b && this.byteAlign)
                  ) {
                    if (1 === (p = this._lookBits(12))) {
                      if (
                        (this._eatBits(12),
                        this.encoding > 0 &&
                          (this._lookBits(1), this._eatBits(1)),
                        this.encoding >= 0)
                      )
                        for (l = 0; l < 4; ++l)
                          1 !== (p = this._lookBits(12)) &&
                            (0, i.info)("bad rtc code: " + p),
                            this._eatBits(12),
                            this.encoding > 0 &&
                              (this._lookBits(1), this._eatBits(1));
                      this.eof = !0;
                    }
                  } else if (this.err && this.eoline) {
                    for (;;) {
                      if ((p = this._lookBits(13)) === t)
                        return (this.eof = !0), -1;
                      if (p >> 1 == 1) break;
                      this._eatBits(1);
                    }
                    this._eatBits(12),
                      this.encoding > 0 &&
                        (this._eatBits(1), (this.nextLine2D = !(1 & p)));
                  }
                  h[0] > 0
                    ? (this.outputBits = h[(this.codingPos = 0)])
                    : (this.outputBits = h[(this.codingPos = 1)]),
                    this.row++;
                }
                if (this.outputBits >= 8)
                  (c = 1 & this.codingPos ? 0 : 255),
                    (this.outputBits -= 8),
                    0 === this.outputBits &&
                      h[this.codingPos] < d &&
                      (this.codingPos++,
                      (this.outputBits =
                        h[this.codingPos] - h[this.codingPos - 1]));
                else {
                  (o = 8), (c = 0);
                  do {
                    this.outputBits > o
                      ? ((c <<= o),
                        1 & this.codingPos || (c |= 255 >> (8 - o)),
                        (this.outputBits -= o),
                        (o = 0))
                      : ((c <<= this.outputBits),
                        1 & this.codingPos ||
                          (c |= 255 >> (8 - this.outputBits)),
                        (o -= this.outputBits),
                        (this.outputBits = 0),
                        h[this.codingPos] < d
                          ? (this.codingPos++,
                            (this.outputBits =
                              h[this.codingPos] - h[this.codingPos - 1]))
                          : o > 0 && ((c <<= o), (o = 0)));
                  } while (o);
                }
                return this.black && (c ^= 255), c;
              },
              _addPixels: function _addPixels(t, r) {
                var a = this.codingLine,
                  o = this.codingPos;
                t > a[o] &&
                  (t > this.columns &&
                    ((0, i.info)("row is wrong length"),
                    (this.err = !0),
                    (t = this.columns)),
                  (1 & o) ^ r && ++o,
                  (a[o] = t)),
                  (this.codingPos = o);
              },
              _addPixelsNeg: function _addPixelsNeg(t, r) {
                var a = this.codingLine,
                  o = this.codingPos;
                if (t > a[o])
                  t > this.columns &&
                    ((0, i.info)("row is wrong length"),
                    (this.err = !0),
                    (t = this.columns)),
                    (1 & o) ^ r && ++o,
                    (a[o] = t);
                else if (t < a[o]) {
                  for (
                    t < 0 &&
                    ((0, i.info)("invalid code"), (this.err = !0), (t = 0));
                    o > 0 && t < a[o - 1];

                  )
                    --o;
                  a[o] = t;
                }
                this.codingPos = o;
              },
              _findTableCode: function _findTableCode(r, a, i, o) {
                for (var l = o || 0, c = r; c <= a; ++c) {
                  var u = this._lookBits(c);
                  if (u === t) return [!0, 1, !1];
                  if ((c < a && (u <<= a - c), !l || u >= l)) {
                    var h = i[u - l];
                    if (h[0] === c) return this._eatBits(c), [!0, h[1], !0];
                  }
                }
                return [!1, 0, !1];
              },
              _getTwoDimCode: function _getTwoDimCode() {
                var a,
                  o = 0;
                if (this.eoblock) {
                  if (((o = this._lookBits(7)), (a = r[o]) && a[0] > 0))
                    return this._eatBits(a[0]), a[1];
                } else {
                  var l = this._findTableCode(1, 7, r);
                  if (l[0] && l[2]) return l[1];
                }
                return (0, i.info)("Bad two dim code"), t;
              },
              _getWhiteCode: function _getWhiteCode() {
                var r,
                  l = 0;
                if (this.eoblock) {
                  if ((l = this._lookBits(12)) === t) return 1;
                  if ((r = l >> 5 == 0 ? a[l] : o[l >> 3])[0] > 0)
                    return this._eatBits(r[0]), r[1];
                } else {
                  var c = this._findTableCode(1, 9, o);
                  if (c[0]) return c[1];
                  if ((c = this._findTableCode(11, 12, a))[0]) return c[1];
                }
                return (0, i.info)("bad white code"), this._eatBits(1), 1;
              },
              _getBlackCode: function _getBlackCode() {
                var r, a;
                if (this.eoblock) {
                  if ((r = this._lookBits(13)) === t) return 1;
                  if (
                    (a =
                      r >> 7 == 0
                        ? l[r]
                        : r >> 9 == 0 && r >> 7 != 0
                        ? c[(r >> 1) - 64]
                        : u[r >> 7])[0] > 0
                  )
                    return this._eatBits(a[0]), a[1];
                } else {
                  var o = this._findTableCode(2, 6, u);
                  if (o[0]) return o[1];
                  if ((o = this._findTableCode(7, 12, c, 64))[0]) return o[1];
                  if ((o = this._findTableCode(10, 13, l))[0]) return o[1];
                }
                return (0, i.info)("bad black code"), this._eatBits(1), 1;
              },
              _lookBits: function _lookBits(r) {
                for (var a; this.inputBits < r; ) {
                  if (-1 === (a = this.source.next()))
                    return 0 === this.inputBits
                      ? t
                      : (this.inputBuf << (r - this.inputBits)) &
                          (65535 >> (16 - r));
                  (this.inputBuf = (this.inputBuf << 8) | a),
                    (this.inputBits += 8);
                }
                return (
                  (this.inputBuf >> (this.inputBits - r)) & (65535 >> (16 - r))
                );
              },
              _eatBits: function _eatBits(t) {
                (this.inputBits -= t) < 0 && (this.inputBits = 0);
              },
            }),
            CCITTFaxDecoder
          );
        })();
      r.CCITTFaxDecoder = o;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.Jbig2Stream = void 0);
      var i = a(198),
        o = a(205),
        l = a(209),
        c = a(5),
        u = (function Jbig2StreamClosure() {
          function Jbig2Stream(t, r, a, i) {
            (this.stream = t),
              (this.maybeLength = r),
              (this.dict = a),
              (this.params = i),
              o.DecodeStream.call(this, r);
          }
          return (
            (Jbig2Stream.prototype = Object.create(o.DecodeStream.prototype)),
            Object.defineProperty(Jbig2Stream.prototype, "bytes", {
              get: function get() {
                return (0, c.shadow)(
                  this,
                  "bytes",
                  this.stream.getBytes(this.maybeLength),
                );
              },
              configurable: !0,
            }),
            (Jbig2Stream.prototype.ensureBuffer = function (t) {}),
            (Jbig2Stream.prototype.readBlock = function () {
              if (!this.eof) {
                var t = new l.Jbig2Image(),
                  r = [];
                if ((0, i.isDict)(this.params)) {
                  var a = this.params.get("JBIG2Globals");
                  if ((0, i.isStream)(a)) {
                    var o = a.getBytes();
                    r.push({ data: o, start: 0, end: o.length });
                  }
                }
                r.push({ data: this.bytes, start: 0, end: this.bytes.length });
                for (var c = t.parseChunks(r), u = c.length, h = 0; h < u; h++)
                  c[h] ^= 255;
                (this.buffer = c), (this.bufferLength = u), (this.eof = !0);
              }
            }),
            Jbig2Stream
          );
        })();
      r.Jbig2Stream = u;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.Jbig2Image = void 0);
      var i = a(5),
        o = a(201),
        l = a(210),
        c = a(207);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      var u = (function (t) {
          !(function _inherits(t, r) {
            if ("function" != typeof r && null !== r)
              throw new TypeError(
                "Super expression must either be null or a function",
              );
            (t.prototype = Object.create(r && r.prototype, {
              constructor: { value: t, writable: !0, configurable: !0 },
            })),
              r && _setPrototypeOf(t, r);
          })(Jbig2Error, t);
          var r = _createSuper(Jbig2Error);
          function Jbig2Error(t) {
            return (
              (function _classCallCheck(t, r) {
                if (!(t instanceof r))
                  throw new TypeError("Cannot call a class as a function");
              })(this, Jbig2Error),
              r.call(this, "JBIG2 error: ".concat(t))
            );
          }
          return Jbig2Error;
        })(i.BaseException),
        h = (function Jbig2ImageClosure() {
          function ContextCache() {}
          function DecodingContext(t, r, a) {
            (this.data = t), (this.start = r), (this.end = a);
          }
          function decodeInteger(t, r, a) {
            var i = t.getContexts(r),
              o = 1;
            function readBits(t) {
              for (var r = 0, l = 0; l < t; l++) {
                var c = a.readBit(i, o);
                (o = o < 256 ? (o << 1) | c : (511 & ((o << 1) | c)) | 256),
                  (r = (r << 1) | c);
              }
              return r >>> 0;
            }
            var l = readBits(1),
              c = readBits(1)
                ? readBits(1)
                  ? readBits(1)
                    ? readBits(1)
                      ? readBits(1)
                        ? readBits(32) + 4436
                        : readBits(12) + 340
                      : readBits(8) + 84
                    : readBits(6) + 20
                  : readBits(4) + 4
                : readBits(2);
            return 0 === l ? c : c > 0 ? -c : null;
          }
          function decodeIAID(t, r, a) {
            for (var i = t.getContexts("IAID"), o = 1, l = 0; l < a; l++) {
              o = (o << 1) | r.readBit(i, o);
            }
            return a < 31 ? o & ((1 << a) - 1) : 2147483647 & o;
          }
          (ContextCache.prototype = {
            getContexts: function getContexts(t) {
              return t in this ? this[t] : (this[t] = new Int8Array(65536));
            },
          }),
            (DecodingContext.prototype = {
              get decoder() {
                var t = new l.ArithmeticDecoder(
                  this.data,
                  this.start,
                  this.end,
                );
                return (0, i.shadow)(this, "decoder", t);
              },
              get contextCache() {
                var t = new ContextCache();
                return (0, i.shadow)(this, "contextCache", t);
              },
            });
          var t = [
              "SymbolDictionary",
              null,
              null,
              null,
              "IntermediateTextRegion",
              null,
              "ImmediateTextRegion",
              "ImmediateLosslessTextRegion",
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              "PatternDictionary",
              null,
              null,
              null,
              "IntermediateHalftoneRegion",
              null,
              "ImmediateHalftoneRegion",
              "ImmediateLosslessHalftoneRegion",
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              "IntermediateGenericRegion",
              null,
              "ImmediateGenericRegion",
              "ImmediateLosslessGenericRegion",
              "IntermediateGenericRefinementRegion",
              null,
              "ImmediateGenericRefinementRegion",
              "ImmediateLosslessGenericRefinementRegion",
              null,
              null,
              null,
              null,
              "PageInformation",
              "EndOfPage",
              "EndOfStripe",
              "EndOfFile",
              "Profiles",
              "Tables",
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              "Extension",
            ],
            r = [
              [
                { x: -1, y: -2 },
                { x: 0, y: -2 },
                { x: 1, y: -2 },
                { x: -2, y: -1 },
                { x: -1, y: -1 },
                { x: 0, y: -1 },
                { x: 1, y: -1 },
                { x: 2, y: -1 },
                { x: -4, y: 0 },
                { x: -3, y: 0 },
                { x: -2, y: 0 },
                { x: -1, y: 0 },
              ],
              [
                { x: -1, y: -2 },
                { x: 0, y: -2 },
                { x: 1, y: -2 },
                { x: 2, y: -2 },
                { x: -2, y: -1 },
                { x: -1, y: -1 },
                { x: 0, y: -1 },
                { x: 1, y: -1 },
                { x: 2, y: -1 },
                { x: -3, y: 0 },
                { x: -2, y: 0 },
                { x: -1, y: 0 },
              ],
              [
                { x: -1, y: -2 },
                { x: 0, y: -2 },
                { x: 1, y: -2 },
                { x: -2, y: -1 },
                { x: -1, y: -1 },
                { x: 0, y: -1 },
                { x: 1, y: -1 },
                { x: -2, y: 0 },
                { x: -1, y: 0 },
              ],
              [
                { x: -3, y: -1 },
                { x: -2, y: -1 },
                { x: -1, y: -1 },
                { x: 0, y: -1 },
                { x: 1, y: -1 },
                { x: -4, y: 0 },
                { x: -3, y: 0 },
                { x: -2, y: 0 },
                { x: -1, y: 0 },
              ],
            ],
            a = [
              {
                coding: [
                  { x: 0, y: -1 },
                  { x: 1, y: -1 },
                  { x: -1, y: 0 },
                ],
                reference: [
                  { x: 0, y: -1 },
                  { x: 1, y: -1 },
                  { x: -1, y: 0 },
                  { x: 0, y: 0 },
                  { x: 1, y: 0 },
                  { x: -1, y: 1 },
                  { x: 0, y: 1 },
                  { x: 1, y: 1 },
                ],
              },
              {
                coding: [
                  { x: -1, y: -1 },
                  { x: 0, y: -1 },
                  { x: 1, y: -1 },
                  { x: -1, y: 0 },
                ],
                reference: [
                  { x: 0, y: -1 },
                  { x: -1, y: 0 },
                  { x: 0, y: 0 },
                  { x: 1, y: 0 },
                  { x: 0, y: 1 },
                  { x: 1, y: 1 },
                ],
              },
            ],
            h = [39717, 1941, 229, 405],
            d = [32, 8];
          function decodeBitmap(t, a, i, o, l, c, u, d) {
            if (t)
              return decodeMMRBitmap(
                new Reader(d.data, d.start, d.end),
                a,
                i,
                !1,
              );
            if (
              0 === o &&
              !c &&
              !l &&
              4 === u.length &&
              3 === u[0].x &&
              -1 === u[0].y &&
              -3 === u[1].x &&
              -1 === u[1].y &&
              2 === u[2].x &&
              -2 === u[2].y &&
              -2 === u[3].x &&
              -2 === u[3].y
            )
              return (function decodeBitmapTemplate0(t, r, a) {
                var i,
                  o,
                  l,
                  c,
                  u,
                  h,
                  d,
                  p = a.decoder,
                  m = a.contextCache.getContexts("GB"),
                  g = [];
                for (o = 0; o < r; o++)
                  for (
                    u = g[o] = new Uint8Array(t),
                      h = o < 1 ? u : g[o - 1],
                      i =
                        ((d = o < 2 ? u : g[o - 2])[0] << 13) |
                        (d[1] << 12) |
                        (d[2] << 11) |
                        (h[0] << 7) |
                        (h[1] << 6) |
                        (h[2] << 5) |
                        (h[3] << 4),
                      l = 0;
                    l < t;
                    l++
                  )
                    (u[l] = c = p.readBit(m, i)),
                      (i =
                        ((31735 & i) << 1) |
                        (l + 3 < t ? d[l + 3] << 11 : 0) |
                        (l + 4 < t ? h[l + 4] << 4 : 0) |
                        c);
                return g;
              })(a, i, d);
            var p = !!c,
              m = r[o].concat(u);
            m.sort(function (t, r) {
              return t.y - r.y || t.x - r.x;
            });
            var g,
              b,
              y = m.length,
              v = new Int8Array(y),
              S = new Int8Array(y),
              k = [],
              w = 0,
              C = 0,
              x = 0,
              _ = 0;
            for (b = 0; b < y; b++)
              (v[b] = m[b].x),
                (S[b] = m[b].y),
                (C = Math.min(C, m[b].x)),
                (x = Math.max(x, m[b].x)),
                (_ = Math.min(_, m[b].y)),
                b < y - 1 && m[b].y === m[b + 1].y && m[b].x === m[b + 1].x - 1
                  ? (w |= 1 << (y - 1 - b))
                  : k.push(b);
            var A = k.length,
              R = new Int8Array(A),
              T = new Int8Array(A),
              I = new Uint16Array(A);
            for (g = 0; g < A; g++)
              (b = k[g]),
                (R[g] = m[b].x),
                (T[g] = m[b].y),
                (I[g] = 1 << (y - 1 - b));
            for (
              var P,
                O,
                E,
                B,
                D,
                M = -C,
                L = -_,
                N = a - x,
                U = h[o],
                j = new Uint8Array(a),
                q = [],
                W = d.decoder,
                z = d.contextCache.getContexts("GB"),
                G = 0,
                H = 0,
                X = 0;
              X < i;
              X++
            ) {
              if (l)
                if ((G ^= W.readBit(z, U))) {
                  q.push(j);
                  continue;
                }
              for (j = new Uint8Array(j), q.push(j), P = 0; P < a; P++)
                if (p && c[X][P]) j[P] = 0;
                else {
                  if (P >= M && P < N && X >= L)
                    for (H = (H << 1) & w, b = 0; b < A; b++)
                      (O = X + T[b]),
                        (E = P + R[b]),
                        (B = q[O][E]) && (H |= B = I[b]);
                  else
                    for (H = 0, D = y - 1, b = 0; b < y; b++, D--)
                      (E = P + v[b]) >= 0 &&
                        E < a &&
                        (O = X + S[b]) >= 0 &&
                        (B = q[O][E]) &&
                        (H |= B << D);
                  var V = W.readBit(z, H);
                  j[P] = V;
                }
            }
            return q;
          }
          function decodeRefinement(t, r, i, o, l, c, h, p, m) {
            var g = a[i].coding;
            0 === i && (g = g.concat([p[0]]));
            var b,
              y = g.length,
              v = new Int32Array(y),
              S = new Int32Array(y);
            for (b = 0; b < y; b++) (v[b] = g[b].x), (S[b] = g[b].y);
            var k = a[i].reference;
            0 === i && (k = k.concat([p[1]]));
            var w = k.length,
              C = new Int32Array(w),
              x = new Int32Array(w);
            for (b = 0; b < w; b++) (C[b] = k[b].x), (x[b] = k[b].y);
            for (
              var _ = o[0].length,
                A = o.length,
                R = d[i],
                T = [],
                I = m.decoder,
                P = m.contextCache.getContexts("GR"),
                O = 0,
                E = 0;
              E < r;
              E++
            ) {
              if (h)
                if ((O ^= I.readBit(P, R)))
                  throw new u("prediction is not supported");
              var B = new Uint8Array(t);
              T.push(B);
              for (var D = 0; D < t; D++) {
                var M,
                  L,
                  N = 0;
                for (b = 0; b < y; b++)
                  (M = E + S[b]),
                    (L = D + v[b]),
                    M < 0 || L < 0 || L >= t
                      ? (N <<= 1)
                      : (N = (N << 1) | T[M][L]);
                for (b = 0; b < w; b++)
                  (M = E + x[b] - c),
                    (L = D + C[b] - l),
                    M < 0 || M >= A || L < 0 || L >= _
                      ? (N <<= 1)
                      : (N = (N << 1) | o[M][L]);
                var U = I.readBit(P, N);
                B[D] = U;
              }
            }
            return T;
          }
          function decodeTextRegion(
            t,
            r,
            a,
            i,
            o,
            l,
            c,
            h,
            d,
            p,
            m,
            g,
            b,
            y,
            v,
            S,
            k,
            w,
            C,
          ) {
            if (t && r) throw new u("refinement with Huffman is not supported");
            var x,
              _,
              A = [];
            for (x = 0; x < i; x++) {
              if (((_ = new Uint8Array(a)), o))
                for (var R = 0; R < a; R++) _[R] = o;
              A.push(_);
            }
            var T = k.decoder,
              I = k.contextCache,
              P = t ? -y.tableDeltaT.decode(C) : -decodeInteger(I, "IADT", T),
              O = 0;
            for (x = 0; x < l; ) {
              P += t ? y.tableDeltaT.decode(C) : decodeInteger(I, "IADT", T);
              for (
                var E = (O += t
                  ? y.tableFirstS.decode(C)
                  : decodeInteger(I, "IAFS", T));
                ;

              ) {
                var B = 0;
                c > 1 && (B = t ? C.readBits(w) : decodeInteger(I, "IAIT", T));
                var D = c * P + B,
                  M = t ? y.symbolIDTable.decode(C) : decodeIAID(I, T, d),
                  L = r && (t ? C.readBit() : decodeInteger(I, "IARI", T)),
                  N = h[M],
                  U = N[0].length,
                  j = N.length;
                if (L) {
                  var q = decodeInteger(I, "IARDW", T),
                    W = decodeInteger(I, "IARDH", T);
                  N = decodeRefinement(
                    (U += q),
                    (j += W),
                    v,
                    N,
                    (q >> 1) + decodeInteger(I, "IARDX", T),
                    (W >> 1) + decodeInteger(I, "IARDY", T),
                    !1,
                    S,
                    k,
                  );
                }
                var z,
                  G,
                  H,
                  X = D - (1 & g ? 0 : j - 1),
                  V = E - (2 & g ? U - 1 : 0);
                if (p) {
                  for (z = 0; z < j; z++)
                    if ((_ = A[V + z])) {
                      H = N[z];
                      var Y = Math.min(a - X, U);
                      switch (b) {
                        case 0:
                          for (G = 0; G < Y; G++) _[X + G] |= H[G];
                          break;
                        case 2:
                          for (G = 0; G < Y; G++) _[X + G] ^= H[G];
                          break;
                        default:
                          throw new u(
                            "operator ".concat(b, " is not supported"),
                          );
                      }
                    }
                  E += j - 1;
                } else {
                  for (G = 0; G < j; G++)
                    if ((_ = A[X + G]))
                      switch (((H = N[G]), b)) {
                        case 0:
                          for (z = 0; z < U; z++) _[V + z] |= H[z];
                          break;
                        case 2:
                          for (z = 0; z < U; z++) _[V + z] ^= H[z];
                          break;
                        default:
                          throw new u(
                            "operator ".concat(b, " is not supported"),
                          );
                      }
                  E += U - 1;
                }
                x++;
                var K = t
                  ? y.tableDeltaS.decode(C)
                  : decodeInteger(I, "IADS", T);
                if (null === K) break;
                E += K + m;
              }
            }
            return A;
          }
          function readSegmentHeader(r, a) {
            var i = {};
            i.number = (0, o.readUint32)(r, a);
            var l = r[a + 4],
              c = 63 & l;
            if (!t[c]) throw new u("invalid segment type: " + c);
            (i.type = c),
              (i.typeName = t[c]),
              (i.deferredNonRetain = !!(128 & l));
            var h = !!(64 & l),
              d = r[a + 5],
              m = (d >> 5) & 7,
              g = [31 & d],
              b = a + 6;
            if (7 === d) {
              (m = 536870911 & (0, o.readUint32)(r, b - 1)), (b += 3);
              var y = (m + 7) >> 3;
              for (g[0] = r[b++]; --y > 0; ) g.push(r[b++]);
            } else if (5 === d || 6 === d)
              throw new u("invalid referred-to flags");
            i.retainBits = g;
            var v = 4;
            i.number <= 256 ? (v = 1) : i.number <= 65536 && (v = 2);
            var S,
              k,
              w = [];
            for (S = 0; S < m; S++) {
              var C = void 0;
              (C =
                1 === v
                  ? r[b]
                  : 2 === v
                  ? (0, o.readUint16)(r, b)
                  : (0, o.readUint32)(r, b)),
                w.push(C),
                (b += v);
            }
            if (
              ((i.referredTo = w),
              h
                ? ((i.pageAssociation = (0, o.readUint32)(r, b)), (b += 4))
                : (i.pageAssociation = r[b++]),
              (i.length = (0, o.readUint32)(r, b)),
              (b += 4),
              4294967295 === i.length)
            ) {
              if (38 !== c) throw new u("invalid unknown segment length");
              var x = readRegionSegmentInformation(r, b),
                _ = !!(1 & r[b + p]),
                A = new Uint8Array(6);
              for (
                _ || ((A[0] = 255), (A[1] = 172)),
                  A[2] = (x.height >>> 24) & 255,
                  A[3] = (x.height >> 16) & 255,
                  A[4] = (x.height >> 8) & 255,
                  A[5] = 255 & x.height,
                  S = b,
                  k = r.length;
                S < k;
                S++
              ) {
                for (var R = 0; R < 6 && A[R] === r[S + R]; ) R++;
                if (6 === R) {
                  i.length = S + 6;
                  break;
                }
              }
              if (4294967295 === i.length)
                throw new u("segment end was not found");
            }
            return (i.headerEnd = b), i;
          }
          function readSegments(t, r, a, i) {
            for (var o = [], l = a; l < i; ) {
              var c = readSegmentHeader(r, l);
              l = c.headerEnd;
              var u = { header: c, data: r };
              if (
                (t.randomAccess ||
                  ((u.start = l), (l += c.length), (u.end = l)),
                o.push(u),
                51 === c.type)
              )
                break;
            }
            if (t.randomAccess)
              for (var h = 0, d = o.length; h < d; h++)
                (o[h].start = l), (l += o[h].header.length), (o[h].end = l);
            return o;
          }
          function readRegionSegmentInformation(t, r) {
            return {
              width: (0, o.readUint32)(t, r),
              height: (0, o.readUint32)(t, r + 4),
              x: (0, o.readUint32)(t, r + 8),
              y: (0, o.readUint32)(t, r + 12),
              combinationOperator: 7 & t[r + 16],
            };
          }
          var p = 17;
          function processSegment(t, r) {
            var a,
              i,
              l,
              c,
              h = t.header,
              d = t.data,
              m = t.start,
              g = t.end;
            switch (h.type) {
              case 0:
                var b = {},
                  y = (0, o.readUint16)(d, m);
                if (
                  ((b.huffman = !!(1 & y)),
                  (b.refinement = !!(2 & y)),
                  (b.huffmanDHSelector = (y >> 2) & 3),
                  (b.huffmanDWSelector = (y >> 4) & 3),
                  (b.bitmapSizeSelector = (y >> 6) & 1),
                  (b.aggregationInstancesSelector = (y >> 7) & 1),
                  (b.bitmapCodingContextUsed = !!(256 & y)),
                  (b.bitmapCodingContextRetained = !!(512 & y)),
                  (b.template = (y >> 10) & 3),
                  (b.refinementTemplate = (y >> 12) & 1),
                  (m += 2),
                  !b.huffman)
                ) {
                  for (c = 0 === b.template ? 4 : 1, i = [], l = 0; l < c; l++)
                    i.push({
                      x: (0, o.readInt8)(d, m),
                      y: (0, o.readInt8)(d, m + 1),
                    }),
                      (m += 2);
                  b.at = i;
                }
                if (b.refinement && !b.refinementTemplate) {
                  for (i = [], l = 0; l < 2; l++)
                    i.push({
                      x: (0, o.readInt8)(d, m),
                      y: (0, o.readInt8)(d, m + 1),
                    }),
                      (m += 2);
                  b.refinementAt = i;
                }
                (b.numberOfExportedSymbols = (0, o.readUint32)(d, m)),
                  (m += 4),
                  (b.numberOfNewSymbols = (0, o.readUint32)(d, m)),
                  (m += 4),
                  (a = [b, h.number, h.referredTo, d, m, g]);
                break;
              case 6:
              case 7:
                var v = {};
                (v.info = readRegionSegmentInformation(d, m)), (m += p);
                var S = (0, o.readUint16)(d, m);
                if (
                  ((m += 2),
                  (v.huffman = !!(1 & S)),
                  (v.refinement = !!(2 & S)),
                  (v.logStripSize = (S >> 2) & 3),
                  (v.stripSize = 1 << v.logStripSize),
                  (v.referenceCorner = (S >> 4) & 3),
                  (v.transposed = !!(64 & S)),
                  (v.combinationOperator = (S >> 7) & 3),
                  (v.defaultPixelValue = (S >> 9) & 1),
                  (v.dsOffset = (S << 17) >> 27),
                  (v.refinementTemplate = (S >> 15) & 1),
                  v.huffman)
                ) {
                  var k = (0, o.readUint16)(d, m);
                  (m += 2),
                    (v.huffmanFS = 3 & k),
                    (v.huffmanDS = (k >> 2) & 3),
                    (v.huffmanDT = (k >> 4) & 3),
                    (v.huffmanRefinementDW = (k >> 6) & 3),
                    (v.huffmanRefinementDH = (k >> 8) & 3),
                    (v.huffmanRefinementDX = (k >> 10) & 3),
                    (v.huffmanRefinementDY = (k >> 12) & 3),
                    (v.huffmanRefinementSizeSelector = !!(16384 & k));
                }
                if (v.refinement && !v.refinementTemplate) {
                  for (i = [], l = 0; l < 2; l++)
                    i.push({
                      x: (0, o.readInt8)(d, m),
                      y: (0, o.readInt8)(d, m + 1),
                    }),
                      (m += 2);
                  v.refinementAt = i;
                }
                (v.numberOfSymbolInstances = (0, o.readUint32)(d, m)),
                  (m += 4),
                  (a = [v, h.referredTo, d, m, g]);
                break;
              case 16:
                var w = {},
                  C = d[m++];
                (w.mmr = !!(1 & C)),
                  (w.template = (C >> 1) & 3),
                  (w.patternWidth = d[m++]),
                  (w.patternHeight = d[m++]),
                  (w.maxPatternIndex = (0, o.readUint32)(d, m)),
                  (m += 4),
                  (a = [w, h.number, d, m, g]);
                break;
              case 22:
              case 23:
                var x = {};
                (x.info = readRegionSegmentInformation(d, m)), (m += p);
                var _ = d[m++];
                (x.mmr = !!(1 & _)),
                  (x.template = (_ >> 1) & 3),
                  (x.enableSkip = !!(8 & _)),
                  (x.combinationOperator = (_ >> 4) & 7),
                  (x.defaultPixelValue = (_ >> 7) & 1),
                  (x.gridWidth = (0, o.readUint32)(d, m)),
                  (m += 4),
                  (x.gridHeight = (0, o.readUint32)(d, m)),
                  (m += 4),
                  (x.gridOffsetX = 4294967295 & (0, o.readUint32)(d, m)),
                  (m += 4),
                  (x.gridOffsetY = 4294967295 & (0, o.readUint32)(d, m)),
                  (m += 4),
                  (x.gridVectorX = (0, o.readUint16)(d, m)),
                  (m += 2),
                  (x.gridVectorY = (0, o.readUint16)(d, m)),
                  (m += 2),
                  (a = [x, h.referredTo, d, m, g]);
                break;
              case 38:
              case 39:
                var A = {};
                (A.info = readRegionSegmentInformation(d, m)), (m += p);
                var R = d[m++];
                if (
                  ((A.mmr = !!(1 & R)),
                  (A.template = (R >> 1) & 3),
                  (A.prediction = !!(8 & R)),
                  !A.mmr)
                ) {
                  for (c = 0 === A.template ? 4 : 1, i = [], l = 0; l < c; l++)
                    i.push({
                      x: (0, o.readInt8)(d, m),
                      y: (0, o.readInt8)(d, m + 1),
                    }),
                      (m += 2);
                  A.at = i;
                }
                a = [A, d, m, g];
                break;
              case 48:
                var T = {
                  width: (0, o.readUint32)(d, m),
                  height: (0, o.readUint32)(d, m + 4),
                  resolutionX: (0, o.readUint32)(d, m + 8),
                  resolutionY: (0, o.readUint32)(d, m + 12),
                };
                4294967295 === T.height && delete T.height;
                var I = d[m + 16];
                (0, o.readUint16)(d, m + 17),
                  (T.lossless = !!(1 & I)),
                  (T.refinement = !!(2 & I)),
                  (T.defaultPixelValue = (I >> 2) & 1),
                  (T.combinationOperator = (I >> 3) & 3),
                  (T.requiresBuffer = !!(32 & I)),
                  (T.combinationOperatorOverride = !!(64 & I)),
                  (a = [T]);
                break;
              case 49:
              case 50:
              case 51:
                break;
              case 53:
                a = [h.number, d, m, g];
                break;
              case 62:
                break;
              default:
                throw new u(
                  "segment type ".concat(h.typeName, "(").concat(h.type, ")") +
                    " is not implemented",
                );
            }
            var P = "on" + h.typeName;
            P in r && r[P].apply(r, a);
          }
          function processSegments(t, r) {
            for (var a = 0, i = t.length; a < i; a++) processSegment(t[a], r);
          }
          function SimpleSegmentVisitor() {}
          function HuffmanLine(t) {
            2 === t.length
              ? ((this.isOOB = !0),
                (this.rangeLow = 0),
                (this.prefixLength = t[0]),
                (this.rangeLength = 0),
                (this.prefixCode = t[1]),
                (this.isLowerRange = !1))
              : ((this.isOOB = !1),
                (this.rangeLow = t[0]),
                (this.prefixLength = t[1]),
                (this.rangeLength = t[2]),
                (this.prefixCode = t[3]),
                (this.isLowerRange = "lower" === t[4]));
          }
          function HuffmanTreeNode(t) {
            (this.children = []),
              t
                ? ((this.isLeaf = !0),
                  (this.rangeLength = t.rangeLength),
                  (this.rangeLow = t.rangeLow),
                  (this.isLowerRange = t.isLowerRange),
                  (this.isOOB = t.isOOB))
                : (this.isLeaf = !1);
          }
          function HuffmanTable(t, r) {
            r || this.assignPrefixCodes(t),
              (this.rootNode = new HuffmanTreeNode(null));
            for (var a = 0, i = t.length; a < i; a++) {
              var o = t[a];
              o.prefixLength > 0 &&
                this.rootNode.buildTree(o, o.prefixLength - 1);
            }
          }
          (SimpleSegmentVisitor.prototype = {
            onPageInformation: function SimpleSegmentVisitor_onPageInformation(
              t,
            ) {
              this.currentPageInfo = t;
              var r = (t.width + 7) >> 3,
                a = new Uint8ClampedArray(r * t.height);
              if (t.defaultPixelValue)
                for (var i = 0, o = a.length; i < o; i++) a[i] = 255;
              this.buffer = a;
            },
            drawBitmap: function SimpleSegmentVisitor_drawBitmap(t, r) {
              var a,
                i,
                o,
                l,
                c = this.currentPageInfo,
                h = t.width,
                d = t.height,
                p = (c.width + 7) >> 3,
                m = c.combinationOperatorOverride
                  ? t.combinationOperator
                  : c.combinationOperator,
                g = this.buffer,
                b = 128 >> (7 & t.x),
                y = t.y * p + (t.x >> 3);
              switch (m) {
                case 0:
                  for (a = 0; a < d; a++) {
                    for (o = b, l = y, i = 0; i < h; i++)
                      r[a][i] && (g[l] |= o), (o >>= 1) || ((o = 128), l++);
                    y += p;
                  }
                  break;
                case 2:
                  for (a = 0; a < d; a++) {
                    for (o = b, l = y, i = 0; i < h; i++)
                      r[a][i] && (g[l] ^= o), (o >>= 1) || ((o = 128), l++);
                    y += p;
                  }
                  break;
                default:
                  throw new u("operator ".concat(m, " is not supported"));
              }
            },
            onImmediateGenericRegion:
              function SimpleSegmentVisitor_onImmediateGenericRegion(
                t,
                r,
                a,
                i,
              ) {
                var o = t.info,
                  l = new DecodingContext(r, a, i),
                  c = decodeBitmap(
                    t.mmr,
                    o.width,
                    o.height,
                    t.template,
                    t.prediction,
                    null,
                    t.at,
                    l,
                  );
                this.drawBitmap(o, c);
              },
            onImmediateLosslessGenericRegion:
              function SimpleSegmentVisitor_onImmediateLosslessGenericRegion() {
                this.onImmediateGenericRegion.apply(this, arguments);
              },
            onSymbolDictionary:
              function SimpleSegmentVisitor_onSymbolDictionary(
                t,
                r,
                a,
                i,
                l,
                c,
              ) {
                var h, d;
                t.huffman &&
                  ((h = (function getSymbolDictionaryHuffmanTables(t, r, a) {
                    var i,
                      o,
                      l,
                      c,
                      h = 0;
                    switch (t.huffmanDHSelector) {
                      case 0:
                      case 1:
                        i = getStandardTable(t.huffmanDHSelector + 4);
                        break;
                      case 3:
                        (i = getCustomHuffmanTable(h, r, a)), h++;
                        break;
                      default:
                        throw new u("invalid Huffman DH selector");
                    }
                    switch (t.huffmanDWSelector) {
                      case 0:
                      case 1:
                        o = getStandardTable(t.huffmanDWSelector + 2);
                        break;
                      case 3:
                        (o = getCustomHuffmanTable(h, r, a)), h++;
                        break;
                      default:
                        throw new u("invalid Huffman DW selector");
                    }
                    t.bitmapSizeSelector
                      ? ((l = getCustomHuffmanTable(h, r, a)), h++)
                      : (l = getStandardTable(1));
                    c = t.aggregationInstancesSelector
                      ? getCustomHuffmanTable(h, r, a)
                      : getStandardTable(1);
                    return {
                      tableDeltaHeight: i,
                      tableDeltaWidth: o,
                      tableBitmapSize: l,
                      tableAggregateInstances: c,
                    };
                  })(t, a, this.customTables)),
                  (d = new Reader(i, l, c)));
                var p = this.symbols;
                p || (this.symbols = p = {});
                for (var m = [], g = 0, b = a.length; g < b; g++) {
                  var y = p[a[g]];
                  y && (m = m.concat(y));
                }
                var v = new DecodingContext(i, l, c);
                p[r] = (function decodeSymbolDictionary(
                  t,
                  r,
                  a,
                  i,
                  l,
                  c,
                  h,
                  d,
                  p,
                  m,
                  g,
                  b,
                ) {
                  if (t && r)
                    throw new u(
                      "symbol refinement with Huffman is not supported",
                    );
                  var y,
                    v,
                    S = [],
                    k = 0,
                    w = (0, o.log2)(a.length + i),
                    C = g.decoder,
                    x = g.contextCache;
                  for (
                    t &&
                    ((y = getStandardTable(1)), (v = []), (w = Math.max(w, 1)));
                    S.length < i;

                  ) {
                    k += t
                      ? c.tableDeltaHeight.decode(b)
                      : decodeInteger(x, "IADH", C);
                    for (var _ = 0, A = 0, R = t ? v.length : 0; ; ) {
                      var T,
                        I = t
                          ? c.tableDeltaWidth.decode(b)
                          : decodeInteger(x, "IADW", C);
                      if (null === I) break;
                      if (((A += _ += I), r)) {
                        var P = decodeInteger(x, "IAAI", C);
                        if (P > 1)
                          T = decodeTextRegion(
                            t,
                            r,
                            _,
                            k,
                            0,
                            P,
                            1,
                            a.concat(S),
                            w,
                            0,
                            0,
                            1,
                            0,
                            c,
                            p,
                            m,
                            g,
                            0,
                            b,
                          );
                        else {
                          var O = decodeIAID(x, C, w),
                            E = decodeInteger(x, "IARDX", C),
                            B = decodeInteger(x, "IARDY", C);
                          T = decodeRefinement(
                            _,
                            k,
                            p,
                            O < a.length ? a[O] : S[O - a.length],
                            E,
                            B,
                            !1,
                            m,
                            g,
                          );
                        }
                        S.push(T);
                      } else
                        t
                          ? v.push(_)
                          : ((T = decodeBitmap(!1, _, k, h, !1, null, d, g)),
                            S.push(T));
                    }
                    if (t && !r) {
                      var D = c.tableBitmapSize.decode(b);
                      b.byteAlign();
                      var M = void 0;
                      if (0 === D) M = readUncompressedBitmap(b, A, k);
                      else {
                        var L = b.end,
                          N = b.position + D;
                        (b.end = N),
                          (M = decodeMMRBitmap(b, A, k, !1)),
                          (b.end = L),
                          (b.position = N);
                      }
                      var U = v.length;
                      if (R === U - 1) S.push(M);
                      else {
                        var j = void 0,
                          q = void 0,
                          W = 0,
                          z = void 0,
                          G = void 0;
                        for (j = R; j < U; j++) {
                          for (z = W + v[j], G = [], q = 0; q < k; q++)
                            G.push(M[q].subarray(W, z));
                          S.push(G), (W = z);
                        }
                      }
                    }
                  }
                  for (
                    var H = [], X = [], V = !1, Y = a.length + i;
                    X.length < Y;

                  ) {
                    for (
                      var K = t ? y.decode(b) : decodeInteger(x, "IAEX", C);
                      K--;

                    )
                      X.push(V);
                    V = !V;
                  }
                  for (var J = 0, Z = a.length; J < Z; J++)
                    X[J] && H.push(a[J]);
                  for (var Q = 0; Q < i; J++, Q++) X[J] && H.push(S[Q]);
                  return H;
                })(
                  t.huffman,
                  t.refinement,
                  m,
                  t.numberOfNewSymbols,
                  t.numberOfExportedSymbols,
                  h,
                  t.template,
                  t.at,
                  t.refinementTemplate,
                  t.refinementAt,
                  v,
                  d,
                );
              },
            onImmediateTextRegion:
              function SimpleSegmentVisitor_onImmediateTextRegion(
                t,
                r,
                a,
                i,
                l,
              ) {
                for (
                  var c,
                    h,
                    d = t.info,
                    p = this.symbols,
                    m = [],
                    g = 0,
                    b = r.length;
                  g < b;
                  g++
                ) {
                  var y = p[r[g]];
                  y && (m = m.concat(y));
                }
                var v = (0, o.log2)(m.length);
                t.huffman &&
                  ((h = new Reader(a, i, l)),
                  (c = (function getTextRegionHuffmanTables(t, r, a, i, o) {
                    for (var l = [], c = 0; c <= 34; c++) {
                      var h = o.readBits(4);
                      l.push(new HuffmanLine([c, h, 0, 0]));
                    }
                    var d = new HuffmanTable(l, !1);
                    l.length = 0;
                    for (var p = 0; p < i; ) {
                      var m = d.decode(o);
                      if (m >= 32) {
                        var g = void 0,
                          b = void 0,
                          y = void 0;
                        switch (m) {
                          case 32:
                            if (0 === p)
                              throw new u(
                                "no previous value in symbol ID table",
                              );
                            (b = o.readBits(2) + 3),
                              (g = l[p - 1].prefixLength);
                            break;
                          case 33:
                            (b = o.readBits(3) + 3), (g = 0);
                            break;
                          case 34:
                            (b = o.readBits(7) + 11), (g = 0);
                            break;
                          default:
                            throw new u(
                              "invalid code length in symbol ID table",
                            );
                        }
                        for (y = 0; y < b; y++)
                          l.push(new HuffmanLine([p, g, 0, 0])), p++;
                      } else l.push(new HuffmanLine([p, m, 0, 0])), p++;
                    }
                    o.byteAlign();
                    var v,
                      S,
                      k,
                      w = new HuffmanTable(l, !1),
                      C = 0;
                    switch (t.huffmanFS) {
                      case 0:
                      case 1:
                        v = getStandardTable(t.huffmanFS + 6);
                        break;
                      case 3:
                        (v = getCustomHuffmanTable(C, r, a)), C++;
                        break;
                      default:
                        throw new u("invalid Huffman FS selector");
                    }
                    switch (t.huffmanDS) {
                      case 0:
                      case 1:
                      case 2:
                        S = getStandardTable(t.huffmanDS + 8);
                        break;
                      case 3:
                        (S = getCustomHuffmanTable(C, r, a)), C++;
                        break;
                      default:
                        throw new u("invalid Huffman DS selector");
                    }
                    switch (t.huffmanDT) {
                      case 0:
                      case 1:
                      case 2:
                        k = getStandardTable(t.huffmanDT + 11);
                        break;
                      case 3:
                        (k = getCustomHuffmanTable(C, r, a)), C++;
                        break;
                      default:
                        throw new u("invalid Huffman DT selector");
                    }
                    if (t.refinement)
                      throw new u("refinement with Huffman is not supported");
                    return {
                      symbolIDTable: w,
                      tableFirstS: v,
                      tableDeltaS: S,
                      tableDeltaT: k,
                    };
                  })(t, r, this.customTables, m.length, h)));
                var S = new DecodingContext(a, i, l),
                  k = decodeTextRegion(
                    t.huffman,
                    t.refinement,
                    d.width,
                    d.height,
                    t.defaultPixelValue,
                    t.numberOfSymbolInstances,
                    t.stripSize,
                    m,
                    v,
                    t.transposed,
                    t.dsOffset,
                    t.referenceCorner,
                    t.combinationOperator,
                    c,
                    t.refinementTemplate,
                    t.refinementAt,
                    S,
                    t.logStripSize,
                    h,
                  );
                this.drawBitmap(d, k);
              },
            onImmediateLosslessTextRegion:
              function SimpleSegmentVisitor_onImmediateLosslessTextRegion() {
                this.onImmediateTextRegion.apply(this, arguments);
              },
            onPatternDictionary: function onPatternDictionary(t, r, a, i, o) {
              var l = this.patterns;
              l || (this.patterns = l = {});
              var c = new DecodingContext(a, i, o);
              l[r] = (function decodePatternDictionary(t, r, a, i, o, l) {
                var c = [];
                t ||
                  (c.push({ x: -r, y: 0 }),
                  0 === o &&
                    (c.push({ x: -3, y: -1 }),
                    c.push({ x: 2, y: -2 }),
                    c.push({ x: -2, y: -2 })));
                for (
                  var u = decodeBitmap(t, (i + 1) * r, a, o, !1, null, c, l),
                    h = [],
                    d = 0;
                  d <= i;
                  d++
                ) {
                  for (var p = [], m = r * d, g = m + r, b = 0; b < a; b++)
                    p.push(u[b].subarray(m, g));
                  h.push(p);
                }
                return h;
              })(
                t.mmr,
                t.patternWidth,
                t.patternHeight,
                t.maxPatternIndex,
                t.template,
                c,
              );
            },
            onImmediateHalftoneRegion: function onImmediateHalftoneRegion(
              t,
              r,
              a,
              i,
              l,
            ) {
              var c = this.patterns[r[0]],
                h = t.info,
                d = new DecodingContext(a, i, l),
                p = (function decodeHalftoneRegion(
                  t,
                  r,
                  a,
                  i,
                  l,
                  c,
                  h,
                  d,
                  p,
                  m,
                  g,
                  b,
                  y,
                  v,
                  S,
                ) {
                  if (h) throw new u("skip is not supported");
                  if (0 !== d)
                    throw new u(
                      "operator " + d + " is not supported in halftone region",
                    );
                  var k,
                    w,
                    C,
                    x = [];
                  for (k = 0; k < l; k++) {
                    if (((C = new Uint8Array(i)), c))
                      for (w = 0; w < i; w++) C[w] = c;
                    x.push(C);
                  }
                  var _ = r.length,
                    A = r[0],
                    R = A[0].length,
                    T = A.length,
                    I = (0, o.log2)(_),
                    P = [];
                  t ||
                    (P.push({ x: a <= 1 ? 3 : 2, y: -1 }),
                    0 === a &&
                      (P.push({ x: -3, y: -1 }),
                      P.push({ x: 2, y: -2 }),
                      P.push({ x: -2, y: -2 })));
                  var O,
                    E,
                    B,
                    D,
                    M,
                    L,
                    N,
                    U,
                    j,
                    q,
                    W,
                    z = [];
                  for (
                    t && (O = new Reader(S.data, S.start, S.end)), k = I - 1;
                    k >= 0;
                    k--
                  )
                    (E = t
                      ? decodeMMRBitmap(O, p, m, !0)
                      : decodeBitmap(!1, p, m, a, !1, null, P, S)),
                      (z[k] = E);
                  for (B = 0; B < m; B++)
                    for (D = 0; D < p; D++) {
                      for (M = 0, L = 0, w = I - 1; w >= 0; w--)
                        L |= (M = z[w][B][D] ^ M) << w;
                      if (
                        ((N = r[L]),
                        (j = (b + B * y - D * v) >> 8),
                        (U = (g + B * v + D * y) >> 8) >= 0 &&
                          U + R <= i &&
                          j >= 0 &&
                          j + T <= l)
                      )
                        for (k = 0; k < T; k++)
                          for (W = x[j + k], q = N[k], w = 0; w < R; w++)
                            W[U + w] |= q[w];
                      else {
                        var G = void 0,
                          H = void 0;
                        for (k = 0; k < T; k++)
                          if (!((H = j + k) < 0 || H >= l))
                            for (W = x[H], q = N[k], w = 0; w < R; w++)
                              (G = U + w) >= 0 && G < i && (W[G] |= q[w]);
                      }
                    }
                  return x;
                })(
                  t.mmr,
                  c,
                  t.template,
                  h.width,
                  h.height,
                  t.defaultPixelValue,
                  t.enableSkip,
                  t.combinationOperator,
                  t.gridWidth,
                  t.gridHeight,
                  t.gridOffsetX,
                  t.gridOffsetY,
                  t.gridVectorX,
                  t.gridVectorY,
                  d,
                );
              this.drawBitmap(h, p);
            },
            onImmediateLosslessHalftoneRegion:
              function onImmediateLosslessHalftoneRegion() {
                this.onImmediateHalftoneRegion.apply(this, arguments);
              },
            onTables: function onTables(t, r, a, i) {
              var l = this.customTables;
              l || (this.customTables = l = {}),
                (l[t] = (function decodeTablesSegment(t, r, a) {
                  var i,
                    l,
                    c = t[r],
                    u = 4294967295 & (0, o.readUint32)(t, r + 1),
                    h = 4294967295 & (0, o.readUint32)(t, r + 5),
                    d = new Reader(t, r + 9, a),
                    p = 1 + ((c >> 1) & 7),
                    m = 1 + ((c >> 4) & 7),
                    g = [],
                    b = u;
                  do {
                    (i = d.readBits(p)),
                      (l = d.readBits(m)),
                      g.push(new HuffmanLine([b, i, l, 0])),
                      (b += 1 << l);
                  } while (b < h);
                  (i = d.readBits(p)),
                    g.push(new HuffmanLine([u - 1, i, 32, 0, "lower"])),
                    (i = d.readBits(p)),
                    g.push(new HuffmanLine([h, i, 32, 0])),
                    1 & c &&
                      ((i = d.readBits(p)), g.push(new HuffmanLine([i, 0])));
                  return new HuffmanTable(g, !1);
                })(r, a, i));
            },
          }),
            (HuffmanTreeNode.prototype = {
              buildTree: function buildTree(t, r) {
                var a = (t.prefixCode >> r) & 1;
                if (r <= 0) this.children[a] = new HuffmanTreeNode(t);
                else {
                  var i = this.children[a];
                  i || (this.children[a] = i = new HuffmanTreeNode(null)),
                    i.buildTree(t, r - 1);
                }
              },
              decodeNode: function decodeNode(t) {
                if (this.isLeaf) {
                  if (this.isOOB) return null;
                  var r = t.readBits(this.rangeLength);
                  return this.rangeLow + (this.isLowerRange ? -r : r);
                }
                var a = this.children[t.readBit()];
                if (!a) throw new u("invalid Huffman data");
                return a.decodeNode(t);
              },
            }),
            (HuffmanTable.prototype = {
              decode: function decode(t) {
                return this.rootNode.decodeNode(t);
              },
              assignPrefixCodes: function assignPrefixCodes(t) {
                for (var r = t.length, a = 0, i = 0; i < r; i++)
                  a = Math.max(a, t[i].prefixLength);
                for (var o = new Uint32Array(a + 1), l = 0; l < r; l++)
                  o[t[l].prefixLength]++;
                var c,
                  u,
                  h,
                  d = 1,
                  p = 0;
                for (o[0] = 0; d <= a; ) {
                  for (c = p = (p + o[d - 1]) << 1, u = 0; u < r; )
                    (h = t[u]).prefixLength === d && ((h.prefixCode = c), c++),
                      u++;
                  d++;
                }
              },
            });
          var m = {};
          function getStandardTable(t) {
            var r,
              a = m[t];
            if (a) return a;
            switch (t) {
              case 1:
                r = [
                  [0, 1, 4, 0],
                  [16, 2, 8, 2],
                  [272, 3, 16, 6],
                  [65808, 3, 32, 7],
                ];
                break;
              case 2:
                r = [
                  [0, 1, 0, 0],
                  [1, 2, 0, 2],
                  [2, 3, 0, 6],
                  [3, 4, 3, 14],
                  [11, 5, 6, 30],
                  [75, 6, 32, 62],
                  [6, 63],
                ];
                break;
              case 3:
                r = [
                  [-256, 8, 8, 254],
                  [0, 1, 0, 0],
                  [1, 2, 0, 2],
                  [2, 3, 0, 6],
                  [3, 4, 3, 14],
                  [11, 5, 6, 30],
                  [-257, 8, 32, 255, "lower"],
                  [75, 7, 32, 126],
                  [6, 62],
                ];
                break;
              case 4:
                r = [
                  [1, 1, 0, 0],
                  [2, 2, 0, 2],
                  [3, 3, 0, 6],
                  [4, 4, 3, 14],
                  [12, 5, 6, 30],
                  [76, 5, 32, 31],
                ];
                break;
              case 5:
                r = [
                  [-255, 7, 8, 126],
                  [1, 1, 0, 0],
                  [2, 2, 0, 2],
                  [3, 3, 0, 6],
                  [4, 4, 3, 14],
                  [12, 5, 6, 30],
                  [-256, 7, 32, 127, "lower"],
                  [76, 6, 32, 62],
                ];
                break;
              case 6:
                r = [
                  [-2048, 5, 10, 28],
                  [-1024, 4, 9, 8],
                  [-512, 4, 8, 9],
                  [-256, 4, 7, 10],
                  [-128, 5, 6, 29],
                  [-64, 5, 5, 30],
                  [-32, 4, 5, 11],
                  [0, 2, 7, 0],
                  [128, 3, 7, 2],
                  [256, 3, 8, 3],
                  [512, 4, 9, 12],
                  [1024, 4, 10, 13],
                  [-2049, 6, 32, 62, "lower"],
                  [2048, 6, 32, 63],
                ];
                break;
              case 7:
                r = [
                  [-1024, 4, 9, 8],
                  [-512, 3, 8, 0],
                  [-256, 4, 7, 9],
                  [-128, 5, 6, 26],
                  [-64, 5, 5, 27],
                  [-32, 4, 5, 10],
                  [0, 4, 5, 11],
                  [32, 5, 5, 28],
                  [64, 5, 6, 29],
                  [128, 4, 7, 12],
                  [256, 3, 8, 1],
                  [512, 3, 9, 2],
                  [1024, 3, 10, 3],
                  [-1025, 5, 32, 30, "lower"],
                  [2048, 5, 32, 31],
                ];
                break;
              case 8:
                r = [
                  [-15, 8, 3, 252],
                  [-7, 9, 1, 508],
                  [-5, 8, 1, 253],
                  [-3, 9, 0, 509],
                  [-2, 7, 0, 124],
                  [-1, 4, 0, 10],
                  [0, 2, 1, 0],
                  [2, 5, 0, 26],
                  [3, 6, 0, 58],
                  [4, 3, 4, 4],
                  [20, 6, 1, 59],
                  [22, 4, 4, 11],
                  [38, 4, 5, 12],
                  [70, 5, 6, 27],
                  [134, 5, 7, 28],
                  [262, 6, 7, 60],
                  [390, 7, 8, 125],
                  [646, 6, 10, 61],
                  [-16, 9, 32, 510, "lower"],
                  [1670, 9, 32, 511],
                  [2, 1],
                ];
                break;
              case 9:
                r = [
                  [-31, 8, 4, 252],
                  [-15, 9, 2, 508],
                  [-11, 8, 2, 253],
                  [-7, 9, 1, 509],
                  [-5, 7, 1, 124],
                  [-3, 4, 1, 10],
                  [-1, 3, 1, 2],
                  [1, 3, 1, 3],
                  [3, 5, 1, 26],
                  [5, 6, 1, 58],
                  [7, 3, 5, 4],
                  [39, 6, 2, 59],
                  [43, 4, 5, 11],
                  [75, 4, 6, 12],
                  [139, 5, 7, 27],
                  [267, 5, 8, 28],
                  [523, 6, 8, 60],
                  [779, 7, 9, 125],
                  [1291, 6, 11, 61],
                  [-32, 9, 32, 510, "lower"],
                  [3339, 9, 32, 511],
                  [2, 0],
                ];
                break;
              case 10:
                r = [
                  [-21, 7, 4, 122],
                  [-5, 8, 0, 252],
                  [-4, 7, 0, 123],
                  [-3, 5, 0, 24],
                  [-2, 2, 2, 0],
                  [2, 5, 0, 25],
                  [3, 6, 0, 54],
                  [4, 7, 0, 124],
                  [5, 8, 0, 253],
                  [6, 2, 6, 1],
                  [70, 5, 5, 26],
                  [102, 6, 5, 55],
                  [134, 6, 6, 56],
                  [198, 6, 7, 57],
                  [326, 6, 8, 58],
                  [582, 6, 9, 59],
                  [1094, 6, 10, 60],
                  [2118, 7, 11, 125],
                  [-22, 8, 32, 254, "lower"],
                  [4166, 8, 32, 255],
                  [2, 2],
                ];
                break;
              case 11:
                r = [
                  [1, 1, 0, 0],
                  [2, 2, 1, 2],
                  [4, 4, 0, 12],
                  [5, 4, 1, 13],
                  [7, 5, 1, 28],
                  [9, 5, 2, 29],
                  [13, 6, 2, 60],
                  [17, 7, 2, 122],
                  [21, 7, 3, 123],
                  [29, 7, 4, 124],
                  [45, 7, 5, 125],
                  [77, 7, 6, 126],
                  [141, 7, 32, 127],
                ];
                break;
              case 12:
                r = [
                  [1, 1, 0, 0],
                  [2, 2, 0, 2],
                  [3, 3, 1, 6],
                  [5, 5, 0, 28],
                  [6, 5, 1, 29],
                  [8, 6, 1, 60],
                  [10, 7, 0, 122],
                  [11, 7, 1, 123],
                  [13, 7, 2, 124],
                  [17, 7, 3, 125],
                  [25, 7, 4, 126],
                  [41, 8, 5, 254],
                  [73, 8, 32, 255],
                ];
                break;
              case 13:
                r = [
                  [1, 1, 0, 0],
                  [2, 3, 0, 4],
                  [3, 4, 0, 12],
                  [4, 5, 0, 28],
                  [5, 4, 1, 13],
                  [7, 3, 3, 5],
                  [15, 6, 1, 58],
                  [17, 6, 2, 59],
                  [21, 6, 3, 60],
                  [29, 6, 4, 61],
                  [45, 6, 5, 62],
                  [77, 7, 6, 126],
                  [141, 7, 32, 127],
                ];
                break;
              case 14:
                r = [
                  [-2, 3, 0, 4],
                  [-1, 3, 0, 5],
                  [0, 1, 0, 0],
                  [1, 3, 0, 6],
                  [2, 3, 0, 7],
                ];
                break;
              case 15:
                r = [
                  [-24, 7, 4, 124],
                  [-8, 6, 2, 60],
                  [-4, 5, 1, 28],
                  [-2, 4, 0, 12],
                  [-1, 3, 0, 4],
                  [0, 1, 0, 0],
                  [1, 3, 0, 5],
                  [2, 4, 0, 13],
                  [3, 5, 1, 29],
                  [5, 6, 2, 61],
                  [9, 7, 4, 125],
                  [-25, 7, 32, 126, "lower"],
                  [25, 7, 32, 127],
                ];
                break;
              default:
                throw new u("standard table B.".concat(t, " does not exist"));
            }
            for (var i = 0, o = r.length; i < o; i++)
              r[i] = new HuffmanLine(r[i]);
            return (a = new HuffmanTable(r, !0)), (m[t] = a), a;
          }
          function Reader(t, r, a) {
            (this.data = t),
              (this.start = r),
              (this.end = a),
              (this.position = r),
              (this.shift = -1),
              (this.currentByte = 0);
          }
          function getCustomHuffmanTable(t, r, a) {
            for (var i = 0, o = 0, l = r.length; o < l; o++) {
              var c = a[r[o]];
              if (c) {
                if (t === i) return c;
                i++;
              }
            }
            throw new u("can't find custom Huffman table");
          }
          function readUncompressedBitmap(t, r, a) {
            for (var i = [], o = 0; o < a; o++) {
              var l = new Uint8Array(r);
              i.push(l);
              for (var c = 0; c < r; c++) l[c] = t.readBit();
              t.byteAlign();
            }
            return i;
          }
          function decodeMMRBitmap(t, r, a, i) {
            for (
              var o,
                l = { K: -1, Columns: r, Rows: a, BlackIs1: !0, EndOfBlock: i },
                u = new c.CCITTFaxDecoder(t, l),
                h = [],
                d = !1,
                p = 0;
              p < a;
              p++
            ) {
              var m = new Uint8Array(r);
              h.push(m);
              for (var g = -1, b = 0; b < r; b++)
                g < 0 &&
                  (-1 === (o = u.readNextChar()) && ((o = 0), (d = !0)),
                  (g = 7)),
                  (m[b] = (o >> g) & 1),
                  g--;
            }
            if (i && !d) for (var y = 0; y < 5 && -1 !== u.readNextChar(); y++);
            return h;
          }
          function Jbig2Image() {}
          return (
            (Reader.prototype = {
              readBit: function readBit() {
                if (this.shift < 0) {
                  if (this.position >= this.end)
                    throw new u("end of data while reading bit");
                  (this.currentByte = this.data[this.position++]),
                    (this.shift = 7);
                }
                var t = (this.currentByte >> this.shift) & 1;
                return this.shift--, t;
              },
              readBits: function readBits(t) {
                var r,
                  a = 0;
                for (r = t - 1; r >= 0; r--) a |= this.readBit() << r;
                return a;
              },
              byteAlign: function byteAlign() {
                this.shift = -1;
              },
              next: function next() {
                return this.position >= this.end
                  ? -1
                  : this.data[this.position++];
              },
            }),
            (Jbig2Image.prototype = {
              parseChunks: function parseChunks(t) {
                return (function parseJbig2Chunks(t) {
                  for (
                    var r = new SimpleSegmentVisitor(), a = 0, i = t.length;
                    a < i;
                    a++
                  ) {
                    var o = t[a];
                    processSegments(
                      readSegments({}, o.data, o.start, o.end),
                      r,
                    );
                  }
                  return r.buffer;
                })(t);
              },
              parse: function parse(t) {
                var r = (function parseJbig2(t) {
                    var r = t.length,
                      a = 0;
                    if (
                      151 !== t[a] ||
                      74 !== t[a + 1] ||
                      66 !== t[a + 2] ||
                      50 !== t[a + 3] ||
                      13 !== t[a + 4] ||
                      10 !== t[a + 5] ||
                      26 !== t[a + 6] ||
                      10 !== t[a + 7]
                    )
                      throw new u("parseJbig2 - invalid header.");
                    var i = Object.create(null);
                    a += 8;
                    var l = t[a++];
                    (i.randomAccess = !(1 & l)),
                      2 & l ||
                        ((i.numberOfPages = (0, o.readUint32)(t, a)), (a += 4));
                    var c = readSegments(i, t, a, r),
                      h = new SimpleSegmentVisitor();
                    processSegments(c, h);
                    for (
                      var d = h.currentPageInfo,
                        p = d.width,
                        m = d.height,
                        g = h.buffer,
                        b = new Uint8ClampedArray(p * m),
                        y = 0,
                        v = 0,
                        S = 0;
                      S < m;
                      S++
                    )
                      for (var k = 0, w = void 0, C = 0; C < p; C++)
                        k || ((k = 128), (w = g[v++])),
                          (b[y++] = w & k ? 0 : 255),
                          (k >>= 1);
                    return { imgData: b, width: p, height: m };
                  })(t),
                  a = r.imgData,
                  i = r.width,
                  l = r.height;
                return (this.width = i), (this.height = l), a;
              },
            }),
            Jbig2Image
          );
        })();
      r.Jbig2Image = h;
    },
    function (t, r, a) {
      "use strict";
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.ArithmeticDecoder = void 0);
      var i = [
          { qe: 22017, nmps: 1, nlps: 1, switchFlag: 1 },
          { qe: 13313, nmps: 2, nlps: 6, switchFlag: 0 },
          { qe: 6145, nmps: 3, nlps: 9, switchFlag: 0 },
          { qe: 2753, nmps: 4, nlps: 12, switchFlag: 0 },
          { qe: 1313, nmps: 5, nlps: 29, switchFlag: 0 },
          { qe: 545, nmps: 38, nlps: 33, switchFlag: 0 },
          { qe: 22017, nmps: 7, nlps: 6, switchFlag: 1 },
          { qe: 21505, nmps: 8, nlps: 14, switchFlag: 0 },
          { qe: 18433, nmps: 9, nlps: 14, switchFlag: 0 },
          { qe: 14337, nmps: 10, nlps: 14, switchFlag: 0 },
          { qe: 12289, nmps: 11, nlps: 17, switchFlag: 0 },
          { qe: 9217, nmps: 12, nlps: 18, switchFlag: 0 },
          { qe: 7169, nmps: 13, nlps: 20, switchFlag: 0 },
          { qe: 5633, nmps: 29, nlps: 21, switchFlag: 0 },
          { qe: 22017, nmps: 15, nlps: 14, switchFlag: 1 },
          { qe: 21505, nmps: 16, nlps: 14, switchFlag: 0 },
          { qe: 20737, nmps: 17, nlps: 15, switchFlag: 0 },
          { qe: 18433, nmps: 18, nlps: 16, switchFlag: 0 },
          { qe: 14337, nmps: 19, nlps: 17, switchFlag: 0 },
          { qe: 13313, nmps: 20, nlps: 18, switchFlag: 0 },
          { qe: 12289, nmps: 21, nlps: 19, switchFlag: 0 },
          { qe: 10241, nmps: 22, nlps: 19, switchFlag: 0 },
          { qe: 9217, nmps: 23, nlps: 20, switchFlag: 0 },
          { qe: 8705, nmps: 24, nlps: 21, switchFlag: 0 },
          { qe: 7169, nmps: 25, nlps: 22, switchFlag: 0 },
          { qe: 6145, nmps: 26, nlps: 23, switchFlag: 0 },
          { qe: 5633, nmps: 27, nlps: 24, switchFlag: 0 },
          { qe: 5121, nmps: 28, nlps: 25, switchFlag: 0 },
          { qe: 4609, nmps: 29, nlps: 26, switchFlag: 0 },
          { qe: 4353, nmps: 30, nlps: 27, switchFlag: 0 },
          { qe: 2753, nmps: 31, nlps: 28, switchFlag: 0 },
          { qe: 2497, nmps: 32, nlps: 29, switchFlag: 0 },
          { qe: 2209, nmps: 33, nlps: 30, switchFlag: 0 },
          { qe: 1313, nmps: 34, nlps: 31, switchFlag: 0 },
          { qe: 1089, nmps: 35, nlps: 32, switchFlag: 0 },
          { qe: 673, nmps: 36, nlps: 33, switchFlag: 0 },
          { qe: 545, nmps: 37, nlps: 34, switchFlag: 0 },
          { qe: 321, nmps: 38, nlps: 35, switchFlag: 0 },
          { qe: 273, nmps: 39, nlps: 36, switchFlag: 0 },
          { qe: 133, nmps: 40, nlps: 37, switchFlag: 0 },
          { qe: 73, nmps: 41, nlps: 38, switchFlag: 0 },
          { qe: 37, nmps: 42, nlps: 39, switchFlag: 0 },
          { qe: 21, nmps: 43, nlps: 40, switchFlag: 0 },
          { qe: 9, nmps: 44, nlps: 41, switchFlag: 0 },
          { qe: 5, nmps: 45, nlps: 42, switchFlag: 0 },
          { qe: 1, nmps: 45, nlps: 43, switchFlag: 0 },
          { qe: 22017, nmps: 46, nlps: 46, switchFlag: 0 },
        ],
        o = (function () {
          function ArithmeticDecoder(t, r, a) {
            !(function _classCallCheck(t, r) {
              if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function");
            })(this, ArithmeticDecoder),
              (this.data = t),
              (this.bp = r),
              (this.dataEnd = a),
              (this.chigh = t[r]),
              (this.clow = 0),
              this.byteIn(),
              (this.chigh =
                ((this.chigh << 7) & 65535) | ((this.clow >> 9) & 127)),
              (this.clow = (this.clow << 7) & 65535),
              (this.ct -= 7),
              (this.a = 32768);
          }
          return (
            (function _createClass(t, r, a) {
              return (
                r && _defineProperties(t.prototype, r),
                a && _defineProperties(t, a),
                t
              );
            })(ArithmeticDecoder, [
              {
                key: "byteIn",
                value: function byteIn() {
                  var t = this.data,
                    r = this.bp;
                  255 === t[r]
                    ? t[r + 1] > 143
                      ? ((this.clow += 65280), (this.ct = 8))
                      : (r++,
                        (this.clow += t[r] << 9),
                        (this.ct = 7),
                        (this.bp = r))
                    : (r++,
                      (this.clow += r < this.dataEnd ? t[r] << 8 : 65280),
                      (this.ct = 8),
                      (this.bp = r)),
                    this.clow > 65535 &&
                      ((this.chigh += this.clow >> 16), (this.clow &= 65535));
                },
              },
              {
                key: "readBit",
                value: function readBit(t, r) {
                  var a,
                    o = t[r] >> 1,
                    l = 1 & t[r],
                    c = i[o],
                    u = c.qe,
                    h = this.a - u;
                  if (this.chigh < u)
                    h < u
                      ? ((h = u), (a = l), (o = c.nmps))
                      : ((h = u),
                        (a = 1 ^ l),
                        1 === c.switchFlag && (l = a),
                        (o = c.nlps));
                  else {
                    if (((this.chigh -= u), 0 != (32768 & h)))
                      return (this.a = h), l;
                    h < u
                      ? ((a = 1 ^ l),
                        1 === c.switchFlag && (l = a),
                        (o = c.nlps))
                      : ((a = l), (o = c.nmps));
                  }
                  do {
                    0 === this.ct && this.byteIn(),
                      (h <<= 1),
                      (this.chigh =
                        ((this.chigh << 1) & 65535) | ((this.clow >> 15) & 1)),
                      (this.clow = (this.clow << 1) & 65535),
                      this.ct--;
                  } while (0 == (32768 & h));
                  return (this.a = h), (t[r] = (o << 1) | l), a;
                },
              },
            ]),
            ArithmeticDecoder
          );
        })();
      r.ArithmeticDecoder = o;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.JpegStream = void 0);
      var i = a(205),
        o = a(198),
        l = a(212),
        c = a(5),
        u = (function JpegStreamClosure() {
          function JpegStream(t, r, a, o) {
            for (var l; -1 !== (l = t.getByte()); )
              if (255 === l) {
                t.skip(-1);
                break;
              }
            (this.stream = t),
              (this.maybeLength = r),
              (this.dict = a),
              (this.params = o),
              i.DecodeStream.call(this, r);
          }
          return (
            (JpegStream.prototype = Object.create(i.DecodeStream.prototype)),
            Object.defineProperty(JpegStream.prototype, "bytes", {
              get: function JpegStream_bytes() {
                return (0, c.shadow)(
                  this,
                  "bytes",
                  this.stream.getBytes(this.maybeLength),
                );
              },
              configurable: !0,
            }),
            (JpegStream.prototype.ensureBuffer = function (t) {}),
            (JpegStream.prototype.readBlock = function () {
              if (!this.eof) {
                var t = { decodeTransform: void 0, colorTransform: void 0 },
                  r = this.dict.getArray("Decode", "D");
                if (this.forceRGB && Array.isArray(r)) {
                  for (
                    var a = this.dict.get("BitsPerComponent") || 8,
                      i = r.length,
                      c = new Int32Array(i),
                      u = !1,
                      h = (1 << a) - 1,
                      d = 0;
                    d < i;
                    d += 2
                  )
                    (c[d] = (256 * (r[d + 1] - r[d])) | 0),
                      (c[d + 1] = (r[d] * h) | 0),
                      (256 === c[d] && 0 === c[d + 1]) || (u = !0);
                  u && (t.decodeTransform = c);
                }
                if ((0, o.isDict)(this.params)) {
                  var p = this.params.get("ColorTransform");
                  Number.isInteger(p) && (t.colorTransform = p);
                }
                var m = new l.JpegImage(t);
                m.parse(this.bytes);
                var g = m.getData({
                  width: this.drawWidth,
                  height: this.drawHeight,
                  forceRGB: this.forceRGB,
                  isSourcePDF: !0,
                });
                (this.buffer = g),
                  (this.bufferLength = g.length),
                  (this.eof = !0);
              }
            }),
            JpegStream
          );
        })();
      r.JpegStream = u;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.JpegImage = void 0);
      var i = a(5),
        o = a(201);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _inherits(t, r) {
        if ("function" != typeof r && null !== r)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (t.prototype = Object.create(r && r.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          r && _setPrototypeOf(t, r);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      var l = (function (t) {
          _inherits(JpegError, t);
          var r = _createSuper(JpegError);
          function JpegError(t) {
            return (
              _classCallCheck(this, JpegError),
              r.call(this, "JPEG error: ".concat(t))
            );
          }
          return JpegError;
        })(i.BaseException),
        c = (function (t) {
          _inherits(DNLMarkerError, t);
          var r = _createSuper(DNLMarkerError);
          function DNLMarkerError(t, a) {
            var i;
            return (
              _classCallCheck(this, DNLMarkerError),
              ((i = r.call(this, t)).scanLines = a),
              i
            );
          }
          return DNLMarkerError;
        })(i.BaseException),
        u = (function (t) {
          _inherits(EOIMarkerError, t);
          var r = _createSuper(EOIMarkerError);
          function EOIMarkerError() {
            return (
              _classCallCheck(this, EOIMarkerError), r.apply(this, arguments)
            );
          }
          return EOIMarkerError;
        })(i.BaseException),
        h = (function JpegImageClosure() {
          var t = new Uint8Array([
              0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19,
              26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49,
              56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52,
              45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63,
            ]),
            r = 4017,
            a = 799,
            h = 3406,
            d = 2276,
            p = 1567,
            m = 3784,
            g = 5793,
            b = 2896;
          function JpegImage() {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : {},
              r = t.decodeTransform,
              a = void 0 === r ? null : r,
              i = t.colorTransform,
              o = void 0 === i ? -1 : i;
            (this._decodeTransform = a), (this._colorTransform = o);
          }
          function buildHuffmanTable(t, r) {
            for (var a, i, o = 0, l = [], c = 16; c > 0 && !t[c - 1]; ) c--;
            l.push({ children: [], index: 0 });
            var u,
              h = l[0];
            for (a = 0; a < c; a++) {
              for (i = 0; i < t[a]; i++) {
                for ((h = l.pop()).children[h.index] = r[o]; h.index > 0; )
                  h = l.pop();
                for (h.index++, l.push(h); l.length <= a; )
                  l.push((u = { children: [], index: 0 })),
                    (h.children[h.index] = u.children),
                    (h = u);
                o++;
              }
              a + 1 < c &&
                (l.push((u = { children: [], index: 0 })),
                (h.children[h.index] = u.children),
                (h = u));
            }
            return l[0].children;
          }
          function getBlockBufferOffset(t, r, a) {
            return 64 * ((t.blocksPerLine + 1) * r + a);
          }
          function decodeScan(r, a, h, d, p, m, g, b, y) {
            var v =
                arguments.length > 9 && void 0 !== arguments[9] && arguments[9],
              S = h.mcusPerLine,
              k = h.progressive,
              w = a,
              C = 0,
              x = 0;
            function readBit() {
              if (x > 0) return x--, (C >> x) & 1;
              if (255 === (C = r[a++])) {
                var t = r[a++];
                if (t) {
                  if (220 === t && v) {
                    a += 2;
                    var i = (0, o.readUint16)(r, a);
                    if (((a += 2), i > 0 && i !== h.scanLines))
                      throw new c(
                        "Found DNL marker (0xFFDC) while parsing scan data",
                        i,
                      );
                  } else if (217 === t) {
                    if (v) {
                      var d = 8 * T;
                      if (d > 0 && d < h.scanLines / 10)
                        throw new c(
                          "Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter",
                          d,
                        );
                    }
                    throw new u(
                      "Found EOI marker (0xFFD9) while parsing scan data",
                    );
                  }
                  throw new l(
                    "unexpected marker ".concat(((C << 8) | t).toString(16)),
                  );
                }
              }
              return (x = 7), C >>> 7;
            }
            function decodeHuffman(t) {
              for (var r = t; ; ) {
                switch (_typeof((r = r[readBit()]))) {
                  case "number":
                    return r;
                  case "object":
                    continue;
                }
                throw new l("invalid huffman sequence");
              }
            }
            function receive(t) {
              for (var r = 0; t > 0; ) (r = (r << 1) | readBit()), t--;
              return r;
            }
            function receiveAndExtend(t) {
              if (1 === t) return 1 === readBit() ? 1 : -1;
              var r = receive(t);
              return r >= 1 << (t - 1) ? r : r + (-1 << t) + 1;
            }
            function decodeBaseline(r, a) {
              var i = decodeHuffman(r.huffmanTableDC),
                o = 0 === i ? 0 : receiveAndExtend(i);
              r.blockData[a] = r.pred += o;
              for (var l = 1; l < 64; ) {
                var c = decodeHuffman(r.huffmanTableAC),
                  u = 15 & c,
                  h = c >> 4;
                if (0 !== u) {
                  var d = t[(l += h)];
                  (r.blockData[a + d] = receiveAndExtend(u)), l++;
                } else {
                  if (h < 15) break;
                  l += 16;
                }
              }
            }
            function decodeDCFirst(t, r) {
              var a = decodeHuffman(t.huffmanTableDC),
                i = 0 === a ? 0 : receiveAndExtend(a) << y;
              t.blockData[r] = t.pred += i;
            }
            function decodeDCSuccessive(t, r) {
              t.blockData[r] |= readBit() << y;
            }
            var _ = 0;
            function decodeACFirst(r, a) {
              if (_ > 0) _--;
              else
                for (var i = m, o = g; i <= o; ) {
                  var l = decodeHuffman(r.huffmanTableAC),
                    c = 15 & l,
                    u = l >> 4;
                  if (0 !== c) {
                    var h = t[(i += u)];
                    (r.blockData[a + h] = receiveAndExtend(c) * (1 << y)), i++;
                  } else {
                    if (u < 15) {
                      _ = receive(u) + (1 << u) - 1;
                      break;
                    }
                    i += 16;
                  }
                }
            }
            var A,
              R = 0;
            function decodeACSuccessive(r, a) {
              for (var i, o, c = m, u = g, h = 0; c <= u; ) {
                var d = a + t[c],
                  p = r.blockData[d] < 0 ? -1 : 1;
                switch (R) {
                  case 0:
                    if (
                      ((h = (o = decodeHuffman(r.huffmanTableAC)) >> 4),
                      0 === (i = 15 & o))
                    )
                      h < 15
                        ? ((_ = receive(h) + (1 << h)), (R = 4))
                        : ((h = 16), (R = 1));
                    else {
                      if (1 !== i) throw new l("invalid ACn encoding");
                      (A = receiveAndExtend(i)), (R = h ? 2 : 3);
                    }
                    continue;
                  case 1:
                  case 2:
                    r.blockData[d]
                      ? (r.blockData[d] += p * (readBit() << y))
                      : 0 === --h && (R = 2 === R ? 3 : 0);
                    break;
                  case 3:
                    r.blockData[d]
                      ? (r.blockData[d] += p * (readBit() << y))
                      : ((r.blockData[d] = A << y), (R = 0));
                    break;
                  case 4:
                    r.blockData[d] && (r.blockData[d] += p * (readBit() << y));
                }
                c++;
              }
              4 === R && 0 === --_ && (R = 0);
            }
            var T = 0;
            function decodeMcu(t, r, a, i, o) {
              var l = a % S;
              T = ((a / S) | 0) * t.v + i;
              var c = l * t.h + o;
              r(t, getBlockBufferOffset(t, T, c));
            }
            function decodeBlock(t, r, a) {
              T = (a / t.blocksPerLine) | 0;
              var i = a % t.blocksPerLine;
              r(t, getBlockBufferOffset(t, T, i));
            }
            var I,
              P,
              O,
              E,
              B,
              D,
              M = d.length;
            D = k
              ? 0 === m
                ? 0 === b
                  ? decodeDCFirst
                  : decodeDCSuccessive
                : 0 === b
                ? decodeACFirst
                : decodeACSuccessive
              : decodeBaseline;
            var L,
              N,
              U,
              j,
              q = 0;
            for (
              N =
                1 === M
                  ? d[0].blocksPerLine * d[0].blocksPerColumn
                  : S * h.mcusPerColumn;
              q <= N;

            ) {
              var W = p ? Math.min(N - q, p) : N;
              if (W > 0) {
                for (P = 0; P < M; P++) d[P].pred = 0;
                if (((_ = 0), 1 === M))
                  for (I = d[0], B = 0; B < W; B++) decodeBlock(I, D, q), q++;
                else
                  for (B = 0; B < W; B++) {
                    for (P = 0; P < M; P++)
                      for (U = (I = d[P]).h, j = I.v, O = 0; O < j; O++)
                        for (E = 0; E < U; E++) decodeMcu(I, D, q, O, E);
                    q++;
                  }
              }
              if (((x = 0), !(L = findNextFileMarker(r, a)))) break;
              if (L.invalid) {
                var z = W > 0 ? "unexpected" : "excessive";
                (0, i.warn)(
                  "decodeScan - "
                    .concat(z, " MCU data, current marker is: ")
                    .concat(L.invalid),
                ),
                  (a = L.offset);
              }
              if (!(L.marker >= 65488 && L.marker <= 65495)) break;
              a += 2;
            }
            return a - w;
          }
          function quantizeAndInverse(t, i, o) {
            var c,
              u,
              y,
              v,
              S,
              k,
              w,
              C,
              x,
              _,
              A,
              R,
              T,
              I,
              P,
              O,
              E,
              B = t.quantizationTable,
              D = t.blockData;
            if (!B) throw new l("missing required Quantization Table.");
            for (var M = 0; M < 64; M += 8)
              (x = D[i + M]),
                (_ = D[i + M + 1]),
                (A = D[i + M + 2]),
                (R = D[i + M + 3]),
                (T = D[i + M + 4]),
                (I = D[i + M + 5]),
                (P = D[i + M + 6]),
                (O = D[i + M + 7]),
                (x *= B[M]),
                0 != (_ | A | R | T | I | P | O)
                  ? ((_ *= B[M + 1]),
                    (A *= B[M + 2]),
                    (R *= B[M + 3]),
                    (T *= B[M + 4]),
                    (I *= B[M + 5]),
                    (P *= B[M + 6]),
                    (O *= B[M + 7]),
                    (u =
                      (c =
                        ((c = (g * x + 128) >> 8) +
                          (u = (g * T + 128) >> 8) +
                          1) >>
                        1) - u),
                    (E = ((y = A) * m + (v = P) * p + 128) >> 8),
                    (y = (y * p - v * m + 128) >> 8),
                    (w =
                      (S =
                        ((S = (b * (_ - O) + 128) >> 8) + (w = I << 4) + 1) >>
                        1) - w),
                    (k =
                      (C =
                        ((C = (b * (_ + O) + 128) >> 8) + (k = R << 4) + 1) >>
                        1) - k),
                    (v = (c = (c + (v = E) + 1) >> 1) - v),
                    (y = (u = (u + y + 1) >> 1) - y),
                    (E = (S * d + C * h + 2048) >> 12),
                    (S = (S * h - C * d + 2048) >> 12),
                    (C = E),
                    (E = (k * a + w * r + 2048) >> 12),
                    (k = (k * r - w * a + 2048) >> 12),
                    (w = E),
                    (o[M] = c + C),
                    (o[M + 7] = c - C),
                    (o[M + 1] = u + w),
                    (o[M + 6] = u - w),
                    (o[M + 2] = y + k),
                    (o[M + 5] = y - k),
                    (o[M + 3] = v + S),
                    (o[M + 4] = v - S))
                  : ((E = (g * x + 512) >> 10),
                    (o[M] = E),
                    (o[M + 1] = E),
                    (o[M + 2] = E),
                    (o[M + 3] = E),
                    (o[M + 4] = E),
                    (o[M + 5] = E),
                    (o[M + 6] = E),
                    (o[M + 7] = E));
            for (var L = 0; L < 8; ++L)
              (x = o[L]),
                0 !=
                ((_ = o[L + 8]) |
                  (A = o[L + 16]) |
                  (R = o[L + 24]) |
                  (T = o[L + 32]) |
                  (I = o[L + 40]) |
                  (P = o[L + 48]) |
                  (O = o[L + 56]))
                  ? ((u =
                      (c =
                        4112 +
                        (((c = (g * x + 2048) >> 12) +
                          (u = (g * T + 2048) >> 12) +
                          1) >>
                          1)) - u),
                    (E = ((y = A) * m + (v = P) * p + 2048) >> 12),
                    (y = (y * p - v * m + 2048) >> 12),
                    (v = E),
                    (w =
                      (S =
                        ((S = (b * (_ - O) + 2048) >> 12) + (w = I) + 1) >> 1) -
                      w),
                    (k =
                      (C =
                        ((C = (b * (_ + O) + 2048) >> 12) + (k = R) + 1) >> 1) -
                      k),
                    (E = (S * d + C * h + 2048) >> 12),
                    (S = (S * h - C * d + 2048) >> 12),
                    (C = E),
                    (E = (k * a + w * r + 2048) >> 12),
                    (k = (k * r - w * a + 2048) >> 12),
                    (x = (c = (c + v + 1) >> 1) + C) < 16
                      ? (x = 0)
                      : x >= 4080
                      ? (x = 255)
                      : (x >>= 4),
                    (_ = (u = (u + y + 1) >> 1) + (w = E)) < 16
                      ? (_ = 0)
                      : _ >= 4080
                      ? (_ = 255)
                      : (_ >>= 4),
                    (A = (y = u - y) + k) < 16
                      ? (A = 0)
                      : A >= 4080
                      ? (A = 255)
                      : (A >>= 4),
                    (R = (v = c - v) + S) < 16
                      ? (R = 0)
                      : R >= 4080
                      ? (R = 255)
                      : (R >>= 4),
                    (T = v - S) < 16
                      ? (T = 0)
                      : T >= 4080
                      ? (T = 255)
                      : (T >>= 4),
                    (I = y - k) < 16
                      ? (I = 0)
                      : I >= 4080
                      ? (I = 255)
                      : (I >>= 4),
                    (P = u - w) < 16
                      ? (P = 0)
                      : P >= 4080
                      ? (P = 255)
                      : (P >>= 4),
                    (O = c - C) < 16
                      ? (O = 0)
                      : O >= 4080
                      ? (O = 255)
                      : (O >>= 4),
                    (D[i + L] = x),
                    (D[i + L + 8] = _),
                    (D[i + L + 16] = A),
                    (D[i + L + 24] = R),
                    (D[i + L + 32] = T),
                    (D[i + L + 40] = I),
                    (D[i + L + 48] = P),
                    (D[i + L + 56] = O))
                  : ((E =
                      (E = (g * x + 8192) >> 14) < -2040
                        ? 0
                        : E >= 2024
                        ? 255
                        : (E + 2056) >> 4),
                    (D[i + L] = E),
                    (D[i + L + 8] = E),
                    (D[i + L + 16] = E),
                    (D[i + L + 24] = E),
                    (D[i + L + 32] = E),
                    (D[i + L + 40] = E),
                    (D[i + L + 48] = E),
                    (D[i + L + 56] = E));
          }
          function buildComponentData(t, r) {
            for (
              var a = r.blocksPerLine,
                i = r.blocksPerColumn,
                o = new Int16Array(64),
                l = 0;
              l < i;
              l++
            )
              for (var c = 0; c < a; c++) {
                quantizeAndInverse(r, getBlockBufferOffset(r, l, c), o);
              }
            return r.blockData;
          }
          function findNextFileMarker(t, r) {
            var a =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : r,
              i = t.length - 1,
              l = a < r ? a : r;
            if (r >= i) return null;
            var c = (0, o.readUint16)(t, r);
            if (c >= 65472 && c <= 65534)
              return { invalid: null, marker: c, offset: r };
            for (
              var u = (0, o.readUint16)(t, l);
              !(u >= 65472 && u <= 65534);

            ) {
              if (++l >= i) return null;
              u = (0, o.readUint16)(t, l);
            }
            return { invalid: c.toString(16), marker: u, offset: l };
          }
          return (
            (JpegImage.prototype = {
              parse: function parse(r) {
                var a =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {},
                  h = a.dnlScanLines,
                  d = void 0 === h ? null : h;
                function readDataBlock() {
                  var t = (0, o.readUint16)(r, g),
                    a = (g += 2) + t - 2,
                    l = findNextFileMarker(r, a, g);
                  l &&
                    l.invalid &&
                    ((0, i.warn)(
                      "readDataBlock - incorrect length, current marker is: " +
                        l.invalid,
                    ),
                    (a = l.offset));
                  var c = r.subarray(g, a);
                  return (g += c.length), c;
                }
                function prepareComponents(t) {
                  for (
                    var r = Math.ceil(t.samplesPerLine / 8 / t.maxH),
                      a = Math.ceil(t.scanLines / 8 / t.maxV),
                      i = 0;
                    i < t.components.length;
                    i++
                  ) {
                    V = t.components[i];
                    var o = Math.ceil(
                        (Math.ceil(t.samplesPerLine / 8) * V.h) / t.maxH,
                      ),
                      l = Math.ceil(
                        (Math.ceil(t.scanLines / 8) * V.v) / t.maxV,
                      ),
                      c = r * V.h,
                      u = 64 * (a * V.v) * (c + 1);
                    (V.blockData = new Int16Array(u)),
                      (V.blocksPerLine = o),
                      (V.blocksPerColumn = l);
                  }
                  (t.mcusPerLine = r), (t.mcusPerColumn = a);
                }
                var p,
                  m,
                  g = 0,
                  b = null,
                  y = null,
                  v = 0,
                  S = [],
                  k = [],
                  w = [],
                  C = (0, o.readUint16)(r, g);
                if (((g += 2), 65496 !== C)) throw new l("SOI not found");
                (C = (0, o.readUint16)(r, g)), (g += 2);
                e: for (; 65497 !== C; ) {
                  var x, _, A;
                  switch (C) {
                    case 65504:
                    case 65505:
                    case 65506:
                    case 65507:
                    case 65508:
                    case 65509:
                    case 65510:
                    case 65511:
                    case 65512:
                    case 65513:
                    case 65514:
                    case 65515:
                    case 65516:
                    case 65517:
                    case 65518:
                    case 65519:
                    case 65534:
                      var R = readDataBlock();
                      65504 === C &&
                        74 === R[0] &&
                        70 === R[1] &&
                        73 === R[2] &&
                        70 === R[3] &&
                        0 === R[4] &&
                        (b = {
                          version: { major: R[5], minor: R[6] },
                          densityUnits: R[7],
                          xDensity: (R[8] << 8) | R[9],
                          yDensity: (R[10] << 8) | R[11],
                          thumbWidth: R[12],
                          thumbHeight: R[13],
                          thumbData: R.subarray(14, 14 + 3 * R[12] * R[13]),
                        }),
                        65518 === C &&
                          65 === R[0] &&
                          100 === R[1] &&
                          111 === R[2] &&
                          98 === R[3] &&
                          101 === R[4] &&
                          (y = {
                            version: (R[5] << 8) | R[6],
                            flags0: (R[7] << 8) | R[8],
                            flags1: (R[9] << 8) | R[10],
                            transformCode: R[11],
                          });
                      break;
                    case 65499:
                      for (
                        var T = (0, o.readUint16)(r, g), I = T + (g += 2) - 2;
                        g < I;

                      ) {
                        var P = r[g++],
                          O = new Uint16Array(64);
                        if (P >> 4 == 0)
                          for (_ = 0; _ < 64; _++) O[t[_]] = r[g++];
                        else {
                          if (P >> 4 != 1)
                            throw new l("DQT - invalid table spec");
                          for (_ = 0; _ < 64; _++)
                            (O[t[_]] = (0, o.readUint16)(r, g)), (g += 2);
                        }
                        S[15 & P] = O;
                      }
                      break;
                    case 65472:
                    case 65473:
                    case 65474:
                      if (p) throw new l("Only single frame JPEGs supported");
                      (g += 2),
                        ((p = {}).extended = 65473 === C),
                        (p.progressive = 65474 === C),
                        (p.precision = r[g++]);
                      var E = (0, o.readUint16)(r, g);
                      (g += 2),
                        (p.scanLines = d || E),
                        (p.samplesPerLine = (0, o.readUint16)(r, g)),
                        (g += 2),
                        (p.components = []),
                        (p.componentIds = {});
                      var B,
                        D = r[g++],
                        M = 0,
                        L = 0;
                      for (x = 0; x < D; x++) {
                        B = r[g];
                        var N = r[g + 1] >> 4,
                          U = 15 & r[g + 1];
                        M < N && (M = N), L < U && (L = U);
                        var j = r[g + 2];
                        (A = p.components.push({
                          h: N,
                          v: U,
                          quantizationId: j,
                          quantizationTable: null,
                        })),
                          (p.componentIds[B] = A - 1),
                          (g += 3);
                      }
                      (p.maxH = M), (p.maxV = L), prepareComponents(p);
                      break;
                    case 65476:
                      var q = (0, o.readUint16)(r, g);
                      for (g += 2, x = 2; x < q; ) {
                        var W = r[g++],
                          z = new Uint8Array(16),
                          G = 0;
                        for (_ = 0; _ < 16; _++, g++) G += z[_] = r[g];
                        var H = new Uint8Array(G);
                        for (_ = 0; _ < G; _++, g++) H[_] = r[g];
                        (x += 17 + G),
                          ((W >> 4 == 0 ? w : k)[15 & W] = buildHuffmanTable(
                            z,
                            H,
                          ));
                      }
                      break;
                    case 65501:
                      (g += 2), (m = (0, o.readUint16)(r, g)), (g += 2);
                      break;
                    case 65498:
                      var X = 1 == ++v && !d;
                      g += 2;
                      var V,
                        Y = r[g++],
                        K = [];
                      for (x = 0; x < Y; x++) {
                        var J = p.componentIds[r[g++]];
                        V = p.components[J];
                        var Z = r[g++];
                        (V.huffmanTableDC = w[Z >> 4]),
                          (V.huffmanTableAC = k[15 & Z]),
                          K.push(V);
                      }
                      var Q = r[g++],
                        $ = r[g++],
                        ee = r[g++];
                      try {
                        var te = decodeScan(
                          r,
                          g,
                          p,
                          K,
                          m,
                          Q,
                          $,
                          ee >> 4,
                          15 & ee,
                          X,
                        );
                        g += te;
                      } catch (t) {
                        if (t instanceof c)
                          return (
                            (0, i.warn)(
                              "".concat(
                                t.message,
                                " -- attempting to re-parse the JPEG image.",
                              ),
                            ),
                            this.parse(r, { dnlScanLines: t.scanLines })
                          );
                        if (t instanceof u) {
                          (0, i.warn)(
                            "".concat(
                              t.message,
                              " -- ignoring the rest of the image data.",
                            ),
                          );
                          break e;
                        }
                        throw t;
                      }
                      break;
                    case 65500:
                      g += 4;
                      break;
                    case 65535:
                      255 !== r[g] && g--;
                      break;
                    default:
                      var re = findNextFileMarker(r, g - 2, g - 3);
                      if (re && re.invalid) {
                        (0, i.warn)(
                          "JpegImage.parse - unexpected data, current marker is: " +
                            re.invalid,
                        ),
                          (g = re.offset);
                        break;
                      }
                      if (g >= r.length - 1) {
                        (0, i.warn)(
                          "JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).",
                        );
                        break e;
                      }
                      throw new l(
                        "JpegImage.parse - unknown marker: " + C.toString(16),
                      );
                  }
                  (C = (0, o.readUint16)(r, g)), (g += 2);
                }
                for (
                  this.width = p.samplesPerLine,
                    this.height = p.scanLines,
                    this.jfif = b,
                    this.adobe = y,
                    this.components = [],
                    x = 0;
                  x < p.components.length;
                  x++
                ) {
                  var ae = S[(V = p.components[x]).quantizationId];
                  ae && (V.quantizationTable = ae),
                    this.components.push({
                      output: buildComponentData(0, V),
                      scaleX: V.h / p.maxH,
                      scaleY: V.v / p.maxV,
                      blocksPerLine: V.blocksPerLine,
                      blocksPerColumn: V.blocksPerColumn,
                    });
                }
                this.numComponents = this.components.length;
              },
              _getLinearizedBlockData: function _getLinearizedBlockData(t, r) {
                var a,
                  i,
                  o,
                  l,
                  c,
                  u,
                  h,
                  d,
                  p,
                  m,
                  g,
                  b,
                  y =
                    arguments.length > 2 &&
                    void 0 !== arguments[2] &&
                    arguments[2],
                  v = this.width / t,
                  S = this.height / r,
                  k = 0,
                  w = this.components.length,
                  C = t * r * w,
                  x = new Uint8ClampedArray(C),
                  _ = new Uint32Array(t),
                  A = 4294967288;
                for (h = 0; h < w; h++) {
                  if (
                    ((i = (a = this.components[h]).scaleX * v),
                    (o = a.scaleY * S),
                    (k = h),
                    (g = a.output),
                    (l = (a.blocksPerLine + 1) << 3),
                    i !== b)
                  ) {
                    for (c = 0; c < t; c++)
                      (d = 0 | (c * i)), (_[c] = ((d & A) << 3) | (7 & d));
                    b = i;
                  }
                  for (u = 0; u < r; u++)
                    for (
                      m = (l * ((d = 0 | (u * o)) & A)) | ((7 & d) << 3), c = 0;
                      c < t;
                      c++
                    )
                      (x[k] = g[m + _[c]]), (k += w);
                }
                var R = this._decodeTransform;
                if (
                  (y ||
                    4 !== w ||
                    R ||
                    (R = new Int32Array([
                      -256, 255, -256, 255, -256, 255, -256, 255,
                    ])),
                  R)
                )
                  for (h = 0; h < C; )
                    for (d = 0, p = 0; d < w; d++, h++, p += 2)
                      x[h] = ((x[h] * R[p]) >> 8) + R[p + 1];
                return x;
              },
              get _isColorConversionNeeded() {
                return this.adobe
                  ? !!this.adobe.transformCode
                  : 3 === this.numComponents
                  ? 0 !== this._colorTransform
                  : 1 === this._colorTransform;
              },
              _convertYccToRgb: function convertYccToRgb(t) {
                for (var r, a, i, o = 0, l = t.length; o < l; o += 3)
                  (r = t[o]),
                    (a = t[o + 1]),
                    (i = t[o + 2]),
                    (t[o] = r - 179.456 + 1.402 * i),
                    (t[o + 1] = r + 135.459 - 0.344 * a - 0.714 * i),
                    (t[o + 2] = r - 226.816 + 1.772 * a);
                return t;
              },
              _convertYcckToRgb: function convertYcckToRgb(t) {
                for (var r, a, i, o, l = 0, c = 0, u = t.length; c < u; c += 4)
                  (r = t[c]),
                    (a = t[c + 1]),
                    (i = t[c + 2]),
                    (o = t[c + 3]),
                    (t[l++] =
                      a *
                        (-660635669420364e-19 * a +
                          0.000437130475926232 * i -
                          54080610064599e-18 * r +
                          0.00048449797120281 * o -
                          0.154362151871126) -
                      122.67195406894 +
                      i *
                        (-0.000957964378445773 * i +
                          0.000817076911346625 * r -
                          0.00477271405408747 * o +
                          1.53380253221734) +
                      r *
                        (0.000961250184130688 * r -
                          0.00266257332283933 * o +
                          0.48357088451265) +
                      o * (-0.000336197177618394 * o + 0.484791561490776)),
                    (t[l++] =
                      107.268039397724 +
                      a *
                        (219927104525741e-19 * a -
                          0.000640992018297945 * i +
                          0.000659397001245577 * r +
                          0.000426105652938837 * o -
                          0.176491792462875) +
                      i *
                        (-0.000778269941513683 * i +
                          0.00130872261408275 * r +
                          0.000770482631801132 * o -
                          0.151051492775562) +
                      r *
                        (0.00126935368114843 * r -
                          0.00265090189010898 * o +
                          0.25802910206845) +
                      o * (-0.000318913117588328 * o - 0.213742400323665)),
                    (t[l++] =
                      a *
                        (-0.000570115196973677 * a -
                          263409051004589e-19 * i +
                          0.0020741088115012 * r -
                          0.00288260236853442 * o +
                          0.814272968359295) -
                      20.810012546947 +
                      i *
                        (-153496057440975e-19 * i -
                          0.000132689043961446 * r +
                          0.000560833691242812 * o -
                          0.195152027534049) +
                      r *
                        (0.00174418132927582 * r -
                          0.00255243321439347 * o +
                          0.116935020465145) +
                      o * (-0.000343531996510555 * o + 0.24165260232407));
                return t.subarray(0, l);
              },
              _convertYcckToCmyk: function convertYcckToCmyk(t) {
                for (var r, a, i, o = 0, l = t.length; o < l; o += 4)
                  (r = t[o]),
                    (a = t[o + 1]),
                    (i = t[o + 2]),
                    (t[o] = 434.456 - r - 1.402 * i),
                    (t[o + 1] = 119.541 - r + 0.344 * a + 0.714 * i),
                    (t[o + 2] = 481.816 - r - 1.772 * a);
                return t;
              },
              _convertCmykToRgb: function convertCmykToRgb(t) {
                for (var r, a, i, o, l = 0, c = 0, u = t.length; c < u; c += 4)
                  (r = t[c]),
                    (a = t[c + 1]),
                    (i = t[c + 2]),
                    (o = t[c + 3]),
                    (t[l++] =
                      255 +
                      r *
                        (-6747147073602441e-20 * r +
                          0.0008379262121013727 * a +
                          0.0002894718188643294 * i +
                          0.003264231057537806 * o -
                          1.1185611867203937) +
                      a *
                        (26374107616089405e-21 * a -
                          8626949158638572e-20 * i -
                          0.0002748769067499491 * o -
                          0.02155688794978967) +
                      i *
                        (-3878099212869363e-20 * i -
                          0.0003267808279485286 * o +
                          0.0686742238595345) -
                      o * (0.0003361971776183937 * o + 0.7430659151342254)),
                    (t[l++] =
                      255 +
                      r *
                        (0.00013596372813588848 * r +
                          0.000924537132573585 * a +
                          0.00010567359618683593 * i +
                          0.0004791864687436512 * o -
                          0.3109689587515875) +
                      a *
                        (-0.00023545346108370344 * a +
                          0.0002702845253534714 * i +
                          0.0020200308977307156 * o -
                          0.7488052167015494) +
                      i *
                        (6834815998235662e-20 * i +
                          0.00015168452363460973 * o -
                          0.09751927774728933) -
                      o * (0.0003189131175883281 * o + 0.7364883807733168)),
                    (t[l++] =
                      255 +
                      r *
                        (13598650411385307e-21 * r +
                          0.00012423956175490851 * a +
                          0.0004751985097583589 * i -
                          36729317476630422e-22 * o -
                          0.05562186980264034) +
                      a *
                        (0.00016141380598724676 * a +
                          0.0009692239130725186 * i +
                          0.0007782692450036253 * o -
                          0.44015232367526463) +
                      i *
                        (5.068882914068769e-7 * i +
                          0.0017778369011375071 * o -
                          0.7591454649749609) -
                      o * (0.0003435319965105553 * o + 0.7063770186160144));
                return t.subarray(0, l);
              },
              getData: function getData(t) {
                var r = t.width,
                  a = t.height,
                  i = t.forceRGB,
                  o = void 0 !== i && i,
                  c = t.isSourcePDF,
                  u = void 0 !== c && c;
                if (this.numComponents > 4)
                  throw new l("Unsupported color mode");
                var h = this._getLinearizedBlockData(r, a, u);
                if (1 === this.numComponents && o) {
                  for (
                    var d = h.length,
                      p = new Uint8ClampedArray(3 * d),
                      m = 0,
                      g = 0;
                    g < d;
                    g++
                  ) {
                    var b = h[g];
                    (p[m++] = b), (p[m++] = b), (p[m++] = b);
                  }
                  return p;
                }
                if (3 === this.numComponents && this._isColorConversionNeeded)
                  return this._convertYccToRgb(h);
                if (4 === this.numComponents) {
                  if (this._isColorConversionNeeded)
                    return o
                      ? this._convertYcckToRgb(h)
                      : this._convertYcckToCmyk(h);
                  if (o) return this._convertCmykToRgb(h);
                }
                return h;
              },
            }),
            JpegImage
          );
        })();
      r.JpegImage = h;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.JpxStream = void 0);
      var i = a(205),
        o = a(214),
        l = a(5),
        c = (function JpxStreamClosure() {
          function JpxStream(t, r, a, o) {
            (this.stream = t),
              (this.maybeLength = r),
              (this.dict = a),
              (this.params = o),
              i.DecodeStream.call(this, r);
          }
          return (
            (JpxStream.prototype = Object.create(i.DecodeStream.prototype)),
            Object.defineProperty(JpxStream.prototype, "bytes", {
              get: function JpxStream_bytes() {
                return (0, l.shadow)(
                  this,
                  "bytes",
                  this.stream.getBytes(this.maybeLength),
                );
              },
              configurable: !0,
            }),
            (JpxStream.prototype.ensureBuffer = function (t) {}),
            (JpxStream.prototype.readBlock = function () {
              if (!this.eof) {
                var t = new o.JpxImage();
                t.parse(this.bytes);
                var r = t.width,
                  a = t.height,
                  i = t.componentsCount,
                  l = t.tiles.length;
                if (1 === l) this.buffer = t.tiles[0].items;
                else {
                  for (
                    var c = new Uint8ClampedArray(r * a * i), u = 0;
                    u < l;
                    u++
                  )
                    for (
                      var h = t.tiles[u],
                        d = h.width,
                        p = h.height,
                        m = h.left,
                        g = h.top,
                        b = h.items,
                        y = 0,
                        v = (r * g + m) * i,
                        S = r * i,
                        k = d * i,
                        w = 0;
                      w < p;
                      w++
                    ) {
                      var C = b.subarray(y, y + k);
                      c.set(C, v), (y += k), (v += S);
                    }
                  this.buffer = c;
                }
                (this.bufferLength = this.buffer.length), (this.eof = !0);
              }
            }),
            JpxStream
          );
        })();
      r.JpxStream = c;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.JpxImage = void 0);
      var i = a(5),
        o = a(201),
        l = a(210);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      var c = (function (t) {
          !(function _inherits(t, r) {
            if ("function" != typeof r && null !== r)
              throw new TypeError(
                "Super expression must either be null or a function",
              );
            (t.prototype = Object.create(r && r.prototype, {
              constructor: { value: t, writable: !0, configurable: !0 },
            })),
              r && _setPrototypeOf(t, r);
          })(JpxError, t);
          var r = _createSuper(JpxError);
          function JpxError(t) {
            return (
              (function _classCallCheck(t, r) {
                if (!(t instanceof r))
                  throw new TypeError("Cannot call a class as a function");
              })(this, JpxError),
              r.call(this, "JPX error: ".concat(t))
            );
          }
          return JpxError;
        })(i.BaseException),
        u = (function JpxImageClosure() {
          var t = { LL: 0, LH: 1, HL: 1, HH: 2 };
          function JpxImage() {
            this.failOnCorruptedImage = !1;
          }
          function calculateComponentDimensions(t, r) {
            (t.x0 = Math.ceil(r.XOsiz / t.XRsiz)),
              (t.x1 = Math.ceil(r.Xsiz / t.XRsiz)),
              (t.y0 = Math.ceil(r.YOsiz / t.YRsiz)),
              (t.y1 = Math.ceil(r.Ysiz / t.YRsiz)),
              (t.width = t.x1 - t.x0),
              (t.height = t.y1 - t.y0);
          }
          function calculateTileGrids(t, r) {
            for (
              var a,
                i = t.SIZ,
                o = [],
                l = Math.ceil((i.Xsiz - i.XTOsiz) / i.XTsiz),
                c = Math.ceil((i.Ysiz - i.YTOsiz) / i.YTsiz),
                u = 0;
              u < c;
              u++
            )
              for (var h = 0; h < l; h++)
                ((a = {}).tx0 = Math.max(i.XTOsiz + h * i.XTsiz, i.XOsiz)),
                  (a.ty0 = Math.max(i.YTOsiz + u * i.YTsiz, i.YOsiz)),
                  (a.tx1 = Math.min(i.XTOsiz + (h + 1) * i.XTsiz, i.Xsiz)),
                  (a.ty1 = Math.min(i.YTOsiz + (u + 1) * i.YTsiz, i.Ysiz)),
                  (a.width = a.tx1 - a.tx0),
                  (a.height = a.ty1 - a.ty0),
                  (a.components = []),
                  o.push(a);
            t.tiles = o;
            for (var d = 0, p = i.Csiz; d < p; d++)
              for (var m = r[d], g = 0, b = o.length; g < b; g++) {
                var y = {};
                (a = o[g]),
                  (y.tcx0 = Math.ceil(a.tx0 / m.XRsiz)),
                  (y.tcy0 = Math.ceil(a.ty0 / m.YRsiz)),
                  (y.tcx1 = Math.ceil(a.tx1 / m.XRsiz)),
                  (y.tcy1 = Math.ceil(a.ty1 / m.YRsiz)),
                  (y.width = y.tcx1 - y.tcx0),
                  (y.height = y.tcy1 - y.tcy0),
                  (a.components[d] = y);
              }
          }
          function getBlocksDimensions(t, r, a) {
            var i = r.codingStyleParameters,
              o = {};
            return (
              i.entropyCoderWithCustomPrecincts
                ? ((o.PPx = i.precinctsSizes[a].PPx),
                  (o.PPy = i.precinctsSizes[a].PPy))
                : ((o.PPx = 15), (o.PPy = 15)),
              (o.xcb_ =
                a > 0 ? Math.min(i.xcb, o.PPx - 1) : Math.min(i.xcb, o.PPx)),
              (o.ycb_ =
                a > 0 ? Math.min(i.ycb, o.PPy - 1) : Math.min(i.ycb, o.PPy)),
              o
            );
          }
          function buildPrecincts(t, r, a) {
            var i = 1 << a.PPx,
              o = 1 << a.PPy,
              l = 0 === r.resLevel,
              c = 1 << (a.PPx + (l ? 0 : -1)),
              u = 1 << (a.PPy + (l ? 0 : -1)),
              h =
                r.trx1 > r.trx0
                  ? Math.ceil(r.trx1 / i) - Math.floor(r.trx0 / i)
                  : 0,
              d =
                r.try1 > r.try0
                  ? Math.ceil(r.try1 / o) - Math.floor(r.try0 / o)
                  : 0,
              p = h * d;
            r.precinctParameters = {
              precinctWidth: i,
              precinctHeight: o,
              numprecinctswide: h,
              numprecinctshigh: d,
              numprecincts: p,
              precinctWidthInSubband: c,
              precinctHeightInSubband: u,
            };
          }
          function buildCodeblocks(t, r, a) {
            var i,
              o,
              l,
              c,
              u = a.xcb_,
              h = a.ycb_,
              d = 1 << u,
              p = 1 << h,
              m = r.tbx0 >> u,
              g = r.tby0 >> h,
              b = (r.tbx1 + d - 1) >> u,
              y = (r.tby1 + p - 1) >> h,
              v = r.resolution.precinctParameters,
              S = [],
              k = [];
            for (o = g; o < y; o++)
              for (i = m; i < b; i++) {
                if (
                  (((l = {
                    cbx: i,
                    cby: o,
                    tbx0: d * i,
                    tby0: p * o,
                    tbx1: d * (i + 1),
                    tby1: p * (o + 1),
                  }).tbx0_ = Math.max(r.tbx0, l.tbx0)),
                  (l.tby0_ = Math.max(r.tby0, l.tby0)),
                  (l.tbx1_ = Math.min(r.tbx1, l.tbx1)),
                  (l.tby1_ = Math.min(r.tby1, l.tby1)),
                  (c =
                    Math.floor((l.tbx0_ - r.tbx0) / v.precinctWidthInSubband) +
                    Math.floor((l.tby0_ - r.tby0) / v.precinctHeightInSubband) *
                      v.numprecinctswide),
                  (l.precinctNumber = c),
                  (l.subbandType = r.type),
                  (l.Lblock = 3),
                  !(l.tbx1_ <= l.tbx0_ || l.tby1_ <= l.tby0_))
                ) {
                  S.push(l);
                  var w = k[c];
                  void 0 !== w
                    ? (i < w.cbxMin
                        ? (w.cbxMin = i)
                        : i > w.cbxMax && (w.cbxMax = i),
                      o < w.cbyMin
                        ? (w.cbxMin = o)
                        : o > w.cbyMax && (w.cbyMax = o))
                    : (k[c] = w =
                        { cbxMin: i, cbyMin: o, cbxMax: i, cbyMax: o }),
                    (l.precinct = w);
                }
              }
            (r.codeblockParameters = {
              codeblockWidth: u,
              codeblockHeight: h,
              numcodeblockwide: b - m + 1,
              numcodeblockhigh: y - g + 1,
            }),
              (r.codeblocks = S),
              (r.precincts = k);
          }
          function createPacket(t, r, a) {
            for (var i = [], o = t.subbands, l = 0, c = o.length; l < c; l++)
              for (var u = o[l].codeblocks, h = 0, d = u.length; h < d; h++) {
                var p = u[h];
                p.precinctNumber === r && i.push(p);
              }
            return { layerNumber: a, codeblocks: i };
          }
          function LayerResolutionComponentPositionIterator(t) {
            for (
              var r = t.SIZ,
                a = t.currentTile.index,
                i = t.tiles[a],
                o = i.codingStyleDefaultParameters.layersCount,
                l = r.Csiz,
                u = 0,
                h = 0;
              h < l;
              h++
            )
              u = Math.max(
                u,
                i.components[h].codingStyleParameters.decompositionLevelsCount,
              );
            var d = 0,
              p = 0,
              m = 0,
              g = 0;
            this.nextPacket = function JpxImage_nextPacket() {
              for (; d < o; d++) {
                for (; p <= u; p++) {
                  for (; m < l; m++) {
                    var t = i.components[m];
                    if (
                      !(p > t.codingStyleParameters.decompositionLevelsCount)
                    ) {
                      for (
                        var r = t.resolutions[p],
                          a = r.precinctParameters.numprecincts;
                        g < a;

                      ) {
                        var h = createPacket(r, g, d);
                        return g++, h;
                      }
                      g = 0;
                    }
                  }
                  m = 0;
                }
                p = 0;
              }
              throw new c("Out of packets");
            };
          }
          function ResolutionLayerComponentPositionIterator(t) {
            for (
              var r = t.SIZ,
                a = t.currentTile.index,
                i = t.tiles[a],
                o = i.codingStyleDefaultParameters.layersCount,
                l = r.Csiz,
                u = 0,
                h = 0;
              h < l;
              h++
            )
              u = Math.max(
                u,
                i.components[h].codingStyleParameters.decompositionLevelsCount,
              );
            var d = 0,
              p = 0,
              m = 0,
              g = 0;
            this.nextPacket = function JpxImage_nextPacket() {
              for (; d <= u; d++) {
                for (; p < o; p++) {
                  for (; m < l; m++) {
                    var t = i.components[m];
                    if (
                      !(d > t.codingStyleParameters.decompositionLevelsCount)
                    ) {
                      for (
                        var r = t.resolutions[d],
                          a = r.precinctParameters.numprecincts;
                        g < a;

                      ) {
                        var h = createPacket(r, g, p);
                        return g++, h;
                      }
                      g = 0;
                    }
                  }
                  m = 0;
                }
                p = 0;
              }
              throw new c("Out of packets");
            };
          }
          function ResolutionPositionComponentLayerIterator(t) {
            var r,
              a,
              i,
              o,
              l = t.SIZ,
              u = t.currentTile.index,
              h = t.tiles[u],
              d = h.codingStyleDefaultParameters.layersCount,
              p = l.Csiz,
              m = 0;
            for (i = 0; i < p; i++) {
              var g = h.components[i];
              m = Math.max(m, g.codingStyleParameters.decompositionLevelsCount);
            }
            var b = new Int32Array(m + 1);
            for (a = 0; a <= m; ++a) {
              var y = 0;
              for (i = 0; i < p; ++i) {
                var v = h.components[i].resolutions;
                a < v.length &&
                  (y = Math.max(y, v[a].precinctParameters.numprecincts));
              }
              b[a] = y;
            }
            (r = 0),
              (a = 0),
              (i = 0),
              (o = 0),
              (this.nextPacket = function JpxImage_nextPacket() {
                for (; a <= m; a++) {
                  for (; o < b[a]; o++) {
                    for (; i < p; i++) {
                      var t = h.components[i];
                      if (
                        !(a > t.codingStyleParameters.decompositionLevelsCount)
                      ) {
                        var l = t.resolutions[a],
                          u = l.precinctParameters.numprecincts;
                        if (!(o >= u)) {
                          for (; r < d; ) {
                            var g = createPacket(l, o, r);
                            return r++, g;
                          }
                          r = 0;
                        }
                      }
                    }
                    i = 0;
                  }
                  o = 0;
                }
                throw new c("Out of packets");
              });
          }
          function PositionComponentResolutionLayerIterator(t) {
            var r = t.SIZ,
              a = t.currentTile.index,
              i = t.tiles[a],
              o = i.codingStyleDefaultParameters.layersCount,
              l = r.Csiz,
              u = getPrecinctSizesInImageScale(i),
              h = u,
              d = 0,
              p = 0,
              m = 0,
              g = 0,
              b = 0;
            this.nextPacket = function JpxImage_nextPacket() {
              for (; b < h.maxNumHigh; b++) {
                for (; g < h.maxNumWide; g++) {
                  for (; m < l; m++) {
                    for (
                      var t = i.components[m],
                        r = t.codingStyleParameters.decompositionLevelsCount;
                      p <= r;
                      p++
                    ) {
                      var a = t.resolutions[p],
                        y = u.components[m].resolutions[p],
                        v = getPrecinctIndexIfExist(g, b, y, h, a);
                      if (null !== v) {
                        for (; d < o; ) {
                          var S = createPacket(a, v, d);
                          return d++, S;
                        }
                        d = 0;
                      }
                    }
                    p = 0;
                  }
                  m = 0;
                }
                g = 0;
              }
              throw new c("Out of packets");
            };
          }
          function ComponentPositionResolutionLayerIterator(t) {
            var r = t.SIZ,
              a = t.currentTile.index,
              i = t.tiles[a],
              o = i.codingStyleDefaultParameters.layersCount,
              l = r.Csiz,
              u = getPrecinctSizesInImageScale(i),
              h = 0,
              d = 0,
              p = 0,
              m = 0,
              g = 0;
            this.nextPacket = function JpxImage_nextPacket() {
              for (; p < l; ++p) {
                for (
                  var t = i.components[p],
                    r = u.components[p],
                    a = t.codingStyleParameters.decompositionLevelsCount;
                  g < r.maxNumHigh;
                  g++
                ) {
                  for (; m < r.maxNumWide; m++) {
                    for (; d <= a; d++) {
                      var b = t.resolutions[d],
                        y = r.resolutions[d],
                        v = getPrecinctIndexIfExist(m, g, y, r, b);
                      if (null !== v) {
                        for (; h < o; ) {
                          var S = createPacket(b, v, h);
                          return h++, S;
                        }
                        h = 0;
                      }
                    }
                    d = 0;
                  }
                  m = 0;
                }
                g = 0;
              }
              throw new c("Out of packets");
            };
          }
          function getPrecinctIndexIfExist(t, r, a, i, o) {
            var l = t * i.minWidth,
              c = r * i.minHeight;
            if (l % a.width != 0 || c % a.height != 0) return null;
            var u = (c / a.width) * o.precinctParameters.numprecinctswide;
            return l / a.height + u;
          }
          function getPrecinctSizesInImageScale(t) {
            for (
              var r = t.components.length,
                a = Number.MAX_VALUE,
                i = Number.MAX_VALUE,
                o = 0,
                l = 0,
                c = new Array(r),
                u = 0;
              u < r;
              u++
            ) {
              for (
                var h = t.components[u],
                  d = h.codingStyleParameters.decompositionLevelsCount,
                  p = new Array(d + 1),
                  m = Number.MAX_VALUE,
                  g = Number.MAX_VALUE,
                  b = 0,
                  y = 0,
                  v = 1,
                  S = d;
                S >= 0;
                --S
              ) {
                var k = h.resolutions[S],
                  w = v * k.precinctParameters.precinctWidth,
                  C = v * k.precinctParameters.precinctHeight;
                (m = Math.min(m, w)),
                  (g = Math.min(g, C)),
                  (b = Math.max(b, k.precinctParameters.numprecinctswide)),
                  (y = Math.max(y, k.precinctParameters.numprecinctshigh)),
                  (p[S] = { width: w, height: C }),
                  (v <<= 1);
              }
              (a = Math.min(a, m)),
                (i = Math.min(i, g)),
                (o = Math.max(o, b)),
                (l = Math.max(l, y)),
                (c[u] = {
                  resolutions: p,
                  minWidth: m,
                  minHeight: g,
                  maxNumWide: b,
                  maxNumHigh: y,
                });
            }
            return {
              components: c,
              minWidth: a,
              minHeight: i,
              maxNumWide: o,
              maxNumHigh: l,
            };
          }
          function buildPackets(t) {
            for (
              var r = t.SIZ,
                a = t.currentTile.index,
                i = t.tiles[a],
                o = r.Csiz,
                l = 0;
              l < o;
              l++
            ) {
              for (
                var u = i.components[l],
                  h = u.codingStyleParameters.decompositionLevelsCount,
                  d = [],
                  p = [],
                  m = 0;
                m <= h;
                m++
              ) {
                var g,
                  b = getBlocksDimensions(0, u, m),
                  y = {},
                  v = 1 << (h - m);
                if (
                  ((y.trx0 = Math.ceil(u.tcx0 / v)),
                  (y.try0 = Math.ceil(u.tcy0 / v)),
                  (y.trx1 = Math.ceil(u.tcx1 / v)),
                  (y.try1 = Math.ceil(u.tcy1 / v)),
                  (y.resLevel = m),
                  buildPrecincts(0, y, b),
                  d.push(y),
                  0 === m)
                )
                  ((g = {}).type = "LL"),
                    (g.tbx0 = Math.ceil(u.tcx0 / v)),
                    (g.tby0 = Math.ceil(u.tcy0 / v)),
                    (g.tbx1 = Math.ceil(u.tcx1 / v)),
                    (g.tby1 = Math.ceil(u.tcy1 / v)),
                    (g.resolution = y),
                    buildCodeblocks(0, g, b),
                    p.push(g),
                    (y.subbands = [g]);
                else {
                  var S = 1 << (h - m + 1),
                    k = [];
                  ((g = {}).type = "HL"),
                    (g.tbx0 = Math.ceil(u.tcx0 / S - 0.5)),
                    (g.tby0 = Math.ceil(u.tcy0 / S)),
                    (g.tbx1 = Math.ceil(u.tcx1 / S - 0.5)),
                    (g.tby1 = Math.ceil(u.tcy1 / S)),
                    (g.resolution = y),
                    buildCodeblocks(0, g, b),
                    p.push(g),
                    k.push(g),
                    ((g = {}).type = "LH"),
                    (g.tbx0 = Math.ceil(u.tcx0 / S)),
                    (g.tby0 = Math.ceil(u.tcy0 / S - 0.5)),
                    (g.tbx1 = Math.ceil(u.tcx1 / S)),
                    (g.tby1 = Math.ceil(u.tcy1 / S - 0.5)),
                    (g.resolution = y),
                    buildCodeblocks(0, g, b),
                    p.push(g),
                    k.push(g),
                    ((g = {}).type = "HH"),
                    (g.tbx0 = Math.ceil(u.tcx0 / S - 0.5)),
                    (g.tby0 = Math.ceil(u.tcy0 / S - 0.5)),
                    (g.tbx1 = Math.ceil(u.tcx1 / S - 0.5)),
                    (g.tby1 = Math.ceil(u.tcy1 / S - 0.5)),
                    (g.resolution = y),
                    buildCodeblocks(0, g, b),
                    p.push(g),
                    k.push(g),
                    (y.subbands = k);
                }
              }
              (u.resolutions = d), (u.subbands = p);
            }
            var w = i.codingStyleDefaultParameters.progressionOrder;
            switch (w) {
              case 0:
                i.packetsIterator =
                  new LayerResolutionComponentPositionIterator(t);
                break;
              case 1:
                i.packetsIterator =
                  new ResolutionLayerComponentPositionIterator(t);
                break;
              case 2:
                i.packetsIterator =
                  new ResolutionPositionComponentLayerIterator(t);
                break;
              case 3:
                i.packetsIterator =
                  new PositionComponentResolutionLayerIterator(t);
                break;
              case 4:
                i.packetsIterator =
                  new ComponentPositionResolutionLayerIterator(t);
                break;
              default:
                throw new c("Unsupported progression order ".concat(w));
            }
          }
          function parseTilePackets(t, i, l, c) {
            var u,
              h = 0,
              d = 0,
              p = !1;
            function readBits(t) {
              for (; d < t; ) {
                var r = i[l + h];
                h++,
                  p
                    ? ((u = (u << 7) | r), (d += 7), (p = !1))
                    : ((u = (u << 8) | r), (d += 8)),
                  255 === r && (p = !0);
              }
              return (u >>> (d -= t)) & ((1 << t) - 1);
            }
            function skipMarkerIfEqual(t) {
              return 255 === i[l + h - 1] && i[l + h] === t
                ? (skipBytes(1), !0)
                : 255 === i[l + h] && i[l + h + 1] === t && (skipBytes(2), !0);
            }
            function skipBytes(t) {
              h += t;
            }
            function alignToByte() {
              (d = 0), p && (h++, (p = !1));
            }
            function readCodingpasses() {
              if (0 === readBits(1)) return 1;
              if (0 === readBits(1)) return 2;
              var t = readBits(2);
              return t < 3
                ? t + 3
                : (t = readBits(5)) < 31
                ? t + 6
                : (t = readBits(7)) + 37;
            }
            for (
              var m = t.currentTile.index,
                g = t.tiles[m],
                b = t.COD.sopMarkerUsed,
                y = t.COD.ephMarkerUsed,
                v = g.packetsIterator;
              h < c;

            ) {
              alignToByte(), b && skipMarkerIfEqual(145) && skipBytes(4);
              var S = v.nextPacket();
              if (readBits(1)) {
                for (
                  var k,
                    w = S.layerNumber,
                    C = [],
                    x = 0,
                    _ = S.codeblocks.length;
                  x < _;
                  x++
                ) {
                  var A = (k = S.codeblocks[x]).precinct,
                    R = k.cbx - A.cbxMin,
                    T = k.cby - A.cbyMin,
                    I = !1,
                    P = !1;
                  if (void 0 !== k.included) I = !!readBits(1);
                  else {
                    var O, E;
                    if (void 0 !== (A = k.precinct).inclusionTree)
                      O = A.inclusionTree;
                    else {
                      var B = A.cbxMax - A.cbxMin + 1,
                        D = A.cbyMax - A.cbyMin + 1;
                      (O = new a(B, D, w)),
                        (E = new r(B, D)),
                        (A.inclusionTree = O),
                        (A.zeroBitPlanesTree = E);
                    }
                    if (O.reset(R, T, w))
                      for (;;) {
                        if (!readBits(1)) {
                          O.incrementValue(w);
                          break;
                        }
                        if (!O.nextLevel()) {
                          (k.included = !0), (I = P = !0);
                          break;
                        }
                      }
                  }
                  if (I) {
                    if (P) {
                      for ((E = A.zeroBitPlanesTree).reset(R, T); ; )
                        if (readBits(1)) {
                          if (!E.nextLevel()) break;
                        } else E.incrementValue();
                      k.zeroBitPlanes = E.value;
                    }
                    for (var M = readCodingpasses(); readBits(1); ) k.Lblock++;
                    var L = (0, o.log2)(M),
                      N = readBits((M < 1 << L ? L - 1 : L) + k.Lblock);
                    C.push({ codeblock: k, codingpasses: M, dataLength: N });
                  }
                }
                for (
                  alignToByte(), y && skipMarkerIfEqual(146);
                  C.length > 0;

                ) {
                  var U = C.shift();
                  void 0 === (k = U.codeblock).data && (k.data = []),
                    k.data.push({
                      data: i,
                      start: l + h,
                      end: l + h + U.dataLength,
                      codingpasses: U.codingpasses,
                    }),
                    (h += U.dataLength);
                }
              }
            }
            return h;
          }
          function copyCoefficients(t, r, a, i, o, c, h, d) {
            for (
              var p = i.tbx0,
                m = i.tby0,
                g = i.tbx1 - i.tbx0,
                b = i.codeblocks,
                y = "H" === i.type.charAt(0) ? 1 : 0,
                v = "H" === i.type.charAt(1) ? r : 0,
                S = 0,
                k = b.length;
              S < k;
              ++S
            ) {
              var w = b[S],
                C = w.tbx1_ - w.tbx0_,
                x = w.tby1_ - w.tby0_;
              if (0 !== C && 0 !== x && void 0 !== w.data) {
                var _, A;
                (_ = new u(C, x, w.subbandType, w.zeroBitPlanes, c)), (A = 2);
                var R,
                  T,
                  I,
                  P = w.data,
                  O = 0,
                  E = 0;
                for (R = 0, T = P.length; R < T; R++)
                  (O += (I = P[R]).end - I.start), (E += I.codingpasses);
                var B = new Uint8Array(O),
                  D = 0;
                for (R = 0, T = P.length; R < T; R++) {
                  var M = (I = P[R]).data.subarray(I.start, I.end);
                  B.set(M, D), (D += M.length);
                }
                var L = new l.ArithmeticDecoder(B, 0, O);
                for (_.setDecoder(L), R = 0; R < E; R++) {
                  switch (A) {
                    case 0:
                      _.runSignificancePropagationPass();
                      break;
                    case 1:
                      _.runMagnitudeRefinementPass();
                      break;
                    case 2:
                      _.runCleanupPass(), d && _.checkSegmentationSymbol();
                  }
                  A = (A + 1) % 3;
                }
                var N,
                  U,
                  j,
                  q = w.tbx0_ - p + (w.tby0_ - m) * g,
                  W = _.coefficentsSign,
                  z = _.coefficentsMagnitude,
                  G = _.bitsDecoded,
                  H = h ? 0 : 0.5;
                D = 0;
                var X = "LL" !== i.type;
                for (R = 0; R < x; R++) {
                  var V = 2 * ((q / g) | 0) * (r - g) + y + v;
                  for (N = 0; N < C; N++) {
                    if (0 !== (U = z[D])) {
                      (U = (U + H) * o), 0 !== W[D] && (U = -U), (j = G[D]);
                      var Y = X ? V + (q << 1) : q;
                      t[Y] = h && j >= c ? U : U * (1 << (c - j));
                    }
                    q++, D++;
                  }
                  q += g - C;
                }
              }
            }
          }
          function transformTile(r, a, i) {
            for (
              var o = a.components[i],
                l = o.codingStyleParameters,
                c = o.quantizationParameters,
                u = l.decompositionLevelsCount,
                h = c.SPqcds,
                m = c.scalarExpounded,
                g = c.guardBits,
                b = l.segmentationSymbolUsed,
                y = r.components[i].precision,
                v = l.reversibleTransformation,
                S = v ? new p() : new d(),
                k = [],
                w = 0,
                C = 0;
              C <= u;
              C++
            ) {
              for (
                var x = o.resolutions[C],
                  _ = x.trx1 - x.trx0,
                  A = x.try1 - x.try0,
                  R = new Float32Array(_ * A),
                  T = 0,
                  I = x.subbands.length;
                T < I;
                T++
              ) {
                var P, O;
                m
                  ? ((P = h[w].mu), (O = h[w].epsilon), w++)
                  : ((P = h[0].mu), (O = h[0].epsilon + (C > 0 ? 1 - C : 0)));
                var E = x.subbands[T],
                  B = t[E.type];
                copyCoefficients(
                  R,
                  _,
                  0,
                  E,
                  v ? 1 : Math.pow(2, y + B - O) * (1 + P / 2048),
                  g + O - 1,
                  v,
                  b,
                );
              }
              k.push({ width: _, height: A, items: R });
            }
            var D = S.calculate(k, o.tcx0, o.tcy0);
            return {
              left: o.tcx0,
              top: o.tcy0,
              width: D.width,
              height: D.height,
              items: D.items,
            };
          }
          function initializeTile(t, r) {
            for (var a = t.SIZ.Csiz, i = t.tiles[r], o = 0; o < a; o++) {
              var l = i.components[o],
                c =
                  void 0 !== t.currentTile.QCC[o]
                    ? t.currentTile.QCC[o]
                    : t.currentTile.QCD;
              l.quantizationParameters = c;
              var u =
                void 0 !== t.currentTile.COC[o]
                  ? t.currentTile.COC[o]
                  : t.currentTile.COD;
              l.codingStyleParameters = u;
            }
            i.codingStyleDefaultParameters = t.currentTile.COD;
          }
          JpxImage.prototype = {
            parse: function JpxImage_parse(t) {
              if (65359 !== (0, o.readUint16)(t, 0))
                for (var r = 0, a = t.length; r < a; ) {
                  var l = 8,
                    u = (0, o.readUint32)(t, r),
                    h = (0, o.readUint32)(t, r + 4);
                  if (
                    ((r += l),
                    1 === u &&
                      ((u =
                        4294967296 * (0, o.readUint32)(t, r) +
                        (0, o.readUint32)(t, r + 4)),
                      (r += 8),
                      (l += 8)),
                    0 === u && (u = a - r + l),
                    u < l)
                  )
                    throw new c("Invalid box field size");
                  var d = u - l,
                    p = !0;
                  switch (h) {
                    case 1785737832:
                      p = !1;
                      break;
                    case 1668246642:
                      var m = t[r];
                      if (1 === m) {
                        var g = (0, o.readUint32)(t, r + 3);
                        switch (g) {
                          case 16:
                          case 17:
                          case 18:
                            break;
                          default:
                            (0, i.warn)("Unknown colorspace " + g);
                        }
                      } else
                        2 === m && (0, i.info)("ICC profile not supported");
                      break;
                    case 1785737827:
                      this.parseCodestream(t, r, r + d);
                      break;
                    case 1783636e3:
                      218793738 !== (0, o.readUint32)(t, r) &&
                        (0, i.warn)("Invalid JP2 signature");
                      break;
                    case 1783634458:
                    case 1718909296:
                    case 1920099697:
                    case 1919251232:
                    case 1768449138:
                      break;
                    default:
                      var b = String.fromCharCode(
                        (h >> 24) & 255,
                        (h >> 16) & 255,
                        (h >> 8) & 255,
                        255 & h,
                      );
                      (0, i.warn)(
                        "Unsupported header type " + h + " (" + b + ")",
                      );
                  }
                  p && (r += d);
                }
              else this.parseCodestream(t, 0, t.length);
            },
            parseImageProperties: function JpxImage_parseImageProperties(t) {
              for (var r = t.getByte(); r >= 0; ) {
                if (65361 === ((r << 8) | (r = t.getByte()))) {
                  t.skip(4);
                  var a = t.getInt32() >>> 0,
                    i = t.getInt32() >>> 0,
                    o = t.getInt32() >>> 0,
                    l = t.getInt32() >>> 0;
                  t.skip(16);
                  var u = t.getUint16();
                  return (
                    (this.width = a - o),
                    (this.height = i - l),
                    (this.componentsCount = u),
                    void (this.bitsPerComponent = 8)
                  );
                }
              }
              throw new c("No size marker found in JPX stream");
            },
            parseCodestream: function JpxImage_parseCodestream(t, r, a) {
              var l = {},
                u = !1;
              try {
                for (var h = r; h + 1 < a; ) {
                  var d = (0, o.readUint16)(t, h);
                  h += 2;
                  var p,
                    m,
                    g,
                    b,
                    y,
                    v,
                    S = 0;
                  switch (d) {
                    case 65359:
                      l.mainHeader = !0;
                      break;
                    case 65497:
                      break;
                    case 65361:
                      S = (0, o.readUint16)(t, h);
                      var k = {};
                      (k.Xsiz = (0, o.readUint32)(t, h + 4)),
                        (k.Ysiz = (0, o.readUint32)(t, h + 8)),
                        (k.XOsiz = (0, o.readUint32)(t, h + 12)),
                        (k.YOsiz = (0, o.readUint32)(t, h + 16)),
                        (k.XTsiz = (0, o.readUint32)(t, h + 20)),
                        (k.YTsiz = (0, o.readUint32)(t, h + 24)),
                        (k.XTOsiz = (0, o.readUint32)(t, h + 28)),
                        (k.YTOsiz = (0, o.readUint32)(t, h + 32));
                      var w = (0, o.readUint16)(t, h + 36);
                      k.Csiz = w;
                      var C = [];
                      p = h + 38;
                      for (var x = 0; x < w; x++) {
                        var _ = {
                          precision: 1 + (127 & t[p]),
                          isSigned: !!(128 & t[p]),
                          XRsiz: t[p + 1],
                          YRsiz: t[p + 2],
                        };
                        (p += 3), calculateComponentDimensions(_, k), C.push(_);
                      }
                      (l.SIZ = k),
                        (l.components = C),
                        calculateTileGrids(l, C),
                        (l.QCC = []),
                        (l.COC = []);
                      break;
                    case 65372:
                      S = (0, o.readUint16)(t, h);
                      var A = {};
                      switch (((p = h + 2), 31 & (m = t[p++]))) {
                        case 0:
                          (b = 8), (y = !0);
                          break;
                        case 1:
                          (b = 16), (y = !1);
                          break;
                        case 2:
                          (b = 16), (y = !0);
                          break;
                        default:
                          throw new Error("Invalid SQcd value " + m);
                      }
                      for (
                        A.noQuantization = 8 === b,
                          A.scalarExpounded = y,
                          A.guardBits = m >> 5,
                          g = [];
                        p < S + h;

                      ) {
                        var R = {};
                        8 === b
                          ? ((R.epsilon = t[p++] >> 3), (R.mu = 0))
                          : ((R.epsilon = t[p] >> 3),
                            (R.mu = ((7 & t[p]) << 8) | t[p + 1]),
                            (p += 2)),
                          g.push(R);
                      }
                      (A.SPqcds = g),
                        l.mainHeader
                          ? (l.QCD = A)
                          : ((l.currentTile.QCD = A), (l.currentTile.QCC = []));
                      break;
                    case 65373:
                      S = (0, o.readUint16)(t, h);
                      var T,
                        I = {};
                      switch (
                        ((p = h + 2),
                        l.SIZ.Csiz < 257
                          ? (T = t[p++])
                          : ((T = (0, o.readUint16)(t, p)), (p += 2)),
                        31 & (m = t[p++]))
                      ) {
                        case 0:
                          (b = 8), (y = !0);
                          break;
                        case 1:
                          (b = 16), (y = !1);
                          break;
                        case 2:
                          (b = 16), (y = !0);
                          break;
                        default:
                          throw new Error("Invalid SQcd value " + m);
                      }
                      for (
                        I.noQuantization = 8 === b,
                          I.scalarExpounded = y,
                          I.guardBits = m >> 5,
                          g = [];
                        p < S + h;

                      )
                        (R = {}),
                          8 === b
                            ? ((R.epsilon = t[p++] >> 3), (R.mu = 0))
                            : ((R.epsilon = t[p] >> 3),
                              (R.mu = ((7 & t[p]) << 8) | t[p + 1]),
                              (p += 2)),
                          g.push(R);
                      (I.SPqcds = g),
                        l.mainHeader
                          ? (l.QCC[T] = I)
                          : (l.currentTile.QCC[T] = I);
                      break;
                    case 65362:
                      S = (0, o.readUint16)(t, h);
                      var P = {};
                      p = h + 2;
                      var O = t[p++];
                      (P.entropyCoderWithCustomPrecincts = !!(1 & O)),
                        (P.sopMarkerUsed = !!(2 & O)),
                        (P.ephMarkerUsed = !!(4 & O)),
                        (P.progressionOrder = t[p++]),
                        (P.layersCount = (0, o.readUint16)(t, p)),
                        (p += 2),
                        (P.multipleComponentTransform = t[p++]),
                        (P.decompositionLevelsCount = t[p++]),
                        (P.xcb = 2 + (15 & t[p++])),
                        (P.ycb = 2 + (15 & t[p++]));
                      var E = t[p++];
                      if (
                        ((P.selectiveArithmeticCodingBypass = !!(1 & E)),
                        (P.resetContextProbabilities = !!(2 & E)),
                        (P.terminationOnEachCodingPass = !!(4 & E)),
                        (P.verticallyStripe = !!(8 & E)),
                        (P.predictableTermination = !!(16 & E)),
                        (P.segmentationSymbolUsed = !!(32 & E)),
                        (P.reversibleTransformation = t[p++]),
                        P.entropyCoderWithCustomPrecincts)
                      ) {
                        for (var B = []; p < S + h; ) {
                          var D = t[p++];
                          B.push({ PPx: 15 & D, PPy: D >> 4 });
                        }
                        P.precinctsSizes = B;
                      }
                      var M = [];
                      if (
                        (P.selectiveArithmeticCodingBypass &&
                          M.push("selectiveArithmeticCodingBypass"),
                        P.resetContextProbabilities &&
                          M.push("resetContextProbabilities"),
                        P.terminationOnEachCodingPass &&
                          M.push("terminationOnEachCodingPass"),
                        P.verticallyStripe && M.push("verticallyStripe"),
                        P.predictableTermination &&
                          M.push("predictableTermination"),
                        M.length > 0)
                      )
                        throw (
                          ((u = !0),
                          new Error(
                            "Unsupported COD options (" + M.join(", ") + ")",
                          ))
                        );
                      l.mainHeader
                        ? (l.COD = P)
                        : ((l.currentTile.COD = P), (l.currentTile.COC = []));
                      break;
                    case 65424:
                      (S = (0, o.readUint16)(t, h)),
                        ((v = {}).index = (0, o.readUint16)(t, h + 2)),
                        (v.length = (0, o.readUint32)(t, h + 4)),
                        (v.dataEnd = v.length + h - 2),
                        (v.partIndex = t[h + 8]),
                        (v.partsCount = t[h + 9]),
                        (l.mainHeader = !1),
                        0 === v.partIndex &&
                          ((v.COD = l.COD),
                          (v.COC = l.COC.slice(0)),
                          (v.QCD = l.QCD),
                          (v.QCC = l.QCC.slice(0))),
                        (l.currentTile = v);
                      break;
                    case 65427:
                      0 === (v = l.currentTile).partIndex &&
                        (initializeTile(l, v.index), buildPackets(l)),
                        parseTilePackets(l, t, h, (S = v.dataEnd - h));
                      break;
                    case 65365:
                    case 65367:
                    case 65368:
                    case 65380:
                      S = (0, o.readUint16)(t, h);
                      break;
                    case 65363:
                      throw new Error(
                        "Codestream code 0xFF53 (COC) is not implemented",
                      );
                    default:
                      throw new Error(
                        "Unknown codestream code: " + d.toString(16),
                      );
                  }
                  h += S;
                }
              } catch (t) {
                if (u || this.failOnCorruptedImage) throw new c(t.message);
                (0, i.warn)("JPX: Trying to recover from: " + t.message);
              }
              (this.tiles = (function transformComponents(t) {
                for (
                  var r = t.SIZ,
                    a = t.components,
                    i = r.Csiz,
                    o = [],
                    l = 0,
                    c = t.tiles.length;
                  l < c;
                  l++
                ) {
                  var u,
                    h = t.tiles[l],
                    d = [];
                  for (u = 0; u < i; u++) d[u] = transformTile(t, h, u);
                  var p,
                    m,
                    g,
                    b,
                    y,
                    v,
                    S,
                    k = d[0],
                    w = new Uint8ClampedArray(k.items.length * i),
                    C = {
                      left: k.left,
                      top: k.top,
                      width: k.width,
                      height: k.height,
                      items: w,
                    },
                    x = 0;
                  if (
                    h.codingStyleDefaultParameters.multipleComponentTransform
                  ) {
                    var _ = 4 === i,
                      A = d[0].items,
                      R = d[1].items,
                      T = d[2].items,
                      I = _ ? d[3].items : null;
                    m = 0.5 + (128 << (p = a[0].precision - 8));
                    var P = h.components[0],
                      O = i - 3;
                    if (
                      ((b = A.length),
                      P.codingStyleParameters.reversibleTransformation)
                    )
                      for (g = 0; g < b; g++, x += O) {
                        (y = A[g] + m), (v = R[g]);
                        var E = y - (((S = T[g]) + v) >> 2);
                        (w[x++] = (E + S) >> p),
                          (w[x++] = E >> p),
                          (w[x++] = (E + v) >> p);
                      }
                    else
                      for (g = 0; g < b; g++, x += O)
                        (y = A[g] + m),
                          (v = R[g]),
                          (S = T[g]),
                          (w[x++] = (y + 1.402 * S) >> p),
                          (w[x++] = (y - 0.34413 * v - 0.71414 * S) >> p),
                          (w[x++] = (y + 1.772 * v) >> p);
                    if (_)
                      for (g = 0, x = 3; g < b; g++, x += 4)
                        w[x] = (I[g] + m) >> p;
                  } else
                    for (u = 0; u < i; u++) {
                      var B = d[u].items;
                      for (
                        m = 0.5 + (128 << (p = a[u].precision - 8)),
                          x = u,
                          g = 0,
                          b = B.length;
                        g < b;
                        g++
                      )
                        (w[x] = (B[g] + m) >> p), (x += i);
                    }
                  o.push(C);
                }
                return o;
              })(l)),
                (this.width = l.SIZ.Xsiz - l.SIZ.XOsiz),
                (this.height = l.SIZ.Ysiz - l.SIZ.YOsiz),
                (this.componentsCount = l.SIZ.Csiz);
            },
          };
          var r = (function TagTreeClosure() {
              function TagTree(t, r) {
                var a = (0, o.log2)(Math.max(t, r)) + 1;
                this.levels = [];
                for (var i = 0; i < a; i++) {
                  var l = { width: t, height: r, items: [] };
                  this.levels.push(l),
                    (t = Math.ceil(t / 2)),
                    (r = Math.ceil(r / 2));
                }
              }
              return (
                (TagTree.prototype = {
                  reset: function TagTree_reset(t, r) {
                    for (var a, i = 0, o = 0; i < this.levels.length; ) {
                      var l = t + r * (a = this.levels[i]).width;
                      if (void 0 !== a.items[l]) {
                        o = a.items[l];
                        break;
                      }
                      (a.index = l), (t >>= 1), (r >>= 1), i++;
                    }
                    i--,
                      ((a = this.levels[i]).items[a.index] = o),
                      (this.currentLevel = i),
                      delete this.value;
                  },
                  incrementValue: function TagTree_incrementValue() {
                    var t = this.levels[this.currentLevel];
                    t.items[t.index]++;
                  },
                  nextLevel: function TagTree_nextLevel() {
                    var t = this.currentLevel,
                      r = this.levels[t],
                      a = r.items[r.index];
                    return --t < 0
                      ? ((this.value = a), !1)
                      : ((this.currentLevel = t),
                        ((r = this.levels[t]).items[r.index] = a),
                        !0);
                  },
                }),
                TagTree
              );
            })(),
            a = (function InclusionTreeClosure() {
              function InclusionTree(t, r, a) {
                var i = (0, o.log2)(Math.max(t, r)) + 1;
                this.levels = [];
                for (var l = 0; l < i; l++) {
                  for (
                    var c = new Uint8Array(t * r), u = 0, h = c.length;
                    u < h;
                    u++
                  )
                    c[u] = a;
                  var d = { width: t, height: r, items: c };
                  this.levels.push(d),
                    (t = Math.ceil(t / 2)),
                    (r = Math.ceil(r / 2));
                }
              }
              return (
                (InclusionTree.prototype = {
                  reset: function InclusionTree_reset(t, r, a) {
                    for (var i = 0; i < this.levels.length; ) {
                      var o = this.levels[i],
                        l = t + r * o.width;
                      o.index = l;
                      var c = o.items[l];
                      if (255 === c) break;
                      if (c > a)
                        return (
                          (this.currentLevel = i), this.propagateValues(), !1
                        );
                      (t >>= 1), (r >>= 1), i++;
                    }
                    return (this.currentLevel = i - 1), !0;
                  },
                  incrementValue: function InclusionTree_incrementValue(t) {
                    var r = this.levels[this.currentLevel];
                    (r.items[r.index] = t + 1), this.propagateValues();
                  },
                  propagateValues: function InclusionTree_propagateValues() {
                    for (
                      var t = this.currentLevel,
                        r = this.levels[t],
                        a = r.items[r.index];
                      --t >= 0;

                    )
                      (r = this.levels[t]).items[r.index] = a;
                  },
                  nextLevel: function InclusionTree_nextLevel() {
                    var t = this.currentLevel,
                      r = this.levels[t],
                      a = r.items[r.index];
                    return (
                      (r.items[r.index] = 255),
                      !(--t < 0) &&
                        ((this.currentLevel = t),
                        ((r = this.levels[t]).items[r.index] = a),
                        !0)
                    );
                  },
                }),
                InclusionTree
              );
            })(),
            u = (function BitModelClosure() {
              var t = 17,
                r = new Uint8Array([
                  0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3,
                  7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7,
                  8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0,
                  0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8,
                ]),
                a = new Uint8Array([
                  0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6,
                  7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8,
                  8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0,
                  0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8,
                ]),
                i = new Uint8Array([
                  0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4,
                  5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7,
                  7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0,
                  0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8,
                ]);
              function BitModel(t, o, l, c, u) {
                var h;
                (this.width = t),
                  (this.height = o),
                  (h = "HH" === l ? i : "HL" === l ? a : r),
                  (this.contextLabelTable = h);
                var d,
                  p = t * o;
                (this.neighborsSignificance = new Uint8Array(p)),
                  (this.coefficentsSign = new Uint8Array(p)),
                  (d =
                    u > 14
                      ? new Uint32Array(p)
                      : u > 6
                      ? new Uint16Array(p)
                      : new Uint8Array(p)),
                  (this.coefficentsMagnitude = d),
                  (this.processingFlags = new Uint8Array(p));
                var m = new Uint8Array(p);
                if (0 !== c) for (var g = 0; g < p; g++) m[g] = c;
                (this.bitsDecoded = m), this.reset();
              }
              return (
                (BitModel.prototype = {
                  setDecoder: function BitModel_setDecoder(t) {
                    this.decoder = t;
                  },
                  reset: function BitModel_reset() {
                    (this.contexts = new Int8Array(19)),
                      (this.contexts[0] = 8),
                      (this.contexts[17] = 92),
                      (this.contexts[18] = 6);
                  },
                  setNeighborsSignificance:
                    function BitModel_setNeighborsSignificance(t, r, a) {
                      var i,
                        o = this.neighborsSignificance,
                        l = this.width,
                        c = this.height,
                        u = r > 0,
                        h = r + 1 < l;
                      t > 0 &&
                        ((i = a - l),
                        u && (o[i - 1] += 16),
                        h && (o[i + 1] += 16),
                        (o[i] += 4)),
                        t + 1 < c &&
                          ((i = a + l),
                          u && (o[i - 1] += 16),
                          h && (o[i + 1] += 16),
                          (o[i] += 4)),
                        u && (o[a - 1] += 1),
                        h && (o[a + 1] += 1),
                        (o[a] |= 128);
                    },
                  runSignificancePropagationPass:
                    function BitModel_runSignificancePropagationPass() {
                      for (
                        var t = this.decoder,
                          r = this.width,
                          a = this.height,
                          i = this.coefficentsMagnitude,
                          o = this.coefficentsSign,
                          l = this.neighborsSignificance,
                          c = this.processingFlags,
                          u = this.contexts,
                          h = this.contextLabelTable,
                          d = this.bitsDecoded,
                          p = 0;
                        p < a;
                        p += 4
                      )
                        for (var m = 0; m < r; m++)
                          for (var g = p * r + m, b = 0; b < 4; b++, g += r) {
                            var y = p + b;
                            if (y >= a) break;
                            if (((c[g] &= -2), !i[g] && l[g])) {
                              var v = h[l[g]];
                              if (t.readBit(u, v)) {
                                var S = this.decodeSignBit(y, m, g);
                                (o[g] = S),
                                  (i[g] = 1),
                                  this.setNeighborsSignificance(y, m, g),
                                  (c[g] |= 2);
                              }
                              d[g]++, (c[g] |= 1);
                            }
                          }
                    },
                  decodeSignBit: function BitModel_decodeSignBit(t, r, a) {
                    var i,
                      o,
                      l,
                      c,
                      u,
                      h,
                      d = this.width,
                      p = this.height,
                      m = this.coefficentsMagnitude,
                      g = this.coefficentsSign;
                    (c = r > 0 && 0 !== m[a - 1]),
                      r + 1 < d && 0 !== m[a + 1]
                        ? ((l = g[a + 1]),
                          (i = c ? 1 - l - (o = g[a - 1]) : 1 - l - l))
                        : (i = c ? 1 - (o = g[a - 1]) - o : 0);
                    var b = 3 * i;
                    return (
                      (c = t > 0 && 0 !== m[a - d]),
                      t + 1 < p && 0 !== m[a + d]
                        ? ((l = g[a + d]),
                          (i = c ? 1 - l - (o = g[a - d]) + b : 1 - l - l + b))
                        : (i = c ? 1 - (o = g[a - d]) - o + b : b),
                      i >= 0
                        ? ((u = 9 + i),
                          (h = this.decoder.readBit(this.contexts, u)))
                        : ((u = 9 - i),
                          (h = 1 ^ this.decoder.readBit(this.contexts, u))),
                      h
                    );
                  },
                  runMagnitudeRefinementPass:
                    function BitModel_runMagnitudeRefinementPass() {
                      for (
                        var t,
                          r = this.decoder,
                          a = this.width,
                          i = this.height,
                          o = this.coefficentsMagnitude,
                          l = this.neighborsSignificance,
                          c = this.contexts,
                          u = this.bitsDecoded,
                          h = this.processingFlags,
                          d = a * i,
                          p = 4 * a,
                          m = 0;
                        m < d;
                        m = t
                      ) {
                        t = Math.min(d, m + p);
                        for (var g = 0; g < a; g++)
                          for (var b = m + g; b < t; b += a)
                            if (o[b] && 0 == (1 & h[b])) {
                              var y = 16;
                              if (0 != (2 & h[b]))
                                (h[b] ^= 2), (y = 0 === (127 & l[b]) ? 15 : 14);
                              var v = r.readBit(c, y);
                              (o[b] = (o[b] << 1) | v), u[b]++, (h[b] |= 1);
                            }
                      }
                    },
                  runCleanupPass: function BitModel_runCleanupPass() {
                    for (
                      var r,
                        a = this.decoder,
                        i = this.width,
                        o = this.height,
                        l = this.neighborsSignificance,
                        c = this.coefficentsMagnitude,
                        u = this.coefficentsSign,
                        h = this.contexts,
                        d = this.contextLabelTable,
                        p = this.bitsDecoded,
                        m = this.processingFlags,
                        g = i,
                        b = 2 * i,
                        y = 3 * i,
                        v = 0;
                      v < o;
                      v = r
                    ) {
                      r = Math.min(v + 4, o);
                      for (var S = v * i, k = v + 3 < o, w = 0; w < i; w++) {
                        var C,
                          x = S + w,
                          _ = 0,
                          A = x,
                          R = v;
                        if (
                          k &&
                          0 === m[x] &&
                          0 === m[x + g] &&
                          0 === m[x + b] &&
                          0 === m[x + y] &&
                          0 === l[x] &&
                          0 === l[x + g] &&
                          0 === l[x + b] &&
                          0 === l[x + y]
                        ) {
                          if (!a.readBit(h, 18)) {
                            p[x]++, p[x + g]++, p[x + b]++, p[x + y]++;
                            continue;
                          }
                          0 !==
                            (_ = (a.readBit(h, t) << 1) | a.readBit(h, t)) &&
                            ((R = v + _), (A += _ * i)),
                            (C = this.decodeSignBit(R, w, A)),
                            (u[A] = C),
                            (c[A] = 1),
                            this.setNeighborsSignificance(R, w, A),
                            (m[A] |= 2),
                            (A = x);
                          for (var T = v; T <= R; T++, A += i) p[A]++;
                          _++;
                        }
                        for (R = v + _; R < r; R++, A += i)
                          if (!c[A] && 0 == (1 & m[A])) {
                            var I = d[l[A]];
                            1 === a.readBit(h, I) &&
                              ((C = this.decodeSignBit(R, w, A)),
                              (u[A] = C),
                              (c[A] = 1),
                              this.setNeighborsSignificance(R, w, A),
                              (m[A] |= 2)),
                              p[A]++;
                          }
                      }
                    }
                  },
                  checkSegmentationSymbol:
                    function BitModel_checkSegmentationSymbol() {
                      var r = this.decoder,
                        a = this.contexts;
                      if (
                        10 !==
                        ((r.readBit(a, t) << 3) |
                          (r.readBit(a, t) << 2) |
                          (r.readBit(a, t) << 1) |
                          r.readBit(a, t))
                      )
                        throw new c("Invalid segmentation symbol");
                    },
                }),
                BitModel
              );
            })(),
            h = (function TransformClosure() {
              function Transform() {}
              return (
                (Transform.prototype.calculate = function transformCalculate(
                  t,
                  r,
                  a,
                ) {
                  for (var i = t[0], o = 1, l = t.length; o < l; o++)
                    i = this.iterate(i, t[o], r, a);
                  return i;
                }),
                (Transform.prototype.extend = function extend(t, r, a) {
                  var i = r - 1,
                    o = r + 1,
                    l = r + a - 2,
                    c = r + a;
                  (t[i--] = t[o++]),
                    (t[c++] = t[l--]),
                    (t[i--] = t[o++]),
                    (t[c++] = t[l--]),
                    (t[i--] = t[o++]),
                    (t[c++] = t[l--]),
                    (t[i] = t[o]),
                    (t[c] = t[l]);
                }),
                (Transform.prototype.iterate = function Transform_iterate(
                  t,
                  r,
                  a,
                  i,
                ) {
                  var o,
                    l,
                    c,
                    u,
                    h,
                    d,
                    p = t.width,
                    m = t.height,
                    g = t.items,
                    b = r.width,
                    y = r.height,
                    v = r.items;
                  for (c = 0, o = 0; o < m; o++)
                    for (u = 2 * o * b, l = 0; l < p; l++, c++, u += 2)
                      v[u] = g[c];
                  g = t.items = null;
                  var S = new Float32Array(b + 8);
                  if (1 === b) {
                    if (0 != (1 & a))
                      for (d = 0, c = 0; d < y; d++, c += b) v[c] *= 0.5;
                  } else
                    for (d = 0, c = 0; d < y; d++, c += b)
                      S.set(v.subarray(c, c + b), 4),
                        this.extend(S, 4, b),
                        this.filter(S, 4, b),
                        v.set(S.subarray(4, 4 + b), c);
                  var k = 16,
                    w = [];
                  for (o = 0; o < k; o++) w.push(new Float32Array(y + 8));
                  var C,
                    x = 0;
                  if (((t = 4 + y), 1 === y)) {
                    if (0 != (1 & i)) for (h = 0; h < b; h++) v[h] *= 0.5;
                  } else
                    for (h = 0; h < b; h++) {
                      if (0 === x) {
                        for (
                          k = Math.min(b - h, k), c = h, u = 4;
                          u < t;
                          c += b, u++
                        )
                          for (C = 0; C < k; C++) w[C][u] = v[c + C];
                        x = k;
                      }
                      var _ = w[--x];
                      if ((this.extend(_, 4, y), this.filter(_, 4, y), 0 === x))
                        for (c = h - k + 1, u = 4; u < t; c += b, u++)
                          for (C = 0; C < k; C++) v[c + C] = w[C][u];
                    }
                  return { width: b, height: y, items: v };
                }),
                Transform
              );
            })(),
            d = (function IrreversibleTransformClosure() {
              function IrreversibleTransform() {
                h.call(this);
              }
              return (
                (IrreversibleTransform.prototype = Object.create(h.prototype)),
                (IrreversibleTransform.prototype.filter =
                  function irreversibleTransformFilter(t, r, a) {
                    var i,
                      o,
                      l,
                      c,
                      u = a >> 1,
                      h = -1.586134342059924,
                      d = -0.052980118572961,
                      p = 0.882911075530934,
                      m = 0.443506852043971,
                      g = 1.230174104914001;
                    for (i = (r |= 0) - 3, o = u + 4; o--; i += 2)
                      t[i] *= 0.8128930661159609;
                    for (
                      l = m * t[(i = r - 2) - 1], o = u + 3;
                      o-- &&
                      ((c = m * t[i + 1]), (t[i] = g * t[i] - l - c), o--);
                      i += 2
                    )
                      (l = m * t[(i += 2) + 1]), (t[i] = g * t[i] - l - c);
                    for (
                      l = p * t[(i = r - 1) - 1], o = u + 2;
                      o-- && ((c = p * t[i + 1]), (t[i] -= l + c), o--);
                      i += 2
                    )
                      (l = p * t[(i += 2) + 1]), (t[i] -= l + c);
                    for (
                      l = d * t[(i = r) - 1], o = u + 1;
                      o-- && ((c = d * t[i + 1]), (t[i] -= l + c), o--);
                      i += 2
                    )
                      (l = d * t[(i += 2) + 1]), (t[i] -= l + c);
                    if (0 !== u)
                      for (
                        l = h * t[(i = r + 1) - 1], o = u;
                        o-- && ((c = h * t[i + 1]), (t[i] -= l + c), o--);
                        i += 2
                      )
                        (l = h * t[(i += 2) + 1]), (t[i] -= l + c);
                  }),
                IrreversibleTransform
              );
            })(),
            p = (function ReversibleTransformClosure() {
              function ReversibleTransform() {
                h.call(this);
              }
              return (
                (ReversibleTransform.prototype = Object.create(h.prototype)),
                (ReversibleTransform.prototype.filter =
                  function reversibleTransformFilter(t, r, a) {
                    var i,
                      o,
                      l = a >> 1;
                    for (i = r |= 0, o = l + 1; o--; i += 2)
                      t[i] -= (t[i - 1] + t[i + 1] + 2) >> 2;
                    for (i = r + 1, o = l; o--; i += 2)
                      t[i] += (t[i - 1] + t[i + 1]) >> 1;
                  }),
                ReversibleTransform
              );
            })();
          return JpxImage;
        })();
      r.JpxImage = u;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.calculateSHA512 =
          r.calculateSHA384 =
          r.calculateSHA256 =
          r.calculateMD5 =
          r.PDF20 =
          r.PDF17 =
          r.CipherTransformFactory =
          r.ARCFourCipher =
          r.AES256Cipher =
          r.AES128Cipher =
            void 0);
      var i = a(5),
        o = a(198),
        l = a(205);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _inherits(t, r) {
        if ("function" != typeof r && null !== r)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (t.prototype = Object.create(r && r.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          r && _setPrototypeOf(t, r);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var c = (function ARCFourCipherClosure() {
        function ARCFourCipher(t) {
          (this.a = 0), (this.b = 0);
          var r,
            a,
            i = new Uint8Array(256),
            o = 0,
            l = t.length;
          for (r = 0; r < 256; ++r) i[r] = r;
          for (r = 0; r < 256; ++r)
            (o = (o + (a = i[r]) + t[r % l]) & 255), (i[r] = i[o]), (i[o] = a);
          this.s = i;
        }
        return (
          (ARCFourCipher.prototype = {
            encryptBlock: function ARCFourCipher_encryptBlock(t) {
              var r,
                a,
                i,
                o = t.length,
                l = this.a,
                c = this.b,
                u = this.s,
                h = new Uint8Array(o);
              for (r = 0; r < o; ++r)
                (i = u[(c = (c + (a = u[(l = (l + 1) & 255)])) & 255)]),
                  (u[l] = i),
                  (u[c] = a),
                  (h[r] = t[r] ^ u[(a + i) & 255]);
              return (this.a = l), (this.b = c), h;
            },
          }),
          (ARCFourCipher.prototype.decryptBlock =
            ARCFourCipher.prototype.encryptBlock),
          ARCFourCipher
        );
      })();
      r.ARCFourCipher = c;
      var u = (function calculateMD5Closure() {
        var t = new Uint8Array([
            7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9,
            14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4,
            11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15,
            21, 6, 10, 15, 21, 6, 10, 15, 21,
          ]),
          r = new Int32Array([
            -680876936, -389564586, 606105819, -1044525330, -176418897,
            1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063,
            -1990404162, 1804603682, -40341101, -1502002290, 1236535329,
            -165796510, -1069501632, 643717713, -373897302, -701558691,
            38016083, -660478335, -405537848, 568446438, -1019803690,
            -187363961, 1163531501, -1444681467, -51403784, 1735328473,
            -1926607734, -378558, -2022574463, 1839030562, -35309556,
            -1530992060, 1272893353, -155497632, -1094730640, 681279174,
            -358537222, -722521979, 76029189, -640364487, -421815835, 530742520,
            -995338651, -198630844, 1126891415, -1416354905, -57434055,
            1700485571, -1894986606, -1051523, -2054922799, 1873313359,
            -30611744, -1560198380, 1309151649, -145523070, -1120210379,
            718787259, -343485551,
          ]);
        return function hash(a, i, o) {
          var l,
            c,
            u,
            h = 1732584193,
            d = -271733879,
            p = -1732584194,
            m = 271733878,
            g = (o + 72) & -64,
            b = new Uint8Array(g);
          for (l = 0; l < o; ++l) b[l] = a[i++];
          for (b[l++] = 128, u = g - 8; l < u; ) b[l++] = 0;
          (b[l++] = (o << 3) & 255),
            (b[l++] = (o >> 5) & 255),
            (b[l++] = (o >> 13) & 255),
            (b[l++] = (o >> 21) & 255),
            (b[l++] = (o >>> 29) & 255),
            (b[l++] = 0),
            (b[l++] = 0),
            (b[l++] = 0);
          var y = new Int32Array(16);
          for (l = 0; l < g; ) {
            for (c = 0; c < 16; ++c, l += 4)
              y[c] =
                b[l] | (b[l + 1] << 8) | (b[l + 2] << 16) | (b[l + 3] << 24);
            var v,
              S,
              k = h,
              w = d,
              C = p,
              x = m;
            for (c = 0; c < 64; ++c) {
              c < 16
                ? ((v = (w & C) | (~w & x)), (S = c))
                : c < 32
                ? ((v = (x & w) | (~x & C)), (S = (5 * c + 1) & 15))
                : c < 48
                ? ((v = w ^ C ^ x), (S = (3 * c + 5) & 15))
                : ((v = C ^ (w | ~x)), (S = (7 * c) & 15));
              var _ = x,
                A = (k + v + r[c] + y[S]) | 0,
                R = t[c];
              (x = C),
                (C = w),
                (w = (w + ((A << R) | (A >>> (32 - R)))) | 0),
                (k = _);
            }
            (h = (h + k) | 0),
              (d = (d + w) | 0),
              (p = (p + C) | 0),
              (m = (m + x) | 0);
          }
          return new Uint8Array([
            255 & h,
            (h >> 8) & 255,
            (h >> 16) & 255,
            (h >>> 24) & 255,
            255 & d,
            (d >> 8) & 255,
            (d >> 16) & 255,
            (d >>> 24) & 255,
            255 & p,
            (p >> 8) & 255,
            (p >> 16) & 255,
            (p >>> 24) & 255,
            255 & m,
            (m >> 8) & 255,
            (m >> 16) & 255,
            (m >>> 24) & 255,
          ]);
        };
      })();
      r.calculateMD5 = u;
      var h = (function Word64Closure() {
          function Word64(t, r) {
            (this.high = 0 | t), (this.low = 0 | r);
          }
          return (
            (Word64.prototype = {
              and: function Word64_and(t) {
                (this.high &= t.high), (this.low &= t.low);
              },
              xor: function Word64_xor(t) {
                (this.high ^= t.high), (this.low ^= t.low);
              },
              or: function Word64_or(t) {
                (this.high |= t.high), (this.low |= t.low);
              },
              shiftRight: function Word64_shiftRight(t) {
                t >= 32
                  ? ((this.low = (this.high >>> (t - 32)) | 0), (this.high = 0))
                  : ((this.low = (this.low >>> t) | (this.high << (32 - t))),
                    (this.high = (this.high >>> t) | 0));
              },
              shiftLeft: function Word64_shiftLeft(t) {
                t >= 32
                  ? ((this.high = this.low << (t - 32)), (this.low = 0))
                  : ((this.high = (this.high << t) | (this.low >>> (32 - t))),
                    (this.low = this.low << t));
              },
              rotateRight: function Word64_rotateRight(t) {
                var r, a;
                32 & t
                  ? ((a = this.low), (r = this.high))
                  : ((r = this.low), (a = this.high)),
                  (t &= 31),
                  (this.low = (r >>> t) | (a << (32 - t))),
                  (this.high = (a >>> t) | (r << (32 - t)));
              },
              not: function Word64_not() {
                (this.high = ~this.high), (this.low = ~this.low);
              },
              add: function Word64_add(t) {
                var r = (this.low >>> 0) + (t.low >>> 0),
                  a = (this.high >>> 0) + (t.high >>> 0);
                r > 4294967295 && (a += 1),
                  (this.low = 0 | r),
                  (this.high = 0 | a);
              },
              copyTo: function Word64_copyTo(t, r) {
                (t[r] = (this.high >>> 24) & 255),
                  (t[r + 1] = (this.high >> 16) & 255),
                  (t[r + 2] = (this.high >> 8) & 255),
                  (t[r + 3] = 255 & this.high),
                  (t[r + 4] = (this.low >>> 24) & 255),
                  (t[r + 5] = (this.low >> 16) & 255),
                  (t[r + 6] = (this.low >> 8) & 255),
                  (t[r + 7] = 255 & this.low);
              },
              assign: function Word64_assign(t) {
                (this.high = t.high), (this.low = t.low);
              },
            }),
            Word64
          );
        })(),
        d = (function calculateSHA256Closure() {
          function rotr(t, r) {
            return (t >>> r) | (t << (32 - r));
          }
          function ch(t, r, a) {
            return (t & r) ^ (~t & a);
          }
          function maj(t, r, a) {
            return (t & r) ^ (t & a) ^ (r & a);
          }
          function sigma(t) {
            return rotr(t, 2) ^ rotr(t, 13) ^ rotr(t, 22);
          }
          function sigmaPrime(t) {
            return rotr(t, 6) ^ rotr(t, 11) ^ rotr(t, 25);
          }
          function littleSigma(t) {
            return rotr(t, 7) ^ rotr(t, 18) ^ (t >>> 3);
          }
          var t = [
            1116352408, 1899447441, 3049323471, 3921009573, 961987163,
            1508970993, 2453635748, 2870763221, 3624381080, 310598401,
            607225278, 1426881987, 1925078388, 2162078206, 2614888103,
            3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983,
            1249150122, 1555081692, 1996064986, 2554220882, 2821834349,
            2952996808, 3210313671, 3336571891, 3584528711, 113926993,
            338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700,
            1986661051, 2177026350, 2456956037, 2730485921, 2820302411,
            3259730800, 3345764771, 3516065817, 3600352804, 4094571909,
            275423344, 430227734, 506948616, 659060556, 883997877, 958139571,
            1322822218, 1537002063, 1747873779, 1955562222, 2024104815,
            2227730452, 2361852424, 2428436474, 2756734187, 3204031479,
            3329325298,
          ];
          return function hash(r, a, i) {
            var o,
              l,
              c,
              u = 1779033703,
              h = 3144134277,
              d = 1013904242,
              p = 2773480762,
              m = 1359893119,
              g = 2600822924,
              b = 528734635,
              y = 1541459225,
              v = 64 * Math.ceil((i + 9) / 64),
              S = new Uint8Array(v);
            for (o = 0; o < i; ++o) S[o] = r[a++];
            for (S[o++] = 128, c = v - 8; o < c; ) S[o++] = 0;
            (S[o++] = 0),
              (S[o++] = 0),
              (S[o++] = 0),
              (S[o++] = (i >>> 29) & 255),
              (S[o++] = (i >> 21) & 255),
              (S[o++] = (i >> 13) & 255),
              (S[o++] = (i >> 5) & 255),
              (S[o++] = (i << 3) & 255);
            var k,
              w = new Uint32Array(64);
            for (o = 0; o < v; ) {
              for (l = 0; l < 16; ++l)
                (w[l] =
                  (S[o] << 24) | (S[o + 1] << 16) | (S[o + 2] << 8) | S[o + 3]),
                  (o += 4);
              for (l = 16; l < 64; ++l)
                w[l] =
                  0 |
                  ((rotr((k = w[l - 2]), 17) ^ rotr(k, 19) ^ (k >>> 10)) +
                    w[l - 7] +
                    littleSigma(w[l - 15]) +
                    w[l - 16]);
              var C,
                x,
                _ = u,
                A = h,
                R = d,
                T = p,
                I = m,
                P = g,
                O = b,
                E = y;
              for (l = 0; l < 64; ++l)
                (C = E + sigmaPrime(I) + ch(I, P, O) + t[l] + w[l]),
                  (x = sigma(_) + maj(_, A, R)),
                  (E = O),
                  (O = P),
                  (P = I),
                  (I = (T + C) | 0),
                  (T = R),
                  (R = A),
                  (A = _),
                  (_ = (C + x) | 0);
              (u = (u + _) | 0),
                (h = (h + A) | 0),
                (d = (d + R) | 0),
                (p = (p + T) | 0),
                (m = (m + I) | 0),
                (g = (g + P) | 0),
                (b = (b + O) | 0),
                (y = (y + E) | 0);
            }
            return new Uint8Array([
              (u >> 24) & 255,
              (u >> 16) & 255,
              (u >> 8) & 255,
              255 & u,
              (h >> 24) & 255,
              (h >> 16) & 255,
              (h >> 8) & 255,
              255 & h,
              (d >> 24) & 255,
              (d >> 16) & 255,
              (d >> 8) & 255,
              255 & d,
              (p >> 24) & 255,
              (p >> 16) & 255,
              (p >> 8) & 255,
              255 & p,
              (m >> 24) & 255,
              (m >> 16) & 255,
              (m >> 8) & 255,
              255 & m,
              (g >> 24) & 255,
              (g >> 16) & 255,
              (g >> 8) & 255,
              255 & g,
              (b >> 24) & 255,
              (b >> 16) & 255,
              (b >> 8) & 255,
              255 & b,
              (y >> 24) & 255,
              (y >> 16) & 255,
              (y >> 8) & 255,
              255 & y,
            ]);
          };
        })();
      r.calculateSHA256 = d;
      var p = (function calculateSHA512Closure() {
        function ch(t, r, a, i, o) {
          t.assign(r), t.and(a), o.assign(r), o.not(), o.and(i), t.xor(o);
        }
        function maj(t, r, a, i, o) {
          t.assign(r),
            t.and(a),
            o.assign(r),
            o.and(i),
            t.xor(o),
            o.assign(a),
            o.and(i),
            t.xor(o);
        }
        function sigma(t, r, a) {
          t.assign(r),
            t.rotateRight(28),
            a.assign(r),
            a.rotateRight(34),
            t.xor(a),
            a.assign(r),
            a.rotateRight(39),
            t.xor(a);
        }
        function sigmaPrime(t, r, a) {
          t.assign(r),
            t.rotateRight(14),
            a.assign(r),
            a.rotateRight(18),
            t.xor(a),
            a.assign(r),
            a.rotateRight(41),
            t.xor(a);
        }
        function littleSigma(t, r, a) {
          t.assign(r),
            t.rotateRight(1),
            a.assign(r),
            a.rotateRight(8),
            t.xor(a),
            a.assign(r),
            a.shiftRight(7),
            t.xor(a);
        }
        function littleSigmaPrime(t, r, a) {
          t.assign(r),
            t.rotateRight(19),
            a.assign(r),
            a.rotateRight(61),
            t.xor(a),
            a.assign(r),
            a.shiftRight(6),
            t.xor(a);
        }
        var t = [
          new h(1116352408, 3609767458),
          new h(1899447441, 602891725),
          new h(3049323471, 3964484399),
          new h(3921009573, 2173295548),
          new h(961987163, 4081628472),
          new h(1508970993, 3053834265),
          new h(2453635748, 2937671579),
          new h(2870763221, 3664609560),
          new h(3624381080, 2734883394),
          new h(310598401, 1164996542),
          new h(607225278, 1323610764),
          new h(1426881987, 3590304994),
          new h(1925078388, 4068182383),
          new h(2162078206, 991336113),
          new h(2614888103, 633803317),
          new h(3248222580, 3479774868),
          new h(3835390401, 2666613458),
          new h(4022224774, 944711139),
          new h(264347078, 2341262773),
          new h(604807628, 2007800933),
          new h(770255983, 1495990901),
          new h(1249150122, 1856431235),
          new h(1555081692, 3175218132),
          new h(1996064986, 2198950837),
          new h(2554220882, 3999719339),
          new h(2821834349, 766784016),
          new h(2952996808, 2566594879),
          new h(3210313671, 3203337956),
          new h(3336571891, 1034457026),
          new h(3584528711, 2466948901),
          new h(113926993, 3758326383),
          new h(338241895, 168717936),
          new h(666307205, 1188179964),
          new h(773529912, 1546045734),
          new h(1294757372, 1522805485),
          new h(1396182291, 2643833823),
          new h(1695183700, 2343527390),
          new h(1986661051, 1014477480),
          new h(2177026350, 1206759142),
          new h(2456956037, 344077627),
          new h(2730485921, 1290863460),
          new h(2820302411, 3158454273),
          new h(3259730800, 3505952657),
          new h(3345764771, 106217008),
          new h(3516065817, 3606008344),
          new h(3600352804, 1432725776),
          new h(4094571909, 1467031594),
          new h(275423344, 851169720),
          new h(430227734, 3100823752),
          new h(506948616, 1363258195),
          new h(659060556, 3750685593),
          new h(883997877, 3785050280),
          new h(958139571, 3318307427),
          new h(1322822218, 3812723403),
          new h(1537002063, 2003034995),
          new h(1747873779, 3602036899),
          new h(1955562222, 1575990012),
          new h(2024104815, 1125592928),
          new h(2227730452, 2716904306),
          new h(2361852424, 442776044),
          new h(2428436474, 593698344),
          new h(2756734187, 3733110249),
          new h(3204031479, 2999351573),
          new h(3329325298, 3815920427),
          new h(3391569614, 3928383900),
          new h(3515267271, 566280711),
          new h(3940187606, 3454069534),
          new h(4118630271, 4000239992),
          new h(116418474, 1914138554),
          new h(174292421, 2731055270),
          new h(289380356, 3203993006),
          new h(460393269, 320620315),
          new h(685471733, 587496836),
          new h(852142971, 1086792851),
          new h(1017036298, 365543100),
          new h(1126000580, 2618297676),
          new h(1288033470, 3409855158),
          new h(1501505948, 4234509866),
          new h(1607167915, 987167468),
          new h(1816402316, 1246189591),
        ];
        return function hash(r, a, i, o) {
          var l, c, u, d, p, m, g, b;
          (o = !!o)
            ? ((l = new h(3418070365, 3238371032)),
              (c = new h(1654270250, 914150663)),
              (u = new h(2438529370, 812702999)),
              (d = new h(355462360, 4144912697)),
              (p = new h(1731405415, 4290775857)),
              (m = new h(2394180231, 1750603025)),
              (g = new h(3675008525, 1694076839)),
              (b = new h(1203062813, 3204075428)))
            : ((l = new h(1779033703, 4089235720)),
              (c = new h(3144134277, 2227873595)),
              (u = new h(1013904242, 4271175723)),
              (d = new h(2773480762, 1595750129)),
              (p = new h(1359893119, 2917565137)),
              (m = new h(2600822924, 725511199)),
              (g = new h(528734635, 4215389547)),
              (b = new h(1541459225, 327033209)));
          var y,
            v,
            S,
            k = 128 * Math.ceil((i + 17) / 128),
            w = new Uint8Array(k);
          for (y = 0; y < i; ++y) w[y] = r[a++];
          for (w[y++] = 128, S = k - 16; y < S; ) w[y++] = 0;
          (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = 0),
            (w[y++] = (i >>> 29) & 255),
            (w[y++] = (i >> 21) & 255),
            (w[y++] = (i >> 13) & 255),
            (w[y++] = (i >> 5) & 255),
            (w[y++] = (i << 3) & 255);
          var C = new Array(80);
          for (y = 0; y < 80; y++) C[y] = new h(0, 0);
          var x,
            _,
            A = new h(0, 0),
            R = new h(0, 0),
            T = new h(0, 0),
            I = new h(0, 0),
            P = new h(0, 0),
            O = new h(0, 0),
            E = new h(0, 0),
            B = new h(0, 0),
            D = new h(0, 0),
            M = new h(0, 0),
            L = new h(0, 0),
            N = new h(0, 0);
          for (y = 0; y < k; ) {
            for (v = 0; v < 16; ++v)
              (C[v].high =
                (w[y] << 24) | (w[y + 1] << 16) | (w[y + 2] << 8) | w[y + 3]),
                (C[v].low =
                  (w[y + 4] << 24) |
                  (w[y + 5] << 16) |
                  (w[y + 6] << 8) |
                  w[y + 7]),
                (y += 8);
            for (v = 16; v < 80; ++v)
              littleSigmaPrime((x = C[v]), C[v - 2], N),
                x.add(C[v - 7]),
                littleSigma(L, C[v - 15], N),
                x.add(L),
                x.add(C[v - 16]);
            for (
              A.assign(l),
                R.assign(c),
                T.assign(u),
                I.assign(d),
                P.assign(p),
                O.assign(m),
                E.assign(g),
                B.assign(b),
                v = 0;
              v < 80;
              ++v
            )
              D.assign(B),
                sigmaPrime(L, P, N),
                D.add(L),
                ch(L, P, O, E, N),
                D.add(L),
                D.add(t[v]),
                D.add(C[v]),
                sigma(M, A, N),
                maj(L, A, R, T, N),
                M.add(L),
                (x = B),
                (B = E),
                (E = O),
                (O = P),
                I.add(D),
                (P = I),
                (I = T),
                (T = R),
                (R = A),
                x.assign(D),
                x.add(M),
                (A = x);
            l.add(A),
              c.add(R),
              u.add(T),
              d.add(I),
              p.add(P),
              m.add(O),
              g.add(E),
              b.add(B);
          }
          return (
            o
              ? ((_ = new Uint8Array(48)),
                l.copyTo(_, 0),
                c.copyTo(_, 8),
                u.copyTo(_, 16),
                d.copyTo(_, 24),
                p.copyTo(_, 32),
                m.copyTo(_, 40))
              : ((_ = new Uint8Array(64)),
                l.copyTo(_, 0),
                c.copyTo(_, 8),
                u.copyTo(_, 16),
                d.copyTo(_, 24),
                p.copyTo(_, 32),
                m.copyTo(_, 40),
                g.copyTo(_, 48),
                b.copyTo(_, 56)),
            _
          );
        };
      })();
      r.calculateSHA512 = p;
      var m = (function calculateSHA384Closure() {
        return function hash(t, r, a) {
          return p(t, r, a, !0);
        };
      })();
      r.calculateSHA384 = m;
      var g = (function NullCipherClosure() {
          function NullCipher() {}
          return (
            (NullCipher.prototype = {
              decryptBlock: function NullCipher_decryptBlock(t) {
                return t;
              },
            }),
            NullCipher
          );
        })(),
        b = (function () {
          function AESBaseCipher() {
            _classCallCheck(this, AESBaseCipher),
              this.constructor === AESBaseCipher &&
                (0, i.unreachable)("Cannot initialize AESBaseCipher."),
              (this._s = new Uint8Array([
                99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215,
                171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162,
                175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204,
                52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150,
                5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27,
                110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0,
                237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208,
                239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159,
                168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16,
                255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126,
                61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70,
                238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92,
                194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141,
                213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37,
                46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138,
                112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193,
                29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135,
                233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65,
                153, 45, 15, 176, 84, 187, 22,
              ])),
              (this._inv_s = new Uint8Array([
                82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243,
                215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68,
                196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76,
                149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178,
                118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134,
                104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112,
                72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132,
                144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179,
                69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1,
                19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207,
                206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133,
                226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41,
                197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75,
                198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31,
                221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236,
                95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147,
                201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235,
                187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38,
                225, 105, 20, 99, 85, 33, 12, 125,
              ])),
              (this._mix = new Uint32Array([
                0, 235474187, 470948374, 303765277, 941896748, 908933415,
                607530554, 708780849, 1883793496, 2118214995, 1817866830,
                1649639237, 1215061108, 1181045119, 1417561698, 1517767529,
                3767586992, 4003061179, 4236429990, 4069246893, 3635733660,
                3602770327, 3299278474, 3400528769, 2430122216, 2664543715,
                2362090238, 2193862645, 2835123396, 2801107407, 3035535058,
                3135740889, 3678124923, 3576870512, 3341394285, 3374361702,
                3810496343, 3977675356, 4279080257, 4043610186, 2876494627,
                2776292904, 3076639029, 3110650942, 2472011535, 2640243204,
                2403728665, 2169303058, 1001089995, 899835584, 666464733,
                699432150, 59727847, 226906860, 530400753, 294930682,
                1273168787, 1172967064, 1475418501, 1509430414, 1942435775,
                2110667444, 1876241833, 1641816226, 2910219766, 2743034109,
                2976151520, 3211623147, 2505202138, 2606453969, 2302690252,
                2269728455, 3711829422, 3543599269, 3240894392, 3475313331,
                3843699074, 3943906441, 4178062228, 4144047775, 1306967366,
                1139781709, 1374988112, 1610459739, 1975683434, 2076935265,
                1775276924, 1742315127, 1034867998, 866637845, 566021896,
                800440835, 92987698, 193195065, 429456164, 395441711,
                1984812685, 2017778566, 1784663195, 1683407248, 1315562145,
                1080094634, 1383856311, 1551037884, 101039829, 135050206,
                437757123, 337553864, 1042385657, 807962610, 573804783,
                742039012, 2531067453, 2564033334, 2328828971, 2227573024,
                2935566865, 2700099354, 3001755655, 3168937228, 3868552805,
                3902563182, 4203181171, 4102977912, 3736164937, 3501741890,
                3265478751, 3433712980, 1106041591, 1340463100, 1576976609,
                1408749034, 2043211483, 2009195472, 1708848333, 1809054150,
                832877231, 1068351396, 766945465, 599762354, 159417987,
                126454664, 361929877, 463180190, 2709260871, 2943682380,
                3178106961, 3009879386, 2572697195, 2538681184, 2236228733,
                2336434550, 3509871135, 3745345300, 3441850377, 3274667266,
                3910161971, 3877198648, 4110568485, 4211818798, 2597806476,
                2497604743, 2261089178, 2295101073, 2733856160, 2902087851,
                3202437046, 2968011453, 3936291284, 3835036895, 4136440770,
                4169408201, 3535486456, 3702665459, 3467192302, 3231722213,
                2051518780, 1951317047, 1716890410, 1750902305, 1113818384,
                1282050075, 1584504582, 1350078989, 168810852, 67556463,
                371049330, 404016761, 841739592, 1008918595, 775550814,
                540080725, 3969562369, 3801332234, 4035489047, 4269907996,
                3569255213, 3669462566, 3366754619, 3332740144, 2631065433,
                2463879762, 2160117071, 2395588676, 2767645557, 2868897406,
                3102011747, 3069049960, 202008497, 33778362, 270040487,
                504459436, 875451293, 975658646, 675039627, 641025152,
                2084704233, 1917518562, 1615861247, 1851332852, 1147550661,
                1248802510, 1484005843, 1451044056, 933301370, 967311729,
                733156972, 632953703, 260388950, 25965917, 328671808, 496906059,
                1206477858, 1239443753, 1543208500, 1441952575, 2144161806,
                1908694277, 1675577880, 1842759443, 3610369226, 3644379585,
                3408119516, 3307916247, 4011190502, 3776767469, 4077384432,
                4245618683, 2809771154, 2842737049, 3144396420, 3043140495,
                2673705150, 2438237621, 2203032232, 2370213795,
              ])),
              (this._mixCol = new Uint8Array(256));
            for (var t = 0; t < 256; t++)
              this._mixCol[t] = t < 128 ? t << 1 : (t << 1) ^ 27;
            (this.buffer = new Uint8Array(16)), (this.bufferPosition = 0);
          }
          return (
            _createClass(AESBaseCipher, [
              {
                key: "_expandKey",
                value: function _expandKey(t) {
                  (0, i.unreachable)(
                    "Cannot call `_expandKey` on the base class",
                  );
                },
              },
              {
                key: "_decrypt",
                value: function _decrypt(t, r) {
                  var a,
                    i,
                    o,
                    l = new Uint8Array(16);
                  l.set(t);
                  for (var c = 0, u = this._keySize; c < 16; ++c, ++u)
                    l[c] ^= r[u];
                  for (var h = this._cyclesOfRepetition - 1; h >= 1; --h) {
                    (a = l[13]),
                      (l[13] = l[9]),
                      (l[9] = l[5]),
                      (l[5] = l[1]),
                      (l[1] = a),
                      (a = l[14]),
                      (i = l[10]),
                      (l[14] = l[6]),
                      (l[10] = l[2]),
                      (l[6] = a),
                      (l[2] = i),
                      (a = l[15]),
                      (i = l[11]),
                      (o = l[7]),
                      (l[15] = l[3]),
                      (l[11] = a),
                      (l[7] = i),
                      (l[3] = o);
                    for (var d = 0; d < 16; ++d) l[d] = this._inv_s[l[d]];
                    for (var p = 0, m = 16 * h; p < 16; ++p, ++m) l[p] ^= r[m];
                    for (var g = 0; g < 16; g += 4) {
                      var b = this._mix[l[g]],
                        y = this._mix[l[g + 1]],
                        v = this._mix[l[g + 2]],
                        S = this._mix[l[g + 3]];
                      (a =
                        b ^
                        (y >>> 8) ^
                        (y << 24) ^
                        (v >>> 16) ^
                        (v << 16) ^
                        (S >>> 24) ^
                        (S << 8)),
                        (l[g] = (a >>> 24) & 255),
                        (l[g + 1] = (a >> 16) & 255),
                        (l[g + 2] = (a >> 8) & 255),
                        (l[g + 3] = 255 & a);
                    }
                  }
                  (a = l[13]),
                    (l[13] = l[9]),
                    (l[9] = l[5]),
                    (l[5] = l[1]),
                    (l[1] = a),
                    (a = l[14]),
                    (i = l[10]),
                    (l[14] = l[6]),
                    (l[10] = l[2]),
                    (l[6] = a),
                    (l[2] = i),
                    (a = l[15]),
                    (i = l[11]),
                    (o = l[7]),
                    (l[15] = l[3]),
                    (l[11] = a),
                    (l[7] = i),
                    (l[3] = o);
                  for (var k = 0; k < 16; ++k)
                    (l[k] = this._inv_s[l[k]]), (l[k] ^= r[k]);
                  return l;
                },
              },
              {
                key: "_encrypt",
                value: function _encrypt(t, r) {
                  var a,
                    i,
                    o,
                    l = this._s,
                    c = new Uint8Array(16);
                  c.set(t);
                  for (var u = 0; u < 16; ++u) c[u] ^= r[u];
                  for (var h = 1; h < this._cyclesOfRepetition; h++) {
                    for (var d = 0; d < 16; ++d) c[d] = l[c[d]];
                    (o = c[1]),
                      (c[1] = c[5]),
                      (c[5] = c[9]),
                      (c[9] = c[13]),
                      (c[13] = o),
                      (o = c[2]),
                      (i = c[6]),
                      (c[2] = c[10]),
                      (c[6] = c[14]),
                      (c[10] = o),
                      (c[14] = i),
                      (o = c[3]),
                      (i = c[7]),
                      (a = c[11]),
                      (c[3] = c[15]),
                      (c[7] = o),
                      (c[11] = i),
                      (c[15] = a);
                    for (var p = 0; p < 16; p += 4) {
                      var m = c[p + 0],
                        g = c[p + 1],
                        b = c[p + 2],
                        y = c[p + 3];
                      (a = m ^ g ^ b ^ y),
                        (c[p + 0] ^= a ^ this._mixCol[m ^ g]),
                        (c[p + 1] ^= a ^ this._mixCol[g ^ b]),
                        (c[p + 2] ^= a ^ this._mixCol[b ^ y]),
                        (c[p + 3] ^= a ^ this._mixCol[y ^ m]);
                    }
                    for (var v = 0, S = 16 * h; v < 16; ++v, ++S) c[v] ^= r[S];
                  }
                  for (var k = 0; k < 16; ++k) c[k] = l[c[k]];
                  (o = c[1]),
                    (c[1] = c[5]),
                    (c[5] = c[9]),
                    (c[9] = c[13]),
                    (c[13] = o),
                    (o = c[2]),
                    (i = c[6]),
                    (c[2] = c[10]),
                    (c[6] = c[14]),
                    (c[10] = o),
                    (c[14] = i),
                    (o = c[3]),
                    (i = c[7]),
                    (a = c[11]),
                    (c[3] = c[15]),
                    (c[7] = o),
                    (c[11] = i),
                    (c[15] = a);
                  for (var w = 0, C = this._keySize; w < 16; ++w, ++C)
                    c[w] ^= r[C];
                  return c;
                },
              },
              {
                key: "_decryptBlock2",
                value: function _decryptBlock2(t, r) {
                  for (
                    var a = t.length,
                      i = this.buffer,
                      o = this.bufferPosition,
                      l = [],
                      c = this.iv,
                      u = 0;
                    u < a;
                    ++u
                  )
                    if (((i[o] = t[u]), !(++o < 16))) {
                      for (
                        var h = this._decrypt(i, this._key), d = 0;
                        d < 16;
                        ++d
                      )
                        h[d] ^= c[d];
                      (c = i), l.push(h), (i = new Uint8Array(16)), (o = 0);
                    }
                  if (
                    ((this.buffer = i),
                    (this.bufferLength = o),
                    (this.iv = c),
                    0 === l.length)
                  )
                    return new Uint8Array(0);
                  var p = 16 * l.length;
                  if (r) {
                    var m = l[l.length - 1],
                      g = m[15];
                    if (g <= 16) {
                      for (var b = 15, y = 16 - g; b >= y; --b)
                        if (m[b] !== g) {
                          g = 0;
                          break;
                        }
                      (p -= g), (l[l.length - 1] = m.subarray(0, 16 - g));
                    }
                  }
                  for (
                    var v = new Uint8Array(p), S = 0, k = 0, w = l.length;
                    S < w;
                    ++S, k += 16
                  )
                    v.set(l[S], k);
                  return v;
                },
              },
              {
                key: "decryptBlock",
                value: function decryptBlock(t, r) {
                  var a =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : null,
                    i = t.length,
                    o = this.buffer,
                    l = this.bufferPosition;
                  if (a) this.iv = a;
                  else {
                    for (var c = 0; l < 16 && c < i; ++c, ++l) o[l] = t[c];
                    if (l < 16)
                      return (this.bufferLength = l), new Uint8Array(0);
                    (this.iv = o), (t = t.subarray(16));
                  }
                  return (
                    (this.buffer = new Uint8Array(16)),
                    (this.bufferLength = 0),
                    (this.decryptBlock = this._decryptBlock2),
                    this.decryptBlock(t, r)
                  );
                },
              },
              {
                key: "encrypt",
                value: function encrypt(t, r) {
                  var a = t.length,
                    i = this.buffer,
                    o = this.bufferPosition,
                    l = [];
                  r || (r = new Uint8Array(16));
                  for (var c = 0; c < a; ++c)
                    if (((i[o] = t[c]), !(++o < 16))) {
                      for (var u = 0; u < 16; ++u) i[u] ^= r[u];
                      var h = this._encrypt(i, this._key);
                      (r = h), l.push(h), (i = new Uint8Array(16)), (o = 0);
                    }
                  if (
                    ((this.buffer = i),
                    (this.bufferLength = o),
                    (this.iv = r),
                    0 === l.length)
                  )
                    return new Uint8Array(0);
                  for (
                    var d = 16 * l.length,
                      p = new Uint8Array(d),
                      m = 0,
                      g = 0,
                      b = l.length;
                    m < b;
                    ++m, g += 16
                  )
                    p.set(l[m], g);
                  return p;
                },
              },
            ]),
            AESBaseCipher
          );
        })(),
        y = (function (t) {
          _inherits(AES128Cipher, t);
          var r = _createSuper(AES128Cipher);
          function AES128Cipher(t) {
            var a;
            return (
              _classCallCheck(this, AES128Cipher),
              ((a = r.call(this))._cyclesOfRepetition = 10),
              (a._keySize = 160),
              (a._rcon = new Uint8Array([
                141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77,
                154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250,
                239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74,
                148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8,
                16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188,
                99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57,
                114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204,
                131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128,
                27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53,
                106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189,
                97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232,
                203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171,
                77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250,
                239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74,
                148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8,
                16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188,
                99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57,
                114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204,
                131, 29, 58, 116, 232, 203, 141,
              ])),
              (a._key = a._expandKey(t)),
              a
            );
          }
          return (
            _createClass(AES128Cipher, [
              {
                key: "_expandKey",
                value: function _expandKey(t) {
                  var r = this._s,
                    a = this._rcon,
                    i = new Uint8Array(176);
                  i.set(t);
                  for (var o = 16, l = 1; o < 176; ++l) {
                    var c = i[o - 3],
                      u = i[o - 2],
                      h = i[o - 1],
                      d = i[o - 4];
                    (c = r[c]), (u = r[u]), (h = r[h]), (d = r[d]), (c ^= a[l]);
                    for (var p = 0; p < 4; ++p)
                      (i[o] = c ^= i[o - 16]),
                        (i[++o] = u ^= i[o - 16]),
                        (i[++o] = h ^= i[o - 16]),
                        (i[++o] = d ^= i[o - 16]),
                        o++;
                  }
                  return i;
                },
              },
            ]),
            AES128Cipher
          );
        })(b);
      r.AES128Cipher = y;
      var v = (function (t) {
        _inherits(AES256Cipher, t);
        var r = _createSuper(AES256Cipher);
        function AES256Cipher(t) {
          var a;
          return (
            _classCallCheck(this, AES256Cipher),
            ((a = r.call(this))._cyclesOfRepetition = 14),
            (a._keySize = 224),
            (a._key = a._expandKey(t)),
            a
          );
        }
        return (
          _createClass(AES256Cipher, [
            {
              key: "_expandKey",
              value: function _expandKey(t) {
                var r = this._s,
                  a = new Uint8Array(240);
                a.set(t);
                for (var i, o, l, c, u = 1, h = 32, d = 1; h < 240; ++d) {
                  h % 32 == 16
                    ? ((i = r[i]), (o = r[o]), (l = r[l]), (c = r[c]))
                    : h % 32 == 0 &&
                      ((i = a[h - 3]),
                      (o = a[h - 2]),
                      (l = a[h - 1]),
                      (c = a[h - 4]),
                      (i = r[i]),
                      (o = r[o]),
                      (l = r[l]),
                      (c = r[c]),
                      (i ^= u),
                      (u <<= 1) >= 256 && (u = 255 & (27 ^ u)));
                  for (var p = 0; p < 4; ++p)
                    (a[h] = i ^= a[h - 32]),
                      (a[++h] = o ^= a[h - 32]),
                      (a[++h] = l ^= a[h - 32]),
                      (a[++h] = c ^= a[h - 32]),
                      h++;
                }
                return a;
              },
            },
          ]),
          AES256Cipher
        );
      })(b);
      r.AES256Cipher = v;
      var S = (function PDF17Closure() {
        function compareByteArrays(t, r) {
          if (t.length !== r.length) return !1;
          for (var a = 0; a < t.length; a++) if (t[a] !== r[a]) return !1;
          return !0;
        }
        function PDF17() {}
        return (
          (PDF17.prototype = {
            checkOwnerPassword: function PDF17_checkOwnerPassword(t, r, a, i) {
              var o = new Uint8Array(t.length + 56);
              return (
                o.set(t, 0),
                o.set(r, t.length),
                o.set(a, t.length + r.length),
                compareByteArrays(d(o, 0, o.length), i)
              );
            },
            checkUserPassword: function PDF17_checkUserPassword(t, r, a) {
              var i = new Uint8Array(t.length + 8);
              return (
                i.set(t, 0),
                i.set(r, t.length),
                compareByteArrays(d(i, 0, i.length), a)
              );
            },
            getOwnerKey: function PDF17_getOwnerKey(t, r, a, i) {
              var o = new Uint8Array(t.length + 56);
              o.set(t, 0), o.set(r, t.length), o.set(a, t.length + r.length);
              var l = d(o, 0, o.length);
              return new v(l).decryptBlock(i, !1, new Uint8Array(16));
            },
            getUserKey: function PDF17_getUserKey(t, r, a) {
              var i = new Uint8Array(t.length + 8);
              i.set(t, 0), i.set(r, t.length);
              var o = d(i, 0, i.length);
              return new v(o).decryptBlock(a, !1, new Uint8Array(16));
            },
          }),
          PDF17
        );
      })();
      r.PDF17 = S;
      var k = (function PDF20Closure() {
        function concatArrays(t, r) {
          var a = new Uint8Array(t.length + r.length);
          return a.set(t, 0), a.set(r, t.length), a;
        }
        function calculatePDF20Hash(t, r, a) {
          for (
            var i = d(r, 0, r.length).subarray(0, 32), o = [0], l = 0;
            l < 64 || o[o.length - 1] > l - 32;

          ) {
            var c = t.length + i.length + a.length,
              u = new Uint8Array(64 * c),
              h = concatArrays(t, i);
            h = concatArrays(h, a);
            for (var g = 0, b = 0; g < 64; g++, b += c) u.set(h, b);
            o = new y(i.subarray(0, 16)).encrypt(u, i.subarray(16, 32));
            for (var v = 0, S = 0; S < 16; S++)
              (v *= 1), (v %= 3), (v += (o[S] >>> 0) % 3), (v %= 3);
            0 === v
              ? (i = d(o, 0, o.length))
              : 1 === v
              ? (i = m(o, 0, o.length))
              : 2 === v && (i = p(o, 0, o.length)),
              l++;
          }
          return i.subarray(0, 32);
        }
        function PDF20() {}
        function compareByteArrays(t, r) {
          if (t.length !== r.length) return !1;
          for (var a = 0; a < t.length; a++) if (t[a] !== r[a]) return !1;
          return !0;
        }
        return (
          (PDF20.prototype = {
            hash: function PDF20_hash(t, r, a) {
              return calculatePDF20Hash(t, r, a);
            },
            checkOwnerPassword: function PDF20_checkOwnerPassword(t, r, a, i) {
              var o = new Uint8Array(t.length + 56);
              return (
                o.set(t, 0),
                o.set(r, t.length),
                o.set(a, t.length + r.length),
                compareByteArrays(calculatePDF20Hash(t, o, a), i)
              );
            },
            checkUserPassword: function PDF20_checkUserPassword(t, r, a) {
              var i = new Uint8Array(t.length + 8);
              return (
                i.set(t, 0),
                i.set(r, t.length),
                compareByteArrays(calculatePDF20Hash(t, i, []), a)
              );
            },
            getOwnerKey: function PDF20_getOwnerKey(t, r, a, i) {
              var o = new Uint8Array(t.length + 56);
              o.set(t, 0), o.set(r, t.length), o.set(a, t.length + r.length);
              var l = calculatePDF20Hash(t, o, a);
              return new v(l).decryptBlock(i, !1, new Uint8Array(16));
            },
            getUserKey: function PDF20_getUserKey(t, r, a) {
              var i = new Uint8Array(t.length + 8);
              i.set(t, 0), i.set(r, t.length);
              var o = calculatePDF20Hash(t, i, []);
              return new v(o).decryptBlock(a, !1, new Uint8Array(16));
            },
          }),
          PDF20
        );
      })();
      r.PDF20 = k;
      var w = (function CipherTransformClosure() {
          function CipherTransform(t, r) {
            (this.StringCipherConstructor = t),
              (this.StreamCipherConstructor = r);
          }
          return (
            (CipherTransform.prototype = {
              createStream: function CipherTransform_createStream(t, r) {
                var a = new this.StreamCipherConstructor();
                return new l.DecryptStream(
                  t,
                  r,
                  function cipherTransformDecryptStream(t, r) {
                    return a.decryptBlock(t, r);
                  },
                );
              },
              decryptString: function CipherTransform_decryptString(t) {
                var r = new this.StringCipherConstructor(),
                  a = (0, i.stringToBytes)(t);
                return (a = r.decryptBlock(a, !0)), (0, i.bytesToString)(a);
              },
            }),
            CipherTransform
          );
        })(),
        C = (function CipherTransformFactoryClosure() {
          var t = new Uint8Array([
            40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8,
            46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105,
            122,
          ]);
          function prepareKeyData(r, a, i, o, l, h, d, p) {
            var m,
              g,
              b = 40 + i.length + r.length,
              y = new Uint8Array(b),
              v = 0;
            if (a) for (g = Math.min(32, a.length); v < g; ++v) y[v] = a[v];
            for (m = 0; v < 32; ) y[v++] = t[m++];
            for (m = 0, g = i.length; m < g; ++m) y[v++] = i[m];
            for (
              y[v++] = 255 & l,
                y[v++] = (l >> 8) & 255,
                y[v++] = (l >> 16) & 255,
                y[v++] = (l >>> 24) & 255,
                m = 0,
                g = r.length;
              m < g;
              ++m
            )
              y[v++] = r[m];
            h >= 4 &&
              !p &&
              ((y[v++] = 255), (y[v++] = 255), (y[v++] = 255), (y[v++] = 255));
            var S = u(y, 0, v),
              k = d >> 3;
            if (h >= 3) for (m = 0; m < 50; ++m) S = u(S, 0, k);
            var w,
              C = S.subarray(0, k);
            if (h >= 3) {
              for (v = 0; v < 32; ++v) y[v] = t[v];
              for (m = 0, g = r.length; m < g; ++m) y[v++] = r[m];
              (w = new c(C).encryptBlock(u(y, 0, v))), (g = C.length);
              var x,
                _ = new Uint8Array(g);
              for (m = 1; m <= 19; ++m) {
                for (x = 0; x < g; ++x) _[x] = C[x] ^ m;
                w = new c(_).encryptBlock(w);
              }
              for (m = 0, g = w.length; m < g; ++m)
                if (o[m] !== w[m]) return null;
            } else
              for (m = 0, g = (w = new c(C).encryptBlock(t)).length; m < g; ++m)
                if (o[m] !== w[m]) return null;
            return C;
          }
          var r = o.Name.get("Identity");
          function CipherTransformFactory(a, l, h) {
            var d = a.get("Filter");
            if (!(0, o.isName)(d, "Standard"))
              throw new i.FormatError("unknown encryption method");
            this.dict = a;
            var p = a.get("V");
            if (
              !Number.isInteger(p) ||
              (1 !== p && 2 !== p && 4 !== p && 5 !== p)
            )
              throw new i.FormatError("unsupported encryption algorithm");
            this.algorithm = p;
            var m = a.get("Length");
            if (!m)
              if (p <= 3) m = 40;
              else {
                var g = a.get("CF"),
                  b = a.get("StmF");
                if ((0, o.isDict)(g) && (0, o.isName)(b)) {
                  g.suppressEncryption = !0;
                  var y = g.get(b.name);
                  (m = (y && y.get("Length")) || 128) < 40 && (m <<= 3);
                }
              }
            if (!Number.isInteger(m) || m < 40 || m % 8 != 0)
              throw new i.FormatError("invalid key length");
            var v = (0, i.stringToBytes)(a.get("O")).subarray(0, 32),
              w = (0, i.stringToBytes)(a.get("U")).subarray(0, 32),
              C = a.get("P"),
              x = a.get("R"),
              _ = (4 === p || 5 === p) && !1 !== a.get("EncryptMetadata");
            this.encryptMetadata = _;
            var A,
              R,
              T = (0, i.stringToBytes)(l);
            if (h) {
              if (6 === x)
                try {
                  h = (0, i.utf8StringToString)(h);
                } catch (t) {
                  (0, i.warn)(
                    "CipherTransformFactory: Unable to convert UTF8 encoded password.",
                  );
                }
              A = (0, i.stringToBytes)(h);
            }
            if (5 !== p) R = prepareKeyData(T, A, v, w, C, x, m, _);
            else {
              var I = (0, i.stringToBytes)(a.get("O")).subarray(32, 40),
                P = (0, i.stringToBytes)(a.get("O")).subarray(40, 48),
                O = (0, i.stringToBytes)(a.get("U")).subarray(0, 48),
                E = (0, i.stringToBytes)(a.get("U")).subarray(32, 40),
                B = (0, i.stringToBytes)(a.get("U")).subarray(40, 48),
                D = (0, i.stringToBytes)(a.get("OE")),
                M = (0, i.stringToBytes)(a.get("UE"));
              (0, i.stringToBytes)(a.get("Perms"));
              R = (function createEncryptionKey20(
                t,
                r,
                a,
                i,
                o,
                l,
                c,
                u,
                h,
                d,
                p,
                m,
              ) {
                if (r) {
                  var g = Math.min(127, r.length);
                  r = r.subarray(0, g);
                } else r = [];
                var b;
                return (b = 6 === t ? new k() : new S()).checkUserPassword(
                  r,
                  u,
                  c,
                )
                  ? b.getUserKey(r, h, p)
                  : r.length && b.checkOwnerPassword(r, i, l, a)
                  ? b.getOwnerKey(r, o, l, d)
                  : null;
              })(x, A, v, I, P, O, w, E, B, D, M);
            }
            if (!R && !h)
              throw new i.PasswordException(
                "No password given",
                i.PasswordResponses.NEED_PASSWORD,
              );
            if (
              (!R &&
                h &&
                (R = prepareKeyData(
                  T,
                  (function decodeUserPassword(r, a, i, o) {
                    var l,
                      h,
                      d = new Uint8Array(32),
                      p = 0;
                    for (h = Math.min(32, r.length); p < h; ++p) d[p] = r[p];
                    for (l = 0; p < 32; ) d[p++] = t[l++];
                    var m,
                      g = u(d, 0, p),
                      b = o >> 3;
                    if (i >= 3) for (l = 0; l < 50; ++l) g = u(g, 0, g.length);
                    if (i >= 3) {
                      m = a;
                      var y,
                        v = new Uint8Array(b);
                      for (l = 19; l >= 0; l--) {
                        for (y = 0; y < b; ++y) v[y] = g[y] ^ l;
                        m = new c(v).encryptBlock(m);
                      }
                    } else m = new c(g.subarray(0, b)).encryptBlock(a);
                    return m;
                  })(A, v, x, m),
                  v,
                  w,
                  C,
                  x,
                  m,
                  _,
                )),
              !R)
            )
              throw new i.PasswordException(
                "Incorrect Password",
                i.PasswordResponses.INCORRECT_PASSWORD,
              );
            if (((this.encryptionKey = R), p >= 4)) {
              var L = a.get("CF");
              (0, o.isDict)(L) && (L.suppressEncryption = !0),
                (this.cf = L),
                (this.stmf = a.get("StmF") || r),
                (this.strf = a.get("StrF") || r),
                (this.eff = a.get("EFF") || this.stmf);
            }
          }
          function buildObjectKey(t, r, a, i) {
            var o,
              l,
              c = new Uint8Array(a.length + 9);
            for (o = 0, l = a.length; o < l; ++o) c[o] = a[o];
            return (
              (c[o++] = 255 & t),
              (c[o++] = (t >> 8) & 255),
              (c[o++] = (t >> 16) & 255),
              (c[o++] = 255 & r),
              (c[o++] = (r >> 8) & 255),
              i &&
                ((c[o++] = 115), (c[o++] = 65), (c[o++] = 108), (c[o++] = 84)),
              u(c, 0, o).subarray(0, Math.min(a.length + 5, 16))
            );
          }
          function buildCipherConstructor(t, r, a, l, u) {
            if (!(0, o.isName)(r))
              throw new i.FormatError("Invalid crypt filter name.");
            var h,
              d = t.get(r.name);
            if ((null != d && (h = d.get("CFM")), !h || "None" === h.name))
              return function cipherTransformFactoryBuildCipherConstructorNone() {
                return new g();
              };
            if ("V2" === h.name)
              return function cipherTransformFactoryBuildCipherConstructorV2() {
                return new c(buildObjectKey(a, l, u, !1));
              };
            if ("AESV2" === h.name)
              return function cipherTransformFactoryBuildCipherConstructorAESV2() {
                return new y(buildObjectKey(a, l, u, !0));
              };
            if ("AESV3" === h.name)
              return function cipherTransformFactoryBuildCipherConstructorAESV3() {
                return new v(u);
              };
            throw new i.FormatError("Unknown crypto method");
          }
          return (
            (CipherTransformFactory.prototype = {
              createCipherTransform:
                function CipherTransformFactory_createCipherTransform(t, r) {
                  if (4 === this.algorithm || 5 === this.algorithm)
                    return new w(
                      buildCipherConstructor(
                        this.cf,
                        this.stmf,
                        t,
                        r,
                        this.encryptionKey,
                      ),
                      buildCipherConstructor(
                        this.cf,
                        this.strf,
                        t,
                        r,
                        this.encryptionKey,
                      ),
                    );
                  var a = buildObjectKey(t, r, this.encryptionKey, !1),
                    i = function buildCipherCipherConstructor() {
                      return new c(a);
                    };
                  return new w(i, i);
                },
            }),
            CipherTransformFactory
          );
        })();
      r.CipherTransformFactory = C;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.ColorSpace = void 0);
      var i = a(5),
        o = a(198);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _inherits(t, r) {
        if ("function" != typeof r && null !== r)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (t.prototype = Object.create(r && r.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          r && _setPrototypeOf(t, r);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var l = (function () {
        function ColorSpace(t, r) {
          _classCallCheck(this, ColorSpace),
            this.constructor === ColorSpace &&
              (0, i.unreachable)("Cannot initialize ColorSpace."),
            (this.name = t),
            (this.numComps = r);
        }
        return (
          _createClass(
            ColorSpace,
            [
              {
                key: "getRgb",
                value: function getRgb(t, r) {
                  var a = new Uint8ClampedArray(3);
                  return this.getRgbItem(t, r, a, 0), a;
                },
              },
              {
                key: "getRgbItem",
                value: function getRgbItem(t, r, a, o) {
                  (0, i.unreachable)("Should not call ColorSpace.getRgbItem");
                },
              },
              {
                key: "getRgbBuffer",
                value: function getRgbBuffer(t, r, a, o, l, c, u) {
                  (0, i.unreachable)("Should not call ColorSpace.getRgbBuffer");
                },
              },
              {
                key: "getOutputLength",
                value: function getOutputLength(t, r) {
                  (0, i.unreachable)(
                    "Should not call ColorSpace.getOutputLength",
                  );
                },
              },
              {
                key: "isPassthrough",
                value: function isPassthrough(t) {
                  return !1;
                },
              },
              {
                key: "isDefaultDecode",
                value: function isDefaultDecode(t, r) {
                  return ColorSpace.isDefaultDecode(t, this.numComps);
                },
              },
              {
                key: "fillRgb",
                value: function fillRgb(t, r, a, i, o, l, c, u, h) {
                  var d = r * a,
                    p = null,
                    m = 1 << c,
                    g = a !== o || r !== i;
                  if (this.isPassthrough(c)) p = u;
                  else if (
                    1 === this.numComps &&
                    d > m &&
                    "DeviceGray" !== this.name &&
                    "DeviceRGB" !== this.name
                  ) {
                    for (
                      var b = c <= 8 ? new Uint8Array(m) : new Uint16Array(m),
                        y = 0;
                      y < m;
                      y++
                    )
                      b[y] = y;
                    var v = new Uint8ClampedArray(3 * m);
                    if ((this.getRgbBuffer(b, 0, m, v, 0, c, 0), g)) {
                      p = new Uint8Array(3 * d);
                      for (var S = 0, k = 0; k < d; ++k) {
                        var w = 3 * u[k];
                        (p[S++] = v[w]),
                          (p[S++] = v[w + 1]),
                          (p[S++] = v[w + 2]);
                      }
                    } else
                      for (var C = 0, x = 0; x < d; ++x) {
                        var _ = 3 * u[x];
                        (t[C++] = v[_]),
                          (t[C++] = v[_ + 1]),
                          (t[C++] = v[_ + 2]),
                          (C += h);
                      }
                  } else
                    g
                      ? ((p = new Uint8ClampedArray(3 * d)),
                        this.getRgbBuffer(u, 0, d, p, 0, c, 0))
                      : this.getRgbBuffer(u, 0, i * l, t, 0, c, h);
                  if (p)
                    if (g)
                      !(function resizeRgbImage(t, r, a, i, o, l, c) {
                        c = 1 !== c ? 0 : c;
                        for (
                          var u,
                            h = a / o,
                            d = i / l,
                            p = 0,
                            m = new Uint16Array(o),
                            g = 3 * a,
                            b = 0;
                          b < o;
                          b++
                        )
                          m[b] = 3 * Math.floor(b * h);
                        for (var y = 0; y < l; y++)
                          for (var v = Math.floor(y * d) * g, S = 0; S < o; S++)
                            (u = v + m[S]),
                              (r[p++] = t[u++]),
                              (r[p++] = t[u++]),
                              (r[p++] = t[u++]),
                              (p += c);
                      })(p, t, r, a, i, o, h);
                    else
                      for (var A = 0, R = 0, T = 0, I = i * l; T < I; T++)
                        (t[A++] = p[R++]),
                          (t[A++] = p[R++]),
                          (t[A++] = p[R++]),
                          (A += h);
                },
              },
              {
                key: "usesZeroToOneRange",
                get: function get() {
                  return (0, i.shadow)(this, "usesZeroToOneRange", !0);
                },
              },
            ],
            [
              {
                key: "parse",
                value: function parse(t, r, a, i) {
                  var o = this.parseToIR(t, r, a, i);
                  return this.fromIR(o);
                },
              },
              {
                key: "fromIR",
                value: function fromIR(t) {
                  var r,
                    a,
                    o,
                    l = Array.isArray(t) ? t[0] : t;
                  switch (l) {
                    case "DeviceGrayCS":
                      return this.singletons.gray;
                    case "DeviceRgbCS":
                      return this.singletons.rgb;
                    case "DeviceCmykCS":
                      return this.singletons.cmyk;
                    case "CalGrayCS":
                      return (r = t[1]), (a = t[2]), (o = t[3]), new g(r, a, o);
                    case "CalRGBCS":
                      (r = t[1]), (a = t[2]), (o = t[3]);
                      var d = t[4];
                      return new b(r, a, o, d);
                    case "PatternCS":
                      var p = t[1];
                      return p && (p = this.fromIR(p)), new u(p);
                    case "IndexedCS":
                      var m = t[1],
                        v = t[2],
                        S = t[3];
                      return new h(this.fromIR(m), v, S);
                    case "AlternateCS":
                      var k = t[1],
                        w = t[2],
                        C = t[3];
                      return new c(k, this.fromIR(w), C);
                    case "LabCS":
                      (r = t[1]), (a = t[2]);
                      var x = t[3];
                      return new y(r, a, x);
                    default:
                      throw new i.FormatError(
                        "Unknown colorspace name: ".concat(l),
                      );
                  }
                },
              },
              {
                key: "parseToIR",
                value: function parseToIR(t, r) {
                  var a =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : null,
                    l = arguments.length > 3 ? arguments[3] : void 0;
                  if (((t = r.fetchIfRef(t)), (0, o.isName)(t)))
                    switch (t.name) {
                      case "DeviceGray":
                      case "G":
                        return "DeviceGrayCS";
                      case "DeviceRGB":
                      case "RGB":
                        return "DeviceRgbCS";
                      case "DeviceCMYK":
                      case "CMYK":
                        return "DeviceCmykCS";
                      case "Pattern":
                        return ["PatternCS", null];
                      default:
                        if ((0, o.isDict)(a)) {
                          var c = a.get("ColorSpace");
                          if ((0, o.isDict)(c)) {
                            var u = c.get(t.name);
                            if (u) {
                              if ((0, o.isName)(u))
                                return this.parseToIR(u, r, a, l);
                              t = u;
                              break;
                            }
                          }
                        }
                        throw new i.FormatError(
                          "unrecognized colorspace ".concat(t.name),
                        );
                    }
                  if (Array.isArray(t)) {
                    var h,
                      d,
                      p,
                      m,
                      g,
                      b,
                      y = r.fetchIfRef(t[0]).name;
                    switch (y) {
                      case "DeviceGray":
                      case "G":
                        return "DeviceGrayCS";
                      case "DeviceRGB":
                      case "RGB":
                        return "DeviceRgbCS";
                      case "DeviceCMYK":
                      case "CMYK":
                        return "DeviceCmykCS";
                      case "CalGray":
                        return [
                          "CalGrayCS",
                          (m = (d = r.fetchIfRef(t[1])).getArray("WhitePoint")),
                          (g = d.getArray("BlackPoint")),
                          (b = d.get("Gamma")),
                        ];
                      case "CalRGB":
                        (m = (d = r.fetchIfRef(t[1])).getArray("WhitePoint")),
                          (g = d.getArray("BlackPoint")),
                          (b = d.getArray("Gamma"));
                        var v = d.getArray("Matrix");
                        return ["CalRGBCS", m, g, b, v];
                      case "ICCBased":
                        var S = r.fetchIfRef(t[1]),
                          k = S.dict;
                        if (((h = k.get("N")), (p = k.get("Alternate")))) {
                          var w = this.parseToIR(p, r, a, l),
                            C = this.fromIR(w, l);
                          if (C.numComps === h) return w;
                          (0, i.warn)(
                            "ICCBased color space: Ignoring incorrect /Alternate entry.",
                          );
                        }
                        if (1 === h) return "DeviceGrayCS";
                        if (3 === h) return "DeviceRgbCS";
                        if (4 === h) return "DeviceCmykCS";
                        break;
                      case "Pattern":
                        var x = t[1] || null;
                        return (
                          x && (x = this.parseToIR(x, r, a, l)),
                          ["PatternCS", x]
                        );
                      case "Indexed":
                      case "I":
                        var _ = this.parseToIR(t[1], r, a, l),
                          A = r.fetchIfRef(t[2]) + 1,
                          R = r.fetchIfRef(t[3]);
                        return (
                          (0, o.isStream)(R) && (R = R.getBytes()),
                          ["IndexedCS", _, A, R]
                        );
                      case "Separation":
                      case "DeviceN":
                        var T = r.fetchIfRef(t[1]);
                        (h = Array.isArray(T) ? T.length : 1),
                          (p = this.parseToIR(t[2], r, a, l));
                        var I = l.create(r.fetchIfRef(t[3]));
                        return ["AlternateCS", h, p, I];
                      case "Lab":
                        (m = (d = r.fetchIfRef(t[1])).getArray("WhitePoint")),
                          (g = d.getArray("BlackPoint"));
                        var P = d.getArray("Range");
                        return ["LabCS", m, g, P];
                      default:
                        throw new i.FormatError(
                          'unimplemented color space object "'.concat(y, '"'),
                        );
                    }
                  }
                  throw new i.FormatError(
                    'unrecognized color space object: "'.concat(t, '"'),
                  );
                },
              },
              {
                key: "isDefaultDecode",
                value: function isDefaultDecode(t, r) {
                  if (!Array.isArray(t)) return !0;
                  if (2 * r !== t.length)
                    return (
                      (0, i.warn)("The decode map is not the correct length"),
                      !0
                    );
                  for (var a = 0, o = t.length; a < o; a += 2)
                    if (0 !== t[a] || 1 !== t[a + 1]) return !1;
                  return !0;
                },
              },
              {
                key: "singletons",
                get: function get() {
                  return (0, i.shadow)(this, "singletons", {
                    get gray() {
                      return (0, i.shadow)(this, "gray", new d());
                    },
                    get rgb() {
                      return (0, i.shadow)(this, "rgb", new p());
                    },
                    get cmyk() {
                      return (0, i.shadow)(this, "cmyk", new m());
                    },
                  });
                },
              },
            ],
          ),
          ColorSpace
        );
      })();
      r.ColorSpace = l;
      var c = (function (t) {
          _inherits(AlternateCS, t);
          var r = _createSuper(AlternateCS);
          function AlternateCS(t, a, i) {
            var o;
            return (
              _classCallCheck(this, AlternateCS),
              ((o = r.call(this, "Alternate", t)).base = a),
              (o.tintFn = i),
              (o.tmpBuf = new Float32Array(a.numComps)),
              o
            );
          }
          return (
            _createClass(AlternateCS, [
              {
                key: "getRgbItem",
                value: function getRgbItem(t, r, a, i) {
                  var o = this.tmpBuf;
                  this.tintFn(t, r, o, 0), this.base.getRgbItem(o, 0, a, i);
                },
              },
              {
                key: "getRgbBuffer",
                value: function getRgbBuffer(t, r, a, i, o, l, c) {
                  var u,
                    h,
                    d = this.tintFn,
                    p = this.base,
                    m = 1 / ((1 << l) - 1),
                    g = p.numComps,
                    b = p.usesZeroToOneRange,
                    y = (p.isPassthrough(8) || !b) && 0 === c,
                    v = y ? o : 0,
                    S = y ? i : new Uint8ClampedArray(g * a),
                    k = this.numComps,
                    w = new Float32Array(k),
                    C = new Float32Array(g);
                  for (u = 0; u < a; u++) {
                    for (h = 0; h < k; h++) w[h] = t[r++] * m;
                    if ((d(w, 0, C, 0), b))
                      for (h = 0; h < g; h++) S[v++] = 255 * C[h];
                    else p.getRgbItem(C, 0, S, v), (v += g);
                  }
                  y || p.getRgbBuffer(S, 0, a, i, o, 8, c);
                },
              },
              {
                key: "getOutputLength",
                value: function getOutputLength(t, r) {
                  return this.base.getOutputLength(
                    (t * this.base.numComps) / this.numComps,
                    r,
                  );
                },
              },
            ]),
            AlternateCS
          );
        })(l),
        u = (function (t) {
          _inherits(PatternCS, t);
          var r = _createSuper(PatternCS);
          function PatternCS(t) {
            var a;
            return (
              _classCallCheck(this, PatternCS),
              ((a = r.call(this, "Pattern", null)).base = t),
              a
            );
          }
          return (
            _createClass(PatternCS, [
              {
                key: "isDefaultDecode",
                value: function isDefaultDecode(t, r) {
                  (0, i.unreachable)(
                    "Should not call PatternCS.isDefaultDecode",
                  );
                },
              },
            ]),
            PatternCS
          );
        })(l),
        h = (function (t) {
          _inherits(IndexedCS, t);
          var r = _createSuper(IndexedCS);
          function IndexedCS(t, a, l) {
            var c;
            _classCallCheck(this, IndexedCS),
              ((c = r.call(this, "Indexed", 1)).base = t),
              (c.highVal = a);
            var u = t.numComps * a;
            if ((0, o.isStream)(l)) {
              c.lookup = new Uint8Array(u);
              var h = l.getBytes(u);
              c.lookup.set(h);
            } else if ((0, i.isString)(l)) {
              c.lookup = new Uint8Array(u);
              for (var d = 0; d < u; ++d) c.lookup[d] = l.charCodeAt(d);
            } else {
              if (!(l instanceof Uint8Array))
                throw new i.FormatError(
                  "Unrecognized lookup table: ".concat(l),
                );
              c.lookup = l;
            }
            return c;
          }
          return (
            _createClass(IndexedCS, [
              {
                key: "getRgbItem",
                value: function getRgbItem(t, r, a, i) {
                  var o = this.base.numComps,
                    l = t[r] * o;
                  this.base.getRgbBuffer(this.lookup, l, 1, a, i, 8, 0);
                },
              },
              {
                key: "getRgbBuffer",
                value: function getRgbBuffer(t, r, a, i, o, l, c) {
                  for (
                    var u = this.base,
                      h = u.numComps,
                      d = u.getOutputLength(h, c),
                      p = this.lookup,
                      m = 0;
                    m < a;
                    ++m
                  ) {
                    var g = t[r++] * h;
                    u.getRgbBuffer(p, g, 1, i, o, 8, c), (o += d);
                  }
                },
              },
              {
                key: "getOutputLength",
                value: function getOutputLength(t, r) {
                  return this.base.getOutputLength(t * this.base.numComps, r);
                },
              },
              {
                key: "isDefaultDecode",
                value: function isDefaultDecode(t, r) {
                  return (
                    !Array.isArray(t) ||
                    (2 !== t.length
                      ? ((0, i.warn)("Decode map length is not correct"), !0)
                      : !Number.isInteger(r) || r < 1
                      ? ((0, i.warn)("Bits per component is not correct"), !0)
                      : 0 === t[0] && t[1] === (1 << r) - 1)
                  );
                },
              },
            ]),
            IndexedCS
          );
        })(l),
        d = (function (t) {
          _inherits(DeviceGrayCS, t);
          var r = _createSuper(DeviceGrayCS);
          function DeviceGrayCS() {
            return (
              _classCallCheck(this, DeviceGrayCS), r.call(this, "DeviceGray", 1)
            );
          }
          return (
            _createClass(DeviceGrayCS, [
              {
                key: "getRgbItem",
                value: function getRgbItem(t, r, a, i) {
                  var o = 255 * t[r];
                  a[i] = a[i + 1] = a[i + 2] = o;
                },
              },
              {
                key: "getRgbBuffer",
                value: function getRgbBuffer(t, r, a, i, o, l, c) {
                  for (
                    var u = 255 / ((1 << l) - 1), h = r, d = o, p = 0;
                    p < a;
                    ++p
                  ) {
                    var m = u * t[h++];
                    (i[d++] = m), (i[d++] = m), (i[d++] = m), (d += c);
                  }
                },
              },
              {
                key: "getOutputLength",
                value: function getOutputLength(t, r) {
                  return t * (3 + r);
                },
              },
            ]),
            DeviceGrayCS
          );
        })(l),
        p = (function (t) {
          _inherits(DeviceRgbCS, t);
          var r = _createSuper(DeviceRgbCS);
          function DeviceRgbCS() {
            return (
              _classCallCheck(this, DeviceRgbCS), r.call(this, "DeviceRGB", 3)
            );
          }
          return (
            _createClass(DeviceRgbCS, [
              {
                key: "getRgbItem",
                value: function getRgbItem(t, r, a, i) {
                  (a[i] = 255 * t[r]),
                    (a[i + 1] = 255 * t[r + 1]),
                    (a[i + 2] = 255 * t[r + 2]);
                },
              },
              {
                key: "getRgbBuffer",
                value: function getRgbBuffer(t, r, a, i, o, l, c) {
                  if (8 !== l || 0 !== c)
                    for (
                      var u = 255 / ((1 << l) - 1), h = r, d = o, p = 0;
                      p < a;
                      ++p
                    )
                      (i[d++] = u * t[h++]),
                        (i[d++] = u * t[h++]),
                        (i[d++] = u * t[h++]),
                        (d += c);
                  else i.set(t.subarray(r, r + 3 * a), o);
                },
              },
              {
                key: "getOutputLength",
                value: function getOutputLength(t, r) {
                  return ((t * (3 + r)) / 3) | 0;
                },
              },
              {
                key: "isPassthrough",
                value: function isPassthrough(t) {
                  return 8 === t;
                },
              },
            ]),
            DeviceRgbCS
          );
        })(l),
        m = (function DeviceCmykCSClosure() {
          function convertToRgb(t, r, a, i, o) {
            var l = t[r] * a,
              c = t[r + 1] * a,
              u = t[r + 2] * a,
              h = t[r + 3] * a;
            (i[o] =
              255 +
              l *
                (-4.387332384609988 * l +
                  54.48615194189176 * c +
                  18.82290502165302 * u +
                  212.25662451639585 * h -
                  285.2331026137004) +
              c *
                (1.7149763477362134 * c -
                  5.6096736904047315 * u +
                  -17.873870861415444 * h -
                  5.497006427196366) +
              u *
                (-2.5217340131683033 * u -
                  21.248923337353073 * h +
                  17.5119270841813) +
              h * (-21.86122147463605 * h - 189.48180835922747)),
              (i[o + 1] =
                255 +
                l *
                  (8.841041422036149 * l +
                    60.118027045597366 * c +
                    6.871425592049007 * u +
                    31.159100130055922 * h -
                    79.2970844816548) +
                c *
                  (-15.310361306967817 * c +
                    17.575251261109482 * u +
                    131.35250912493976 * h -
                    190.9453302588951) +
                u *
                  (4.444339102852739 * u +
                    9.8632861493405 * h -
                    24.86741582555878) +
                h * (-20.737325471181034 * h - 187.80453709719578)),
              (i[o + 2] =
                255 +
                l *
                  (0.8842522430003296 * l +
                    8.078677503112928 * c +
                    30.89978309703729 * u -
                    0.23883238689178934 * h -
                    14.183576799673286) +
                c *
                  (10.49593273432072 * c +
                    63.02378494754052 * u +
                    50.606957656360734 * h -
                    112.23884253719248) +
                u *
                  (0.03296041114873217 * u +
                    115.60384449646641 * h -
                    193.58209356861505) +
                h * (-22.33816807309886 * h - 180.12613974708367));
          }
          return (function (t) {
            _inherits(DeviceCmykCS, t);
            var r = _createSuper(DeviceCmykCS);
            function DeviceCmykCS() {
              return (
                _classCallCheck(this, DeviceCmykCS),
                r.call(this, "DeviceCMYK", 4)
              );
            }
            return (
              _createClass(DeviceCmykCS, [
                {
                  key: "getRgbItem",
                  value: function getRgbItem(t, r, a, i) {
                    convertToRgb(t, r, 1, a, i);
                  },
                },
                {
                  key: "getRgbBuffer",
                  value: function getRgbBuffer(t, r, a, i, o, l, c) {
                    for (var u = 1 / ((1 << l) - 1), h = 0; h < a; h++)
                      convertToRgb(t, r, u, i, o), (r += 4), (o += 3 + c);
                  },
                },
                {
                  key: "getOutputLength",
                  value: function getOutputLength(t, r) {
                    return ((t / 4) * (3 + r)) | 0;
                  },
                },
              ]),
              DeviceCmykCS
            );
          })(l);
        })(),
        g = (function CalGrayCSClosure() {
          function convertToRgb(t, r, a, i, o, l) {
            var c = r[a] * l,
              u = Math.pow(c, t.G),
              h = t.YW * u,
              d = Math.max(295.8 * Math.pow(h, 0.3333333333333333) - 40.8, 0);
            (i[o] = d), (i[o + 1] = d), (i[o + 2] = d);
          }
          return (function (t) {
            _inherits(CalGrayCS, t);
            var r = _createSuper(CalGrayCS);
            function CalGrayCS(t, a, o) {
              var l;
              if (
                (_classCallCheck(this, CalGrayCS),
                (l = r.call(this, "CalGray", 1)),
                !t)
              )
                throw new i.FormatError(
                  "WhitePoint missing - required for color space CalGray",
                );
              if (
                ((a = a || [0, 0, 0]),
                (o = o || 1),
                (l.XW = t[0]),
                (l.YW = t[1]),
                (l.ZW = t[2]),
                (l.XB = a[0]),
                (l.YB = a[1]),
                (l.ZB = a[2]),
                (l.G = o),
                l.XW < 0 || l.ZW < 0 || 1 !== l.YW)
              )
                throw new i.FormatError(
                  "Invalid WhitePoint components for ".concat(l.name) +
                    ", no fallback available",
                );
              return (
                (l.XB < 0 || l.YB < 0 || l.ZB < 0) &&
                  ((0, i.info)(
                    "Invalid BlackPoint for ".concat(
                      l.name,
                      ", falling back to default.",
                    ),
                  ),
                  (l.XB = l.YB = l.ZB = 0)),
                (0 === l.XB && 0 === l.YB && 0 === l.ZB) ||
                  (0, i.warn)(
                    ""
                      .concat(l.name, ", BlackPoint: XB: ")
                      .concat(l.XB, ", YB: ")
                      .concat(l.YB, ", ") +
                      "ZB: ".concat(
                        l.ZB,
                        ", only default values are supported.",
                      ),
                  ),
                l.G < 1 &&
                  ((0, i.info)(
                    "Invalid Gamma: "
                      .concat(l.G, " for ")
                      .concat(l.name, ", ") + "falling back to default.",
                  ),
                  (l.G = 1)),
                l
              );
            }
            return (
              _createClass(CalGrayCS, [
                {
                  key: "getRgbItem",
                  value: function getRgbItem(t, r, a, i) {
                    convertToRgb(this, t, r, a, i, 1);
                  },
                },
                {
                  key: "getRgbBuffer",
                  value: function getRgbBuffer(t, r, a, i, o, l, c) {
                    for (var u = 1 / ((1 << l) - 1), h = 0; h < a; ++h)
                      convertToRgb(this, t, r, i, o, u), (r += 1), (o += 3 + c);
                  },
                },
                {
                  key: "getOutputLength",
                  value: function getOutputLength(t, r) {
                    return t * (3 + r);
                  },
                },
              ]),
              CalGrayCS
            );
          })(l);
        })(),
        b = (function CalRGBCSClosure() {
          var t = new Float32Array([
              0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685,
              1.0296,
            ]),
            r = new Float32Array([
              0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912,
              -0.0085287, 0.0400428, 0.9684867,
            ]),
            a = new Float32Array([
              3.2404542, -1.5371385, -0.4985314, -0.969266, 1.8760108, 0.041556,
              0.0556434, -0.2040259, 1.0572252,
            ]),
            o = new Float32Array([1, 1, 1]),
            c = new Float32Array(3),
            u = new Float32Array(3),
            h = new Float32Array(3),
            d = Math.pow(24 / 116, 3) / 8;
          function matrixProduct(t, r, a) {
            (a[0] = t[0] * r[0] + t[1] * r[1] + t[2] * r[2]),
              (a[1] = t[3] * r[0] + t[4] * r[1] + t[5] * r[2]),
              (a[2] = t[6] * r[0] + t[7] * r[1] + t[8] * r[2]);
          }
          function sRGBTransferFunction(t) {
            return adjustToRange(
              0,
              1,
              t <= 0.0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - 0.055,
            );
          }
          function adjustToRange(t, r, a) {
            return Math.max(t, Math.min(r, a));
          }
          function decodeL(t) {
            return t < 0
              ? -decodeL(-t)
              : t > 8
              ? Math.pow((t + 16) / 116, 3)
              : t * d;
          }
          function convertToRgb(i, l, d, p, m, g) {
            var b = adjustToRange(0, 1, l[d] * g),
              y = adjustToRange(0, 1, l[d + 1] * g),
              v = adjustToRange(0, 1, l[d + 2] * g),
              S = Math.pow(b, i.GR),
              k = Math.pow(y, i.GG),
              w = Math.pow(v, i.GB),
              C = i.MXA * S + i.MXB * k + i.MXC * w,
              x = i.MYA * S + i.MYB * k + i.MYC * w,
              _ = i.MZA * S + i.MZB * k + i.MZC * w,
              A = u;
            (A[0] = C), (A[1] = x), (A[2] = _);
            var R = h;
            !(function normalizeWhitePointToFlat(a, i, o) {
              if (1 === a[0] && 1 === a[2])
                return (o[0] = i[0]), (o[1] = i[1]), void (o[2] = i[2]);
              var l = o;
              matrixProduct(t, i, l);
              var u = c;
              !(function convertToFlat(t, r, a) {
                (a[0] = (1 * r[0]) / t[0]),
                  (a[1] = (1 * r[1]) / t[1]),
                  (a[2] = (1 * r[2]) / t[2]);
              })(a, l, u),
                matrixProduct(r, u, o);
            })(i.whitePoint, A, R);
            var T = u;
            !(function compensateBlackPoint(t, r, a) {
              if (0 === t[0] && 0 === t[1] && 0 === t[2])
                return (a[0] = r[0]), (a[1] = r[1]), void (a[2] = r[2]);
              var i = decodeL(0),
                o = (1 - i) / (1 - decodeL(t[0])),
                l = 1 - o,
                c = (1 - i) / (1 - decodeL(t[1])),
                u = 1 - c,
                h = (1 - i) / (1 - decodeL(t[2])),
                d = 1 - h;
              (a[0] = r[0] * o + l),
                (a[1] = r[1] * c + u),
                (a[2] = r[2] * h + d);
            })(i.blackPoint, R, T);
            var I = h;
            !(function normalizeWhitePointToD65(a, i, o) {
              var l = o;
              matrixProduct(t, i, l);
              var u = c;
              !(function convertToD65(t, r, a) {
                (a[0] = (0.95047 * r[0]) / t[0]),
                  (a[1] = (1 * r[1]) / t[1]),
                  (a[2] = (1.08883 * r[2]) / t[2]);
              })(a, l, u),
                matrixProduct(r, u, o);
            })(o, T, I);
            var P = u;
            matrixProduct(a, I, P),
              (p[m] = 255 * sRGBTransferFunction(P[0])),
              (p[m + 1] = 255 * sRGBTransferFunction(P[1])),
              (p[m + 2] = 255 * sRGBTransferFunction(P[2]));
          }
          return (function (t) {
            _inherits(CalRGBCS, t);
            var r = _createSuper(CalRGBCS);
            function CalRGBCS(t, a, o, l) {
              var c;
              if (
                (_classCallCheck(this, CalRGBCS),
                (c = r.call(this, "CalRGB", 3)),
                !t)
              )
                throw new i.FormatError(
                  "WhitePoint missing - required for color space CalRGB",
                );
              (a = a || new Float32Array(3)),
                (o = o || new Float32Array([1, 1, 1])),
                (l = l || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]));
              var u = t[0],
                h = t[1],
                d = t[2];
              c.whitePoint = t;
              var p = a[0],
                m = a[1],
                g = a[2];
              if (
                ((c.blackPoint = a),
                (c.GR = o[0]),
                (c.GG = o[1]),
                (c.GB = o[2]),
                (c.MXA = l[0]),
                (c.MYA = l[1]),
                (c.MZA = l[2]),
                (c.MXB = l[3]),
                (c.MYB = l[4]),
                (c.MZB = l[5]),
                (c.MXC = l[6]),
                (c.MYC = l[7]),
                (c.MZC = l[8]),
                u < 0 || d < 0 || 1 !== h)
              )
                throw new i.FormatError(
                  "Invalid WhitePoint components for ".concat(c.name) +
                    ", no fallback available",
                );
              return (
                (p < 0 || m < 0 || g < 0) &&
                  ((0, i.info)(
                    "Invalid BlackPoint for "
                      .concat(c.name, " [")
                      .concat(p, ", ")
                      .concat(m, ", ")
                      .concat(g, "], ") + "falling back to default.",
                  ),
                  (c.blackPoint = new Float32Array(3))),
                (c.GR < 0 || c.GG < 0 || c.GB < 0) &&
                  ((0, i.info)(
                    "Invalid Gamma ["
                      .concat(c.GR, ", ")
                      .concat(c.GG, ", ")
                      .concat(c.GB, "] for ") +
                      "".concat(c.name, ", falling back to default."),
                  ),
                  (c.GR = c.GG = c.GB = 1)),
                c
              );
            }
            return (
              _createClass(CalRGBCS, [
                {
                  key: "getRgbItem",
                  value: function getRgbItem(t, r, a, i) {
                    convertToRgb(this, t, r, a, i, 1);
                  },
                },
                {
                  key: "getRgbBuffer",
                  value: function getRgbBuffer(t, r, a, i, o, l, c) {
                    for (var u = 1 / ((1 << l) - 1), h = 0; h < a; ++h)
                      convertToRgb(this, t, r, i, o, u), (r += 3), (o += 3 + c);
                  },
                },
                {
                  key: "getOutputLength",
                  value: function getOutputLength(t, r) {
                    return ((t * (3 + r)) / 3) | 0;
                  },
                },
              ]),
              CalRGBCS
            );
          })(l);
        })(),
        y = (function LabCSClosure() {
          function fn_g(t) {
            return t >= 6 / 29 ? t * t * t : (108 / 841) * (t - 4 / 29);
          }
          function decode(t, r, a, i) {
            return a + (t * (i - a)) / r;
          }
          function convertToRgb(t, r, a, i, o, l) {
            var c = r[a],
              u = r[a + 1],
              h = r[a + 2];
            !1 !== i &&
              ((c = decode(c, i, 0, 100)),
              (u = decode(u, i, t.amin, t.amax)),
              (h = decode(h, i, t.bmin, t.bmax))),
              u > t.amax ? (u = t.amax) : u < t.amin && (u = t.amin),
              h > t.bmax ? (h = t.bmax) : h < t.bmin && (h = t.bmin);
            var d,
              p,
              m,
              g = (c + 16) / 116,
              b = g + u / 500,
              y = g - h / 200,
              v = t.XW * fn_g(b),
              S = t.YW * fn_g(g),
              k = t.ZW * fn_g(y);
            t.ZW < 1
              ? ((d = 3.1339 * v + -1.617 * S + -0.4906 * k),
                (p = -0.9785 * v + 1.916 * S + 0.0333 * k),
                (m = 0.072 * v + -0.229 * S + 1.4057 * k))
              : ((d = 3.2406 * v + -1.5372 * S + -0.4986 * k),
                (p = -0.9689 * v + 1.8758 * S + 0.0415 * k),
                (m = 0.0557 * v + -0.204 * S + 1.057 * k)),
              (o[l] = 255 * Math.sqrt(d)),
              (o[l + 1] = 255 * Math.sqrt(p)),
              (o[l + 2] = 255 * Math.sqrt(m));
          }
          return (function (t) {
            _inherits(LabCS, t);
            var r = _createSuper(LabCS);
            function LabCS(t, a, o) {
              var l;
              if (
                (_classCallCheck(this, LabCS), (l = r.call(this, "Lab", 3)), !t)
              )
                throw new i.FormatError(
                  "WhitePoint missing - required for color space Lab",
                );
              if (
                ((a = a || [0, 0, 0]),
                (o = o || [-100, 100, -100, 100]),
                (l.XW = t[0]),
                (l.YW = t[1]),
                (l.ZW = t[2]),
                (l.amin = o[0]),
                (l.amax = o[1]),
                (l.bmin = o[2]),
                (l.bmax = o[3]),
                (l.XB = a[0]),
                (l.YB = a[1]),
                (l.ZB = a[2]),
                l.XW < 0 || l.ZW < 0 || 1 !== l.YW)
              )
                throw new i.FormatError(
                  "Invalid WhitePoint components, no fallback available",
                );
              return (
                (l.XB < 0 || l.YB < 0 || l.ZB < 0) &&
                  ((0, i.info)("Invalid BlackPoint, falling back to default"),
                  (l.XB = l.YB = l.ZB = 0)),
                (l.amin > l.amax || l.bmin > l.bmax) &&
                  ((0, i.info)("Invalid Range, falling back to defaults"),
                  (l.amin = -100),
                  (l.amax = 100),
                  (l.bmin = -100),
                  (l.bmax = 100)),
                l
              );
            }
            return (
              _createClass(LabCS, [
                {
                  key: "getRgbItem",
                  value: function getRgbItem(t, r, a, i) {
                    convertToRgb(this, t, r, !1, a, i);
                  },
                },
                {
                  key: "getRgbBuffer",
                  value: function getRgbBuffer(t, r, a, i, o, l, c) {
                    for (var u = (1 << l) - 1, h = 0; h < a; h++)
                      convertToRgb(this, t, r, u, i, o), (r += 3), (o += 3 + c);
                  },
                },
                {
                  key: "getOutputLength",
                  value: function getOutputLength(t, r) {
                    return ((t * (3 + r)) / 3) | 0;
                  },
                },
                {
                  key: "isDefaultDecode",
                  value: function isDefaultDecode(t, r) {
                    return !0;
                  },
                },
                {
                  key: "usesZeroToOneRange",
                  get: function get() {
                    return (0, i.shadow)(this, "usesZeroToOneRange", !1);
                  },
                },
              ]),
              LabCS
            );
          })(l);
        })();
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.GlobalImageCache = r.LocalImageCache = void 0);
      var i = a(5),
        o = a(198);
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var l = (function () {
        function LocalImageCache() {
          _classCallCheck(this, LocalImageCache),
            (this._nameRefMap = new Map()),
            (this._imageMap = new Map()),
            (this._imageCache = new o.RefSetCache());
        }
        return (
          _createClass(LocalImageCache, [
            {
              key: "getByName",
              value: function getByName(t) {
                var r = this._nameRefMap.get(t);
                return r ? this.getByRef(r) : this._imageMap.get(t) || null;
              },
            },
            {
              key: "getByRef",
              value: function getByRef(t) {
                return this._imageCache.get(t) || null;
              },
            },
            {
              key: "set",
              value: function set(t) {
                var r =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : null,
                  a = arguments.length > 2 ? arguments[2] : void 0;
                if (!t)
                  throw new Error(
                    'LocalImageCache.set - expected "name" argument.',
                  );
                if (r) {
                  if (this._imageCache.has(r)) return;
                  return (
                    this._nameRefMap.set(t, r), void this._imageCache.put(r, a)
                  );
                }
                this._imageMap.has(t) || this._imageMap.set(t, a);
              },
            },
          ]),
          LocalImageCache
        );
      })();
      r.LocalImageCache = l;
      var c = (function () {
        function GlobalImageCache() {
          _classCallCheck(this, GlobalImageCache),
            (this._refCache = new o.RefSetCache()),
            (this._imageCache = new o.RefSetCache());
        }
        return (
          _createClass(GlobalImageCache, null, [
            {
              key: "NUM_PAGES_THRESHOLD",
              get: function get() {
                return (0, i.shadow)(this, "NUM_PAGES_THRESHOLD", 2);
              },
            },
            {
              key: "MAX_IMAGES_TO_CACHE",
              get: function get() {
                return (0, i.shadow)(this, "MAX_IMAGES_TO_CACHE", 10);
              },
            },
          ]),
          _createClass(GlobalImageCache, [
            {
              key: "shouldCache",
              value: function shouldCache(t, r) {
                var a = this._refCache.get(t);
                return (
                  !(
                    (a ? a.size + (a.has(r) ? 0 : 1) : 1) <
                    GlobalImageCache.NUM_PAGES_THRESHOLD
                  ) &&
                  !(
                    !this._imageCache.has(t) &&
                    this._imageCache.size >=
                      GlobalImageCache.MAX_IMAGES_TO_CACHE
                  )
                );
              },
            },
            {
              key: "addPageIndex",
              value: function addPageIndex(t, r) {
                var a = this._refCache.get(t);
                a || ((a = new Set()), this._refCache.put(t, a)), a.add(r);
              },
            },
            {
              key: "getData",
              value: function getData(t, r) {
                if (!this._refCache.has(t)) return null;
                var a = this._refCache.get(t);
                return a.size < GlobalImageCache.NUM_PAGES_THRESHOLD
                  ? null
                  : this._imageCache.has(t)
                  ? (a.add(r), this._imageCache.get(t))
                  : null;
              },
            },
            {
              key: "setData",
              value: function setData(t, r) {
                if (!this._refCache.has(t))
                  throw new Error(
                    'GlobalImageCache.setData - expected "addPageIndex" to have been called.',
                  );
                this._imageCache.has(t) ||
                  (this._imageCache.size >= GlobalImageCache.MAX_IMAGES_TO_CACHE
                    ? (0, i.info)(
                        "GlobalImageCache.setData - ignoring image above MAX_IMAGES_TO_CACHE.",
                      )
                    : this._imageCache.put(t, r));
              },
            },
            {
              key: "clear",
              value: function clear() {
                var t =
                  arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0];
                t || this._refCache.clear(), this._imageCache.clear();
              },
            },
          ]),
          GlobalImageCache
        );
      })();
      r.GlobalImageCache = c;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.getQuadPoints = getQuadPoints),
        (r.MarkupAnnotation =
          r.AnnotationFactory =
          r.AnnotationBorderStyle =
          r.Annotation =
            void 0);
      var i = a(5),
        o = a(203),
        l = a(198),
        c = a(216),
        u = a(201),
        h = a(219),
        d = a(205);
      function _get(t, r, a) {
        return (_get =
          "undefined" != typeof Reflect && Reflect.get
            ? Reflect.get
            : function _get(t, r, a) {
                var i = (function _superPropBase(t, r) {
                  for (
                    ;
                    !Object.prototype.hasOwnProperty.call(t, r) &&
                    null !== (t = _getPrototypeOf(t));

                  );
                  return t;
                })(t, r);
                if (i) {
                  var o = Object.getOwnPropertyDescriptor(i, r);
                  return o.get ? o.get.call(a) : o.value;
                }
              })(t, r, a || t);
      }
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _inherits(t, r) {
        if ("function" != typeof r && null !== r)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (t.prototype = Object.create(r && r.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          r && _setPrototypeOf(t, r);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function _createForOfIteratorHelper(t, r) {
        var a;
        if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
          if (
            Array.isArray(t) ||
            (a = _unsupportedIterableToArray(t)) ||
            (r && t && "number" == typeof t.length)
          ) {
            a && (t = a);
            var i = 0,
              o = function F() {};
            return {
              s: o,
              n: function n() {
                return i >= t.length
                  ? { done: !0 }
                  : { done: !1, value: t[i++] };
              },
              e: function e(t) {
                throw t;
              },
              f: o,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var l,
          c = !0,
          u = !1;
        return {
          s: function s() {
            a = t[Symbol.iterator]();
          },
          n: function n() {
            var t = a.next();
            return (c = t.done), t;
          },
          e: function e(t) {
            (u = !0), (l = t);
          },
          f: function f() {
            try {
              c || null == a.return || a.return();
            } finally {
              if (u) throw l;
            }
          },
        };
      }
      function _slicedToArray(t, r) {
        return (
          (function _arrayWithHoles(t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function _iterableToArrayLimit(t, r) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var a = [],
              i = !0,
              o = !1,
              l = void 0;
            try {
              for (
                var c, u = t[Symbol.iterator]();
                !(i = (c = u.next()).done) &&
                (a.push(c.value), !r || a.length !== r);
                i = !0
              );
            } catch (t) {
              (o = !0), (l = t);
            } finally {
              try {
                i || null == u.return || u.return();
              } finally {
                if (o) throw l;
              }
            }
            return a;
          })(t, r) ||
          _unsupportedIterableToArray(t, r) ||
          (function _nonIterableRest() {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function _unsupportedIterableToArray(t, r) {
        if (t) {
          if ("string" == typeof t) return _arrayLikeToArray(t, r);
          var a = Object.prototype.toString.call(t).slice(8, -1);
          return (
            "Object" === a && t.constructor && (a = t.constructor.name),
            "Map" === a || "Set" === a
              ? Array.from(t)
              : "Arguments" === a ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
              ? _arrayLikeToArray(t, r)
              : void 0
          );
        }
      }
      function _arrayLikeToArray(t, r) {
        (null == r || r > t.length) && (r = t.length);
        for (var a = 0, i = new Array(r); a < r; a++) i[a] = t[a];
        return i;
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var p = (function () {
        function AnnotationFactory() {
          _classCallCheck(this, AnnotationFactory);
        }
        return (
          _createClass(AnnotationFactory, null, [
            {
              key: "create",
              value: function create(t, r, a, i) {
                return a.ensure(this, "_create", [t, r, a, i]);
              },
            },
            {
              key: "_create",
              value: function _create(t, r, a, o) {
                var c = t.fetchIfRef(r);
                if ((0, l.isDict)(c)) {
                  var h = (0, l.isRef)(r)
                      ? r.toString()
                      : "annot_".concat(o.createObjId()),
                    d = c.get("Subtype"),
                    p = {
                      xref: t,
                      dict: c,
                      subtype: (d = (0, l.isName)(d) ? d.name : null),
                      id: h,
                      pdfManager: a,
                    };
                  switch (d) {
                    case "Link":
                      return new C(p);
                    case "Text":
                      return new w(p);
                    case "Widget":
                      var g = (0, u.getInheritableProperty)({
                        dict: c,
                        key: "FT",
                      });
                      switch ((g = (0, l.isName)(g) ? g.name : null)) {
                        case "Tx":
                          return new v(p);
                        case "Btn":
                          return new S(p);
                        case "Ch":
                          return new k(p);
                      }
                      return (
                        (0, i.warn)(
                          'Unimplemented widget field type "' +
                            g +
                            '", falling back to base field type.',
                        ),
                        new y(p)
                      );
                    case "Popup":
                      return new x(p);
                    case "FreeText":
                      return new _(p);
                    case "Line":
                      return new A(p);
                    case "Square":
                      return new R(p);
                    case "Circle":
                      return new T(p);
                    case "PolyLine":
                      return new I(p);
                    case "Polygon":
                      return new P(p);
                    case "Caret":
                      return new O(p);
                    case "Ink":
                      return new E(p);
                    case "Highlight":
                      return new B(p);
                    case "Underline":
                      return new D(p);
                    case "Squiggly":
                      return new M(p);
                    case "StrikeOut":
                      return new L(p);
                    case "Stamp":
                      return new N(p);
                    case "FileAttachment":
                      return new U(p);
                    default:
                      return (
                        d
                          ? (0, i.warn)(
                              'Unimplemented annotation type "' +
                                d +
                                '", falling back to base annotation.',
                            )
                          : (0, i.warn)(
                              "Annotation is missing the required /Subtype.",
                            ),
                        new m(p)
                      );
                  }
                }
              },
            },
          ]),
          AnnotationFactory
        );
      })();
      function getQuadPoints(t, r) {
        if (!t.has("QuadPoints")) return null;
        var a = t.getArray("QuadPoints");
        if (!Array.isArray(a) || a.length % 8 > 0) return null;
        for (var i = [], o = 0, l = a.length / 8; o < l; o++) {
          i.push([]);
          for (var c = 8 * o, u = 8 * o + 8; c < u; c += 2) {
            var h = a[c],
              d = a[c + 1];
            if (h < r[0] || h > r[2] || d < r[1] || d > r[3]) return null;
            i[o].push({ x: h, y: d });
          }
        }
        return i;
      }
      r.AnnotationFactory = p;
      var m = (function () {
        function Annotation(t) {
          _classCallCheck(this, Annotation);
          var r = t.dict;
          this.setContents(r.get("Contents")),
            this.setModificationDate(r.get("M")),
            this.setFlags(r.get("F")),
            this.setRectangle(r.getArray("Rect")),
            this.setColor(r.getArray("C")),
            this.setBorderStyle(r),
            this.setAppearance(r),
            (this.data = {
              annotationFlags: this.flags,
              borderStyle: this.borderStyle,
              color: this.color,
              contents: this.contents,
              hasAppearance: !!this.appearance,
              id: t.id,
              modificationDate: this.modificationDate,
              rect: this.rectangle,
              subtype: t.subtype,
            });
        }
        return (
          _createClass(Annotation, [
            {
              key: "_hasFlag",
              value: function _hasFlag(t, r) {
                return !!(t & r);
              },
            },
            {
              key: "_isViewable",
              value: function _isViewable(t) {
                return (
                  !this._hasFlag(t, i.AnnotationFlag.INVISIBLE) &&
                  !this._hasFlag(t, i.AnnotationFlag.HIDDEN) &&
                  !this._hasFlag(t, i.AnnotationFlag.NOVIEW)
                );
              },
            },
            {
              key: "_isPrintable",
              value: function _isPrintable(t) {
                return (
                  this._hasFlag(t, i.AnnotationFlag.PRINT) &&
                  !this._hasFlag(t, i.AnnotationFlag.INVISIBLE) &&
                  !this._hasFlag(t, i.AnnotationFlag.HIDDEN)
                );
              },
            },
            {
              key: "setContents",
              value: function setContents(t) {
                this.contents = (0, i.stringToPDFString)(t || "");
              },
            },
            {
              key: "setModificationDate",
              value: function setModificationDate(t) {
                this.modificationDate = (0, i.isString)(t) ? t : null;
              },
            },
            {
              key: "setFlags",
              value: function setFlags(t) {
                this.flags = Number.isInteger(t) && t > 0 ? t : 0;
              },
            },
            {
              key: "hasFlag",
              value: function hasFlag(t) {
                return this._hasFlag(this.flags, t);
              },
            },
            {
              key: "setRectangle",
              value: function setRectangle(t) {
                Array.isArray(t) && 4 === t.length
                  ? (this.rectangle = i.Util.normalizeRect(t))
                  : (this.rectangle = [0, 0, 0, 0]);
              },
            },
            {
              key: "setColor",
              value: function setColor(t) {
                var r = new Uint8ClampedArray(3);
                if (Array.isArray(t))
                  switch (t.length) {
                    case 0:
                      this.color = null;
                      break;
                    case 1:
                      c.ColorSpace.singletons.gray.getRgbItem(t, 0, r, 0),
                        (this.color = r);
                      break;
                    case 3:
                      c.ColorSpace.singletons.rgb.getRgbItem(t, 0, r, 0),
                        (this.color = r);
                      break;
                    case 4:
                      c.ColorSpace.singletons.cmyk.getRgbItem(t, 0, r, 0),
                        (this.color = r);
                      break;
                    default:
                      this.color = r;
                  }
                else this.color = r;
              },
            },
            {
              key: "setBorderStyle",
              value: function setBorderStyle(t) {
                if (((this.borderStyle = new g()), (0, l.isDict)(t)))
                  if (t.has("BS")) {
                    var r = t.get("BS"),
                      a = r.get("Type");
                    (a && !(0, l.isName)(a, "Border")) ||
                      (this.borderStyle.setWidth(r.get("W"), this.rectangle),
                      this.borderStyle.setStyle(r.get("S")),
                      this.borderStyle.setDashArray(r.getArray("D")));
                  } else if (t.has("Border")) {
                    var i = t.getArray("Border");
                    Array.isArray(i) &&
                      i.length >= 3 &&
                      (this.borderStyle.setHorizontalCornerRadius(i[0]),
                      this.borderStyle.setVerticalCornerRadius(i[1]),
                      this.borderStyle.setWidth(i[2], this.rectangle),
                      4 === i.length && this.borderStyle.setDashArray(i[3]));
                  } else this.borderStyle.setWidth(0);
              },
            },
            {
              key: "setAppearance",
              value: function setAppearance(t) {
                this.appearance = null;
                var r = t.get("AP");
                if ((0, l.isDict)(r)) {
                  var a = r.get("N");
                  if ((0, l.isStream)(a)) this.appearance = a;
                  else if ((0, l.isDict)(a)) {
                    var i = t.get("AS");
                    (0, l.isName)(i) &&
                      a.has(i.name) &&
                      (this.appearance = a.get(i.name));
                  }
                }
              },
            },
            {
              key: "loadResources",
              value: function loadResources(t) {
                return this.appearance.dict
                  .getAsync("Resources")
                  .then(function (r) {
                    if (r)
                      return new o.ObjectLoader(r, t, r.xref)
                        .load()
                        .then(function () {
                          return r;
                        });
                  });
              },
            },
            {
              key: "getOperatorList",
              value: function getOperatorList(t, r, a) {
                var o = this;
                if (!this.appearance)
                  return Promise.resolve(new h.OperatorList());
                var l = this.data,
                  c = this.appearance.dict,
                  u = this.loadResources([
                    "ExtGState",
                    "ColorSpace",
                    "Pattern",
                    "Shading",
                    "XObject",
                    "Font",
                  ]),
                  d = c.getArray("BBox") || [0, 0, 1, 1],
                  p = c.getArray("Matrix") || [1, 0, 0, 1, 0, 0],
                  m = (function getTransformMatrix(t, r, a) {
                    var o = _slicedToArray(
                        i.Util.getAxialAlignedBoundingBox(r, a),
                        4,
                      ),
                      l = o[0],
                      c = o[1],
                      u = o[2],
                      h = o[3];
                    if (l === u || c === h) return [1, 0, 0, 1, t[0], t[1]];
                    var d = (t[2] - t[0]) / (u - l),
                      p = (t[3] - t[1]) / (h - c);
                    return [d, 0, 0, p, t[0] - l * d, t[1] - c * p];
                  })(l.rect, d, p);
                return u.then(function (a) {
                  var c = new h.OperatorList();
                  return (
                    c.addOp(i.OPS.beginAnnotation, [l.rect, m, p]),
                    t
                      .getOperatorList({
                        stream: o.appearance,
                        task: r,
                        resources: a,
                        operatorList: c,
                      })
                      .then(function () {
                        return (
                          c.addOp(i.OPS.endAnnotation, []),
                          o.appearance.reset(),
                          c
                        );
                      })
                  );
                });
              },
            },
            {
              key: "viewable",
              get: function get() {
                return 0 === this.flags || this._isViewable(this.flags);
              },
            },
            {
              key: "printable",
              get: function get() {
                return 0 !== this.flags && this._isPrintable(this.flags);
              },
            },
          ]),
          Annotation
        );
      })();
      r.Annotation = m;
      var g = (function () {
        function AnnotationBorderStyle() {
          _classCallCheck(this, AnnotationBorderStyle),
            (this.width = 1),
            (this.style = i.AnnotationBorderStyleType.SOLID),
            (this.dashArray = [3]),
            (this.horizontalCornerRadius = 0),
            (this.verticalCornerRadius = 0);
        }
        return (
          _createClass(AnnotationBorderStyle, [
            {
              key: "setWidth",
              value: function setWidth(t) {
                var r =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : [0, 0, 0, 0];
                if ((0, l.isName)(t)) this.width = 0;
                else if (Number.isInteger(t)) {
                  if (t > 0) {
                    var a = (r[2] - r[0]) / 2,
                      o = (r[3] - r[1]) / 2;
                    a > 0 &&
                      o > 0 &&
                      (t > a || t > o) &&
                      ((0, i.warn)(
                        "AnnotationBorderStyle.setWidth - ignoring width: ".concat(
                          t,
                        ),
                      ),
                      (t = 1));
                  }
                  this.width = t;
                }
              },
            },
            {
              key: "setStyle",
              value: function setStyle(t) {
                if ((0, l.isName)(t))
                  switch (t.name) {
                    case "S":
                      this.style = i.AnnotationBorderStyleType.SOLID;
                      break;
                    case "D":
                      this.style = i.AnnotationBorderStyleType.DASHED;
                      break;
                    case "B":
                      this.style = i.AnnotationBorderStyleType.BEVELED;
                      break;
                    case "I":
                      this.style = i.AnnotationBorderStyleType.INSET;
                      break;
                    case "U":
                      this.style = i.AnnotationBorderStyleType.UNDERLINE;
                  }
              },
            },
            {
              key: "setDashArray",
              value: function setDashArray(t) {
                if (Array.isArray(t) && t.length > 0) {
                  var r,
                    a = !0,
                    i = !0,
                    o = _createForOfIteratorHelper(t);
                  try {
                    for (o.s(); !(r = o.n()).done; ) {
                      var l = r.value;
                      if (!(+l >= 0)) {
                        a = !1;
                        break;
                      }
                      l > 0 && (i = !1);
                    }
                  } catch (t) {
                    o.e(t);
                  } finally {
                    o.f();
                  }
                  a && !i ? (this.dashArray = t) : (this.width = 0);
                } else t && (this.width = 0);
              },
            },
            {
              key: "setHorizontalCornerRadius",
              value: function setHorizontalCornerRadius(t) {
                Number.isInteger(t) && (this.horizontalCornerRadius = t);
              },
            },
            {
              key: "setVerticalCornerRadius",
              value: function setVerticalCornerRadius(t) {
                Number.isInteger(t) && (this.verticalCornerRadius = t);
              },
            },
          ]),
          AnnotationBorderStyle
        );
      })();
      r.AnnotationBorderStyle = g;
      var b = (function (t) {
        _inherits(MarkupAnnotation, t);
        var r = _createSuper(MarkupAnnotation);
        function MarkupAnnotation(t) {
          var a;
          _classCallCheck(this, MarkupAnnotation), (a = r.call(this, t));
          var o = t.dict;
          if (o.has("IRT")) {
            var c = o.getRaw("IRT");
            a.data.inReplyTo = (0, l.isRef)(c) ? c.toString() : null;
            var u = o.get("RT");
            a.data.replyType = (0, l.isName)(u)
              ? u.name
              : i.AnnotationReplyType.REPLY;
          }
          if (a.data.replyType === i.AnnotationReplyType.GROUP) {
            var h = o.get("IRT");
            (a.data.title = (0, i.stringToPDFString)(h.get("T") || "")),
              a.setContents(h.get("Contents")),
              (a.data.contents = a.contents),
              h.has("CreationDate")
                ? (a.setCreationDate(h.get("CreationDate")),
                  (a.data.creationDate = a.creationDate))
                : (a.data.creationDate = null),
              h.has("M")
                ? (a.setModificationDate(h.get("M")),
                  (a.data.modificationDate = a.modificationDate))
                : (a.data.modificationDate = null),
              (a.data.hasPopup = h.has("Popup")),
              h.has("C")
                ? (a.setColor(h.getArray("C")), (a.data.color = a.color))
                : (a.data.color = null);
          } else
            (a.data.title = (0, i.stringToPDFString)(o.get("T") || "")),
              a.setCreationDate(o.get("CreationDate")),
              (a.data.creationDate = a.creationDate),
              (a.data.hasPopup = o.has("Popup")),
              o.has("C") || (a.data.color = null);
          return a;
        }
        return (
          _createClass(MarkupAnnotation, [
            {
              key: "setCreationDate",
              value: function setCreationDate(t) {
                this.creationDate = (0, i.isString)(t) ? t : null;
              },
            },
          ]),
          MarkupAnnotation
        );
      })(m);
      r.MarkupAnnotation = b;
      var y = (function (t) {
          _inherits(WidgetAnnotation, t);
          var r = _createSuper(WidgetAnnotation);
          function WidgetAnnotation(t) {
            var a;
            _classCallCheck(this, WidgetAnnotation), (a = r.call(this, t));
            var o = t.dict,
              c = a.data;
            (c.annotationType = i.AnnotationType.WIDGET),
              (c.fieldName = a._constructFieldName(o)),
              (c.fieldValue = (0, u.getInheritableProperty)({
                dict: o,
                key: "V",
                getArray: !0,
              })),
              (c.alternativeText = (0, i.stringToPDFString)(o.get("TU") || "")),
              (c.defaultAppearance =
                (0, u.getInheritableProperty)({ dict: o, key: "DA" }) || "");
            var h = (0, u.getInheritableProperty)({ dict: o, key: "FT" });
            return (
              (c.fieldType = (0, l.isName)(h) ? h.name : null),
              (a.fieldResources =
                (0, u.getInheritableProperty)({ dict: o, key: "DR" }) ||
                l.Dict.empty),
              (c.fieldFlags = (0, u.getInheritableProperty)({
                dict: o,
                key: "Ff",
              })),
              (!Number.isInteger(c.fieldFlags) || c.fieldFlags < 0) &&
                (c.fieldFlags = 0),
              (c.readOnly = a.hasFieldFlag(i.AnnotationFieldFlag.READONLY)),
              "Sig" === c.fieldType &&
                ((c.fieldValue = null), a.setFlags(i.AnnotationFlag.HIDDEN)),
              a
            );
          }
          return (
            _createClass(WidgetAnnotation, [
              {
                key: "_constructFieldName",
                value: function _constructFieldName(t) {
                  if (!t.has("T") && !t.has("Parent"))
                    return (
                      (0, i.warn)(
                        "Unknown field name, falling back to empty field name.",
                      ),
                      ""
                    );
                  if (!t.has("Parent"))
                    return (0, i.stringToPDFString)(t.get("T"));
                  var r = [];
                  t.has("T") && r.unshift((0, i.stringToPDFString)(t.get("T")));
                  for (
                    var a = t;
                    a.has("Parent") &&
                    ((a = a.get("Parent")), (0, l.isDict)(a));

                  )
                    a.has("T") &&
                      r.unshift((0, i.stringToPDFString)(a.get("T")));
                  return r.join(".");
                },
              },
              {
                key: "hasFieldFlag",
                value: function hasFieldFlag(t) {
                  return !!(this.data.fieldFlags & t);
                },
              },
              {
                key: "getOperatorList",
                value: function getOperatorList(t, r, a) {
                  return a
                    ? Promise.resolve(new h.OperatorList())
                    : _get(
                        _getPrototypeOf(WidgetAnnotation.prototype),
                        "getOperatorList",
                        this,
                      ).call(this, t, r, a);
                },
              },
            ]),
            WidgetAnnotation
          );
        })(m),
        v = (function (t) {
          _inherits(TextWidgetAnnotation, t);
          var r = _createSuper(TextWidgetAnnotation);
          function TextWidgetAnnotation(t) {
            var a;
            _classCallCheck(this, TextWidgetAnnotation), (a = r.call(this, t));
            var o = t.dict;
            a.data.fieldValue = (0, i.stringToPDFString)(
              a.data.fieldValue || "",
            );
            var l = (0, u.getInheritableProperty)({ dict: o, key: "Q" });
            (!Number.isInteger(l) || l < 0 || l > 2) && (l = null),
              (a.data.textAlignment = l);
            var c = (0, u.getInheritableProperty)({ dict: o, key: "MaxLen" });
            return (
              (!Number.isInteger(c) || c < 0) && (c = null),
              (a.data.maxLen = c),
              (a.data.multiLine = a.hasFieldFlag(
                i.AnnotationFieldFlag.MULTILINE,
              )),
              (a.data.comb =
                a.hasFieldFlag(i.AnnotationFieldFlag.COMB) &&
                !a.hasFieldFlag(i.AnnotationFieldFlag.MULTILINE) &&
                !a.hasFieldFlag(i.AnnotationFieldFlag.PASSWORD) &&
                !a.hasFieldFlag(i.AnnotationFieldFlag.FILESELECT) &&
                null !== a.data.maxLen),
              a
            );
          }
          return (
            _createClass(TextWidgetAnnotation, [
              {
                key: "getOperatorList",
                value: function getOperatorList(t, r, a) {
                  if (a || this.appearance)
                    return _get(
                      _getPrototypeOf(TextWidgetAnnotation.prototype),
                      "getOperatorList",
                      this,
                    ).call(this, t, r, a);
                  var o = new h.OperatorList();
                  if (!this.data.defaultAppearance) return Promise.resolve(o);
                  var l = new d.Stream(
                    (0, i.stringToBytes)(this.data.defaultAppearance),
                  );
                  return t
                    .getOperatorList({
                      stream: l,
                      task: r,
                      resources: this.fieldResources,
                      operatorList: o,
                    })
                    .then(function () {
                      return o;
                    });
                },
              },
            ]),
            TextWidgetAnnotation
          );
        })(y),
        S = (function (t) {
          _inherits(ButtonWidgetAnnotation, t);
          var r = _createSuper(ButtonWidgetAnnotation);
          function ButtonWidgetAnnotation(t) {
            var a;
            return (
              _classCallCheck(this, ButtonWidgetAnnotation),
              ((a = r.call(this, t)).data.checkBox =
                !a.hasFieldFlag(i.AnnotationFieldFlag.RADIO) &&
                !a.hasFieldFlag(i.AnnotationFieldFlag.PUSHBUTTON)),
              (a.data.radioButton =
                a.hasFieldFlag(i.AnnotationFieldFlag.RADIO) &&
                !a.hasFieldFlag(i.AnnotationFieldFlag.PUSHBUTTON)),
              (a.data.pushButton = a.hasFieldFlag(
                i.AnnotationFieldFlag.PUSHBUTTON,
              )),
              a.data.checkBox
                ? a._processCheckBox(t)
                : a.data.radioButton
                ? a._processRadioButton(t)
                : a.data.pushButton
                ? a._processPushButton(t)
                : (0, i.warn)(
                    "Invalid field flags for button widget annotation",
                  ),
              a
            );
          }
          return (
            _createClass(ButtonWidgetAnnotation, [
              {
                key: "_processCheckBox",
                value: function _processCheckBox(t) {
                  (0, l.isName)(this.data.fieldValue) &&
                    (this.data.fieldValue = this.data.fieldValue.name);
                  var r = t.dict.get("AP");
                  if ((0, l.isDict)(r)) {
                    var a = r.get("D");
                    if ((0, l.isDict)(a)) {
                      var i = a.getKeys();
                      2 === i.length &&
                        (this.data.exportValue = "Off" === i[0] ? i[1] : i[0]);
                    }
                  }
                },
              },
              {
                key: "_processRadioButton",
                value: function _processRadioButton(t) {
                  this.data.fieldValue = this.data.buttonValue = null;
                  var r = t.dict.get("Parent");
                  if ((0, l.isDict)(r) && r.has("V")) {
                    var a = r.get("V");
                    (0, l.isName)(a) && (this.data.fieldValue = a.name);
                  }
                  var i = t.dict.get("AP");
                  if ((0, l.isDict)(i)) {
                    var o = i.get("N");
                    if ((0, l.isDict)(o)) {
                      var c,
                        u = _createForOfIteratorHelper(o.getKeys());
                      try {
                        for (u.s(); !(c = u.n()).done; ) {
                          var h = c.value;
                          if ("Off" !== h) {
                            this.data.buttonValue = h;
                            break;
                          }
                        }
                      } catch (t) {
                        u.e(t);
                      } finally {
                        u.f();
                      }
                    }
                  }
                },
              },
              {
                key: "_processPushButton",
                value: function _processPushButton(t) {
                  t.dict.has("A")
                    ? o.Catalog.parseDestDictionary({
                        destDict: t.dict,
                        resultObj: this.data,
                        docBaseUrl: t.pdfManager.docBaseUrl,
                      })
                    : (0, i.warn)(
                        "Push buttons without action dictionaries are not supported",
                      );
                },
              },
            ]),
            ButtonWidgetAnnotation
          );
        })(y),
        k = (function (t) {
          _inherits(ChoiceWidgetAnnotation, t);
          var r = _createSuper(ChoiceWidgetAnnotation);
          function ChoiceWidgetAnnotation(t) {
            var a;
            _classCallCheck(this, ChoiceWidgetAnnotation),
              ((a = r.call(this, t)).data.options = []);
            var o = (0, u.getInheritableProperty)({ dict: t.dict, key: "Opt" });
            if (Array.isArray(o))
              for (var l = t.xref, c = 0, h = o.length; c < h; c++) {
                var d = l.fetchIfRef(o[c]),
                  p = Array.isArray(d);
                a.data.options[c] = {
                  exportValue: p ? l.fetchIfRef(d[0]) : d,
                  displayValue: (0, i.stringToPDFString)(
                    p ? l.fetchIfRef(d[1]) : d,
                  ),
                };
              }
            return (
              Array.isArray(a.data.fieldValue) ||
                (a.data.fieldValue = [a.data.fieldValue]),
              (a.data.combo = a.hasFieldFlag(i.AnnotationFieldFlag.COMBO)),
              (a.data.multiSelect = a.hasFieldFlag(
                i.AnnotationFieldFlag.MULTISELECT,
              )),
              a
            );
          }
          return ChoiceWidgetAnnotation;
        })(y),
        w = (function (t) {
          _inherits(TextAnnotation, t);
          var r = _createSuper(TextAnnotation);
          function TextAnnotation(t) {
            var a;
            _classCallCheck(this, TextAnnotation);
            a = r.call(this, t);
            var o = t.dict;
            return (
              (a.data.annotationType = i.AnnotationType.TEXT),
              a.data.hasAppearance
                ? (a.data.name = "NoIcon")
                : ((a.data.rect[1] = a.data.rect[3] - 22),
                  (a.data.rect[2] = a.data.rect[0] + 22),
                  (a.data.name = o.has("Name") ? o.get("Name").name : "Note")),
              o.has("State")
                ? ((a.data.state = o.get("State") || null),
                  (a.data.stateModel = o.get("StateModel") || null))
                : ((a.data.state = null), (a.data.stateModel = null)),
              a
            );
          }
          return TextAnnotation;
        })(b),
        C = (function (t) {
          _inherits(LinkAnnotation, t);
          var r = _createSuper(LinkAnnotation);
          function LinkAnnotation(t) {
            var a;
            _classCallCheck(this, LinkAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.LINK);
            var l = getQuadPoints(t.dict, a.rectangle);
            return (
              l && (a.data.quadPoints = l),
              o.Catalog.parseDestDictionary({
                destDict: t.dict,
                resultObj: a.data,
                docBaseUrl: t.pdfManager.docBaseUrl,
              }),
              a
            );
          }
          return LinkAnnotation;
        })(m),
        x = (function (t) {
          _inherits(PopupAnnotation, t);
          var r = _createSuper(PopupAnnotation);
          function PopupAnnotation(t) {
            var a;
            _classCallCheck(this, PopupAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.POPUP);
            var o = t.dict.get("Parent");
            if (!o)
              return (
                (0, i.warn)(
                  "Popup annotation has a missing or invalid parent annotation.",
                ),
                _possibleConstructorReturn(a)
              );
            var c = o.get("Subtype");
            a.data.parentType = (0, l.isName)(c) ? c.name : null;
            var u = t.dict.getRaw("Parent");
            a.data.parentId = (0, l.isRef)(u) ? u.toString() : null;
            var h = o.get("RT");
            if (
              ((0, l.isName)(h, i.AnnotationReplyType.GROUP) &&
                (o = o.get("IRT")),
              o.has("M")
                ? (a.setModificationDate(o.get("M")),
                  (a.data.modificationDate = a.modificationDate))
                : (a.data.modificationDate = null),
              o.has("C")
                ? (a.setColor(o.getArray("C")), (a.data.color = a.color))
                : (a.data.color = null),
              !a.viewable)
            ) {
              var d = o.get("F");
              a._isViewable(d) && a.setFlags(d);
            }
            return (
              (a.data.title = (0, i.stringToPDFString)(o.get("T") || "")),
              (a.data.contents = (0, i.stringToPDFString)(
                o.get("Contents") || "",
              )),
              a
            );
          }
          return PopupAnnotation;
        })(m),
        _ = (function (t) {
          _inherits(FreeTextAnnotation, t);
          var r = _createSuper(FreeTextAnnotation);
          function FreeTextAnnotation(t) {
            var a;
            return (
              _classCallCheck(this, FreeTextAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.FREETEXT),
              a
            );
          }
          return FreeTextAnnotation;
        })(b),
        A = (function (t) {
          _inherits(LineAnnotation, t);
          var r = _createSuper(LineAnnotation);
          function LineAnnotation(t) {
            var a;
            return (
              _classCallCheck(this, LineAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.LINE),
              (a.data.lineCoordinates = i.Util.normalizeRect(
                t.dict.getArray("L"),
              )),
              a
            );
          }
          return LineAnnotation;
        })(b),
        R = (function (t) {
          _inherits(SquareAnnotation, t);
          var r = _createSuper(SquareAnnotation);
          function SquareAnnotation(t) {
            var a;
            return (
              _classCallCheck(this, SquareAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.SQUARE),
              a
            );
          }
          return SquareAnnotation;
        })(b),
        T = (function (t) {
          _inherits(CircleAnnotation, t);
          var r = _createSuper(CircleAnnotation);
          function CircleAnnotation(t) {
            var a;
            return (
              _classCallCheck(this, CircleAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.CIRCLE),
              a
            );
          }
          return CircleAnnotation;
        })(b),
        I = (function (t) {
          _inherits(PolylineAnnotation, t);
          var r = _createSuper(PolylineAnnotation);
          function PolylineAnnotation(t) {
            var a;
            _classCallCheck(this, PolylineAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.POLYLINE);
            var o = t.dict.getArray("Vertices");
            a.data.vertices = [];
            for (var l = 0, c = o.length; l < c; l += 2)
              a.data.vertices.push({ x: o[l], y: o[l + 1] });
            return a;
          }
          return PolylineAnnotation;
        })(b),
        P = (function (t) {
          _inherits(PolygonAnnotation, t);
          var r = _createSuper(PolygonAnnotation);
          function PolygonAnnotation(t) {
            var a;
            return (
              _classCallCheck(this, PolygonAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.POLYGON),
              a
            );
          }
          return PolygonAnnotation;
        })(I),
        O = (function (t) {
          _inherits(CaretAnnotation, t);
          var r = _createSuper(CaretAnnotation);
          function CaretAnnotation(t) {
            var a;
            return (
              _classCallCheck(this, CaretAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.CARET),
              a
            );
          }
          return CaretAnnotation;
        })(b),
        E = (function (t) {
          _inherits(InkAnnotation, t);
          var r = _createSuper(InkAnnotation);
          function InkAnnotation(t) {
            var a;
            _classCallCheck(this, InkAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.INK);
            var o = t.xref,
              l = t.dict.getArray("InkList");
            a.data.inkLists = [];
            for (var c = 0, u = l.length; c < u; ++c) {
              a.data.inkLists.push([]);
              for (var h = 0, d = l[c].length; h < d; h += 2)
                a.data.inkLists[c].push({
                  x: o.fetchIfRef(l[c][h]),
                  y: o.fetchIfRef(l[c][h + 1]),
                });
            }
            return a;
          }
          return InkAnnotation;
        })(b),
        B = (function (t) {
          _inherits(HighlightAnnotation, t);
          var r = _createSuper(HighlightAnnotation);
          function HighlightAnnotation(t) {
            var a;
            _classCallCheck(this, HighlightAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.HIGHLIGHT);
            var o = getQuadPoints(t.dict, a.rectangle);
            return o && (a.data.quadPoints = o), a;
          }
          return HighlightAnnotation;
        })(b),
        D = (function (t) {
          _inherits(UnderlineAnnotation, t);
          var r = _createSuper(UnderlineAnnotation);
          function UnderlineAnnotation(t) {
            var a;
            _classCallCheck(this, UnderlineAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.UNDERLINE);
            var o = getQuadPoints(t.dict, a.rectangle);
            return o && (a.data.quadPoints = o), a;
          }
          return UnderlineAnnotation;
        })(b),
        M = (function (t) {
          _inherits(SquigglyAnnotation, t);
          var r = _createSuper(SquigglyAnnotation);
          function SquigglyAnnotation(t) {
            var a;
            _classCallCheck(this, SquigglyAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.SQUIGGLY);
            var o = getQuadPoints(t.dict, a.rectangle);
            return o && (a.data.quadPoints = o), a;
          }
          return SquigglyAnnotation;
        })(b),
        L = (function (t) {
          _inherits(StrikeOutAnnotation, t);
          var r = _createSuper(StrikeOutAnnotation);
          function StrikeOutAnnotation(t) {
            var a;
            _classCallCheck(this, StrikeOutAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.STRIKEOUT);
            var o = getQuadPoints(t.dict, a.rectangle);
            return o && (a.data.quadPoints = o), a;
          }
          return StrikeOutAnnotation;
        })(b),
        N = (function (t) {
          _inherits(StampAnnotation, t);
          var r = _createSuper(StampAnnotation);
          function StampAnnotation(t) {
            var a;
            return (
              _classCallCheck(this, StampAnnotation),
              ((a = r.call(this, t)).data.annotationType =
                i.AnnotationType.STAMP),
              a
            );
          }
          return StampAnnotation;
        })(b),
        U = (function (t) {
          _inherits(FileAttachmentAnnotation, t);
          var r = _createSuper(FileAttachmentAnnotation);
          function FileAttachmentAnnotation(t) {
            var a;
            _classCallCheck(this, FileAttachmentAnnotation),
              (a = r.call(this, t));
            var l = new o.FileSpec(t.dict.get("FS"), t.xref);
            return (
              (a.data.annotationType = i.AnnotationType.FILEATTACHMENT),
              (a.data.file = l.serializable),
              a
            );
          }
          return FileAttachmentAnnotation;
        })(b);
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.OperatorList = void 0);
      var i = a(5),
        o = (function QueueOptimizerClosure() {
          function addState(t, r, a, i, o) {
            for (var l = t, c = 0, u = r.length - 1; c < u; c++) {
              var h = r[c];
              l = l[h] || (l[h] = []);
            }
            l[r[r.length - 1]] = { checkFn: a, iterateFn: i, processFn: o };
          }
          var t = [];
          function QueueOptimizer(t) {
            (this.queue = t),
              (this.state = null),
              (this.context = {
                iCurr: 0,
                fnArray: t.fnArray,
                argsArray: t.argsArray,
              }),
              (this.match = null),
              (this.lastProcessed = 0);
          }
          return (
            addState(
              t,
              [
                i.OPS.save,
                i.OPS.transform,
                i.OPS.paintInlineImageXObject,
                i.OPS.restore,
              ],
              null,
              function iterateInlineImageGroup(t, r) {
                var a = t.fnArray,
                  o = (r - (t.iCurr - 3)) % 4;
                switch (o) {
                  case 0:
                    return a[r] === i.OPS.save;
                  case 1:
                    return a[r] === i.OPS.transform;
                  case 2:
                    return a[r] === i.OPS.paintInlineImageXObject;
                  case 3:
                    return a[r] === i.OPS.restore;
                }
                throw new Error(
                  "iterateInlineImageGroup - invalid pos: ".concat(o),
                );
              },
              function foundInlineImageGroup(t, r) {
                var a = t.fnArray,
                  o = t.argsArray,
                  l = t.iCurr,
                  c = l - 3,
                  u = l - 2,
                  h = l - 1,
                  d = Math.min(Math.floor((r - c) / 4), 200);
                if (d < 10) return r - ((r - c) % 4);
                var p,
                  m = 0,
                  g = [],
                  b = 0,
                  y = 1,
                  v = 1;
                for (p = 0; p < d; p++) {
                  var S = o[u + (p << 2)],
                    k = o[h + (p << 2)][0];
                  y + k.width > 1e3 &&
                    ((m = Math.max(m, y)), (v += b + 2), (y = 0), (b = 0)),
                    g.push({
                      transform: S,
                      x: y,
                      y: v,
                      w: k.width,
                      h: k.height,
                    }),
                    (y += k.width + 2),
                    (b = Math.max(b, k.height));
                }
                var w = Math.max(m, y) + 1,
                  C = v + b + 1,
                  x = new Uint8ClampedArray(w * C * 4),
                  _ = w << 2;
                for (p = 0; p < d; p++) {
                  var A = o[h + (p << 2)][0].data,
                    R = g[p].w << 2,
                    T = 0,
                    I = (g[p].x + g[p].y * w) << 2;
                  x.set(A.subarray(0, R), I - _);
                  for (var P = 0, O = g[p].h; P < O; P++)
                    x.set(A.subarray(T, T + R), I), (T += R), (I += _);
                  for (x.set(A.subarray(T - R, T), I); I >= 0; )
                    (A[I - 4] = A[I]),
                      (A[I - 3] = A[I + 1]),
                      (A[I - 2] = A[I + 2]),
                      (A[I - 1] = A[I + 3]),
                      (A[I + R] = A[I + R - 4]),
                      (A[I + R + 1] = A[I + R - 3]),
                      (A[I + R + 2] = A[I + R - 2]),
                      (A[I + R + 3] = A[I + R - 1]),
                      (I -= _);
                }
                return (
                  a.splice(c, 4 * d, i.OPS.paintInlineImageXObjectGroup),
                  o.splice(c, 4 * d, [
                    {
                      width: w,
                      height: C,
                      kind: i.ImageKind.RGBA_32BPP,
                      data: x,
                    },
                    g,
                  ]),
                  c + 1
                );
              },
            ),
            addState(
              t,
              [
                i.OPS.save,
                i.OPS.transform,
                i.OPS.paintImageMaskXObject,
                i.OPS.restore,
              ],
              null,
              function iterateImageMaskGroup(t, r) {
                var a = t.fnArray,
                  o = (r - (t.iCurr - 3)) % 4;
                switch (o) {
                  case 0:
                    return a[r] === i.OPS.save;
                  case 1:
                    return a[r] === i.OPS.transform;
                  case 2:
                    return a[r] === i.OPS.paintImageMaskXObject;
                  case 3:
                    return a[r] === i.OPS.restore;
                }
                throw new Error(
                  "iterateImageMaskGroup - invalid pos: ".concat(o),
                );
              },
              function foundImageMaskGroup(t, r) {
                var a,
                  o = t.fnArray,
                  l = t.argsArray,
                  c = t.iCurr,
                  u = c - 3,
                  h = c - 2,
                  d = c - 1,
                  p = Math.floor((r - u) / 4);
                if (
                  (p = (function handlePaintSolidColorImageMask(t, r, a, o) {
                    for (var l = t + 2, c = 0; c < r; c++) {
                      var u = o[l + 4 * c],
                        h = 1 === u.length && u[0];
                      if (
                        !h ||
                        1 !== h.width ||
                        1 !== h.height ||
                        (h.data.length &&
                          (1 !== h.data.length || 0 !== h.data[0]))
                      )
                        break;
                      a[l + 4 * c] = i.OPS.paintSolidColorImageMask;
                    }
                    return r - c;
                  })(u, p, o, l)) < 10
                )
                  return r - ((r - u) % 4);
                var m,
                  g,
                  b = !1,
                  y = l[d][0];
                if (0 === l[h][1] && 0 === l[h][2]) {
                  b = !0;
                  var v = l[h][0],
                    S = l[h][3];
                  m = h + 4;
                  var k = d + 4;
                  for (a = 1; a < p; a++, m += 4, k += 4)
                    if (
                      ((g = l[m]),
                      l[k][0] !== y ||
                        g[0] !== v ||
                        0 !== g[1] ||
                        0 !== g[2] ||
                        g[3] !== S)
                    ) {
                      a < 10 ? (b = !1) : (p = a);
                      break;
                    }
                }
                if (b) {
                  p = Math.min(p, 1e3);
                  var w = new Float32Array(2 * p);
                  for (m = h, a = 0; a < p; a++, m += 4)
                    (g = l[m]), (w[a << 1] = g[4]), (w[1 + (a << 1)] = g[5]);
                  o.splice(u, 4 * p, i.OPS.paintImageMaskXObjectRepeat),
                    l.splice(u, 4 * p, [y, v, S, w]);
                } else {
                  p = Math.min(p, 100);
                  var C = [];
                  for (a = 0; a < p; a++) {
                    g = l[h + (a << 2)];
                    var x = l[d + (a << 2)][0];
                    C.push({
                      data: x.data,
                      width: x.width,
                      height: x.height,
                      transform: g,
                    });
                  }
                  o.splice(u, 4 * p, i.OPS.paintImageMaskXObjectGroup),
                    l.splice(u, 4 * p, [C]);
                }
                return u + 1;
              },
            ),
            addState(
              t,
              [
                i.OPS.save,
                i.OPS.transform,
                i.OPS.paintImageXObject,
                i.OPS.restore,
              ],
              function (t) {
                var r = t.argsArray,
                  a = t.iCurr - 2;
                return 0 === r[a][1] && 0 === r[a][2];
              },
              function iterateImageGroup(t, r) {
                var a = t.fnArray,
                  o = t.argsArray,
                  l = (r - (t.iCurr - 3)) % 4;
                switch (l) {
                  case 0:
                    return a[r] === i.OPS.save;
                  case 1:
                    if (a[r] !== i.OPS.transform) return !1;
                    var c = t.iCurr - 2,
                      u = o[c][0],
                      h = o[c][3];
                    return (
                      o[r][0] === u &&
                      0 === o[r][1] &&
                      0 === o[r][2] &&
                      o[r][3] === h
                    );
                  case 2:
                    if (a[r] !== i.OPS.paintImageXObject) return !1;
                    var d = o[t.iCurr - 1][0];
                    return o[r][0] === d;
                  case 3:
                    return a[r] === i.OPS.restore;
                }
                throw new Error("iterateImageGroup - invalid pos: ".concat(l));
              },
              function (t, r) {
                var a = t.fnArray,
                  o = t.argsArray,
                  l = t.iCurr,
                  c = l - 3,
                  u = l - 2,
                  h = o[l - 1][0],
                  d = o[u][0],
                  p = o[u][3],
                  m = Math.min(Math.floor((r - c) / 4), 1e3);
                if (m < 3) return r - ((r - c) % 4);
                for (
                  var g = new Float32Array(2 * m), b = u, y = 0;
                  y < m;
                  y++, b += 4
                ) {
                  var v = o[b];
                  (g[y << 1] = v[4]), (g[1 + (y << 1)] = v[5]);
                }
                var S = [h, d, p, g];
                return (
                  a.splice(c, 4 * m, i.OPS.paintImageXObjectRepeat),
                  o.splice(c, 4 * m, S),
                  c + 1
                );
              },
            ),
            addState(
              t,
              [
                i.OPS.beginText,
                i.OPS.setFont,
                i.OPS.setTextMatrix,
                i.OPS.showText,
                i.OPS.endText,
              ],
              null,
              function iterateShowTextGroup(t, r) {
                var a = t.fnArray,
                  o = t.argsArray,
                  l = (r - (t.iCurr - 4)) % 5;
                switch (l) {
                  case 0:
                    return a[r] === i.OPS.beginText;
                  case 1:
                    return a[r] === i.OPS.setFont;
                  case 2:
                    return a[r] === i.OPS.setTextMatrix;
                  case 3:
                    if (a[r] !== i.OPS.showText) return !1;
                    var c = t.iCurr - 3,
                      u = o[c][0],
                      h = o[c][1];
                    return o[r][0] === u && o[r][1] === h;
                  case 4:
                    return a[r] === i.OPS.endText;
                }
                throw new Error(
                  "iterateShowTextGroup - invalid pos: ".concat(l),
                );
              },
              function (t, r) {
                var a = t.fnArray,
                  i = t.argsArray,
                  o = t.iCurr,
                  l = o - 4,
                  c = o - 3,
                  u = o - 2,
                  h = o - 1,
                  d = o,
                  p = i[c][0],
                  m = i[c][1],
                  g = Math.min(Math.floor((r - l) / 5), 1e3);
                if (g < 3) return r - ((r - l) % 5);
                var b = l;
                l >= 4 &&
                  a[l - 4] === a[c] &&
                  a[l - 3] === a[u] &&
                  a[l - 2] === a[h] &&
                  a[l - 1] === a[d] &&
                  i[l - 4][0] === p &&
                  i[l - 4][1] === m &&
                  (g++, (b -= 5));
                for (var y = b + 4, v = 1; v < g; v++)
                  a.splice(y, 3), i.splice(y, 3), (y += 2);
                return y + 1;
              },
            ),
            (QueueOptimizer.prototype = {
              _optimize: function _optimize() {
                var r = this.queue.fnArray,
                  a = this.lastProcessed,
                  i = r.length,
                  o = this.state,
                  l = this.match;
                if (o || l || a + 1 !== i || t[r[a]]) {
                  for (var c = this.context; a < i; ) {
                    if (l) {
                      if ((0, l.iterateFn)(c, a)) {
                        a++;
                        continue;
                      }
                      if (
                        ((a = (0, l.processFn)(c, a + 1)),
                        (l = null),
                        (o = null),
                        a >= (i = r.length))
                      )
                        break;
                    }
                    (o = (o || t)[r[a]]) && !Array.isArray(o)
                      ? ((c.iCurr = a),
                        a++,
                        !o.checkFn || (0, o.checkFn)(c)
                          ? ((l = o), (o = null))
                          : (o = null))
                      : a++;
                  }
                  (this.state = o), (this.match = l), (this.lastProcessed = a);
                } else this.lastProcessed = i;
              },
              push: function push(t, r) {
                this.queue.fnArray.push(t),
                  this.queue.argsArray.push(r),
                  this._optimize();
              },
              flush: function flush() {
                for (; this.match; ) {
                  var t = this.queue.fnArray.length;
                  (this.lastProcessed = (0, this.match.processFn)(
                    this.context,
                    t,
                  )),
                    (this.match = null),
                    (this.state = null),
                    this._optimize();
                }
              },
              reset: function reset() {
                (this.state = null),
                  (this.match = null),
                  (this.lastProcessed = 0);
              },
            }),
            QueueOptimizer
          );
        })(),
        l = (function NullOptimizerClosure() {
          function NullOptimizer(t) {
            this.queue = t;
          }
          return (
            (NullOptimizer.prototype = {
              push: function push(t, r) {
                this.queue.fnArray.push(t), this.queue.argsArray.push(r);
              },
              flush: function flush() {},
              reset: function reset() {},
            }),
            NullOptimizer
          );
        })(),
        c = (function OperatorListClosure() {
          function OperatorList(t, r, a) {
            (this._streamSink = r),
              (this.fnArray = []),
              (this.argsArray = []),
              (this.optimizer =
                r && "oplist" !== t ? new o(this) : new l(this)),
              (this.dependencies = Object.create(null)),
              (this._totalLength = 0),
              (this.pageIndex = a),
              (this.intent = t),
              (this.weight = 0),
              (this._resolved = r ? null : Promise.resolve());
          }
          return (
            (OperatorList.prototype = {
              get length() {
                return this.argsArray.length;
              },
              get ready() {
                return this._resolved || this._streamSink.ready;
              },
              get totalLength() {
                return this._totalLength + this.length;
              },
              addOp: function addOp(t, r) {
                this.optimizer.push(t, r),
                  this.weight++,
                  this._streamSink &&
                    (this.weight >= 1e3 ||
                      (this.weight >= 995 &&
                        (t === i.OPS.restore || t === i.OPS.endText))) &&
                    this.flush();
              },
              addDependency: function addDependency(t) {
                t in this.dependencies ||
                  ((this.dependencies[t] = !0),
                  this.addOp(i.OPS.dependency, [t]));
              },
              addDependencies: function addDependencies(t) {
                for (var r in t) this.addDependency(r);
              },
              addOpList: function addOpList(t) {
                if (t instanceof OperatorList) {
                  Object.assign(this.dependencies, t.dependencies);
                  for (var r = 0, a = t.length; r < a; r++)
                    this.addOp(t.fnArray[r], t.argsArray[r]);
                } else
                  (0, i.warn)(
                    'addOpList - ignoring invalid "opList" parameter.',
                  );
              },
              getIR: function getIR() {
                return {
                  fnArray: this.fnArray,
                  argsArray: this.argsArray,
                  length: this.length,
                };
              },
              get _transfers() {
                for (
                  var t = [],
                    r = this.fnArray,
                    a = this.argsArray,
                    o = this.length,
                    l = 0;
                  l < o;
                  l++
                )
                  switch (r[l]) {
                    case i.OPS.paintInlineImageXObject:
                    case i.OPS.paintInlineImageXObjectGroup:
                    case i.OPS.paintImageMaskXObject:
                      var c = a[l][0];
                      c.cached || t.push(c.data.buffer);
                  }
                return t;
              },
              flush: function flush() {
                var t =
                  arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0];
                this.optimizer.flush();
                var r = this.length;
                (this._totalLength += r),
                  this._streamSink.enqueue(
                    {
                      fnArray: this.fnArray,
                      argsArray: this.argsArray,
                      lastChunk: t,
                      length: r,
                    },
                    1,
                    this._transfers,
                  ),
                  (this.dependencies = Object.create(null)),
                  (this.fnArray.length = 0),
                  (this.argsArray.length = 0),
                  (this.weight = 0),
                  this.optimizer.reset();
              },
            }),
            OperatorList
          );
        })();
      r.OperatorList = c;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.PartialEvaluator = void 0);
      var i = (function _interopRequireDefault(t) {
          return t && t.__esModule ? t : { default: t };
        })(a(2)),
        o = a(5),
        l = a(221),
        c = a(198),
        u = a(222),
        h = a(225),
        d = a(201),
        p = a(228),
        m = a(227),
        g = a(231),
        b = a(204),
        y = a(232),
        v = a(216),
        S = a(205),
        k = a(226),
        w = a(233),
        C = a(234),
        x = a(217),
        _ = a(236),
        A = a(219),
        R = a(237);
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createForOfIteratorHelper(t, r) {
        var a;
        if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
          if (
            Array.isArray(t) ||
            (a = (function _unsupportedIterableToArray(t, r) {
              if (!t) return;
              if ("string" == typeof t) return _arrayLikeToArray(t, r);
              var a = Object.prototype.toString.call(t).slice(8, -1);
              "Object" === a && t.constructor && (a = t.constructor.name);
              if ("Map" === a || "Set" === a) return Array.from(t);
              if (
                "Arguments" === a ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
              )
                return _arrayLikeToArray(t, r);
            })(t)) ||
            (r && t && "number" == typeof t.length)
          ) {
            a && (t = a);
            var i = 0,
              o = function F() {};
            return {
              s: o,
              n: function n() {
                return i >= t.length
                  ? { done: !0 }
                  : { done: !1, value: t[i++] };
              },
              e: function e(t) {
                throw t;
              },
              f: o,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var l,
          c = !0,
          u = !1;
        return {
          s: function s() {
            a = t[Symbol.iterator]();
          },
          n: function n() {
            var t = a.next();
            return (c = t.done), t;
          },
          e: function e(t) {
            (u = !0), (l = t);
          },
          f: function f() {
            try {
              c || null == a.return || a.return();
            } finally {
              if (u) throw l;
            }
          },
        };
      }
      function _arrayLikeToArray(t, r) {
        (null == r || r > t.length) && (r = t.length);
        for (var a = 0, i = new Array(r); a < r; a++) i[a] = t[a];
        return i;
      }
      function asyncGeneratorStep(t, r, a, i, o, l, c) {
        try {
          var u = t[l](c),
            h = u.value;
        } catch (t) {
          return void a(t);
        }
        u.done ? r(h) : Promise.resolve(h).then(i, o);
      }
      function _asyncToGenerator(t) {
        return function () {
          var r = this,
            a = arguments;
          return new Promise(function (i, o) {
            var l = t.apply(r, a);
            function _next(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "next", t);
            }
            function _throw(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "throw", t);
            }
            _next(void 0);
          });
        };
      }
      var T = (function PartialEvaluatorClosure() {
        var t = {
          maxImageSize: -1,
          disableFontFace: !1,
          ignoreErrors: !1,
          isEvalSupported: !0,
          fontExtraProperties: !1,
        };
        function PartialEvaluator(r) {
          var a = this,
            l = r.xref,
            c = r.handler,
            u = r.pageIndex,
            h = r.idFactory,
            d = r.fontCache,
            p = r.builtInCMapCache,
            m = r.globalImageCache,
            g = r.options,
            b = void 0 === g ? null : g,
            y = r.pdfFunctionFactory;
          (this.xref = l),
            (this.handler = c),
            (this.pageIndex = u),
            (this.idFactory = h),
            (this.fontCache = d),
            (this.builtInCMapCache = p),
            (this.globalImageCache = m),
            (this.options = b || t),
            (this.pdfFunctionFactory = y),
            (this.parsingType3Font = !1),
            (this.fetchBuiltInCMap = (function () {
              var t = _asyncToGenerator(
                i.default.mark(function _callee(t) {
                  var r, l, c;
                  return i.default.wrap(function _callee$(i) {
                    for (;;)
                      switch ((i.prev = i.next)) {
                        case 0:
                          if (!a.builtInCMapCache.has(t)) {
                            i.next = 2;
                            break;
                          }
                          return i.abrupt("return", a.builtInCMapCache.get(t));
                        case 2:
                          return (
                            (r = a.handler.sendWithStream("FetchBuiltInCMap", {
                              name: t,
                            })),
                            (l = r.getReader()),
                            (i.next = 6),
                            new Promise(function (t, r) {
                              !(function pump() {
                                l.read().then(function (r) {
                                  var a = r.value;
                                  r.done || (t(a), pump());
                                }, r);
                              })();
                            })
                          );
                        case 6:
                          return (
                            (c = i.sent).compressionType !==
                              o.CMapCompressionType.NONE &&
                              a.builtInCMapCache.set(t, c),
                            i.abrupt("return", c)
                          );
                        case 9:
                        case "end":
                          return i.stop();
                      }
                  }, _callee);
                }),
              );
              return function (r) {
                return t.apply(this, arguments);
              };
            })());
        }
        function TimeSlotManager() {
          this.reset();
        }
        function normalizeBlendMode(t) {
          var r =
            arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          if (Array.isArray(t)) {
            for (var a = 0, i = t.length; a < i; a++) {
              var l = normalizeBlendMode(t[a], !0);
              if (l) return l;
            }
            return (
              (0, o.warn)("Unsupported blend mode Array: ".concat(t)),
              "source-over"
            );
          }
          if (!(0, c.isName)(t)) return r ? null : "source-over";
          switch (t.name) {
            case "Normal":
            case "Compatible":
              return "source-over";
            case "Multiply":
              return "multiply";
            case "Screen":
              return "screen";
            case "Overlay":
              return "overlay";
            case "Darken":
              return "darken";
            case "Lighten":
              return "lighten";
            case "ColorDodge":
              return "color-dodge";
            case "ColorBurn":
              return "color-burn";
            case "HardLight":
              return "hard-light";
            case "SoftLight":
              return "soft-light";
            case "Difference":
              return "difference";
            case "Exclusion":
              return "exclusion";
            case "Hue":
              return "hue";
            case "Saturation":
              return "saturation";
            case "Color":
              return "color";
            case "Luminosity":
              return "luminosity";
          }
          return r
            ? null
            : ((0, o.warn)("Unsupported blend mode: ".concat(t.name)),
              "source-over");
        }
        TimeSlotManager.prototype = {
          check: function TimeSlotManager_check() {
            return (
              !(++this.checked < 100) &&
              ((this.checked = 0), this.endTime <= Date.now())
            );
          },
          reset: function TimeSlotManager_reset() {
            (this.endTime = Date.now() + 20), (this.checked = 0);
          },
        };
        var r = Promise.resolve();
        return (
          (PartialEvaluator.prototype = {
            clone: function clone() {
              var r =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : t,
                a = Object.create(this);
              return (a.options = r), a;
            },
            hasBlendModes: function PartialEvaluator_hasBlendModes(t) {
              if (!(t instanceof c.Dict)) return !1;
              var r = Object.create(null);
              t.objId && (r[t.objId] = !0);
              for (var a = [t], i = this.xref; a.length; ) {
                var l = a.shift(),
                  u = l.get("ExtGState");
                if (u instanceof c.Dict)
                  for (var h = u.getKeys(), p = 0, m = h.length; p < m; p++) {
                    var g = h[p],
                      b = u.getRaw(g);
                    if (b instanceof c.Ref) {
                      if (r[b.toString()]) continue;
                      try {
                        b = i.fetch(b);
                      } catch (t) {
                        if (t instanceof d.MissingDataException) throw t;
                        if (this.options.ignoreErrors) {
                          b instanceof c.Ref && (r[b.toString()] = !0),
                            this.handler.send("UnsupportedFeature", {
                              featureId: o.UNSUPPORTED_FEATURES.errorExtGState,
                            }),
                            (0, o.warn)(
                              'hasBlendModes - ignoring ExtGState: "'.concat(
                                t,
                                '".',
                              ),
                            );
                          continue;
                        }
                        throw t;
                      }
                    }
                    if (b instanceof c.Dict) {
                      b.objId && (r[b.objId] = !0);
                      var y = b.get("BM");
                      if (y instanceof c.Name) {
                        if ("Normal" !== y.name) return !0;
                      } else if (void 0 !== y && Array.isArray(y))
                        for (var v = 0, S = y.length; v < S; v++)
                          if (y[v] instanceof c.Name && "Normal" !== y[v].name)
                            return !0;
                    }
                  }
                var k = l.get("XObject");
                if (k instanceof c.Dict)
                  for (var w = k.getKeys(), C = 0, x = w.length; C < x; C++) {
                    var _ = w[C],
                      A = k.getRaw(_);
                    if (A instanceof c.Ref) {
                      if (r[A.toString()]) continue;
                      try {
                        A = i.fetch(A);
                      } catch (t) {
                        if (t instanceof d.MissingDataException) throw t;
                        if (this.options.ignoreErrors) {
                          A instanceof c.Ref && (r[A.toString()] = !0),
                            this.handler.send("UnsupportedFeature", {
                              featureId: o.UNSUPPORTED_FEATURES.errorXObject,
                            }),
                            (0, o.warn)(
                              'hasBlendModes - ignoring XObject: "'.concat(
                                t,
                                '".',
                              ),
                            );
                          continue;
                        }
                        throw t;
                      }
                    }
                    if ((0, c.isStream)(A)) {
                      if (A.dict.objId) {
                        if (r[A.dict.objId]) continue;
                        r[A.dict.objId] = !0;
                      }
                      var R = A.dict.get("Resources");
                      !(R instanceof c.Dict) ||
                        (R.objId && r[R.objId]) ||
                        (a.push(R), R.objId && (r[R.objId] = !0));
                    }
                  }
              }
              return !1;
            },
            buildFormXObject: function buildFormXObject(t, r, a, l, u, h) {
              var d = this;
              return _asyncToGenerator(
                i.default.mark(function _callee2() {
                  var p, m, g, b, y, S, k;
                  return i.default.wrap(function _callee2$(i) {
                    for (;;)
                      switch ((i.prev = i.next)) {
                        case 0:
                          if (
                            ((p = r.dict),
                            (m = p.getArray("Matrix")),
                            (g = p.getArray("BBox")),
                            (g =
                              Array.isArray(g) && 4 === g.length
                                ? o.Util.normalizeRect(g)
                                : null),
                            !(b = p.get("Group")))
                          ) {
                            i.next = 18;
                            break;
                          }
                          if (
                            ((y = {
                              matrix: m,
                              bbox: g,
                              smask: a,
                              isolated: !1,
                              knockout: !1,
                            }),
                            (S = b.get("S")),
                            (k = null),
                            !(0, c.isName)(S, "Transparency"))
                          ) {
                            i.next = 16;
                            break;
                          }
                          if (
                            ((y.isolated = b.get("I") || !1),
                            (y.knockout = b.get("K") || !1),
                            !b.has("CS"))
                          ) {
                            i.next = 16;
                            break;
                          }
                          return (
                            (i.next = 15),
                            d.parseColorSpace({ cs: b.get("CS"), resources: t })
                          );
                        case 15:
                          k = i.sent;
                        case 16:
                          a &&
                            a.backdrop &&
                            ((k = k || v.ColorSpace.singletons.rgb),
                            (a.backdrop = k.getRgb(a.backdrop, 0))),
                            l.addOp(o.OPS.beginGroup, [y]);
                        case 18:
                          return (
                            l.addOp(o.OPS.paintFormXObjectBegin, [m, g]),
                            i.abrupt(
                              "return",
                              d
                                .getOperatorList({
                                  stream: r,
                                  task: u,
                                  resources: p.get("Resources") || t,
                                  operatorList: l,
                                  initialState: h,
                                })
                                .then(function () {
                                  l.addOp(o.OPS.paintFormXObjectEnd, []),
                                    b && l.addOp(o.OPS.endGroup, [y]);
                                }),
                            )
                          );
                        case 20:
                        case "end":
                          return i.stop();
                      }
                  }, _callee2);
                }),
              )();
            },
            buildPaintImageXObject: function buildPaintImageXObject(t) {
              var r = this;
              return _asyncToGenerator(
                i.default.mark(function _callee3() {
                  var a,
                    l,
                    c,
                    u,
                    h,
                    d,
                    p,
                    m,
                    g,
                    b,
                    y,
                    v,
                    k,
                    w,
                    C,
                    x,
                    _,
                    A,
                    T,
                    I,
                    P,
                    O,
                    E,
                    B,
                    D;
                  return i.default.wrap(function _callee3$(i) {
                    for (;;)
                      switch ((i.prev = i.next)) {
                        case 0:
                          if (
                            ((a = t.resources),
                            (l = t.image),
                            (c = t.isInline),
                            (u = void 0 !== c && c),
                            (h = t.operatorList),
                            (d = t.cacheKey),
                            (p = t.localImageCache),
                            (m = l.dict),
                            (g = m.objId),
                            (b = m.get("Width", "W")),
                            (y = m.get("Height", "H")),
                            b && (0, o.isNum)(b) && y && (0, o.isNum)(y))
                          ) {
                            i.next = 8;
                            break;
                          }
                          return (
                            (0, o.warn)(
                              "Image dimensions are missing, or not numbers.",
                            ),
                            i.abrupt("return", void 0)
                          );
                        case 8:
                          if (
                            !(-1 !== (v = r.options.maxImageSize) && b * y > v)
                          ) {
                            i.next = 12;
                            break;
                          }
                          return (
                            (0, o.warn)(
                              "Image exceeded maximum allowed size and was removed.",
                            ),
                            i.abrupt("return", void 0)
                          );
                        case 12:
                          if (!(m.get("ImageMask", "IM") || !1)) {
                            i.next = 25;
                            break;
                          }
                          return (
                            (C = m.get("Width", "W")),
                            (x = m.get("Height", "H")),
                            (_ = (C + 7) >> 3),
                            (A = l.getBytes(_ * x, !0)),
                            (T = m.getArray("Decode", "D")),
                            ((k = R.PDFImage.createMask({
                              imgArray: A,
                              width: C,
                              height: x,
                              imageIsFromDecodeStream:
                                l instanceof S.DecodeStream,
                              inverseDecode: !!T && T[0] > 0,
                            })).cached = !!d),
                            (w = [k]),
                            h.addOp(o.OPS.paintImageMaskXObject, w),
                            d &&
                              p.set(d, g, {
                                fn: o.OPS.paintImageMaskXObject,
                                args: w,
                              }),
                            i.abrupt("return", void 0)
                          );
                        case 25:
                          if (
                            ((I = m.get("SMask", "SM") || !1),
                            (P = m.get("Mask") || !1),
                            200,
                            !u || I || P || !(b + y < 200))
                          ) {
                            i.next = 33;
                            break;
                          }
                          return (
                            (O = new R.PDFImage({
                              xref: r.xref,
                              res: a,
                              image: l,
                              isInline: u,
                              pdfFunctionFactory: r.pdfFunctionFactory,
                            })),
                            (k = O.createImageData(!0)),
                            h.addOp(o.OPS.paintInlineImageXObject, [k]),
                            i.abrupt("return", void 0)
                          );
                        case 33:
                          if (
                            ((E = "img_".concat(r.idFactory.createObjId())),
                            (B = !1),
                            r.parsingType3Font
                              ? (E = ""
                                  .concat(r.idFactory.getDocId(), "_type3res_")
                                  .concat(E))
                              : g &&
                                (B = r.globalImageCache.shouldCache(
                                  g,
                                  r.pageIndex,
                                )) &&
                                (E = ""
                                  .concat(r.idFactory.getDocId(), "_")
                                  .concat(E)),
                            h.addDependency(E),
                            (w = [E, b, y]),
                            (D = R.PDFImage.buildImage({
                              xref: r.xref,
                              res: a,
                              image: l,
                              isInline: u,
                              pdfFunctionFactory: r.pdfFunctionFactory,
                            })
                              .then(function (t) {
                                if (
                                  ((k = t.createImageData(!1)),
                                  r.parsingType3Font)
                                )
                                  return r.handler.sendWithPromise(
                                    "commonobj",
                                    [E, "FontType3Res", k],
                                    [k.data.buffer],
                                  );
                                B
                                  ? r.handler.send(
                                      "commonobj",
                                      [E, "Image", k],
                                      [k.data.buffer],
                                    )
                                  : r.handler.send(
                                      "obj",
                                      [E, r.pageIndex, "Image", k],
                                      [k.data.buffer],
                                    );
                              })
                              .catch(function (t) {
                                if (
                                  ((0, o.warn)("Unable to decode image: " + t),
                                  r.parsingType3Font)
                                )
                                  return r.handler.sendWithPromise(
                                    "commonobj",
                                    [E, "FontType3Res", null],
                                  );
                                B
                                  ? r.handler.send("commonobj", [
                                      E,
                                      "Image",
                                      null,
                                    ])
                                  : r.handler.send("obj", [
                                      E,
                                      r.pageIndex,
                                      "Image",
                                      null,
                                    ]);
                              })),
                            !r.parsingType3Font)
                          ) {
                            i.next = 41;
                            break;
                          }
                          return (i.next = 41), D;
                        case 41:
                          return (
                            h.addOp(o.OPS.paintImageXObject, w),
                            d &&
                              (p.set(d, g, {
                                fn: o.OPS.paintImageXObject,
                                args: w,
                              }),
                              g &&
                                ((0, o.assert)(
                                  !u,
                                  "Cannot cache an inline image globally.",
                                ),
                                r.globalImageCache.addPageIndex(g, r.pageIndex),
                                B &&
                                  r.globalImageCache.setData(g, {
                                    objId: E,
                                    fn: o.OPS.paintImageXObject,
                                    args: w,
                                  }))),
                            i.abrupt("return", void 0)
                          );
                        case 44:
                        case "end":
                          return i.stop();
                      }
                  }, _callee3);
                }),
              )();
            },
            handleSMask: function PartialEvaluator_handleSmask(t, r, a, i, o) {
              var l = t.get("G"),
                c = { subtype: t.get("S").name, backdrop: t.get("BC") },
                u = t.get("TR");
              if ((0, C.isPDFFunction)(u)) {
                for (
                  var h = this.pdfFunctionFactory.create(u),
                    d = new Uint8Array(256),
                    p = new Float32Array(1),
                    m = 0;
                  m < 256;
                  m++
                )
                  (p[0] = m / 255), h(p, 0, p, 0), (d[m] = (255 * p[0]) | 0);
                c.transferMap = d;
              }
              return this.buildFormXObject(r, l, c, a, i, o.state.clone());
            },
            handleTilingType: function handleTilingType(t, r, a, i, l, u, h) {
              var d = this,
                p = new A.OperatorList(),
                m = [l.get("Resources"), a],
                b = c.Dict.merge(this.xref, m);
              return this.getOperatorList({
                stream: i,
                task: h,
                resources: b,
                operatorList: p,
              })
                .then(function () {
                  return (0, g.getTilingPatternIR)(
                    { fnArray: p.fnArray, argsArray: p.argsArray },
                    l,
                    r,
                  );
                })
                .then(
                  function (r) {
                    u.addDependencies(p.dependencies), u.addOp(t, r);
                  },
                  function (t) {
                    if (!(t instanceof o.AbortException)) {
                      if (d.options.ignoreErrors)
                        return (
                          d.handler.send("UnsupportedFeature", {
                            featureId:
                              o.UNSUPPORTED_FEATURES.errorTilingPattern,
                          }),
                          void (0, o.warn)(
                            'handleTilingType - ignoring pattern: "'.concat(
                              t,
                              '".',
                            ),
                          )
                        );
                      throw t;
                    }
                  },
                );
            },
            handleSetFont: function PartialEvaluator_handleSetFont(
              t,
              r,
              a,
              i,
              l,
              c,
            ) {
              var h,
                d = this;
              return (
                r && (h = (r = r.slice())[0].name),
                this.loadFont(h, a, t)
                  .then(function (r) {
                    return r.font.isType3Font
                      ? r
                          .loadType3Data(d, t, i, l)
                          .then(function () {
                            return r;
                          })
                          .catch(function (t) {
                            return (
                              d.handler.send("UnsupportedFeature", {
                                featureId:
                                  o.UNSUPPORTED_FEATURES.errorFontLoadType3,
                              }),
                              new I({
                                loadedName: "g_font_error",
                                font: new u.ErrorFont(
                                  "Type3 font load error: ".concat(t),
                                ),
                                dict: r.font,
                                extraProperties: d.options.fontExtraProperties,
                              })
                            );
                          })
                      : r;
                  })
                  .then(function (t) {
                    return (c.font = t.font), t.send(d.handler), t.loadedName;
                  })
              );
            },
            handleText: function handleText(t, r) {
              var a = r.font,
                i = a.charsToGlyphs(t);
              a.data &&
                (!!(
                  r.textRenderingMode & o.TextRenderingMode.ADD_TO_PATH_FLAG
                ) ||
                  "Pattern" === r.fillColorSpace.name ||
                  a.disableFontFace ||
                  this.options.disableFontFace) &&
                PartialEvaluator.buildFontPaths(a, i, this.handler);
              return i;
            },
            ensureStateFont: function ensureStateFont(t) {
              if (!t.font) {
                var r = new o.FormatError(
                  "Missing setFont (Tf) operator before text rendering operator.",
                );
                if (this.options.ignoreErrors)
                  return (
                    this.handler.send("UnsupportedFeature", {
                      featureId: o.UNSUPPORTED_FEATURES.errorFontState,
                    }),
                    void (0, o.warn)('ensureStateFont: "'.concat(r, '".'))
                  );
                throw r;
              }
            },
            setGState: function PartialEvaluator_setGState(t, r, a, i, l) {
              for (
                var u = this,
                  h = [],
                  d = r.getKeys(),
                  p = Promise.resolve(),
                  m = function _loop() {
                    var m = d[g],
                      b = r.get(m);
                    switch (m) {
                      case "Type":
                        break;
                      case "LW":
                      case "LC":
                      case "LJ":
                      case "ML":
                      case "D":
                      case "RI":
                      case "FL":
                      case "CA":
                      case "ca":
                        h.push([m, b]);
                        break;
                      case "Font":
                        p = p.then(function () {
                          return u
                            .handleSetFont(t, null, b[0], a, i, l.state)
                            .then(function (t) {
                              a.addDependency(t), h.push([m, [t, b[1]]]);
                            });
                        });
                        break;
                      case "BM":
                        h.push([m, normalizeBlendMode(b)]);
                        break;
                      case "SMask":
                        if ((0, c.isName)(b, "None")) {
                          h.push([m, !1]);
                          break;
                        }
                        (0, c.isDict)(b)
                          ? ((p = p.then(function () {
                              return u.handleSMask(b, t, a, i, l);
                            })),
                            h.push([m, !0]))
                          : (0, o.warn)("Unsupported SMask type");
                        break;
                      case "OP":
                      case "op":
                      case "OPM":
                      case "BG":
                      case "BG2":
                      case "UCR":
                      case "UCR2":
                      case "TR":
                      case "TR2":
                      case "HT":
                      case "SM":
                      case "SA":
                      case "AIS":
                      case "TK":
                        (0, o.info)("graphic state operator " + m);
                        break;
                      default:
                        (0, o.info)("Unknown graphic state operator " + m);
                    }
                  },
                  g = 0,
                  b = d.length;
                g < b;
                g++
              )
                m();
              return p.then(function () {
                h.length > 0 && a.addOp(o.OPS.setGState, [h]);
              });
            },
            loadFont: function PartialEvaluator_loadFont(t, r, a) {
              var i,
                l = this,
                h = function errorFont() {
                  return Promise.resolve(
                    new I({
                      loadedName: "g_font_error",
                      font: new u.ErrorFont(
                        'Font "'.concat(t, '" is not available.'),
                      ),
                      dict: r,
                      extraProperties: l.options.fontExtraProperties,
                    }),
                  );
                },
                d = this.xref;
              if (r) {
                if (!(0, c.isRef)(r))
                  throw new o.FormatError(
                    'The "font" object should be a reference.',
                  );
                i = r;
              } else {
                var p = a.get("Font");
                p && (i = p.getRaw(t));
              }
              if (!i) {
                var m = 'Font "'.concat(
                  t || (r && r.toString()),
                  '" is not available',
                );
                if (!this.options.ignoreErrors && !this.parsingType3Font)
                  return (0, o.warn)("".concat(m, ".")), h();
                this.handler.send("UnsupportedFeature", {
                  featureId: o.UNSUPPORTED_FEATURES.errorFontMissing,
                }),
                  (0, o.warn)(
                    "".concat(
                      m,
                      " -- attempting to fallback to a default font.",
                    ),
                  ),
                  (i = PartialEvaluator.getFallbackFontDict());
              }
              if (this.fontCache.has(i)) return this.fontCache.get(i);
              if (((r = d.fetchIfRef(i)), !(0, c.isDict)(r))) return h();
              if (r.translated) return r.translated;
              var g,
                b,
                y = (0, o.createPromiseCapability)(),
                v = this.preEvaluateFont(r),
                S = v.descriptor,
                k = v.hash,
                w = (0, c.isRef)(i);
              if ((w && (g = i.toString()), k && (0, c.isDict)(S))) {
                S.fontAliases || (S.fontAliases = Object.create(null));
                var C = S.fontAliases;
                if (C[k]) {
                  var x = C[k].aliasRef;
                  if (w && x && this.fontCache.has(x))
                    return this.fontCache.putAlias(i, x), this.fontCache.get(i);
                } else C[k] = { fontID: u.Font.getFontID() };
                w && (C[k].aliasRef = i), (g = C[k].fontID);
              }
              w
                ? this.fontCache.put(i, y.promise)
                : (g || (g = this.idFactory.createObjId()),
                  this.fontCache.put("id_".concat(g), y.promise)),
                (0, o.assert)(g, 'The "fontID" must be defined.'),
                (r.loadedName = ""
                  .concat(this.idFactory.getDocId(), "_f")
                  .concat(g)),
                (r.translated = y.promise);
              try {
                b = this.translateFont(v);
              } catch (t) {
                b = Promise.reject(t);
              }
              return (
                b
                  .then(function (t) {
                    void 0 !== t.fontType &&
                      (d.stats.fontTypes[t.fontType] = !0);
                    y.resolve(
                      new I({
                        loadedName: r.loadedName,
                        font: t,
                        dict: r,
                        extraProperties: l.options.fontExtraProperties,
                      }),
                    );
                  })
                  .catch(function (t) {
                    l.handler.send("UnsupportedFeature", {
                      featureId: o.UNSUPPORTED_FEATURES.errorFontTranslate,
                    });
                    try {
                      var a = S && S.get("FontFile3"),
                        i = a && a.get("Subtype"),
                        c = (0, u.getFontType)(v.type, i && i.name);
                      d.stats.fontTypes[c] = !0;
                    } catch (t) {}
                    y.resolve(
                      new I({
                        loadedName: r.loadedName,
                        font: new u.ErrorFont(
                          t instanceof Error ? t.message : t,
                        ),
                        dict: r,
                        extraProperties: l.options.fontExtraProperties,
                      }),
                    );
                  }),
                y.promise
              );
            },
            buildPath: function buildPath(t, r, a) {
              var i =
                  arguments.length > 3 &&
                  void 0 !== arguments[3] &&
                  arguments[3],
                l = t.length - 1;
              if (
                (a || (a = []), l < 0 || t.fnArray[l] !== o.OPS.constructPath)
              )
                i &&
                  ((0, o.warn)(
                    'Encountered path operator "'.concat(
                      r,
                      '" inside of a text object.',
                    ),
                  ),
                  t.addOp(o.OPS.save, null)),
                  t.addOp(o.OPS.constructPath, [[r], a]),
                  i && t.addOp(o.OPS.restore, null);
              else {
                var c = t.argsArray[l];
                c[0].push(r), Array.prototype.push.apply(c[1], a);
              }
            },
            parseColorSpace: function parseColorSpace(t) {
              var r = this,
                a = t.cs,
                i = t.resources;
              return new Promise(function (t) {
                t(v.ColorSpace.parse(a, r.xref, i, r.pdfFunctionFactory));
              }).catch(function (t) {
                if (t instanceof o.AbortException) return null;
                if (r.options.ignoreErrors)
                  return (
                    r.handler.send("UnsupportedFeature", {
                      featureId: o.UNSUPPORTED_FEATURES.errorColorSpace,
                    }),
                    (0, o.warn)(
                      'parseColorSpace - ignoring ColorSpace: "'.concat(
                        t,
                        '".',
                      ),
                    ),
                    null
                  );
                throw t;
              });
            },
            handleColorN: function handleColorN(t, r, a, l, u, h, d) {
              var p = this;
              return _asyncToGenerator(
                i.default.mark(function _callee4() {
                  var m, b, y, v, S, k, w;
                  return i.default.wrap(function _callee4$(i) {
                    for (;;)
                      switch ((i.prev = i.next)) {
                        case 0:
                          if (
                            ((m = a[a.length - 1]),
                            !(0, c.isName)(m) || !(b = u.get(m.name)))
                          ) {
                            i.next = 16;
                            break;
                          }
                          if (
                            ((y = (0, c.isStream)(b) ? b.dict : b),
                            1 !== (v = y.get("PatternType")))
                          ) {
                            i.next = 9;
                            break;
                          }
                          return (
                            (S = l.base ? l.base.getRgb(a, 0) : null),
                            i.abrupt(
                              "return",
                              p.handleTilingType(r, S, h, b, y, t, d),
                            )
                          );
                        case 9:
                          if (2 !== v) {
                            i.next = 15;
                            break;
                          }
                          return (
                            (k = y.get("Shading")),
                            (w = y.getArray("Matrix")),
                            (b = g.Pattern.parseShading(
                              k,
                              w,
                              p.xref,
                              h,
                              p.handler,
                              p.pdfFunctionFactory,
                            )),
                            t.addOp(r, b.getIR()),
                            i.abrupt("return", void 0)
                          );
                        case 15:
                          throw new o.FormatError(
                            "Unknown PatternType: ".concat(v),
                          );
                        case 16:
                          throw new o.FormatError(
                            "Unknown PatternName: ".concat(m),
                          );
                        case 17:
                        case "end":
                          return i.stop();
                      }
                  }, _callee4);
                }),
              )();
            },
            getOperatorList: function getOperatorList(t) {
              var a = this,
                i = t.stream,
                l = t.task,
                u = t.resources,
                h = t.operatorList,
                d = t.initialState,
                p = void 0 === d ? null : d;
              if (((u = u || c.Dict.empty), (p = p || new E()), !h))
                throw new Error(
                  'getOperatorList: missing "operatorList" parameter',
                );
              var m = this,
                b = this.xref,
                y = !1,
                S = new x.LocalImageCache(),
                k = u.get("XObject") || c.Dict.empty,
                w = u.get("Pattern") || c.Dict.empty,
                C = new P(p),
                _ = new B(i, b, C),
                A = new TimeSlotManager();
              function closePendingRestoreOPS(t) {
                for (var r = 0, a = _.savedStatesDepth; r < a; r++)
                  h.addOp(o.OPS.restore, []);
              }
              return new Promise(function promiseBody(t, a) {
                var i = function next(r) {
                  Promise.all([r, h.ready]).then(function () {
                    try {
                      promiseBody(t, a);
                    } catch (t) {
                      a(t);
                    }
                  }, a);
                };
                l.ensureNotTerminated(), A.reset();
                for (
                  var d, p, x, R, T = {};
                  !(d = A.check()) && ((T.args = null), _.read(T));

                ) {
                  var I = T.args,
                    P = T.fn;
                  switch (0 | P) {
                    case o.OPS.paintXObject:
                      var O = I[0].name;
                      if (O) {
                        var E = S.getByName(O);
                        if (E) {
                          h.addOp(E.fn, E.args), (I = null);
                          continue;
                        }
                      }
                      return void i(
                        new Promise(function (t, r) {
                          if (!O)
                            throw new o.FormatError(
                              "XObject must be referred to by name.",
                            );
                          var a = k.getRaw(O);
                          if (a instanceof c.Ref) {
                            var i = S.getByRef(a);
                            if (i) return h.addOp(i.fn, i.args), void t();
                            var d = m.globalImageCache.getData(a, m.pageIndex);
                            if (d)
                              return (
                                h.addDependency(d.objId),
                                h.addOp(d.fn, d.args),
                                void t()
                              );
                            a = b.fetch(a);
                          }
                          if (!a) return h.addOp(P, I), void t();
                          if (!(0, c.isStream)(a))
                            throw new o.FormatError(
                              "XObject should be a stream",
                            );
                          var p = a.dict.get("Subtype");
                          if (!(0, c.isName)(p))
                            throw new o.FormatError(
                              "XObject should have a Name subtype",
                            );
                          if ("Form" === p.name)
                            return (
                              C.save(),
                              void m
                                .buildFormXObject(
                                  u,
                                  a,
                                  null,
                                  h,
                                  l,
                                  C.state.clone(),
                                )
                                .then(function () {
                                  C.restore(), t();
                                }, r)
                            );
                          if ("Image" !== p.name) {
                            if ("PS" !== p.name)
                              throw new o.FormatError(
                                "Unhandled XObject subtype ".concat(p.name),
                              );
                            (0, o.info)("Ignored XObject subtype PS"), t();
                          } else
                            m.buildPaintImageXObject({
                              resources: u,
                              image: a,
                              operatorList: h,
                              cacheKey: O,
                              localImageCache: S,
                            }).then(t, r);
                        }).catch(function (t) {
                          if (!(t instanceof o.AbortException)) {
                            if (m.options.ignoreErrors)
                              return (
                                m.handler.send("UnsupportedFeature", {
                                  featureId:
                                    o.UNSUPPORTED_FEATURES.errorXObject,
                                }),
                                void (0, o.warn)(
                                  'getOperatorList - ignoring XObject: "'.concat(
                                    t,
                                    '".',
                                  ),
                                )
                              );
                            throw t;
                          }
                        }),
                      );
                    case o.OPS.setFont:
                      var B = I[1];
                      return void i(
                        m
                          .handleSetFont(u, I, null, h, l, C.state)
                          .then(function (t) {
                            h.addDependency(t), h.addOp(o.OPS.setFont, [t, B]);
                          }),
                      );
                    case o.OPS.beginText:
                      y = !0;
                      break;
                    case o.OPS.endText:
                      y = !1;
                      break;
                    case o.OPS.endInlineImage:
                      var D = I[0].cacheKey;
                      if (D) {
                        var M = S.getByName(D);
                        if (M) {
                          h.addOp(M.fn, M.args), (I = null);
                          continue;
                        }
                      }
                      return void i(
                        m.buildPaintImageXObject({
                          resources: u,
                          image: I[0],
                          isInline: !0,
                          operatorList: h,
                          cacheKey: D,
                          localImageCache: S,
                        }),
                      );
                    case o.OPS.showText:
                      if (!C.state.font) {
                        m.ensureStateFont(C.state);
                        continue;
                      }
                      I[0] = m.handleText(I[0], C.state);
                      break;
                    case o.OPS.showSpacedText:
                      if (!C.state.font) {
                        m.ensureStateFont(C.state);
                        continue;
                      }
                      var L = I[0],
                        N = [],
                        U = L.length,
                        j = C.state;
                      for (p = 0; p < U; ++p) {
                        var q = L[p];
                        (0, o.isString)(q)
                          ? Array.prototype.push.apply(N, m.handleText(q, j))
                          : (0, o.isNum)(q) && N.push(q);
                      }
                      (I[0] = N), (P = o.OPS.showText);
                      break;
                    case o.OPS.nextLineShowText:
                      if (!C.state.font) {
                        m.ensureStateFont(C.state);
                        continue;
                      }
                      h.addOp(o.OPS.nextLine),
                        (I[0] = m.handleText(I[0], C.state)),
                        (P = o.OPS.showText);
                      break;
                    case o.OPS.nextLineSetSpacingShowText:
                      if (!C.state.font) {
                        m.ensureStateFont(C.state);
                        continue;
                      }
                      h.addOp(o.OPS.nextLine),
                        h.addOp(o.OPS.setWordSpacing, [I.shift()]),
                        h.addOp(o.OPS.setCharSpacing, [I.shift()]),
                        (I[0] = m.handleText(I[0], C.state)),
                        (P = o.OPS.showText);
                      break;
                    case o.OPS.setTextRenderingMode:
                      C.state.textRenderingMode = I[0];
                      break;
                    case o.OPS.setFillColorSpace:
                      return void i(
                        m
                          .parseColorSpace({ cs: I[0], resources: u })
                          .then(function (t) {
                            t && (C.state.fillColorSpace = t);
                          }),
                      );
                    case o.OPS.setStrokeColorSpace:
                      return void i(
                        m
                          .parseColorSpace({ cs: I[0], resources: u })
                          .then(function (t) {
                            t && (C.state.strokeColorSpace = t);
                          }),
                      );
                    case o.OPS.setFillColor:
                      (R = C.state.fillColorSpace),
                        (I = R.getRgb(I, 0)),
                        (P = o.OPS.setFillRGBColor);
                      break;
                    case o.OPS.setStrokeColor:
                      (R = C.state.strokeColorSpace),
                        (I = R.getRgb(I, 0)),
                        (P = o.OPS.setStrokeRGBColor);
                      break;
                    case o.OPS.setFillGray:
                      (C.state.fillColorSpace = v.ColorSpace.singletons.gray),
                        (I = v.ColorSpace.singletons.gray.getRgb(I, 0)),
                        (P = o.OPS.setFillRGBColor);
                      break;
                    case o.OPS.setStrokeGray:
                      (C.state.strokeColorSpace = v.ColorSpace.singletons.gray),
                        (I = v.ColorSpace.singletons.gray.getRgb(I, 0)),
                        (P = o.OPS.setStrokeRGBColor);
                      break;
                    case o.OPS.setFillCMYKColor:
                      (C.state.fillColorSpace = v.ColorSpace.singletons.cmyk),
                        (I = v.ColorSpace.singletons.cmyk.getRgb(I, 0)),
                        (P = o.OPS.setFillRGBColor);
                      break;
                    case o.OPS.setStrokeCMYKColor:
                      (C.state.strokeColorSpace = v.ColorSpace.singletons.cmyk),
                        (I = v.ColorSpace.singletons.cmyk.getRgb(I, 0)),
                        (P = o.OPS.setStrokeRGBColor);
                      break;
                    case o.OPS.setFillRGBColor:
                      (C.state.fillColorSpace = v.ColorSpace.singletons.rgb),
                        (I = v.ColorSpace.singletons.rgb.getRgb(I, 0));
                      break;
                    case o.OPS.setStrokeRGBColor:
                      (C.state.strokeColorSpace = v.ColorSpace.singletons.rgb),
                        (I = v.ColorSpace.singletons.rgb.getRgb(I, 0));
                      break;
                    case o.OPS.setFillColorN:
                      if ("Pattern" === (R = C.state.fillColorSpace).name)
                        return void i(
                          m.handleColorN(h, o.OPS.setFillColorN, I, R, w, u, l),
                        );
                      (I = R.getRgb(I, 0)), (P = o.OPS.setFillRGBColor);
                      break;
                    case o.OPS.setStrokeColorN:
                      if ("Pattern" === (R = C.state.strokeColorSpace).name)
                        return void i(
                          m.handleColorN(
                            h,
                            o.OPS.setStrokeColorN,
                            I,
                            R,
                            w,
                            u,
                            l,
                          ),
                        );
                      (I = R.getRgb(I, 0)), (P = o.OPS.setStrokeRGBColor);
                      break;
                    case o.OPS.shadingFill:
                      var W = u.get("Shading");
                      if (!W)
                        throw new o.FormatError("No shading resource found");
                      var z = W.get(I[0].name);
                      if (!z)
                        throw new o.FormatError("No shading object found");
                      var G = g.Pattern.parseShading(
                        z,
                        null,
                        b,
                        u,
                        m.handler,
                        m.pdfFunctionFactory,
                      ).getIR();
                      (I = [G]), (P = o.OPS.shadingFill);
                      break;
                    case o.OPS.setGState:
                      var H = I[0],
                        X = u.get("ExtGState");
                      if (!(0, c.isDict)(X) || !X.has(H.name)) break;
                      var V = X.get(H.name);
                      return void i(m.setGState(u, V, h, l, C));
                    case o.OPS.moveTo:
                    case o.OPS.lineTo:
                    case o.OPS.curveTo:
                    case o.OPS.curveTo2:
                    case o.OPS.curveTo3:
                    case o.OPS.closePath:
                    case o.OPS.rectangle:
                      m.buildPath(h, P, I, y);
                      continue;
                    case o.OPS.markPoint:
                    case o.OPS.markPointProps:
                    case o.OPS.beginMarkedContent:
                    case o.OPS.beginMarkedContentProps:
                    case o.OPS.endMarkedContent:
                    case o.OPS.beginCompat:
                    case o.OPS.endCompat:
                      continue;
                    default:
                      if (null !== I) {
                        for (
                          p = 0, x = I.length;
                          p < x && !(I[p] instanceof c.Dict);
                          p++
                        );
                        if (p < x) {
                          (0, o.warn)(
                            "getOperatorList - ignoring operator: " + P,
                          );
                          continue;
                        }
                      }
                  }
                  h.addOp(P, I);
                }
                d ? i(r) : (closePendingRestoreOPS(), t());
              }).catch(function (t) {
                if (!(t instanceof o.AbortException)) {
                  if (a.options.ignoreErrors)
                    return (
                      a.handler.send("UnsupportedFeature", {
                        featureId: o.UNSUPPORTED_FEATURES.errorOperatorList,
                      }),
                      (0, o.warn)(
                        'getOperatorList - ignoring errors during "'.concat(
                          l.name,
                          '" ',
                        ) + 'task: "'.concat(t, '".'),
                      ),
                      void closePendingRestoreOPS()
                    );
                  throw t;
                }
              });
            },
            getTextContent: function getTextContent(t) {
              var a = this,
                i = t.stream,
                l = t.task,
                u = t.resources,
                h = t.stateManager,
                d = void 0 === h ? null : h,
                m = t.normalizeWhitespace,
                g = void 0 !== m && m,
                b = t.combineTextItems,
                v = void 0 !== b && b,
                S = t.sink,
                k = t.seenStyles,
                w = void 0 === k ? Object.create(null) : k;
              (u = u || c.Dict.empty), (d = d || new P(new O()));
              var C,
                _ = /\s/g,
                A = { items: [], styles: Object.create(null) },
                R = {
                  initialized: !1,
                  str: [],
                  width: 0,
                  height: 0,
                  vertical: !1,
                  lastAdvanceWidth: 0,
                  lastAdvanceHeight: 0,
                  textAdvanceScale: 0,
                  spaceWidth: 0,
                  fakeSpaceMin: 1 / 0,
                  fakeMultiSpaceMin: 1 / 0,
                  fakeMultiSpaceMax: -0,
                  textRunBreakAllowed: !1,
                  transform: null,
                  fontName: null,
                },
                T = this,
                I = this.xref,
                E = null,
                D = new x.LocalImageCache(),
                M = new B(i, I, d);
              function ensureTextContentItem() {
                if (R.initialized) return R;
                var t = C.font;
                t.loadedName in w ||
                  ((w[t.loadedName] = !0),
                  (A.styles[t.loadedName] = {
                    fontFamily: t.fallbackName,
                    ascent: t.ascent,
                    descent: t.descent,
                    vertical: t.vertical,
                  })),
                  (R.fontName = t.loadedName);
                var r = [
                  C.fontSize * C.textHScale,
                  0,
                  0,
                  C.fontSize,
                  0,
                  C.textRise,
                ];
                if (
                  t.isType3Font &&
                  C.fontSize <= 1 &&
                  !(0, o.isArrayEqual)(C.fontMatrix, o.FONT_IDENTITY_MATRIX)
                ) {
                  var a = t.bbox[3] - t.bbox[1];
                  a > 0 && (r[3] *= a * C.fontMatrix[3]);
                }
                var i = o.Util.transform(
                  C.ctm,
                  o.Util.transform(C.textMatrix, r),
                );
                (R.transform = i),
                  t.vertical
                    ? ((R.width = Math.sqrt(i[0] * i[0] + i[1] * i[1])),
                      (R.height = 0),
                      (R.vertical = !0))
                    : ((R.width = 0),
                      (R.height = Math.sqrt(i[2] * i[2] + i[3] * i[3])),
                      (R.vertical = !1));
                var l = C.textLineMatrix[0],
                  c = C.textLineMatrix[1],
                  u = Math.sqrt(l * l + c * c);
                (l = C.ctm[0]), (c = C.ctm[1]);
                var h = Math.sqrt(l * l + c * c);
                (R.textAdvanceScale = h * u),
                  (R.lastAdvanceWidth = 0),
                  (R.lastAdvanceHeight = 0);
                var d = (t.spaceWidth / 1e3) * C.fontSize;
                return (
                  d
                    ? ((R.spaceWidth = d),
                      (R.fakeSpaceMin = 0.3 * d),
                      (R.fakeMultiSpaceMin = 1.5 * d),
                      (R.fakeMultiSpaceMax = 4 * d),
                      (R.textRunBreakAllowed = !t.isMonospace))
                    : ((R.spaceWidth = 0),
                      (R.fakeSpaceMin = 1 / 0),
                      (R.fakeMultiSpaceMin = 1 / 0),
                      (R.fakeMultiSpaceMax = 0),
                      (R.textRunBreakAllowed = !1)),
                  (R.initialized = !0),
                  R
                );
              }
              function replaceWhitespace(t) {
                for (
                  var r, a = 0, i = t.length;
                  a < i && (r = t.charCodeAt(a)) >= 32 && r <= 127;

                )
                  a++;
                return a < i ? t.replace(_, " ") : t;
              }
              function handleSetFont(t, r) {
                return T.loadFont(t, r, u).then(function (t) {
                  (C.font = t.font),
                    (C.fontMatrix =
                      t.font.fontMatrix || o.FONT_IDENTITY_MATRIX);
                });
              }
              function buildTextContentItem(t) {
                for (
                  var r = C.font,
                    a = ensureTextContentItem(),
                    i = 0,
                    o = 0,
                    l = r.charsToGlyphs(t),
                    c = 0;
                  c < l.length;
                  c++
                ) {
                  var u = l[c],
                    h = null;
                  h = r.vertical && u.vmetric ? u.vmetric[0] : u.width;
                  var d = u.unicode,
                    m = (0, p.getNormalizedUnicodes)();
                  void 0 !== m[d] && (d = m[d]), (d = (0, p.reverseIfRtl)(d));
                  var g = C.charSpacing;
                  if (u.isSpace) {
                    var b = C.wordSpacing;
                    (g += b), b > 0 && addFakeSpaces(b, a.str);
                  }
                  var y = 0,
                    v = 0;
                  if (r.vertical) o += v = h * C.fontMatrix[0] * C.fontSize + g;
                  else
                    i += y =
                      (h * C.fontMatrix[0] * C.fontSize + g) * C.textHScale;
                  C.translateTextMatrix(y, v), a.str.push(d);
                }
                return (
                  r.vertical
                    ? ((a.lastAdvanceHeight = o), (a.height += Math.abs(o)))
                    : ((a.lastAdvanceWidth = i), (a.width += i)),
                  a
                );
              }
              function addFakeSpaces(t, r) {
                if (!(t < R.fakeSpaceMin))
                  if (t < R.fakeMultiSpaceMin) r.push(" ");
                  else
                    for (var a = Math.round(t / R.spaceWidth); a-- > 0; )
                      r.push(" ");
              }
              function flushTextContentItem() {
                R.initialized &&
                  (R.vertical
                    ? (R.height *= R.textAdvanceScale)
                    : (R.width *= R.textAdvanceScale),
                  A.items.push(
                    (function runBidiTransform(t) {
                      var r = t.str.join(""),
                        a = (0, y.bidi)(r, -1, t.vertical);
                      return {
                        str: g ? replaceWhitespace(a.str) : a.str,
                        dir: a.dir,
                        width: t.width,
                        height: t.height,
                        transform: t.transform,
                        fontName: t.fontName,
                      };
                    })(R),
                  ),
                  (R.initialized = !1),
                  (R.str.length = 0));
              }
              function enqueueChunk() {
                var t = A.items.length;
                t > 0 &&
                  (S.enqueue(A, t),
                  (A.items = []),
                  (A.styles = Object.create(null)));
              }
              var L = new TimeSlotManager();
              return new Promise(function promiseBody(t, a) {
                var i = function next(r) {
                  enqueueChunk(),
                    Promise.all([r, S.ready]).then(function () {
                      try {
                        promiseBody(t, a);
                      } catch (t) {
                        a(t);
                      }
                    }, a);
                };
                l.ensureNotTerminated(), L.reset();
                for (
                  var h, p = {}, m = [];
                  !(h = L.check()) && ((m.length = 0), (p.args = m), M.read(p));

                ) {
                  C = d.state;
                  var b,
                    y = p.fn;
                  switch (((m = p.args), 0 | y)) {
                    case o.OPS.setFont:
                      var k = m[0].name,
                        x = m[1];
                      if (C.font && k === C.fontName && x === C.fontSize) break;
                      return (
                        flushTextContentItem(),
                        (C.fontName = k),
                        (C.fontSize = x),
                        void i(handleSetFont(k, null))
                      );
                    case o.OPS.setTextRise:
                      flushTextContentItem(), (C.textRise = m[0]);
                      break;
                    case o.OPS.setHScale:
                      flushTextContentItem(), (C.textHScale = m[0] / 100);
                      break;
                    case o.OPS.setLeading:
                      flushTextContentItem(), (C.leading = m[0]);
                      break;
                    case o.OPS.moveText:
                      var _ = !!C.font && 0 === (C.font.vertical ? m[0] : m[1]);
                      if (
                        ((b = m[0] - m[1]),
                        v &&
                          _ &&
                          R.initialized &&
                          b > 0 &&
                          b <= R.fakeMultiSpaceMax)
                      ) {
                        C.translateTextLineMatrix(m[0], m[1]),
                          (R.width += m[0] - R.lastAdvanceWidth),
                          (R.height += m[1] - R.lastAdvanceHeight),
                          addFakeSpaces(
                            m[0] -
                              R.lastAdvanceWidth -
                              (m[1] - R.lastAdvanceHeight),
                            R.str,
                          );
                        break;
                      }
                      flushTextContentItem(),
                        C.translateTextLineMatrix(m[0], m[1]),
                        (C.textMatrix = C.textLineMatrix.slice());
                      break;
                    case o.OPS.setLeadingMoveText:
                      flushTextContentItem(),
                        (C.leading = -m[1]),
                        C.translateTextLineMatrix(m[0], m[1]),
                        (C.textMatrix = C.textLineMatrix.slice());
                      break;
                    case o.OPS.nextLine:
                      flushTextContentItem(), C.carriageReturn();
                      break;
                    case o.OPS.setTextMatrix:
                      if (
                        ((b = C.calcTextLineMatrixAdvance(
                          m[0],
                          m[1],
                          m[2],
                          m[3],
                          m[4],
                          m[5],
                        )),
                        v &&
                          null !== b &&
                          R.initialized &&
                          b.value > 0 &&
                          b.value <= R.fakeMultiSpaceMax)
                      ) {
                        C.translateTextLineMatrix(b.width, b.height),
                          (R.width += b.width - R.lastAdvanceWidth),
                          (R.height += b.height - R.lastAdvanceHeight),
                          addFakeSpaces(
                            b.width -
                              R.lastAdvanceWidth -
                              (b.height - R.lastAdvanceHeight),
                            R.str,
                          );
                        break;
                      }
                      flushTextContentItem(),
                        C.setTextMatrix(m[0], m[1], m[2], m[3], m[4], m[5]),
                        C.setTextLineMatrix(m[0], m[1], m[2], m[3], m[4], m[5]);
                      break;
                    case o.OPS.setCharSpacing:
                      C.charSpacing = m[0];
                      break;
                    case o.OPS.setWordSpacing:
                      C.wordSpacing = m[0];
                      break;
                    case o.OPS.beginText:
                      flushTextContentItem(),
                        (C.textMatrix = o.IDENTITY_MATRIX.slice()),
                        (C.textLineMatrix = o.IDENTITY_MATRIX.slice());
                      break;
                    case o.OPS.showSpacedText:
                      if (!d.state.font) {
                        T.ensureStateFont(d.state);
                        continue;
                      }
                      for (var O, B = m[0], N = 0, U = B.length; N < U; N++)
                        if ("string" == typeof B[N]) buildTextContentItem(B[N]);
                        else if ((0, o.isNum)(B[N])) {
                          ensureTextContentItem(),
                            (b = (B[N] * C.fontSize) / 1e3);
                          var j = !1;
                          C.font.vertical
                            ? ((O = b),
                              C.translateTextMatrix(0, O),
                              (j =
                                R.textRunBreakAllowed &&
                                b > R.fakeMultiSpaceMax) || (R.height += O))
                            : ((O = (b = -b) * C.textHScale),
                              C.translateTextMatrix(O, 0),
                              (j =
                                R.textRunBreakAllowed &&
                                b > R.fakeMultiSpaceMax) || (R.width += O)),
                            j
                              ? flushTextContentItem()
                              : b > 0 && addFakeSpaces(b, R.str);
                        }
                      break;
                    case o.OPS.showText:
                      if (!d.state.font) {
                        T.ensureStateFont(d.state);
                        continue;
                      }
                      buildTextContentItem(m[0]);
                      break;
                    case o.OPS.nextLineShowText:
                      if (!d.state.font) {
                        T.ensureStateFont(d.state);
                        continue;
                      }
                      flushTextContentItem(),
                        C.carriageReturn(),
                        buildTextContentItem(m[0]);
                      break;
                    case o.OPS.nextLineSetSpacingShowText:
                      if (!d.state.font) {
                        T.ensureStateFont(d.state);
                        continue;
                      }
                      flushTextContentItem(),
                        (C.wordSpacing = m[0]),
                        (C.charSpacing = m[1]),
                        C.carriageReturn(),
                        buildTextContentItem(m[2]);
                      break;
                    case o.OPS.paintXObject:
                      flushTextContentItem(),
                        E || (E = u.get("XObject") || c.Dict.empty);
                      var q = m[0].name;
                      if (q && D.getByName(q)) break;
                      return void i(
                        new Promise(function (t, r) {
                          if (!q)
                            throw new o.FormatError(
                              "XObject must be referred to by name.",
                            );
                          var a = E.getRaw(q);
                          if (a instanceof c.Ref) {
                            if (D.getByRef(a)) return void t();
                            a = I.fetch(a);
                          }
                          if (a) {
                            if (!(0, c.isStream)(a))
                              throw new o.FormatError(
                                "XObject should be a stream",
                              );
                            var i = a.dict.get("Subtype");
                            if (!(0, c.isName)(i))
                              throw new o.FormatError(
                                "XObject should have a Name subtype",
                              );
                            if ("Form" !== i.name)
                              return D.set(q, a.dict.objId, !0), void t();
                            var h = d.state.clone(),
                              p = new P(h),
                              m = a.dict.getArray("Matrix");
                            Array.isArray(m) &&
                              6 === m.length &&
                              p.transform(m),
                              enqueueChunk();
                            var b = {
                              enqueueInvoked: !1,
                              enqueue: function enqueue(t, r) {
                                (this.enqueueInvoked = !0), S.enqueue(t, r);
                              },
                              get desiredSize() {
                                return S.desiredSize;
                              },
                              get ready() {
                                return S.ready;
                              },
                            };
                            T.getTextContent({
                              stream: a,
                              task: l,
                              resources: a.dict.get("Resources") || u,
                              stateManager: p,
                              normalizeWhitespace: g,
                              combineTextItems: v,
                              sink: b,
                              seenStyles: w,
                            }).then(function () {
                              b.enqueueInvoked || D.set(q, a.dict.objId, !0),
                                t();
                            }, r);
                          } else t();
                        }).catch(function (t) {
                          if (!(t instanceof o.AbortException)) {
                            if (!T.options.ignoreErrors) throw t;
                            (0, o.warn)(
                              'getTextContent - ignoring XObject: "'.concat(
                                t,
                                '".',
                              ),
                            );
                          }
                        }),
                      );
                    case o.OPS.setGState:
                      flushTextContentItem();
                      var W = m[0],
                        z = u.get("ExtGState");
                      if (!(0, c.isDict)(z) || !(0, c.isName)(W)) break;
                      var G = z.get(W.name);
                      if (!(0, c.isDict)(G)) break;
                      var H = G.get("Font");
                      if (H)
                        return (
                          (C.fontName = null),
                          (C.fontSize = H[1]),
                          void i(handleSetFont(null, H[0]))
                        );
                  }
                  if (A.items.length >= S.desiredSize) {
                    h = !0;
                    break;
                  }
                }
                h ? i(r) : (flushTextContentItem(), enqueueChunk(), t());
              }).catch(function (t) {
                if (!(t instanceof o.AbortException)) {
                  if (a.options.ignoreErrors)
                    return (
                      (0, o.warn)(
                        'getTextContent - ignoring errors during "'.concat(
                          l.name,
                          '" ',
                        ) + 'task: "'.concat(t, '".'),
                      ),
                      flushTextContentItem(),
                      void enqueueChunk()
                    );
                  throw t;
                }
              });
            },
            extractDataStructures:
              function PartialEvaluator_extractDataStructures(t, r, a) {
                var i,
                  l = this,
                  d = this.xref,
                  p = t.get("ToUnicode") || r.get("ToUnicode"),
                  m = p ? this.readToUnicode(p) : Promise.resolve(void 0);
                if (a.composite) {
                  var g = t.get("CIDSystemInfo");
                  (0, c.isDict)(g) &&
                    (a.cidSystemInfo = {
                      registry: (0, o.stringToPDFString)(g.get("Registry")),
                      ordering: (0, o.stringToPDFString)(g.get("Ordering")),
                      supplement: g.get("Supplement"),
                    });
                  var b = t.get("CIDToGIDMap");
                  (0, c.isStream)(b) && (i = b.getBytes());
                }
                var y,
                  v = [],
                  S = null;
                if (t.has("Encoding")) {
                  if (((y = t.get("Encoding")), (0, c.isDict)(y))) {
                    if (
                      ((S = y.get("BaseEncoding")),
                      (S = (0, c.isName)(S) ? S.name : null),
                      y.has("Differences"))
                    )
                      for (
                        var k = y.get("Differences"),
                          w = 0,
                          C = 0,
                          x = k.length;
                        C < x;
                        C++
                      ) {
                        var _ = d.fetchIfRef(k[C]);
                        if ((0, o.isNum)(_)) w = _;
                        else {
                          if (!(0, c.isName)(_))
                            throw new o.FormatError(
                              "Invalid entry in 'Differences' array: ".concat(
                                _,
                              ),
                            );
                          v[w++] = _.name;
                        }
                      }
                  } else {
                    if (!(0, c.isName)(y))
                      throw new o.FormatError(
                        "Encoding is not a Name nor a Dict",
                      );
                    S = y.name;
                  }
                  "MacRomanEncoding" !== S &&
                    "MacExpertEncoding" !== S &&
                    "WinAnsiEncoding" !== S &&
                    (S = null);
                }
                if (S) a.defaultEncoding = (0, h.getEncoding)(S).slice();
                else {
                  var A = !!(a.flags & u.FontFlags.Symbolic),
                    R = !!(a.flags & u.FontFlags.Nonsymbolic);
                  (y = h.StandardEncoding),
                    "TrueType" !== a.type || R || (y = h.WinAnsiEncoding),
                    A &&
                      ((y = h.MacRomanEncoding),
                      a.file ||
                        (/Symbol/i.test(a.name)
                          ? (y = h.SymbolSetEncoding)
                          : /Dingbats|Wingdings/i.test(a.name) &&
                            (y = h.ZapfDingbatsEncoding))),
                    (a.defaultEncoding = y);
                }
                return (
                  (a.differences = v),
                  (a.baseEncodingName = S),
                  (a.hasEncoding = !!S || v.length > 0),
                  (a.dict = t),
                  m
                    .then(function (t) {
                      return (a.toUnicode = t), l.buildToUnicode(a);
                    })
                    .then(function (t) {
                      return (
                        (a.toUnicode = t),
                        i && (a.cidToGidMap = l.readCidToGidMap(i, t)),
                        a
                      );
                    })
                );
              },
            _buildSimpleFontToUnicode: function _buildSimpleFontToUnicode(t) {
              var r =
                arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              (0, o.assert)(!t.composite, "Must be a simple font.");
              var a = [],
                i = t.defaultEncoding.slice(),
                l = t.baseEncodingName,
                c = t.differences;
              for (var d in c) {
                var m = c[d];
                ".notdef" !== m && (i[d] = m);
              }
              var g = (0, k.getGlyphsUnicode)();
              for (var b in i) {
                var y = i[b];
                if ("" !== y)
                  if (void 0 !== g[y]) a[b] = String.fromCharCode(g[y]);
                  else {
                    var v = 0;
                    switch (y[0]) {
                      case "G":
                        3 === y.length && (v = parseInt(y.substring(1), 16));
                        break;
                      case "g":
                        5 === y.length && (v = parseInt(y.substring(1), 16));
                        break;
                      case "C":
                      case "c":
                        if (y.length >= 3 && y.length <= 4) {
                          var S = y.substring(1);
                          if (r) {
                            v = parseInt(S, 16);
                            break;
                          }
                          if (
                            ((v = +S),
                            Number.isNaN(v) &&
                              Number.isInteger(parseInt(S, 16)))
                          )
                            return this._buildSimpleFontToUnicode(t, !0);
                        }
                        break;
                      default:
                        var w = (0, p.getUnicodeForGlyph)(y, g);
                        -1 !== w && (v = w);
                    }
                    if (v > 0 && v <= 1114111 && Number.isInteger(v)) {
                      if (l && v === +b) {
                        var C = (0, h.getEncoding)(l);
                        if (C && (y = C[b])) {
                          a[b] = String.fromCharCode(g[y]);
                          continue;
                        }
                      }
                      a[b] = String.fromCodePoint(v);
                    }
                  }
              }
              return new u.ToUnicodeMap(a);
            },
            buildToUnicode: function buildToUnicode(t) {
              if (
                ((t.hasIncludedToUnicodeMap =
                  !!t.toUnicode && t.toUnicode.length > 0),
                t.hasIncludedToUnicodeMap)
              )
                return (
                  !t.composite &&
                    t.hasEncoding &&
                    (t.fallbackToUnicode = this._buildSimpleFontToUnicode(t)),
                  Promise.resolve(t.toUnicode)
                );
              if (!t.composite)
                return Promise.resolve(this._buildSimpleFontToUnicode(t));
              if (
                t.composite &&
                ((t.cMap.builtInCMap && !(t.cMap instanceof l.IdentityCMap)) ||
                  ("Adobe" === t.cidSystemInfo.registry &&
                    ("GB1" === t.cidSystemInfo.ordering ||
                      "CNS1" === t.cidSystemInfo.ordering ||
                      "Japan1" === t.cidSystemInfo.ordering ||
                      "Korea1" === t.cidSystemInfo.ordering)))
              ) {
                var r = t.cidSystemInfo.registry,
                  a = t.cidSystemInfo.ordering,
                  i = c.Name.get(r + "-" + a + "-UCS2");
                return l.CMapFactory.create({
                  encoding: i,
                  fetchBuiltInCMap: this.fetchBuiltInCMap,
                  useCMap: null,
                }).then(function (r) {
                  var a = t.cMap,
                    i = [];
                  return (
                    a.forEach(function (t, a) {
                      if (a > 65535)
                        throw new o.FormatError("Max size of CID is 65,535");
                      var l = r.lookup(a);
                      l &&
                        (i[t] = String.fromCharCode(
                          (l.charCodeAt(0) << 8) + l.charCodeAt(1),
                        ));
                    }),
                    new u.ToUnicodeMap(i)
                  );
                });
              }
              return Promise.resolve(
                new u.IdentityToUnicodeMap(t.firstChar, t.lastChar),
              );
            },
            readToUnicode: function PartialEvaluator_readToUnicode(t) {
              var r = this,
                a = t;
              return (0, c.isName)(a)
                ? l.CMapFactory.create({
                    encoding: a,
                    fetchBuiltInCMap: this.fetchBuiltInCMap,
                    useCMap: null,
                  }).then(function (t) {
                    return t instanceof l.IdentityCMap
                      ? new u.IdentityToUnicodeMap(0, 65535)
                      : new u.ToUnicodeMap(t.getMap());
                  })
                : (0, c.isStream)(a)
                ? l.CMapFactory.create({
                    encoding: a,
                    fetchBuiltInCMap: this.fetchBuiltInCMap,
                    useCMap: null,
                  }).then(
                    function (t) {
                      if (t instanceof l.IdentityCMap)
                        return new u.IdentityToUnicodeMap(0, 65535);
                      var r = new Array(t.length);
                      return (
                        t.forEach(function (t, a) {
                          for (var i = [], o = 0; o < a.length; o += 2) {
                            var l =
                              (a.charCodeAt(o) << 8) | a.charCodeAt(o + 1);
                            if (55296 == (63488 & l)) {
                              o += 2;
                              var c =
                                (a.charCodeAt(o) << 8) | a.charCodeAt(o + 1);
                              i.push(((1023 & l) << 10) + (1023 & c) + 65536);
                            } else i.push(l);
                          }
                          r[t] = String.fromCodePoint.apply(String, i);
                        }),
                        new u.ToUnicodeMap(r)
                      );
                    },
                    function (t) {
                      if (t instanceof o.AbortException) return null;
                      if (r.options.ignoreErrors)
                        return (
                          r.handler.send("UnsupportedFeature", {
                            featureId:
                              o.UNSUPPORTED_FEATURES.errorFontToUnicode,
                          }),
                          (0, o.warn)(
                            'readToUnicode - ignoring ToUnicode data: "'.concat(
                              t,
                              '".',
                            ),
                          ),
                          null
                        );
                      throw t;
                    },
                  )
                : Promise.resolve(null);
            },
            readCidToGidMap: function readCidToGidMap(t, r) {
              for (var a = [], i = 0, o = t.length; i < o; i++) {
                var l = (t[i++] << 8) | t[i],
                  c = i >> 1;
                (0 !== l || r.has(c)) && (a[c] = l);
              }
              return a;
            },
            extractWidths: function PartialEvaluator_extractWidths(t, r, a) {
              var i,
                o,
                l,
                h,
                d,
                p,
                m,
                g,
                b = this.xref,
                y = [],
                v = 0,
                S = [];
              if (a.composite) {
                if (((v = t.has("DW") ? t.get("DW") : 1e3), (g = t.get("W"))))
                  for (o = 0, l = g.length; o < l; o++)
                    if (
                      ((p = b.fetchIfRef(g[o++])),
                      (m = b.fetchIfRef(g[o])),
                      Array.isArray(m))
                    )
                      for (h = 0, d = m.length; h < d; h++)
                        y[p++] = b.fetchIfRef(m[h]);
                    else {
                      var k = b.fetchIfRef(g[++o]);
                      for (h = p; h <= m; h++) y[h] = k;
                    }
                if (a.vertical) {
                  var w = t.getArray("DW2") || [880, -1e3];
                  if (((i = [w[1], 0.5 * v, w[0]]), (w = t.get("W2"))))
                    for (o = 0, l = w.length; o < l; o++)
                      if (
                        ((p = b.fetchIfRef(w[o++])),
                        (m = b.fetchIfRef(w[o])),
                        Array.isArray(m))
                      )
                        for (h = 0, d = m.length; h < d; h++)
                          S[p++] = [
                            b.fetchIfRef(m[h++]),
                            b.fetchIfRef(m[h++]),
                            b.fetchIfRef(m[h]),
                          ];
                      else {
                        var C = [
                          b.fetchIfRef(w[++o]),
                          b.fetchIfRef(w[++o]),
                          b.fetchIfRef(w[++o]),
                        ];
                        for (h = p; h <= m; h++) S[h] = C;
                      }
                }
              } else {
                var x = a.firstChar;
                if ((g = t.get("Widths"))) {
                  for (h = x, o = 0, l = g.length; o < l; o++)
                    y[h++] = b.fetchIfRef(g[o]);
                  v = parseFloat(r.get("MissingWidth")) || 0;
                } else {
                  var _ = t.get("BaseFont");
                  if ((0, c.isName)(_)) {
                    var A = this.getBaseFontMetrics(_.name);
                    (y = this.buildCharCodeToWidth(A.widths, a)),
                      (v = A.defaultWidth);
                  }
                }
              }
              var R = !0,
                T = v;
              for (var I in y) {
                var P = y[I];
                if (P)
                  if (T) {
                    if (T !== P) {
                      R = !1;
                      break;
                    }
                  } else T = P;
              }
              R && (a.flags |= u.FontFlags.FixedPitch),
                (a.defaultWidth = v),
                (a.widths = y),
                (a.defaultVMetrics = i),
                (a.vmetrics = S);
            },
            isSerifFont: function PartialEvaluator_isSerifFont(t) {
              var r = t.split("-")[0];
              return r in (0, m.getSerifFonts)() || -1 !== r.search(/serif/gi);
            },
            getBaseFontMetrics: function PartialEvaluator_getBaseFontMetrics(
              t,
            ) {
              var r = 0,
                a = [],
                i = !1,
                l = (0, m.getStdFontMap)()[t] || t,
                c = (0, w.getMetrics)();
              l in c || (l = this.isSerifFont(t) ? "Times-Roman" : "Helvetica");
              var u = c[l];
              return (
                (0, o.isNum)(u) ? ((r = u), (i = !0)) : (a = u()),
                { defaultWidth: r, monospace: i, widths: a }
              );
            },
            buildCharCodeToWidth:
              function PartialEvaluator_bulildCharCodeToWidth(t, r) {
                for (
                  var a = Object.create(null),
                    i = r.differences,
                    o = r.defaultEncoding,
                    l = 0;
                  l < 256;
                  l++
                )
                  l in i && t[i[l]]
                    ? (a[l] = t[i[l]])
                    : l in o && t[o[l]] && (a[l] = t[o[l]]);
                return a;
              },
            preEvaluateFont: function PartialEvaluator_preEvaluateFont(t) {
              var r = t,
                a = t.get("Subtype");
              if (!(0, c.isName)(a))
                throw new o.FormatError("invalid font Subtype");
              var i,
                l = !1;
              if ("Type0" === a.name) {
                var u = t.get("DescendantFonts");
                if (!u)
                  throw new o.FormatError("Descendant fonts are not specified");
                if (
                  ((a = (t = Array.isArray(u)
                    ? this.xref.fetchIfRef(u[0])
                    : u).get("Subtype")),
                  !(0, c.isName)(a))
                )
                  throw new o.FormatError("invalid font Subtype");
                l = !0;
              }
              var h = t.get("FontDescriptor");
              if (h) {
                var d = new _.MurmurHash3_64(),
                  p = r.getRaw("Encoding");
                if ((0, c.isName)(p)) d.update(p.name);
                else if ((0, c.isRef)(p)) d.update(p.toString());
                else if ((0, c.isDict)(p))
                  for (var m = p.getKeys(), g = 0, b = m.length; g < b; g++) {
                    var y = p.getRaw(m[g]);
                    if ((0, c.isName)(y)) d.update(y.name);
                    else if ((0, c.isRef)(y)) d.update(y.toString());
                    else if (Array.isArray(y)) {
                      for (
                        var v = y.length, S = new Array(v), k = 0;
                        k < v;
                        k++
                      ) {
                        var w = y[k];
                        (0, c.isName)(w)
                          ? (S[k] = w.name)
                          : ((0, o.isNum)(w) || (0, c.isRef)(w)) &&
                            (S[k] = w.toString());
                      }
                      d.update(S.join());
                    }
                  }
                var C = t.get("FirstChar") || 0,
                  x = t.get("LastChar") || (l ? 65535 : 255);
                d.update("".concat(C, "-").concat(x));
                var A = t.get("ToUnicode") || r.get("ToUnicode");
                if ((0, c.isStream)(A)) {
                  var R = A.str || A;
                  (i = R.buffer
                    ? new Uint8Array(R.buffer.buffer, 0, R.bufferLength)
                    : new Uint8Array(R.bytes.buffer, R.start, R.end - R.start)),
                    d.update(i);
                } else (0, c.isName)(A) && d.update(A.name);
                var T = t.get("Widths") || r.get("Widths");
                T &&
                  ((i = new Uint8Array(new Uint32Array(T).buffer)),
                  d.update(i));
              }
              return {
                descriptor: h,
                dict: t,
                baseDict: r,
                composite: l,
                type: a.name,
                hash: d ? d.hexdigest() : "",
              };
            },
            translateFont: function PartialEvaluator_translateFont(t) {
              var r,
                a = this,
                i = t.baseDict,
                h = t.dict,
                d = t.composite,
                p = t.descriptor,
                g = t.type,
                b = d ? 65535 : 255,
                y = h.get("FirstChar") || 0,
                v = h.get("LastChar") || b;
              if (!p) {
                if ("Type3" !== g) {
                  var S = h.get("BaseFont");
                  if (!(0, c.isName)(S))
                    throw new o.FormatError("Base font is not specified");
                  S = S.name.replace(/[,_]/g, "-");
                  var k = this.getBaseFontMetrics(S),
                    w = S.split("-")[0],
                    C =
                      (this.isSerifFont(w) ? u.FontFlags.Serif : 0) |
                      (k.monospace ? u.FontFlags.FixedPitch : 0) |
                      ((0, m.getSymbolsFonts)()[w]
                        ? u.FontFlags.Symbolic
                        : u.FontFlags.Nonsymbolic);
                  r = {
                    type: g,
                    name: S,
                    widths: k.widths,
                    defaultWidth: k.defaultWidth,
                    flags: C,
                    firstChar: y,
                    lastChar: v,
                  };
                  var x = h.get("Widths");
                  return this.extractDataStructures(h, h, r).then(function (t) {
                    if (x) {
                      for (var r = [], i = y, o = 0, l = x.length; o < l; o++)
                        r[i++] = a.xref.fetchIfRef(x[o]);
                      t.widths = r;
                    } else t.widths = a.buildCharCodeToWidth(k.widths, t);
                    return new u.Font(S, null, t);
                  });
                }
                (p = new c.Dict(null)).set("FontName", c.Name.get(g)),
                  p.set("FontBBox", h.getArray("FontBBox") || [0, 0, 0, 0]);
              }
              var _ = p.get("FontName"),
                A = h.get("BaseFont");
              if (
                ((0, o.isString)(_) && (_ = c.Name.get(_)),
                (0, o.isString)(A) && (A = c.Name.get(A)),
                "Type3" !== g)
              ) {
                var R = _ && _.name,
                  T = A && A.name;
                R !== T &&
                  ((0, o.info)(
                    "The FontDescriptor's FontName is \"".concat(R, '" but ') +
                      "should be the same as the Font's BaseFont \"".concat(
                        T,
                        '".',
                      ),
                  ),
                  R && T && T.startsWith(R) && (_ = A));
              }
              if (((_ = _ || A), !(0, c.isName)(_)))
                throw new o.FormatError("invalid font name");
              var I,
                P = p.get("FontFile", "FontFile2", "FontFile3");
              if (P && P.dict) {
                var O = P.dict.get("Subtype");
                O && (O = O.name);
                var E = P.dict.get("Length1"),
                  B = P.dict.get("Length2"),
                  D = P.dict.get("Length3");
              }
              if (
                ((r = {
                  type: g,
                  name: _.name,
                  subtype: O,
                  file: P,
                  length1: E,
                  length2: B,
                  length3: D,
                  loadedName: i.loadedName,
                  composite: d,
                  fixedPitch: !1,
                  fontMatrix:
                    h.getArray("FontMatrix") || o.FONT_IDENTITY_MATRIX,
                  firstChar: y || 0,
                  lastChar: v || b,
                  bbox: p.getArray("FontBBox"),
                  ascent: p.get("Ascent"),
                  descent: p.get("Descent"),
                  xHeight: p.get("XHeight"),
                  capHeight: p.get("CapHeight"),
                  flags: p.get("Flags"),
                  italicAngle: p.get("ItalicAngle"),
                  isType3Font: !1,
                }),
                d)
              ) {
                var M = i.get("Encoding");
                (0, c.isName)(M) && (r.cidEncoding = M.name),
                  (I = l.CMapFactory.create({
                    encoding: M,
                    fetchBuiltInCMap: this.fetchBuiltInCMap,
                    useCMap: null,
                  }).then(function (t) {
                    (r.cMap = t), (r.vertical = r.cMap.vertical);
                  }));
              } else I = Promise.resolve(void 0);
              return I.then(function () {
                return a.extractDataStructures(h, i, r);
              }).then(function (t) {
                return (
                  a.extractWidths(h, p, t),
                  "Type3" === g && (t.isType3Font = !0),
                  new u.Font(_.name, P, t)
                );
              });
            },
          }),
          (PartialEvaluator.buildFontPaths = function (t, r, a) {
            function buildPath(r) {
              t.renderer.hasBuiltPath(r) ||
                a.send("commonobj", [
                  "".concat(t.loadedName, "_path_").concat(r),
                  "FontPath",
                  t.renderer.getPathJs(r),
                ]);
            }
            var i,
              o = _createForOfIteratorHelper(r);
            try {
              for (o.s(); !(i = o.n()).done; ) {
                var l = i.value;
                buildPath(l.fontChar);
                var c = l.accent;
                c && c.fontChar && buildPath(c.fontChar);
              }
            } catch (t) {
              o.e(t);
            } finally {
              o.f();
            }
          }),
          (PartialEvaluator.getFallbackFontDict = function () {
            if (this._fallbackFontDict) return this._fallbackFontDict;
            var t = new c.Dict();
            return (
              t.set("BaseFont", c.Name.get("PDFJS-FallbackFont")),
              t.set("Type", c.Name.get("FallbackType")),
              t.set("Subtype", c.Name.get("FallbackType")),
              t.set("Encoding", c.Name.get("WinAnsiEncoding")),
              (this._fallbackFontDict = t)
            );
          }),
          PartialEvaluator
        );
      })();
      r.PartialEvaluator = T;
      var I = (function () {
          function TranslatedFont(t) {
            var r = t.loadedName,
              a = t.font,
              i = t.dict,
              o = t.extraProperties,
              l = void 0 !== o && o;
            !(function _classCallCheck(t, r) {
              if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function");
            })(this, TranslatedFont),
              (this.loadedName = r),
              (this.font = a),
              (this.dict = i),
              (this._extraProperties = l),
              (this.type3Loaded = null),
              (this.sent = !1);
          }
          return (
            (function _createClass(t, r, a) {
              return (
                r && _defineProperties(t.prototype, r),
                a && _defineProperties(t, a),
                t
              );
            })(TranslatedFont, [
              {
                key: "send",
                value: function send(t) {
                  this.sent ||
                    ((this.sent = !0),
                    t.send("commonobj", [
                      this.loadedName,
                      "Font",
                      this.font.exportData(this._extraProperties),
                    ]));
                },
              },
              {
                key: "fallback",
                value: function fallback(t) {
                  if (this.font.data) {
                    this.font.disableFontFace = !0;
                    var r = this.font.glyphCacheValues;
                    T.buildFontPaths(this.font, r, t);
                  }
                },
              },
              {
                key: "loadType3Data",
                value: function loadType3Data(t, r, a, i) {
                  if (!this.font.isType3Font)
                    throw new Error("Must be a Type3 font.");
                  if (this.type3Loaded) return this.type3Loaded;
                  var l = Object.create(t.options);
                  l.ignoreErrors = !1;
                  var c = t.clone(l);
                  c.parsingType3Font = !0;
                  for (
                    var u = this.font,
                      h = Promise.resolve(),
                      d = this.dict.get("CharProcs"),
                      p = this.dict.get("Resources") || r,
                      m = d.getKeys(),
                      g = Object.create(null),
                      b = function _loop2() {
                        var t = m[y];
                        h = h.then(function () {
                          var r = d.get(t),
                            l = new A.OperatorList();
                          return c
                            .getOperatorList({
                              stream: r,
                              task: i,
                              resources: p,
                              operatorList: l,
                            })
                            .then(function () {
                              (g[t] = l.getIR()),
                                a.addDependencies(l.dependencies);
                            })
                            .catch(function (r) {
                              (0, o.warn)(
                                'Type3 font resource "'.concat(
                                  t,
                                  '" is not available.',
                                ),
                              );
                              var a = new A.OperatorList();
                              g[t] = a.getIR();
                            });
                        });
                      },
                      y = 0,
                      v = m.length;
                    y < v;
                    ++y
                  )
                    b();
                  return (
                    (this.type3Loaded = h.then(function () {
                      u.charProcOperatorList = g;
                    })),
                    this.type3Loaded
                  );
                },
              },
            ]),
            TranslatedFont
          );
        })(),
        P = (function StateManagerClosure() {
          function StateManager(t) {
            (this.state = t), (this.stateStack = []);
          }
          return (
            (StateManager.prototype = {
              save: function save() {
                var t = this.state;
                this.stateStack.push(this.state), (this.state = t.clone());
              },
              restore: function restore() {
                var t = this.stateStack.pop();
                t && (this.state = t);
              },
              transform: function transform(t) {
                this.state.ctm = o.Util.transform(this.state.ctm, t);
              },
            }),
            StateManager
          );
        })(),
        O = (function TextStateClosure() {
          function TextState() {
            (this.ctm = new Float32Array(o.IDENTITY_MATRIX)),
              (this.fontName = null),
              (this.fontSize = 0),
              (this.font = null),
              (this.fontMatrix = o.FONT_IDENTITY_MATRIX),
              (this.textMatrix = o.IDENTITY_MATRIX.slice()),
              (this.textLineMatrix = o.IDENTITY_MATRIX.slice()),
              (this.charSpacing = 0),
              (this.wordSpacing = 0),
              (this.leading = 0),
              (this.textHScale = 1),
              (this.textRise = 0);
          }
          return (
            (TextState.prototype = {
              setTextMatrix: function TextState_setTextMatrix(
                t,
                r,
                a,
                i,
                o,
                l,
              ) {
                var c = this.textMatrix;
                (c[0] = t),
                  (c[1] = r),
                  (c[2] = a),
                  (c[3] = i),
                  (c[4] = o),
                  (c[5] = l);
              },
              setTextLineMatrix: function TextState_setTextMatrix(
                t,
                r,
                a,
                i,
                o,
                l,
              ) {
                var c = this.textLineMatrix;
                (c[0] = t),
                  (c[1] = r),
                  (c[2] = a),
                  (c[3] = i),
                  (c[4] = o),
                  (c[5] = l);
              },
              translateTextMatrix: function TextState_translateTextMatrix(
                t,
                r,
              ) {
                var a = this.textMatrix;
                (a[4] = a[0] * t + a[2] * r + a[4]),
                  (a[5] = a[1] * t + a[3] * r + a[5]);
              },
              translateTextLineMatrix: function TextState_translateTextMatrix(
                t,
                r,
              ) {
                var a = this.textLineMatrix;
                (a[4] = a[0] * t + a[2] * r + a[4]),
                  (a[5] = a[1] * t + a[3] * r + a[5]);
              },
              calcTextLineMatrixAdvance:
                function TextState_calcTextLineMatrixAdvance(t, r, a, i, o, l) {
                  var c = this.font;
                  if (!c) return null;
                  var u = this.textLineMatrix;
                  if (t !== u[0] || r !== u[1] || a !== u[2] || i !== u[3])
                    return null;
                  var h = o - u[4],
                    d = l - u[5];
                  if ((c.vertical && 0 !== h) || (!c.vertical && 0 !== d))
                    return null;
                  var p,
                    m,
                    g = t * i - r * a;
                  return (
                    c.vertical
                      ? ((p = (-d * a) / g), (m = (d * t) / g))
                      : ((p = (h * i) / g), (m = (-h * r) / g)),
                    { width: p, height: m, value: c.vertical ? m : p }
                  );
                },
              calcRenderMatrix: function TextState_calcRendeMatrix(t) {
                var r = [
                  this.fontSize * this.textHScale,
                  0,
                  0,
                  this.fontSize,
                  0,
                  this.textRise,
                ];
                return o.Util.transform(
                  t,
                  o.Util.transform(this.textMatrix, r),
                );
              },
              carriageReturn: function TextState_carriageReturn() {
                this.translateTextLineMatrix(0, -this.leading),
                  (this.textMatrix = this.textLineMatrix.slice());
              },
              clone: function TextState_clone() {
                var t = Object.create(this);
                return (
                  (t.textMatrix = this.textMatrix.slice()),
                  (t.textLineMatrix = this.textLineMatrix.slice()),
                  (t.fontMatrix = this.fontMatrix.slice()),
                  t
                );
              },
            }),
            TextState
          );
        })(),
        E = (function EvalStateClosure() {
          function EvalState() {
            (this.ctm = new Float32Array(o.IDENTITY_MATRIX)),
              (this.font = null),
              (this.textRenderingMode = o.TextRenderingMode.FILL),
              (this.fillColorSpace = v.ColorSpace.singletons.gray),
              (this.strokeColorSpace = v.ColorSpace.singletons.gray);
          }
          return (
            (EvalState.prototype = {
              clone: function CanvasExtraState_clone() {
                return Object.create(this);
              },
            }),
            EvalState
          );
        })(),
        B = (function EvaluatorPreprocessorClosure() {
          var t = (0, d.getLookupTableFactory)(function (t) {
            (t.w = { id: o.OPS.setLineWidth, numArgs: 1, variableArgs: !1 }),
              (t.J = { id: o.OPS.setLineCap, numArgs: 1, variableArgs: !1 }),
              (t.j = { id: o.OPS.setLineJoin, numArgs: 1, variableArgs: !1 }),
              (t.M = { id: o.OPS.setMiterLimit, numArgs: 1, variableArgs: !1 }),
              (t.d = { id: o.OPS.setDash, numArgs: 2, variableArgs: !1 }),
              (t.ri = {
                id: o.OPS.setRenderingIntent,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t.i = { id: o.OPS.setFlatness, numArgs: 1, variableArgs: !1 }),
              (t.gs = { id: o.OPS.setGState, numArgs: 1, variableArgs: !1 }),
              (t.q = { id: o.OPS.save, numArgs: 0, variableArgs: !1 }),
              (t.Q = { id: o.OPS.restore, numArgs: 0, variableArgs: !1 }),
              (t.cm = { id: o.OPS.transform, numArgs: 6, variableArgs: !1 }),
              (t.m = { id: o.OPS.moveTo, numArgs: 2, variableArgs: !1 }),
              (t.l = { id: o.OPS.lineTo, numArgs: 2, variableArgs: !1 }),
              (t.c = { id: o.OPS.curveTo, numArgs: 6, variableArgs: !1 }),
              (t.v = { id: o.OPS.curveTo2, numArgs: 4, variableArgs: !1 }),
              (t.y = { id: o.OPS.curveTo3, numArgs: 4, variableArgs: !1 }),
              (t.h = { id: o.OPS.closePath, numArgs: 0, variableArgs: !1 }),
              (t.re = { id: o.OPS.rectangle, numArgs: 4, variableArgs: !1 }),
              (t.S = { id: o.OPS.stroke, numArgs: 0, variableArgs: !1 }),
              (t.s = { id: o.OPS.closeStroke, numArgs: 0, variableArgs: !1 }),
              (t.f = { id: o.OPS.fill, numArgs: 0, variableArgs: !1 }),
              (t.F = { id: o.OPS.fill, numArgs: 0, variableArgs: !1 }),
              (t["f*"] = { id: o.OPS.eoFill, numArgs: 0, variableArgs: !1 }),
              (t.B = { id: o.OPS.fillStroke, numArgs: 0, variableArgs: !1 }),
              (t["B*"] = {
                id: o.OPS.eoFillStroke,
                numArgs: 0,
                variableArgs: !1,
              }),
              (t.b = {
                id: o.OPS.closeFillStroke,
                numArgs: 0,
                variableArgs: !1,
              }),
              (t["b*"] = {
                id: o.OPS.closeEOFillStroke,
                numArgs: 0,
                variableArgs: !1,
              }),
              (t.n = { id: o.OPS.endPath, numArgs: 0, variableArgs: !1 }),
              (t.W = { id: o.OPS.clip, numArgs: 0, variableArgs: !1 }),
              (t["W*"] = { id: o.OPS.eoClip, numArgs: 0, variableArgs: !1 }),
              (t.BT = { id: o.OPS.beginText, numArgs: 0, variableArgs: !1 }),
              (t.ET = { id: o.OPS.endText, numArgs: 0, variableArgs: !1 }),
              (t.Tc = {
                id: o.OPS.setCharSpacing,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t.Tw = {
                id: o.OPS.setWordSpacing,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t.Tz = { id: o.OPS.setHScale, numArgs: 1, variableArgs: !1 }),
              (t.TL = { id: o.OPS.setLeading, numArgs: 1, variableArgs: !1 }),
              (t.Tf = { id: o.OPS.setFont, numArgs: 2, variableArgs: !1 }),
              (t.Tr = {
                id: o.OPS.setTextRenderingMode,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t.Ts = { id: o.OPS.setTextRise, numArgs: 1, variableArgs: !1 }),
              (t.Td = { id: o.OPS.moveText, numArgs: 2, variableArgs: !1 }),
              (t.TD = {
                id: o.OPS.setLeadingMoveText,
                numArgs: 2,
                variableArgs: !1,
              }),
              (t.Tm = {
                id: o.OPS.setTextMatrix,
                numArgs: 6,
                variableArgs: !1,
              }),
              (t["T*"] = { id: o.OPS.nextLine, numArgs: 0, variableArgs: !1 }),
              (t.Tj = { id: o.OPS.showText, numArgs: 1, variableArgs: !1 }),
              (t.TJ = {
                id: o.OPS.showSpacedText,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t["'"] = {
                id: o.OPS.nextLineShowText,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t['"'] = {
                id: o.OPS.nextLineSetSpacingShowText,
                numArgs: 3,
                variableArgs: !1,
              }),
              (t.d0 = { id: o.OPS.setCharWidth, numArgs: 2, variableArgs: !1 }),
              (t.d1 = {
                id: o.OPS.setCharWidthAndBounds,
                numArgs: 6,
                variableArgs: !1,
              }),
              (t.CS = {
                id: o.OPS.setStrokeColorSpace,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t.cs = {
                id: o.OPS.setFillColorSpace,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t.SC = {
                id: o.OPS.setStrokeColor,
                numArgs: 4,
                variableArgs: !0,
              }),
              (t.SCN = {
                id: o.OPS.setStrokeColorN,
                numArgs: 33,
                variableArgs: !0,
              }),
              (t.sc = { id: o.OPS.setFillColor, numArgs: 4, variableArgs: !0 }),
              (t.scn = {
                id: o.OPS.setFillColorN,
                numArgs: 33,
                variableArgs: !0,
              }),
              (t.G = { id: o.OPS.setStrokeGray, numArgs: 1, variableArgs: !1 }),
              (t.g = { id: o.OPS.setFillGray, numArgs: 1, variableArgs: !1 }),
              (t.RG = {
                id: o.OPS.setStrokeRGBColor,
                numArgs: 3,
                variableArgs: !1,
              }),
              (t.rg = {
                id: o.OPS.setFillRGBColor,
                numArgs: 3,
                variableArgs: !1,
              }),
              (t.K = {
                id: o.OPS.setStrokeCMYKColor,
                numArgs: 4,
                variableArgs: !1,
              }),
              (t.k = {
                id: o.OPS.setFillCMYKColor,
                numArgs: 4,
                variableArgs: !1,
              }),
              (t.sh = { id: o.OPS.shadingFill, numArgs: 1, variableArgs: !1 }),
              (t.BI = {
                id: o.OPS.beginInlineImage,
                numArgs: 0,
                variableArgs: !1,
              }),
              (t.ID = {
                id: o.OPS.beginImageData,
                numArgs: 0,
                variableArgs: !1,
              }),
              (t.EI = {
                id: o.OPS.endInlineImage,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t.Do = { id: o.OPS.paintXObject, numArgs: 1, variableArgs: !1 }),
              (t.MP = { id: o.OPS.markPoint, numArgs: 1, variableArgs: !1 }),
              (t.DP = {
                id: o.OPS.markPointProps,
                numArgs: 2,
                variableArgs: !1,
              }),
              (t.BMC = {
                id: o.OPS.beginMarkedContent,
                numArgs: 1,
                variableArgs: !1,
              }),
              (t.BDC = {
                id: o.OPS.beginMarkedContentProps,
                numArgs: 2,
                variableArgs: !1,
              }),
              (t.EMC = {
                id: o.OPS.endMarkedContent,
                numArgs: 0,
                variableArgs: !1,
              }),
              (t.BX = { id: o.OPS.beginCompat, numArgs: 0, variableArgs: !1 }),
              (t.EX = { id: o.OPS.endCompat, numArgs: 0, variableArgs: !1 }),
              (t.BM = null),
              (t.BD = null),
              (t.true = null),
              (t.fa = null),
              (t.fal = null),
              (t.fals = null),
              (t.false = null),
              (t.nu = null),
              (t.nul = null),
              (t.null = null);
          });
          function EvaluatorPreprocessor(r, a, i) {
            (this.opMap = t()),
              (this.parser = new b.Parser({
                lexer: new b.Lexer(r, this.opMap),
                xref: a,
              })),
              (this.stateManager = i),
              (this.nonProcessedArgs = []),
              (this._numInvalidPathOPS = 0);
          }
          return (
            (EvaluatorPreprocessor.prototype = {
              get savedStatesDepth() {
                return this.stateManager.stateStack.length;
              },
              read: function EvaluatorPreprocessor_read(t) {
                for (var r = t.args; ; ) {
                  var a = this.parser.getObj();
                  if (a instanceof c.Cmd) {
                    var i = a.cmd,
                      l = this.opMap[i];
                    if (!l) {
                      (0, o.warn)('Unknown command "'.concat(i, '".'));
                      continue;
                    }
                    var u = l.id,
                      h = l.numArgs,
                      d = null !== r ? r.length : 0;
                    if (l.variableArgs)
                      d > h &&
                        (0, o.info)(
                          "Command "
                            .concat(i, ": expected [0, ")
                            .concat(h, "] args, ") +
                            "but received ".concat(d, " args."),
                        );
                    else {
                      if (d !== h) {
                        for (var p = this.nonProcessedArgs; d > h; )
                          p.push(r.shift()), d--;
                        for (; d < h && 0 !== p.length; )
                          null === r && (r = []), r.unshift(p.pop()), d++;
                      }
                      if (d < h) {
                        var m =
                          "command "
                            .concat(i, ": expected ")
                            .concat(h, " args, ") +
                          "but received ".concat(d, " args.");
                        if (
                          u >= o.OPS.moveTo &&
                          u <= o.OPS.endPath &&
                          ++this._numInvalidPathOPS > 20
                        )
                          throw new o.FormatError("Invalid ".concat(m));
                        (0, o.warn)("Skipping ".concat(m)),
                          null !== r && (r.length = 0);
                        continue;
                      }
                    }
                    return (
                      this.preprocessCommand(u, r), (t.fn = u), (t.args = r), !0
                    );
                  }
                  if (a === c.EOF) return !1;
                  if (
                    null !== a &&
                    (null === r && (r = []), r.push(a), r.length > 33)
                  )
                    throw new o.FormatError("Too many arguments");
                }
              },
              preprocessCommand:
                function EvaluatorPreprocessor_preprocessCommand(t, r) {
                  switch (0 | t) {
                    case o.OPS.save:
                      this.stateManager.save();
                      break;
                    case o.OPS.restore:
                      this.stateManager.restore();
                      break;
                    case o.OPS.transform:
                      this.stateManager.transform(r);
                  }
                },
            }),
            EvaluatorPreprocessor
          );
        })();
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.CMapFactory = r.IdentityCMap = r.CMap = void 0);
      var i = (function _interopRequireDefault(t) {
          return t && t.__esModule ? t : { default: t };
        })(a(2)),
        o = a(5),
        l = a(198),
        c = a(204),
        u = a(201),
        h = a(205);
      function asyncGeneratorStep(t, r, a, i, o, l, c) {
        try {
          var u = t[l](c),
            h = u.value;
        } catch (t) {
          return void a(t);
        }
        u.done ? r(h) : Promise.resolve(h).then(i, o);
      }
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var d = [
          "Adobe-GB1-UCS2",
          "Adobe-CNS1-UCS2",
          "Adobe-Japan1-UCS2",
          "Adobe-Korea1-UCS2",
          "78-EUC-H",
          "78-EUC-V",
          "78-H",
          "78-RKSJ-H",
          "78-RKSJ-V",
          "78-V",
          "78ms-RKSJ-H",
          "78ms-RKSJ-V",
          "83pv-RKSJ-H",
          "90ms-RKSJ-H",
          "90ms-RKSJ-V",
          "90msp-RKSJ-H",
          "90msp-RKSJ-V",
          "90pv-RKSJ-H",
          "90pv-RKSJ-V",
          "Add-H",
          "Add-RKSJ-H",
          "Add-RKSJ-V",
          "Add-V",
          "Adobe-CNS1-0",
          "Adobe-CNS1-1",
          "Adobe-CNS1-2",
          "Adobe-CNS1-3",
          "Adobe-CNS1-4",
          "Adobe-CNS1-5",
          "Adobe-CNS1-6",
          "Adobe-GB1-0",
          "Adobe-GB1-1",
          "Adobe-GB1-2",
          "Adobe-GB1-3",
          "Adobe-GB1-4",
          "Adobe-GB1-5",
          "Adobe-Japan1-0",
          "Adobe-Japan1-1",
          "Adobe-Japan1-2",
          "Adobe-Japan1-3",
          "Adobe-Japan1-4",
          "Adobe-Japan1-5",
          "Adobe-Japan1-6",
          "Adobe-Korea1-0",
          "Adobe-Korea1-1",
          "Adobe-Korea1-2",
          "B5-H",
          "B5-V",
          "B5pc-H",
          "B5pc-V",
          "CNS-EUC-H",
          "CNS-EUC-V",
          "CNS1-H",
          "CNS1-V",
          "CNS2-H",
          "CNS2-V",
          "ETHK-B5-H",
          "ETHK-B5-V",
          "ETen-B5-H",
          "ETen-B5-V",
          "ETenms-B5-H",
          "ETenms-B5-V",
          "EUC-H",
          "EUC-V",
          "Ext-H",
          "Ext-RKSJ-H",
          "Ext-RKSJ-V",
          "Ext-V",
          "GB-EUC-H",
          "GB-EUC-V",
          "GB-H",
          "GB-V",
          "GBK-EUC-H",
          "GBK-EUC-V",
          "GBK2K-H",
          "GBK2K-V",
          "GBKp-EUC-H",
          "GBKp-EUC-V",
          "GBT-EUC-H",
          "GBT-EUC-V",
          "GBT-H",
          "GBT-V",
          "GBTpc-EUC-H",
          "GBTpc-EUC-V",
          "GBpc-EUC-H",
          "GBpc-EUC-V",
          "H",
          "HKdla-B5-H",
          "HKdla-B5-V",
          "HKdlb-B5-H",
          "HKdlb-B5-V",
          "HKgccs-B5-H",
          "HKgccs-B5-V",
          "HKm314-B5-H",
          "HKm314-B5-V",
          "HKm471-B5-H",
          "HKm471-B5-V",
          "HKscs-B5-H",
          "HKscs-B5-V",
          "Hankaku",
          "Hiragana",
          "KSC-EUC-H",
          "KSC-EUC-V",
          "KSC-H",
          "KSC-Johab-H",
          "KSC-Johab-V",
          "KSC-V",
          "KSCms-UHC-H",
          "KSCms-UHC-HW-H",
          "KSCms-UHC-HW-V",
          "KSCms-UHC-V",
          "KSCpc-EUC-H",
          "KSCpc-EUC-V",
          "Katakana",
          "NWP-H",
          "NWP-V",
          "RKSJ-H",
          "RKSJ-V",
          "Roman",
          "UniCNS-UCS2-H",
          "UniCNS-UCS2-V",
          "UniCNS-UTF16-H",
          "UniCNS-UTF16-V",
          "UniCNS-UTF32-H",
          "UniCNS-UTF32-V",
          "UniCNS-UTF8-H",
          "UniCNS-UTF8-V",
          "UniGB-UCS2-H",
          "UniGB-UCS2-V",
          "UniGB-UTF16-H",
          "UniGB-UTF16-V",
          "UniGB-UTF32-H",
          "UniGB-UTF32-V",
          "UniGB-UTF8-H",
          "UniGB-UTF8-V",
          "UniJIS-UCS2-H",
          "UniJIS-UCS2-HW-H",
          "UniJIS-UCS2-HW-V",
          "UniJIS-UCS2-V",
          "UniJIS-UTF16-H",
          "UniJIS-UTF16-V",
          "UniJIS-UTF32-H",
          "UniJIS-UTF32-V",
          "UniJIS-UTF8-H",
          "UniJIS-UTF8-V",
          "UniJIS2004-UTF16-H",
          "UniJIS2004-UTF16-V",
          "UniJIS2004-UTF32-H",
          "UniJIS2004-UTF32-V",
          "UniJIS2004-UTF8-H",
          "UniJIS2004-UTF8-V",
          "UniJISPro-UCS2-HW-V",
          "UniJISPro-UCS2-V",
          "UniJISPro-UTF8-V",
          "UniJISX0213-UTF32-H",
          "UniJISX0213-UTF32-V",
          "UniJISX02132004-UTF32-H",
          "UniJISX02132004-UTF32-V",
          "UniKS-UCS2-H",
          "UniKS-UCS2-V",
          "UniKS-UTF16-H",
          "UniKS-UTF16-V",
          "UniKS-UTF32-H",
          "UniKS-UTF32-V",
          "UniKS-UTF8-H",
          "UniKS-UTF8-V",
          "V",
          "WP-Symbol",
        ],
        p = Math.pow(2, 24) - 1,
        m = (function () {
          function CMap() {
            var t =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            _classCallCheck(this, CMap),
              (this.codespaceRanges = [[], [], [], []]),
              (this.numCodespaceRanges = 0),
              (this._map = []),
              (this.name = ""),
              (this.vertical = !1),
              (this.useCMap = null),
              (this.builtInCMap = t);
          }
          return (
            _createClass(CMap, [
              {
                key: "addCodespaceRange",
                value: function addCodespaceRange(t, r, a) {
                  this.codespaceRanges[t - 1].push(r, a),
                    this.numCodespaceRanges++;
                },
              },
              {
                key: "mapCidRange",
                value: function mapCidRange(t, r, a) {
                  if (r - t > p)
                    throw new Error(
                      "mapCidRange - ignoring data above MAX_MAP_RANGE.",
                    );
                  for (; t <= r; ) this._map[t++] = a++;
                },
              },
              {
                key: "mapBfRange",
                value: function mapBfRange(t, r, a) {
                  if (r - t > p)
                    throw new Error(
                      "mapBfRange - ignoring data above MAX_MAP_RANGE.",
                    );
                  for (var i = a.length - 1; t <= r; )
                    (this._map[t++] = a),
                      (a =
                        a.substring(0, i) +
                        String.fromCharCode(a.charCodeAt(i) + 1));
                },
              },
              {
                key: "mapBfRangeToArray",
                value: function mapBfRangeToArray(t, r, a) {
                  if (r - t > p)
                    throw new Error(
                      "mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.",
                    );
                  for (var i = a.length, o = 0; t <= r && o < i; )
                    (this._map[t] = a[o++]), ++t;
                },
              },
              {
                key: "mapOne",
                value: function mapOne(t, r) {
                  this._map[t] = r;
                },
              },
              {
                key: "lookup",
                value: function lookup(t) {
                  return this._map[t];
                },
              },
              {
                key: "contains",
                value: function contains(t) {
                  return void 0 !== this._map[t];
                },
              },
              {
                key: "forEach",
                value: function forEach(t) {
                  var r = this._map,
                    a = r.length;
                  if (a <= 65536)
                    for (var i = 0; i < a; i++) void 0 !== r[i] && t(i, r[i]);
                  else for (var o in r) t(o, r[o]);
                },
              },
              {
                key: "charCodeOf",
                value: function charCodeOf(t) {
                  var r = this._map;
                  if (r.length <= 65536) return r.indexOf(t);
                  for (var a in r) if (r[a] === t) return 0 | a;
                  return -1;
                },
              },
              {
                key: "getMap",
                value: function getMap() {
                  return this._map;
                },
              },
              {
                key: "readCharCode",
                value: function readCharCode(t, r, a) {
                  for (
                    var i = 0, o = this.codespaceRanges, l = 0, c = o.length;
                    l < c;
                    l++
                  ) {
                    i = ((i << 8) | t.charCodeAt(r + l)) >>> 0;
                    for (var u = o[l], h = 0, d = u.length; h < d; ) {
                      var p = u[h++],
                        m = u[h++];
                      if (i >= p && i <= m)
                        return (a.charcode = i), void (a.length = l + 1);
                    }
                  }
                  (a.charcode = 0), (a.length = 1);
                },
              },
              {
                key: "length",
                get: function get() {
                  return this._map.length;
                },
              },
              {
                key: "isIdentityCMap",
                get: function get() {
                  if ("Identity-H" !== this.name && "Identity-V" !== this.name)
                    return !1;
                  if (65536 !== this._map.length) return !1;
                  for (var t = 0; t < 65536; t++)
                    if (this._map[t] !== t) return !1;
                  return !0;
                },
              },
            ]),
            CMap
          );
        })();
      r.CMap = m;
      var g = (function (t) {
        !(function _inherits(t, r) {
          if ("function" != typeof r && null !== r)
            throw new TypeError(
              "Super expression must either be null or a function",
            );
          (t.prototype = Object.create(r && r.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            r && _setPrototypeOf(t, r);
        })(IdentityCMap, t);
        var r = _createSuper(IdentityCMap);
        function IdentityCMap(t, a) {
          var i;
          return (
            _classCallCheck(this, IdentityCMap),
            ((i = r.call(this)).vertical = t),
            i.addCodespaceRange(a, 0, 65535),
            i
          );
        }
        return (
          _createClass(IdentityCMap, [
            {
              key: "mapCidRange",
              value: function mapCidRange(t, r, a) {
                (0, o.unreachable)("should not call mapCidRange");
              },
            },
            {
              key: "mapBfRange",
              value: function mapBfRange(t, r, a) {
                (0, o.unreachable)("should not call mapBfRange");
              },
            },
            {
              key: "mapBfRangeToArray",
              value: function mapBfRangeToArray(t, r, a) {
                (0, o.unreachable)("should not call mapBfRangeToArray");
              },
            },
            {
              key: "mapOne",
              value: function mapOne(t, r) {
                (0, o.unreachable)("should not call mapCidOne");
              },
            },
            {
              key: "lookup",
              value: function lookup(t) {
                return Number.isInteger(t) && t <= 65535 ? t : void 0;
              },
            },
            {
              key: "contains",
              value: function contains(t) {
                return Number.isInteger(t) && t <= 65535;
              },
            },
            {
              key: "forEach",
              value: function forEach(t) {
                for (var r = 0; r <= 65535; r++) t(r, r);
              },
            },
            {
              key: "charCodeOf",
              value: function charCodeOf(t) {
                return Number.isInteger(t) && t <= 65535 ? t : -1;
              },
            },
            {
              key: "getMap",
              value: function getMap() {
                for (var t = new Array(65536), r = 0; r <= 65535; r++) t[r] = r;
                return t;
              },
            },
            {
              key: "length",
              get: function get() {
                return 65536;
              },
            },
            {
              key: "isIdentityCMap",
              get: function get() {
                (0, o.unreachable)("should not access .isIdentityCMap");
              },
            },
          ]),
          IdentityCMap
        );
      })(m);
      r.IdentityCMap = g;
      var b = (function BinaryCMapReaderClosure() {
          function hexToInt(t, r) {
            for (var a = 0, i = 0; i <= r; i++) a = (a << 8) | t[i];
            return a >>> 0;
          }
          function hexToStr(t, r) {
            return 1 === r
              ? String.fromCharCode(t[0], t[1])
              : 3 === r
              ? String.fromCharCode(t[0], t[1], t[2], t[3])
              : String.fromCharCode.apply(null, t.subarray(0, r + 1));
          }
          function addHex(t, r, a) {
            for (var i = 0, o = a; o >= 0; o--)
              (i += t[o] + r[o]), (t[o] = 255 & i), (i >>= 8);
          }
          function incHex(t, r) {
            for (var a = 1, i = r; i >= 0 && a > 0; i--)
              (a += t[i]), (t[i] = 255 & a), (a >>= 8);
          }
          var t = 16;
          function BinaryCMapStream(t) {
            (this.buffer = t),
              (this.pos = 0),
              (this.end = t.length),
              (this.tmpBuf = new Uint8Array(19));
          }
          function BinaryCMapReader() {}
          return (
            (BinaryCMapStream.prototype = {
              readByte: function readByte() {
                return this.pos >= this.end ? -1 : this.buffer[this.pos++];
              },
              readNumber: function readNumber() {
                var t,
                  r = 0;
                do {
                  var a = this.readByte();
                  if (a < 0) throw new o.FormatError("unexpected EOF in bcmap");
                  (t = !(128 & a)), (r = (r << 7) | (127 & a));
                } while (!t);
                return r;
              },
              readSigned: function readSigned() {
                var t = this.readNumber();
                return 1 & t ? ~(t >>> 1) : t >>> 1;
              },
              readHex: function readHex(t, r) {
                t.set(this.buffer.subarray(this.pos, this.pos + r + 1)),
                  (this.pos += r + 1);
              },
              readHexNumber: function readHexNumber(t, r) {
                var a,
                  i = this.tmpBuf,
                  l = 0;
                do {
                  var c = this.readByte();
                  if (c < 0) throw new o.FormatError("unexpected EOF in bcmap");
                  (a = !(128 & c)), (i[l++] = 127 & c);
                } while (!a);
                for (var u = r, h = 0, d = 0; u >= 0; ) {
                  for (; d < 8 && i.length > 0; )
                    (h = (i[--l] << d) | h), (d += 7);
                  (t[u] = 255 & h), u--, (h >>= 8), (d -= 8);
                }
              },
              readHexSigned: function readHexSigned(t, r) {
                this.readHexNumber(t, r);
                for (var a = 1 & t[r] ? 255 : 0, i = 0, o = 0; o <= r; o++)
                  (i = ((1 & i) << 8) | t[o]), (t[o] = (i >> 1) ^ a);
              },
              readString: function readString() {
                for (var t = this.readNumber(), r = "", a = 0; a < t; a++)
                  r += String.fromCharCode(this.readNumber());
                return r;
              },
            }),
            (BinaryCMapReader.prototype = {
              process: function processBinaryCMap(r, a, i) {
                return new Promise(function (o, l) {
                  var c = new BinaryCMapStream(r),
                    u = c.readByte();
                  a.vertical = !!(1 & u);
                  for (
                    var h,
                      d,
                      p = null,
                      m = new Uint8Array(t),
                      g = new Uint8Array(t),
                      b = new Uint8Array(t),
                      y = new Uint8Array(t),
                      v = new Uint8Array(t);
                    (d = c.readByte()) >= 0;

                  ) {
                    var S = d >> 5;
                    if (7 !== S) {
                      var k = !!(16 & d),
                        w = 15 & d;
                      if (w + 1 > t)
                        throw new Error("processBinaryCMap: Invalid dataSize.");
                      var C,
                        x = c.readNumber();
                      switch (S) {
                        case 0:
                          for (
                            c.readHex(m, w),
                              c.readHexNumber(g, w),
                              addHex(g, m, w),
                              a.addCodespaceRange(
                                w + 1,
                                hexToInt(m, w),
                                hexToInt(g, w),
                              ),
                              C = 1;
                            C < x;
                            C++
                          )
                            incHex(g, w),
                              c.readHexNumber(m, w),
                              addHex(m, g, w),
                              c.readHexNumber(g, w),
                              addHex(g, m, w),
                              a.addCodespaceRange(
                                w + 1,
                                hexToInt(m, w),
                                hexToInt(g, w),
                              );
                          break;
                        case 1:
                          for (
                            c.readHex(m, w),
                              c.readHexNumber(g, w),
                              addHex(g, m, w),
                              c.readNumber(),
                              C = 1;
                            C < x;
                            C++
                          )
                            incHex(g, w),
                              c.readHexNumber(m, w),
                              addHex(m, g, w),
                              c.readHexNumber(g, w),
                              addHex(g, m, w),
                              c.readNumber();
                          break;
                        case 2:
                          for (
                            c.readHex(b, w),
                              h = c.readNumber(),
                              a.mapOne(hexToInt(b, w), h),
                              C = 1;
                            C < x;
                            C++
                          )
                            incHex(b, w),
                              k || (c.readHexNumber(v, w), addHex(b, v, w)),
                              (h = c.readSigned() + (h + 1)),
                              a.mapOne(hexToInt(b, w), h);
                          break;
                        case 3:
                          for (
                            c.readHex(m, w),
                              c.readHexNumber(g, w),
                              addHex(g, m, w),
                              h = c.readNumber(),
                              a.mapCidRange(hexToInt(m, w), hexToInt(g, w), h),
                              C = 1;
                            C < x;
                            C++
                          )
                            incHex(g, w),
                              k
                                ? m.set(g)
                                : (c.readHexNumber(m, w), addHex(m, g, w)),
                              c.readHexNumber(g, w),
                              addHex(g, m, w),
                              (h = c.readNumber()),
                              a.mapCidRange(hexToInt(m, w), hexToInt(g, w), h);
                          break;
                        case 4:
                          for (
                            c.readHex(b, 1),
                              c.readHex(y, w),
                              a.mapOne(hexToInt(b, 1), hexToStr(y, w)),
                              C = 1;
                            C < x;
                            C++
                          )
                            incHex(b, 1),
                              k || (c.readHexNumber(v, 1), addHex(b, v, 1)),
                              incHex(y, w),
                              c.readHexSigned(v, w),
                              addHex(y, v, w),
                              a.mapOne(hexToInt(b, 1), hexToStr(y, w));
                          break;
                        case 5:
                          for (
                            c.readHex(m, 1),
                              c.readHexNumber(g, 1),
                              addHex(g, m, 1),
                              c.readHex(y, w),
                              a.mapBfRange(
                                hexToInt(m, 1),
                                hexToInt(g, 1),
                                hexToStr(y, w),
                              ),
                              C = 1;
                            C < x;
                            C++
                          )
                            incHex(g, 1),
                              k
                                ? m.set(g)
                                : (c.readHexNumber(m, 1), addHex(m, g, 1)),
                              c.readHexNumber(g, 1),
                              addHex(g, m, 1),
                              c.readHex(y, w),
                              a.mapBfRange(
                                hexToInt(m, 1),
                                hexToInt(g, 1),
                                hexToStr(y, w),
                              );
                          break;
                        default:
                          return void l(
                            new Error("processBinaryCMap: Unknown type: " + S),
                          );
                      }
                    } else
                      switch (31 & d) {
                        case 0:
                          c.readString();
                          break;
                        case 1:
                          p = c.readString();
                      }
                  }
                  o(p ? i(p) : a);
                });
              },
            }),
            BinaryCMapReader
          );
        })(),
        y = (function CMapFactoryClosure() {
          function strToInt(t) {
            for (var r = 0, a = 0; a < t.length; a++)
              r = (r << 8) | t.charCodeAt(a);
            return r >>> 0;
          }
          function expectString(t) {
            if (!(0, o.isString)(t))
              throw new o.FormatError("Malformed CMap: expected string.");
          }
          function expectInt(t) {
            if (!Number.isInteger(t))
              throw new o.FormatError("Malformed CMap: expected int.");
          }
          function parseBfChar(t, r) {
            for (;;) {
              var a = r.getObj();
              if ((0, l.isEOF)(a)) break;
              if ((0, l.isCmd)(a, "endbfchar")) return;
              expectString(a);
              var i = strToInt(a);
              expectString((a = r.getObj()));
              var o = a;
              t.mapOne(i, o);
            }
          }
          function parseBfRange(t, r) {
            for (;;) {
              var a = r.getObj();
              if ((0, l.isEOF)(a)) break;
              if ((0, l.isCmd)(a, "endbfrange")) return;
              expectString(a);
              var i = strToInt(a);
              expectString((a = r.getObj()));
              var c = strToInt(a);
              if (
                ((a = r.getObj()), Number.isInteger(a) || (0, o.isString)(a))
              ) {
                var u = Number.isInteger(a) ? String.fromCharCode(a) : a;
                t.mapBfRange(i, c, u);
              } else {
                if (!(0, l.isCmd)(a, "[")) break;
                a = r.getObj();
                for (var h = []; !(0, l.isCmd)(a, "]") && !(0, l.isEOF)(a); )
                  h.push(a), (a = r.getObj());
                t.mapBfRangeToArray(i, c, h);
              }
            }
            throw new o.FormatError("Invalid bf range.");
          }
          function parseCidChar(t, r) {
            for (;;) {
              var a = r.getObj();
              if ((0, l.isEOF)(a)) break;
              if ((0, l.isCmd)(a, "endcidchar")) return;
              expectString(a);
              var i = strToInt(a);
              expectInt((a = r.getObj()));
              var o = a;
              t.mapOne(i, o);
            }
          }
          function parseCidRange(t, r) {
            for (;;) {
              var a = r.getObj();
              if ((0, l.isEOF)(a)) break;
              if ((0, l.isCmd)(a, "endcidrange")) return;
              expectString(a);
              var i = strToInt(a);
              expectString((a = r.getObj()));
              var o = strToInt(a);
              expectInt((a = r.getObj()));
              var c = a;
              t.mapCidRange(i, o, c);
            }
          }
          function parseCodespaceRange(t, r) {
            for (;;) {
              var a = r.getObj();
              if ((0, l.isEOF)(a)) break;
              if ((0, l.isCmd)(a, "endcodespacerange")) return;
              if (!(0, o.isString)(a)) break;
              var i = strToInt(a);
              if (((a = r.getObj()), !(0, o.isString)(a))) break;
              var c = strToInt(a);
              t.addCodespaceRange(a.length, i, c);
            }
            throw new o.FormatError("Invalid codespace range.");
          }
          function parseWMode(t, r) {
            var a = r.getObj();
            Number.isInteger(a) && (t.vertical = !!a);
          }
          function parseCMapName(t, r) {
            var a = r.getObj();
            (0, l.isName)(a) && (0, o.isString)(a.name) && (t.name = a.name);
          }
          function parseCMap(t, r, a, i) {
            var c, h;
            e: for (;;)
              try {
                var d = r.getObj();
                if ((0, l.isEOF)(d)) break;
                if ((0, l.isName)(d))
                  "WMode" === d.name
                    ? parseWMode(t, r)
                    : "CMapName" === d.name && parseCMapName(t, r),
                    (c = d);
                else if ((0, l.isCmd)(d))
                  switch (d.cmd) {
                    case "endcmap":
                      break e;
                    case "usecmap":
                      (0, l.isName)(c) && (h = c.name);
                      break;
                    case "begincodespacerange":
                      parseCodespaceRange(t, r);
                      break;
                    case "beginbfchar":
                      parseBfChar(t, r);
                      break;
                    case "begincidchar":
                      parseCidChar(t, r);
                      break;
                    case "beginbfrange":
                      parseBfRange(t, r);
                      break;
                    case "begincidrange":
                      parseCidRange(t, r);
                  }
              } catch (t) {
                if (t instanceof u.MissingDataException) throw t;
                (0, o.warn)("Invalid cMap data: " + t);
                continue;
              }
            return (
              !i && h && (i = h), i ? extendCMap(t, a, i) : Promise.resolve(t)
            );
          }
          function extendCMap(t, r, a) {
            return createBuiltInCMap(a, r).then(function (r) {
              if (((t.useCMap = r), 0 === t.numCodespaceRanges)) {
                for (
                  var a = t.useCMap.codespaceRanges, i = 0;
                  i < a.length;
                  i++
                )
                  t.codespaceRanges[i] = a[i].slice();
                t.numCodespaceRanges = t.useCMap.numCodespaceRanges;
              }
              return (
                t.useCMap.forEach(function (r, a) {
                  t.contains(r) || t.mapOne(r, t.useCMap.lookup(r));
                }),
                t
              );
            });
          }
          function createBuiltInCMap(t, r) {
            return "Identity-H" === t
              ? Promise.resolve(new g(!1, 2))
              : "Identity-V" === t
              ? Promise.resolve(new g(!0, 2))
              : d.includes(t)
              ? r
                ? r(t).then(function (t) {
                    var a = t.cMapData,
                      i = t.compressionType,
                      l = new m(!0);
                    if (i === o.CMapCompressionType.BINARY)
                      return new b().process(a, l, function (t) {
                        return extendCMap(l, r, t);
                      });
                    if (i === o.CMapCompressionType.NONE) {
                      var u = new c.Lexer(new h.Stream(a));
                      return parseCMap(l, u, r, null);
                    }
                    return Promise.reject(
                      new Error(
                        "TODO: Only BINARY/NONE CMap compression is currently supported.",
                      ),
                    );
                  })
                : Promise.reject(
                    new Error("Built-in CMap parameters are not provided."),
                  )
              : Promise.reject(new Error("Unknown CMap name: " + t));
          }
          return {
            create: function create(t) {
              return (function _asyncToGenerator(t) {
                return function () {
                  var r = this,
                    a = arguments;
                  return new Promise(function (i, o) {
                    var l = t.apply(r, a);
                    function _next(t) {
                      asyncGeneratorStep(l, i, o, _next, _throw, "next", t);
                    }
                    function _throw(t) {
                      asyncGeneratorStep(l, i, o, _next, _throw, "throw", t);
                    }
                    _next(void 0);
                  });
                };
              })(
                i.default.mark(function _callee() {
                  var r, a, o, u, h;
                  return i.default.wrap(function _callee$(i) {
                    for (;;)
                      switch ((i.prev = i.next)) {
                        case 0:
                          if (
                            ((r = t.encoding),
                            (a = t.fetchBuiltInCMap),
                            (o = t.useCMap),
                            !(0, l.isName)(r))
                          ) {
                            i.next = 7;
                            break;
                          }
                          return i.abrupt(
                            "return",
                            createBuiltInCMap(r.name, a),
                          );
                        case 7:
                          if (!(0, l.isStream)(r)) {
                            i.next = 11;
                            break;
                          }
                          return (
                            (u = new m()),
                            (h = new c.Lexer(r)),
                            i.abrupt(
                              "return",
                              parseCMap(u, h, a, o).then(function (t) {
                                return t.isIdentityCMap
                                  ? createBuiltInCMap(t.name, a)
                                  : t;
                              }),
                            )
                          );
                        case 11:
                          throw new Error("Encoding required.");
                        case 12:
                        case "end":
                          return i.stop();
                      }
                  }, _callee);
                }),
              )();
            },
          };
        })();
      r.CMapFactory = y;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.getFontType = getFontType),
        (r.IdentityToUnicodeMap =
          r.ToUnicodeMap =
          r.FontFlags =
          r.Font =
          r.ErrorFont =
          r.SEAC_ANALYSIS_ENABLED =
            void 0);
      var i = a(5),
        o = a(223),
        l = a(226),
        c = a(225),
        u = a(227),
        h = a(228),
        d = a(201),
        p = a(229),
        m = a(221),
        g = a(205),
        b = a(230);
      function _createForOfIteratorHelper(t, r) {
        var a;
        if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
          if (
            Array.isArray(t) ||
            (a = _unsupportedIterableToArray(t)) ||
            (r && t && "number" == typeof t.length)
          ) {
            a && (t = a);
            var i = 0,
              o = function F() {};
            return {
              s: o,
              n: function n() {
                return i >= t.length
                  ? { done: !0 }
                  : { done: !1, value: t[i++] };
              },
              e: function e(t) {
                throw t;
              },
              f: o,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var l,
          c = !0,
          u = !1;
        return {
          s: function s() {
            a = t[Symbol.iterator]();
          },
          n: function n() {
            var t = a.next();
            return (c = t.done), t;
          },
          e: function e(t) {
            (u = !0), (l = t);
          },
          f: function f() {
            try {
              c || null == a.return || a.return();
            } finally {
              if (u) throw l;
            }
          },
        };
      }
      function _slicedToArray(t, r) {
        return (
          (function _arrayWithHoles(t) {
            if (Array.isArray(t)) return t;
          })(t) ||
          (function _iterableToArrayLimit(t, r) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
              return;
            var a = [],
              i = !0,
              o = !1,
              l = void 0;
            try {
              for (
                var c, u = t[Symbol.iterator]();
                !(i = (c = u.next()).done) &&
                (a.push(c.value), !r || a.length !== r);
                i = !0
              );
            } catch (t) {
              (o = !0), (l = t);
            } finally {
              try {
                i || null == u.return || u.return();
              } finally {
                if (o) throw l;
              }
            }
            return a;
          })(t, r) ||
          _unsupportedIterableToArray(t, r) ||
          (function _nonIterableRest() {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
            );
          })()
        );
      }
      function _unsupportedIterableToArray(t, r) {
        if (t) {
          if ("string" == typeof t) return _arrayLikeToArray(t, r);
          var a = Object.prototype.toString.call(t).slice(8, -1);
          return (
            "Object" === a && t.constructor && (a = t.constructor.name),
            "Map" === a || "Set" === a
              ? Array.from(t)
              : "Arguments" === a ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)
              ? _arrayLikeToArray(t, r)
              : void 0
          );
        }
      }
      function _arrayLikeToArray(t, r) {
        (null == r || r > t.length) && (r = t.length);
        for (var a = 0, i = new Array(r); a < r; a++) i[a] = t[a];
        return i;
      }
      var y = [
          [57344, 63743],
          [1048576, 1114109],
        ],
        v = 1e3,
        S = !0;
      r.SEAC_ANALYSIS_ENABLED = S;
      var k = [
          "ascent",
          "bbox",
          "black",
          "bold",
          "charProcOperatorList",
          "composite",
          "data",
          "defaultVMetrics",
          "defaultWidth",
          "descent",
          "fallbackName",
          "fontMatrix",
          "fontType",
          "isMonospace",
          "isSerifFont",
          "isType3Font",
          "italic",
          "loadedName",
          "mimetype",
          "missingFile",
          "name",
          "remeasure",
          "subtype",
          "type",
          "vertical",
        ],
        w = [
          "cMap",
          "defaultEncoding",
          "differences",
          "isSymbolicFont",
          "seacMap",
          "toFontChar",
          "toUnicode",
          "vmetrics",
          "widths",
        ],
        C = {
          FixedPitch: 1,
          Serif: 2,
          Symbolic: 4,
          Script: 8,
          Nonsymbolic: 32,
          Italic: 64,
          AllCap: 65536,
          SmallCap: 131072,
          ForceBold: 262144,
        };
      r.FontFlags = C;
      var x = [
        ".notdef",
        ".null",
        "nonmarkingreturn",
        "space",
        "exclam",
        "quotedbl",
        "numbersign",
        "dollar",
        "percent",
        "ampersand",
        "quotesingle",
        "parenleft",
        "parenright",
        "asterisk",
        "plus",
        "comma",
        "hyphen",
        "period",
        "slash",
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "colon",
        "semicolon",
        "less",
        "equal",
        "greater",
        "question",
        "at",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "bracketleft",
        "backslash",
        "bracketright",
        "asciicircum",
        "underscore",
        "grave",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "braceleft",
        "bar",
        "braceright",
        "asciitilde",
        "Adieresis",
        "Aring",
        "Ccedilla",
        "Eacute",
        "Ntilde",
        "Odieresis",
        "Udieresis",
        "aacute",
        "agrave",
        "acircumflex",
        "adieresis",
        "atilde",
        "aring",
        "ccedilla",
        "eacute",
        "egrave",
        "ecircumflex",
        "edieresis",
        "iacute",
        "igrave",
        "icircumflex",
        "idieresis",
        "ntilde",
        "oacute",
        "ograve",
        "ocircumflex",
        "odieresis",
        "otilde",
        "uacute",
        "ugrave",
        "ucircumflex",
        "udieresis",
        "dagger",
        "degree",
        "cent",
        "sterling",
        "section",
        "bullet",
        "paragraph",
        "germandbls",
        "registered",
        "copyright",
        "trademark",
        "acute",
        "dieresis",
        "notequal",
        "AE",
        "Oslash",
        "infinity",
        "plusminus",
        "lessequal",
        "greaterequal",
        "yen",
        "mu",
        "partialdiff",
        "summation",
        "product",
        "pi",
        "integral",
        "ordfeminine",
        "ordmasculine",
        "Omega",
        "ae",
        "oslash",
        "questiondown",
        "exclamdown",
        "logicalnot",
        "radical",
        "florin",
        "approxequal",
        "Delta",
        "guillemotleft",
        "guillemotright",
        "ellipsis",
        "nonbreakingspace",
        "Agrave",
        "Atilde",
        "Otilde",
        "OE",
        "oe",
        "endash",
        "emdash",
        "quotedblleft",
        "quotedblright",
        "quoteleft",
        "quoteright",
        "divide",
        "lozenge",
        "ydieresis",
        "Ydieresis",
        "fraction",
        "currency",
        "guilsinglleft",
        "guilsinglright",
        "fi",
        "fl",
        "daggerdbl",
        "periodcentered",
        "quotesinglbase",
        "quotedblbase",
        "perthousand",
        "Acircumflex",
        "Ecircumflex",
        "Aacute",
        "Edieresis",
        "Egrave",
        "Iacute",
        "Icircumflex",
        "Idieresis",
        "Igrave",
        "Oacute",
        "Ocircumflex",
        "apple",
        "Ograve",
        "Uacute",
        "Ucircumflex",
        "Ugrave",
        "dotlessi",
        "circumflex",
        "tilde",
        "macron",
        "breve",
        "dotaccent",
        "ring",
        "cedilla",
        "hungarumlaut",
        "ogonek",
        "caron",
        "Lslash",
        "lslash",
        "Scaron",
        "scaron",
        "Zcaron",
        "zcaron",
        "brokenbar",
        "Eth",
        "eth",
        "Yacute",
        "yacute",
        "Thorn",
        "thorn",
        "minus",
        "multiply",
        "onesuperior",
        "twosuperior",
        "threesuperior",
        "onehalf",
        "onequarter",
        "threequarters",
        "franc",
        "Gbreve",
        "gbreve",
        "Idotaccent",
        "Scedilla",
        "scedilla",
        "Cacute",
        "cacute",
        "Ccaron",
        "ccaron",
        "dcroat",
      ];
      function adjustWidths(t) {
        if (t.fontMatrix && t.fontMatrix[0] !== i.FONT_IDENTITY_MATRIX[0]) {
          var r = 0.001 / t.fontMatrix[0],
            a = t.widths;
          for (var o in a) a[o] *= r;
          t.defaultWidth *= r;
        }
      }
      function getFontType(t, r) {
        switch (t) {
          case "Type1":
            return "Type1C" === r ? i.FontType.TYPE1C : i.FontType.TYPE1;
          case "CIDFontType0":
            return "CIDFontType0C" === r
              ? i.FontType.CIDFONTTYPE0C
              : i.FontType.CIDFONTTYPE0;
          case "OpenType":
            return i.FontType.OPENTYPE;
          case "TrueType":
            return i.FontType.TRUETYPE;
          case "CIDFontType2":
            return i.FontType.CIDFONTTYPE2;
          case "MMType1":
            return i.FontType.MMTYPE1;
          case "Type0":
            return i.FontType.TYPE0;
          default:
            return i.FontType.UNKNOWN;
        }
      }
      function recoverGlyphName(t, r) {
        if (void 0 !== r[t]) return t;
        var a = (0, h.getUnicodeForGlyph)(t, r);
        if (-1 !== a) for (var o in r) if (r[o] === a) return o;
        return (
          (0, i.info)("Unable to recover a standard glyph name for: " + t), t
        );
      }
      var _ = (function GlyphClosure() {
          function Glyph(t, r, a, i, o, l, c, u) {
            (this.fontChar = t),
              (this.unicode = r),
              (this.accent = a),
              (this.width = i),
              (this.vmetric = o),
              (this.operatorListId = l),
              (this.isSpace = c),
              (this.isInFont = u);
          }
          return (
            (Glyph.prototype.matchesForCache = function (
              t,
              r,
              a,
              i,
              o,
              l,
              c,
              u,
            ) {
              return (
                this.fontChar === t &&
                this.unicode === r &&
                this.accent === a &&
                this.width === i &&
                this.vmetric === o &&
                this.operatorListId === l &&
                this.isSpace === c &&
                this.isInFont === u
              );
            }),
            Glyph
          );
        })(),
        A = (function ToUnicodeMapClosure() {
          function ToUnicodeMap() {
            var t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : [];
            this._map = t;
          }
          return (
            (ToUnicodeMap.prototype = {
              get length() {
                return this._map.length;
              },
              forEach: function forEach(t) {
                for (var r in this._map) t(r, this._map[r].charCodeAt(0));
              },
              has: function has(t) {
                return void 0 !== this._map[t];
              },
              get: function get(t) {
                return this._map[t];
              },
              charCodeOf: function charCodeOf(t) {
                var r = this._map;
                if (r.length <= 65536) return r.indexOf(t);
                for (var a in r) if (r[a] === t) return 0 | a;
                return -1;
              },
              amend: function amend(t) {
                for (var r in t) this._map[r] = t[r];
              },
            }),
            ToUnicodeMap
          );
        })();
      r.ToUnicodeMap = A;
      var R = (function IdentityToUnicodeMapClosure() {
        function IdentityToUnicodeMap(t, r) {
          (this.firstChar = t), (this.lastChar = r);
        }
        return (
          (IdentityToUnicodeMap.prototype = {
            get length() {
              return this.lastChar + 1 - this.firstChar;
            },
            forEach: function forEach(t) {
              for (var r = this.firstChar, a = this.lastChar; r <= a; r++)
                t(r, r);
            },
            has: function has(t) {
              return this.firstChar <= t && t <= this.lastChar;
            },
            get: function get(t) {
              if (this.firstChar <= t && t <= this.lastChar)
                return String.fromCharCode(t);
            },
            charCodeOf: function charCodeOf(t) {
              return Number.isInteger(t) &&
                t >= this.firstChar &&
                t <= this.lastChar
                ? t
                : -1;
            },
            amend: function amend(t) {
              (0, i.unreachable)("Should not call amend()");
            },
          }),
          IdentityToUnicodeMap
        );
      })();
      r.IdentityToUnicodeMap = R;
      var T = (function OpenTypeFileBuilderClosure() {
          function writeInt16(t, r, a) {
            (t[r] = (a >> 8) & 255), (t[r + 1] = 255 & a);
          }
          function writeInt32(t, r, a) {
            (t[r] = (a >> 24) & 255),
              (t[r + 1] = (a >> 16) & 255),
              (t[r + 2] = (a >> 8) & 255),
              (t[r + 3] = 255 & a);
          }
          function writeData(t, r, a) {
            var i, o;
            if (a instanceof Uint8Array) t.set(a, r);
            else if ("string" == typeof a)
              for (i = 0, o = a.length; i < o; i++)
                t[r++] = 255 & a.charCodeAt(i);
            else for (i = 0, o = a.length; i < o; i++) t[r++] = 255 & a[i];
          }
          function OpenTypeFileBuilder(t) {
            (this.sfnt = t), (this.tables = Object.create(null));
          }
          OpenTypeFileBuilder.getSearchParams =
            function OpenTypeFileBuilder_getSearchParams(t, r) {
              for (var a = 1, i = 0; (a ^ t) > a; ) (a <<= 1), i++;
              var o = a * r;
              return { range: o, entry: i, rangeShift: r * t - o };
            };
          return (
            (OpenTypeFileBuilder.prototype = {
              toArray: function OpenTypeFileBuilder_toArray() {
                var t = this.sfnt,
                  r = this.tables,
                  a = Object.keys(r);
                a.sort();
                var o,
                  l,
                  c,
                  u,
                  h,
                  p = a.length,
                  m = 12 + 16 * p,
                  g = [m];
                for (o = 0; o < p; o++) {
                  (m += (((u = r[a[o]]).length + 3) & -4) >>> 0), g.push(m);
                }
                var b = new Uint8Array(m);
                for (o = 0; o < p; o++) (u = r[a[o]]), writeData(b, g[o], u);
                "true" === t && (t = (0, i.string32)(65536)),
                  (b[0] = 255 & t.charCodeAt(0)),
                  (b[1] = 255 & t.charCodeAt(1)),
                  (b[2] = 255 & t.charCodeAt(2)),
                  (b[3] = 255 & t.charCodeAt(3)),
                  writeInt16(b, 4, p);
                var y = OpenTypeFileBuilder.getSearchParams(p, 16);
                for (
                  writeInt16(b, 6, y.range),
                    writeInt16(b, 8, y.entry),
                    writeInt16(b, 10, y.rangeShift),
                    m = 12,
                    o = 0;
                  o < p;
                  o++
                ) {
                  (h = a[o]),
                    (b[m] = 255 & h.charCodeAt(0)),
                    (b[m + 1] = 255 & h.charCodeAt(1)),
                    (b[m + 2] = 255 & h.charCodeAt(2)),
                    (b[m + 3] = 255 & h.charCodeAt(3));
                  var v = 0;
                  for (l = g[o], c = g[o + 1]; l < c; l += 4) {
                    v = (v + (0, d.readUint32)(b, l)) >>> 0;
                  }
                  writeInt32(b, m + 4, v),
                    writeInt32(b, m + 8, g[o]),
                    writeInt32(b, m + 12, r[h].length),
                    (m += 16);
                }
                return b;
              },
              addTable: function OpenTypeFileBuilder_addTable(t, r) {
                if (t in this.tables)
                  throw new Error("Table " + t + " already exists");
                this.tables[t] = r;
              },
            }),
            OpenTypeFileBuilder
          );
        })(),
        I = (function FontClosure() {
          function Font(t, r, a) {
            var o;
            (this.name = t),
              (this.loadedName = a.loadedName),
              (this.isType3Font = a.isType3Font),
              (this.missingFile = !1),
              (this.glyphCache = Object.create(null)),
              (this.isSerifFont = !!(a.flags & C.Serif)),
              (this.isSymbolicFont = !!(a.flags & C.Symbolic)),
              (this.isMonospace = !!(a.flags & C.FixedPitch));
            var l = a.type,
              c = a.subtype;
            (this.type = l), (this.subtype = c);
            var u = "sans-serif";
            if (
              (this.isMonospace
                ? (u = "monospace")
                : this.isSerifFont && (u = "serif"),
              (this.fallbackName = u),
              (this.differences = a.differences),
              (this.widths = a.widths),
              (this.defaultWidth = a.defaultWidth),
              (this.composite = a.composite),
              (this.cMap = a.cMap),
              (this.ascent = a.ascent / v),
              (this.descent = a.descent / v),
              (this.fontMatrix = a.fontMatrix),
              (this.bbox = a.bbox),
              (this.defaultEncoding = a.defaultEncoding),
              (this.toUnicode = a.toUnicode),
              (this.fallbackToUnicode = a.fallbackToUnicode || new A()),
              (this.toFontChar = []),
              "Type3" !== a.type)
            ) {
              if (
                ((this.cidEncoding = a.cidEncoding),
                (this.vertical = !!a.vertical),
                this.vertical &&
                  ((this.vmetrics = a.vmetrics),
                  (this.defaultVMetrics = a.defaultVMetrics)),
                !r || r.isEmpty)
              )
                return (
                  r &&
                    (0, i.warn)(
                      'Font file is empty in "' +
                        t +
                        '" (' +
                        this.loadedName +
                        ")",
                    ),
                  void this.fallbackToSystemFont()
                );
              var h = _slicedToArray(
                (function getFontFileType(t, r) {
                  var a,
                    o,
                    l = r.type,
                    c = r.subtype,
                    u = r.composite;
                  (function isTrueTypeFile(t) {
                    var r = t.peekBytes(4);
                    return (
                      65536 === (0, d.readUint32)(r, 0) ||
                      "true" === (0, i.bytesToString)(r)
                    );
                  })(t) || isTrueTypeCollectionFile(t)
                    ? (a = u ? "CIDFontType2" : "TrueType")
                    : !(function isOpenTypeFile(t) {
                        var r = t.peekBytes(4);
                        return "OTTO" === (0, i.bytesToString)(r);
                      })(t)
                    ? !(function isType1File(t) {
                        var r = t.peekBytes(2);
                        if (37 === r[0] && 33 === r[1]) return !0;
                        if (128 === r[0] && 1 === r[1]) return !0;
                        return !1;
                      })(t)
                      ? !(function isCFFFile(t) {
                          var r = t.peekBytes(4);
                          if (r[0] >= 1 && r[3] >= 1 && r[3] <= 4) return !0;
                          return !1;
                        })(t)
                        ? ((0, i.warn)(
                            "getFontFileType: Unable to detect correct font file Type/Subtype.",
                          ),
                          (a = l),
                          (o = c))
                        : u
                        ? ((a = "CIDFontType0"), (o = "CIDFontType0C"))
                        : ((a = "MMType1" === l ? "MMType1" : "Type1"),
                          (o = "Type1C"))
                      : (a = u
                          ? "CIDFontType0"
                          : "MMType1" === l
                          ? "MMType1"
                          : "Type1")
                    : (a = u ? "CIDFontType2" : "OpenType");
                  return [a, o];
                })(r, a),
                2,
              );
              (l = h[0]),
                (c = h[1]),
                (l === this.type && c === this.subtype) ||
                  (0, i.info)(
                    "Inconsistent font file Type/SubType, expected: " +
                      ""
                        .concat(this.type, "/")
                        .concat(this.subtype, " but found: ")
                        .concat(l, "/")
                        .concat(c, "."),
                  );
              try {
                var p;
                switch (l) {
                  case "MMType1":
                    (0, i.info)(
                      "MMType1 font (" + t + "), falling back to Type1.",
                    );
                  case "Type1":
                  case "CIDFontType0":
                    this.mimetype = "font/opentype";
                    var m =
                      "Type1C" === c || "CIDFontType0C" === c
                        ? new E(r, a)
                        : new O(t, r, a);
                    adjustWidths(a), (p = this.convert(t, m, a));
                    break;
                  case "OpenType":
                  case "TrueType":
                  case "CIDFontType2":
                    (this.mimetype = "font/opentype"),
                      (p = this.checkAndRepair(t, r, a)),
                      this.isOpenType && (adjustWidths(a), (l = "OpenType"));
                    break;
                  default:
                    throw new i.FormatError(
                      "Font ".concat(l, " is not supported"),
                    );
                }
              } catch (t) {
                return (0, i.warn)(t), void this.fallbackToSystemFont();
              }
              (this.data = p),
                (this.fontType = getFontType(l, c)),
                (this.fontMatrix = a.fontMatrix),
                (this.widths = a.widths),
                (this.defaultWidth = a.defaultWidth),
                (this.toUnicode = a.toUnicode),
                (this.seacMap = a.seacMap);
            } else {
              for (o = 0; o < 256; o++)
                this.toFontChar[o] =
                  this.differences[o] || a.defaultEncoding[o];
              this.fontType = i.FontType.TYPE3;
            }
          }
          var t;
          function int16(t, r) {
            return (t << 8) + r;
          }
          function signedInt16(t, r) {
            var a = (t << 8) + r;
            return 32768 & a ? a - 65536 : a;
          }
          function string16(t) {
            return String.fromCharCode((t >> 8) & 255, 255 & t);
          }
          function safeString16(t) {
            return (
              t > 32767 ? (t = 32767) : t < -32768 && (t = -32768),
              String.fromCharCode((t >> 8) & 255, 255 & t)
            );
          }
          function isTrueTypeCollectionFile(t) {
            var r = t.peekBytes(4);
            return "ttcf" === (0, i.bytesToString)(r);
          }
          function buildToFontChar(t, r, a) {
            for (var i, o = [], l = 0, c = t.length; l < c; l++)
              -1 !== (i = (0, h.getUnicodeForGlyph)(t[l], r)) && (o[l] = i);
            for (var u in a)
              -1 !== (i = (0, h.getUnicodeForGlyph)(a[u], r)) && (o[+u] = i);
            return o;
          }
          function adjustMapping(t, r, a) {
            var o = Object.create(null),
              l = [],
              c = 0,
              u = y[c][0],
              h = y[c][1];
            for (var d in t) {
              var p = t[(d |= 0)];
              if (r(p)) {
                if (u > h) {
                  if (++c >= y.length) {
                    (0, i.warn)("Ran out of space in font private use area.");
                    break;
                  }
                  (u = y[c][0]), (h = y[c][1]);
                }
                var m = u++;
                0 === p && (p = a), (o[m] = p), (l[d] = m);
              }
            }
            return {
              toFontChar: l,
              charCodeToGlyphId: o,
              nextAvailableFontCharCode: u,
            };
          }
          function createCmapTable(t, r) {
            var a,
              o,
              l,
              c,
              u = (function getRanges(t, r) {
                var a = [];
                for (var i in t)
                  t[i] >= r || a.push({ fontCharCode: 0 | i, glyphId: t[i] });
                0 === a.length && a.push({ fontCharCode: 0, glyphId: 0 }),
                  a.sort(function fontGetRangesSort(t, r) {
                    return t.fontCharCode - r.fontCharCode;
                  });
                for (var o = [], l = a.length, c = 0; c < l; ) {
                  var u = a[c].fontCharCode,
                    h = [a[c].glyphId];
                  ++c;
                  for (
                    var d = u;
                    c < l &&
                    d + 1 === a[c].fontCharCode &&
                    (h.push(a[c].glyphId), ++c, 65535 != ++d);

                  );
                  o.push([u, d, h]);
                }
                return o;
              })(t, r),
              h = u[u.length - 1][1] > 65535 ? 2 : 1,
              d = "\0\0" + string16(h) + "\0\0" + (0, i.string32)(4 + 8 * h);
            for (a = u.length - 1; a >= 0 && !(u[a][0] <= 65535); --a);
            var p = a + 1;
            u[a][0] < 65535 && 65535 === u[a][1] && (u[a][1] = 65534);
            var m,
              g,
              b,
              y,
              v = u[a][1] < 65535 ? 1 : 0,
              S = p + v,
              k = T.getSearchParams(S, 2),
              w = "",
              C = "",
              x = "",
              _ = "",
              A = "",
              R = 0;
            for (a = 0, o = p; a < o; a++) {
              (g = (m = u[a])[0]),
                (b = m[1]),
                (w += string16(g)),
                (C += string16(b));
              var I = !0;
              for (l = 1, c = (y = m[2]).length; l < c; ++l)
                if (y[l] !== y[l - 1] + 1) {
                  I = !1;
                  break;
                }
              if (I) {
                (x += string16((y[0] - g) & 65535)), (_ += string16(0));
              } else {
                var P = 2 * (S - a) + 2 * R;
                for (
                  R += b - g + 1,
                    x += string16(0),
                    _ += string16(P),
                    l = 0,
                    c = y.length;
                  l < c;
                  ++l
                )
                  A += string16(y[l]);
              }
            }
            v > 0 && ((C += "ÿÿ"), (w += "ÿÿ"), (x += "\0"), (_ += "\0\0"));
            var O =
                "\0\0" +
                string16(2 * S) +
                string16(k.range) +
                string16(k.entry) +
                string16(k.rangeShift) +
                C +
                "\0\0" +
                w +
                x +
                _ +
                A,
              E = "",
              B = "";
            if (h > 1) {
              for (
                d += "\0\0\n" + (0, i.string32)(4 + 8 * h + 4 + O.length),
                  E = "",
                  a = 0,
                  o = u.length;
                a < o;
                a++
              ) {
                g = (m = u[a])[0];
                var D = (y = m[2])[0];
                for (l = 1, c = y.length; l < c; ++l)
                  y[l] !== y[l - 1] + 1 &&
                    ((b = m[0] + l - 1),
                    (E +=
                      (0, i.string32)(g) +
                      (0, i.string32)(b) +
                      (0, i.string32)(D)),
                    (g = b + 1),
                    (D = y[l]));
                E +=
                  (0, i.string32)(g) +
                  (0, i.string32)(m[1]) +
                  (0, i.string32)(D);
              }
              B =
                "\0\f\0\0" +
                (0, i.string32)(E.length + 16) +
                "\0\0\0\0" +
                (0, i.string32)(E.length / 12);
            }
            return d + "\0" + string16(O.length + 4) + O + B + E;
          }
          function createOS2Table(t, r, a) {
            a = a || { unitsPerEm: 0, yMax: 0, yMin: 0, ascent: 0, descent: 0 };
            var o = 0,
              l = 0,
              c = 0,
              u = 0,
              d = null,
              p = 0;
            if (r) {
              for (var m in r) {
                (d > (m |= 0) || !d) && (d = m), p < m && (p = m);
                var g = (0, h.getUnicodeRangeFor)(m);
                if (g < 32) o |= 1 << g;
                else if (g < 64) l |= 1 << (g - 32);
                else if (g < 96) c |= 1 << (g - 64);
                else {
                  if (!(g < 123))
                    throw new i.FormatError(
                      "Unicode ranges Bits > 123 are reserved for internal usage",
                    );
                  u |= 1 << (g - 96);
                }
              }
              p > 65535 && (p = 65535);
            } else (d = 0), (p = 255);
            var b = t.bbox || [0, 0, 0, 0],
              y =
                a.unitsPerEm || 1 / (t.fontMatrix || i.FONT_IDENTITY_MATRIX)[0],
              S = t.ascentScaled ? 1 : y / v,
              k = a.ascent || Math.round(S * (t.ascent || b[3])),
              w = a.descent || Math.round(S * (t.descent || b[1]));
            w > 0 && t.descent > 0 && b[1] < 0 && (w = -w);
            var C = a.yMax || k,
              x = -a.yMin || -w;
            return (
              "\0$ô\0\0\0»\0\0\0»\0\0ß\x001\0\0\0\0" +
              String.fromCharCode(t.fixedPitch ? 9 : 0) +
              "\0\0\0\0\0\0" +
              (0, i.string32)(o) +
              (0, i.string32)(l) +
              (0, i.string32)(c) +
              (0, i.string32)(u) +
              "*21*" +
              string16(t.italicAngle ? 1 : 0) +
              string16(d || t.firstChar) +
              string16(p || t.lastChar) +
              string16(k) +
              string16(w) +
              "\0d" +
              string16(C) +
              string16(x) +
              "\0\0\0\0\0\0\0\0" +
              string16(t.xHeight) +
              string16(t.capHeight) +
              string16(0) +
              string16(d || t.firstChar) +
              "\0"
            );
          }
          function createPostTable(t) {
            var r = Math.floor(t.italicAngle * Math.pow(2, 16));
            return (
              "\0\0\0" +
              (0, i.string32)(r) +
              "\0\0\0\0" +
              (0, i.string32)(t.fixedPitch) +
              "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0"
            );
          }
          function createNameTable(t, r) {
            r || (r = [[], []]);
            var a,
              i,
              o,
              l,
              c,
              u = [
                r[0][0] || "Original licence",
                r[0][1] || t,
                r[0][2] || "Unknown",
                r[0][3] || "uniqueID",
                r[0][4] || t,
                r[0][5] || "Version 0.11",
                r[0][6] || "",
                r[0][7] || "Unknown",
                r[0][8] || "Unknown",
                r[0][9] || "Unknown",
              ],
              h = [];
            for (a = 0, i = u.length; a < i; a++) {
              var d = [];
              for (o = 0, l = (c = r[1][a] || u[a]).length; o < l; o++)
                d.push(string16(c.charCodeAt(o)));
              h.push(d.join(""));
            }
            var p = [u, h],
              m = ["\0", "\0"],
              g = ["\0\0", "\0"],
              b = ["\0\0", "\t"],
              y = u.length * m.length,
              v = "\0\0" + string16(y) + string16(12 * y + 6),
              S = 0;
            for (a = 0, i = m.length; a < i; a++) {
              var k = p[a];
              for (o = 0, l = k.length; o < l; o++) {
                (c = k[o]),
                  (v +=
                    m[a] +
                    g[a] +
                    b[a] +
                    string16(o) +
                    string16(c.length) +
                    string16(S)),
                  (S += c.length);
              }
            }
            return (v += u.join("") + h.join(""));
          }
          return (
            (Font.getFontID =
              ((t = 1),
              function Font_getFontID() {
                return String(t++);
              })),
            (Font.prototype = {
              name: null,
              font: null,
              mimetype: null,
              disableFontFace: !1,
              get renderer() {
                var t = p.FontRendererFactory.create(this, S);
                return (0, i.shadow)(this, "renderer", t);
              },
              exportData: function exportData() {
                var t,
                  r,
                  a,
                  i =
                    arguments.length > 0 &&
                    void 0 !== arguments[0] &&
                    arguments[0],
                  o = i ? [].concat(k, w) : k,
                  l = Object.create(null),
                  c = _createForOfIteratorHelper(o);
                try {
                  for (c.s(); !(a = c.n()).done; )
                    void 0 !== (r = this[(t = a.value)]) && (l[t] = r);
                } catch (t) {
                  c.e(t);
                } finally {
                  c.f();
                }
                return l;
              },
              fallbackToSystemFont: function Font_fallbackToSystemFont() {
                var t = this;
                this.missingFile = !0;
                var r = this.name,
                  a = this.type,
                  o = this.subtype,
                  d = r.replace(/[,_]/g, "-").replace(/\s/g, ""),
                  p = (0, u.getStdFontMap)(),
                  m = (0, u.getNonStdFontMap)(),
                  g = !!p[d] || !(!m[d] || !p[m[d]]);
                if (
                  ((d = p[d] || m[d] || d),
                  (this.bold = -1 !== d.search(/bold/gi)),
                  (this.italic =
                    -1 !== d.search(/oblique/gi) ||
                    -1 !== d.search(/italic/gi)),
                  (this.black = -1 !== r.search(/Black/g)),
                  (this.remeasure = Object.keys(this.widths).length > 0),
                  g &&
                    "CIDFontType2" === a &&
                    this.cidEncoding.startsWith("Identity-"))
                ) {
                  var b = (0, u.getGlyphMapForStandardFonts)(),
                    y = [];
                  for (var v in b) y[+v] = b[v];
                  if (/Arial-?Black/i.test(r)) {
                    var S = (0, u.getSupplementalGlyphMapForArialBlack)();
                    for (var k in S) y[+k] = S[k];
                  } else if (/Calibri/i.test(r)) {
                    var w = (0, u.getSupplementalGlyphMapForCalibri)();
                    for (var C in w) y[+C] = w[C];
                  }
                  this.toUnicode instanceof R ||
                    this.toUnicode.forEach(function (t, r) {
                      y[+t] = r;
                    }),
                    (this.toFontChar = y),
                    (this.toUnicode = new A(y));
                } else if (/Symbol/i.test(d))
                  this.toFontChar = buildToFontChar(
                    c.SymbolSetEncoding,
                    (0, l.getGlyphsUnicode)(),
                    this.differences,
                  );
                else if (/Dingbats/i.test(d))
                  /Wingdings/i.test(r) &&
                    (0, i.warn)(
                      "Non-embedded Wingdings font, falling back to ZapfDingbats.",
                    ),
                    (this.toFontChar = buildToFontChar(
                      c.ZapfDingbatsEncoding,
                      (0, l.getDingbatsGlyphsUnicode)(),
                      this.differences,
                    ));
                else if (g)
                  this.toFontChar = buildToFontChar(
                    this.defaultEncoding,
                    (0, l.getGlyphsUnicode)(),
                    this.differences,
                  );
                else {
                  var x = (0, l.getGlyphsUnicode)(),
                    _ = [];
                  if (
                    (this.toUnicode.forEach(function (r, a) {
                      if (!t.composite) {
                        var i = t.differences[r] || t.defaultEncoding[r],
                          o = (0, h.getUnicodeForGlyph)(i, x);
                        -1 !== o && (a = o);
                      }
                      _[+r] = a;
                    }),
                    this.composite &&
                      this.toUnicode instanceof R &&
                      /Verdana/i.test(r))
                  ) {
                    var T = (0, u.getGlyphMapForStandardFonts)();
                    for (var I in T) _[+I] = T[I];
                  }
                  this.toFontChar = _;
                }
                (this.loadedName = d.split("-")[0]),
                  (this.fontType = getFontType(a, o));
              },
              checkAndRepair: function Font_checkAndRepair(t, r, a) {
                var u = [
                  "OS/2",
                  "cmap",
                  "head",
                  "hhea",
                  "hmtx",
                  "maxp",
                  "name",
                  "post",
                  "loca",
                  "glyf",
                  "fpgm",
                  "prep",
                  "cvt ",
                  "CFF ",
                ];
                function readTables(t, r) {
                  var a = Object.create(null);
                  (a["OS/2"] = null),
                    (a.cmap = null),
                    (a.head = null),
                    (a.hhea = null),
                    (a.hmtx = null),
                    (a.maxp = null),
                    (a.name = null),
                    (a.post = null);
                  for (var i = 0; i < r; i++) {
                    var o = readTableEntry(t);
                    u.includes(o.tag) && 0 !== o.length && (a[o.tag] = o);
                  }
                  return a;
                }
                function readTableEntry(t) {
                  var r = (0, i.bytesToString)(t.getBytes(4)),
                    a = t.getInt32() >>> 0,
                    o = t.getInt32() >>> 0,
                    l = t.getInt32() >>> 0,
                    c = t.pos;
                  (t.pos = t.start ? t.start : 0), t.skip(o);
                  var u = t.getBytes(l);
                  return (
                    (t.pos = c),
                    "head" === r &&
                      ((u[8] = u[9] = u[10] = u[11] = 0), (u[17] |= 32)),
                    { tag: r, checksum: a, length: l, offset: o, data: u }
                  );
                }
                function readOpenTypeHeader(t) {
                  return {
                    version: (0, i.bytesToString)(t.getBytes(4)),
                    numTables: t.getUint16(),
                    searchRange: t.getUint16(),
                    entrySelector: t.getUint16(),
                    rangeShift: t.getUint16(),
                  };
                }
                function sanitizeGlyph(t, r, a, i, o, l) {
                  var c = { length: 0, sizeOfInstructions: 0 };
                  if (a - r <= 12) return c;
                  var u = t.subarray(r, a),
                    h = signedInt16(u[0], u[1]);
                  if (h < 0)
                    return (
                      (function writeSignedInt16(t, r, a) {
                        (t[r + 1] = a), (t[r] = a >>> 8);
                      })(u, 0, (h = -1)),
                      i.set(u, o),
                      (c.length = u.length),
                      c
                    );
                  var d,
                    p = 10,
                    m = 0;
                  for (d = 0; d < h; d++) {
                    (m = ((u[p] << 8) | u[p + 1]) + 1), (p += 2);
                  }
                  var g = p,
                    b = (u[p] << 8) | u[p + 1];
                  c.sizeOfInstructions = b;
                  var y = (p += 2 + b),
                    v = 0;
                  for (d = 0; d < m; d++) {
                    var S = u[p++];
                    192 & S && (u[p - 1] = 63 & S);
                    var k = 2;
                    2 & S ? (k = 1) : 16 & S && (k = 0);
                    var w = 2;
                    4 & S ? (w = 1) : 32 & S && (w = 0);
                    var C = k + w;
                    if (((v += C), 8 & S)) {
                      var x = u[p++];
                      (d += x), (v += x * C);
                    }
                  }
                  if (0 === v) return c;
                  var _ = p + v;
                  return _ > u.length
                    ? c
                    : !l && b > 0
                    ? (i.set(u.subarray(0, g), o),
                      i.set([0, 0], o + g),
                      i.set(u.subarray(y, _), o + g + 2),
                      (_ -= b),
                      u.length - _ > 3 && (_ = (_ + 3) & -4),
                      (c.length = _),
                      c)
                    : u.length - _ > 3
                    ? ((_ = (_ + 3) & -4),
                      i.set(u.subarray(0, _), o),
                      (c.length = _),
                      c)
                    : (i.set(u, o), (c.length = u.length), c);
                }
                function readNameTable(t) {
                  var a = (r.start ? r.start : 0) + t.offset;
                  r.pos = a;
                  var o = [[], []],
                    l = t.length,
                    c = a + l;
                  if (0 !== r.getUint16() || l < 6) return o;
                  var u,
                    h,
                    d = r.getUint16(),
                    p = r.getUint16(),
                    m = [];
                  for (u = 0; u < d && r.pos + 12 <= c; u++) {
                    var g = {
                      platform: r.getUint16(),
                      encoding: r.getUint16(),
                      language: r.getUint16(),
                      name: r.getUint16(),
                      length: r.getUint16(),
                      offset: r.getUint16(),
                    };
                    ((1 === g.platform &&
                      0 === g.encoding &&
                      0 === g.language) ||
                      (3 === g.platform &&
                        1 === g.encoding &&
                        1033 === g.language)) &&
                      m.push(g);
                  }
                  for (u = 0, h = m.length; u < h; u++) {
                    var b = m[u];
                    if (!(b.length <= 0)) {
                      var y = a + p + b.offset;
                      if (!(y + b.length > c)) {
                        r.pos = y;
                        var v = b.name;
                        if (b.encoding) {
                          for (var S = "", k = 0, w = b.length; k < w; k += 2)
                            S += String.fromCharCode(r.getUint16());
                          o[1][v] = S;
                        } else
                          o[0][v] = (0, i.bytesToString)(r.getBytes(b.length));
                      }
                    }
                  }
                  return o;
                }
                var h,
                  d,
                  p,
                  b,
                  y = [
                    0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1,
                    -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1,
                    -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0,
                    0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0,
                    -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0,
                    -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999,
                    -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0,
                    0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1,
                    -1, -2,
                  ];
                function sanitizeTTProgram(t, r) {
                  for (
                    var a,
                      o,
                      l,
                      c,
                      u,
                      h = t.data,
                      d = 0,
                      p = 0,
                      m = 0,
                      g = [],
                      b = [],
                      v = [],
                      S = r.tooComplexToFollowFunctions,
                      k = !1,
                      w = 0,
                      C = 0,
                      x = h.length;
                    d < x;

                  ) {
                    var _ = h[d++];
                    if (64 === _)
                      if (((o = h[d++]), k || C)) d += o;
                      else for (a = 0; a < o; a++) g.push(h[d++]);
                    else if (65 === _)
                      if (((o = h[d++]), k || C)) d += 2 * o;
                      else
                        for (a = 0; a < o; a++)
                          (l = h[d++]), g.push((l << 8) | h[d++]);
                    else if (176 == (248 & _))
                      if (((o = _ - 176 + 1), k || C)) d += o;
                      else for (a = 0; a < o; a++) g.push(h[d++]);
                    else if (184 == (248 & _))
                      if (((o = _ - 184 + 1), k || C)) d += 2 * o;
                      else
                        for (a = 0; a < o; a++)
                          (l = h[d++]), g.push((l << 8) | h[d++]);
                    else if (43 !== _ || S)
                      if (44 !== _ || S) {
                        if (45 === _)
                          if (k) (k = !1), (p = d);
                          else {
                            if (!(u = b.pop()))
                              return (
                                (0, i.warn)("TT: ENDF bad stack"),
                                void (r.hintsValid = !1)
                              );
                            (c = v.pop()),
                              (h = u.data),
                              (d = u.i),
                              (r.functionsStackDeltas[c] =
                                g.length - u.stackTop);
                          }
                        else if (137 === _)
                          (k || C) &&
                            ((0, i.warn)("TT: nested IDEFs not allowed"),
                            (S = !0)),
                            (k = !0),
                            (m = d);
                        else if (88 === _) ++w;
                        else if (27 === _) C = w;
                        else if (89 === _) C === w && (C = 0), --w;
                        else if (28 === _ && !k && !C) {
                          var A = g[g.length - 1];
                          A > 0 && (d += A - 1);
                        }
                      } else
                        (k || C) &&
                          ((0, i.warn)("TT: nested FDEFs not allowed"),
                          (S = !0)),
                          (k = !0),
                          (m = d),
                          (c = g.pop()),
                          (r.functionsDefined[c] = { data: h, i: d });
                    else if (!k && !C)
                      if (((c = g[g.length - 1]), isNaN(c)))
                        (0, i.info)("TT: CALL empty stack (or invalid entry).");
                      else if (
                        ((r.functionsUsed[c] = !0), c in r.functionsStackDeltas)
                      ) {
                        var R = g.length + r.functionsStackDeltas[c];
                        if (R < 0)
                          return (
                            (0, i.warn)(
                              "TT: CALL invalid functions stack delta.",
                            ),
                            void (r.hintsValid = !1)
                          );
                        g.length = R;
                      } else if (c in r.functionsDefined && !v.includes(c)) {
                        if (
                          (b.push({ data: h, i: d, stackTop: g.length - 1 }),
                          v.push(c),
                          !(u = r.functionsDefined[c]))
                        )
                          return (
                            (0, i.warn)("TT: CALL non-existent function"),
                            void (r.hintsValid = !1)
                          );
                        (h = u.data), (d = u.i);
                      }
                    if (!k && !C) {
                      var T = 0;
                      for (
                        _ <= 142
                          ? (T = y[_])
                          : _ >= 192 && _ <= 223
                          ? (T = -1)
                          : _ >= 224 && (T = -2),
                          _ >= 113 &&
                            _ <= 117 &&
                            ((o = g.pop()), isNaN(o) || (T = 2 * -o));
                        T < 0 && g.length > 0;

                      )
                        g.pop(), T++;
                      for (; T > 0; ) g.push(NaN), T--;
                    }
                  }
                  r.tooComplexToFollowFunctions = S;
                  var I = [h];
                  d > h.length && I.push(new Uint8Array(d - h.length)),
                    m > p &&
                      ((0, i.warn)("TT: complementing a missing function tail"),
                      I.push(new Uint8Array([34, 45]))),
                    (function foldTTTable(t, r) {
                      if (r.length > 1) {
                        var a,
                          i,
                          o = 0;
                        for (a = 0, i = r.length; a < i; a++) o += r[a].length;
                        o = (o + 3) & -4;
                        var l = new Uint8Array(o),
                          c = 0;
                        for (a = 0, i = r.length; a < i; a++)
                          l.set(r[a], c), (c += r[a].length);
                        (t.data = l), (t.length = o);
                      }
                    })(t, I);
                }
                if (
                  isTrueTypeCollectionFile(
                    (r = new g.Stream(new Uint8Array(r.getBytes()))),
                  )
                ) {
                  var v = (function readTrueTypeCollectionData(t, r) {
                    for (
                      var a = (function readTrueTypeCollectionHeader(t) {
                          var r = (0, i.bytesToString)(t.getBytes(4));
                          (0, i.assert)(
                            "ttcf" === r,
                            "Must be a TrueType Collection font.",
                          );
                          for (
                            var a = t.getUint16(),
                              o = t.getUint16(),
                              l = t.getInt32() >>> 0,
                              c = [],
                              u = 0;
                            u < l;
                            u++
                          )
                            c.push(t.getInt32() >>> 0);
                          var h = {
                            ttcTag: r,
                            majorVersion: a,
                            minorVersion: o,
                            numFonts: l,
                            offsetTable: c,
                          };
                          switch (a) {
                            case 1:
                              return h;
                            case 2:
                              return (
                                (h.dsigTag = t.getInt32() >>> 0),
                                (h.dsigLength = t.getInt32() >>> 0),
                                (h.dsigOffset = t.getInt32() >>> 0),
                                h
                              );
                          }
                          throw new i.FormatError(
                            "Invalid TrueType Collection majorVersion: ".concat(
                              a,
                              ".",
                            ),
                          );
                        })(t),
                        o = a.numFonts,
                        l = a.offsetTable,
                        c = 0;
                      c < o;
                      c++
                    ) {
                      t.pos = (t.start || 0) + l[c];
                      var u = readOpenTypeHeader(t),
                        h = readTables(t, u.numTables);
                      if (!h.name)
                        throw new i.FormatError(
                          'TrueType Collection font must contain a "name" table.',
                        );
                      for (
                        var d = readNameTable(h.name), p = 0, m = d.length;
                        p < m;
                        p++
                      )
                        for (var g = 0, b = d[p].length; g < b; g++) {
                          var y = d[p][g];
                          if (y && y.replace(/\s/g, "") === r)
                            return { header: u, tables: h };
                        }
                    }
                    throw new i.FormatError(
                      'TrueType Collection does not contain "'.concat(
                        r,
                        '" font.',
                      ),
                    );
                  })(r, this.name);
                  (h = v.header), (d = v.tables);
                } else
                  (h = readOpenTypeHeader(r)), (d = readTables(r, h.numTables));
                var k = !d["CFF "];
                if (k) {
                  if (!d.loca)
                    throw new i.FormatError(
                      'Required "loca" table is not found',
                    );
                  d.glyf ||
                    ((0, i.warn)(
                      'Required "glyf" table is not found -- trying to recover.',
                    ),
                    (d.glyf = { tag: "glyf", data: new Uint8Array(0) })),
                    (this.isOpenType = !1);
                } else {
                  var w =
                    a.composite &&
                    ((a.cidToGidMap || []).length > 0 ||
                      !(a.cMap instanceof m.IdentityCMap));
                  if (
                    ("OTTO" === h.version && !w) ||
                    !d.head ||
                    !d.hhea ||
                    !d.maxp ||
                    !d.post
                  )
                    return (
                      (b = new g.Stream(d["CFF "].data)),
                      (p = new E(b, a)),
                      adjustWidths(a),
                      this.convert(t, p, a)
                    );
                  delete d.glyf,
                    delete d.loca,
                    delete d.fpgm,
                    delete d.prep,
                    delete d["cvt "],
                    (this.isOpenType = !0);
                }
                if (!d.maxp)
                  throw new i.FormatError('Required "maxp" table is not found');
                r.pos = (r.start || 0) + d.maxp.offset;
                var C = r.getInt32(),
                  _ = r.getUint16(),
                  A = _ + 1,
                  R = !0;
                A > 65535 &&
                  ((R = !1),
                  (A = _),
                  (0, i.warn)(
                    "Not enough space in glyfs to duplicate first glyph.",
                  ));
                var I = 0,
                  P = 0;
                C >= 65536 &&
                  d.maxp.length >= 22 &&
                  ((r.pos += 8),
                  r.getUint16() > 2 &&
                    ((d.maxp.data[14] = 0), (d.maxp.data[15] = 2)),
                  (r.pos += 4),
                  (I = r.getUint16()),
                  (r.pos += 4),
                  (P = r.getUint16()));
                (d.maxp.data[4] = A >> 8), (d.maxp.data[5] = 255 & A);
                var O = (function sanitizeTTPrograms(t, r, a, o) {
                  var l = {
                    functionsDefined: [],
                    functionsUsed: [],
                    functionsStackDeltas: [],
                    tooComplexToFollowFunctions: !1,
                    hintsValid: !0,
                  };
                  if (
                    (t && sanitizeTTProgram(t, l),
                    r && sanitizeTTProgram(r, l),
                    t &&
                      (function checkInvalidFunctions(t, r) {
                        if (!t.tooComplexToFollowFunctions) {
                          if (t.functionsDefined.length > r)
                            return (
                              (0, i.warn)(
                                "TT: more functions defined than expected",
                              ),
                              void (t.hintsValid = !1)
                            );
                          for (
                            var a = 0, o = t.functionsUsed.length;
                            a < o;
                            a++
                          ) {
                            if (a > r)
                              return (
                                (0, i.warn)("TT: invalid function id: " + a),
                                void (t.hintsValid = !1)
                              );
                            if (t.functionsUsed[a] && !t.functionsDefined[a])
                              return (
                                (0, i.warn)("TT: undefined function: " + a),
                                void (t.hintsValid = !1)
                              );
                          }
                        }
                      })(l, o),
                    a && 1 & a.length)
                  ) {
                    var c = new Uint8Array(a.length + 1);
                    c.set(a.data), (a.data = c);
                  }
                  return l.hintsValid;
                })(d.fpgm, d.prep, d["cvt "], I);
                if (
                  (O || (delete d.fpgm, delete d.prep, delete d["cvt "]),
                  (function sanitizeMetrics(t, r, a, o, l) {
                    if (r) {
                      (t.pos = (t.start ? t.start : 0) + r.offset),
                        (t.pos += 4),
                        (t.pos += 2),
                        (t.pos += 2),
                        (t.pos += 2),
                        (t.pos += 2),
                        (t.pos += 2),
                        (t.pos += 2),
                        (t.pos += 2),
                        (t.pos += 2),
                        (t.pos += 2),
                        (t.pos += 2),
                        (t.pos += 8),
                        (t.pos += 2);
                      var c = t.getUint16();
                      c > o &&
                        ((0, i.info)(
                          "The numOfMetrics (" +
                            c +
                            ") should not be greater than the numGlyphs (" +
                            o +
                            ")",
                        ),
                        (c = o),
                        (r.data[34] = (65280 & c) >> 8),
                        (r.data[35] = 255 & c));
                      var u = o - c - ((a.length - 4 * c) >> 1);
                      if (u > 0) {
                        var h = new Uint8Array(a.length + 2 * u);
                        h.set(a.data),
                          l &&
                            ((h[a.length] = a.data[2]),
                            (h[a.length + 1] = a.data[3])),
                          (a.data = h);
                      }
                    } else a && (a.data = null);
                  })(r, d.hhea, d.hmtx, A, R),
                  !d.head)
                )
                  throw new i.FormatError('Required "head" table is not found');
                !(function sanitizeHead(t, r, a) {
                  var o = t.data,
                    l = (function int32(t, r, a, i) {
                      return (t << 24) + (r << 16) + (a << 8) + i;
                    })(o[0], o[1], o[2], o[3]);
                  l >> 16 != 1 &&
                    ((0, i.info)(
                      "Attempting to fix invalid version in head table: " + l,
                    ),
                    (o[0] = 0),
                    (o[1] = 1),
                    (o[2] = 0),
                    (o[3] = 0));
                  var c = int16(o[50], o[51]);
                  if (c < 0 || c > 1) {
                    (0, i.info)(
                      "Attempting to fix invalid indexToLocFormat in head table: " +
                        c,
                    );
                    var u = r + 1;
                    if (a === u << 1) (o[50] = 0), (o[51] = 0);
                    else {
                      if (a !== u << 2)
                        throw new i.FormatError(
                          "Could not fix indexToLocFormat: " + c,
                        );
                      (o[50] = 0), (o[51] = 1);
                    }
                  }
                })(d.head, _, k ? d.loca.length : 0);
                var B = Object.create(null);
                if (k) {
                  var D = int16(d.head.data[50], d.head.data[51]),
                    M = (function sanitizeGlyphLocations(t, r, a, i, o, l, c) {
                      var u, h, d;
                      i
                        ? ((u = 4),
                          (h = function fontItemDecodeLong(t, r) {
                            return (
                              (t[r] << 24) |
                              (t[r + 1] << 16) |
                              (t[r + 2] << 8) |
                              t[r + 3]
                            );
                          }),
                          (d = function fontItemEncodeLong(t, r, a) {
                            (t[r] = (a >>> 24) & 255),
                              (t[r + 1] = (a >> 16) & 255),
                              (t[r + 2] = (a >> 8) & 255),
                              (t[r + 3] = 255 & a);
                          }))
                        : ((u = 2),
                          (h = function fontItemDecode(t, r) {
                            return (t[r] << 9) | (t[r + 1] << 1);
                          }),
                          (d = function fontItemEncode(t, r, a) {
                            (t[r] = (a >> 9) & 255),
                              (t[r + 1] = (a >> 1) & 255);
                          }));
                      var p = l ? a + 1 : a,
                        m = u * (1 + p),
                        g = new Uint8Array(m);
                      g.set(t.data.subarray(0, m)), (t.data = g);
                      var b,
                        y,
                        v = r.data,
                        S = v.length,
                        k = new Uint8Array(S),
                        w = h(g, 0),
                        C = 0,
                        x = Object.create(null);
                      for (d(g, 0, C), b = 0, y = u; b < a; b++, y += u) {
                        var _ = h(g, y);
                        0 === _ && (_ = w),
                          _ > S && ((S + 3) & -4) === _ && (_ = S),
                          _ > S && (w = _);
                        var A = sanitizeGlyph(v, w, _, k, C, o),
                          R = A.length;
                        0 === R && (x[b] = !0),
                          A.sizeOfInstructions > c &&
                            (c = A.sizeOfInstructions),
                          d(g, y, (C += R)),
                          (w = _);
                      }
                      if (0 === C) {
                        var T = new Uint8Array([
                          0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0,
                        ]);
                        for (b = 0, y = u; b < p; b++, y += u)
                          d(g, y, T.length);
                        r.data = T;
                      } else if (l) {
                        var I = h(g, u);
                        k.length > I + C
                          ? (r.data = k.subarray(0, I + C))
                          : ((r.data = new Uint8Array(I + C)),
                            r.data.set(k.subarray(0, C))),
                          r.data.set(k.subarray(0, I), C),
                          d(t.data, g.length - u, C + I);
                      } else r.data = k.subarray(0, C);
                      return { missingGlyphs: x, maxSizeOfInstructions: c };
                    })(d.loca, d.glyf, _, D, O, R, P);
                  (B = M.missingGlyphs),
                    C >= 65536 &&
                      d.maxp.length >= 22 &&
                      ((d.maxp.data[26] = M.maxSizeOfInstructions >> 8),
                      (d.maxp.data[27] = 255 & M.maxSizeOfInstructions));
                }
                if (!d.hhea)
                  throw new i.FormatError('Required "hhea" table is not found');
                0 === d.hhea.data[10] &&
                  0 === d.hhea.data[11] &&
                  ((d.hhea.data[10] = 255), (d.hhea.data[11] = 255));
                var L = {
                  unitsPerEm: int16(d.head.data[18], d.head.data[19]),
                  yMax: int16(d.head.data[42], d.head.data[43]),
                  yMin: signedInt16(d.head.data[38], d.head.data[39]),
                  ascent: int16(d.hhea.data[4], d.hhea.data[5]),
                  descent: signedInt16(d.hhea.data[6], d.hhea.data[7]),
                };
                (this.ascent = L.ascent / L.unitsPerEm),
                  (this.descent = L.descent / L.unitsPerEm),
                  d.post &&
                    (function readPostScriptTable(t, a, o) {
                      var l = (r.start ? r.start : 0) + t.offset;
                      r.pos = l;
                      var c,
                        u = l + t.length,
                        h = r.getInt32();
                      r.skip(28);
                      var d,
                        p = !0;
                      switch (h) {
                        case 65536:
                          c = x;
                          break;
                        case 131072:
                          var m = r.getUint16();
                          if (m !== o) {
                            p = !1;
                            break;
                          }
                          var g = [];
                          for (d = 0; d < m; ++d) {
                            var b = r.getUint16();
                            if (b >= 32768) {
                              p = !1;
                              break;
                            }
                            g.push(b);
                          }
                          if (!p) break;
                          for (var y = [], v = []; r.pos < u; ) {
                            var S = r.getByte();
                            for (v.length = S, d = 0; d < S; ++d)
                              v[d] = String.fromCharCode(r.getByte());
                            y.push(v.join(""));
                          }
                          for (c = [], d = 0; d < m; ++d) {
                            var k = g[d];
                            k < 258 ? c.push(x[k]) : c.push(y[k - 258]);
                          }
                          break;
                        case 196608:
                          break;
                        default:
                          (0, i.warn)(
                            "Unknown/unsupported post table version " + h,
                          ),
                            (p = !1),
                            a.defaultEncoding && (c = a.defaultEncoding);
                      }
                      return (a.glyphNames = c), p;
                    })(d.post, a, _),
                  (d.post = { tag: "post", data: createPostTable(a) });
                var N = [];
                function hasGlyph(t) {
                  return !B[t];
                }
                if (a.composite) {
                  var U = a.cidToGidMap || [],
                    j = 0 === U.length;
                  a.cMap.forEach(function (t, r) {
                    if (r > 65535)
                      throw new i.FormatError("Max size of CID is 65,535");
                    var a = -1;
                    j ? (a = r) : void 0 !== U[r] && (a = U[r]),
                      a >= 0 && a < _ && hasGlyph(a) && (N[t] = a);
                  });
                } else {
                  var q = (function readCmapTable(t, r, a, o) {
                      if (!t)
                        return (
                          (0, i.warn)("No cmap table available."),
                          {
                            platformId: -1,
                            encodingId: -1,
                            mappings: [],
                            hasShortCmap: !1,
                          }
                        );
                      var l,
                        c = (r.start ? r.start : 0) + t.offset;
                      (r.pos = c), r.skip(2);
                      for (
                        var u, h = r.getUint16(), d = !1, p = 0;
                        p < h;
                        p++
                      ) {
                        var m = r.getUint16(),
                          g = r.getUint16(),
                          b = r.getInt32() >>> 0,
                          y = !1;
                        if (
                          (!u || u.platformId !== m || u.encodingId !== g) &&
                          ((0 === m && 0 === g) || (1 === m && 0 === g)
                            ? (y = !0)
                            : 3 !== m || 1 !== g || (!o && u)
                            ? a && 3 === m && 0 === g && ((y = !0), (d = !0))
                            : ((y = !0), a || (d = !0)),
                          y &&
                            (u = { platformId: m, encodingId: g, offset: b }),
                          d)
                        )
                          break;
                      }
                      if (
                        (u && (r.pos = c + u.offset), !u || -1 === r.peekByte())
                      )
                        return (
                          (0, i.warn)("Could not find a preferred cmap table."),
                          {
                            platformId: -1,
                            encodingId: -1,
                            mappings: [],
                            hasShortCmap: !1,
                          }
                        );
                      var v = r.getUint16();
                      r.skip(4);
                      var S,
                        k,
                        w = !1,
                        C = [];
                      if (0 === v) {
                        for (S = 0; S < 256; S++) {
                          var x = r.getByte();
                          x && C.push({ charCode: S, glyphId: x });
                        }
                        w = !0;
                      } else if (4 === v) {
                        var _ = r.getUint16() >> 1;
                        r.skip(6);
                        var A,
                          R = [];
                        for (A = 0; A < _; A++) R.push({ end: r.getUint16() });
                        for (r.skip(2), A = 0; A < _; A++)
                          R[A].start = r.getUint16();
                        for (A = 0; A < _; A++) R[A].delta = r.getUint16();
                        var T = 0;
                        for (A = 0; A < _; A++) {
                          l = R[A];
                          var I = r.getUint16();
                          if (I) {
                            var P = (I >> 1) - (_ - A);
                            (l.offsetIndex = P),
                              (T = Math.max(T, P + l.end - l.start + 1));
                          } else l.offsetIndex = -1;
                        }
                        var O = [];
                        for (S = 0; S < T; S++) O.push(r.getUint16());
                        for (A = 0; A < _; A++) {
                          c = (l = R[A]).start;
                          var E = l.end,
                            B = l.delta;
                          for (P = l.offsetIndex, S = c; S <= E; S++)
                            65535 !== S &&
                              ((k =
                                ((k = P < 0 ? S : O[P + S - c]) + B) & 65535),
                              C.push({ charCode: S, glyphId: k }));
                        }
                      } else {
                        if (6 !== v)
                          return (
                            (0, i.warn)(
                              "cmap table has unsupported format: " + v,
                            ),
                            {
                              platformId: -1,
                              encodingId: -1,
                              mappings: [],
                              hasShortCmap: !1,
                            }
                          );
                        var D = r.getUint16(),
                          M = r.getUint16();
                        for (S = 0; S < M; S++) {
                          k = r.getUint16();
                          var L = D + S;
                          C.push({ charCode: L, glyphId: k });
                        }
                      }
                      for (
                        C.sort(function (t, r) {
                          return t.charCode - r.charCode;
                        }),
                          p = 1;
                        p < C.length;
                        p++
                      )
                        C[p - 1].charCode === C[p].charCode &&
                          (C.splice(p, 1), p--);
                      return {
                        platformId: u.platformId,
                        encodingId: u.encodingId,
                        mappings: C,
                        hasShortCmap: w,
                      };
                    })(d.cmap, r, this.isSymbolicFont, a.hasEncoding),
                    W = q.platformId,
                    z = q.encodingId,
                    G = q.mappings,
                    H = G.length;
                  if (
                    (a.hasEncoding &&
                      ((3 === W && 1 === z) || (1 === W && 0 === z))) ||
                    (-1 === W &&
                      -1 === z &&
                      (0, c.getEncoding)(a.baseEncodingName))
                  ) {
                    var X = [];
                    ("MacRomanEncoding" !== a.baseEncodingName &&
                      "WinAnsiEncoding" !== a.baseEncodingName) ||
                      (X = (0, c.getEncoding)(a.baseEncodingName));
                    for (
                      var V = (0, l.getGlyphsUnicode)(), Y = 0;
                      Y < 256;
                      Y++
                    ) {
                      var K, J;
                      if (
                        (K =
                          this.differences && Y in this.differences
                            ? this.differences[Y]
                            : Y in X && "" !== X[Y]
                            ? X[Y]
                            : c.StandardEncoding[Y])
                      ) {
                        var Z;
                        (J = recoverGlyphName(K, V)),
                          3 === W && 1 === z
                            ? (Z = V[J])
                            : 1 === W &&
                              0 === z &&
                              (Z = c.MacRomanEncoding.indexOf(J));
                        for (var Q = !1, $ = 0; $ < H; ++$)
                          if (G[$].charCode === Z) {
                            (N[Y] = G[$].glyphId), (Q = !0);
                            break;
                          }
                        if (!Q && a.glyphNames) {
                          var ee = a.glyphNames.indexOf(K);
                          -1 === ee &&
                            J !== K &&
                            (ee = a.glyphNames.indexOf(J)),
                            ee > 0 && hasGlyph(ee) && (N[Y] = ee);
                        }
                      }
                    }
                  } else if (0 === W && 0 === z)
                    for (var te = 0; te < H; ++te)
                      N[G[te].charCode] = G[te].glyphId;
                  else
                    for (var re = 0; re < H; ++re) {
                      var ae = G[re].charCode;
                      3 === W && ae >= 61440 && ae <= 61695 && (ae &= 255),
                        (N[ae] = G[re].glyphId);
                    }
                }
                0 === N.length && (N[0] = 0);
                var ne = A - 1;
                R || (ne = 0);
                var ie = adjustMapping(N, hasGlyph, ne);
                if (
                  ((this.toFontChar = ie.toFontChar),
                  (d.cmap = {
                    tag: "cmap",
                    data: createCmapTable(ie.charCodeToGlyphId, A),
                  }),
                  (d["OS/2"] &&
                    (function validateOS2Table(t, r) {
                      r.pos = (r.start || 0) + t.offset;
                      var a = r.getUint16();
                      r.skip(60);
                      var i = r.getUint16();
                      return !(
                        (a < 4 && 768 & i) ||
                        r.getUint16() > r.getUint16() ||
                        (r.skip(6),
                        0 === r.getUint16() || ((t.data[8] = t.data[9] = 0), 0))
                      );
                    })(d["OS/2"], r)) ||
                    (d["OS/2"] = {
                      tag: "OS/2",
                      data: createOS2Table(a, ie.charCodeToGlyphId, L),
                    }),
                  !k)
                )
                  try {
                    (b = new g.Stream(d["CFF "].data)),
                      (p = new o.CFFParser(
                        b,
                        a,
                        S,
                      ).parse()).duplicateFirstGlyph();
                    var oe = new o.CFFCompiler(p);
                    d["CFF "].data = oe.compile();
                  } catch (t) {
                    (0, i.warn)("Failed to compile font " + a.loadedName);
                  }
                if (d.name) {
                  var se = readNameTable(d.name);
                  d.name.data = createNameTable(t, se);
                } else
                  d.name = { tag: "name", data: createNameTable(this.name) };
                var le = new T(h.version);
                for (var ce in d) le.addTable(ce, d[ce].data);
                return le.toArray();
              },
              convert: function Font_convert(t, r, a) {
                (a.fixedPitch = !1),
                  a.builtInEncoding &&
                    (function adjustToUnicode(t, r) {
                      if (
                        !t.hasIncludedToUnicodeMap &&
                        !(
                          t.hasEncoding ||
                          r === t.defaultEncoding ||
                          t.toUnicode instanceof R
                        )
                      ) {
                        var a = [],
                          i = (0, l.getGlyphsUnicode)();
                        for (var o in r) {
                          var c = r[o],
                            u = (0, h.getUnicodeForGlyph)(c, i);
                          -1 !== u && (a[o] = String.fromCharCode(u));
                        }
                        t.toUnicode.amend(a);
                      }
                    })(a, a.builtInEncoding);
                var o = 1;
                r instanceof E && (o = r.numGlyphs - 1);
                var u = r.getGlyphMapping(a),
                  d = adjustMapping(u, r.hasGlyphId.bind(r), o);
                this.toFontChar = d.toFontChar;
                var p = r.numGlyphs;
                function getCharCodes(t, r) {
                  var a = null;
                  for (var i in t) r === t[i] && (a || (a = []), a.push(0 | i));
                  return a;
                }
                function createCharCode(t, r) {
                  for (var a in t) if (r === t[a]) return 0 | a;
                  return (
                    (d.charCodeToGlyphId[d.nextAvailableFontCharCode] = r),
                    d.nextAvailableFontCharCode++
                  );
                }
                var m = r.seacs;
                if (m && m.length) {
                  var g = a.fontMatrix || i.FONT_IDENTITY_MATRIX,
                    b = r.getCharset(),
                    y = Object.create(null);
                  for (var v in m) {
                    var S = m[(v |= 0)],
                      k = c.StandardEncoding[S[2]],
                      w = c.StandardEncoding[S[3]],
                      C = b.indexOf(k),
                      x = b.indexOf(w);
                    if (!(C < 0 || x < 0)) {
                      var _ = {
                          x: S[0] * g[0] + S[1] * g[2] + g[4],
                          y: S[0] * g[1] + S[1] * g[3] + g[5],
                        },
                        A = getCharCodes(u, v);
                      if (A)
                        for (var I = 0, P = A.length; I < P; I++) {
                          var O = A[I],
                            B = d.charCodeToGlyphId,
                            D = createCharCode(B, C),
                            M = createCharCode(B, x);
                          y[O] = {
                            baseFontCharCode: D,
                            accentFontCharCode: M,
                            accentOffset: _,
                          };
                        }
                    }
                  }
                  a.seacMap = y;
                }
                var L = 1 / (a.fontMatrix || i.FONT_IDENTITY_MATRIX)[0],
                  N = new T("OTTO");
                return (
                  N.addTable("CFF ", r.data),
                  N.addTable("OS/2", createOS2Table(a, d.charCodeToGlyphId)),
                  N.addTable("cmap", createCmapTable(d.charCodeToGlyphId, p)),
                  N.addTable(
                    "head",
                    "\0\0\0\0\0\0\0\0\0\0_<õ\0\0" +
                      safeString16(L) +
                      "\0\0\0\0\v~'\0\0\0\0\v~'\0\0" +
                      safeString16(a.descent) +
                      "ÿ" +
                      safeString16(a.ascent) +
                      string16(a.italicAngle ? 2 : 0) +
                      "\0\0\0\0\0\0\0",
                  ),
                  N.addTable(
                    "hhea",
                    "\0\0\0" +
                      safeString16(a.ascent) +
                      safeString16(a.descent) +
                      "\0\0ÿÿ\0\0\0\0\0\0" +
                      safeString16(a.capHeight) +
                      safeString16(Math.tan(a.italicAngle) * a.xHeight) +
                      "\0\0\0\0\0\0\0\0\0\0\0\0" +
                      string16(p),
                  ),
                  N.addTable(
                    "hmtx",
                    (function fontFieldsHmtx() {
                      for (
                        var t = r.charstrings,
                          a = r.cff ? r.cff.widths : null,
                          i = "\0\0\0\0",
                          o = 1,
                          l = p;
                        o < l;
                        o++
                      ) {
                        var c = 0;
                        if (t) {
                          var u = t[o - 1];
                          c = "width" in u ? u.width : 0;
                        } else a && (c = Math.ceil(a[o] || 0));
                        i += string16(c) + string16(0);
                      }
                      return i;
                    })(),
                  ),
                  N.addTable("maxp", "\0\0P\0" + string16(p)),
                  N.addTable("name", createNameTable(t)),
                  N.addTable("post", createPostTable(a)),
                  N.toArray()
                );
              },
              get spaceWidth() {
                for (
                  var t,
                    r = ["space", "minus", "one", "i", "I"],
                    a = 0,
                    o = r.length;
                  a < o;
                  a++
                ) {
                  var c = r[a];
                  if (c in this.widths) {
                    t = this.widths[c];
                    break;
                  }
                  var u = (0, l.getGlyphsUnicode)()[c],
                    h = 0;
                  if (
                    (this.composite &&
                      this.cMap.contains(u) &&
                      (h = this.cMap.lookup(u)),
                    !h && this.toUnicode && (h = this.toUnicode.charCodeOf(u)),
                    h <= 0 && (h = u),
                    (t = this.widths[h]))
                  )
                    break;
                }
                return (
                  (t = t || this.defaultWidth),
                  (0, i.shadow)(this, "spaceWidth", t)
                );
              },
              charToGlyph: function Font_charToGlyph(t, r) {
                var a,
                  o,
                  l,
                  c = t;
                this.cMap && this.cMap.contains(t) && (c = this.cMap.lookup(t)),
                  (o = this.widths[c]),
                  (o = (0, i.isNum)(o) ? o : this.defaultWidth);
                var u = this.vmetrics && this.vmetrics[c],
                  d =
                    this.toUnicode.get(t) || this.fallbackToUnicode.get(t) || t;
                "number" == typeof d && (d = String.fromCharCode(d));
                var p = t in this.toFontChar;
                if (((a = this.toFontChar[t] || t), this.missingFile)) {
                  var m = this.differences[t] || this.defaultEncoding[t];
                  (".notdef" !== m && "" !== m) ||
                    "Type1" !== this.type ||
                    (a = 32),
                    (a = (0, h.mapSpecialUnicodeValues)(a));
                }
                this.isType3Font && (l = a);
                var g = null;
                if (this.seacMap && this.seacMap[t]) {
                  p = !0;
                  var b = this.seacMap[t];
                  (a = b.baseFontCharCode),
                    (g = {
                      fontChar: String.fromCodePoint(b.accentFontCharCode),
                      offset: b.accentOffset,
                    });
                }
                var y = "";
                "number" == typeof a &&
                  (a <= 1114111
                    ? (y = String.fromCodePoint(a))
                    : (0, i.warn)(
                        "charToGlyph - invalid fontCharCode: ".concat(a),
                      ));
                var v = this.glyphCache[t];
                return (
                  (v && v.matchesForCache(y, d, g, o, u, l, r, p)) ||
                    ((v = new _(y, d, g, o, u, l, r, p)),
                    (this.glyphCache[t] = v)),
                  v
                );
              },
              charsToGlyphs: function Font_charsToGlyphs(t) {
                var r,
                  a,
                  i,
                  o = this.charsCache;
                if (o && (r = o[t])) return r;
                o || (o = this.charsCache = Object.create(null)), (r = []);
                var l,
                  c = t,
                  u = 0;
                if (this.cMap)
                  for (var h = Object.create(null); u < t.length; ) {
                    this.cMap.readCharCode(t, u, h), (i = h.charcode);
                    var d = h.length;
                    u += d;
                    var p = 1 === d && 32 === t.charCodeAt(u - 1);
                    (a = this.charToGlyph(i, p)), r.push(a);
                  }
                else
                  for (u = 0, l = t.length; u < l; ++u)
                    (i = t.charCodeAt(u)),
                      (a = this.charToGlyph(i, 32 === i)),
                      r.push(a);
                return (o[c] = r);
              },
              get glyphCacheValues() {
                return Object.values(this.glyphCache);
              },
            }),
            Font
          );
        })();
      r.Font = I;
      var P = (function ErrorFontClosure() {
        function ErrorFont(t) {
          (this.error = t),
            (this.loadedName = "g_font_error"),
            (this.missingFile = !0);
        }
        return (
          (ErrorFont.prototype = {
            charsToGlyphs: function ErrorFont_charsToGlyphs() {
              return [];
            },
            exportData: function exportData() {
              return { error: this.error };
            },
          }),
          ErrorFont
        );
      })();
      function type1FontGlyphMapping(t, r, a) {
        var i,
          o,
          u,
          h = Object.create(null),
          d = !!(t.flags & C.Symbolic);
        if (t.baseEncodingName)
          for (
            u = (0, c.getEncoding)(t.baseEncodingName), o = 0;
            o < u.length;
            o++
          )
            (i = a.indexOf(u[o])), (h[o] = i >= 0 ? i : 0);
        else if (d) for (o in r) h[o] = r[o];
        else
          for (u = c.StandardEncoding, o = 0; o < u.length; o++)
            (i = a.indexOf(u[o])), (h[o] = i >= 0 ? i : 0);
        var p,
          m = t.differences;
        if (m)
          for (o in m) {
            var g = m[o];
            if (-1 === (i = a.indexOf(g))) {
              p || (p = (0, l.getGlyphsUnicode)());
              var b = recoverGlyphName(g, p);
              b !== g && (i = a.indexOf(b));
            }
            h[o] = i >= 0 ? i : 0;
          }
        return h;
      }
      r.ErrorFont = P;
      var O = (function Type1FontClosure() {
          function findBlock(t, r, a) {
            for (
              var i, o = t.length, l = r.length, c = o - l, u = a, h = !1;
              u < c;

            ) {
              for (i = 0; i < l && t[u + i] === r[i]; ) i++;
              if (i >= l) {
                for (u += i; u < o && (0, d.isWhiteSpace)(t[u]); ) u++;
                h = !0;
                break;
              }
              u++;
            }
            return { found: h, length: u };
          }
          function Type1Font(t, r, a) {
            var o = a.length1,
              l = (a.length2, r.peekBytes(6)),
              c = 128 === l[0] && 1 === l[1];
            c &&
              (r.skip(6),
              (o = (l[5] << 24) | (l[4] << 16) | (l[3] << 8) | l[2]));
            var u = (function getHeaderBlock(t, r) {
              var a,
                o,
                l,
                c,
                u = [101, 101, 120, 101, 99],
                h = t.pos;
              try {
                o = (a = t.getBytes(r)).length;
              } catch (t) {
                if (t instanceof d.MissingDataException) throw t;
              }
              if (
                o === r &&
                (l = findBlock(a, u, r - 2 * u.length)).found &&
                l.length === r
              )
                return { stream: new g.Stream(a), length: r };
              for (
                (0, i.warn)(
                  'Invalid "Length1" property in Type1 font -- trying to recover.',
                ),
                  t.pos = h;
                0 !== (l = findBlock(t.peekBytes(2048), u, 0)).length;

              )
                if (((t.pos += l.length), l.found)) {
                  c = t.pos - h;
                  break;
                }
              return (
                (t.pos = h),
                c
                  ? { stream: new g.Stream(t.getBytes(c)), length: c }
                  : ((0, i.warn)(
                      'Unable to recover "Length1" property in Type1 font -- using as is.',
                    ),
                    { stream: new g.Stream(t.getBytes(r)), length: r })
              );
            })(r, o);
            new b.Type1Parser(u.stream, !1, S).extractFontHeader(a),
              c && ((l = r.getBytes(6))[5], l[4], l[3], l[2]);
            var h = (function getEexecBlock(t, r) {
                var a = t.getBytes();
                return { stream: new g.Stream(a), length: a.length };
              })(r),
              p = new b.Type1Parser(h.stream, !0, S).extractFontProgram(a);
            for (var m in p.properties) a[m] = p.properties[m];
            var y = p.charstrings,
              v = this.getType2Charstrings(y),
              k = this.getType2Subrs(p.subrs);
            (this.charstrings = y),
              (this.data = this.wrap(t, v, this.charstrings, k, a)),
              (this.seacs = this.getSeacs(p.charstrings));
          }
          return (
            (Type1Font.prototype = {
              get numGlyphs() {
                return this.charstrings.length + 1;
              },
              getCharset: function Type1Font_getCharset() {
                for (
                  var t = [".notdef"], r = this.charstrings, a = 0;
                  a < r.length;
                  a++
                )
                  t.push(r[a].glyphName);
                return t;
              },
              getGlyphMapping: function Type1Font_getGlyphMapping(t) {
                var r = this.charstrings;
                if (t.composite) {
                  for (
                    var a = Object.create(null), i = 0, o = r.length;
                    i < o;
                    i++
                  ) {
                    a[t.cMap.charCodeOf(i)] = i + 1;
                  }
                  return a;
                }
                var l,
                  c = [".notdef"];
                for (l = 0; l < r.length; l++) c.push(r[l].glyphName);
                var u = t.builtInEncoding;
                if (u) {
                  var h = Object.create(null);
                  for (var d in u) (l = c.indexOf(u[d])) >= 0 && (h[d] = l);
                }
                return type1FontGlyphMapping(t, h, c);
              },
              hasGlyphId: function Type1Font_hasGlyphID(t) {
                return (
                  !(t < 0 || t >= this.numGlyphs) &&
                  (0 === t || this.charstrings[t - 1].charstring.length > 0)
                );
              },
              getSeacs: function Type1Font_getSeacs(t) {
                var r,
                  a,
                  i = [];
                for (r = 0, a = t.length; r < a; r++) {
                  var o = t[r];
                  o.seac && (i[r + 1] = o.seac);
                }
                return i;
              },
              getType2Charstrings: function Type1Font_getType2Charstrings(t) {
                for (var r = [], a = 0, i = t.length; a < i; a++)
                  r.push(t[a].charstring);
                return r;
              },
              getType2Subrs: function Type1Font_getType2Subrs(t) {
                var r = 0,
                  a = t.length;
                r = a < 1133 ? 107 : a < 33769 ? 1131 : 32768;
                var i,
                  o = [];
                for (i = 0; i < r; i++) o.push([11]);
                for (i = 0; i < a; i++) o.push(t[i]);
                return o;
              },
              wrap: function Type1Font_wrap(t, r, a, i, l) {
                var c = new o.CFF();
                (c.header = new o.CFFHeader(1, 0, 4, 4)), (c.names = [t]);
                var u = new o.CFFTopDict();
                u.setByName("version", 391),
                  u.setByName("Notice", 392),
                  u.setByName("FullName", 393),
                  u.setByName("FamilyName", 394),
                  u.setByName("Weight", 395),
                  u.setByName("Encoding", null),
                  u.setByName("FontMatrix", l.fontMatrix),
                  u.setByName("FontBBox", l.bbox),
                  u.setByName("charset", null),
                  u.setByName("CharStrings", null),
                  u.setByName("Private", null),
                  (c.topDict = u);
                var h = new o.CFFStrings();
                h.add("Version 0.11"),
                  h.add("See original notice"),
                  h.add(t),
                  h.add(t),
                  h.add("Medium"),
                  (c.strings = h),
                  (c.globalSubrIndex = new o.CFFIndex());
                var d,
                  p,
                  m = r.length,
                  g = [".notdef"];
                for (d = 0; d < m; d++) {
                  var b = a[d].glyphName;
                  -1 === o.CFFStandardStrings.indexOf(b) && h.add(b), g.push(b);
                }
                c.charset = new o.CFFCharset(!1, 0, g);
                var y = new o.CFFIndex();
                for (y.add([139, 14]), d = 0; d < m; d++) y.add(r[d]);
                c.charStrings = y;
                var v = new o.CFFPrivateDict();
                v.setByName("Subrs", null);
                var S = [
                  "BlueValues",
                  "OtherBlues",
                  "FamilyBlues",
                  "FamilyOtherBlues",
                  "StemSnapH",
                  "StemSnapV",
                  "BlueShift",
                  "BlueFuzz",
                  "BlueScale",
                  "LanguageGroup",
                  "ExpansionFactor",
                  "ForceBold",
                  "StdHW",
                  "StdVW",
                ];
                for (d = 0, p = S.length; d < p; d++) {
                  var k = S[d];
                  if (k in l.privateData) {
                    var w = l.privateData[k];
                    if (Array.isArray(w))
                      for (var C = w.length - 1; C > 0; C--) w[C] -= w[C - 1];
                    v.setByName(k, w);
                  }
                }
                c.topDict.privateDict = v;
                var x = new o.CFFIndex();
                for (d = 0, p = i.length; d < p; d++) x.add(i[d]);
                return (v.subrsIndex = x), new o.CFFCompiler(c).compile();
              },
            }),
            Type1Font
          );
        })(),
        E = (function CFFFontClosure() {
          function CFFFont(t, r) {
            this.properties = r;
            var a = new o.CFFParser(t, r, S);
            (this.cff = a.parse()), this.cff.duplicateFirstGlyph();
            var l = new o.CFFCompiler(this.cff);
            this.seacs = this.cff.seacs;
            try {
              this.data = l.compile();
            } catch (a) {
              (0, i.warn)("Failed to compile font " + r.loadedName),
                (this.data = t);
            }
          }
          return (
            (CFFFont.prototype = {
              get numGlyphs() {
                return this.cff.charStrings.count;
              },
              getCharset: function CFFFont_getCharset() {
                return this.cff.charset.charset;
              },
              getGlyphMapping: function CFFFont_getGlyphMapping() {
                var t,
                  r,
                  a = this.cff,
                  i = this.properties,
                  o = a.charset.charset;
                if (i.composite) {
                  if (((t = Object.create(null)), a.isCIDFont))
                    for (r = 0; r < o.length; r++) {
                      var l = o[r];
                      t[i.cMap.charCodeOf(l)] = r;
                    }
                  else
                    for (r = 0; r < a.charStrings.count; r++)
                      t[i.cMap.charCodeOf(r)] = r;
                  return t;
                }
                return (t = type1FontGlyphMapping(
                  i,
                  a.encoding ? a.encoding.encoding : null,
                  o,
                ));
              },
              hasGlyphId: function CFFFont_hasGlyphID(t) {
                return this.cff.hasGlyphId(t);
              },
            }),
            CFFFont
          );
        })();
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.CFFFDSelect =
          r.CFFCompiler =
          r.CFFPrivateDict =
          r.CFFTopDict =
          r.CFFCharset =
          r.CFFIndex =
          r.CFFStrings =
          r.CFFHeader =
          r.CFF =
          r.CFFParser =
          r.CFFStandardStrings =
            void 0);
      var i = a(5),
        o = a(224),
        l = a(225),
        c = [
          ".notdef",
          "space",
          "exclam",
          "quotedbl",
          "numbersign",
          "dollar",
          "percent",
          "ampersand",
          "quoteright",
          "parenleft",
          "parenright",
          "asterisk",
          "plus",
          "comma",
          "hyphen",
          "period",
          "slash",
          "zero",
          "one",
          "two",
          "three",
          "four",
          "five",
          "six",
          "seven",
          "eight",
          "nine",
          "colon",
          "semicolon",
          "less",
          "equal",
          "greater",
          "question",
          "at",
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
          "bracketleft",
          "backslash",
          "bracketright",
          "asciicircum",
          "underscore",
          "quoteleft",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
          "braceleft",
          "bar",
          "braceright",
          "asciitilde",
          "exclamdown",
          "cent",
          "sterling",
          "fraction",
          "yen",
          "florin",
          "section",
          "currency",
          "quotesingle",
          "quotedblleft",
          "guillemotleft",
          "guilsinglleft",
          "guilsinglright",
          "fi",
          "fl",
          "endash",
          "dagger",
          "daggerdbl",
          "periodcentered",
          "paragraph",
          "bullet",
          "quotesinglbase",
          "quotedblbase",
          "quotedblright",
          "guillemotright",
          "ellipsis",
          "perthousand",
          "questiondown",
          "grave",
          "acute",
          "circumflex",
          "tilde",
          "macron",
          "breve",
          "dotaccent",
          "dieresis",
          "ring",
          "cedilla",
          "hungarumlaut",
          "ogonek",
          "caron",
          "emdash",
          "AE",
          "ordfeminine",
          "Lslash",
          "Oslash",
          "OE",
          "ordmasculine",
          "ae",
          "dotlessi",
          "lslash",
          "oslash",
          "oe",
          "germandbls",
          "onesuperior",
          "logicalnot",
          "mu",
          "trademark",
          "Eth",
          "onehalf",
          "plusminus",
          "Thorn",
          "onequarter",
          "divide",
          "brokenbar",
          "degree",
          "thorn",
          "threequarters",
          "twosuperior",
          "registered",
          "minus",
          "eth",
          "multiply",
          "threesuperior",
          "copyright",
          "Aacute",
          "Acircumflex",
          "Adieresis",
          "Agrave",
          "Aring",
          "Atilde",
          "Ccedilla",
          "Eacute",
          "Ecircumflex",
          "Edieresis",
          "Egrave",
          "Iacute",
          "Icircumflex",
          "Idieresis",
          "Igrave",
          "Ntilde",
          "Oacute",
          "Ocircumflex",
          "Odieresis",
          "Ograve",
          "Otilde",
          "Scaron",
          "Uacute",
          "Ucircumflex",
          "Udieresis",
          "Ugrave",
          "Yacute",
          "Ydieresis",
          "Zcaron",
          "aacute",
          "acircumflex",
          "adieresis",
          "agrave",
          "aring",
          "atilde",
          "ccedilla",
          "eacute",
          "ecircumflex",
          "edieresis",
          "egrave",
          "iacute",
          "icircumflex",
          "idieresis",
          "igrave",
          "ntilde",
          "oacute",
          "ocircumflex",
          "odieresis",
          "ograve",
          "otilde",
          "scaron",
          "uacute",
          "ucircumflex",
          "udieresis",
          "ugrave",
          "yacute",
          "ydieresis",
          "zcaron",
          "exclamsmall",
          "Hungarumlautsmall",
          "dollaroldstyle",
          "dollarsuperior",
          "ampersandsmall",
          "Acutesmall",
          "parenleftsuperior",
          "parenrightsuperior",
          "twodotenleader",
          "onedotenleader",
          "zerooldstyle",
          "oneoldstyle",
          "twooldstyle",
          "threeoldstyle",
          "fouroldstyle",
          "fiveoldstyle",
          "sixoldstyle",
          "sevenoldstyle",
          "eightoldstyle",
          "nineoldstyle",
          "commasuperior",
          "threequartersemdash",
          "periodsuperior",
          "questionsmall",
          "asuperior",
          "bsuperior",
          "centsuperior",
          "dsuperior",
          "esuperior",
          "isuperior",
          "lsuperior",
          "msuperior",
          "nsuperior",
          "osuperior",
          "rsuperior",
          "ssuperior",
          "tsuperior",
          "ff",
          "ffi",
          "ffl",
          "parenleftinferior",
          "parenrightinferior",
          "Circumflexsmall",
          "hyphensuperior",
          "Gravesmall",
          "Asmall",
          "Bsmall",
          "Csmall",
          "Dsmall",
          "Esmall",
          "Fsmall",
          "Gsmall",
          "Hsmall",
          "Ismall",
          "Jsmall",
          "Ksmall",
          "Lsmall",
          "Msmall",
          "Nsmall",
          "Osmall",
          "Psmall",
          "Qsmall",
          "Rsmall",
          "Ssmall",
          "Tsmall",
          "Usmall",
          "Vsmall",
          "Wsmall",
          "Xsmall",
          "Ysmall",
          "Zsmall",
          "colonmonetary",
          "onefitted",
          "rupiah",
          "Tildesmall",
          "exclamdownsmall",
          "centoldstyle",
          "Lslashsmall",
          "Scaronsmall",
          "Zcaronsmall",
          "Dieresissmall",
          "Brevesmall",
          "Caronsmall",
          "Dotaccentsmall",
          "Macronsmall",
          "figuredash",
          "hypheninferior",
          "Ogoneksmall",
          "Ringsmall",
          "Cedillasmall",
          "questiondownsmall",
          "oneeighth",
          "threeeighths",
          "fiveeighths",
          "seveneighths",
          "onethird",
          "twothirds",
          "zerosuperior",
          "foursuperior",
          "fivesuperior",
          "sixsuperior",
          "sevensuperior",
          "eightsuperior",
          "ninesuperior",
          "zeroinferior",
          "oneinferior",
          "twoinferior",
          "threeinferior",
          "fourinferior",
          "fiveinferior",
          "sixinferior",
          "seveninferior",
          "eightinferior",
          "nineinferior",
          "centinferior",
          "dollarinferior",
          "periodinferior",
          "commainferior",
          "Agravesmall",
          "Aacutesmall",
          "Acircumflexsmall",
          "Atildesmall",
          "Adieresissmall",
          "Aringsmall",
          "AEsmall",
          "Ccedillasmall",
          "Egravesmall",
          "Eacutesmall",
          "Ecircumflexsmall",
          "Edieresissmall",
          "Igravesmall",
          "Iacutesmall",
          "Icircumflexsmall",
          "Idieresissmall",
          "Ethsmall",
          "Ntildesmall",
          "Ogravesmall",
          "Oacutesmall",
          "Ocircumflexsmall",
          "Otildesmall",
          "Odieresissmall",
          "OEsmall",
          "Oslashsmall",
          "Ugravesmall",
          "Uacutesmall",
          "Ucircumflexsmall",
          "Udieresissmall",
          "Yacutesmall",
          "Thornsmall",
          "Ydieresissmall",
          "001.000",
          "001.001",
          "001.002",
          "001.003",
          "Black",
          "Bold",
          "Book",
          "Light",
          "Medium",
          "Regular",
          "Roman",
          "Semibold",
        ];
      r.CFFStandardStrings = c;
      var u = 391,
        h = (function CFFParserClosure() {
          var t = [
              null,
              { id: "hstem", min: 2, stackClearing: !0, stem: !0 },
              null,
              { id: "vstem", min: 2, stackClearing: !0, stem: !0 },
              { id: "vmoveto", min: 1, stackClearing: !0 },
              { id: "rlineto", min: 2, resetStack: !0 },
              { id: "hlineto", min: 1, resetStack: !0 },
              { id: "vlineto", min: 1, resetStack: !0 },
              { id: "rrcurveto", min: 6, resetStack: !0 },
              null,
              { id: "callsubr", min: 1, undefStack: !0 },
              { id: "return", min: 0, undefStack: !0 },
              null,
              null,
              { id: "endchar", min: 0, stackClearing: !0 },
              null,
              null,
              null,
              { id: "hstemhm", min: 2, stackClearing: !0, stem: !0 },
              { id: "hintmask", min: 0, stackClearing: !0 },
              { id: "cntrmask", min: 0, stackClearing: !0 },
              { id: "rmoveto", min: 2, stackClearing: !0 },
              { id: "hmoveto", min: 1, stackClearing: !0 },
              { id: "vstemhm", min: 2, stackClearing: !0, stem: !0 },
              { id: "rcurveline", min: 8, resetStack: !0 },
              { id: "rlinecurve", min: 8, resetStack: !0 },
              { id: "vvcurveto", min: 4, resetStack: !0 },
              { id: "hhcurveto", min: 4, resetStack: !0 },
              null,
              { id: "callgsubr", min: 1, undefStack: !0 },
              { id: "vhcurveto", min: 4, resetStack: !0 },
              { id: "hvcurveto", min: 4, resetStack: !0 },
            ],
            r = [
              null,
              null,
              null,
              { id: "and", min: 2, stackDelta: -1 },
              { id: "or", min: 2, stackDelta: -1 },
              { id: "not", min: 1, stackDelta: 0 },
              null,
              null,
              null,
              { id: "abs", min: 1, stackDelta: 0 },
              {
                id: "add",
                min: 2,
                stackDelta: -1,
                stackFn: function stack_div(t, r) {
                  t[r - 2] = t[r - 2] + t[r - 1];
                },
              },
              {
                id: "sub",
                min: 2,
                stackDelta: -1,
                stackFn: function stack_div(t, r) {
                  t[r - 2] = t[r - 2] - t[r - 1];
                },
              },
              {
                id: "div",
                min: 2,
                stackDelta: -1,
                stackFn: function stack_div(t, r) {
                  t[r - 2] = t[r - 2] / t[r - 1];
                },
              },
              null,
              {
                id: "neg",
                min: 1,
                stackDelta: 0,
                stackFn: function stack_div(t, r) {
                  t[r - 1] = -t[r - 1];
                },
              },
              { id: "eq", min: 2, stackDelta: -1 },
              null,
              null,
              { id: "drop", min: 1, stackDelta: -1 },
              null,
              { id: "put", min: 2, stackDelta: -2 },
              { id: "get", min: 1, stackDelta: 0 },
              { id: "ifelse", min: 4, stackDelta: -3 },
              { id: "random", min: 0, stackDelta: 1 },
              {
                id: "mul",
                min: 2,
                stackDelta: -1,
                stackFn: function stack_div(t, r) {
                  t[r - 2] = t[r - 2] * t[r - 1];
                },
              },
              null,
              { id: "sqrt", min: 1, stackDelta: 0 },
              { id: "dup", min: 1, stackDelta: 1 },
              { id: "exch", min: 2, stackDelta: 0 },
              { id: "index", min: 2, stackDelta: 0 },
              { id: "roll", min: 3, stackDelta: -2 },
              null,
              null,
              null,
              { id: "hflex", min: 7, resetStack: !0 },
              { id: "flex", min: 13, resetStack: !0 },
              { id: "hflex1", min: 9, resetStack: !0 },
              { id: "flex1", min: 11, resetStack: !0 },
            ];
          function CFFParser(t, r, a) {
            (this.bytes = t.getBytes()),
              (this.properties = r),
              (this.seacAnalysisEnabled = !!a);
          }
          return (
            (CFFParser.prototype = {
              parse: function CFFParser_parse() {
                var t = this.properties,
                  r = new d();
                this.cff = r;
                var a = this.parseHeader(),
                  i = this.parseIndex(a.endPos),
                  o = this.parseIndex(i.endPos),
                  l = this.parseIndex(o.endPos),
                  c = this.parseIndex(l.endPos),
                  u = this.parseDict(o.obj.get(0)),
                  h = this.createDict(y, u, r.strings);
                (r.header = a.obj),
                  (r.names = this.parseNameIndex(i.obj)),
                  (r.strings = this.parseStringIndex(l.obj)),
                  (r.topDict = h),
                  (r.globalSubrIndex = c.obj),
                  this.parsePrivateDict(r.topDict),
                  (r.isCIDFont = h.hasName("ROS"));
                var p = h.getByName("CharStrings"),
                  m = this.parseIndex(p).obj,
                  g = h.getByName("FontMatrix");
                g && (t.fontMatrix = g);
                var b,
                  v,
                  S = h.getByName("FontBBox");
                if (
                  (S &&
                    ((t.ascent = Math.max(S[3], S[1])),
                    (t.descent = Math.min(S[1], S[3])),
                    (t.ascentScaled = !0)),
                  r.isCIDFont)
                ) {
                  for (
                    var k = this.parseIndex(h.getByName("FDArray")).obj,
                      w = 0,
                      C = k.count;
                    w < C;
                    ++w
                  ) {
                    var x = k.get(w),
                      _ = this.createDict(y, this.parseDict(x), r.strings);
                    this.parsePrivateDict(_), r.fdArray.push(_);
                  }
                  (v = null),
                    (b = this.parseCharsets(
                      h.getByName("charset"),
                      m.count,
                      r.strings,
                      !0,
                    )),
                    (r.fdSelect = this.parseFDSelect(
                      h.getByName("FDSelect"),
                      m.count,
                    ));
                } else
                  (b = this.parseCharsets(
                    h.getByName("charset"),
                    m.count,
                    r.strings,
                    !1,
                  )),
                    (v = this.parseEncoding(
                      h.getByName("Encoding"),
                      t,
                      r.strings,
                      b.charset,
                    ));
                (r.charset = b), (r.encoding = v);
                var A = this.parseCharStrings({
                  charStrings: m,
                  localSubrIndex: h.privateDict.subrsIndex,
                  globalSubrIndex: c.obj,
                  fdSelect: r.fdSelect,
                  fdArray: r.fdArray,
                  privateDict: h.privateDict,
                });
                return (
                  (r.charStrings = A.charStrings),
                  (r.seacs = A.seacs),
                  (r.widths = A.widths),
                  r
                );
              },
              parseHeader: function CFFParser_parseHeader() {
                for (
                  var t = this.bytes, r = t.length, a = 0;
                  a < r && 1 !== t[a];

                )
                  ++a;
                if (a >= r) throw new i.FormatError("Invalid CFF header");
                0 !== a &&
                  ((0, i.info)("cff data is shifted"),
                  (t = t.subarray(a)),
                  (this.bytes = t));
                var o = t[0],
                  l = t[1],
                  c = t[2],
                  u = t[3];
                return { obj: new p(o, l, c, u), endPos: c };
              },
              parseDict: function CFFParser_parseDict(t) {
                var r = 0;
                function parseOperand() {
                  var a = t[r++];
                  return 30 === a
                    ? (function parseFloatOperand() {
                        var a = "",
                          i = 15,
                          o = [
                            "0",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5",
                            "6",
                            "7",
                            "8",
                            "9",
                            ".",
                            "E",
                            "E-",
                            null,
                            "-",
                          ],
                          l = t.length;
                        for (; r < l; ) {
                          var c = t[r++],
                            u = c >> 4,
                            h = 15 & c;
                          if (u === i) break;
                          if (((a += o[u]), h === i)) break;
                          a += o[h];
                        }
                        return parseFloat(a);
                      })()
                    : 28 === a
                    ? (a = (((a = t[r++]) << 24) | (t[r++] << 16)) >> 16)
                    : 29 === a
                    ? (a =
                        ((a =
                          ((a = ((a = t[r++]) << 8) | t[r++]) << 8) | t[r++]) <<
                          8) |
                        t[r++])
                    : a >= 32 && a <= 246
                    ? a - 139
                    : a >= 247 && a <= 250
                    ? 256 * (a - 247) + t[r++] + 108
                    : a >= 251 && a <= 254
                    ? -256 * (a - 251) - t[r++] - 108
                    : ((0, i.warn)(
                        'CFFParser_parseDict: "' +
                          a +
                          '" is a reserved command.',
                      ),
                      NaN);
                }
                var a = [],
                  o = [];
                r = 0;
                for (var l = t.length; r < l; ) {
                  var c = t[r];
                  c <= 21
                    ? (12 === c && (c = (c << 8) | t[++r]),
                      o.push([c, a]),
                      (a = []),
                      ++r)
                    : a.push(parseOperand());
                }
                return o;
              },
              parseIndex: function CFFParser_parseIndex(t) {
                var r,
                  a,
                  i = new g(),
                  o = this.bytes,
                  l = (o[t++] << 8) | o[t++],
                  c = [],
                  u = t;
                if (0 !== l) {
                  var h = o[t++],
                    d = t + (l + 1) * h - 1;
                  for (r = 0, a = l + 1; r < a; ++r) {
                    for (var p = 0, m = 0; m < h; ++m) (p <<= 8), (p += o[t++]);
                    c.push(d + p);
                  }
                  u = c[l];
                }
                for (r = 0, a = c.length - 1; r < a; ++r) {
                  var b = c[r],
                    y = c[r + 1];
                  i.add(o.subarray(b, y));
                }
                return { obj: i, endPos: u };
              },
              parseNameIndex: function CFFParser_parseNameIndex(t) {
                for (var r = [], a = 0, o = t.count; a < o; ++a) {
                  var l = t.get(a);
                  r.push((0, i.bytesToString)(l));
                }
                return r;
              },
              parseStringIndex: function CFFParser_parseStringIndex(t) {
                for (var r = new m(), a = 0, o = t.count; a < o; ++a) {
                  var l = t.get(a);
                  r.add((0, i.bytesToString)(l));
                }
                return r;
              },
              createDict: function CFFParser_createDict(t, r, a) {
                for (var i = new t(a), o = 0, l = r.length; o < l; ++o) {
                  var c = r[o],
                    u = c[0],
                    h = c[1];
                  i.setByKey(u, h);
                }
                return i;
              },
              parseCharString: function CFFParser_parseCharString(a, o, l, c) {
                if (!o || a.callDepth > 10) return !1;
                for (
                  var u = a.stackSize, h = a.stack, d = o.length, p = 0;
                  p < d;

                ) {
                  var m = o[p++],
                    g = null;
                  if (12 === m) {
                    var b = o[p++];
                    0 === b
                      ? ((o[p - 2] = 139), (o[p - 1] = 22), (u = 0))
                      : (g = r[b]);
                  } else if (28 === m)
                    (h[u] = ((o[p] << 24) | (o[p + 1] << 16)) >> 16),
                      (p += 2),
                      u++;
                  else if (14 === m) {
                    if (u >= 4 && ((u -= 4), this.seacAnalysisEnabled))
                      return (a.seac = h.slice(u, u + 4)), !1;
                    g = t[m];
                  } else if (m >= 32 && m <= 246) (h[u] = m - 139), u++;
                  else if (m >= 247 && m <= 254)
                    (h[u] =
                      m < 251
                        ? ((m - 247) << 8) + o[p] + 108
                        : -((m - 251) << 8) - o[p] - 108),
                      p++,
                      u++;
                  else if (255 === m)
                    (h[u] =
                      ((o[p] << 24) |
                        (o[p + 1] << 16) |
                        (o[p + 2] << 8) |
                        o[p + 3]) /
                      65536),
                      (p += 4),
                      u++;
                  else if (19 === m || 20 === m)
                    (a.hints += u >> 1),
                      (p += (a.hints + 7) >> 3),
                      (u %= 2),
                      (g = t[m]);
                  else {
                    if (10 === m || 29 === m) {
                      var y;
                      if (!(y = 10 === m ? l : c))
                        return (
                          (g = t[m]),
                          (0, i.warn)("Missing subrsIndex for " + g.id),
                          !1
                        );
                      var v = 32768;
                      y.count < 1240
                        ? (v = 107)
                        : y.count < 33900 && (v = 1131);
                      var S = h[--u] + v;
                      if (S < 0 || S >= y.count || isNaN(S))
                        return (
                          (g = t[m]),
                          (0, i.warn)("Out of bounds subrIndex for " + g.id),
                          !1
                        );
                      if (
                        ((a.stackSize = u),
                        a.callDepth++,
                        !this.parseCharString(a, y.get(S), l, c))
                      )
                        return !1;
                      a.callDepth--, (u = a.stackSize);
                      continue;
                    }
                    if (11 === m) return (a.stackSize = u), !0;
                    g = t[m];
                  }
                  if (g) {
                    if (
                      (g.stem &&
                        ((a.hints += u >> 1),
                        3 === m || 23 === m
                          ? (a.hasVStems = !0)
                          : !a.hasVStems ||
                            (1 !== m && 18 !== m) ||
                            ((0, i.warn)("CFF stem hints are in wrong order"),
                            (o[p - 1] = 1 === m ? 3 : 23))),
                      "min" in g && !a.undefStack && u < g.min)
                    )
                      return (
                        (0, i.warn)(
                          "Not enough parameters for " +
                            g.id +
                            "; actual: " +
                            u +
                            ", expected: " +
                            g.min,
                        ),
                        !1
                      );
                    a.firstStackClearing &&
                      g.stackClearing &&
                      ((a.firstStackClearing = !1),
                      (u -= g.min) >= 2 && g.stem
                        ? (u %= 2)
                        : u > 1 &&
                          (0, i.warn)(
                            "Found too many parameters for stack-clearing command",
                          ),
                      u > 0 && h[u - 1] >= 0 && (a.width = h[u - 1])),
                      "stackDelta" in g
                        ? ("stackFn" in g && g.stackFn(h, u),
                          (u += g.stackDelta))
                        : g.stackClearing
                        ? (u = 0)
                        : g.resetStack
                        ? ((u = 0), (a.undefStack = !1))
                        : g.undefStack &&
                          ((u = 0),
                          (a.undefStack = !0),
                          (a.firstStackClearing = !1));
                  }
                }
                return (a.stackSize = u), !0;
              },
              parseCharStrings: function parseCharStrings(t) {
                for (
                  var r = t.charStrings,
                    a = t.localSubrIndex,
                    o = t.globalSubrIndex,
                    l = t.fdSelect,
                    c = t.fdArray,
                    u = t.privateDict,
                    h = [],
                    d = [],
                    p = r.count,
                    m = 0;
                  m < p;
                  m++
                ) {
                  var g = r.get(m),
                    b = {
                      callDepth: 0,
                      stackSize: 0,
                      stack: [],
                      undefStack: !0,
                      hints: 0,
                      firstStackClearing: !0,
                      seac: null,
                      width: null,
                      hasVStems: !1,
                    },
                    y = !0,
                    v = null,
                    S = u;
                  if (l && c.length) {
                    var k = l.getFDIndex(m);
                    -1 === k &&
                      ((0, i.warn)("Glyph index is not in fd select."),
                      (y = !1)),
                      k >= c.length &&
                        ((0, i.warn)("Invalid fd index for glyph index."),
                        (y = !1)),
                      y && (v = (S = c[k].privateDict).subrsIndex);
                  } else a && (v = a);
                  if (
                    (y && (y = this.parseCharString(b, g, v, o)),
                    null !== b.width)
                  ) {
                    var w = S.getByName("nominalWidthX");
                    d[m] = w + b.width;
                  } else {
                    var C = S.getByName("defaultWidthX");
                    d[m] = C;
                  }
                  null !== b.seac && (h[m] = b.seac),
                    y || r.set(m, new Uint8Array([14]));
                }
                return { charStrings: r, seacs: h, widths: d };
              },
              emptyPrivateDictionary: function CFFParser_emptyPrivateDictionary(
                t,
              ) {
                var r = this.createDict(v, [], t.strings);
                t.setByKey(18, [0, 0]), (t.privateDict = r);
              },
              parsePrivateDict: function CFFParser_parsePrivateDict(t) {
                if (t.hasName("Private")) {
                  var r = t.getByName("Private");
                  if (Array.isArray(r) && 2 === r.length) {
                    var a = r[0],
                      i = r[1];
                    if (0 === a || i >= this.bytes.length)
                      this.emptyPrivateDictionary(t);
                    else {
                      var o = i + a,
                        l = this.bytes.subarray(i, o),
                        c = this.parseDict(l),
                        u = this.createDict(v, c, t.strings);
                      if (((t.privateDict = u), u.getByName("Subrs"))) {
                        var h = u.getByName("Subrs"),
                          d = i + h;
                        if (0 === h || d >= this.bytes.length)
                          this.emptyPrivateDictionary(t);
                        else {
                          var p = this.parseIndex(d);
                          u.subrsIndex = p.obj;
                        }
                      }
                    }
                  } else t.removeByName("Private");
                } else this.emptyPrivateDictionary(t);
              },
              parseCharsets: function CFFParser_parseCharsets(t, r, a, l) {
                if (0 === t) return new k(!0, S.ISO_ADOBE, o.ISOAdobeCharset);
                if (1 === t) return new k(!0, S.EXPERT, o.ExpertCharset);
                if (2 === t)
                  return new k(!0, S.EXPERT_SUBSET, o.ExpertSubsetCharset);
                var c,
                  u,
                  h,
                  d = this.bytes,
                  p = t,
                  m = d[t++],
                  g = [l ? 0 : ".notdef"];
                switch (((r -= 1), m)) {
                  case 0:
                    for (h = 0; h < r; h++)
                      (c = (d[t++] << 8) | d[t++]), g.push(l ? c : a.get(c));
                    break;
                  case 1:
                    for (; g.length <= r; )
                      for (
                        c = (d[t++] << 8) | d[t++], u = d[t++], h = 0;
                        h <= u;
                        h++
                      )
                        g.push(l ? c++ : a.get(c++));
                    break;
                  case 2:
                    for (; g.length <= r; )
                      for (
                        c = (d[t++] << 8) | d[t++],
                          u = (d[t++] << 8) | d[t++],
                          h = 0;
                        h <= u;
                        h++
                      )
                        g.push(l ? c++ : a.get(c++));
                    break;
                  default:
                    throw new i.FormatError("Unknown charset format");
                }
                var b = t,
                  y = d.subarray(p, b);
                return new k(!1, m, g, y);
              },
              parseEncoding: function CFFParser_parseEncoding(t, r, a, o) {
                var c,
                  u,
                  h,
                  d = Object.create(null),
                  p = this.bytes,
                  m = !1,
                  g = null;
                if (0 === t || 1 === t) {
                  (m = !0), (c = t);
                  var b = t ? l.ExpertEncoding : l.StandardEncoding;
                  for (u = 0, h = o.length; u < h; u++) {
                    var y = b.indexOf(o[u]);
                    -1 !== y && (d[y] = u);
                  }
                } else {
                  var v = t;
                  switch (127 & (c = p[t++])) {
                    case 0:
                      var S = p[t++];
                      for (u = 1; u <= S; u++) d[p[t++]] = u;
                      break;
                    case 1:
                      var k = p[t++],
                        C = 1;
                      for (u = 0; u < k; u++)
                        for (var x = p[t++], _ = p[t++], A = x; A <= x + _; A++)
                          d[A] = C++;
                      break;
                    default:
                      throw new i.FormatError(
                        "Unknown encoding format: ".concat(c, " in CFF"),
                      );
                  }
                  var R = t;
                  128 & c &&
                    ((p[v] &= 127),
                    (function readSupplement() {
                      var r = p[t++];
                      for (u = 0; u < r; u++) {
                        var i = p[t++],
                          l = (p[t++] << 8) + (255 & p[t++]);
                        d[i] = o.indexOf(a.get(l));
                      }
                    })()),
                    (g = p.subarray(v, R));
                }
                return new w(m, (c &= 127), d, g);
              },
              parseFDSelect: function CFFParser_parseFDSelect(t, r) {
                var a,
                  o = this.bytes,
                  l = o[t++],
                  c = [];
                switch (l) {
                  case 0:
                    for (a = 0; a < r; ++a) {
                      var u = o[t++];
                      c.push(u);
                    }
                    break;
                  case 3:
                    var h = (o[t++] << 8) | o[t++];
                    for (a = 0; a < h; ++a) {
                      var d = (o[t++] << 8) | o[t++];
                      0 === a &&
                        0 !== d &&
                        ((0, i.warn)(
                          "parseFDSelect: The first range must have a first GID of 0 -- trying to recover.",
                        ),
                        (d = 0));
                      for (
                        var p = o[t++], m = (o[t] << 8) | o[t + 1], g = d;
                        g < m;
                        ++g
                      )
                        c.push(p);
                    }
                    t += 2;
                    break;
                  default:
                    throw new i.FormatError(
                      'parseFDSelect: Unknown format "'.concat(l, '".'),
                    );
                }
                if (c.length !== r)
                  throw new i.FormatError("parseFDSelect: Invalid font data.");
                return new C(l, c);
              },
            }),
            CFFParser
          );
        })();
      r.CFFParser = h;
      var d = (function CFFClosure() {
        function CFF() {
          (this.header = null),
            (this.names = []),
            (this.topDict = null),
            (this.strings = new m()),
            (this.globalSubrIndex = null),
            (this.encoding = null),
            (this.charset = null),
            (this.charStrings = null),
            (this.fdArray = []),
            (this.fdSelect = null),
            (this.isCIDFont = !1);
        }
        return (
          (CFF.prototype = {
            duplicateFirstGlyph: function CFF_duplicateFirstGlyph() {
              if (this.charStrings.count >= 65535)
                (0, i.warn)(
                  "Not enough space in charstrings to duplicate first glyph.",
                );
              else {
                var t = this.charStrings.get(0);
                this.charStrings.add(t),
                  this.isCIDFont &&
                    this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
              }
            },
            hasGlyphId: function CFF_hasGlyphID(t) {
              return (
                !(t < 0 || t >= this.charStrings.count) &&
                this.charStrings.get(t).length > 0
              );
            },
          }),
          CFF
        );
      })();
      r.CFF = d;
      var p = function p(t, r, a, i) {
        (this.major = t),
          (this.minor = r),
          (this.hdrSize = a),
          (this.offSize = i);
      };
      r.CFFHeader = p;
      var m = (function CFFStringsClosure() {
        function CFFStrings() {
          this.strings = [];
        }
        return (
          (CFFStrings.prototype = {
            get: function CFFStrings_get(t) {
              return t >= 0 && t <= 390
                ? c[t]
                : t - u <= this.strings.length
                ? this.strings[t - u]
                : c[0];
            },
            getSID: function CFFStrings_getSID(t) {
              var r = c.indexOf(t);
              return -1 !== r
                ? r
                : -1 !== (r = this.strings.indexOf(t))
                ? r + u
                : -1;
            },
            add: function CFFStrings_add(t) {
              this.strings.push(t);
            },
            get count() {
              return this.strings.length;
            },
          }),
          CFFStrings
        );
      })();
      r.CFFStrings = m;
      var g = (function CFFIndexClosure() {
        function CFFIndex() {
          (this.objects = []), (this.length = 0);
        }
        return (
          (CFFIndex.prototype = {
            add: function CFFIndex_add(t) {
              (this.length += t.length), this.objects.push(t);
            },
            set: function CFFIndex_set(t, r) {
              (this.length += r.length - this.objects[t].length),
                (this.objects[t] = r);
            },
            get: function CFFIndex_get(t) {
              return this.objects[t];
            },
            get count() {
              return this.objects.length;
            },
          }),
          CFFIndex
        );
      })();
      r.CFFIndex = g;
      var b = (function CFFDictClosure() {
          function CFFDict(t, r) {
            (this.keyToNameMap = t.keyToNameMap),
              (this.nameToKeyMap = t.nameToKeyMap),
              (this.defaults = t.defaults),
              (this.types = t.types),
              (this.opcodes = t.opcodes),
              (this.order = t.order),
              (this.strings = r),
              (this.values = Object.create(null));
          }
          return (
            (CFFDict.prototype = {
              setByKey: function CFFDict_setByKey(t, r) {
                if (!(t in this.keyToNameMap)) return !1;
                var a = r.length;
                if (0 === a) return !0;
                for (var o = 0; o < a; o++)
                  if (isNaN(r[o]))
                    return (
                      (0, i.warn)(
                        'Invalid CFFDict value: "' +
                          r +
                          '" for key "' +
                          t +
                          '".',
                      ),
                      !0
                    );
                var l = this.types[t];
                return (
                  ("num" !== l && "sid" !== l && "offset" !== l) || (r = r[0]),
                  (this.values[t] = r),
                  !0
                );
              },
              setByName: function CFFDict_setByName(t, r) {
                if (!(t in this.nameToKeyMap))
                  throw new i.FormatError(
                    'Invalid dictionary name "'.concat(t, '"'),
                  );
                this.values[this.nameToKeyMap[t]] = r;
              },
              hasName: function CFFDict_hasName(t) {
                return this.nameToKeyMap[t] in this.values;
              },
              getByName: function CFFDict_getByName(t) {
                if (!(t in this.nameToKeyMap))
                  throw new i.FormatError(
                    "Invalid dictionary name ".concat(t, '"'),
                  );
                var r = this.nameToKeyMap[t];
                return r in this.values ? this.values[r] : this.defaults[r];
              },
              removeByName: function CFFDict_removeByName(t) {
                delete this.values[this.nameToKeyMap[t]];
              },
            }),
            (CFFDict.createTables = function CFFDict_createTables(t) {
              for (
                var r = {
                    keyToNameMap: {},
                    nameToKeyMap: {},
                    defaults: {},
                    types: {},
                    opcodes: {},
                    order: [],
                  },
                  a = 0,
                  i = t.length;
                a < i;
                ++a
              ) {
                var o = t[a],
                  l = Array.isArray(o[0]) ? (o[0][0] << 8) + o[0][1] : o[0];
                (r.keyToNameMap[l] = o[1]),
                  (r.nameToKeyMap[o[1]] = l),
                  (r.types[l] = o[2]),
                  (r.defaults[l] = o[3]),
                  (r.opcodes[l] = Array.isArray(o[0]) ? o[0] : [o[0]]),
                  r.order.push(l);
              }
              return r;
            }),
            CFFDict
          );
        })(),
        y = (function CFFTopDictClosure() {
          var t = [
              [[12, 30], "ROS", ["sid", "sid", "num"], null],
              [[12, 20], "SyntheticBase", "num", null],
              [0, "version", "sid", null],
              [1, "Notice", "sid", null],
              [[12, 0], "Copyright", "sid", null],
              [2, "FullName", "sid", null],
              [3, "FamilyName", "sid", null],
              [4, "Weight", "sid", null],
              [[12, 1], "isFixedPitch", "num", 0],
              [[12, 2], "ItalicAngle", "num", 0],
              [[12, 3], "UnderlinePosition", "num", -100],
              [[12, 4], "UnderlineThickness", "num", 50],
              [[12, 5], "PaintType", "num", 0],
              [[12, 6], "CharstringType", "num", 2],
              [
                [12, 7],
                "FontMatrix",
                ["num", "num", "num", "num", "num", "num"],
                [0.001, 0, 0, 0.001, 0, 0],
              ],
              [13, "UniqueID", "num", null],
              [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]],
              [[12, 8], "StrokeWidth", "num", 0],
              [14, "XUID", "array", null],
              [15, "charset", "offset", 0],
              [16, "Encoding", "offset", 0],
              [17, "CharStrings", "offset", 0],
              [18, "Private", ["offset", "offset"], null],
              [[12, 21], "PostScript", "sid", null],
              [[12, 22], "BaseFontName", "sid", null],
              [[12, 23], "BaseFontBlend", "delta", null],
              [[12, 31], "CIDFontVersion", "num", 0],
              [[12, 32], "CIDFontRevision", "num", 0],
              [[12, 33], "CIDFontType", "num", 0],
              [[12, 34], "CIDCount", "num", 8720],
              [[12, 35], "UIDBase", "num", null],
              [[12, 37], "FDSelect", "offset", null],
              [[12, 36], "FDArray", "offset", null],
              [[12, 38], "FontName", "sid", null],
            ],
            r = null;
          function CFFTopDict(a) {
            null === r && (r = b.createTables(t)),
              b.call(this, r, a),
              (this.privateDict = null);
          }
          return (
            (CFFTopDict.prototype = Object.create(b.prototype)), CFFTopDict
          );
        })();
      r.CFFTopDict = y;
      var v = (function CFFPrivateDictClosure() {
        var t = [
            [6, "BlueValues", "delta", null],
            [7, "OtherBlues", "delta", null],
            [8, "FamilyBlues", "delta", null],
            [9, "FamilyOtherBlues", "delta", null],
            [[12, 9], "BlueScale", "num", 0.039625],
            [[12, 10], "BlueShift", "num", 7],
            [[12, 11], "BlueFuzz", "num", 1],
            [10, "StdHW", "num", null],
            [11, "StdVW", "num", null],
            [[12, 12], "StemSnapH", "delta", null],
            [[12, 13], "StemSnapV", "delta", null],
            [[12, 14], "ForceBold", "num", 0],
            [[12, 17], "LanguageGroup", "num", 0],
            [[12, 18], "ExpansionFactor", "num", 0.06],
            [[12, 19], "initialRandomSeed", "num", 0],
            [20, "defaultWidthX", "num", 0],
            [21, "nominalWidthX", "num", 0],
            [19, "Subrs", "offset", null],
          ],
          r = null;
        function CFFPrivateDict(a) {
          null === r && (r = b.createTables(t)),
            b.call(this, r, a),
            (this.subrsIndex = null);
        }
        return (
          (CFFPrivateDict.prototype = Object.create(b.prototype)),
          CFFPrivateDict
        );
      })();
      r.CFFPrivateDict = v;
      var S = { ISO_ADOBE: 0, EXPERT: 1, EXPERT_SUBSET: 2 },
        k = function k(t, r, a, i) {
          (this.predefined = t),
            (this.format = r),
            (this.charset = a),
            (this.raw = i);
        };
      r.CFFCharset = k;
      var w = function w(t, r, a, i) {
          (this.predefined = t),
            (this.format = r),
            (this.encoding = a),
            (this.raw = i);
        },
        C = (function CFFFDSelectClosure() {
          function CFFFDSelect(t, r) {
            (this.format = t), (this.fdSelect = r);
          }
          return (
            (CFFFDSelect.prototype = {
              getFDIndex: function CFFFDSelect_get(t) {
                return t < 0 || t >= this.fdSelect.length
                  ? -1
                  : this.fdSelect[t];
              },
            }),
            CFFFDSelect
          );
        })();
      r.CFFFDSelect = C;
      var x = (function CFFOffsetTrackerClosure() {
          function CFFOffsetTracker() {
            this.offsets = Object.create(null);
          }
          return (
            (CFFOffsetTracker.prototype = {
              isTracking: function CFFOffsetTracker_isTracking(t) {
                return t in this.offsets;
              },
              track: function CFFOffsetTracker_track(t, r) {
                if (t in this.offsets)
                  throw new i.FormatError(
                    "Already tracking location of ".concat(t),
                  );
                this.offsets[t] = r;
              },
              offset: function CFFOffsetTracker_offset(t) {
                for (var r in this.offsets) this.offsets[r] += t;
              },
              setEntryLocation: function CFFOffsetTracker_setEntryLocation(
                t,
                r,
                a,
              ) {
                if (!(t in this.offsets))
                  throw new i.FormatError(
                    "Not tracking location of ".concat(t),
                  );
                for (
                  var o = a.data, l = this.offsets[t], c = 0, u = r.length;
                  c < u;
                  ++c
                ) {
                  var h = 5 * c + l,
                    d = h + 1,
                    p = h + 2,
                    m = h + 3,
                    g = h + 4;
                  if (
                    29 !== o[h] ||
                    0 !== o[d] ||
                    0 !== o[p] ||
                    0 !== o[m] ||
                    0 !== o[g]
                  )
                    throw new i.FormatError(
                      "writing to an offset that is not empty",
                    );
                  var b = r[c];
                  (o[h] = 29),
                    (o[d] = (b >> 24) & 255),
                    (o[p] = (b >> 16) & 255),
                    (o[m] = (b >> 8) & 255),
                    (o[g] = 255 & b);
                }
              },
            }),
            CFFOffsetTracker
          );
        })(),
        _ = (function CFFCompilerClosure() {
          function CFFCompiler(t) {
            this.cff = t;
          }
          return (
            (CFFCompiler.prototype = {
              compile: function CFFCompiler_compile() {
                var t = this.cff,
                  r = {
                    data: [],
                    length: 0,
                    add: function CFFCompiler_add(t) {
                      (this.data = this.data.concat(t)),
                        (this.length = this.data.length);
                    },
                  },
                  a = this.compileHeader(t.header);
                r.add(a);
                var o = this.compileNameIndex(t.names);
                if (
                  (r.add(o), t.isCIDFont && t.topDict.hasName("FontMatrix"))
                ) {
                  var l = t.topDict.getByName("FontMatrix");
                  t.topDict.removeByName("FontMatrix");
                  for (var c = 0, u = t.fdArray.length; c < u; c++) {
                    var h = t.fdArray[c],
                      d = l.slice(0);
                    h.hasName("FontMatrix") &&
                      (d = i.Util.transform(d, h.getByName("FontMatrix"))),
                      h.setByName("FontMatrix", d);
                  }
                }
                t.topDict.setByName("charset", 0);
                var p = this.compileTopDicts(
                  [t.topDict],
                  r.length,
                  t.isCIDFont,
                );
                r.add(p.output);
                var m = p.trackers[0],
                  g = this.compileStringIndex(t.strings.strings);
                r.add(g);
                var b = this.compileIndex(t.globalSubrIndex);
                if ((r.add(b), t.encoding && t.topDict.hasName("Encoding")))
                  if (t.encoding.predefined)
                    m.setEntryLocation("Encoding", [t.encoding.format], r);
                  else {
                    var y = this.compileEncoding(t.encoding);
                    m.setEntryLocation("Encoding", [r.length], r), r.add(y);
                  }
                var v = this.compileCharset(
                  t.charset,
                  t.charStrings.count,
                  t.strings,
                  t.isCIDFont,
                );
                m.setEntryLocation("charset", [r.length], r), r.add(v);
                var S = this.compileCharStrings(t.charStrings);
                if (
                  (m.setEntryLocation("CharStrings", [r.length], r),
                  r.add(S),
                  t.isCIDFont)
                ) {
                  m.setEntryLocation("FDSelect", [r.length], r);
                  var k = this.compileFDSelect(t.fdSelect);
                  r.add(k),
                    (p = this.compileTopDicts(t.fdArray, r.length, !0)),
                    m.setEntryLocation("FDArray", [r.length], r),
                    r.add(p.output);
                  var w = p.trackers;
                  this.compilePrivateDicts(t.fdArray, w, r);
                }
                return (
                  this.compilePrivateDicts([t.topDict], [m], r),
                  r.add([0]),
                  r.data
                );
              },
              encodeNumber: function CFFCompiler_encodeNumber(t) {
                return parseFloat(t) !== parseInt(t, 10) || isNaN(t)
                  ? this.encodeFloat(t)
                  : this.encodeInteger(t);
              },
              encodeFloat: function CFFCompiler_encodeFloat(t) {
                var r = t.toString(),
                  a = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(r);
                if (a) {
                  var i = parseFloat("1e" + ((a[2] ? +a[2] : 0) + a[1].length));
                  r = (Math.round(t * i) / i).toString();
                }
                var o,
                  l,
                  c = "";
                for (o = 0, l = r.length; o < l; ++o) {
                  var u = r[o];
                  c +=
                    "e" === u
                      ? "-" === r[++o]
                        ? "c"
                        : "b"
                      : "." === u
                      ? "a"
                      : "-" === u
                      ? "e"
                      : u;
                }
                var h = [30];
                for (
                  o = 0, l = (c += 1 & c.length ? "f" : "ff").length;
                  o < l;
                  o += 2
                )
                  h.push(parseInt(c.substring(o, o + 2), 16));
                return h;
              },
              encodeInteger: function CFFCompiler_encodeInteger(t) {
                return t >= -107 && t <= 107
                  ? [t + 139]
                  : t >= 108 && t <= 1131
                  ? [247 + ((t -= 108) >> 8), 255 & t]
                  : t >= -1131 && t <= -108
                  ? [251 + ((t = -t - 108) >> 8), 255 & t]
                  : t >= -32768 && t <= 32767
                  ? [28, (t >> 8) & 255, 255 & t]
                  : [
                      29,
                      (t >> 24) & 255,
                      (t >> 16) & 255,
                      (t >> 8) & 255,
                      255 & t,
                    ];
              },
              compileHeader: function CFFCompiler_compileHeader(t) {
                return [t.major, t.minor, t.hdrSize, t.offSize];
              },
              compileNameIndex: function CFFCompiler_compileNameIndex(t) {
                for (var r = new g(), a = 0, o = t.length; a < o; ++a) {
                  for (
                    var l = t[a],
                      c = Math.min(l.length, 127),
                      u = new Array(c),
                      h = 0;
                    h < c;
                    h++
                  ) {
                    var d = l[h];
                    (d < "!" ||
                      d > "~" ||
                      "[" === d ||
                      "]" === d ||
                      "(" === d ||
                      ")" === d ||
                      "{" === d ||
                      "}" === d ||
                      "<" === d ||
                      ">" === d ||
                      "/" === d ||
                      "%" === d) &&
                      (d = "_"),
                      (u[h] = d);
                  }
                  "" === (u = u.join("")) && (u = "Bad_Font_Name"),
                    r.add((0, i.stringToBytes)(u));
                }
                return this.compileIndex(r);
              },
              compileTopDicts: function CFFCompiler_compileTopDicts(t, r, a) {
                for (var i = [], o = new g(), l = 0, c = t.length; l < c; ++l) {
                  var u = t[l];
                  a &&
                    (u.removeByName("CIDFontVersion"),
                    u.removeByName("CIDFontRevision"),
                    u.removeByName("CIDFontType"),
                    u.removeByName("CIDCount"),
                    u.removeByName("UIDBase"));
                  var h = new x(),
                    d = this.compileDict(u, h);
                  i.push(h), o.add(d), h.offset(r);
                }
                return { trackers: i, output: (o = this.compileIndex(o, i)) };
              },
              compilePrivateDicts: function CFFCompiler_compilePrivateDicts(
                t,
                r,
                a,
              ) {
                for (var o = 0, l = t.length; o < l; ++o) {
                  var c = t[o],
                    u = c.privateDict;
                  if (!u || !c.hasName("Private"))
                    throw new i.FormatError(
                      "There must be a private dictionary.",
                    );
                  var h = new x(),
                    d = this.compileDict(u, h),
                    p = a.length;
                  if (
                    (h.offset(p),
                    d.length || (p = 0),
                    r[o].setEntryLocation("Private", [d.length, p], a),
                    a.add(d),
                    u.subrsIndex && u.hasName("Subrs"))
                  ) {
                    var m = this.compileIndex(u.subrsIndex);
                    h.setEntryLocation("Subrs", [d.length], a), a.add(m);
                  }
                }
              },
              compileDict: function CFFCompiler_compileDict(t, r) {
                for (var a = [], o = t.order, l = 0; l < o.length; ++l) {
                  var c = o[l];
                  if (c in t.values) {
                    var u = t.values[c],
                      h = t.types[c];
                    if (
                      (Array.isArray(h) || (h = [h]),
                      Array.isArray(u) || (u = [u]),
                      0 !== u.length)
                    ) {
                      for (var d = 0, p = h.length; d < p; ++d) {
                        var m = h[d],
                          g = u[d];
                        switch (m) {
                          case "num":
                          case "sid":
                            a = a.concat(this.encodeNumber(g));
                            break;
                          case "offset":
                            var b = t.keyToNameMap[c];
                            r.isTracking(b) || r.track(b, a.length),
                              (a = a.concat([29, 0, 0, 0, 0]));
                            break;
                          case "array":
                          case "delta":
                            a = a.concat(this.encodeNumber(g));
                            for (var y = 1, v = u.length; y < v; ++y)
                              a = a.concat(this.encodeNumber(u[y]));
                            break;
                          default:
                            throw new i.FormatError(
                              "Unknown data type of ".concat(m),
                            );
                        }
                      }
                      a = a.concat(t.opcodes[c]);
                    }
                  }
                }
                return a;
              },
              compileStringIndex: function CFFCompiler_compileStringIndex(t) {
                for (var r = new g(), a = 0, o = t.length; a < o; ++a)
                  r.add((0, i.stringToBytes)(t[a]));
                return this.compileIndex(r);
              },
              compileGlobalSubrIndex:
                function CFFCompiler_compileGlobalSubrIndex() {
                  var t = this.cff.globalSubrIndex;
                  this.out.writeByteArray(this.compileIndex(t));
                },
              compileCharStrings: function CFFCompiler_compileCharStrings(t) {
                for (var r = new g(), a = 0; a < t.count; a++) {
                  var i = t.get(a);
                  0 !== i.length ? r.add(i) : r.add(new Uint8Array([139, 14]));
                }
                return this.compileIndex(r);
              },
              compileCharset: function CFFCompiler_compileCharset(t, r, a, o) {
                var l,
                  c = r - 1;
                if (o) l = new Uint8Array([2, 0, 0, (c >> 8) & 255, 255 & c]);
                else {
                  (l = new Uint8Array(1 + 2 * c))[0] = 0;
                  for (
                    var u = 0, h = t.charset.length, d = !1, p = 1;
                    p < l.length;
                    p += 2
                  ) {
                    var m = 0;
                    if (u < h) {
                      var g = t.charset[u++];
                      -1 === (m = a.getSID(g)) &&
                        ((m = 0),
                        d ||
                          ((d = !0),
                          (0, i.warn)(
                            "Couldn't find ".concat(g, " in CFF strings"),
                          )));
                    }
                    (l[p] = (m >> 8) & 255), (l[p + 1] = 255 & m);
                  }
                }
                return this.compileTypedArray(l);
              },
              compileEncoding: function CFFCompiler_compileEncoding(t) {
                return this.compileTypedArray(t.raw);
              },
              compileFDSelect: function CFFCompiler_compileFDSelect(t) {
                var r,
                  a,
                  i = t.format;
                switch (i) {
                  case 0:
                    for (
                      (r = new Uint8Array(1 + t.fdSelect.length))[0] = i, a = 0;
                      a < t.fdSelect.length;
                      a++
                    )
                      r[a + 1] = t.fdSelect[a];
                    break;
                  case 3:
                    var o = t.fdSelect[0],
                      l = [i, 0, 0, 0, 0, o];
                    for (a = 1; a < t.fdSelect.length; a++) {
                      var c = t.fdSelect[a];
                      c !== o && (l.push((a >> 8) & 255, 255 & a, c), (o = c));
                    }
                    var u = (l.length - 3) / 3;
                    (l[1] = (u >> 8) & 255),
                      (l[2] = 255 & u),
                      l.push((a >> 8) & 255, 255 & a),
                      (r = new Uint8Array(l));
                }
                return this.compileTypedArray(r);
              },
              compileTypedArray: function CFFCompiler_compileTypedArray(t) {
                for (var r = [], a = 0, i = t.length; a < i; ++a) r[a] = t[a];
                return r;
              },
              compileIndex: function CFFCompiler_compileIndex(t, r) {
                r = r || [];
                var a = t.objects,
                  i = a.length;
                if (0 === i) return [0, 0, 0];
                var o,
                  l,
                  c = [(i >> 8) & 255, 255 & i],
                  u = 1;
                for (o = 0; o < i; ++o) u += a[o].length;
                (l = u < 256 ? 1 : u < 65536 ? 2 : u < 16777216 ? 3 : 4),
                  c.push(l);
                var h = 1;
                for (o = 0; o < i + 1; o++)
                  1 === l
                    ? c.push(255 & h)
                    : 2 === l
                    ? c.push((h >> 8) & 255, 255 & h)
                    : 3 === l
                    ? c.push((h >> 16) & 255, (h >> 8) & 255, 255 & h)
                    : c.push(
                        (h >>> 24) & 255,
                        (h >> 16) & 255,
                        (h >> 8) & 255,
                        255 & h,
                      ),
                    a[o] && (h += a[o].length);
                for (o = 0; o < i; o++) {
                  r[o] && r[o].offset(c.length);
                  for (var d = 0, p = a[o].length; d < p; d++) c.push(a[o][d]);
                }
                return c;
              },
            }),
            CFFCompiler
          );
        })();
      r.CFFCompiler = _;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.ExpertSubsetCharset = r.ExpertCharset = r.ISOAdobeCharset = void 0);
      r.ISOAdobeCharset = [
        ".notdef",
        "space",
        "exclam",
        "quotedbl",
        "numbersign",
        "dollar",
        "percent",
        "ampersand",
        "quoteright",
        "parenleft",
        "parenright",
        "asterisk",
        "plus",
        "comma",
        "hyphen",
        "period",
        "slash",
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "colon",
        "semicolon",
        "less",
        "equal",
        "greater",
        "question",
        "at",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "bracketleft",
        "backslash",
        "bracketright",
        "asciicircum",
        "underscore",
        "quoteleft",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "braceleft",
        "bar",
        "braceright",
        "asciitilde",
        "exclamdown",
        "cent",
        "sterling",
        "fraction",
        "yen",
        "florin",
        "section",
        "currency",
        "quotesingle",
        "quotedblleft",
        "guillemotleft",
        "guilsinglleft",
        "guilsinglright",
        "fi",
        "fl",
        "endash",
        "dagger",
        "daggerdbl",
        "periodcentered",
        "paragraph",
        "bullet",
        "quotesinglbase",
        "quotedblbase",
        "quotedblright",
        "guillemotright",
        "ellipsis",
        "perthousand",
        "questiondown",
        "grave",
        "acute",
        "circumflex",
        "tilde",
        "macron",
        "breve",
        "dotaccent",
        "dieresis",
        "ring",
        "cedilla",
        "hungarumlaut",
        "ogonek",
        "caron",
        "emdash",
        "AE",
        "ordfeminine",
        "Lslash",
        "Oslash",
        "OE",
        "ordmasculine",
        "ae",
        "dotlessi",
        "lslash",
        "oslash",
        "oe",
        "germandbls",
        "onesuperior",
        "logicalnot",
        "mu",
        "trademark",
        "Eth",
        "onehalf",
        "plusminus",
        "Thorn",
        "onequarter",
        "divide",
        "brokenbar",
        "degree",
        "thorn",
        "threequarters",
        "twosuperior",
        "registered",
        "minus",
        "eth",
        "multiply",
        "threesuperior",
        "copyright",
        "Aacute",
        "Acircumflex",
        "Adieresis",
        "Agrave",
        "Aring",
        "Atilde",
        "Ccedilla",
        "Eacute",
        "Ecircumflex",
        "Edieresis",
        "Egrave",
        "Iacute",
        "Icircumflex",
        "Idieresis",
        "Igrave",
        "Ntilde",
        "Oacute",
        "Ocircumflex",
        "Odieresis",
        "Ograve",
        "Otilde",
        "Scaron",
        "Uacute",
        "Ucircumflex",
        "Udieresis",
        "Ugrave",
        "Yacute",
        "Ydieresis",
        "Zcaron",
        "aacute",
        "acircumflex",
        "adieresis",
        "agrave",
        "aring",
        "atilde",
        "ccedilla",
        "eacute",
        "ecircumflex",
        "edieresis",
        "egrave",
        "iacute",
        "icircumflex",
        "idieresis",
        "igrave",
        "ntilde",
        "oacute",
        "ocircumflex",
        "odieresis",
        "ograve",
        "otilde",
        "scaron",
        "uacute",
        "ucircumflex",
        "udieresis",
        "ugrave",
        "yacute",
        "ydieresis",
        "zcaron",
      ];
      r.ExpertCharset = [
        ".notdef",
        "space",
        "exclamsmall",
        "Hungarumlautsmall",
        "dollaroldstyle",
        "dollarsuperior",
        "ampersandsmall",
        "Acutesmall",
        "parenleftsuperior",
        "parenrightsuperior",
        "twodotenleader",
        "onedotenleader",
        "comma",
        "hyphen",
        "period",
        "fraction",
        "zerooldstyle",
        "oneoldstyle",
        "twooldstyle",
        "threeoldstyle",
        "fouroldstyle",
        "fiveoldstyle",
        "sixoldstyle",
        "sevenoldstyle",
        "eightoldstyle",
        "nineoldstyle",
        "colon",
        "semicolon",
        "commasuperior",
        "threequartersemdash",
        "periodsuperior",
        "questionsmall",
        "asuperior",
        "bsuperior",
        "centsuperior",
        "dsuperior",
        "esuperior",
        "isuperior",
        "lsuperior",
        "msuperior",
        "nsuperior",
        "osuperior",
        "rsuperior",
        "ssuperior",
        "tsuperior",
        "ff",
        "fi",
        "fl",
        "ffi",
        "ffl",
        "parenleftinferior",
        "parenrightinferior",
        "Circumflexsmall",
        "hyphensuperior",
        "Gravesmall",
        "Asmall",
        "Bsmall",
        "Csmall",
        "Dsmall",
        "Esmall",
        "Fsmall",
        "Gsmall",
        "Hsmall",
        "Ismall",
        "Jsmall",
        "Ksmall",
        "Lsmall",
        "Msmall",
        "Nsmall",
        "Osmall",
        "Psmall",
        "Qsmall",
        "Rsmall",
        "Ssmall",
        "Tsmall",
        "Usmall",
        "Vsmall",
        "Wsmall",
        "Xsmall",
        "Ysmall",
        "Zsmall",
        "colonmonetary",
        "onefitted",
        "rupiah",
        "Tildesmall",
        "exclamdownsmall",
        "centoldstyle",
        "Lslashsmall",
        "Scaronsmall",
        "Zcaronsmall",
        "Dieresissmall",
        "Brevesmall",
        "Caronsmall",
        "Dotaccentsmall",
        "Macronsmall",
        "figuredash",
        "hypheninferior",
        "Ogoneksmall",
        "Ringsmall",
        "Cedillasmall",
        "onequarter",
        "onehalf",
        "threequarters",
        "questiondownsmall",
        "oneeighth",
        "threeeighths",
        "fiveeighths",
        "seveneighths",
        "onethird",
        "twothirds",
        "zerosuperior",
        "onesuperior",
        "twosuperior",
        "threesuperior",
        "foursuperior",
        "fivesuperior",
        "sixsuperior",
        "sevensuperior",
        "eightsuperior",
        "ninesuperior",
        "zeroinferior",
        "oneinferior",
        "twoinferior",
        "threeinferior",
        "fourinferior",
        "fiveinferior",
        "sixinferior",
        "seveninferior",
        "eightinferior",
        "nineinferior",
        "centinferior",
        "dollarinferior",
        "periodinferior",
        "commainferior",
        "Agravesmall",
        "Aacutesmall",
        "Acircumflexsmall",
        "Atildesmall",
        "Adieresissmall",
        "Aringsmall",
        "AEsmall",
        "Ccedillasmall",
        "Egravesmall",
        "Eacutesmall",
        "Ecircumflexsmall",
        "Edieresissmall",
        "Igravesmall",
        "Iacutesmall",
        "Icircumflexsmall",
        "Idieresissmall",
        "Ethsmall",
        "Ntildesmall",
        "Ogravesmall",
        "Oacutesmall",
        "Ocircumflexsmall",
        "Otildesmall",
        "Odieresissmall",
        "OEsmall",
        "Oslashsmall",
        "Ugravesmall",
        "Uacutesmall",
        "Ucircumflexsmall",
        "Udieresissmall",
        "Yacutesmall",
        "Thornsmall",
        "Ydieresissmall",
      ];
      r.ExpertSubsetCharset = [
        ".notdef",
        "space",
        "dollaroldstyle",
        "dollarsuperior",
        "parenleftsuperior",
        "parenrightsuperior",
        "twodotenleader",
        "onedotenleader",
        "comma",
        "hyphen",
        "period",
        "fraction",
        "zerooldstyle",
        "oneoldstyle",
        "twooldstyle",
        "threeoldstyle",
        "fouroldstyle",
        "fiveoldstyle",
        "sixoldstyle",
        "sevenoldstyle",
        "eightoldstyle",
        "nineoldstyle",
        "colon",
        "semicolon",
        "commasuperior",
        "threequartersemdash",
        "periodsuperior",
        "asuperior",
        "bsuperior",
        "centsuperior",
        "dsuperior",
        "esuperior",
        "isuperior",
        "lsuperior",
        "msuperior",
        "nsuperior",
        "osuperior",
        "rsuperior",
        "ssuperior",
        "tsuperior",
        "ff",
        "fi",
        "fl",
        "ffi",
        "ffl",
        "parenleftinferior",
        "parenrightinferior",
        "hyphensuperior",
        "colonmonetary",
        "onefitted",
        "rupiah",
        "centoldstyle",
        "figuredash",
        "hypheninferior",
        "onequarter",
        "onehalf",
        "threequarters",
        "oneeighth",
        "threeeighths",
        "fiveeighths",
        "seveneighths",
        "onethird",
        "twothirds",
        "zerosuperior",
        "onesuperior",
        "twosuperior",
        "threesuperior",
        "foursuperior",
        "fivesuperior",
        "sixsuperior",
        "sevensuperior",
        "eightsuperior",
        "ninesuperior",
        "zeroinferior",
        "oneinferior",
        "twoinferior",
        "threeinferior",
        "fourinferior",
        "fiveinferior",
        "sixinferior",
        "seveninferior",
        "eightinferior",
        "nineinferior",
        "centinferior",
        "dollarinferior",
        "periodinferior",
        "commainferior",
      ];
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.getEncoding = function getEncoding(t) {
          switch (t) {
            case "WinAnsiEncoding":
              return u;
            case "StandardEncoding":
              return c;
            case "MacRomanEncoding":
              return l;
            case "SymbolSetEncoding":
              return h;
            case "ZapfDingbatsEncoding":
              return d;
            case "ExpertEncoding":
              return i;
            case "MacExpertEncoding":
              return o;
            default:
              return null;
          }
        }),
        (r.ExpertEncoding =
          r.ZapfDingbatsEncoding =
          r.SymbolSetEncoding =
          r.MacRomanEncoding =
          r.StandardEncoding =
          r.WinAnsiEncoding =
            void 0);
      var i = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "space",
        "exclamsmall",
        "Hungarumlautsmall",
        "",
        "dollaroldstyle",
        "dollarsuperior",
        "ampersandsmall",
        "Acutesmall",
        "parenleftsuperior",
        "parenrightsuperior",
        "twodotenleader",
        "onedotenleader",
        "comma",
        "hyphen",
        "period",
        "fraction",
        "zerooldstyle",
        "oneoldstyle",
        "twooldstyle",
        "threeoldstyle",
        "fouroldstyle",
        "fiveoldstyle",
        "sixoldstyle",
        "sevenoldstyle",
        "eightoldstyle",
        "nineoldstyle",
        "colon",
        "semicolon",
        "commasuperior",
        "threequartersemdash",
        "periodsuperior",
        "questionsmall",
        "",
        "asuperior",
        "bsuperior",
        "centsuperior",
        "dsuperior",
        "esuperior",
        "",
        "",
        "",
        "isuperior",
        "",
        "",
        "lsuperior",
        "msuperior",
        "nsuperior",
        "osuperior",
        "",
        "",
        "rsuperior",
        "ssuperior",
        "tsuperior",
        "",
        "ff",
        "fi",
        "fl",
        "ffi",
        "ffl",
        "parenleftinferior",
        "",
        "parenrightinferior",
        "Circumflexsmall",
        "hyphensuperior",
        "Gravesmall",
        "Asmall",
        "Bsmall",
        "Csmall",
        "Dsmall",
        "Esmall",
        "Fsmall",
        "Gsmall",
        "Hsmall",
        "Ismall",
        "Jsmall",
        "Ksmall",
        "Lsmall",
        "Msmall",
        "Nsmall",
        "Osmall",
        "Psmall",
        "Qsmall",
        "Rsmall",
        "Ssmall",
        "Tsmall",
        "Usmall",
        "Vsmall",
        "Wsmall",
        "Xsmall",
        "Ysmall",
        "Zsmall",
        "colonmonetary",
        "onefitted",
        "rupiah",
        "Tildesmall",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "exclamdownsmall",
        "centoldstyle",
        "Lslashsmall",
        "",
        "",
        "Scaronsmall",
        "Zcaronsmall",
        "Dieresissmall",
        "Brevesmall",
        "Caronsmall",
        "",
        "Dotaccentsmall",
        "",
        "",
        "Macronsmall",
        "",
        "",
        "figuredash",
        "hypheninferior",
        "",
        "",
        "Ogoneksmall",
        "Ringsmall",
        "Cedillasmall",
        "",
        "",
        "",
        "onequarter",
        "onehalf",
        "threequarters",
        "questiondownsmall",
        "oneeighth",
        "threeeighths",
        "fiveeighths",
        "seveneighths",
        "onethird",
        "twothirds",
        "",
        "",
        "zerosuperior",
        "onesuperior",
        "twosuperior",
        "threesuperior",
        "foursuperior",
        "fivesuperior",
        "sixsuperior",
        "sevensuperior",
        "eightsuperior",
        "ninesuperior",
        "zeroinferior",
        "oneinferior",
        "twoinferior",
        "threeinferior",
        "fourinferior",
        "fiveinferior",
        "sixinferior",
        "seveninferior",
        "eightinferior",
        "nineinferior",
        "centinferior",
        "dollarinferior",
        "periodinferior",
        "commainferior",
        "Agravesmall",
        "Aacutesmall",
        "Acircumflexsmall",
        "Atildesmall",
        "Adieresissmall",
        "Aringsmall",
        "AEsmall",
        "Ccedillasmall",
        "Egravesmall",
        "Eacutesmall",
        "Ecircumflexsmall",
        "Edieresissmall",
        "Igravesmall",
        "Iacutesmall",
        "Icircumflexsmall",
        "Idieresissmall",
        "Ethsmall",
        "Ntildesmall",
        "Ogravesmall",
        "Oacutesmall",
        "Ocircumflexsmall",
        "Otildesmall",
        "Odieresissmall",
        "OEsmall",
        "Oslashsmall",
        "Ugravesmall",
        "Uacutesmall",
        "Ucircumflexsmall",
        "Udieresissmall",
        "Yacutesmall",
        "Thornsmall",
        "Ydieresissmall",
      ];
      r.ExpertEncoding = i;
      var o = [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "space",
          "exclamsmall",
          "Hungarumlautsmall",
          "centoldstyle",
          "dollaroldstyle",
          "dollarsuperior",
          "ampersandsmall",
          "Acutesmall",
          "parenleftsuperior",
          "parenrightsuperior",
          "twodotenleader",
          "onedotenleader",
          "comma",
          "hyphen",
          "period",
          "fraction",
          "zerooldstyle",
          "oneoldstyle",
          "twooldstyle",
          "threeoldstyle",
          "fouroldstyle",
          "fiveoldstyle",
          "sixoldstyle",
          "sevenoldstyle",
          "eightoldstyle",
          "nineoldstyle",
          "colon",
          "semicolon",
          "",
          "threequartersemdash",
          "",
          "questionsmall",
          "",
          "",
          "",
          "",
          "Ethsmall",
          "",
          "",
          "onequarter",
          "onehalf",
          "threequarters",
          "oneeighth",
          "threeeighths",
          "fiveeighths",
          "seveneighths",
          "onethird",
          "twothirds",
          "",
          "",
          "",
          "",
          "",
          "",
          "ff",
          "fi",
          "fl",
          "ffi",
          "ffl",
          "parenleftinferior",
          "",
          "parenrightinferior",
          "Circumflexsmall",
          "hypheninferior",
          "Gravesmall",
          "Asmall",
          "Bsmall",
          "Csmall",
          "Dsmall",
          "Esmall",
          "Fsmall",
          "Gsmall",
          "Hsmall",
          "Ismall",
          "Jsmall",
          "Ksmall",
          "Lsmall",
          "Msmall",
          "Nsmall",
          "Osmall",
          "Psmall",
          "Qsmall",
          "Rsmall",
          "Ssmall",
          "Tsmall",
          "Usmall",
          "Vsmall",
          "Wsmall",
          "Xsmall",
          "Ysmall",
          "Zsmall",
          "colonmonetary",
          "onefitted",
          "rupiah",
          "Tildesmall",
          "",
          "",
          "asuperior",
          "centsuperior",
          "",
          "",
          "",
          "",
          "Aacutesmall",
          "Agravesmall",
          "Acircumflexsmall",
          "Adieresissmall",
          "Atildesmall",
          "Aringsmall",
          "Ccedillasmall",
          "Eacutesmall",
          "Egravesmall",
          "Ecircumflexsmall",
          "Edieresissmall",
          "Iacutesmall",
          "Igravesmall",
          "Icircumflexsmall",
          "Idieresissmall",
          "Ntildesmall",
          "Oacutesmall",
          "Ogravesmall",
          "Ocircumflexsmall",
          "Odieresissmall",
          "Otildesmall",
          "Uacutesmall",
          "Ugravesmall",
          "Ucircumflexsmall",
          "Udieresissmall",
          "",
          "eightsuperior",
          "fourinferior",
          "threeinferior",
          "sixinferior",
          "eightinferior",
          "seveninferior",
          "Scaronsmall",
          "",
          "centinferior",
          "twoinferior",
          "",
          "Dieresissmall",
          "",
          "Caronsmall",
          "osuperior",
          "fiveinferior",
          "",
          "commainferior",
          "periodinferior",
          "Yacutesmall",
          "",
          "dollarinferior",
          "",
          "",
          "Thornsmall",
          "",
          "nineinferior",
          "zeroinferior",
          "Zcaronsmall",
          "AEsmall",
          "Oslashsmall",
          "questiondownsmall",
          "oneinferior",
          "Lslashsmall",
          "",
          "",
          "",
          "",
          "",
          "",
          "Cedillasmall",
          "",
          "",
          "",
          "",
          "",
          "OEsmall",
          "figuredash",
          "hyphensuperior",
          "",
          "",
          "",
          "",
          "exclamdownsmall",
          "",
          "Ydieresissmall",
          "",
          "onesuperior",
          "twosuperior",
          "threesuperior",
          "foursuperior",
          "fivesuperior",
          "sixsuperior",
          "sevensuperior",
          "ninesuperior",
          "zerosuperior",
          "",
          "esuperior",
          "rsuperior",
          "tsuperior",
          "",
          "",
          "isuperior",
          "ssuperior",
          "dsuperior",
          "",
          "",
          "",
          "",
          "",
          "lsuperior",
          "Ogoneksmall",
          "Brevesmall",
          "Macronsmall",
          "bsuperior",
          "nsuperior",
          "msuperior",
          "commasuperior",
          "periodsuperior",
          "Dotaccentsmall",
          "Ringsmall",
          "",
          "",
          "",
          "",
        ],
        l = [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "space",
          "exclam",
          "quotedbl",
          "numbersign",
          "dollar",
          "percent",
          "ampersand",
          "quotesingle",
          "parenleft",
          "parenright",
          "asterisk",
          "plus",
          "comma",
          "hyphen",
          "period",
          "slash",
          "zero",
          "one",
          "two",
          "three",
          "four",
          "five",
          "six",
          "seven",
          "eight",
          "nine",
          "colon",
          "semicolon",
          "less",
          "equal",
          "greater",
          "question",
          "at",
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
          "bracketleft",
          "backslash",
          "bracketright",
          "asciicircum",
          "underscore",
          "grave",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
          "braceleft",
          "bar",
          "braceright",
          "asciitilde",
          "",
          "Adieresis",
          "Aring",
          "Ccedilla",
          "Eacute",
          "Ntilde",
          "Odieresis",
          "Udieresis",
          "aacute",
          "agrave",
          "acircumflex",
          "adieresis",
          "atilde",
          "aring",
          "ccedilla",
          "eacute",
          "egrave",
          "ecircumflex",
          "edieresis",
          "iacute",
          "igrave",
          "icircumflex",
          "idieresis",
          "ntilde",
          "oacute",
          "ograve",
          "ocircumflex",
          "odieresis",
          "otilde",
          "uacute",
          "ugrave",
          "ucircumflex",
          "udieresis",
          "dagger",
          "degree",
          "cent",
          "sterling",
          "section",
          "bullet",
          "paragraph",
          "germandbls",
          "registered",
          "copyright",
          "trademark",
          "acute",
          "dieresis",
          "notequal",
          "AE",
          "Oslash",
          "infinity",
          "plusminus",
          "lessequal",
          "greaterequal",
          "yen",
          "mu",
          "partialdiff",
          "summation",
          "product",
          "pi",
          "integral",
          "ordfeminine",
          "ordmasculine",
          "Omega",
          "ae",
          "oslash",
          "questiondown",
          "exclamdown",
          "logicalnot",
          "radical",
          "florin",
          "approxequal",
          "Delta",
          "guillemotleft",
          "guillemotright",
          "ellipsis",
          "space",
          "Agrave",
          "Atilde",
          "Otilde",
          "OE",
          "oe",
          "endash",
          "emdash",
          "quotedblleft",
          "quotedblright",
          "quoteleft",
          "quoteright",
          "divide",
          "lozenge",
          "ydieresis",
          "Ydieresis",
          "fraction",
          "currency",
          "guilsinglleft",
          "guilsinglright",
          "fi",
          "fl",
          "daggerdbl",
          "periodcentered",
          "quotesinglbase",
          "quotedblbase",
          "perthousand",
          "Acircumflex",
          "Ecircumflex",
          "Aacute",
          "Edieresis",
          "Egrave",
          "Iacute",
          "Icircumflex",
          "Idieresis",
          "Igrave",
          "Oacute",
          "Ocircumflex",
          "apple",
          "Ograve",
          "Uacute",
          "Ucircumflex",
          "Ugrave",
          "dotlessi",
          "circumflex",
          "tilde",
          "macron",
          "breve",
          "dotaccent",
          "ring",
          "cedilla",
          "hungarumlaut",
          "ogonek",
          "caron",
        ];
      r.MacRomanEncoding = l;
      var c = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "space",
        "exclam",
        "quotedbl",
        "numbersign",
        "dollar",
        "percent",
        "ampersand",
        "quoteright",
        "parenleft",
        "parenright",
        "asterisk",
        "plus",
        "comma",
        "hyphen",
        "period",
        "slash",
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "colon",
        "semicolon",
        "less",
        "equal",
        "greater",
        "question",
        "at",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "bracketleft",
        "backslash",
        "bracketright",
        "asciicircum",
        "underscore",
        "quoteleft",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "braceleft",
        "bar",
        "braceright",
        "asciitilde",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "exclamdown",
        "cent",
        "sterling",
        "fraction",
        "yen",
        "florin",
        "section",
        "currency",
        "quotesingle",
        "quotedblleft",
        "guillemotleft",
        "guilsinglleft",
        "guilsinglright",
        "fi",
        "fl",
        "",
        "endash",
        "dagger",
        "daggerdbl",
        "periodcentered",
        "",
        "paragraph",
        "bullet",
        "quotesinglbase",
        "quotedblbase",
        "quotedblright",
        "guillemotright",
        "ellipsis",
        "perthousand",
        "",
        "questiondown",
        "",
        "grave",
        "acute",
        "circumflex",
        "tilde",
        "macron",
        "breve",
        "dotaccent",
        "dieresis",
        "",
        "ring",
        "cedilla",
        "",
        "hungarumlaut",
        "ogonek",
        "caron",
        "emdash",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "AE",
        "",
        "ordfeminine",
        "",
        "",
        "",
        "",
        "Lslash",
        "Oslash",
        "OE",
        "ordmasculine",
        "",
        "",
        "",
        "",
        "",
        "ae",
        "",
        "",
        "",
        "dotlessi",
        "",
        "",
        "lslash",
        "oslash",
        "oe",
        "germandbls",
        "",
        "",
        "",
        "",
      ];
      r.StandardEncoding = c;
      var u = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "space",
        "exclam",
        "quotedbl",
        "numbersign",
        "dollar",
        "percent",
        "ampersand",
        "quotesingle",
        "parenleft",
        "parenright",
        "asterisk",
        "plus",
        "comma",
        "hyphen",
        "period",
        "slash",
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "colon",
        "semicolon",
        "less",
        "equal",
        "greater",
        "question",
        "at",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "bracketleft",
        "backslash",
        "bracketright",
        "asciicircum",
        "underscore",
        "grave",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "braceleft",
        "bar",
        "braceright",
        "asciitilde",
        "bullet",
        "Euro",
        "bullet",
        "quotesinglbase",
        "florin",
        "quotedblbase",
        "ellipsis",
        "dagger",
        "daggerdbl",
        "circumflex",
        "perthousand",
        "Scaron",
        "guilsinglleft",
        "OE",
        "bullet",
        "Zcaron",
        "bullet",
        "bullet",
        "quoteleft",
        "quoteright",
        "quotedblleft",
        "quotedblright",
        "bullet",
        "endash",
        "emdash",
        "tilde",
        "trademark",
        "scaron",
        "guilsinglright",
        "oe",
        "bullet",
        "zcaron",
        "Ydieresis",
        "space",
        "exclamdown",
        "cent",
        "sterling",
        "currency",
        "yen",
        "brokenbar",
        "section",
        "dieresis",
        "copyright",
        "ordfeminine",
        "guillemotleft",
        "logicalnot",
        "hyphen",
        "registered",
        "macron",
        "degree",
        "plusminus",
        "twosuperior",
        "threesuperior",
        "acute",
        "mu",
        "paragraph",
        "periodcentered",
        "cedilla",
        "onesuperior",
        "ordmasculine",
        "guillemotright",
        "onequarter",
        "onehalf",
        "threequarters",
        "questiondown",
        "Agrave",
        "Aacute",
        "Acircumflex",
        "Atilde",
        "Adieresis",
        "Aring",
        "AE",
        "Ccedilla",
        "Egrave",
        "Eacute",
        "Ecircumflex",
        "Edieresis",
        "Igrave",
        "Iacute",
        "Icircumflex",
        "Idieresis",
        "Eth",
        "Ntilde",
        "Ograve",
        "Oacute",
        "Ocircumflex",
        "Otilde",
        "Odieresis",
        "multiply",
        "Oslash",
        "Ugrave",
        "Uacute",
        "Ucircumflex",
        "Udieresis",
        "Yacute",
        "Thorn",
        "germandbls",
        "agrave",
        "aacute",
        "acircumflex",
        "atilde",
        "adieresis",
        "aring",
        "ae",
        "ccedilla",
        "egrave",
        "eacute",
        "ecircumflex",
        "edieresis",
        "igrave",
        "iacute",
        "icircumflex",
        "idieresis",
        "eth",
        "ntilde",
        "ograve",
        "oacute",
        "ocircumflex",
        "otilde",
        "odieresis",
        "divide",
        "oslash",
        "ugrave",
        "uacute",
        "ucircumflex",
        "udieresis",
        "yacute",
        "thorn",
        "ydieresis",
      ];
      r.WinAnsiEncoding = u;
      var h = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "space",
        "exclam",
        "universal",
        "numbersign",
        "existential",
        "percent",
        "ampersand",
        "suchthat",
        "parenleft",
        "parenright",
        "asteriskmath",
        "plus",
        "comma",
        "minus",
        "period",
        "slash",
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "colon",
        "semicolon",
        "less",
        "equal",
        "greater",
        "question",
        "congruent",
        "Alpha",
        "Beta",
        "Chi",
        "Delta",
        "Epsilon",
        "Phi",
        "Gamma",
        "Eta",
        "Iota",
        "theta1",
        "Kappa",
        "Lambda",
        "Mu",
        "Nu",
        "Omicron",
        "Pi",
        "Theta",
        "Rho",
        "Sigma",
        "Tau",
        "Upsilon",
        "sigma1",
        "Omega",
        "Xi",
        "Psi",
        "Zeta",
        "bracketleft",
        "therefore",
        "bracketright",
        "perpendicular",
        "underscore",
        "radicalex",
        "alpha",
        "beta",
        "chi",
        "delta",
        "epsilon",
        "phi",
        "gamma",
        "eta",
        "iota",
        "phi1",
        "kappa",
        "lambda",
        "mu",
        "nu",
        "omicron",
        "pi",
        "theta",
        "rho",
        "sigma",
        "tau",
        "upsilon",
        "omega1",
        "omega",
        "xi",
        "psi",
        "zeta",
        "braceleft",
        "bar",
        "braceright",
        "similar",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Euro",
        "Upsilon1",
        "minute",
        "lessequal",
        "fraction",
        "infinity",
        "florin",
        "club",
        "diamond",
        "heart",
        "spade",
        "arrowboth",
        "arrowleft",
        "arrowup",
        "arrowright",
        "arrowdown",
        "degree",
        "plusminus",
        "second",
        "greaterequal",
        "multiply",
        "proportional",
        "partialdiff",
        "bullet",
        "divide",
        "notequal",
        "equivalence",
        "approxequal",
        "ellipsis",
        "arrowvertex",
        "arrowhorizex",
        "carriagereturn",
        "aleph",
        "Ifraktur",
        "Rfraktur",
        "weierstrass",
        "circlemultiply",
        "circleplus",
        "emptyset",
        "intersection",
        "union",
        "propersuperset",
        "reflexsuperset",
        "notsubset",
        "propersubset",
        "reflexsubset",
        "element",
        "notelement",
        "angle",
        "gradient",
        "registerserif",
        "copyrightserif",
        "trademarkserif",
        "product",
        "radical",
        "dotmath",
        "logicalnot",
        "logicaland",
        "logicalor",
        "arrowdblboth",
        "arrowdblleft",
        "arrowdblup",
        "arrowdblright",
        "arrowdbldown",
        "lozenge",
        "angleleft",
        "registersans",
        "copyrightsans",
        "trademarksans",
        "summation",
        "parenlefttp",
        "parenleftex",
        "parenleftbt",
        "bracketlefttp",
        "bracketleftex",
        "bracketleftbt",
        "bracelefttp",
        "braceleftmid",
        "braceleftbt",
        "braceex",
        "",
        "angleright",
        "integral",
        "integraltp",
        "integralex",
        "integralbt",
        "parenrighttp",
        "parenrightex",
        "parenrightbt",
        "bracketrighttp",
        "bracketrightex",
        "bracketrightbt",
        "bracerighttp",
        "bracerightmid",
        "bracerightbt",
        "",
      ];
      r.SymbolSetEncoding = h;
      var d = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "space",
        "a1",
        "a2",
        "a202",
        "a3",
        "a4",
        "a5",
        "a119",
        "a118",
        "a117",
        "a11",
        "a12",
        "a13",
        "a14",
        "a15",
        "a16",
        "a105",
        "a17",
        "a18",
        "a19",
        "a20",
        "a21",
        "a22",
        "a23",
        "a24",
        "a25",
        "a26",
        "a27",
        "a28",
        "a6",
        "a7",
        "a8",
        "a9",
        "a10",
        "a29",
        "a30",
        "a31",
        "a32",
        "a33",
        "a34",
        "a35",
        "a36",
        "a37",
        "a38",
        "a39",
        "a40",
        "a41",
        "a42",
        "a43",
        "a44",
        "a45",
        "a46",
        "a47",
        "a48",
        "a49",
        "a50",
        "a51",
        "a52",
        "a53",
        "a54",
        "a55",
        "a56",
        "a57",
        "a58",
        "a59",
        "a60",
        "a61",
        "a62",
        "a63",
        "a64",
        "a65",
        "a66",
        "a67",
        "a68",
        "a69",
        "a70",
        "a71",
        "a72",
        "a73",
        "a74",
        "a203",
        "a75",
        "a204",
        "a76",
        "a77",
        "a78",
        "a79",
        "a81",
        "a82",
        "a83",
        "a84",
        "a97",
        "a98",
        "a99",
        "a100",
        "",
        "a89",
        "a90",
        "a93",
        "a94",
        "a91",
        "a92",
        "a205",
        "a85",
        "a206",
        "a86",
        "a87",
        "a88",
        "a95",
        "a96",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "a101",
        "a102",
        "a103",
        "a104",
        "a106",
        "a107",
        "a108",
        "a112",
        "a111",
        "a110",
        "a109",
        "a120",
        "a121",
        "a122",
        "a123",
        "a124",
        "a125",
        "a126",
        "a127",
        "a128",
        "a129",
        "a130",
        "a131",
        "a132",
        "a133",
        "a134",
        "a135",
        "a136",
        "a137",
        "a138",
        "a139",
        "a140",
        "a141",
        "a142",
        "a143",
        "a144",
        "a145",
        "a146",
        "a147",
        "a148",
        "a149",
        "a150",
        "a151",
        "a152",
        "a153",
        "a154",
        "a155",
        "a156",
        "a157",
        "a158",
        "a159",
        "a160",
        "a161",
        "a163",
        "a164",
        "a196",
        "a165",
        "a192",
        "a166",
        "a167",
        "a168",
        "a169",
        "a170",
        "a171",
        "a172",
        "a173",
        "a162",
        "a174",
        "a175",
        "a176",
        "a177",
        "a178",
        "a179",
        "a193",
        "a180",
        "a199",
        "a181",
        "a200",
        "a182",
        "",
        "a201",
        "a183",
        "a184",
        "a197",
        "a185",
        "a194",
        "a198",
        "a186",
        "a195",
        "a187",
        "a188",
        "a189",
        "a190",
        "a191",
        "",
      ];
      r.ZapfDingbatsEncoding = d;
    },
    function (t, r, a) {
      var i = a(201).getLookupTableFactory,
        o = i(function (t) {
          (t.A = 65),
            (t.AE = 198),
            (t.AEacute = 508),
            (t.AEmacron = 482),
            (t.AEsmall = 63462),
            (t.Aacute = 193),
            (t.Aacutesmall = 63457),
            (t.Abreve = 258),
            (t.Abreveacute = 7854),
            (t.Abrevecyrillic = 1232),
            (t.Abrevedotbelow = 7862),
            (t.Abrevegrave = 7856),
            (t.Abrevehookabove = 7858),
            (t.Abrevetilde = 7860),
            (t.Acaron = 461),
            (t.Acircle = 9398),
            (t.Acircumflex = 194),
            (t.Acircumflexacute = 7844),
            (t.Acircumflexdotbelow = 7852),
            (t.Acircumflexgrave = 7846),
            (t.Acircumflexhookabove = 7848),
            (t.Acircumflexsmall = 63458),
            (t.Acircumflextilde = 7850),
            (t.Acute = 63177),
            (t.Acutesmall = 63412),
            (t.Acyrillic = 1040),
            (t.Adblgrave = 512),
            (t.Adieresis = 196),
            (t.Adieresiscyrillic = 1234),
            (t.Adieresismacron = 478),
            (t.Adieresissmall = 63460),
            (t.Adotbelow = 7840),
            (t.Adotmacron = 480),
            (t.Agrave = 192),
            (t.Agravesmall = 63456),
            (t.Ahookabove = 7842),
            (t.Aiecyrillic = 1236),
            (t.Ainvertedbreve = 514),
            (t.Alpha = 913),
            (t.Alphatonos = 902),
            (t.Amacron = 256),
            (t.Amonospace = 65313),
            (t.Aogonek = 260),
            (t.Aring = 197),
            (t.Aringacute = 506),
            (t.Aringbelow = 7680),
            (t.Aringsmall = 63461),
            (t.Asmall = 63329),
            (t.Atilde = 195),
            (t.Atildesmall = 63459),
            (t.Aybarmenian = 1329),
            (t.B = 66),
            (t.Bcircle = 9399),
            (t.Bdotaccent = 7682),
            (t.Bdotbelow = 7684),
            (t.Becyrillic = 1041),
            (t.Benarmenian = 1330),
            (t.Beta = 914),
            (t.Bhook = 385),
            (t.Blinebelow = 7686),
            (t.Bmonospace = 65314),
            (t.Brevesmall = 63220),
            (t.Bsmall = 63330),
            (t.Btopbar = 386),
            (t.C = 67),
            (t.Caarmenian = 1342),
            (t.Cacute = 262),
            (t.Caron = 63178),
            (t.Caronsmall = 63221),
            (t.Ccaron = 268),
            (t.Ccedilla = 199),
            (t.Ccedillaacute = 7688),
            (t.Ccedillasmall = 63463),
            (t.Ccircle = 9400),
            (t.Ccircumflex = 264),
            (t.Cdot = 266),
            (t.Cdotaccent = 266),
            (t.Cedillasmall = 63416),
            (t.Chaarmenian = 1353),
            (t.Cheabkhasiancyrillic = 1212),
            (t.Checyrillic = 1063),
            (t.Chedescenderabkhasiancyrillic = 1214),
            (t.Chedescendercyrillic = 1206),
            (t.Chedieresiscyrillic = 1268),
            (t.Cheharmenian = 1347),
            (t.Chekhakassiancyrillic = 1227),
            (t.Cheverticalstrokecyrillic = 1208),
            (t.Chi = 935),
            (t.Chook = 391),
            (t.Circumflexsmall = 63222),
            (t.Cmonospace = 65315),
            (t.Coarmenian = 1361),
            (t.Csmall = 63331),
            (t.D = 68),
            (t.DZ = 497),
            (t.DZcaron = 452),
            (t.Daarmenian = 1332),
            (t.Dafrican = 393),
            (t.Dcaron = 270),
            (t.Dcedilla = 7696),
            (t.Dcircle = 9401),
            (t.Dcircumflexbelow = 7698),
            (t.Dcroat = 272),
            (t.Ddotaccent = 7690),
            (t.Ddotbelow = 7692),
            (t.Decyrillic = 1044),
            (t.Deicoptic = 1006),
            (t.Delta = 8710),
            (t.Deltagreek = 916),
            (t.Dhook = 394),
            (t.Dieresis = 63179),
            (t.DieresisAcute = 63180),
            (t.DieresisGrave = 63181),
            (t.Dieresissmall = 63400),
            (t.Digammagreek = 988),
            (t.Djecyrillic = 1026),
            (t.Dlinebelow = 7694),
            (t.Dmonospace = 65316),
            (t.Dotaccentsmall = 63223),
            (t.Dslash = 272),
            (t.Dsmall = 63332),
            (t.Dtopbar = 395),
            (t.Dz = 498),
            (t.Dzcaron = 453),
            (t.Dzeabkhasiancyrillic = 1248),
            (t.Dzecyrillic = 1029),
            (t.Dzhecyrillic = 1039),
            (t.E = 69),
            (t.Eacute = 201),
            (t.Eacutesmall = 63465),
            (t.Ebreve = 276),
            (t.Ecaron = 282),
            (t.Ecedillabreve = 7708),
            (t.Echarmenian = 1333),
            (t.Ecircle = 9402),
            (t.Ecircumflex = 202),
            (t.Ecircumflexacute = 7870),
            (t.Ecircumflexbelow = 7704),
            (t.Ecircumflexdotbelow = 7878),
            (t.Ecircumflexgrave = 7872),
            (t.Ecircumflexhookabove = 7874),
            (t.Ecircumflexsmall = 63466),
            (t.Ecircumflextilde = 7876),
            (t.Ecyrillic = 1028),
            (t.Edblgrave = 516),
            (t.Edieresis = 203),
            (t.Edieresissmall = 63467),
            (t.Edot = 278),
            (t.Edotaccent = 278),
            (t.Edotbelow = 7864),
            (t.Efcyrillic = 1060),
            (t.Egrave = 200),
            (t.Egravesmall = 63464),
            (t.Eharmenian = 1335),
            (t.Ehookabove = 7866),
            (t.Eightroman = 8551),
            (t.Einvertedbreve = 518),
            (t.Eiotifiedcyrillic = 1124),
            (t.Elcyrillic = 1051),
            (t.Elevenroman = 8554),
            (t.Emacron = 274),
            (t.Emacronacute = 7702),
            (t.Emacrongrave = 7700),
            (t.Emcyrillic = 1052),
            (t.Emonospace = 65317),
            (t.Encyrillic = 1053),
            (t.Endescendercyrillic = 1186),
            (t.Eng = 330),
            (t.Enghecyrillic = 1188),
            (t.Enhookcyrillic = 1223),
            (t.Eogonek = 280),
            (t.Eopen = 400),
            (t.Epsilon = 917),
            (t.Epsilontonos = 904),
            (t.Ercyrillic = 1056),
            (t.Ereversed = 398),
            (t.Ereversedcyrillic = 1069),
            (t.Escyrillic = 1057),
            (t.Esdescendercyrillic = 1194),
            (t.Esh = 425),
            (t.Esmall = 63333),
            (t.Eta = 919),
            (t.Etarmenian = 1336),
            (t.Etatonos = 905),
            (t.Eth = 208),
            (t.Ethsmall = 63472),
            (t.Etilde = 7868),
            (t.Etildebelow = 7706),
            (t.Euro = 8364),
            (t.Ezh = 439),
            (t.Ezhcaron = 494),
            (t.Ezhreversed = 440),
            (t.F = 70),
            (t.Fcircle = 9403),
            (t.Fdotaccent = 7710),
            (t.Feharmenian = 1366),
            (t.Feicoptic = 996),
            (t.Fhook = 401),
            (t.Fitacyrillic = 1138),
            (t.Fiveroman = 8548),
            (t.Fmonospace = 65318),
            (t.Fourroman = 8547),
            (t.Fsmall = 63334),
            (t.G = 71),
            (t.GBsquare = 13191),
            (t.Gacute = 500),
            (t.Gamma = 915),
            (t.Gammaafrican = 404),
            (t.Gangiacoptic = 1002),
            (t.Gbreve = 286),
            (t.Gcaron = 486),
            (t.Gcedilla = 290),
            (t.Gcircle = 9404),
            (t.Gcircumflex = 284),
            (t.Gcommaaccent = 290),
            (t.Gdot = 288),
            (t.Gdotaccent = 288),
            (t.Gecyrillic = 1043),
            (t.Ghadarmenian = 1346),
            (t.Ghemiddlehookcyrillic = 1172),
            (t.Ghestrokecyrillic = 1170),
            (t.Gheupturncyrillic = 1168),
            (t.Ghook = 403),
            (t.Gimarmenian = 1331),
            (t.Gjecyrillic = 1027),
            (t.Gmacron = 7712),
            (t.Gmonospace = 65319),
            (t.Grave = 63182),
            (t.Gravesmall = 63328),
            (t.Gsmall = 63335),
            (t.Gsmallhook = 667),
            (t.Gstroke = 484),
            (t.H = 72),
            (t.H18533 = 9679),
            (t.H18543 = 9642),
            (t.H18551 = 9643),
            (t.H22073 = 9633),
            (t.HPsquare = 13259),
            (t.Haabkhasiancyrillic = 1192),
            (t.Hadescendercyrillic = 1202),
            (t.Hardsigncyrillic = 1066),
            (t.Hbar = 294),
            (t.Hbrevebelow = 7722),
            (t.Hcedilla = 7720),
            (t.Hcircle = 9405),
            (t.Hcircumflex = 292),
            (t.Hdieresis = 7718),
            (t.Hdotaccent = 7714),
            (t.Hdotbelow = 7716),
            (t.Hmonospace = 65320),
            (t.Hoarmenian = 1344),
            (t.Horicoptic = 1e3),
            (t.Hsmall = 63336),
            (t.Hungarumlaut = 63183),
            (t.Hungarumlautsmall = 63224),
            (t.Hzsquare = 13200),
            (t.I = 73),
            (t.IAcyrillic = 1071),
            (t.IJ = 306),
            (t.IUcyrillic = 1070),
            (t.Iacute = 205),
            (t.Iacutesmall = 63469),
            (t.Ibreve = 300),
            (t.Icaron = 463),
            (t.Icircle = 9406),
            (t.Icircumflex = 206),
            (t.Icircumflexsmall = 63470),
            (t.Icyrillic = 1030),
            (t.Idblgrave = 520),
            (t.Idieresis = 207),
            (t.Idieresisacute = 7726),
            (t.Idieresiscyrillic = 1252),
            (t.Idieresissmall = 63471),
            (t.Idot = 304),
            (t.Idotaccent = 304),
            (t.Idotbelow = 7882),
            (t.Iebrevecyrillic = 1238),
            (t.Iecyrillic = 1045),
            (t.Ifraktur = 8465),
            (t.Igrave = 204),
            (t.Igravesmall = 63468),
            (t.Ihookabove = 7880),
            (t.Iicyrillic = 1048),
            (t.Iinvertedbreve = 522),
            (t.Iishortcyrillic = 1049),
            (t.Imacron = 298),
            (t.Imacroncyrillic = 1250),
            (t.Imonospace = 65321),
            (t.Iniarmenian = 1339),
            (t.Iocyrillic = 1025),
            (t.Iogonek = 302),
            (t.Iota = 921),
            (t.Iotaafrican = 406),
            (t.Iotadieresis = 938),
            (t.Iotatonos = 906),
            (t.Ismall = 63337),
            (t.Istroke = 407),
            (t.Itilde = 296),
            (t.Itildebelow = 7724),
            (t.Izhitsacyrillic = 1140),
            (t.Izhitsadblgravecyrillic = 1142),
            (t.J = 74),
            (t.Jaarmenian = 1345),
            (t.Jcircle = 9407),
            (t.Jcircumflex = 308),
            (t.Jecyrillic = 1032),
            (t.Jheharmenian = 1355),
            (t.Jmonospace = 65322),
            (t.Jsmall = 63338),
            (t.K = 75),
            (t.KBsquare = 13189),
            (t.KKsquare = 13261),
            (t.Kabashkircyrillic = 1184),
            (t.Kacute = 7728),
            (t.Kacyrillic = 1050),
            (t.Kadescendercyrillic = 1178),
            (t.Kahookcyrillic = 1219),
            (t.Kappa = 922),
            (t.Kastrokecyrillic = 1182),
            (t.Kaverticalstrokecyrillic = 1180),
            (t.Kcaron = 488),
            (t.Kcedilla = 310),
            (t.Kcircle = 9408),
            (t.Kcommaaccent = 310),
            (t.Kdotbelow = 7730),
            (t.Keharmenian = 1364),
            (t.Kenarmenian = 1343),
            (t.Khacyrillic = 1061),
            (t.Kheicoptic = 998),
            (t.Khook = 408),
            (t.Kjecyrillic = 1036),
            (t.Klinebelow = 7732),
            (t.Kmonospace = 65323),
            (t.Koppacyrillic = 1152),
            (t.Koppagreek = 990),
            (t.Ksicyrillic = 1134),
            (t.Ksmall = 63339),
            (t.L = 76),
            (t.LJ = 455),
            (t.LL = 63167),
            (t.Lacute = 313),
            (t.Lambda = 923),
            (t.Lcaron = 317),
            (t.Lcedilla = 315),
            (t.Lcircle = 9409),
            (t.Lcircumflexbelow = 7740),
            (t.Lcommaaccent = 315),
            (t.Ldot = 319),
            (t.Ldotaccent = 319),
            (t.Ldotbelow = 7734),
            (t.Ldotbelowmacron = 7736),
            (t.Liwnarmenian = 1340),
            (t.Lj = 456),
            (t.Ljecyrillic = 1033),
            (t.Llinebelow = 7738),
            (t.Lmonospace = 65324),
            (t.Lslash = 321),
            (t.Lslashsmall = 63225),
            (t.Lsmall = 63340),
            (t.M = 77),
            (t.MBsquare = 13190),
            (t.Macron = 63184),
            (t.Macronsmall = 63407),
            (t.Macute = 7742),
            (t.Mcircle = 9410),
            (t.Mdotaccent = 7744),
            (t.Mdotbelow = 7746),
            (t.Menarmenian = 1348),
            (t.Mmonospace = 65325),
            (t.Msmall = 63341),
            (t.Mturned = 412),
            (t.Mu = 924),
            (t.N = 78),
            (t.NJ = 458),
            (t.Nacute = 323),
            (t.Ncaron = 327),
            (t.Ncedilla = 325),
            (t.Ncircle = 9411),
            (t.Ncircumflexbelow = 7754),
            (t.Ncommaaccent = 325),
            (t.Ndotaccent = 7748),
            (t.Ndotbelow = 7750),
            (t.Nhookleft = 413),
            (t.Nineroman = 8552),
            (t.Nj = 459),
            (t.Njecyrillic = 1034),
            (t.Nlinebelow = 7752),
            (t.Nmonospace = 65326),
            (t.Nowarmenian = 1350),
            (t.Nsmall = 63342),
            (t.Ntilde = 209),
            (t.Ntildesmall = 63473),
            (t.Nu = 925),
            (t.O = 79),
            (t.OE = 338),
            (t.OEsmall = 63226),
            (t.Oacute = 211),
            (t.Oacutesmall = 63475),
            (t.Obarredcyrillic = 1256),
            (t.Obarreddieresiscyrillic = 1258),
            (t.Obreve = 334),
            (t.Ocaron = 465),
            (t.Ocenteredtilde = 415),
            (t.Ocircle = 9412),
            (t.Ocircumflex = 212),
            (t.Ocircumflexacute = 7888),
            (t.Ocircumflexdotbelow = 7896),
            (t.Ocircumflexgrave = 7890),
            (t.Ocircumflexhookabove = 7892),
            (t.Ocircumflexsmall = 63476),
            (t.Ocircumflextilde = 7894),
            (t.Ocyrillic = 1054),
            (t.Odblacute = 336),
            (t.Odblgrave = 524),
            (t.Odieresis = 214),
            (t.Odieresiscyrillic = 1254),
            (t.Odieresissmall = 63478),
            (t.Odotbelow = 7884),
            (t.Ogoneksmall = 63227),
            (t.Ograve = 210),
            (t.Ogravesmall = 63474),
            (t.Oharmenian = 1365),
            (t.Ohm = 8486),
            (t.Ohookabove = 7886),
            (t.Ohorn = 416),
            (t.Ohornacute = 7898),
            (t.Ohorndotbelow = 7906),
            (t.Ohorngrave = 7900),
            (t.Ohornhookabove = 7902),
            (t.Ohorntilde = 7904),
            (t.Ohungarumlaut = 336),
            (t.Oi = 418),
            (t.Oinvertedbreve = 526),
            (t.Omacron = 332),
            (t.Omacronacute = 7762),
            (t.Omacrongrave = 7760),
            (t.Omega = 8486),
            (t.Omegacyrillic = 1120),
            (t.Omegagreek = 937),
            (t.Omegaroundcyrillic = 1146),
            (t.Omegatitlocyrillic = 1148),
            (t.Omegatonos = 911),
            (t.Omicron = 927),
            (t.Omicrontonos = 908),
            (t.Omonospace = 65327),
            (t.Oneroman = 8544),
            (t.Oogonek = 490),
            (t.Oogonekmacron = 492),
            (t.Oopen = 390),
            (t.Oslash = 216),
            (t.Oslashacute = 510),
            (t.Oslashsmall = 63480),
            (t.Osmall = 63343),
            (t.Ostrokeacute = 510),
            (t.Otcyrillic = 1150),
            (t.Otilde = 213),
            (t.Otildeacute = 7756),
            (t.Otildedieresis = 7758),
            (t.Otildesmall = 63477),
            (t.P = 80),
            (t.Pacute = 7764),
            (t.Pcircle = 9413),
            (t.Pdotaccent = 7766),
            (t.Pecyrillic = 1055),
            (t.Peharmenian = 1354),
            (t.Pemiddlehookcyrillic = 1190),
            (t.Phi = 934),
            (t.Phook = 420),
            (t.Pi = 928),
            (t.Piwrarmenian = 1363),
            (t.Pmonospace = 65328),
            (t.Psi = 936),
            (t.Psicyrillic = 1136),
            (t.Psmall = 63344),
            (t.Q = 81),
            (t.Qcircle = 9414),
            (t.Qmonospace = 65329),
            (t.Qsmall = 63345),
            (t.R = 82),
            (t.Raarmenian = 1356),
            (t.Racute = 340),
            (t.Rcaron = 344),
            (t.Rcedilla = 342),
            (t.Rcircle = 9415),
            (t.Rcommaaccent = 342),
            (t.Rdblgrave = 528),
            (t.Rdotaccent = 7768),
            (t.Rdotbelow = 7770),
            (t.Rdotbelowmacron = 7772),
            (t.Reharmenian = 1360),
            (t.Rfraktur = 8476),
            (t.Rho = 929),
            (t.Ringsmall = 63228),
            (t.Rinvertedbreve = 530),
            (t.Rlinebelow = 7774),
            (t.Rmonospace = 65330),
            (t.Rsmall = 63346),
            (t.Rsmallinverted = 641),
            (t.Rsmallinvertedsuperior = 694),
            (t.S = 83),
            (t.SF010000 = 9484),
            (t.SF020000 = 9492),
            (t.SF030000 = 9488),
            (t.SF040000 = 9496),
            (t.SF050000 = 9532),
            (t.SF060000 = 9516),
            (t.SF070000 = 9524),
            (t.SF080000 = 9500),
            (t.SF090000 = 9508),
            (t.SF100000 = 9472),
            (t.SF110000 = 9474),
            (t.SF190000 = 9569),
            (t.SF200000 = 9570),
            (t.SF210000 = 9558),
            (t.SF220000 = 9557),
            (t.SF230000 = 9571),
            (t.SF240000 = 9553),
            (t.SF250000 = 9559),
            (t.SF260000 = 9565),
            (t.SF270000 = 9564),
            (t.SF280000 = 9563),
            (t.SF360000 = 9566),
            (t.SF370000 = 9567),
            (t.SF380000 = 9562),
            (t.SF390000 = 9556),
            (t.SF400000 = 9577),
            (t.SF410000 = 9574),
            (t.SF420000 = 9568),
            (t.SF430000 = 9552),
            (t.SF440000 = 9580),
            (t.SF450000 = 9575),
            (t.SF460000 = 9576),
            (t.SF470000 = 9572),
            (t.SF480000 = 9573),
            (t.SF490000 = 9561),
            (t.SF500000 = 9560),
            (t.SF510000 = 9554),
            (t.SF520000 = 9555),
            (t.SF530000 = 9579),
            (t.SF540000 = 9578),
            (t.Sacute = 346),
            (t.Sacutedotaccent = 7780),
            (t.Sampigreek = 992),
            (t.Scaron = 352),
            (t.Scarondotaccent = 7782),
            (t.Scaronsmall = 63229),
            (t.Scedilla = 350),
            (t.Schwa = 399),
            (t.Schwacyrillic = 1240),
            (t.Schwadieresiscyrillic = 1242),
            (t.Scircle = 9416),
            (t.Scircumflex = 348),
            (t.Scommaaccent = 536),
            (t.Sdotaccent = 7776),
            (t.Sdotbelow = 7778),
            (t.Sdotbelowdotaccent = 7784),
            (t.Seharmenian = 1357),
            (t.Sevenroman = 8550),
            (t.Shaarmenian = 1351),
            (t.Shacyrillic = 1064),
            (t.Shchacyrillic = 1065),
            (t.Sheicoptic = 994),
            (t.Shhacyrillic = 1210),
            (t.Shimacoptic = 1004),
            (t.Sigma = 931),
            (t.Sixroman = 8549),
            (t.Smonospace = 65331),
            (t.Softsigncyrillic = 1068),
            (t.Ssmall = 63347),
            (t.Stigmagreek = 986),
            (t.T = 84),
            (t.Tau = 932),
            (t.Tbar = 358),
            (t.Tcaron = 356),
            (t.Tcedilla = 354),
            (t.Tcircle = 9417),
            (t.Tcircumflexbelow = 7792),
            (t.Tcommaaccent = 354),
            (t.Tdotaccent = 7786),
            (t.Tdotbelow = 7788),
            (t.Tecyrillic = 1058),
            (t.Tedescendercyrillic = 1196),
            (t.Tenroman = 8553),
            (t.Tetsecyrillic = 1204),
            (t.Theta = 920),
            (t.Thook = 428),
            (t.Thorn = 222),
            (t.Thornsmall = 63486),
            (t.Threeroman = 8546),
            (t.Tildesmall = 63230),
            (t.Tiwnarmenian = 1359),
            (t.Tlinebelow = 7790),
            (t.Tmonospace = 65332),
            (t.Toarmenian = 1337),
            (t.Tonefive = 444),
            (t.Tonesix = 388),
            (t.Tonetwo = 423),
            (t.Tretroflexhook = 430),
            (t.Tsecyrillic = 1062),
            (t.Tshecyrillic = 1035),
            (t.Tsmall = 63348),
            (t.Twelveroman = 8555),
            (t.Tworoman = 8545),
            (t.U = 85),
            (t.Uacute = 218),
            (t.Uacutesmall = 63482),
            (t.Ubreve = 364),
            (t.Ucaron = 467),
            (t.Ucircle = 9418),
            (t.Ucircumflex = 219),
            (t.Ucircumflexbelow = 7798),
            (t.Ucircumflexsmall = 63483),
            (t.Ucyrillic = 1059),
            (t.Udblacute = 368),
            (t.Udblgrave = 532),
            (t.Udieresis = 220),
            (t.Udieresisacute = 471),
            (t.Udieresisbelow = 7794),
            (t.Udieresiscaron = 473),
            (t.Udieresiscyrillic = 1264),
            (t.Udieresisgrave = 475),
            (t.Udieresismacron = 469),
            (t.Udieresissmall = 63484),
            (t.Udotbelow = 7908),
            (t.Ugrave = 217),
            (t.Ugravesmall = 63481),
            (t.Uhookabove = 7910),
            (t.Uhorn = 431),
            (t.Uhornacute = 7912),
            (t.Uhorndotbelow = 7920),
            (t.Uhorngrave = 7914),
            (t.Uhornhookabove = 7916),
            (t.Uhorntilde = 7918),
            (t.Uhungarumlaut = 368),
            (t.Uhungarumlautcyrillic = 1266),
            (t.Uinvertedbreve = 534),
            (t.Ukcyrillic = 1144),
            (t.Umacron = 362),
            (t.Umacroncyrillic = 1262),
            (t.Umacrondieresis = 7802),
            (t.Umonospace = 65333),
            (t.Uogonek = 370),
            (t.Upsilon = 933),
            (t.Upsilon1 = 978),
            (t.Upsilonacutehooksymbolgreek = 979),
            (t.Upsilonafrican = 433),
            (t.Upsilondieresis = 939),
            (t.Upsilondieresishooksymbolgreek = 980),
            (t.Upsilonhooksymbol = 978),
            (t.Upsilontonos = 910),
            (t.Uring = 366),
            (t.Ushortcyrillic = 1038),
            (t.Usmall = 63349),
            (t.Ustraightcyrillic = 1198),
            (t.Ustraightstrokecyrillic = 1200),
            (t.Utilde = 360),
            (t.Utildeacute = 7800),
            (t.Utildebelow = 7796),
            (t.V = 86),
            (t.Vcircle = 9419),
            (t.Vdotbelow = 7806),
            (t.Vecyrillic = 1042),
            (t.Vewarmenian = 1358),
            (t.Vhook = 434),
            (t.Vmonospace = 65334),
            (t.Voarmenian = 1352),
            (t.Vsmall = 63350),
            (t.Vtilde = 7804),
            (t.W = 87),
            (t.Wacute = 7810),
            (t.Wcircle = 9420),
            (t.Wcircumflex = 372),
            (t.Wdieresis = 7812),
            (t.Wdotaccent = 7814),
            (t.Wdotbelow = 7816),
            (t.Wgrave = 7808),
            (t.Wmonospace = 65335),
            (t.Wsmall = 63351),
            (t.X = 88),
            (t.Xcircle = 9421),
            (t.Xdieresis = 7820),
            (t.Xdotaccent = 7818),
            (t.Xeharmenian = 1341),
            (t.Xi = 926),
            (t.Xmonospace = 65336),
            (t.Xsmall = 63352),
            (t.Y = 89),
            (t.Yacute = 221),
            (t.Yacutesmall = 63485),
            (t.Yatcyrillic = 1122),
            (t.Ycircle = 9422),
            (t.Ycircumflex = 374),
            (t.Ydieresis = 376),
            (t.Ydieresissmall = 63487),
            (t.Ydotaccent = 7822),
            (t.Ydotbelow = 7924),
            (t.Yericyrillic = 1067),
            (t.Yerudieresiscyrillic = 1272),
            (t.Ygrave = 7922),
            (t.Yhook = 435),
            (t.Yhookabove = 7926),
            (t.Yiarmenian = 1349),
            (t.Yicyrillic = 1031),
            (t.Yiwnarmenian = 1362),
            (t.Ymonospace = 65337),
            (t.Ysmall = 63353),
            (t.Ytilde = 7928),
            (t.Yusbigcyrillic = 1130),
            (t.Yusbigiotifiedcyrillic = 1132),
            (t.Yuslittlecyrillic = 1126),
            (t.Yuslittleiotifiedcyrillic = 1128),
            (t.Z = 90),
            (t.Zaarmenian = 1334),
            (t.Zacute = 377),
            (t.Zcaron = 381),
            (t.Zcaronsmall = 63231),
            (t.Zcircle = 9423),
            (t.Zcircumflex = 7824),
            (t.Zdot = 379),
            (t.Zdotaccent = 379),
            (t.Zdotbelow = 7826),
            (t.Zecyrillic = 1047),
            (t.Zedescendercyrillic = 1176),
            (t.Zedieresiscyrillic = 1246),
            (t.Zeta = 918),
            (t.Zhearmenian = 1338),
            (t.Zhebrevecyrillic = 1217),
            (t.Zhecyrillic = 1046),
            (t.Zhedescendercyrillic = 1174),
            (t.Zhedieresiscyrillic = 1244),
            (t.Zlinebelow = 7828),
            (t.Zmonospace = 65338),
            (t.Zsmall = 63354),
            (t.Zstroke = 437),
            (t.a = 97),
            (t.aabengali = 2438),
            (t.aacute = 225),
            (t.aadeva = 2310),
            (t.aagujarati = 2694),
            (t.aagurmukhi = 2566),
            (t.aamatragurmukhi = 2622),
            (t.aarusquare = 13059),
            (t.aavowelsignbengali = 2494),
            (t.aavowelsigndeva = 2366),
            (t.aavowelsigngujarati = 2750),
            (t.abbreviationmarkarmenian = 1375),
            (t.abbreviationsigndeva = 2416),
            (t.abengali = 2437),
            (t.abopomofo = 12570),
            (t.abreve = 259),
            (t.abreveacute = 7855),
            (t.abrevecyrillic = 1233),
            (t.abrevedotbelow = 7863),
            (t.abrevegrave = 7857),
            (t.abrevehookabove = 7859),
            (t.abrevetilde = 7861),
            (t.acaron = 462),
            (t.acircle = 9424),
            (t.acircumflex = 226),
            (t.acircumflexacute = 7845),
            (t.acircumflexdotbelow = 7853),
            (t.acircumflexgrave = 7847),
            (t.acircumflexhookabove = 7849),
            (t.acircumflextilde = 7851),
            (t.acute = 180),
            (t.acutebelowcmb = 791),
            (t.acutecmb = 769),
            (t.acutecomb = 769),
            (t.acutedeva = 2388),
            (t.acutelowmod = 719),
            (t.acutetonecmb = 833),
            (t.acyrillic = 1072),
            (t.adblgrave = 513),
            (t.addakgurmukhi = 2673),
            (t.adeva = 2309),
            (t.adieresis = 228),
            (t.adieresiscyrillic = 1235),
            (t.adieresismacron = 479),
            (t.adotbelow = 7841),
            (t.adotmacron = 481),
            (t.ae = 230),
            (t.aeacute = 509),
            (t.aekorean = 12624),
            (t.aemacron = 483),
            (t.afii00208 = 8213),
            (t.afii08941 = 8356),
            (t.afii10017 = 1040),
            (t.afii10018 = 1041),
            (t.afii10019 = 1042),
            (t.afii10020 = 1043),
            (t.afii10021 = 1044),
            (t.afii10022 = 1045),
            (t.afii10023 = 1025),
            (t.afii10024 = 1046),
            (t.afii10025 = 1047),
            (t.afii10026 = 1048),
            (t.afii10027 = 1049),
            (t.afii10028 = 1050),
            (t.afii10029 = 1051),
            (t.afii10030 = 1052);
          (t.afii10031 = 1053),
            (t.afii10032 = 1054),
            (t.afii10033 = 1055),
            (t.afii10034 = 1056),
            (t.afii10035 = 1057),
            (t.afii10036 = 1058),
            (t.afii10037 = 1059),
            (t.afii10038 = 1060),
            (t.afii10039 = 1061),
            (t.afii10040 = 1062),
            (t.afii10041 = 1063),
            (t.afii10042 = 1064),
            (t.afii10043 = 1065),
            (t.afii10044 = 1066),
            (t.afii10045 = 1067),
            (t.afii10046 = 1068),
            (t.afii10047 = 1069),
            (t.afii10048 = 1070),
            (t.afii10049 = 1071),
            (t.afii10050 = 1168),
            (t.afii10051 = 1026),
            (t.afii10052 = 1027),
            (t.afii10053 = 1028),
            (t.afii10054 = 1029),
            (t.afii10055 = 1030),
            (t.afii10056 = 1031),
            (t.afii10057 = 1032),
            (t.afii10058 = 1033),
            (t.afii10059 = 1034),
            (t.afii10060 = 1035),
            (t.afii10061 = 1036),
            (t.afii10062 = 1038),
            (t.afii10063 = 63172),
            (t.afii10064 = 63173),
            (t.afii10065 = 1072),
            (t.afii10066 = 1073),
            (t.afii10067 = 1074),
            (t.afii10068 = 1075),
            (t.afii10069 = 1076),
            (t.afii10070 = 1077),
            (t.afii10071 = 1105),
            (t.afii10072 = 1078),
            (t.afii10073 = 1079),
            (t.afii10074 = 1080),
            (t.afii10075 = 1081),
            (t.afii10076 = 1082),
            (t.afii10077 = 1083),
            (t.afii10078 = 1084),
            (t.afii10079 = 1085),
            (t.afii10080 = 1086),
            (t.afii10081 = 1087),
            (t.afii10082 = 1088),
            (t.afii10083 = 1089),
            (t.afii10084 = 1090),
            (t.afii10085 = 1091),
            (t.afii10086 = 1092),
            (t.afii10087 = 1093),
            (t.afii10088 = 1094),
            (t.afii10089 = 1095),
            (t.afii10090 = 1096),
            (t.afii10091 = 1097),
            (t.afii10092 = 1098),
            (t.afii10093 = 1099),
            (t.afii10094 = 1100),
            (t.afii10095 = 1101),
            (t.afii10096 = 1102),
            (t.afii10097 = 1103),
            (t.afii10098 = 1169),
            (t.afii10099 = 1106),
            (t.afii10100 = 1107),
            (t.afii10101 = 1108),
            (t.afii10102 = 1109),
            (t.afii10103 = 1110),
            (t.afii10104 = 1111),
            (t.afii10105 = 1112),
            (t.afii10106 = 1113),
            (t.afii10107 = 1114),
            (t.afii10108 = 1115),
            (t.afii10109 = 1116),
            (t.afii10110 = 1118),
            (t.afii10145 = 1039),
            (t.afii10146 = 1122),
            (t.afii10147 = 1138),
            (t.afii10148 = 1140),
            (t.afii10192 = 63174),
            (t.afii10193 = 1119),
            (t.afii10194 = 1123),
            (t.afii10195 = 1139),
            (t.afii10196 = 1141),
            (t.afii10831 = 63175),
            (t.afii10832 = 63176),
            (t.afii10846 = 1241),
            (t.afii299 = 8206),
            (t.afii300 = 8207),
            (t.afii301 = 8205),
            (t.afii57381 = 1642),
            (t.afii57388 = 1548),
            (t.afii57392 = 1632),
            (t.afii57393 = 1633),
            (t.afii57394 = 1634),
            (t.afii57395 = 1635),
            (t.afii57396 = 1636),
            (t.afii57397 = 1637),
            (t.afii57398 = 1638),
            (t.afii57399 = 1639),
            (t.afii57400 = 1640),
            (t.afii57401 = 1641),
            (t.afii57403 = 1563),
            (t.afii57407 = 1567),
            (t.afii57409 = 1569),
            (t.afii57410 = 1570),
            (t.afii57411 = 1571),
            (t.afii57412 = 1572),
            (t.afii57413 = 1573),
            (t.afii57414 = 1574),
            (t.afii57415 = 1575),
            (t.afii57416 = 1576),
            (t.afii57417 = 1577),
            (t.afii57418 = 1578),
            (t.afii57419 = 1579),
            (t.afii57420 = 1580),
            (t.afii57421 = 1581),
            (t.afii57422 = 1582),
            (t.afii57423 = 1583),
            (t.afii57424 = 1584),
            (t.afii57425 = 1585),
            (t.afii57426 = 1586),
            (t.afii57427 = 1587),
            (t.afii57428 = 1588),
            (t.afii57429 = 1589),
            (t.afii57430 = 1590),
            (t.afii57431 = 1591),
            (t.afii57432 = 1592),
            (t.afii57433 = 1593),
            (t.afii57434 = 1594),
            (t.afii57440 = 1600),
            (t.afii57441 = 1601),
            (t.afii57442 = 1602),
            (t.afii57443 = 1603),
            (t.afii57444 = 1604),
            (t.afii57445 = 1605),
            (t.afii57446 = 1606),
            (t.afii57448 = 1608),
            (t.afii57449 = 1609),
            (t.afii57450 = 1610),
            (t.afii57451 = 1611),
            (t.afii57452 = 1612),
            (t.afii57453 = 1613),
            (t.afii57454 = 1614),
            (t.afii57455 = 1615),
            (t.afii57456 = 1616),
            (t.afii57457 = 1617),
            (t.afii57458 = 1618),
            (t.afii57470 = 1607),
            (t.afii57505 = 1700),
            (t.afii57506 = 1662),
            (t.afii57507 = 1670),
            (t.afii57508 = 1688),
            (t.afii57509 = 1711),
            (t.afii57511 = 1657),
            (t.afii57512 = 1672),
            (t.afii57513 = 1681),
            (t.afii57514 = 1722),
            (t.afii57519 = 1746),
            (t.afii57534 = 1749),
            (t.afii57636 = 8362),
            (t.afii57645 = 1470),
            (t.afii57658 = 1475),
            (t.afii57664 = 1488),
            (t.afii57665 = 1489),
            (t.afii57666 = 1490),
            (t.afii57667 = 1491),
            (t.afii57668 = 1492),
            (t.afii57669 = 1493),
            (t.afii57670 = 1494),
            (t.afii57671 = 1495),
            (t.afii57672 = 1496),
            (t.afii57673 = 1497),
            (t.afii57674 = 1498),
            (t.afii57675 = 1499),
            (t.afii57676 = 1500),
            (t.afii57677 = 1501),
            (t.afii57678 = 1502),
            (t.afii57679 = 1503),
            (t.afii57680 = 1504),
            (t.afii57681 = 1505),
            (t.afii57682 = 1506),
            (t.afii57683 = 1507),
            (t.afii57684 = 1508),
            (t.afii57685 = 1509),
            (t.afii57686 = 1510),
            (t.afii57687 = 1511),
            (t.afii57688 = 1512),
            (t.afii57689 = 1513),
            (t.afii57690 = 1514),
            (t.afii57694 = 64298),
            (t.afii57695 = 64299),
            (t.afii57700 = 64331),
            (t.afii57705 = 64287),
            (t.afii57716 = 1520),
            (t.afii57717 = 1521),
            (t.afii57718 = 1522),
            (t.afii57723 = 64309),
            (t.afii57793 = 1460),
            (t.afii57794 = 1461),
            (t.afii57795 = 1462),
            (t.afii57796 = 1467),
            (t.afii57797 = 1464),
            (t.afii57798 = 1463),
            (t.afii57799 = 1456),
            (t.afii57800 = 1458),
            (t.afii57801 = 1457),
            (t.afii57802 = 1459),
            (t.afii57803 = 1474),
            (t.afii57804 = 1473),
            (t.afii57806 = 1465),
            (t.afii57807 = 1468),
            (t.afii57839 = 1469),
            (t.afii57841 = 1471),
            (t.afii57842 = 1472),
            (t.afii57929 = 700),
            (t.afii61248 = 8453),
            (t.afii61289 = 8467),
            (t.afii61352 = 8470),
            (t.afii61573 = 8236),
            (t.afii61574 = 8237),
            (t.afii61575 = 8238),
            (t.afii61664 = 8204),
            (t.afii63167 = 1645),
            (t.afii64937 = 701),
            (t.agrave = 224),
            (t.agujarati = 2693),
            (t.agurmukhi = 2565),
            (t.ahiragana = 12354),
            (t.ahookabove = 7843),
            (t.aibengali = 2448),
            (t.aibopomofo = 12574),
            (t.aideva = 2320),
            (t.aiecyrillic = 1237),
            (t.aigujarati = 2704),
            (t.aigurmukhi = 2576),
            (t.aimatragurmukhi = 2632),
            (t.ainarabic = 1593),
            (t.ainfinalarabic = 65226),
            (t.aininitialarabic = 65227),
            (t.ainmedialarabic = 65228),
            (t.ainvertedbreve = 515),
            (t.aivowelsignbengali = 2504),
            (t.aivowelsigndeva = 2376),
            (t.aivowelsigngujarati = 2760),
            (t.akatakana = 12450),
            (t.akatakanahalfwidth = 65393),
            (t.akorean = 12623),
            (t.alef = 1488),
            (t.alefarabic = 1575),
            (t.alefdageshhebrew = 64304),
            (t.aleffinalarabic = 65166),
            (t.alefhamzaabovearabic = 1571),
            (t.alefhamzaabovefinalarabic = 65156),
            (t.alefhamzabelowarabic = 1573),
            (t.alefhamzabelowfinalarabic = 65160),
            (t.alefhebrew = 1488),
            (t.aleflamedhebrew = 64335),
            (t.alefmaddaabovearabic = 1570),
            (t.alefmaddaabovefinalarabic = 65154),
            (t.alefmaksuraarabic = 1609),
            (t.alefmaksurafinalarabic = 65264),
            (t.alefmaksurainitialarabic = 65267),
            (t.alefmaksuramedialarabic = 65268),
            (t.alefpatahhebrew = 64302),
            (t.alefqamatshebrew = 64303),
            (t.aleph = 8501),
            (t.allequal = 8780),
            (t.alpha = 945),
            (t.alphatonos = 940),
            (t.amacron = 257),
            (t.amonospace = 65345),
            (t.ampersand = 38),
            (t.ampersandmonospace = 65286),
            (t.ampersandsmall = 63270),
            (t.amsquare = 13250),
            (t.anbopomofo = 12578),
            (t.angbopomofo = 12580),
            (t.angbracketleft = 12296),
            (t.angbracketright = 12297),
            (t.angkhankhuthai = 3674),
            (t.angle = 8736),
            (t.anglebracketleft = 12296),
            (t.anglebracketleftvertical = 65087),
            (t.anglebracketright = 12297),
            (t.anglebracketrightvertical = 65088),
            (t.angleleft = 9001),
            (t.angleright = 9002),
            (t.angstrom = 8491),
            (t.anoteleia = 903),
            (t.anudattadeva = 2386),
            (t.anusvarabengali = 2434),
            (t.anusvaradeva = 2306),
            (t.anusvaragujarati = 2690),
            (t.aogonek = 261),
            (t.apaatosquare = 13056),
            (t.aparen = 9372),
            (t.apostrophearmenian = 1370),
            (t.apostrophemod = 700),
            (t.apple = 63743),
            (t.approaches = 8784),
            (t.approxequal = 8776),
            (t.approxequalorimage = 8786),
            (t.approximatelyequal = 8773),
            (t.araeaekorean = 12686),
            (t.araeakorean = 12685),
            (t.arc = 8978),
            (t.arighthalfring = 7834),
            (t.aring = 229),
            (t.aringacute = 507),
            (t.aringbelow = 7681),
            (t.arrowboth = 8596),
            (t.arrowdashdown = 8675),
            (t.arrowdashleft = 8672),
            (t.arrowdashright = 8674),
            (t.arrowdashup = 8673),
            (t.arrowdblboth = 8660),
            (t.arrowdbldown = 8659),
            (t.arrowdblleft = 8656),
            (t.arrowdblright = 8658),
            (t.arrowdblup = 8657),
            (t.arrowdown = 8595),
            (t.arrowdownleft = 8601),
            (t.arrowdownright = 8600),
            (t.arrowdownwhite = 8681),
            (t.arrowheaddownmod = 709),
            (t.arrowheadleftmod = 706),
            (t.arrowheadrightmod = 707),
            (t.arrowheadupmod = 708),
            (t.arrowhorizex = 63719),
            (t.arrowleft = 8592),
            (t.arrowleftdbl = 8656),
            (t.arrowleftdblstroke = 8653),
            (t.arrowleftoverright = 8646),
            (t.arrowleftwhite = 8678),
            (t.arrowright = 8594),
            (t.arrowrightdblstroke = 8655),
            (t.arrowrightheavy = 10142),
            (t.arrowrightoverleft = 8644),
            (t.arrowrightwhite = 8680),
            (t.arrowtableft = 8676),
            (t.arrowtabright = 8677),
            (t.arrowup = 8593),
            (t.arrowupdn = 8597),
            (t.arrowupdnbse = 8616),
            (t.arrowupdownbase = 8616),
            (t.arrowupleft = 8598),
            (t.arrowupleftofdown = 8645),
            (t.arrowupright = 8599),
            (t.arrowupwhite = 8679),
            (t.arrowvertex = 63718),
            (t.asciicircum = 94),
            (t.asciicircummonospace = 65342),
            (t.asciitilde = 126),
            (t.asciitildemonospace = 65374),
            (t.ascript = 593),
            (t.ascriptturned = 594),
            (t.asmallhiragana = 12353),
            (t.asmallkatakana = 12449),
            (t.asmallkatakanahalfwidth = 65383),
            (t.asterisk = 42),
            (t.asteriskaltonearabic = 1645),
            (t.asteriskarabic = 1645),
            (t.asteriskmath = 8727),
            (t.asteriskmonospace = 65290),
            (t.asterisksmall = 65121),
            (t.asterism = 8258),
            (t.asuperior = 63209),
            (t.asymptoticallyequal = 8771),
            (t.at = 64),
            (t.atilde = 227),
            (t.atmonospace = 65312),
            (t.atsmall = 65131),
            (t.aturned = 592),
            (t.aubengali = 2452),
            (t.aubopomofo = 12576),
            (t.audeva = 2324),
            (t.augujarati = 2708),
            (t.augurmukhi = 2580),
            (t.aulengthmarkbengali = 2519),
            (t.aumatragurmukhi = 2636),
            (t.auvowelsignbengali = 2508),
            (t.auvowelsigndeva = 2380),
            (t.auvowelsigngujarati = 2764),
            (t.avagrahadeva = 2365),
            (t.aybarmenian = 1377),
            (t.ayin = 1506),
            (t.ayinaltonehebrew = 64288),
            (t.ayinhebrew = 1506),
            (t.b = 98),
            (t.babengali = 2476),
            (t.backslash = 92),
            (t.backslashmonospace = 65340),
            (t.badeva = 2348),
            (t.bagujarati = 2732),
            (t.bagurmukhi = 2604),
            (t.bahiragana = 12400),
            (t.bahtthai = 3647),
            (t.bakatakana = 12496),
            (t.bar = 124),
            (t.barmonospace = 65372),
            (t.bbopomofo = 12549),
            (t.bcircle = 9425),
            (t.bdotaccent = 7683),
            (t.bdotbelow = 7685),
            (t.beamedsixteenthnotes = 9836),
            (t.because = 8757),
            (t.becyrillic = 1073),
            (t.beharabic = 1576),
            (t.behfinalarabic = 65168),
            (t.behinitialarabic = 65169),
            (t.behiragana = 12409),
            (t.behmedialarabic = 65170),
            (t.behmeeminitialarabic = 64671),
            (t.behmeemisolatedarabic = 64520),
            (t.behnoonfinalarabic = 64621),
            (t.bekatakana = 12505),
            (t.benarmenian = 1378),
            (t.bet = 1489),
            (t.beta = 946),
            (t.betasymbolgreek = 976),
            (t.betdagesh = 64305),
            (t.betdageshhebrew = 64305),
            (t.bethebrew = 1489),
            (t.betrafehebrew = 64332),
            (t.bhabengali = 2477),
            (t.bhadeva = 2349),
            (t.bhagujarati = 2733),
            (t.bhagurmukhi = 2605),
            (t.bhook = 595),
            (t.bihiragana = 12403),
            (t.bikatakana = 12499),
            (t.bilabialclick = 664),
            (t.bindigurmukhi = 2562),
            (t.birusquare = 13105),
            (t.blackcircle = 9679),
            (t.blackdiamond = 9670),
            (t.blackdownpointingtriangle = 9660),
            (t.blackleftpointingpointer = 9668),
            (t.blackleftpointingtriangle = 9664),
            (t.blacklenticularbracketleft = 12304),
            (t.blacklenticularbracketleftvertical = 65083),
            (t.blacklenticularbracketright = 12305),
            (t.blacklenticularbracketrightvertical = 65084),
            (t.blacklowerlefttriangle = 9699),
            (t.blacklowerrighttriangle = 9698),
            (t.blackrectangle = 9644),
            (t.blackrightpointingpointer = 9658),
            (t.blackrightpointingtriangle = 9654),
            (t.blacksmallsquare = 9642),
            (t.blacksmilingface = 9787),
            (t.blacksquare = 9632),
            (t.blackstar = 9733),
            (t.blackupperlefttriangle = 9700),
            (t.blackupperrighttriangle = 9701),
            (t.blackuppointingsmalltriangle = 9652),
            (t.blackuppointingtriangle = 9650),
            (t.blank = 9251),
            (t.blinebelow = 7687),
            (t.block = 9608),
            (t.bmonospace = 65346),
            (t.bobaimaithai = 3610),
            (t.bohiragana = 12412),
            (t.bokatakana = 12508),
            (t.bparen = 9373),
            (t.bqsquare = 13251),
            (t.braceex = 63732),
            (t.braceleft = 123),
            (t.braceleftbt = 63731),
            (t.braceleftmid = 63730),
            (t.braceleftmonospace = 65371),
            (t.braceleftsmall = 65115),
            (t.bracelefttp = 63729),
            (t.braceleftvertical = 65079),
            (t.braceright = 125),
            (t.bracerightbt = 63742),
            (t.bracerightmid = 63741),
            (t.bracerightmonospace = 65373),
            (t.bracerightsmall = 65116),
            (t.bracerighttp = 63740),
            (t.bracerightvertical = 65080),
            (t.bracketleft = 91),
            (t.bracketleftbt = 63728),
            (t.bracketleftex = 63727),
            (t.bracketleftmonospace = 65339),
            (t.bracketlefttp = 63726),
            (t.bracketright = 93),
            (t.bracketrightbt = 63739),
            (t.bracketrightex = 63738),
            (t.bracketrightmonospace = 65341),
            (t.bracketrighttp = 63737),
            (t.breve = 728),
            (t.brevebelowcmb = 814),
            (t.brevecmb = 774),
            (t.breveinvertedbelowcmb = 815),
            (t.breveinvertedcmb = 785),
            (t.breveinverteddoublecmb = 865),
            (t.bridgebelowcmb = 810),
            (t.bridgeinvertedbelowcmb = 826),
            (t.brokenbar = 166),
            (t.bstroke = 384),
            (t.bsuperior = 63210),
            (t.btopbar = 387),
            (t.buhiragana = 12406),
            (t.bukatakana = 12502),
            (t.bullet = 8226),
            (t.bulletinverse = 9688),
            (t.bulletoperator = 8729),
            (t.bullseye = 9678),
            (t.c = 99),
            (t.caarmenian = 1390),
            (t.cabengali = 2458),
            (t.cacute = 263),
            (t.cadeva = 2330),
            (t.cagujarati = 2714),
            (t.cagurmukhi = 2586),
            (t.calsquare = 13192),
            (t.candrabindubengali = 2433),
            (t.candrabinducmb = 784),
            (t.candrabindudeva = 2305),
            (t.candrabindugujarati = 2689),
            (t.capslock = 8682),
            (t.careof = 8453),
            (t.caron = 711),
            (t.caronbelowcmb = 812),
            (t.caroncmb = 780),
            (t.carriagereturn = 8629),
            (t.cbopomofo = 12568),
            (t.ccaron = 269),
            (t.ccedilla = 231),
            (t.ccedillaacute = 7689),
            (t.ccircle = 9426),
            (t.ccircumflex = 265),
            (t.ccurl = 597),
            (t.cdot = 267),
            (t.cdotaccent = 267),
            (t.cdsquare = 13253),
            (t.cedilla = 184),
            (t.cedillacmb = 807),
            (t.cent = 162),
            (t.centigrade = 8451),
            (t.centinferior = 63199),
            (t.centmonospace = 65504),
            (t.centoldstyle = 63394),
            (t.centsuperior = 63200),
            (t.chaarmenian = 1401),
            (t.chabengali = 2459),
            (t.chadeva = 2331),
            (t.chagujarati = 2715),
            (t.chagurmukhi = 2587),
            (t.chbopomofo = 12564),
            (t.cheabkhasiancyrillic = 1213),
            (t.checkmark = 10003),
            (t.checyrillic = 1095),
            (t.chedescenderabkhasiancyrillic = 1215),
            (t.chedescendercyrillic = 1207),
            (t.chedieresiscyrillic = 1269),
            (t.cheharmenian = 1395),
            (t.chekhakassiancyrillic = 1228),
            (t.cheverticalstrokecyrillic = 1209),
            (t.chi = 967),
            (t.chieuchacirclekorean = 12919),
            (t.chieuchaparenkorean = 12823),
            (t.chieuchcirclekorean = 12905),
            (t.chieuchkorean = 12618),
            (t.chieuchparenkorean = 12809),
            (t.chochangthai = 3594),
            (t.chochanthai = 3592),
            (t.chochingthai = 3593),
            (t.chochoethai = 3596),
            (t.chook = 392),
            (t.cieucacirclekorean = 12918),
            (t.cieucaparenkorean = 12822),
            (t.cieuccirclekorean = 12904),
            (t.cieuckorean = 12616),
            (t.cieucparenkorean = 12808),
            (t.cieucuparenkorean = 12828),
            (t.circle = 9675),
            (t.circlecopyrt = 169),
            (t.circlemultiply = 8855),
            (t.circleot = 8857),
            (t.circleplus = 8853),
            (t.circlepostalmark = 12342),
            (t.circlewithlefthalfblack = 9680),
            (t.circlewithrighthalfblack = 9681),
            (t.circumflex = 710),
            (t.circumflexbelowcmb = 813),
            (t.circumflexcmb = 770),
            (t.clear = 8999),
            (t.clickalveolar = 450),
            (t.clickdental = 448),
            (t.clicklateral = 449),
            (t.clickretroflex = 451),
            (t.club = 9827),
            (t.clubsuitblack = 9827),
            (t.clubsuitwhite = 9831),
            (t.cmcubedsquare = 13220),
            (t.cmonospace = 65347),
            (t.cmsquaredsquare = 13216),
            (t.coarmenian = 1409),
            (t.colon = 58),
            (t.colonmonetary = 8353),
            (t.colonmonospace = 65306),
            (t.colonsign = 8353),
            (t.colonsmall = 65109),
            (t.colontriangularhalfmod = 721),
            (t.colontriangularmod = 720),
            (t.comma = 44),
            (t.commaabovecmb = 787),
            (t.commaaboverightcmb = 789),
            (t.commaaccent = 63171),
            (t.commaarabic = 1548),
            (t.commaarmenian = 1373),
            (t.commainferior = 63201),
            (t.commamonospace = 65292),
            (t.commareversedabovecmb = 788),
            (t.commareversedmod = 701),
            (t.commasmall = 65104),
            (t.commasuperior = 63202),
            (t.commaturnedabovecmb = 786),
            (t.commaturnedmod = 699),
            (t.compass = 9788),
            (t.congruent = 8773),
            (t.contourintegral = 8750),
            (t.control = 8963),
            (t.controlACK = 6),
            (t.controlBEL = 7),
            (t.controlBS = 8),
            (t.controlCAN = 24),
            (t.controlCR = 13),
            (t.controlDC1 = 17),
            (t.controlDC2 = 18),
            (t.controlDC3 = 19),
            (t.controlDC4 = 20),
            (t.controlDEL = 127),
            (t.controlDLE = 16),
            (t.controlEM = 25),
            (t.controlENQ = 5),
            (t.controlEOT = 4),
            (t.controlESC = 27),
            (t.controlETB = 23),
            (t.controlETX = 3),
            (t.controlFF = 12),
            (t.controlFS = 28),
            (t.controlGS = 29),
            (t.controlHT = 9),
            (t.controlLF = 10),
            (t.controlNAK = 21),
            (t.controlNULL = 0),
            (t.controlRS = 30),
            (t.controlSI = 15),
            (t.controlSO = 14),
            (t.controlSOT = 2),
            (t.controlSTX = 1),
            (t.controlSUB = 26),
            (t.controlSYN = 22),
            (t.controlUS = 31),
            (t.controlVT = 11),
            (t.copyright = 169),
            (t.copyrightsans = 63721),
            (t.copyrightserif = 63193),
            (t.cornerbracketleft = 12300),
            (t.cornerbracketlefthalfwidth = 65378),
            (t.cornerbracketleftvertical = 65089),
            (t.cornerbracketright = 12301),
            (t.cornerbracketrighthalfwidth = 65379),
            (t.cornerbracketrightvertical = 65090),
            (t.corporationsquare = 13183),
            (t.cosquare = 13255),
            (t.coverkgsquare = 13254),
            (t.cparen = 9374),
            (t.cruzeiro = 8354),
            (t.cstretched = 663),
            (t.curlyand = 8911),
            (t.curlyor = 8910),
            (t.currency = 164),
            (t.cyrBreve = 63185),
            (t.cyrFlex = 63186),
            (t.cyrbreve = 63188),
            (t.cyrflex = 63189),
            (t.d = 100),
            (t.daarmenian = 1380),
            (t.dabengali = 2470),
            (t.dadarabic = 1590),
            (t.dadeva = 2342),
            (t.dadfinalarabic = 65214),
            (t.dadinitialarabic = 65215),
            (t.dadmedialarabic = 65216),
            (t.dagesh = 1468),
            (t.dageshhebrew = 1468),
            (t.dagger = 8224),
            (t.daggerdbl = 8225),
            (t.dagujarati = 2726),
            (t.dagurmukhi = 2598),
            (t.dahiragana = 12384),
            (t.dakatakana = 12480),
            (t.dalarabic = 1583),
            (t.dalet = 1491),
            (t.daletdagesh = 64307),
            (t.daletdageshhebrew = 64307),
            (t.dalethebrew = 1491),
            (t.dalfinalarabic = 65194),
            (t.dammaarabic = 1615),
            (t.dammalowarabic = 1615),
            (t.dammatanaltonearabic = 1612),
            (t.dammatanarabic = 1612),
            (t.danda = 2404),
            (t.dargahebrew = 1447),
            (t.dargalefthebrew = 1447),
            (t.dasiapneumatacyrilliccmb = 1157),
            (t.dblGrave = 63187),
            (t.dblanglebracketleft = 12298),
            (t.dblanglebracketleftvertical = 65085),
            (t.dblanglebracketright = 12299),
            (t.dblanglebracketrightvertical = 65086),
            (t.dblarchinvertedbelowcmb = 811),
            (t.dblarrowleft = 8660),
            (t.dblarrowright = 8658),
            (t.dbldanda = 2405),
            (t.dblgrave = 63190),
            (t.dblgravecmb = 783),
            (t.dblintegral = 8748),
            (t.dbllowline = 8215),
            (t.dbllowlinecmb = 819),
            (t.dbloverlinecmb = 831),
            (t.dblprimemod = 698),
            (t.dblverticalbar = 8214),
            (t.dblverticallineabovecmb = 782),
            (t.dbopomofo = 12553),
            (t.dbsquare = 13256),
            (t.dcaron = 271),
            (t.dcedilla = 7697),
            (t.dcircle = 9427),
            (t.dcircumflexbelow = 7699),
            (t.dcroat = 273),
            (t.ddabengali = 2465),
            (t.ddadeva = 2337),
            (t.ddagujarati = 2721),
            (t.ddagurmukhi = 2593),
            (t.ddalarabic = 1672),
            (t.ddalfinalarabic = 64393),
            (t.dddhadeva = 2396),
            (t.ddhabengali = 2466),
            (t.ddhadeva = 2338),
            (t.ddhagujarati = 2722),
            (t.ddhagurmukhi = 2594),
            (t.ddotaccent = 7691),
            (t.ddotbelow = 7693),
            (t.decimalseparatorarabic = 1643),
            (t.decimalseparatorpersian = 1643),
            (t.decyrillic = 1076),
            (t.degree = 176),
            (t.dehihebrew = 1453),
            (t.dehiragana = 12391),
            (t.deicoptic = 1007),
            (t.dekatakana = 12487),
            (t.deleteleft = 9003),
            (t.deleteright = 8998),
            (t.delta = 948),
            (t.deltaturned = 397),
            (t.denominatorminusonenumeratorbengali = 2552),
            (t.dezh = 676),
            (t.dhabengali = 2471),
            (t.dhadeva = 2343),
            (t.dhagujarati = 2727),
            (t.dhagurmukhi = 2599),
            (t.dhook = 599),
            (t.dialytikatonos = 901),
            (t.dialytikatonoscmb = 836),
            (t.diamond = 9830),
            (t.diamondsuitwhite = 9826),
            (t.dieresis = 168),
            (t.dieresisacute = 63191),
            (t.dieresisbelowcmb = 804),
            (t.dieresiscmb = 776),
            (t.dieresisgrave = 63192),
            (t.dieresistonos = 901),
            (t.dihiragana = 12386),
            (t.dikatakana = 12482),
            (t.dittomark = 12291),
            (t.divide = 247),
            (t.divides = 8739),
            (t.divisionslash = 8725),
            (t.djecyrillic = 1106),
            (t.dkshade = 9619),
            (t.dlinebelow = 7695),
            (t.dlsquare = 13207),
            (t.dmacron = 273),
            (t.dmonospace = 65348),
            (t.dnblock = 9604),
            (t.dochadathai = 3598),
            (t.dodekthai = 3604),
            (t.dohiragana = 12393),
            (t.dokatakana = 12489),
            (t.dollar = 36);
          (t.dollarinferior = 63203),
            (t.dollarmonospace = 65284),
            (t.dollaroldstyle = 63268),
            (t.dollarsmall = 65129),
            (t.dollarsuperior = 63204),
            (t.dong = 8363),
            (t.dorusquare = 13094),
            (t.dotaccent = 729),
            (t.dotaccentcmb = 775),
            (t.dotbelowcmb = 803),
            (t.dotbelowcomb = 803),
            (t.dotkatakana = 12539),
            (t.dotlessi = 305),
            (t.dotlessj = 63166),
            (t.dotlessjstrokehook = 644),
            (t.dotmath = 8901),
            (t.dottedcircle = 9676),
            (t.doubleyodpatah = 64287),
            (t.doubleyodpatahhebrew = 64287),
            (t.downtackbelowcmb = 798),
            (t.downtackmod = 725),
            (t.dparen = 9375),
            (t.dsuperior = 63211),
            (t.dtail = 598),
            (t.dtopbar = 396),
            (t.duhiragana = 12389),
            (t.dukatakana = 12485),
            (t.dz = 499),
            (t.dzaltone = 675),
            (t.dzcaron = 454),
            (t.dzcurl = 677),
            (t.dzeabkhasiancyrillic = 1249),
            (t.dzecyrillic = 1109),
            (t.dzhecyrillic = 1119),
            (t.e = 101),
            (t.eacute = 233),
            (t.earth = 9793),
            (t.ebengali = 2447),
            (t.ebopomofo = 12572),
            (t.ebreve = 277),
            (t.ecandradeva = 2317),
            (t.ecandragujarati = 2701),
            (t.ecandravowelsigndeva = 2373),
            (t.ecandravowelsigngujarati = 2757),
            (t.ecaron = 283),
            (t.ecedillabreve = 7709),
            (t.echarmenian = 1381),
            (t.echyiwnarmenian = 1415),
            (t.ecircle = 9428),
            (t.ecircumflex = 234),
            (t.ecircumflexacute = 7871),
            (t.ecircumflexbelow = 7705),
            (t.ecircumflexdotbelow = 7879),
            (t.ecircumflexgrave = 7873),
            (t.ecircumflexhookabove = 7875),
            (t.ecircumflextilde = 7877),
            (t.ecyrillic = 1108),
            (t.edblgrave = 517),
            (t.edeva = 2319),
            (t.edieresis = 235),
            (t.edot = 279),
            (t.edotaccent = 279),
            (t.edotbelow = 7865),
            (t.eegurmukhi = 2575),
            (t.eematragurmukhi = 2631),
            (t.efcyrillic = 1092),
            (t.egrave = 232),
            (t.egujarati = 2703),
            (t.eharmenian = 1383),
            (t.ehbopomofo = 12573),
            (t.ehiragana = 12360),
            (t.ehookabove = 7867),
            (t.eibopomofo = 12575),
            (t.eight = 56),
            (t.eightarabic = 1640),
            (t.eightbengali = 2542),
            (t.eightcircle = 9319),
            (t.eightcircleinversesansserif = 10129),
            (t.eightdeva = 2414),
            (t.eighteencircle = 9329),
            (t.eighteenparen = 9349),
            (t.eighteenperiod = 9369),
            (t.eightgujarati = 2798),
            (t.eightgurmukhi = 2670),
            (t.eighthackarabic = 1640),
            (t.eighthangzhou = 12328),
            (t.eighthnotebeamed = 9835),
            (t.eightideographicparen = 12839),
            (t.eightinferior = 8328),
            (t.eightmonospace = 65304),
            (t.eightoldstyle = 63288),
            (t.eightparen = 9339),
            (t.eightperiod = 9359),
            (t.eightpersian = 1784),
            (t.eightroman = 8567),
            (t.eightsuperior = 8312),
            (t.eightthai = 3672),
            (t.einvertedbreve = 519),
            (t.eiotifiedcyrillic = 1125),
            (t.ekatakana = 12456),
            (t.ekatakanahalfwidth = 65396),
            (t.ekonkargurmukhi = 2676),
            (t.ekorean = 12628),
            (t.elcyrillic = 1083),
            (t.element = 8712),
            (t.elevencircle = 9322),
            (t.elevenparen = 9342),
            (t.elevenperiod = 9362),
            (t.elevenroman = 8570),
            (t.ellipsis = 8230),
            (t.ellipsisvertical = 8942),
            (t.emacron = 275),
            (t.emacronacute = 7703),
            (t.emacrongrave = 7701),
            (t.emcyrillic = 1084),
            (t.emdash = 8212),
            (t.emdashvertical = 65073),
            (t.emonospace = 65349),
            (t.emphasismarkarmenian = 1371),
            (t.emptyset = 8709),
            (t.enbopomofo = 12579),
            (t.encyrillic = 1085),
            (t.endash = 8211),
            (t.endashvertical = 65074),
            (t.endescendercyrillic = 1187),
            (t.eng = 331),
            (t.engbopomofo = 12581),
            (t.enghecyrillic = 1189),
            (t.enhookcyrillic = 1224),
            (t.enspace = 8194),
            (t.eogonek = 281),
            (t.eokorean = 12627),
            (t.eopen = 603),
            (t.eopenclosed = 666),
            (t.eopenreversed = 604),
            (t.eopenreversedclosed = 606),
            (t.eopenreversedhook = 605),
            (t.eparen = 9376),
            (t.epsilon = 949),
            (t.epsilontonos = 941),
            (t.equal = 61),
            (t.equalmonospace = 65309),
            (t.equalsmall = 65126),
            (t.equalsuperior = 8316),
            (t.equivalence = 8801),
            (t.erbopomofo = 12582),
            (t.ercyrillic = 1088),
            (t.ereversed = 600),
            (t.ereversedcyrillic = 1101),
            (t.escyrillic = 1089),
            (t.esdescendercyrillic = 1195),
            (t.esh = 643),
            (t.eshcurl = 646),
            (t.eshortdeva = 2318),
            (t.eshortvowelsigndeva = 2374),
            (t.eshreversedloop = 426),
            (t.eshsquatreversed = 645),
            (t.esmallhiragana = 12359),
            (t.esmallkatakana = 12455),
            (t.esmallkatakanahalfwidth = 65386),
            (t.estimated = 8494),
            (t.esuperior = 63212),
            (t.eta = 951),
            (t.etarmenian = 1384),
            (t.etatonos = 942),
            (t.eth = 240),
            (t.etilde = 7869),
            (t.etildebelow = 7707),
            (t.etnahtafoukhhebrew = 1425),
            (t.etnahtafoukhlefthebrew = 1425),
            (t.etnahtahebrew = 1425),
            (t.etnahtalefthebrew = 1425),
            (t.eturned = 477),
            (t.eukorean = 12641),
            (t.euro = 8364),
            (t.evowelsignbengali = 2503),
            (t.evowelsigndeva = 2375),
            (t.evowelsigngujarati = 2759),
            (t.exclam = 33),
            (t.exclamarmenian = 1372),
            (t.exclamdbl = 8252),
            (t.exclamdown = 161),
            (t.exclamdownsmall = 63393),
            (t.exclammonospace = 65281),
            (t.exclamsmall = 63265),
            (t.existential = 8707),
            (t.ezh = 658),
            (t.ezhcaron = 495),
            (t.ezhcurl = 659),
            (t.ezhreversed = 441),
            (t.ezhtail = 442),
            (t.f = 102),
            (t.fadeva = 2398),
            (t.fagurmukhi = 2654),
            (t.fahrenheit = 8457),
            (t.fathaarabic = 1614),
            (t.fathalowarabic = 1614),
            (t.fathatanarabic = 1611),
            (t.fbopomofo = 12552),
            (t.fcircle = 9429),
            (t.fdotaccent = 7711),
            (t.feharabic = 1601),
            (t.feharmenian = 1414),
            (t.fehfinalarabic = 65234),
            (t.fehinitialarabic = 65235),
            (t.fehmedialarabic = 65236),
            (t.feicoptic = 997),
            (t.female = 9792),
            (t.ff = 64256),
            (t.f_f = 64256),
            (t.ffi = 64259),
            (t.ffl = 64260),
            (t.fi = 64257),
            (t.fifteencircle = 9326),
            (t.fifteenparen = 9346),
            (t.fifteenperiod = 9366),
            (t.figuredash = 8210),
            (t.filledbox = 9632),
            (t.filledrect = 9644),
            (t.finalkaf = 1498),
            (t.finalkafdagesh = 64314),
            (t.finalkafdageshhebrew = 64314),
            (t.finalkafhebrew = 1498),
            (t.finalmem = 1501),
            (t.finalmemhebrew = 1501),
            (t.finalnun = 1503),
            (t.finalnunhebrew = 1503),
            (t.finalpe = 1507),
            (t.finalpehebrew = 1507),
            (t.finaltsadi = 1509),
            (t.finaltsadihebrew = 1509),
            (t.firsttonechinese = 713),
            (t.fisheye = 9673),
            (t.fitacyrillic = 1139),
            (t.five = 53),
            (t.fivearabic = 1637),
            (t.fivebengali = 2539),
            (t.fivecircle = 9316),
            (t.fivecircleinversesansserif = 10126),
            (t.fivedeva = 2411),
            (t.fiveeighths = 8541),
            (t.fivegujarati = 2795),
            (t.fivegurmukhi = 2667),
            (t.fivehackarabic = 1637),
            (t.fivehangzhou = 12325),
            (t.fiveideographicparen = 12836),
            (t.fiveinferior = 8325),
            (t.fivemonospace = 65301),
            (t.fiveoldstyle = 63285),
            (t.fiveparen = 9336),
            (t.fiveperiod = 9356),
            (t.fivepersian = 1781),
            (t.fiveroman = 8564),
            (t.fivesuperior = 8309),
            (t.fivethai = 3669),
            (t.fl = 64258),
            (t.florin = 402),
            (t.fmonospace = 65350),
            (t.fmsquare = 13209),
            (t.fofanthai = 3615),
            (t.fofathai = 3613),
            (t.fongmanthai = 3663),
            (t.forall = 8704),
            (t.four = 52),
            (t.fourarabic = 1636),
            (t.fourbengali = 2538),
            (t.fourcircle = 9315),
            (t.fourcircleinversesansserif = 10125),
            (t.fourdeva = 2410),
            (t.fourgujarati = 2794),
            (t.fourgurmukhi = 2666),
            (t.fourhackarabic = 1636),
            (t.fourhangzhou = 12324),
            (t.fourideographicparen = 12835),
            (t.fourinferior = 8324),
            (t.fourmonospace = 65300),
            (t.fournumeratorbengali = 2551),
            (t.fouroldstyle = 63284),
            (t.fourparen = 9335),
            (t.fourperiod = 9355),
            (t.fourpersian = 1780),
            (t.fourroman = 8563),
            (t.foursuperior = 8308),
            (t.fourteencircle = 9325),
            (t.fourteenparen = 9345),
            (t.fourteenperiod = 9365),
            (t.fourthai = 3668),
            (t.fourthtonechinese = 715),
            (t.fparen = 9377),
            (t.fraction = 8260),
            (t.franc = 8355),
            (t.g = 103),
            (t.gabengali = 2455),
            (t.gacute = 501),
            (t.gadeva = 2327),
            (t.gafarabic = 1711),
            (t.gaffinalarabic = 64403),
            (t.gafinitialarabic = 64404),
            (t.gafmedialarabic = 64405),
            (t.gagujarati = 2711),
            (t.gagurmukhi = 2583),
            (t.gahiragana = 12364),
            (t.gakatakana = 12460),
            (t.gamma = 947),
            (t.gammalatinsmall = 611),
            (t.gammasuperior = 736),
            (t.gangiacoptic = 1003),
            (t.gbopomofo = 12557),
            (t.gbreve = 287),
            (t.gcaron = 487),
            (t.gcedilla = 291),
            (t.gcircle = 9430),
            (t.gcircumflex = 285),
            (t.gcommaaccent = 291),
            (t.gdot = 289),
            (t.gdotaccent = 289),
            (t.gecyrillic = 1075),
            (t.gehiragana = 12370),
            (t.gekatakana = 12466),
            (t.geometricallyequal = 8785),
            (t.gereshaccenthebrew = 1436),
            (t.gereshhebrew = 1523),
            (t.gereshmuqdamhebrew = 1437),
            (t.germandbls = 223),
            (t.gershayimaccenthebrew = 1438),
            (t.gershayimhebrew = 1524),
            (t.getamark = 12307),
            (t.ghabengali = 2456),
            (t.ghadarmenian = 1394),
            (t.ghadeva = 2328),
            (t.ghagujarati = 2712),
            (t.ghagurmukhi = 2584),
            (t.ghainarabic = 1594),
            (t.ghainfinalarabic = 65230),
            (t.ghaininitialarabic = 65231),
            (t.ghainmedialarabic = 65232),
            (t.ghemiddlehookcyrillic = 1173),
            (t.ghestrokecyrillic = 1171),
            (t.gheupturncyrillic = 1169),
            (t.ghhadeva = 2394),
            (t.ghhagurmukhi = 2650),
            (t.ghook = 608),
            (t.ghzsquare = 13203),
            (t.gihiragana = 12366),
            (t.gikatakana = 12462),
            (t.gimarmenian = 1379),
            (t.gimel = 1490),
            (t.gimeldagesh = 64306),
            (t.gimeldageshhebrew = 64306),
            (t.gimelhebrew = 1490),
            (t.gjecyrillic = 1107),
            (t.glottalinvertedstroke = 446),
            (t.glottalstop = 660),
            (t.glottalstopinverted = 662),
            (t.glottalstopmod = 704),
            (t.glottalstopreversed = 661),
            (t.glottalstopreversedmod = 705),
            (t.glottalstopreversedsuperior = 740),
            (t.glottalstopstroke = 673),
            (t.glottalstopstrokereversed = 674),
            (t.gmacron = 7713),
            (t.gmonospace = 65351),
            (t.gohiragana = 12372),
            (t.gokatakana = 12468),
            (t.gparen = 9378),
            (t.gpasquare = 13228),
            (t.gradient = 8711),
            (t.grave = 96),
            (t.gravebelowcmb = 790),
            (t.gravecmb = 768),
            (t.gravecomb = 768),
            (t.gravedeva = 2387),
            (t.gravelowmod = 718),
            (t.gravemonospace = 65344),
            (t.gravetonecmb = 832),
            (t.greater = 62),
            (t.greaterequal = 8805),
            (t.greaterequalorless = 8923),
            (t.greatermonospace = 65310),
            (t.greaterorequivalent = 8819),
            (t.greaterorless = 8823),
            (t.greateroverequal = 8807),
            (t.greatersmall = 65125),
            (t.gscript = 609),
            (t.gstroke = 485),
            (t.guhiragana = 12368),
            (t.guillemotleft = 171),
            (t.guillemotright = 187),
            (t.guilsinglleft = 8249),
            (t.guilsinglright = 8250),
            (t.gukatakana = 12464),
            (t.guramusquare = 13080),
            (t.gysquare = 13257),
            (t.h = 104),
            (t.haabkhasiancyrillic = 1193),
            (t.haaltonearabic = 1729),
            (t.habengali = 2489),
            (t.hadescendercyrillic = 1203),
            (t.hadeva = 2361),
            (t.hagujarati = 2745),
            (t.hagurmukhi = 2617),
            (t.haharabic = 1581),
            (t.hahfinalarabic = 65186),
            (t.hahinitialarabic = 65187),
            (t.hahiragana = 12399),
            (t.hahmedialarabic = 65188),
            (t.haitusquare = 13098),
            (t.hakatakana = 12495),
            (t.hakatakanahalfwidth = 65418),
            (t.halantgurmukhi = 2637),
            (t.hamzaarabic = 1569),
            (t.hamzalowarabic = 1569),
            (t.hangulfiller = 12644),
            (t.hardsigncyrillic = 1098),
            (t.harpoonleftbarbup = 8636),
            (t.harpoonrightbarbup = 8640),
            (t.hasquare = 13258),
            (t.hatafpatah = 1458),
            (t.hatafpatah16 = 1458),
            (t.hatafpatah23 = 1458),
            (t.hatafpatah2f = 1458),
            (t.hatafpatahhebrew = 1458),
            (t.hatafpatahnarrowhebrew = 1458),
            (t.hatafpatahquarterhebrew = 1458),
            (t.hatafpatahwidehebrew = 1458),
            (t.hatafqamats = 1459),
            (t.hatafqamats1b = 1459),
            (t.hatafqamats28 = 1459),
            (t.hatafqamats34 = 1459),
            (t.hatafqamatshebrew = 1459),
            (t.hatafqamatsnarrowhebrew = 1459),
            (t.hatafqamatsquarterhebrew = 1459),
            (t.hatafqamatswidehebrew = 1459),
            (t.hatafsegol = 1457),
            (t.hatafsegol17 = 1457),
            (t.hatafsegol24 = 1457),
            (t.hatafsegol30 = 1457),
            (t.hatafsegolhebrew = 1457),
            (t.hatafsegolnarrowhebrew = 1457),
            (t.hatafsegolquarterhebrew = 1457),
            (t.hatafsegolwidehebrew = 1457),
            (t.hbar = 295),
            (t.hbopomofo = 12559),
            (t.hbrevebelow = 7723),
            (t.hcedilla = 7721),
            (t.hcircle = 9431),
            (t.hcircumflex = 293),
            (t.hdieresis = 7719),
            (t.hdotaccent = 7715),
            (t.hdotbelow = 7717),
            (t.he = 1492),
            (t.heart = 9829),
            (t.heartsuitblack = 9829),
            (t.heartsuitwhite = 9825),
            (t.hedagesh = 64308),
            (t.hedageshhebrew = 64308),
            (t.hehaltonearabic = 1729),
            (t.heharabic = 1607),
            (t.hehebrew = 1492),
            (t.hehfinalaltonearabic = 64423),
            (t.hehfinalalttwoarabic = 65258),
            (t.hehfinalarabic = 65258),
            (t.hehhamzaabovefinalarabic = 64421),
            (t.hehhamzaaboveisolatedarabic = 64420),
            (t.hehinitialaltonearabic = 64424),
            (t.hehinitialarabic = 65259),
            (t.hehiragana = 12408),
            (t.hehmedialaltonearabic = 64425),
            (t.hehmedialarabic = 65260),
            (t.heiseierasquare = 13179),
            (t.hekatakana = 12504),
            (t.hekatakanahalfwidth = 65421),
            (t.hekutaarusquare = 13110),
            (t.henghook = 615),
            (t.herutusquare = 13113),
            (t.het = 1495),
            (t.hethebrew = 1495),
            (t.hhook = 614),
            (t.hhooksuperior = 689),
            (t.hieuhacirclekorean = 12923),
            (t.hieuhaparenkorean = 12827),
            (t.hieuhcirclekorean = 12909),
            (t.hieuhkorean = 12622),
            (t.hieuhparenkorean = 12813),
            (t.hihiragana = 12402),
            (t.hikatakana = 12498),
            (t.hikatakanahalfwidth = 65419),
            (t.hiriq = 1460),
            (t.hiriq14 = 1460),
            (t.hiriq21 = 1460),
            (t.hiriq2d = 1460),
            (t.hiriqhebrew = 1460),
            (t.hiriqnarrowhebrew = 1460),
            (t.hiriqquarterhebrew = 1460),
            (t.hiriqwidehebrew = 1460),
            (t.hlinebelow = 7830),
            (t.hmonospace = 65352),
            (t.hoarmenian = 1392),
            (t.hohipthai = 3627),
            (t.hohiragana = 12411),
            (t.hokatakana = 12507),
            (t.hokatakanahalfwidth = 65422),
            (t.holam = 1465),
            (t.holam19 = 1465),
            (t.holam26 = 1465),
            (t.holam32 = 1465),
            (t.holamhebrew = 1465),
            (t.holamnarrowhebrew = 1465),
            (t.holamquarterhebrew = 1465),
            (t.holamwidehebrew = 1465),
            (t.honokhukthai = 3630),
            (t.hookabovecomb = 777),
            (t.hookcmb = 777),
            (t.hookpalatalizedbelowcmb = 801),
            (t.hookretroflexbelowcmb = 802),
            (t.hoonsquare = 13122),
            (t.horicoptic = 1001),
            (t.horizontalbar = 8213),
            (t.horncmb = 795),
            (t.hotsprings = 9832),
            (t.house = 8962),
            (t.hparen = 9379),
            (t.hsuperior = 688),
            (t.hturned = 613),
            (t.huhiragana = 12405),
            (t.huiitosquare = 13107),
            (t.hukatakana = 12501),
            (t.hukatakanahalfwidth = 65420),
            (t.hungarumlaut = 733),
            (t.hungarumlautcmb = 779),
            (t.hv = 405),
            (t.hyphen = 45),
            (t.hypheninferior = 63205),
            (t.hyphenmonospace = 65293),
            (t.hyphensmall = 65123),
            (t.hyphensuperior = 63206),
            (t.hyphentwo = 8208),
            (t.i = 105),
            (t.iacute = 237),
            (t.iacyrillic = 1103),
            (t.ibengali = 2439),
            (t.ibopomofo = 12583),
            (t.ibreve = 301),
            (t.icaron = 464),
            (t.icircle = 9432),
            (t.icircumflex = 238),
            (t.icyrillic = 1110),
            (t.idblgrave = 521),
            (t.ideographearthcircle = 12943),
            (t.ideographfirecircle = 12939),
            (t.ideographicallianceparen = 12863),
            (t.ideographiccallparen = 12858),
            (t.ideographiccentrecircle = 12965),
            (t.ideographicclose = 12294),
            (t.ideographiccomma = 12289),
            (t.ideographiccommaleft = 65380),
            (t.ideographiccongratulationparen = 12855),
            (t.ideographiccorrectcircle = 12963),
            (t.ideographicearthparen = 12847),
            (t.ideographicenterpriseparen = 12861),
            (t.ideographicexcellentcircle = 12957),
            (t.ideographicfestivalparen = 12864),
            (t.ideographicfinancialcircle = 12950),
            (t.ideographicfinancialparen = 12854),
            (t.ideographicfireparen = 12843),
            (t.ideographichaveparen = 12850),
            (t.ideographichighcircle = 12964),
            (t.ideographiciterationmark = 12293),
            (t.ideographiclaborcircle = 12952),
            (t.ideographiclaborparen = 12856),
            (t.ideographicleftcircle = 12967),
            (t.ideographiclowcircle = 12966),
            (t.ideographicmedicinecircle = 12969),
            (t.ideographicmetalparen = 12846),
            (t.ideographicmoonparen = 12842),
            (t.ideographicnameparen = 12852),
            (t.ideographicperiod = 12290),
            (t.ideographicprintcircle = 12958),
            (t.ideographicreachparen = 12867),
            (t.ideographicrepresentparen = 12857),
            (t.ideographicresourceparen = 12862),
            (t.ideographicrightcircle = 12968),
            (t.ideographicsecretcircle = 12953),
            (t.ideographicselfparen = 12866),
            (t.ideographicsocietyparen = 12851),
            (t.ideographicspace = 12288),
            (t.ideographicspecialparen = 12853),
            (t.ideographicstockparen = 12849),
            (t.ideographicstudyparen = 12859),
            (t.ideographicsunparen = 12848),
            (t.ideographicsuperviseparen = 12860),
            (t.ideographicwaterparen = 12844),
            (t.ideographicwoodparen = 12845),
            (t.ideographiczero = 12295),
            (t.ideographmetalcircle = 12942),
            (t.ideographmooncircle = 12938),
            (t.ideographnamecircle = 12948),
            (t.ideographsuncircle = 12944),
            (t.ideographwatercircle = 12940),
            (t.ideographwoodcircle = 12941),
            (t.ideva = 2311),
            (t.idieresis = 239),
            (t.idieresisacute = 7727),
            (t.idieresiscyrillic = 1253),
            (t.idotbelow = 7883),
            (t.iebrevecyrillic = 1239),
            (t.iecyrillic = 1077),
            (t.ieungacirclekorean = 12917),
            (t.ieungaparenkorean = 12821),
            (t.ieungcirclekorean = 12903),
            (t.ieungkorean = 12615),
            (t.ieungparenkorean = 12807),
            (t.igrave = 236),
            (t.igujarati = 2695),
            (t.igurmukhi = 2567),
            (t.ihiragana = 12356),
            (t.ihookabove = 7881),
            (t.iibengali = 2440),
            (t.iicyrillic = 1080),
            (t.iideva = 2312),
            (t.iigujarati = 2696),
            (t.iigurmukhi = 2568),
            (t.iimatragurmukhi = 2624),
            (t.iinvertedbreve = 523),
            (t.iishortcyrillic = 1081),
            (t.iivowelsignbengali = 2496),
            (t.iivowelsigndeva = 2368),
            (t.iivowelsigngujarati = 2752),
            (t.ij = 307),
            (t.ikatakana = 12452),
            (t.ikatakanahalfwidth = 65394),
            (t.ikorean = 12643),
            (t.ilde = 732),
            (t.iluyhebrew = 1452),
            (t.imacron = 299),
            (t.imacroncyrillic = 1251),
            (t.imageorapproximatelyequal = 8787),
            (t.imatragurmukhi = 2623),
            (t.imonospace = 65353),
            (t.increment = 8710),
            (t.infinity = 8734),
            (t.iniarmenian = 1387),
            (t.integral = 8747),
            (t.integralbottom = 8993),
            (t.integralbt = 8993),
            (t.integralex = 63733),
            (t.integraltop = 8992),
            (t.integraltp = 8992),
            (t.intersection = 8745),
            (t.intisquare = 13061),
            (t.invbullet = 9688),
            (t.invcircle = 9689),
            (t.invsmileface = 9787),
            (t.iocyrillic = 1105),
            (t.iogonek = 303),
            (t.iota = 953),
            (t.iotadieresis = 970),
            (t.iotadieresistonos = 912),
            (t.iotalatin = 617),
            (t.iotatonos = 943),
            (t.iparen = 9380),
            (t.irigurmukhi = 2674),
            (t.ismallhiragana = 12355),
            (t.ismallkatakana = 12451),
            (t.ismallkatakanahalfwidth = 65384),
            (t.issharbengali = 2554),
            (t.istroke = 616),
            (t.isuperior = 63213),
            (t.iterationhiragana = 12445),
            (t.iterationkatakana = 12541),
            (t.itilde = 297),
            (t.itildebelow = 7725),
            (t.iubopomofo = 12585),
            (t.iucyrillic = 1102),
            (t.ivowelsignbengali = 2495),
            (t.ivowelsigndeva = 2367),
            (t.ivowelsigngujarati = 2751),
            (t.izhitsacyrillic = 1141),
            (t.izhitsadblgravecyrillic = 1143),
            (t.j = 106),
            (t.jaarmenian = 1393),
            (t.jabengali = 2460),
            (t.jadeva = 2332),
            (t.jagujarati = 2716),
            (t.jagurmukhi = 2588),
            (t.jbopomofo = 12560),
            (t.jcaron = 496),
            (t.jcircle = 9433),
            (t.jcircumflex = 309),
            (t.jcrossedtail = 669),
            (t.jdotlessstroke = 607),
            (t.jecyrillic = 1112),
            (t.jeemarabic = 1580),
            (t.jeemfinalarabic = 65182),
            (t.jeeminitialarabic = 65183),
            (t.jeemmedialarabic = 65184),
            (t.jeharabic = 1688),
            (t.jehfinalarabic = 64395),
            (t.jhabengali = 2461),
            (t.jhadeva = 2333),
            (t.jhagujarati = 2717),
            (t.jhagurmukhi = 2589),
            (t.jheharmenian = 1403),
            (t.jis = 12292),
            (t.jmonospace = 65354),
            (t.jparen = 9381),
            (t.jsuperior = 690),
            (t.k = 107),
            (t.kabashkircyrillic = 1185),
            (t.kabengali = 2453),
            (t.kacute = 7729),
            (t.kacyrillic = 1082),
            (t.kadescendercyrillic = 1179),
            (t.kadeva = 2325),
            (t.kaf = 1499),
            (t.kafarabic = 1603),
            (t.kafdagesh = 64315),
            (t.kafdageshhebrew = 64315),
            (t.kaffinalarabic = 65242),
            (t.kafhebrew = 1499),
            (t.kafinitialarabic = 65243),
            (t.kafmedialarabic = 65244),
            (t.kafrafehebrew = 64333),
            (t.kagujarati = 2709),
            (t.kagurmukhi = 2581),
            (t.kahiragana = 12363),
            (t.kahookcyrillic = 1220),
            (t.kakatakana = 12459),
            (t.kakatakanahalfwidth = 65398),
            (t.kappa = 954),
            (t.kappasymbolgreek = 1008),
            (t.kapyeounmieumkorean = 12657),
            (t.kapyeounphieuphkorean = 12676),
            (t.kapyeounpieupkorean = 12664),
            (t.kapyeounssangpieupkorean = 12665),
            (t.karoriisquare = 13069),
            (t.kashidaautoarabic = 1600),
            (t.kashidaautonosidebearingarabic = 1600),
            (t.kasmallkatakana = 12533),
            (t.kasquare = 13188),
            (t.kasraarabic = 1616),
            (t.kasratanarabic = 1613),
            (t.kastrokecyrillic = 1183),
            (t.katahiraprolongmarkhalfwidth = 65392),
            (t.kaverticalstrokecyrillic = 1181),
            (t.kbopomofo = 12558),
            (t.kcalsquare = 13193),
            (t.kcaron = 489),
            (t.kcedilla = 311),
            (t.kcircle = 9434),
            (t.kcommaaccent = 311),
            (t.kdotbelow = 7731),
            (t.keharmenian = 1412),
            (t.kehiragana = 12369),
            (t.kekatakana = 12465),
            (t.kekatakanahalfwidth = 65401),
            (t.kenarmenian = 1391),
            (t.kesmallkatakana = 12534),
            (t.kgreenlandic = 312),
            (t.khabengali = 2454),
            (t.khacyrillic = 1093),
            (t.khadeva = 2326),
            (t.khagujarati = 2710),
            (t.khagurmukhi = 2582),
            (t.khaharabic = 1582),
            (t.khahfinalarabic = 65190),
            (t.khahinitialarabic = 65191),
            (t.khahmedialarabic = 65192),
            (t.kheicoptic = 999),
            (t.khhadeva = 2393),
            (t.khhagurmukhi = 2649),
            (t.khieukhacirclekorean = 12920),
            (t.khieukhaparenkorean = 12824),
            (t.khieukhcirclekorean = 12906),
            (t.khieukhkorean = 12619),
            (t.khieukhparenkorean = 12810),
            (t.khokhaithai = 3586),
            (t.khokhonthai = 3589),
            (t.khokhuatthai = 3587),
            (t.khokhwaithai = 3588),
            (t.khomutthai = 3675),
            (t.khook = 409),
            (t.khorakhangthai = 3590),
            (t.khzsquare = 13201),
            (t.kihiragana = 12365),
            (t.kikatakana = 12461),
            (t.kikatakanahalfwidth = 65399),
            (t.kiroguramusquare = 13077),
            (t.kiromeetorusquare = 13078),
            (t.kirosquare = 13076),
            (t.kiyeokacirclekorean = 12910),
            (t.kiyeokaparenkorean = 12814),
            (t.kiyeokcirclekorean = 12896),
            (t.kiyeokkorean = 12593),
            (t.kiyeokparenkorean = 12800),
            (t.kiyeoksioskorean = 12595),
            (t.kjecyrillic = 1116),
            (t.klinebelow = 7733),
            (t.klsquare = 13208),
            (t.kmcubedsquare = 13222);
          (t.kmonospace = 65355),
            (t.kmsquaredsquare = 13218),
            (t.kohiragana = 12371),
            (t.kohmsquare = 13248),
            (t.kokaithai = 3585),
            (t.kokatakana = 12467),
            (t.kokatakanahalfwidth = 65402),
            (t.kooposquare = 13086),
            (t.koppacyrillic = 1153),
            (t.koreanstandardsymbol = 12927),
            (t.koroniscmb = 835),
            (t.kparen = 9382),
            (t.kpasquare = 13226),
            (t.ksicyrillic = 1135),
            (t.ktsquare = 13263),
            (t.kturned = 670),
            (t.kuhiragana = 12367),
            (t.kukatakana = 12463),
            (t.kukatakanahalfwidth = 65400),
            (t.kvsquare = 13240),
            (t.kwsquare = 13246),
            (t.l = 108),
            (t.labengali = 2482),
            (t.lacute = 314),
            (t.ladeva = 2354),
            (t.lagujarati = 2738),
            (t.lagurmukhi = 2610),
            (t.lakkhangyaothai = 3653),
            (t.lamaleffinalarabic = 65276),
            (t.lamalefhamzaabovefinalarabic = 65272),
            (t.lamalefhamzaaboveisolatedarabic = 65271),
            (t.lamalefhamzabelowfinalarabic = 65274),
            (t.lamalefhamzabelowisolatedarabic = 65273),
            (t.lamalefisolatedarabic = 65275),
            (t.lamalefmaddaabovefinalarabic = 65270),
            (t.lamalefmaddaaboveisolatedarabic = 65269),
            (t.lamarabic = 1604),
            (t.lambda = 955),
            (t.lambdastroke = 411),
            (t.lamed = 1500),
            (t.lameddagesh = 64316),
            (t.lameddageshhebrew = 64316),
            (t.lamedhebrew = 1500),
            (t.lamfinalarabic = 65246),
            (t.lamhahinitialarabic = 64714),
            (t.laminitialarabic = 65247),
            (t.lamjeeminitialarabic = 64713),
            (t.lamkhahinitialarabic = 64715),
            (t.lamlamhehisolatedarabic = 65010),
            (t.lammedialarabic = 65248),
            (t.lammeemhahinitialarabic = 64904),
            (t.lammeeminitialarabic = 64716),
            (t.largecircle = 9711),
            (t.lbar = 410),
            (t.lbelt = 620),
            (t.lbopomofo = 12556),
            (t.lcaron = 318),
            (t.lcedilla = 316),
            (t.lcircle = 9435),
            (t.lcircumflexbelow = 7741),
            (t.lcommaaccent = 316),
            (t.ldot = 320),
            (t.ldotaccent = 320),
            (t.ldotbelow = 7735),
            (t.ldotbelowmacron = 7737),
            (t.leftangleabovecmb = 794),
            (t.lefttackbelowcmb = 792),
            (t.less = 60),
            (t.lessequal = 8804),
            (t.lessequalorgreater = 8922),
            (t.lessmonospace = 65308),
            (t.lessorequivalent = 8818),
            (t.lessorgreater = 8822),
            (t.lessoverequal = 8806),
            (t.lesssmall = 65124),
            (t.lezh = 622),
            (t.lfblock = 9612),
            (t.lhookretroflex = 621),
            (t.lira = 8356),
            (t.liwnarmenian = 1388),
            (t.lj = 457),
            (t.ljecyrillic = 1113),
            (t.ll = 63168),
            (t.lladeva = 2355),
            (t.llagujarati = 2739),
            (t.llinebelow = 7739),
            (t.llladeva = 2356),
            (t.llvocalicbengali = 2529),
            (t.llvocalicdeva = 2401),
            (t.llvocalicvowelsignbengali = 2531),
            (t.llvocalicvowelsigndeva = 2403),
            (t.lmiddletilde = 619),
            (t.lmonospace = 65356),
            (t.lmsquare = 13264),
            (t.lochulathai = 3628),
            (t.logicaland = 8743),
            (t.logicalnot = 172),
            (t.logicalnotreversed = 8976),
            (t.logicalor = 8744),
            (t.lolingthai = 3621),
            (t.longs = 383),
            (t.lowlinecenterline = 65102),
            (t.lowlinecmb = 818),
            (t.lowlinedashed = 65101),
            (t.lozenge = 9674),
            (t.lparen = 9383),
            (t.lslash = 322),
            (t.lsquare = 8467),
            (t.lsuperior = 63214),
            (t.ltshade = 9617),
            (t.luthai = 3622),
            (t.lvocalicbengali = 2444),
            (t.lvocalicdeva = 2316),
            (t.lvocalicvowelsignbengali = 2530),
            (t.lvocalicvowelsigndeva = 2402),
            (t.lxsquare = 13267),
            (t.m = 109),
            (t.mabengali = 2478),
            (t.macron = 175),
            (t.macronbelowcmb = 817),
            (t.macroncmb = 772),
            (t.macronlowmod = 717),
            (t.macronmonospace = 65507),
            (t.macute = 7743),
            (t.madeva = 2350),
            (t.magujarati = 2734),
            (t.magurmukhi = 2606),
            (t.mahapakhhebrew = 1444),
            (t.mahapakhlefthebrew = 1444),
            (t.mahiragana = 12414),
            (t.maichattawalowleftthai = 63637),
            (t.maichattawalowrightthai = 63636),
            (t.maichattawathai = 3659),
            (t.maichattawaupperleftthai = 63635),
            (t.maieklowleftthai = 63628),
            (t.maieklowrightthai = 63627),
            (t.maiekthai = 3656),
            (t.maiekupperleftthai = 63626),
            (t.maihanakatleftthai = 63620),
            (t.maihanakatthai = 3633),
            (t.maitaikhuleftthai = 63625),
            (t.maitaikhuthai = 3655),
            (t.maitholowleftthai = 63631),
            (t.maitholowrightthai = 63630),
            (t.maithothai = 3657),
            (t.maithoupperleftthai = 63629),
            (t.maitrilowleftthai = 63634),
            (t.maitrilowrightthai = 63633),
            (t.maitrithai = 3658),
            (t.maitriupperleftthai = 63632),
            (t.maiyamokthai = 3654),
            (t.makatakana = 12510),
            (t.makatakanahalfwidth = 65423),
            (t.male = 9794),
            (t.mansyonsquare = 13127),
            (t.maqafhebrew = 1470),
            (t.mars = 9794),
            (t.masoracirclehebrew = 1455),
            (t.masquare = 13187),
            (t.mbopomofo = 12551),
            (t.mbsquare = 13268),
            (t.mcircle = 9436),
            (t.mcubedsquare = 13221),
            (t.mdotaccent = 7745),
            (t.mdotbelow = 7747),
            (t.meemarabic = 1605),
            (t.meemfinalarabic = 65250),
            (t.meeminitialarabic = 65251),
            (t.meemmedialarabic = 65252),
            (t.meemmeeminitialarabic = 64721),
            (t.meemmeemisolatedarabic = 64584),
            (t.meetorusquare = 13133),
            (t.mehiragana = 12417),
            (t.meizierasquare = 13182),
            (t.mekatakana = 12513),
            (t.mekatakanahalfwidth = 65426),
            (t.mem = 1502),
            (t.memdagesh = 64318),
            (t.memdageshhebrew = 64318),
            (t.memhebrew = 1502),
            (t.menarmenian = 1396),
            (t.merkhahebrew = 1445),
            (t.merkhakefulahebrew = 1446),
            (t.merkhakefulalefthebrew = 1446),
            (t.merkhalefthebrew = 1445),
            (t.mhook = 625),
            (t.mhzsquare = 13202),
            (t.middledotkatakanahalfwidth = 65381),
            (t.middot = 183),
            (t.mieumacirclekorean = 12914),
            (t.mieumaparenkorean = 12818),
            (t.mieumcirclekorean = 12900),
            (t.mieumkorean = 12609),
            (t.mieumpansioskorean = 12656),
            (t.mieumparenkorean = 12804),
            (t.mieumpieupkorean = 12654),
            (t.mieumsioskorean = 12655),
            (t.mihiragana = 12415),
            (t.mikatakana = 12511),
            (t.mikatakanahalfwidth = 65424),
            (t.minus = 8722),
            (t.minusbelowcmb = 800),
            (t.minuscircle = 8854),
            (t.minusmod = 727),
            (t.minusplus = 8723),
            (t.minute = 8242),
            (t.miribaarusquare = 13130),
            (t.mirisquare = 13129),
            (t.mlonglegturned = 624),
            (t.mlsquare = 13206),
            (t.mmcubedsquare = 13219),
            (t.mmonospace = 65357),
            (t.mmsquaredsquare = 13215),
            (t.mohiragana = 12418),
            (t.mohmsquare = 13249),
            (t.mokatakana = 12514),
            (t.mokatakanahalfwidth = 65427),
            (t.molsquare = 13270),
            (t.momathai = 3617),
            (t.moverssquare = 13223),
            (t.moverssquaredsquare = 13224),
            (t.mparen = 9384),
            (t.mpasquare = 13227),
            (t.mssquare = 13235),
            (t.msuperior = 63215),
            (t.mturned = 623),
            (t.mu = 181),
            (t.mu1 = 181),
            (t.muasquare = 13186),
            (t.muchgreater = 8811),
            (t.muchless = 8810),
            (t.mufsquare = 13196),
            (t.mugreek = 956),
            (t.mugsquare = 13197),
            (t.muhiragana = 12416),
            (t.mukatakana = 12512),
            (t.mukatakanahalfwidth = 65425),
            (t.mulsquare = 13205),
            (t.multiply = 215),
            (t.mumsquare = 13211),
            (t.munahhebrew = 1443),
            (t.munahlefthebrew = 1443),
            (t.musicalnote = 9834),
            (t.musicalnotedbl = 9835),
            (t.musicflatsign = 9837),
            (t.musicsharpsign = 9839),
            (t.mussquare = 13234),
            (t.muvsquare = 13238),
            (t.muwsquare = 13244),
            (t.mvmegasquare = 13241),
            (t.mvsquare = 13239),
            (t.mwmegasquare = 13247),
            (t.mwsquare = 13245),
            (t.n = 110),
            (t.nabengali = 2472),
            (t.nabla = 8711),
            (t.nacute = 324),
            (t.nadeva = 2344),
            (t.nagujarati = 2728),
            (t.nagurmukhi = 2600),
            (t.nahiragana = 12394),
            (t.nakatakana = 12490),
            (t.nakatakanahalfwidth = 65413),
            (t.napostrophe = 329),
            (t.nasquare = 13185),
            (t.nbopomofo = 12555),
            (t.nbspace = 160),
            (t.ncaron = 328),
            (t.ncedilla = 326),
            (t.ncircle = 9437),
            (t.ncircumflexbelow = 7755),
            (t.ncommaaccent = 326),
            (t.ndotaccent = 7749),
            (t.ndotbelow = 7751),
            (t.nehiragana = 12397),
            (t.nekatakana = 12493),
            (t.nekatakanahalfwidth = 65416),
            (t.newsheqelsign = 8362),
            (t.nfsquare = 13195),
            (t.ngabengali = 2457),
            (t.ngadeva = 2329),
            (t.ngagujarati = 2713),
            (t.ngagurmukhi = 2585),
            (t.ngonguthai = 3591),
            (t.nhiragana = 12435),
            (t.nhookleft = 626),
            (t.nhookretroflex = 627),
            (t.nieunacirclekorean = 12911),
            (t.nieunaparenkorean = 12815),
            (t.nieuncieuckorean = 12597),
            (t.nieuncirclekorean = 12897),
            (t.nieunhieuhkorean = 12598),
            (t.nieunkorean = 12596),
            (t.nieunpansioskorean = 12648),
            (t.nieunparenkorean = 12801),
            (t.nieunsioskorean = 12647),
            (t.nieuntikeutkorean = 12646),
            (t.nihiragana = 12395),
            (t.nikatakana = 12491),
            (t.nikatakanahalfwidth = 65414),
            (t.nikhahitleftthai = 63641),
            (t.nikhahitthai = 3661),
            (t.nine = 57),
            (t.ninearabic = 1641),
            (t.ninebengali = 2543),
            (t.ninecircle = 9320),
            (t.ninecircleinversesansserif = 10130),
            (t.ninedeva = 2415),
            (t.ninegujarati = 2799),
            (t.ninegurmukhi = 2671),
            (t.ninehackarabic = 1641),
            (t.ninehangzhou = 12329),
            (t.nineideographicparen = 12840),
            (t.nineinferior = 8329),
            (t.ninemonospace = 65305),
            (t.nineoldstyle = 63289),
            (t.nineparen = 9340),
            (t.nineperiod = 9360),
            (t.ninepersian = 1785),
            (t.nineroman = 8568),
            (t.ninesuperior = 8313),
            (t.nineteencircle = 9330),
            (t.nineteenparen = 9350),
            (t.nineteenperiod = 9370),
            (t.ninethai = 3673),
            (t.nj = 460),
            (t.njecyrillic = 1114),
            (t.nkatakana = 12531),
            (t.nkatakanahalfwidth = 65437),
            (t.nlegrightlong = 414),
            (t.nlinebelow = 7753),
            (t.nmonospace = 65358),
            (t.nmsquare = 13210),
            (t.nnabengali = 2467),
            (t.nnadeva = 2339),
            (t.nnagujarati = 2723),
            (t.nnagurmukhi = 2595),
            (t.nnnadeva = 2345),
            (t.nohiragana = 12398),
            (t.nokatakana = 12494),
            (t.nokatakanahalfwidth = 65417),
            (t.nonbreakingspace = 160),
            (t.nonenthai = 3603),
            (t.nonuthai = 3609),
            (t.noonarabic = 1606),
            (t.noonfinalarabic = 65254),
            (t.noonghunnaarabic = 1722),
            (t.noonghunnafinalarabic = 64415),
            (t.nooninitialarabic = 65255),
            (t.noonjeeminitialarabic = 64722),
            (t.noonjeemisolatedarabic = 64587),
            (t.noonmedialarabic = 65256),
            (t.noonmeeminitialarabic = 64725),
            (t.noonmeemisolatedarabic = 64590),
            (t.noonnoonfinalarabic = 64653),
            (t.notcontains = 8716),
            (t.notelement = 8713),
            (t.notelementof = 8713),
            (t.notequal = 8800),
            (t.notgreater = 8815),
            (t.notgreaternorequal = 8817),
            (t.notgreaternorless = 8825),
            (t.notidentical = 8802),
            (t.notless = 8814),
            (t.notlessnorequal = 8816),
            (t.notparallel = 8742),
            (t.notprecedes = 8832),
            (t.notsubset = 8836),
            (t.notsucceeds = 8833),
            (t.notsuperset = 8837),
            (t.nowarmenian = 1398),
            (t.nparen = 9385),
            (t.nssquare = 13233),
            (t.nsuperior = 8319),
            (t.ntilde = 241),
            (t.nu = 957),
            (t.nuhiragana = 12396),
            (t.nukatakana = 12492),
            (t.nukatakanahalfwidth = 65415),
            (t.nuktabengali = 2492),
            (t.nuktadeva = 2364),
            (t.nuktagujarati = 2748),
            (t.nuktagurmukhi = 2620),
            (t.numbersign = 35),
            (t.numbersignmonospace = 65283),
            (t.numbersignsmall = 65119),
            (t.numeralsigngreek = 884),
            (t.numeralsignlowergreek = 885),
            (t.numero = 8470),
            (t.nun = 1504),
            (t.nundagesh = 64320),
            (t.nundageshhebrew = 64320),
            (t.nunhebrew = 1504),
            (t.nvsquare = 13237),
            (t.nwsquare = 13243),
            (t.nyabengali = 2462),
            (t.nyadeva = 2334),
            (t.nyagujarati = 2718),
            (t.nyagurmukhi = 2590),
            (t.o = 111),
            (t.oacute = 243),
            (t.oangthai = 3629),
            (t.obarred = 629),
            (t.obarredcyrillic = 1257),
            (t.obarreddieresiscyrillic = 1259),
            (t.obengali = 2451),
            (t.obopomofo = 12571),
            (t.obreve = 335),
            (t.ocandradeva = 2321),
            (t.ocandragujarati = 2705),
            (t.ocandravowelsigndeva = 2377),
            (t.ocandravowelsigngujarati = 2761),
            (t.ocaron = 466),
            (t.ocircle = 9438),
            (t.ocircumflex = 244),
            (t.ocircumflexacute = 7889),
            (t.ocircumflexdotbelow = 7897),
            (t.ocircumflexgrave = 7891),
            (t.ocircumflexhookabove = 7893),
            (t.ocircumflextilde = 7895),
            (t.ocyrillic = 1086),
            (t.odblacute = 337),
            (t.odblgrave = 525),
            (t.odeva = 2323),
            (t.odieresis = 246),
            (t.odieresiscyrillic = 1255),
            (t.odotbelow = 7885),
            (t.oe = 339),
            (t.oekorean = 12634),
            (t.ogonek = 731),
            (t.ogonekcmb = 808),
            (t.ograve = 242),
            (t.ogujarati = 2707),
            (t.oharmenian = 1413),
            (t.ohiragana = 12362),
            (t.ohookabove = 7887),
            (t.ohorn = 417),
            (t.ohornacute = 7899),
            (t.ohorndotbelow = 7907),
            (t.ohorngrave = 7901),
            (t.ohornhookabove = 7903),
            (t.ohorntilde = 7905),
            (t.ohungarumlaut = 337),
            (t.oi = 419),
            (t.oinvertedbreve = 527),
            (t.okatakana = 12458),
            (t.okatakanahalfwidth = 65397),
            (t.okorean = 12631),
            (t.olehebrew = 1451),
            (t.omacron = 333),
            (t.omacronacute = 7763),
            (t.omacrongrave = 7761),
            (t.omdeva = 2384),
            (t.omega = 969),
            (t.omega1 = 982),
            (t.omegacyrillic = 1121),
            (t.omegalatinclosed = 631),
            (t.omegaroundcyrillic = 1147),
            (t.omegatitlocyrillic = 1149),
            (t.omegatonos = 974),
            (t.omgujarati = 2768),
            (t.omicron = 959),
            (t.omicrontonos = 972),
            (t.omonospace = 65359),
            (t.one = 49),
            (t.onearabic = 1633),
            (t.onebengali = 2535),
            (t.onecircle = 9312),
            (t.onecircleinversesansserif = 10122),
            (t.onedeva = 2407),
            (t.onedotenleader = 8228),
            (t.oneeighth = 8539),
            (t.onefitted = 63196),
            (t.onegujarati = 2791),
            (t.onegurmukhi = 2663),
            (t.onehackarabic = 1633),
            (t.onehalf = 189),
            (t.onehangzhou = 12321),
            (t.oneideographicparen = 12832),
            (t.oneinferior = 8321),
            (t.onemonospace = 65297),
            (t.onenumeratorbengali = 2548),
            (t.oneoldstyle = 63281),
            (t.oneparen = 9332),
            (t.oneperiod = 9352),
            (t.onepersian = 1777),
            (t.onequarter = 188),
            (t.oneroman = 8560),
            (t.onesuperior = 185),
            (t.onethai = 3665),
            (t.onethird = 8531),
            (t.oogonek = 491),
            (t.oogonekmacron = 493),
            (t.oogurmukhi = 2579),
            (t.oomatragurmukhi = 2635),
            (t.oopen = 596),
            (t.oparen = 9386),
            (t.openbullet = 9702),
            (t.option = 8997),
            (t.ordfeminine = 170),
            (t.ordmasculine = 186),
            (t.orthogonal = 8735),
            (t.oshortdeva = 2322),
            (t.oshortvowelsigndeva = 2378),
            (t.oslash = 248),
            (t.oslashacute = 511),
            (t.osmallhiragana = 12361),
            (t.osmallkatakana = 12457),
            (t.osmallkatakanahalfwidth = 65387),
            (t.ostrokeacute = 511),
            (t.osuperior = 63216),
            (t.otcyrillic = 1151),
            (t.otilde = 245),
            (t.otildeacute = 7757),
            (t.otildedieresis = 7759),
            (t.oubopomofo = 12577),
            (t.overline = 8254),
            (t.overlinecenterline = 65098),
            (t.overlinecmb = 773),
            (t.overlinedashed = 65097),
            (t.overlinedblwavy = 65100),
            (t.overlinewavy = 65099),
            (t.overscore = 175),
            (t.ovowelsignbengali = 2507),
            (t.ovowelsigndeva = 2379),
            (t.ovowelsigngujarati = 2763),
            (t.p = 112),
            (t.paampssquare = 13184),
            (t.paasentosquare = 13099),
            (t.pabengali = 2474),
            (t.pacute = 7765),
            (t.padeva = 2346),
            (t.pagedown = 8671),
            (t.pageup = 8670),
            (t.pagujarati = 2730),
            (t.pagurmukhi = 2602),
            (t.pahiragana = 12401),
            (t.paiyannoithai = 3631),
            (t.pakatakana = 12497),
            (t.palatalizationcyrilliccmb = 1156),
            (t.palochkacyrillic = 1216),
            (t.pansioskorean = 12671),
            (t.paragraph = 182),
            (t.parallel = 8741),
            (t.parenleft = 40),
            (t.parenleftaltonearabic = 64830),
            (t.parenleftbt = 63725),
            (t.parenleftex = 63724),
            (t.parenleftinferior = 8333),
            (t.parenleftmonospace = 65288),
            (t.parenleftsmall = 65113),
            (t.parenleftsuperior = 8317),
            (t.parenlefttp = 63723),
            (t.parenleftvertical = 65077),
            (t.parenright = 41),
            (t.parenrightaltonearabic = 64831),
            (t.parenrightbt = 63736),
            (t.parenrightex = 63735),
            (t.parenrightinferior = 8334),
            (t.parenrightmonospace = 65289),
            (t.parenrightsmall = 65114),
            (t.parenrightsuperior = 8318),
            (t.parenrighttp = 63734),
            (t.parenrightvertical = 65078),
            (t.partialdiff = 8706),
            (t.paseqhebrew = 1472),
            (t.pashtahebrew = 1433),
            (t.pasquare = 13225),
            (t.patah = 1463),
            (t.patah11 = 1463),
            (t.patah1d = 1463),
            (t.patah2a = 1463),
            (t.patahhebrew = 1463),
            (t.patahnarrowhebrew = 1463),
            (t.patahquarterhebrew = 1463),
            (t.patahwidehebrew = 1463),
            (t.pazerhebrew = 1441),
            (t.pbopomofo = 12550),
            (t.pcircle = 9439),
            (t.pdotaccent = 7767),
            (t.pe = 1508),
            (t.pecyrillic = 1087),
            (t.pedagesh = 64324),
            (t.pedageshhebrew = 64324),
            (t.peezisquare = 13115),
            (t.pefinaldageshhebrew = 64323),
            (t.peharabic = 1662),
            (t.peharmenian = 1402),
            (t.pehebrew = 1508),
            (t.pehfinalarabic = 64343),
            (t.pehinitialarabic = 64344),
            (t.pehiragana = 12410),
            (t.pehmedialarabic = 64345),
            (t.pekatakana = 12506),
            (t.pemiddlehookcyrillic = 1191),
            (t.perafehebrew = 64334),
            (t.percent = 37),
            (t.percentarabic = 1642),
            (t.percentmonospace = 65285),
            (t.percentsmall = 65130),
            (t.period = 46),
            (t.periodarmenian = 1417),
            (t.periodcentered = 183),
            (t.periodhalfwidth = 65377),
            (t.periodinferior = 63207),
            (t.periodmonospace = 65294),
            (t.periodsmall = 65106),
            (t.periodsuperior = 63208),
            (t.perispomenigreekcmb = 834),
            (t.perpendicular = 8869),
            (t.perthousand = 8240),
            (t.peseta = 8359),
            (t.pfsquare = 13194),
            (t.phabengali = 2475),
            (t.phadeva = 2347),
            (t.phagujarati = 2731),
            (t.phagurmukhi = 2603),
            (t.phi = 966),
            (t.phi1 = 981),
            (t.phieuphacirclekorean = 12922),
            (t.phieuphaparenkorean = 12826),
            (t.phieuphcirclekorean = 12908),
            (t.phieuphkorean = 12621),
            (t.phieuphparenkorean = 12812),
            (t.philatin = 632),
            (t.phinthuthai = 3642),
            (t.phisymbolgreek = 981),
            (t.phook = 421),
            (t.phophanthai = 3614),
            (t.phophungthai = 3612),
            (t.phosamphaothai = 3616),
            (t.pi = 960),
            (t.pieupacirclekorean = 12915),
            (t.pieupaparenkorean = 12819),
            (t.pieupcieuckorean = 12662),
            (t.pieupcirclekorean = 12901),
            (t.pieupkiyeokkorean = 12658),
            (t.pieupkorean = 12610),
            (t.pieupparenkorean = 12805),
            (t.pieupsioskiyeokkorean = 12660),
            (t.pieupsioskorean = 12612),
            (t.pieupsiostikeutkorean = 12661),
            (t.pieupthieuthkorean = 12663),
            (t.pieuptikeutkorean = 12659),
            (t.pihiragana = 12404),
            (t.pikatakana = 12500),
            (t.pisymbolgreek = 982),
            (t.piwrarmenian = 1411),
            (t.plus = 43),
            (t.plusbelowcmb = 799),
            (t.pluscircle = 8853),
            (t.plusminus = 177),
            (t.plusmod = 726),
            (t.plusmonospace = 65291),
            (t.plussmall = 65122),
            (t.plussuperior = 8314),
            (t.pmonospace = 65360),
            (t.pmsquare = 13272),
            (t.pohiragana = 12413),
            (t.pointingindexdownwhite = 9759),
            (t.pointingindexleftwhite = 9756),
            (t.pointingindexrightwhite = 9758),
            (t.pointingindexupwhite = 9757),
            (t.pokatakana = 12509),
            (t.poplathai = 3611),
            (t.postalmark = 12306),
            (t.postalmarkface = 12320),
            (t.pparen = 9387),
            (t.precedes = 8826),
            (t.prescription = 8478),
            (t.primemod = 697),
            (t.primereversed = 8245),
            (t.product = 8719),
            (t.projective = 8965),
            (t.prolongedkana = 12540),
            (t.propellor = 8984),
            (t.propersubset = 8834),
            (t.propersuperset = 8835),
            (t.proportion = 8759),
            (t.proportional = 8733),
            (t.psi = 968),
            (t.psicyrillic = 1137),
            (t.psilipneumatacyrilliccmb = 1158),
            (t.pssquare = 13232),
            (t.puhiragana = 12407),
            (t.pukatakana = 12503),
            (t.pvsquare = 13236),
            (t.pwsquare = 13242),
            (t.q = 113),
            (t.qadeva = 2392),
            (t.qadmahebrew = 1448),
            (t.qafarabic = 1602),
            (t.qaffinalarabic = 65238),
            (t.qafinitialarabic = 65239),
            (t.qafmedialarabic = 65240),
            (t.qamats = 1464),
            (t.qamats10 = 1464),
            (t.qamats1a = 1464),
            (t.qamats1c = 1464),
            (t.qamats27 = 1464),
            (t.qamats29 = 1464),
            (t.qamats33 = 1464),
            (t.qamatsde = 1464),
            (t.qamatshebrew = 1464),
            (t.qamatsnarrowhebrew = 1464),
            (t.qamatsqatanhebrew = 1464),
            (t.qamatsqatannarrowhebrew = 1464),
            (t.qamatsqatanquarterhebrew = 1464),
            (t.qamatsqatanwidehebrew = 1464),
            (t.qamatsquarterhebrew = 1464),
            (t.qamatswidehebrew = 1464),
            (t.qarneyparahebrew = 1439),
            (t.qbopomofo = 12561),
            (t.qcircle = 9440),
            (t.qhook = 672),
            (t.qmonospace = 65361),
            (t.qof = 1511),
            (t.qofdagesh = 64327),
            (t.qofdageshhebrew = 64327),
            (t.qofhebrew = 1511),
            (t.qparen = 9388),
            (t.quarternote = 9833),
            (t.qubuts = 1467),
            (t.qubuts18 = 1467),
            (t.qubuts25 = 1467),
            (t.qubuts31 = 1467),
            (t.qubutshebrew = 1467),
            (t.qubutsnarrowhebrew = 1467),
            (t.qubutsquarterhebrew = 1467),
            (t.qubutswidehebrew = 1467),
            (t.question = 63),
            (t.questionarabic = 1567),
            (t.questionarmenian = 1374),
            (t.questiondown = 191),
            (t.questiondownsmall = 63423),
            (t.questiongreek = 894),
            (t.questionmonospace = 65311),
            (t.questionsmall = 63295),
            (t.quotedbl = 34),
            (t.quotedblbase = 8222),
            (t.quotedblleft = 8220),
            (t.quotedblmonospace = 65282),
            (t.quotedblprime = 12318),
            (t.quotedblprimereversed = 12317),
            (t.quotedblright = 8221),
            (t.quoteleft = 8216),
            (t.quoteleftreversed = 8219),
            (t.quotereversed = 8219),
            (t.quoteright = 8217),
            (t.quoterightn = 329),
            (t.quotesinglbase = 8218),
            (t.quotesingle = 39),
            (t.quotesinglemonospace = 65287),
            (t.r = 114),
            (t.raarmenian = 1404),
            (t.rabengali = 2480),
            (t.racute = 341),
            (t.radeva = 2352),
            (t.radical = 8730),
            (t.radicalex = 63717),
            (t.radoverssquare = 13230),
            (t.radoverssquaredsquare = 13231),
            (t.radsquare = 13229),
            (t.rafe = 1471),
            (t.rafehebrew = 1471),
            (t.ragujarati = 2736),
            (t.ragurmukhi = 2608),
            (t.rahiragana = 12425),
            (t.rakatakana = 12521),
            (t.rakatakanahalfwidth = 65431),
            (t.ralowerdiagonalbengali = 2545),
            (t.ramiddlediagonalbengali = 2544),
            (t.ramshorn = 612),
            (t.ratio = 8758),
            (t.rbopomofo = 12566),
            (t.rcaron = 345),
            (t.rcedilla = 343),
            (t.rcircle = 9441),
            (t.rcommaaccent = 343),
            (t.rdblgrave = 529),
            (t.rdotaccent = 7769),
            (t.rdotbelow = 7771),
            (t.rdotbelowmacron = 7773),
            (t.referencemark = 8251),
            (t.reflexsubset = 8838),
            (t.reflexsuperset = 8839),
            (t.registered = 174),
            (t.registersans = 63720),
            (t.registerserif = 63194),
            (t.reharabic = 1585),
            (t.reharmenian = 1408),
            (t.rehfinalarabic = 65198),
            (t.rehiragana = 12428),
            (t.rekatakana = 12524),
            (t.rekatakanahalfwidth = 65434),
            (t.resh = 1512),
            (t.reshdageshhebrew = 64328),
            (t.reshhebrew = 1512),
            (t.reversedtilde = 8765),
            (t.reviahebrew = 1431);
          (t.reviamugrashhebrew = 1431),
            (t.revlogicalnot = 8976),
            (t.rfishhook = 638),
            (t.rfishhookreversed = 639),
            (t.rhabengali = 2525),
            (t.rhadeva = 2397),
            (t.rho = 961),
            (t.rhook = 637),
            (t.rhookturned = 635),
            (t.rhookturnedsuperior = 693),
            (t.rhosymbolgreek = 1009),
            (t.rhotichookmod = 734),
            (t.rieulacirclekorean = 12913),
            (t.rieulaparenkorean = 12817),
            (t.rieulcirclekorean = 12899),
            (t.rieulhieuhkorean = 12608),
            (t.rieulkiyeokkorean = 12602),
            (t.rieulkiyeoksioskorean = 12649),
            (t.rieulkorean = 12601),
            (t.rieulmieumkorean = 12603),
            (t.rieulpansioskorean = 12652),
            (t.rieulparenkorean = 12803),
            (t.rieulphieuphkorean = 12607),
            (t.rieulpieupkorean = 12604),
            (t.rieulpieupsioskorean = 12651),
            (t.rieulsioskorean = 12605),
            (t.rieulthieuthkorean = 12606),
            (t.rieultikeutkorean = 12650),
            (t.rieulyeorinhieuhkorean = 12653),
            (t.rightangle = 8735),
            (t.righttackbelowcmb = 793),
            (t.righttriangle = 8895),
            (t.rihiragana = 12426),
            (t.rikatakana = 12522),
            (t.rikatakanahalfwidth = 65432),
            (t.ring = 730),
            (t.ringbelowcmb = 805),
            (t.ringcmb = 778),
            (t.ringhalfleft = 703),
            (t.ringhalfleftarmenian = 1369),
            (t.ringhalfleftbelowcmb = 796),
            (t.ringhalfleftcentered = 723),
            (t.ringhalfright = 702),
            (t.ringhalfrightbelowcmb = 825),
            (t.ringhalfrightcentered = 722),
            (t.rinvertedbreve = 531),
            (t.rittorusquare = 13137),
            (t.rlinebelow = 7775),
            (t.rlongleg = 636),
            (t.rlonglegturned = 634),
            (t.rmonospace = 65362),
            (t.rohiragana = 12429),
            (t.rokatakana = 12525),
            (t.rokatakanahalfwidth = 65435),
            (t.roruathai = 3619),
            (t.rparen = 9389),
            (t.rrabengali = 2524),
            (t.rradeva = 2353),
            (t.rragurmukhi = 2652),
            (t.rreharabic = 1681),
            (t.rrehfinalarabic = 64397),
            (t.rrvocalicbengali = 2528),
            (t.rrvocalicdeva = 2400),
            (t.rrvocalicgujarati = 2784),
            (t.rrvocalicvowelsignbengali = 2500),
            (t.rrvocalicvowelsigndeva = 2372),
            (t.rrvocalicvowelsigngujarati = 2756),
            (t.rsuperior = 63217),
            (t.rtblock = 9616),
            (t.rturned = 633),
            (t.rturnedsuperior = 692),
            (t.ruhiragana = 12427),
            (t.rukatakana = 12523),
            (t.rukatakanahalfwidth = 65433),
            (t.rupeemarkbengali = 2546),
            (t.rupeesignbengali = 2547),
            (t.rupiah = 63197),
            (t.ruthai = 3620),
            (t.rvocalicbengali = 2443),
            (t.rvocalicdeva = 2315),
            (t.rvocalicgujarati = 2699),
            (t.rvocalicvowelsignbengali = 2499),
            (t.rvocalicvowelsigndeva = 2371),
            (t.rvocalicvowelsigngujarati = 2755),
            (t.s = 115),
            (t.sabengali = 2488),
            (t.sacute = 347),
            (t.sacutedotaccent = 7781),
            (t.sadarabic = 1589),
            (t.sadeva = 2360),
            (t.sadfinalarabic = 65210),
            (t.sadinitialarabic = 65211),
            (t.sadmedialarabic = 65212),
            (t.sagujarati = 2744),
            (t.sagurmukhi = 2616),
            (t.sahiragana = 12373),
            (t.sakatakana = 12469),
            (t.sakatakanahalfwidth = 65403),
            (t.sallallahoualayhewasallamarabic = 65018),
            (t.samekh = 1505),
            (t.samekhdagesh = 64321),
            (t.samekhdageshhebrew = 64321),
            (t.samekhhebrew = 1505),
            (t.saraaathai = 3634),
            (t.saraaethai = 3649),
            (t.saraaimaimalaithai = 3652),
            (t.saraaimaimuanthai = 3651),
            (t.saraamthai = 3635),
            (t.saraathai = 3632),
            (t.saraethai = 3648),
            (t.saraiileftthai = 63622),
            (t.saraiithai = 3637),
            (t.saraileftthai = 63621),
            (t.saraithai = 3636),
            (t.saraothai = 3650),
            (t.saraueeleftthai = 63624),
            (t.saraueethai = 3639),
            (t.saraueleftthai = 63623),
            (t.sarauethai = 3638),
            (t.sarauthai = 3640),
            (t.sarauuthai = 3641),
            (t.sbopomofo = 12569),
            (t.scaron = 353),
            (t.scarondotaccent = 7783),
            (t.scedilla = 351),
            (t.schwa = 601),
            (t.schwacyrillic = 1241),
            (t.schwadieresiscyrillic = 1243),
            (t.schwahook = 602),
            (t.scircle = 9442),
            (t.scircumflex = 349),
            (t.scommaaccent = 537),
            (t.sdotaccent = 7777),
            (t.sdotbelow = 7779),
            (t.sdotbelowdotaccent = 7785),
            (t.seagullbelowcmb = 828),
            (t.second = 8243),
            (t.secondtonechinese = 714),
            (t.section = 167),
            (t.seenarabic = 1587),
            (t.seenfinalarabic = 65202),
            (t.seeninitialarabic = 65203),
            (t.seenmedialarabic = 65204),
            (t.segol = 1462),
            (t.segol13 = 1462),
            (t.segol1f = 1462),
            (t.segol2c = 1462),
            (t.segolhebrew = 1462),
            (t.segolnarrowhebrew = 1462),
            (t.segolquarterhebrew = 1462),
            (t.segoltahebrew = 1426),
            (t.segolwidehebrew = 1462),
            (t.seharmenian = 1405),
            (t.sehiragana = 12379),
            (t.sekatakana = 12475),
            (t.sekatakanahalfwidth = 65406),
            (t.semicolon = 59),
            (t.semicolonarabic = 1563),
            (t.semicolonmonospace = 65307),
            (t.semicolonsmall = 65108),
            (t.semivoicedmarkkana = 12444),
            (t.semivoicedmarkkanahalfwidth = 65439),
            (t.sentisquare = 13090),
            (t.sentosquare = 13091),
            (t.seven = 55),
            (t.sevenarabic = 1639),
            (t.sevenbengali = 2541),
            (t.sevencircle = 9318),
            (t.sevencircleinversesansserif = 10128),
            (t.sevendeva = 2413),
            (t.seveneighths = 8542),
            (t.sevengujarati = 2797),
            (t.sevengurmukhi = 2669),
            (t.sevenhackarabic = 1639),
            (t.sevenhangzhou = 12327),
            (t.sevenideographicparen = 12838),
            (t.seveninferior = 8327),
            (t.sevenmonospace = 65303),
            (t.sevenoldstyle = 63287),
            (t.sevenparen = 9338),
            (t.sevenperiod = 9358),
            (t.sevenpersian = 1783),
            (t.sevenroman = 8566),
            (t.sevensuperior = 8311),
            (t.seventeencircle = 9328),
            (t.seventeenparen = 9348),
            (t.seventeenperiod = 9368),
            (t.seventhai = 3671),
            (t.sfthyphen = 173),
            (t.shaarmenian = 1399),
            (t.shabengali = 2486),
            (t.shacyrillic = 1096),
            (t.shaddaarabic = 1617),
            (t.shaddadammaarabic = 64609),
            (t.shaddadammatanarabic = 64606),
            (t.shaddafathaarabic = 64608),
            (t.shaddakasraarabic = 64610),
            (t.shaddakasratanarabic = 64607),
            (t.shade = 9618),
            (t.shadedark = 9619),
            (t.shadelight = 9617),
            (t.shademedium = 9618),
            (t.shadeva = 2358),
            (t.shagujarati = 2742),
            (t.shagurmukhi = 2614),
            (t.shalshelethebrew = 1427),
            (t.shbopomofo = 12565),
            (t.shchacyrillic = 1097),
            (t.sheenarabic = 1588),
            (t.sheenfinalarabic = 65206),
            (t.sheeninitialarabic = 65207),
            (t.sheenmedialarabic = 65208),
            (t.sheicoptic = 995),
            (t.sheqel = 8362),
            (t.sheqelhebrew = 8362),
            (t.sheva = 1456),
            (t.sheva115 = 1456),
            (t.sheva15 = 1456),
            (t.sheva22 = 1456),
            (t.sheva2e = 1456),
            (t.shevahebrew = 1456),
            (t.shevanarrowhebrew = 1456),
            (t.shevaquarterhebrew = 1456),
            (t.shevawidehebrew = 1456),
            (t.shhacyrillic = 1211),
            (t.shimacoptic = 1005),
            (t.shin = 1513),
            (t.shindagesh = 64329),
            (t.shindageshhebrew = 64329),
            (t.shindageshshindot = 64300),
            (t.shindageshshindothebrew = 64300),
            (t.shindageshsindot = 64301),
            (t.shindageshsindothebrew = 64301),
            (t.shindothebrew = 1473),
            (t.shinhebrew = 1513),
            (t.shinshindot = 64298),
            (t.shinshindothebrew = 64298),
            (t.shinsindot = 64299),
            (t.shinsindothebrew = 64299),
            (t.shook = 642),
            (t.sigma = 963),
            (t.sigma1 = 962),
            (t.sigmafinal = 962),
            (t.sigmalunatesymbolgreek = 1010),
            (t.sihiragana = 12375),
            (t.sikatakana = 12471),
            (t.sikatakanahalfwidth = 65404),
            (t.siluqhebrew = 1469),
            (t.siluqlefthebrew = 1469),
            (t.similar = 8764),
            (t.sindothebrew = 1474),
            (t.siosacirclekorean = 12916),
            (t.siosaparenkorean = 12820),
            (t.sioscieuckorean = 12670),
            (t.sioscirclekorean = 12902),
            (t.sioskiyeokkorean = 12666),
            (t.sioskorean = 12613),
            (t.siosnieunkorean = 12667),
            (t.siosparenkorean = 12806),
            (t.siospieupkorean = 12669),
            (t.siostikeutkorean = 12668),
            (t.six = 54),
            (t.sixarabic = 1638),
            (t.sixbengali = 2540),
            (t.sixcircle = 9317),
            (t.sixcircleinversesansserif = 10127),
            (t.sixdeva = 2412),
            (t.sixgujarati = 2796),
            (t.sixgurmukhi = 2668),
            (t.sixhackarabic = 1638),
            (t.sixhangzhou = 12326),
            (t.sixideographicparen = 12837),
            (t.sixinferior = 8326),
            (t.sixmonospace = 65302),
            (t.sixoldstyle = 63286),
            (t.sixparen = 9337),
            (t.sixperiod = 9357),
            (t.sixpersian = 1782),
            (t.sixroman = 8565),
            (t.sixsuperior = 8310),
            (t.sixteencircle = 9327),
            (t.sixteencurrencydenominatorbengali = 2553),
            (t.sixteenparen = 9347),
            (t.sixteenperiod = 9367),
            (t.sixthai = 3670),
            (t.slash = 47),
            (t.slashmonospace = 65295),
            (t.slong = 383),
            (t.slongdotaccent = 7835),
            (t.smileface = 9786),
            (t.smonospace = 65363),
            (t.sofpasuqhebrew = 1475),
            (t.softhyphen = 173),
            (t.softsigncyrillic = 1100),
            (t.sohiragana = 12381),
            (t.sokatakana = 12477),
            (t.sokatakanahalfwidth = 65407),
            (t.soliduslongoverlaycmb = 824),
            (t.solidusshortoverlaycmb = 823),
            (t.sorusithai = 3625),
            (t.sosalathai = 3624),
            (t.sosothai = 3595),
            (t.sosuathai = 3626),
            (t.space = 32),
            (t.spacehackarabic = 32),
            (t.spade = 9824),
            (t.spadesuitblack = 9824),
            (t.spadesuitwhite = 9828),
            (t.sparen = 9390),
            (t.squarebelowcmb = 827),
            (t.squarecc = 13252),
            (t.squarecm = 13213),
            (t.squarediagonalcrosshatchfill = 9641),
            (t.squarehorizontalfill = 9636),
            (t.squarekg = 13199),
            (t.squarekm = 13214),
            (t.squarekmcapital = 13262),
            (t.squareln = 13265),
            (t.squarelog = 13266),
            (t.squaremg = 13198),
            (t.squaremil = 13269),
            (t.squaremm = 13212),
            (t.squaremsquared = 13217),
            (t.squareorthogonalcrosshatchfill = 9638),
            (t.squareupperlefttolowerrightfill = 9639),
            (t.squareupperrighttolowerleftfill = 9640),
            (t.squareverticalfill = 9637),
            (t.squarewhitewithsmallblack = 9635),
            (t.srsquare = 13275),
            (t.ssabengali = 2487),
            (t.ssadeva = 2359),
            (t.ssagujarati = 2743),
            (t.ssangcieuckorean = 12617),
            (t.ssanghieuhkorean = 12677),
            (t.ssangieungkorean = 12672),
            (t.ssangkiyeokkorean = 12594),
            (t.ssangnieunkorean = 12645),
            (t.ssangpieupkorean = 12611),
            (t.ssangsioskorean = 12614),
            (t.ssangtikeutkorean = 12600),
            (t.ssuperior = 63218),
            (t.sterling = 163),
            (t.sterlingmonospace = 65505),
            (t.strokelongoverlaycmb = 822),
            (t.strokeshortoverlaycmb = 821),
            (t.subset = 8834),
            (t.subsetnotequal = 8842),
            (t.subsetorequal = 8838),
            (t.succeeds = 8827),
            (t.suchthat = 8715),
            (t.suhiragana = 12377),
            (t.sukatakana = 12473),
            (t.sukatakanahalfwidth = 65405),
            (t.sukunarabic = 1618),
            (t.summation = 8721),
            (t.sun = 9788),
            (t.superset = 8835),
            (t.supersetnotequal = 8843),
            (t.supersetorequal = 8839),
            (t.svsquare = 13276),
            (t.syouwaerasquare = 13180),
            (t.t = 116),
            (t.tabengali = 2468),
            (t.tackdown = 8868),
            (t.tackleft = 8867),
            (t.tadeva = 2340),
            (t.tagujarati = 2724),
            (t.tagurmukhi = 2596),
            (t.taharabic = 1591),
            (t.tahfinalarabic = 65218),
            (t.tahinitialarabic = 65219),
            (t.tahiragana = 12383),
            (t.tahmedialarabic = 65220),
            (t.taisyouerasquare = 13181),
            (t.takatakana = 12479),
            (t.takatakanahalfwidth = 65408),
            (t.tatweelarabic = 1600),
            (t.tau = 964),
            (t.tav = 1514),
            (t.tavdages = 64330),
            (t.tavdagesh = 64330),
            (t.tavdageshhebrew = 64330),
            (t.tavhebrew = 1514),
            (t.tbar = 359),
            (t.tbopomofo = 12554),
            (t.tcaron = 357),
            (t.tccurl = 680),
            (t.tcedilla = 355),
            (t.tcheharabic = 1670),
            (t.tchehfinalarabic = 64379),
            (t.tchehinitialarabic = 64380),
            (t.tchehmedialarabic = 64381),
            (t.tcircle = 9443),
            (t.tcircumflexbelow = 7793),
            (t.tcommaaccent = 355),
            (t.tdieresis = 7831),
            (t.tdotaccent = 7787),
            (t.tdotbelow = 7789),
            (t.tecyrillic = 1090),
            (t.tedescendercyrillic = 1197),
            (t.teharabic = 1578),
            (t.tehfinalarabic = 65174),
            (t.tehhahinitialarabic = 64674),
            (t.tehhahisolatedarabic = 64524),
            (t.tehinitialarabic = 65175),
            (t.tehiragana = 12390),
            (t.tehjeeminitialarabic = 64673),
            (t.tehjeemisolatedarabic = 64523),
            (t.tehmarbutaarabic = 1577),
            (t.tehmarbutafinalarabic = 65172),
            (t.tehmedialarabic = 65176),
            (t.tehmeeminitialarabic = 64676),
            (t.tehmeemisolatedarabic = 64526),
            (t.tehnoonfinalarabic = 64627),
            (t.tekatakana = 12486),
            (t.tekatakanahalfwidth = 65411),
            (t.telephone = 8481),
            (t.telephoneblack = 9742),
            (t.telishagedolahebrew = 1440),
            (t.telishaqetanahebrew = 1449),
            (t.tencircle = 9321),
            (t.tenideographicparen = 12841),
            (t.tenparen = 9341),
            (t.tenperiod = 9361),
            (t.tenroman = 8569),
            (t.tesh = 679),
            (t.tet = 1496),
            (t.tetdagesh = 64312),
            (t.tetdageshhebrew = 64312),
            (t.tethebrew = 1496),
            (t.tetsecyrillic = 1205),
            (t.tevirhebrew = 1435),
            (t.tevirlefthebrew = 1435),
            (t.thabengali = 2469),
            (t.thadeva = 2341),
            (t.thagujarati = 2725),
            (t.thagurmukhi = 2597),
            (t.thalarabic = 1584),
            (t.thalfinalarabic = 65196),
            (t.thanthakhatlowleftthai = 63640),
            (t.thanthakhatlowrightthai = 63639),
            (t.thanthakhatthai = 3660),
            (t.thanthakhatupperleftthai = 63638),
            (t.theharabic = 1579),
            (t.thehfinalarabic = 65178),
            (t.thehinitialarabic = 65179),
            (t.thehmedialarabic = 65180),
            (t.thereexists = 8707),
            (t.therefore = 8756),
            (t.theta = 952),
            (t.theta1 = 977),
            (t.thetasymbolgreek = 977),
            (t.thieuthacirclekorean = 12921),
            (t.thieuthaparenkorean = 12825),
            (t.thieuthcirclekorean = 12907),
            (t.thieuthkorean = 12620),
            (t.thieuthparenkorean = 12811),
            (t.thirteencircle = 9324),
            (t.thirteenparen = 9344),
            (t.thirteenperiod = 9364),
            (t.thonangmonthothai = 3601),
            (t.thook = 429),
            (t.thophuthaothai = 3602),
            (t.thorn = 254),
            (t.thothahanthai = 3607),
            (t.thothanthai = 3600),
            (t.thothongthai = 3608),
            (t.thothungthai = 3606),
            (t.thousandcyrillic = 1154),
            (t.thousandsseparatorarabic = 1644),
            (t.thousandsseparatorpersian = 1644),
            (t.three = 51),
            (t.threearabic = 1635),
            (t.threebengali = 2537),
            (t.threecircle = 9314),
            (t.threecircleinversesansserif = 10124),
            (t.threedeva = 2409),
            (t.threeeighths = 8540),
            (t.threegujarati = 2793),
            (t.threegurmukhi = 2665),
            (t.threehackarabic = 1635),
            (t.threehangzhou = 12323),
            (t.threeideographicparen = 12834),
            (t.threeinferior = 8323),
            (t.threemonospace = 65299),
            (t.threenumeratorbengali = 2550),
            (t.threeoldstyle = 63283),
            (t.threeparen = 9334),
            (t.threeperiod = 9354),
            (t.threepersian = 1779),
            (t.threequarters = 190),
            (t.threequartersemdash = 63198),
            (t.threeroman = 8562),
            (t.threesuperior = 179),
            (t.threethai = 3667),
            (t.thzsquare = 13204),
            (t.tihiragana = 12385),
            (t.tikatakana = 12481),
            (t.tikatakanahalfwidth = 65409),
            (t.tikeutacirclekorean = 12912),
            (t.tikeutaparenkorean = 12816),
            (t.tikeutcirclekorean = 12898),
            (t.tikeutkorean = 12599),
            (t.tikeutparenkorean = 12802),
            (t.tilde = 732),
            (t.tildebelowcmb = 816),
            (t.tildecmb = 771),
            (t.tildecomb = 771),
            (t.tildedoublecmb = 864),
            (t.tildeoperator = 8764),
            (t.tildeoverlaycmb = 820),
            (t.tildeverticalcmb = 830),
            (t.timescircle = 8855),
            (t.tipehahebrew = 1430),
            (t.tipehalefthebrew = 1430),
            (t.tippigurmukhi = 2672),
            (t.titlocyrilliccmb = 1155),
            (t.tiwnarmenian = 1407),
            (t.tlinebelow = 7791),
            (t.tmonospace = 65364),
            (t.toarmenian = 1385),
            (t.tohiragana = 12392),
            (t.tokatakana = 12488),
            (t.tokatakanahalfwidth = 65412),
            (t.tonebarextrahighmod = 741),
            (t.tonebarextralowmod = 745),
            (t.tonebarhighmod = 742),
            (t.tonebarlowmod = 744),
            (t.tonebarmidmod = 743),
            (t.tonefive = 445),
            (t.tonesix = 389),
            (t.tonetwo = 424),
            (t.tonos = 900),
            (t.tonsquare = 13095),
            (t.topatakthai = 3599),
            (t.tortoiseshellbracketleft = 12308),
            (t.tortoiseshellbracketleftsmall = 65117),
            (t.tortoiseshellbracketleftvertical = 65081),
            (t.tortoiseshellbracketright = 12309),
            (t.tortoiseshellbracketrightsmall = 65118),
            (t.tortoiseshellbracketrightvertical = 65082),
            (t.totaothai = 3605),
            (t.tpalatalhook = 427),
            (t.tparen = 9391),
            (t.trademark = 8482),
            (t.trademarksans = 63722),
            (t.trademarkserif = 63195),
            (t.tretroflexhook = 648),
            (t.triagdn = 9660),
            (t.triaglf = 9668),
            (t.triagrt = 9658),
            (t.triagup = 9650),
            (t.ts = 678),
            (t.tsadi = 1510),
            (t.tsadidagesh = 64326),
            (t.tsadidageshhebrew = 64326),
            (t.tsadihebrew = 1510),
            (t.tsecyrillic = 1094),
            (t.tsere = 1461),
            (t.tsere12 = 1461),
            (t.tsere1e = 1461),
            (t.tsere2b = 1461),
            (t.tserehebrew = 1461),
            (t.tserenarrowhebrew = 1461),
            (t.tserequarterhebrew = 1461),
            (t.tserewidehebrew = 1461),
            (t.tshecyrillic = 1115),
            (t.tsuperior = 63219),
            (t.ttabengali = 2463),
            (t.ttadeva = 2335),
            (t.ttagujarati = 2719),
            (t.ttagurmukhi = 2591),
            (t.tteharabic = 1657),
            (t.ttehfinalarabic = 64359),
            (t.ttehinitialarabic = 64360),
            (t.ttehmedialarabic = 64361),
            (t.tthabengali = 2464),
            (t.tthadeva = 2336),
            (t.tthagujarati = 2720),
            (t.tthagurmukhi = 2592),
            (t.tturned = 647),
            (t.tuhiragana = 12388),
            (t.tukatakana = 12484),
            (t.tukatakanahalfwidth = 65410),
            (t.tusmallhiragana = 12387),
            (t.tusmallkatakana = 12483),
            (t.tusmallkatakanahalfwidth = 65391),
            (t.twelvecircle = 9323),
            (t.twelveparen = 9343),
            (t.twelveperiod = 9363),
            (t.twelveroman = 8571),
            (t.twentycircle = 9331),
            (t.twentyhangzhou = 21316),
            (t.twentyparen = 9351),
            (t.twentyperiod = 9371),
            (t.two = 50),
            (t.twoarabic = 1634),
            (t.twobengali = 2536),
            (t.twocircle = 9313),
            (t.twocircleinversesansserif = 10123),
            (t.twodeva = 2408),
            (t.twodotenleader = 8229),
            (t.twodotleader = 8229),
            (t.twodotleadervertical = 65072),
            (t.twogujarati = 2792),
            (t.twogurmukhi = 2664),
            (t.twohackarabic = 1634),
            (t.twohangzhou = 12322),
            (t.twoideographicparen = 12833),
            (t.twoinferior = 8322),
            (t.twomonospace = 65298),
            (t.twonumeratorbengali = 2549),
            (t.twooldstyle = 63282),
            (t.twoparen = 9333),
            (t.twoperiod = 9353),
            (t.twopersian = 1778),
            (t.tworoman = 8561),
            (t.twostroke = 443),
            (t.twosuperior = 178),
            (t.twothai = 3666),
            (t.twothirds = 8532),
            (t.u = 117),
            (t.uacute = 250),
            (t.ubar = 649),
            (t.ubengali = 2441),
            (t.ubopomofo = 12584),
            (t.ubreve = 365),
            (t.ucaron = 468),
            (t.ucircle = 9444),
            (t.ucircumflex = 251),
            (t.ucircumflexbelow = 7799),
            (t.ucyrillic = 1091),
            (t.udattadeva = 2385),
            (t.udblacute = 369),
            (t.udblgrave = 533),
            (t.udeva = 2313),
            (t.udieresis = 252),
            (t.udieresisacute = 472),
            (t.udieresisbelow = 7795),
            (t.udieresiscaron = 474),
            (t.udieresiscyrillic = 1265),
            (t.udieresisgrave = 476),
            (t.udieresismacron = 470),
            (t.udotbelow = 7909),
            (t.ugrave = 249),
            (t.ugujarati = 2697),
            (t.ugurmukhi = 2569),
            (t.uhiragana = 12358),
            (t.uhookabove = 7911),
            (t.uhorn = 432),
            (t.uhornacute = 7913),
            (t.uhorndotbelow = 7921),
            (t.uhorngrave = 7915),
            (t.uhornhookabove = 7917),
            (t.uhorntilde = 7919),
            (t.uhungarumlaut = 369),
            (t.uhungarumlautcyrillic = 1267),
            (t.uinvertedbreve = 535),
            (t.ukatakana = 12454),
            (t.ukatakanahalfwidth = 65395),
            (t.ukcyrillic = 1145),
            (t.ukorean = 12636),
            (t.umacron = 363),
            (t.umacroncyrillic = 1263),
            (t.umacrondieresis = 7803),
            (t.umatragurmukhi = 2625),
            (t.umonospace = 65365),
            (t.underscore = 95),
            (t.underscoredbl = 8215),
            (t.underscoremonospace = 65343),
            (t.underscorevertical = 65075),
            (t.underscorewavy = 65103),
            (t.union = 8746),
            (t.universal = 8704),
            (t.uogonek = 371),
            (t.uparen = 9392),
            (t.upblock = 9600),
            (t.upperdothebrew = 1476),
            (t.upsilon = 965),
            (t.upsilondieresis = 971),
            (t.upsilondieresistonos = 944),
            (t.upsilonlatin = 650),
            (t.upsilontonos = 973),
            (t.uptackbelowcmb = 797),
            (t.uptackmod = 724),
            (t.uragurmukhi = 2675),
            (t.uring = 367),
            (t.ushortcyrillic = 1118),
            (t.usmallhiragana = 12357),
            (t.usmallkatakana = 12453),
            (t.usmallkatakanahalfwidth = 65385),
            (t.ustraightcyrillic = 1199),
            (t.ustraightstrokecyrillic = 1201),
            (t.utilde = 361),
            (t.utildeacute = 7801),
            (t.utildebelow = 7797),
            (t.uubengali = 2442),
            (t.uudeva = 2314),
            (t.uugujarati = 2698),
            (t.uugurmukhi = 2570),
            (t.uumatragurmukhi = 2626),
            (t.uuvowelsignbengali = 2498),
            (t.uuvowelsigndeva = 2370),
            (t.uuvowelsigngujarati = 2754),
            (t.uvowelsignbengali = 2497),
            (t.uvowelsigndeva = 2369),
            (t.uvowelsigngujarati = 2753),
            (t.v = 118),
            (t.vadeva = 2357),
            (t.vagujarati = 2741),
            (t.vagurmukhi = 2613),
            (t.vakatakana = 12535),
            (t.vav = 1493),
            (t.vavdagesh = 64309),
            (t.vavdagesh65 = 64309),
            (t.vavdageshhebrew = 64309),
            (t.vavhebrew = 1493),
            (t.vavholam = 64331),
            (t.vavholamhebrew = 64331),
            (t.vavvavhebrew = 1520),
            (t.vavyodhebrew = 1521),
            (t.vcircle = 9445),
            (t.vdotbelow = 7807),
            (t.vecyrillic = 1074),
            (t.veharabic = 1700),
            (t.vehfinalarabic = 64363),
            (t.vehinitialarabic = 64364),
            (t.vehmedialarabic = 64365),
            (t.vekatakana = 12537),
            (t.venus = 9792),
            (t.verticalbar = 124),
            (t.verticallineabovecmb = 781),
            (t.verticallinebelowcmb = 809),
            (t.verticallinelowmod = 716),
            (t.verticallinemod = 712),
            (t.vewarmenian = 1406),
            (t.vhook = 651),
            (t.vikatakana = 12536),
            (t.viramabengali = 2509),
            (t.viramadeva = 2381),
            (t.viramagujarati = 2765),
            (t.visargabengali = 2435),
            (t.visargadeva = 2307),
            (t.visargagujarati = 2691),
            (t.vmonospace = 65366),
            (t.voarmenian = 1400),
            (t.voicediterationhiragana = 12446),
            (t.voicediterationkatakana = 12542),
            (t.voicedmarkkana = 12443),
            (t.voicedmarkkanahalfwidth = 65438),
            (t.vokatakana = 12538),
            (t.vparen = 9393),
            (t.vtilde = 7805),
            (t.vturned = 652),
            (t.vuhiragana = 12436),
            (t.vukatakana = 12532),
            (t.w = 119),
            (t.wacute = 7811),
            (t.waekorean = 12633),
            (t.wahiragana = 12431),
            (t.wakatakana = 12527),
            (t.wakatakanahalfwidth = 65436),
            (t.wakorean = 12632),
            (t.wasmallhiragana = 12430),
            (t.wasmallkatakana = 12526),
            (t.wattosquare = 13143),
            (t.wavedash = 12316),
            (t.wavyunderscorevertical = 65076),
            (t.wawarabic = 1608),
            (t.wawfinalarabic = 65262),
            (t.wawhamzaabovearabic = 1572),
            (t.wawhamzaabovefinalarabic = 65158),
            (t.wbsquare = 13277),
            (t.wcircle = 9446),
            (t.wcircumflex = 373),
            (t.wdieresis = 7813),
            (t.wdotaccent = 7815),
            (t.wdotbelow = 7817),
            (t.wehiragana = 12433),
            (t.weierstrass = 8472),
            (t.wekatakana = 12529),
            (t.wekorean = 12638),
            (t.weokorean = 12637),
            (t.wgrave = 7809),
            (t.whitebullet = 9702),
            (t.whitecircle = 9675),
            (t.whitecircleinverse = 9689),
            (t.whitecornerbracketleft = 12302),
            (t.whitecornerbracketleftvertical = 65091),
            (t.whitecornerbracketright = 12303),
            (t.whitecornerbracketrightvertical = 65092),
            (t.whitediamond = 9671),
            (t.whitediamondcontainingblacksmalldiamond = 9672),
            (t.whitedownpointingsmalltriangle = 9663),
            (t.whitedownpointingtriangle = 9661),
            (t.whiteleftpointingsmalltriangle = 9667),
            (t.whiteleftpointingtriangle = 9665),
            (t.whitelenticularbracketleft = 12310),
            (t.whitelenticularbracketright = 12311),
            (t.whiterightpointingsmalltriangle = 9657);
          (t.whiterightpointingtriangle = 9655),
            (t.whitesmallsquare = 9643),
            (t.whitesmilingface = 9786),
            (t.whitesquare = 9633),
            (t.whitestar = 9734),
            (t.whitetelephone = 9743),
            (t.whitetortoiseshellbracketleft = 12312),
            (t.whitetortoiseshellbracketright = 12313),
            (t.whiteuppointingsmalltriangle = 9653),
            (t.whiteuppointingtriangle = 9651),
            (t.wihiragana = 12432),
            (t.wikatakana = 12528),
            (t.wikorean = 12639),
            (t.wmonospace = 65367),
            (t.wohiragana = 12434),
            (t.wokatakana = 12530),
            (t.wokatakanahalfwidth = 65382),
            (t.won = 8361),
            (t.wonmonospace = 65510),
            (t.wowaenthai = 3623),
            (t.wparen = 9394),
            (t.wring = 7832),
            (t.wsuperior = 695),
            (t.wturned = 653),
            (t.wynn = 447),
            (t.x = 120),
            (t.xabovecmb = 829),
            (t.xbopomofo = 12562),
            (t.xcircle = 9447),
            (t.xdieresis = 7821),
            (t.xdotaccent = 7819),
            (t.xeharmenian = 1389),
            (t.xi = 958),
            (t.xmonospace = 65368),
            (t.xparen = 9395),
            (t.xsuperior = 739),
            (t.y = 121),
            (t.yaadosquare = 13134),
            (t.yabengali = 2479),
            (t.yacute = 253),
            (t.yadeva = 2351),
            (t.yaekorean = 12626),
            (t.yagujarati = 2735),
            (t.yagurmukhi = 2607),
            (t.yahiragana = 12420),
            (t.yakatakana = 12516),
            (t.yakatakanahalfwidth = 65428),
            (t.yakorean = 12625),
            (t.yamakkanthai = 3662),
            (t.yasmallhiragana = 12419),
            (t.yasmallkatakana = 12515),
            (t.yasmallkatakanahalfwidth = 65388),
            (t.yatcyrillic = 1123),
            (t.ycircle = 9448),
            (t.ycircumflex = 375),
            (t.ydieresis = 255),
            (t.ydotaccent = 7823),
            (t.ydotbelow = 7925),
            (t.yeharabic = 1610),
            (t.yehbarreearabic = 1746),
            (t.yehbarreefinalarabic = 64431),
            (t.yehfinalarabic = 65266),
            (t.yehhamzaabovearabic = 1574),
            (t.yehhamzaabovefinalarabic = 65162),
            (t.yehhamzaaboveinitialarabic = 65163),
            (t.yehhamzaabovemedialarabic = 65164),
            (t.yehinitialarabic = 65267),
            (t.yehmedialarabic = 65268),
            (t.yehmeeminitialarabic = 64733),
            (t.yehmeemisolatedarabic = 64600),
            (t.yehnoonfinalarabic = 64660),
            (t.yehthreedotsbelowarabic = 1745),
            (t.yekorean = 12630),
            (t.yen = 165),
            (t.yenmonospace = 65509),
            (t.yeokorean = 12629),
            (t.yeorinhieuhkorean = 12678),
            (t.yerahbenyomohebrew = 1450),
            (t.yerahbenyomolefthebrew = 1450),
            (t.yericyrillic = 1099),
            (t.yerudieresiscyrillic = 1273),
            (t.yesieungkorean = 12673),
            (t.yesieungpansioskorean = 12675),
            (t.yesieungsioskorean = 12674),
            (t.yetivhebrew = 1434),
            (t.ygrave = 7923),
            (t.yhook = 436),
            (t.yhookabove = 7927),
            (t.yiarmenian = 1397),
            (t.yicyrillic = 1111),
            (t.yikorean = 12642),
            (t.yinyang = 9775),
            (t.yiwnarmenian = 1410),
            (t.ymonospace = 65369),
            (t.yod = 1497),
            (t.yoddagesh = 64313),
            (t.yoddageshhebrew = 64313),
            (t.yodhebrew = 1497),
            (t.yodyodhebrew = 1522),
            (t.yodyodpatahhebrew = 64287),
            (t.yohiragana = 12424),
            (t.yoikorean = 12681),
            (t.yokatakana = 12520),
            (t.yokatakanahalfwidth = 65430),
            (t.yokorean = 12635),
            (t.yosmallhiragana = 12423),
            (t.yosmallkatakana = 12519),
            (t.yosmallkatakanahalfwidth = 65390),
            (t.yotgreek = 1011),
            (t.yoyaekorean = 12680),
            (t.yoyakorean = 12679),
            (t.yoyakthai = 3618),
            (t.yoyingthai = 3597),
            (t.yparen = 9396),
            (t.ypogegrammeni = 890),
            (t.ypogegrammenigreekcmb = 837),
            (t.yr = 422),
            (t.yring = 7833),
            (t.ysuperior = 696),
            (t.ytilde = 7929),
            (t.yturned = 654),
            (t.yuhiragana = 12422),
            (t.yuikorean = 12684),
            (t.yukatakana = 12518),
            (t.yukatakanahalfwidth = 65429),
            (t.yukorean = 12640),
            (t.yusbigcyrillic = 1131),
            (t.yusbigiotifiedcyrillic = 1133),
            (t.yuslittlecyrillic = 1127),
            (t.yuslittleiotifiedcyrillic = 1129),
            (t.yusmallhiragana = 12421),
            (t.yusmallkatakana = 12517),
            (t.yusmallkatakanahalfwidth = 65389),
            (t.yuyekorean = 12683),
            (t.yuyeokorean = 12682),
            (t.yyabengali = 2527),
            (t.yyadeva = 2399),
            (t.z = 122),
            (t.zaarmenian = 1382),
            (t.zacute = 378),
            (t.zadeva = 2395),
            (t.zagurmukhi = 2651),
            (t.zaharabic = 1592),
            (t.zahfinalarabic = 65222),
            (t.zahinitialarabic = 65223),
            (t.zahiragana = 12374),
            (t.zahmedialarabic = 65224),
            (t.zainarabic = 1586),
            (t.zainfinalarabic = 65200),
            (t.zakatakana = 12470),
            (t.zaqefgadolhebrew = 1429),
            (t.zaqefqatanhebrew = 1428),
            (t.zarqahebrew = 1432),
            (t.zayin = 1494),
            (t.zayindagesh = 64310),
            (t.zayindageshhebrew = 64310),
            (t.zayinhebrew = 1494),
            (t.zbopomofo = 12567),
            (t.zcaron = 382),
            (t.zcircle = 9449),
            (t.zcircumflex = 7825),
            (t.zcurl = 657),
            (t.zdot = 380),
            (t.zdotaccent = 380),
            (t.zdotbelow = 7827),
            (t.zecyrillic = 1079),
            (t.zedescendercyrillic = 1177),
            (t.zedieresiscyrillic = 1247),
            (t.zehiragana = 12380),
            (t.zekatakana = 12476),
            (t.zero = 48),
            (t.zeroarabic = 1632),
            (t.zerobengali = 2534),
            (t.zerodeva = 2406),
            (t.zerogujarati = 2790),
            (t.zerogurmukhi = 2662),
            (t.zerohackarabic = 1632),
            (t.zeroinferior = 8320),
            (t.zeromonospace = 65296),
            (t.zerooldstyle = 63280),
            (t.zeropersian = 1776),
            (t.zerosuperior = 8304),
            (t.zerothai = 3664),
            (t.zerowidthjoiner = 65279),
            (t.zerowidthnonjoiner = 8204),
            (t.zerowidthspace = 8203),
            (t.zeta = 950),
            (t.zhbopomofo = 12563),
            (t.zhearmenian = 1386),
            (t.zhebrevecyrillic = 1218),
            (t.zhecyrillic = 1078),
            (t.zhedescendercyrillic = 1175),
            (t.zhedieresiscyrillic = 1245),
            (t.zihiragana = 12376),
            (t.zikatakana = 12472),
            (t.zinorhebrew = 1454),
            (t.zlinebelow = 7829),
            (t.zmonospace = 65370),
            (t.zohiragana = 12382),
            (t.zokatakana = 12478),
            (t.zparen = 9397),
            (t.zretroflexhook = 656),
            (t.zstroke = 438),
            (t.zuhiragana = 12378),
            (t.zukatakana = 12474),
            (t[".notdef"] = 0),
            (t.angbracketleftbig = 9001),
            (t.angbracketleftBig = 9001),
            (t.angbracketleftbigg = 9001),
            (t.angbracketleftBigg = 9001),
            (t.angbracketrightBig = 9002),
            (t.angbracketrightbig = 9002),
            (t.angbracketrightBigg = 9002),
            (t.angbracketrightbigg = 9002),
            (t.arrowhookleft = 8618),
            (t.arrowhookright = 8617),
            (t.arrowlefttophalf = 8636),
            (t.arrowleftbothalf = 8637),
            (t.arrownortheast = 8599),
            (t.arrownorthwest = 8598),
            (t.arrowrighttophalf = 8640),
            (t.arrowrightbothalf = 8641),
            (t.arrowsoutheast = 8600),
            (t.arrowsouthwest = 8601),
            (t.backslashbig = 8726),
            (t.backslashBig = 8726),
            (t.backslashBigg = 8726),
            (t.backslashbigg = 8726),
            (t.bardbl = 8214),
            (t.bracehtipdownleft = 65079),
            (t.bracehtipdownright = 65079),
            (t.bracehtipupleft = 65080),
            (t.bracehtipupright = 65080),
            (t.braceleftBig = 123),
            (t.braceleftbig = 123),
            (t.braceleftbigg = 123),
            (t.braceleftBigg = 123),
            (t.bracerightBig = 125),
            (t.bracerightbig = 125),
            (t.bracerightbigg = 125),
            (t.bracerightBigg = 125),
            (t.bracketleftbig = 91),
            (t.bracketleftBig = 91),
            (t.bracketleftbigg = 91),
            (t.bracketleftBigg = 91),
            (t.bracketrightBig = 93),
            (t.bracketrightbig = 93),
            (t.bracketrightbigg = 93),
            (t.bracketrightBigg = 93),
            (t.ceilingleftbig = 8968),
            (t.ceilingleftBig = 8968),
            (t.ceilingleftBigg = 8968),
            (t.ceilingleftbigg = 8968),
            (t.ceilingrightbig = 8969),
            (t.ceilingrightBig = 8969),
            (t.ceilingrightbigg = 8969),
            (t.ceilingrightBigg = 8969),
            (t.circledotdisplay = 8857),
            (t.circledottext = 8857),
            (t.circlemultiplydisplay = 8855),
            (t.circlemultiplytext = 8855),
            (t.circleplusdisplay = 8853),
            (t.circleplustext = 8853),
            (t.contintegraldisplay = 8750),
            (t.contintegraltext = 8750),
            (t.coproductdisplay = 8720),
            (t.coproducttext = 8720),
            (t.floorleftBig = 8970),
            (t.floorleftbig = 8970),
            (t.floorleftbigg = 8970),
            (t.floorleftBigg = 8970),
            (t.floorrightbig = 8971),
            (t.floorrightBig = 8971),
            (t.floorrightBigg = 8971),
            (t.floorrightbigg = 8971),
            (t.hatwide = 770),
            (t.hatwider = 770),
            (t.hatwidest = 770),
            (t.intercal = 7488),
            (t.integraldisplay = 8747),
            (t.integraltext = 8747),
            (t.intersectiondisplay = 8898),
            (t.intersectiontext = 8898),
            (t.logicalanddisplay = 8743),
            (t.logicalandtext = 8743),
            (t.logicalordisplay = 8744),
            (t.logicalortext = 8744),
            (t.parenleftBig = 40),
            (t.parenleftbig = 40),
            (t.parenleftBigg = 40),
            (t.parenleftbigg = 40),
            (t.parenrightBig = 41),
            (t.parenrightbig = 41),
            (t.parenrightBigg = 41),
            (t.parenrightbigg = 41),
            (t.prime = 8242),
            (t.productdisplay = 8719),
            (t.producttext = 8719),
            (t.radicalbig = 8730),
            (t.radicalBig = 8730),
            (t.radicalBigg = 8730),
            (t.radicalbigg = 8730),
            (t.radicalbt = 8730),
            (t.radicaltp = 8730),
            (t.radicalvertex = 8730),
            (t.slashbig = 47),
            (t.slashBig = 47),
            (t.slashBigg = 47),
            (t.slashbigg = 47),
            (t.summationdisplay = 8721),
            (t.summationtext = 8721),
            (t.tildewide = 732),
            (t.tildewider = 732),
            (t.tildewidest = 732),
            (t.uniondisplay = 8899),
            (t.unionmultidisplay = 8846),
            (t.unionmultitext = 8846),
            (t.unionsqdisplay = 8852),
            (t.unionsqtext = 8852),
            (t.uniontext = 8899),
            (t.vextenddouble = 8741),
            (t.vextendsingle = 8739);
        }),
        l = i(function (t) {
          (t.space = 32),
            (t.a1 = 9985),
            (t.a2 = 9986),
            (t.a202 = 9987),
            (t.a3 = 9988),
            (t.a4 = 9742),
            (t.a5 = 9990),
            (t.a119 = 9991),
            (t.a118 = 9992),
            (t.a117 = 9993),
            (t.a11 = 9755),
            (t.a12 = 9758),
            (t.a13 = 9996),
            (t.a14 = 9997),
            (t.a15 = 9998),
            (t.a16 = 9999),
            (t.a105 = 1e4),
            (t.a17 = 10001),
            (t.a18 = 10002),
            (t.a19 = 10003),
            (t.a20 = 10004),
            (t.a21 = 10005),
            (t.a22 = 10006),
            (t.a23 = 10007),
            (t.a24 = 10008),
            (t.a25 = 10009),
            (t.a26 = 10010),
            (t.a27 = 10011),
            (t.a28 = 10012),
            (t.a6 = 10013),
            (t.a7 = 10014),
            (t.a8 = 10015),
            (t.a9 = 10016),
            (t.a10 = 10017),
            (t.a29 = 10018),
            (t.a30 = 10019),
            (t.a31 = 10020),
            (t.a32 = 10021),
            (t.a33 = 10022),
            (t.a34 = 10023),
            (t.a35 = 9733),
            (t.a36 = 10025),
            (t.a37 = 10026),
            (t.a38 = 10027),
            (t.a39 = 10028),
            (t.a40 = 10029),
            (t.a41 = 10030),
            (t.a42 = 10031),
            (t.a43 = 10032),
            (t.a44 = 10033),
            (t.a45 = 10034),
            (t.a46 = 10035),
            (t.a47 = 10036),
            (t.a48 = 10037),
            (t.a49 = 10038),
            (t.a50 = 10039),
            (t.a51 = 10040),
            (t.a52 = 10041),
            (t.a53 = 10042),
            (t.a54 = 10043),
            (t.a55 = 10044),
            (t.a56 = 10045),
            (t.a57 = 10046),
            (t.a58 = 10047),
            (t.a59 = 10048),
            (t.a60 = 10049),
            (t.a61 = 10050),
            (t.a62 = 10051),
            (t.a63 = 10052),
            (t.a64 = 10053),
            (t.a65 = 10054),
            (t.a66 = 10055),
            (t.a67 = 10056),
            (t.a68 = 10057),
            (t.a69 = 10058),
            (t.a70 = 10059),
            (t.a71 = 9679),
            (t.a72 = 10061),
            (t.a73 = 9632),
            (t.a74 = 10063),
            (t.a203 = 10064),
            (t.a75 = 10065),
            (t.a204 = 10066),
            (t.a76 = 9650),
            (t.a77 = 9660),
            (t.a78 = 9670),
            (t.a79 = 10070),
            (t.a81 = 9687),
            (t.a82 = 10072),
            (t.a83 = 10073),
            (t.a84 = 10074),
            (t.a97 = 10075),
            (t.a98 = 10076),
            (t.a99 = 10077),
            (t.a100 = 10078),
            (t.a101 = 10081),
            (t.a102 = 10082),
            (t.a103 = 10083),
            (t.a104 = 10084),
            (t.a106 = 10085),
            (t.a107 = 10086),
            (t.a108 = 10087),
            (t.a112 = 9827),
            (t.a111 = 9830),
            (t.a110 = 9829),
            (t.a109 = 9824),
            (t.a120 = 9312),
            (t.a121 = 9313),
            (t.a122 = 9314),
            (t.a123 = 9315),
            (t.a124 = 9316),
            (t.a125 = 9317),
            (t.a126 = 9318),
            (t.a127 = 9319),
            (t.a128 = 9320),
            (t.a129 = 9321),
            (t.a130 = 10102),
            (t.a131 = 10103),
            (t.a132 = 10104),
            (t.a133 = 10105),
            (t.a134 = 10106),
            (t.a135 = 10107),
            (t.a136 = 10108),
            (t.a137 = 10109),
            (t.a138 = 10110),
            (t.a139 = 10111),
            (t.a140 = 10112),
            (t.a141 = 10113),
            (t.a142 = 10114),
            (t.a143 = 10115),
            (t.a144 = 10116),
            (t.a145 = 10117),
            (t.a146 = 10118),
            (t.a147 = 10119),
            (t.a148 = 10120),
            (t.a149 = 10121),
            (t.a150 = 10122),
            (t.a151 = 10123),
            (t.a152 = 10124),
            (t.a153 = 10125),
            (t.a154 = 10126),
            (t.a155 = 10127),
            (t.a156 = 10128),
            (t.a157 = 10129),
            (t.a158 = 10130),
            (t.a159 = 10131),
            (t.a160 = 10132),
            (t.a161 = 8594),
            (t.a163 = 8596),
            (t.a164 = 8597),
            (t.a196 = 10136),
            (t.a165 = 10137),
            (t.a192 = 10138),
            (t.a166 = 10139),
            (t.a167 = 10140),
            (t.a168 = 10141),
            (t.a169 = 10142),
            (t.a170 = 10143),
            (t.a171 = 10144),
            (t.a172 = 10145),
            (t.a173 = 10146),
            (t.a162 = 10147),
            (t.a174 = 10148),
            (t.a175 = 10149),
            (t.a176 = 10150),
            (t.a177 = 10151),
            (t.a178 = 10152),
            (t.a179 = 10153),
            (t.a193 = 10154),
            (t.a180 = 10155),
            (t.a199 = 10156),
            (t.a181 = 10157),
            (t.a200 = 10158),
            (t.a182 = 10159),
            (t.a201 = 10161),
            (t.a183 = 10162),
            (t.a184 = 10163),
            (t.a197 = 10164),
            (t.a185 = 10165),
            (t.a194 = 10166),
            (t.a198 = 10167),
            (t.a186 = 10168),
            (t.a195 = 10169),
            (t.a187 = 10170),
            (t.a188 = 10171),
            (t.a189 = 10172),
            (t.a190 = 10173),
            (t.a191 = 10174),
            (t.a89 = 10088),
            (t.a90 = 10089),
            (t.a93 = 10090),
            (t.a94 = 10091),
            (t.a91 = 10092),
            (t.a92 = 10093),
            (t.a205 = 10094),
            (t.a85 = 10095),
            (t.a206 = 10096),
            (t.a86 = 10097),
            (t.a87 = 10098),
            (t.a88 = 10099),
            (t.a95 = 10100),
            (t.a96 = 10101),
            (t[".notdef"] = 0);
        });
      (r.getGlyphsUnicode = o), (r.getDingbatsGlyphsUnicode = l);
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.getSupplementalGlyphMapForCalibri =
          r.getSupplementalGlyphMapForArialBlack =
          r.getGlyphMapForStandardFonts =
          r.getSymbolsFonts =
          r.getSerifFonts =
          r.getNonStdFontMap =
          r.getStdFontMap =
            void 0);
      var i = a(201),
        o = (0, i.getLookupTableFactory)(function (t) {
          (t.ArialNarrow = "Helvetica"),
            (t["ArialNarrow-Bold"] = "Helvetica-Bold"),
            (t["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique"),
            (t["ArialNarrow-Italic"] = "Helvetica-Oblique"),
            (t.ArialBlack = "Helvetica"),
            (t["ArialBlack-Bold"] = "Helvetica-Bold"),
            (t["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique"),
            (t["ArialBlack-Italic"] = "Helvetica-Oblique"),
            (t["Arial-Black"] = "Helvetica"),
            (t["Arial-Black-Bold"] = "Helvetica-Bold"),
            (t["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique"),
            (t["Arial-Black-Italic"] = "Helvetica-Oblique"),
            (t.Arial = "Helvetica"),
            (t["Arial-Bold"] = "Helvetica-Bold"),
            (t["Arial-BoldItalic"] = "Helvetica-BoldOblique"),
            (t["Arial-Italic"] = "Helvetica-Oblique"),
            (t["Arial-BoldItalicMT"] = "Helvetica-BoldOblique"),
            (t["Arial-BoldMT"] = "Helvetica-Bold"),
            (t["Arial-ItalicMT"] = "Helvetica-Oblique"),
            (t.ArialMT = "Helvetica"),
            (t["Courier-Bold"] = "Courier-Bold"),
            (t["Courier-BoldItalic"] = "Courier-BoldOblique"),
            (t["Courier-Italic"] = "Courier-Oblique"),
            (t.CourierNew = "Courier"),
            (t["CourierNew-Bold"] = "Courier-Bold"),
            (t["CourierNew-BoldItalic"] = "Courier-BoldOblique"),
            (t["CourierNew-Italic"] = "Courier-Oblique"),
            (t["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique"),
            (t["CourierNewPS-BoldMT"] = "Courier-Bold"),
            (t["CourierNewPS-ItalicMT"] = "Courier-Oblique"),
            (t.CourierNewPSMT = "Courier"),
            (t.Helvetica = "Helvetica"),
            (t["Helvetica-Bold"] = "Helvetica-Bold"),
            (t["Helvetica-BoldItalic"] = "Helvetica-BoldOblique"),
            (t["Helvetica-BoldOblique"] = "Helvetica-BoldOblique"),
            (t["Helvetica-Italic"] = "Helvetica-Oblique"),
            (t["Helvetica-Oblique"] = "Helvetica-Oblique"),
            (t["Symbol-Bold"] = "Symbol"),
            (t["Symbol-BoldItalic"] = "Symbol"),
            (t["Symbol-Italic"] = "Symbol"),
            (t.TimesNewRoman = "Times-Roman"),
            (t["TimesNewRoman-Bold"] = "Times-Bold"),
            (t["TimesNewRoman-BoldItalic"] = "Times-BoldItalic"),
            (t["TimesNewRoman-Italic"] = "Times-Italic"),
            (t.TimesNewRomanPS = "Times-Roman"),
            (t["TimesNewRomanPS-Bold"] = "Times-Bold"),
            (t["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic"),
            (t["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic"),
            (t["TimesNewRomanPS-BoldMT"] = "Times-Bold"),
            (t["TimesNewRomanPS-Italic"] = "Times-Italic"),
            (t["TimesNewRomanPS-ItalicMT"] = "Times-Italic"),
            (t.TimesNewRomanPSMT = "Times-Roman"),
            (t["TimesNewRomanPSMT-Bold"] = "Times-Bold"),
            (t["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic"),
            (t["TimesNewRomanPSMT-Italic"] = "Times-Italic");
        });
      r.getStdFontMap = o;
      var l = (0, i.getLookupTableFactory)(function (t) {
        (t.Calibri = "Helvetica"),
          (t["Calibri-Bold"] = "Helvetica-Bold"),
          (t["Calibri-BoldItalic"] = "Helvetica-BoldOblique"),
          (t["Calibri-Italic"] = "Helvetica-Oblique"),
          (t.CenturyGothic = "Helvetica"),
          (t["CenturyGothic-Bold"] = "Helvetica-Bold"),
          (t["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique"),
          (t["CenturyGothic-Italic"] = "Helvetica-Oblique"),
          (t.ComicSansMS = "Comic Sans MS"),
          (t["ComicSansMS-Bold"] = "Comic Sans MS-Bold"),
          (t["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic"),
          (t["ComicSansMS-Italic"] = "Comic Sans MS-Italic"),
          (t.LucidaConsole = "Courier"),
          (t["LucidaConsole-Bold"] = "Courier-Bold"),
          (t["LucidaConsole-BoldItalic"] = "Courier-BoldOblique"),
          (t["LucidaConsole-Italic"] = "Courier-Oblique"),
          (t["LucidaSans-Demi"] = "Helvetica-Bold"),
          (t["MS-Gothic"] = "MS Gothic"),
          (t["MS-Gothic-Bold"] = "MS Gothic-Bold"),
          (t["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic"),
          (t["MS-Gothic-Italic"] = "MS Gothic-Italic"),
          (t["MS-Mincho"] = "MS Mincho"),
          (t["MS-Mincho-Bold"] = "MS Mincho-Bold"),
          (t["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic"),
          (t["MS-Mincho-Italic"] = "MS Mincho-Italic"),
          (t["MS-PGothic"] = "MS PGothic"),
          (t["MS-PGothic-Bold"] = "MS PGothic-Bold"),
          (t["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic"),
          (t["MS-PGothic-Italic"] = "MS PGothic-Italic"),
          (t["MS-PMincho"] = "MS PMincho"),
          (t["MS-PMincho-Bold"] = "MS PMincho-Bold"),
          (t["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic"),
          (t["MS-PMincho-Italic"] = "MS PMincho-Italic"),
          (t.NuptialScript = "Times-Italic"),
          (t.SegoeUISymbol = "Helvetica"),
          (t.Wingdings = "ZapfDingbats"),
          (t["Wingdings-Regular"] = "ZapfDingbats");
      });
      r.getNonStdFontMap = l;
      var c = (0, i.getLookupTableFactory)(function (t) {
        (t["Adobe Jenson"] = !0),
          (t["Adobe Text"] = !0),
          (t.Albertus = !0),
          (t.Aldus = !0),
          (t.Alexandria = !0),
          (t.Algerian = !0),
          (t["American Typewriter"] = !0),
          (t.Antiqua = !0),
          (t.Apex = !0),
          (t.Arno = !0),
          (t.Aster = !0),
          (t.Aurora = !0),
          (t.Baskerville = !0),
          (t.Bell = !0),
          (t.Bembo = !0),
          (t["Bembo Schoolbook"] = !0),
          (t.Benguiat = !0),
          (t["Berkeley Old Style"] = !0),
          (t["Bernhard Modern"] = !0),
          (t["Berthold City"] = !0),
          (t.Bodoni = !0),
          (t["Bauer Bodoni"] = !0),
          (t["Book Antiqua"] = !0),
          (t.Bookman = !0),
          (t["Bordeaux Roman"] = !0),
          (t["Californian FB"] = !0),
          (t.Calisto = !0),
          (t.Calvert = !0),
          (t.Capitals = !0),
          (t.Cambria = !0),
          (t.Cartier = !0),
          (t.Caslon = !0),
          (t.Catull = !0),
          (t.Centaur = !0),
          (t["Century Old Style"] = !0),
          (t["Century Schoolbook"] = !0),
          (t.Chaparral = !0),
          (t["Charis SIL"] = !0),
          (t.Cheltenham = !0),
          (t["Cholla Slab"] = !0),
          (t.Clarendon = !0),
          (t.Clearface = !0),
          (t.Cochin = !0),
          (t.Colonna = !0),
          (t["Computer Modern"] = !0),
          (t["Concrete Roman"] = !0),
          (t.Constantia = !0),
          (t["Cooper Black"] = !0),
          (t.Corona = !0),
          (t.Ecotype = !0),
          (t.Egyptienne = !0),
          (t.Elephant = !0),
          (t.Excelsior = !0),
          (t.Fairfield = !0),
          (t["FF Scala"] = !0),
          (t.Folkard = !0),
          (t.Footlight = !0),
          (t.FreeSerif = !0),
          (t["Friz Quadrata"] = !0),
          (t.Garamond = !0),
          (t.Gentium = !0),
          (t.Georgia = !0),
          (t.Gloucester = !0),
          (t["Goudy Old Style"] = !0),
          (t["Goudy Schoolbook"] = !0),
          (t["Goudy Pro Font"] = !0),
          (t.Granjon = !0),
          (t["Guardian Egyptian"] = !0),
          (t.Heather = !0),
          (t.Hercules = !0),
          (t["High Tower Text"] = !0),
          (t.Hiroshige = !0),
          (t["Hoefler Text"] = !0),
          (t["Humana Serif"] = !0),
          (t.Imprint = !0),
          (t["Ionic No. 5"] = !0),
          (t.Janson = !0),
          (t.Joanna = !0),
          (t.Korinna = !0),
          (t.Lexicon = !0),
          (t["Liberation Serif"] = !0),
          (t["Linux Libertine"] = !0),
          (t.Literaturnaya = !0),
          (t.Lucida = !0),
          (t["Lucida Bright"] = !0),
          (t.Melior = !0),
          (t.Memphis = !0),
          (t.Miller = !0),
          (t.Minion = !0),
          (t.Modern = !0),
          (t["Mona Lisa"] = !0),
          (t["Mrs Eaves"] = !0),
          (t["MS Serif"] = !0),
          (t["Museo Slab"] = !0),
          (t["New York"] = !0),
          (t["Nimbus Roman"] = !0),
          (t["NPS Rawlinson Roadway"] = !0),
          (t.NuptialScript = !0),
          (t.Palatino = !0),
          (t.Perpetua = !0),
          (t.Plantin = !0),
          (t["Plantin Schoolbook"] = !0),
          (t.Playbill = !0),
          (t["Poor Richard"] = !0),
          (t["Rawlinson Roadway"] = !0),
          (t.Renault = !0),
          (t.Requiem = !0),
          (t.Rockwell = !0),
          (t.Roman = !0),
          (t["Rotis Serif"] = !0),
          (t.Sabon = !0),
          (t.Scala = !0),
          (t.Seagull = !0),
          (t.Sistina = !0),
          (t.Souvenir = !0),
          (t.STIX = !0),
          (t["Stone Informal"] = !0),
          (t["Stone Serif"] = !0),
          (t.Sylfaen = !0),
          (t.Times = !0),
          (t.Trajan = !0),
          (t["Trinité"] = !0),
          (t["Trump Mediaeval"] = !0),
          (t.Utopia = !0),
          (t["Vale Type"] = !0),
          (t["Bitstream Vera"] = !0),
          (t["Vera Serif"] = !0),
          (t.Versailles = !0),
          (t.Wanted = !0),
          (t.Weiss = !0),
          (t["Wide Latin"] = !0),
          (t.Windsor = !0),
          (t.XITS = !0);
      });
      r.getSerifFonts = c;
      var u = (0, i.getLookupTableFactory)(function (t) {
        (t.Dingbats = !0), (t.Symbol = !0), (t.ZapfDingbats = !0);
      });
      r.getSymbolsFonts = u;
      var h = (0, i.getLookupTableFactory)(function (t) {
        (t[2] = 10),
          (t[3] = 32),
          (t[4] = 33),
          (t[5] = 34),
          (t[6] = 35),
          (t[7] = 36),
          (t[8] = 37),
          (t[9] = 38),
          (t[10] = 39),
          (t[11] = 40),
          (t[12] = 41),
          (t[13] = 42),
          (t[14] = 43),
          (t[15] = 44),
          (t[16] = 45),
          (t[17] = 46),
          (t[18] = 47),
          (t[19] = 48),
          (t[20] = 49),
          (t[21] = 50),
          (t[22] = 51),
          (t[23] = 52),
          (t[24] = 53),
          (t[25] = 54),
          (t[26] = 55),
          (t[27] = 56),
          (t[28] = 57),
          (t[29] = 58),
          (t[30] = 894),
          (t[31] = 60),
          (t[32] = 61),
          (t[33] = 62),
          (t[34] = 63),
          (t[35] = 64),
          (t[36] = 65),
          (t[37] = 66),
          (t[38] = 67),
          (t[39] = 68),
          (t[40] = 69),
          (t[41] = 70),
          (t[42] = 71),
          (t[43] = 72),
          (t[44] = 73),
          (t[45] = 74),
          (t[46] = 75),
          (t[47] = 76),
          (t[48] = 77),
          (t[49] = 78),
          (t[50] = 79),
          (t[51] = 80),
          (t[52] = 81),
          (t[53] = 82),
          (t[54] = 83),
          (t[55] = 84),
          (t[56] = 85),
          (t[57] = 86),
          (t[58] = 87),
          (t[59] = 88),
          (t[60] = 89),
          (t[61] = 90),
          (t[62] = 91),
          (t[63] = 92),
          (t[64] = 93),
          (t[65] = 94),
          (t[66] = 95),
          (t[67] = 96),
          (t[68] = 97),
          (t[69] = 98),
          (t[70] = 99),
          (t[71] = 100),
          (t[72] = 101),
          (t[73] = 102),
          (t[74] = 103),
          (t[75] = 104),
          (t[76] = 105),
          (t[77] = 106),
          (t[78] = 107),
          (t[79] = 108),
          (t[80] = 109),
          (t[81] = 110),
          (t[82] = 111),
          (t[83] = 112),
          (t[84] = 113),
          (t[85] = 114),
          (t[86] = 115),
          (t[87] = 116),
          (t[88] = 117),
          (t[89] = 118),
          (t[90] = 119),
          (t[91] = 120),
          (t[92] = 121),
          (t[93] = 122),
          (t[94] = 123),
          (t[95] = 124),
          (t[96] = 125),
          (t[97] = 126),
          (t[98] = 196),
          (t[99] = 197),
          (t[100] = 199),
          (t[101] = 201),
          (t[102] = 209),
          (t[103] = 214),
          (t[104] = 220),
          (t[105] = 225),
          (t[106] = 224),
          (t[107] = 226),
          (t[108] = 228),
          (t[109] = 227),
          (t[110] = 229),
          (t[111] = 231),
          (t[112] = 233),
          (t[113] = 232),
          (t[114] = 234),
          (t[115] = 235),
          (t[116] = 237),
          (t[117] = 236),
          (t[118] = 238),
          (t[119] = 239),
          (t[120] = 241),
          (t[121] = 243),
          (t[122] = 242),
          (t[123] = 244),
          (t[124] = 246),
          (t[125] = 245),
          (t[126] = 250),
          (t[127] = 249),
          (t[128] = 251),
          (t[129] = 252),
          (t[130] = 8224),
          (t[131] = 176),
          (t[132] = 162),
          (t[133] = 163),
          (t[134] = 167),
          (t[135] = 8226),
          (t[136] = 182),
          (t[137] = 223),
          (t[138] = 174),
          (t[139] = 169),
          (t[140] = 8482),
          (t[141] = 180),
          (t[142] = 168),
          (t[143] = 8800),
          (t[144] = 198),
          (t[145] = 216),
          (t[146] = 8734),
          (t[147] = 177),
          (t[148] = 8804),
          (t[149] = 8805),
          (t[150] = 165),
          (t[151] = 181),
          (t[152] = 8706),
          (t[153] = 8721),
          (t[154] = 8719),
          (t[156] = 8747),
          (t[157] = 170),
          (t[158] = 186),
          (t[159] = 8486),
          (t[160] = 230),
          (t[161] = 248),
          (t[162] = 191),
          (t[163] = 161),
          (t[164] = 172),
          (t[165] = 8730),
          (t[166] = 402),
          (t[167] = 8776),
          (t[168] = 8710),
          (t[169] = 171),
          (t[170] = 187),
          (t[171] = 8230),
          (t[210] = 218),
          (t[223] = 711),
          (t[224] = 321),
          (t[225] = 322),
          (t[227] = 353),
          (t[229] = 382),
          (t[234] = 253),
          (t[252] = 263),
          (t[253] = 268),
          (t[254] = 269),
          (t[258] = 258),
          (t[260] = 260),
          (t[261] = 261),
          (t[265] = 280),
          (t[266] = 281),
          (t[268] = 283),
          (t[269] = 313),
          (t[275] = 323),
          (t[276] = 324),
          (t[278] = 328),
          (t[284] = 345),
          (t[285] = 346),
          (t[286] = 347),
          (t[292] = 367),
          (t[295] = 377),
          (t[296] = 378),
          (t[298] = 380),
          (t[305] = 963),
          (t[306] = 964),
          (t[307] = 966),
          (t[308] = 8215),
          (t[309] = 8252),
          (t[310] = 8319),
          (t[311] = 8359),
          (t[312] = 8592),
          (t[313] = 8593),
          (t[337] = 9552),
          (t[493] = 1039),
          (t[494] = 1040),
          (t[705] = 1524),
          (t[706] = 8362),
          (t[710] = 64288),
          (t[711] = 64298),
          (t[759] = 1617),
          (t[761] = 1776),
          (t[763] = 1778),
          (t[775] = 1652),
          (t[777] = 1764),
          (t[778] = 1780),
          (t[779] = 1781),
          (t[780] = 1782),
          (t[782] = 771),
          (t[783] = 64726),
          (t[786] = 8363),
          (t[788] = 8532),
          (t[790] = 768),
          (t[791] = 769),
          (t[792] = 768),
          (t[795] = 803),
          (t[797] = 64336),
          (t[798] = 64337),
          (t[799] = 64342),
          (t[800] = 64343),
          (t[801] = 64344),
          (t[802] = 64345),
          (t[803] = 64362),
          (t[804] = 64363),
          (t[805] = 64364),
          (t[2424] = 7821),
          (t[2425] = 7822),
          (t[2426] = 7823),
          (t[2427] = 7824),
          (t[2428] = 7825),
          (t[2429] = 7826),
          (t[2430] = 7827),
          (t[2433] = 7682),
          (t[2678] = 8045),
          (t[2679] = 8046),
          (t[2830] = 1552),
          (t[2838] = 686),
          (t[2840] = 751),
          (t[2842] = 753),
          (t[2843] = 754),
          (t[2844] = 755),
          (t[2846] = 757),
          (t[2856] = 767),
          (t[2857] = 848),
          (t[2858] = 849),
          (t[2862] = 853),
          (t[2863] = 854),
          (t[2864] = 855),
          (t[2865] = 861),
          (t[2866] = 862),
          (t[2906] = 7460),
          (t[2908] = 7462),
          (t[2909] = 7463),
          (t[2910] = 7464),
          (t[2912] = 7466),
          (t[2913] = 7467),
          (t[2914] = 7468),
          (t[2916] = 7470),
          (t[2917] = 7471),
          (t[2918] = 7472),
          (t[2920] = 7474),
          (t[2921] = 7475),
          (t[2922] = 7476),
          (t[2924] = 7478),
          (t[2925] = 7479),
          (t[2926] = 7480),
          (t[2928] = 7482),
          (t[2929] = 7483),
          (t[2930] = 7484),
          (t[2932] = 7486),
          (t[2933] = 7487),
          (t[2934] = 7488),
          (t[2936] = 7490),
          (t[2937] = 7491),
          (t[2938] = 7492),
          (t[2940] = 7494),
          (t[2941] = 7495),
          (t[2942] = 7496),
          (t[2944] = 7498),
          (t[2946] = 7500),
          (t[2948] = 7502),
          (t[2950] = 7504),
          (t[2951] = 7505),
          (t[2952] = 7506),
          (t[2954] = 7508),
          (t[2955] = 7509),
          (t[2956] = 7510),
          (t[2958] = 7512),
          (t[2959] = 7513),
          (t[2960] = 7514),
          (t[2962] = 7516),
          (t[2963] = 7517),
          (t[2964] = 7518),
          (t[2966] = 7520),
          (t[2967] = 7521),
          (t[2968] = 7522),
          (t[2970] = 7524),
          (t[2971] = 7525),
          (t[2972] = 7526),
          (t[2974] = 7528),
          (t[2975] = 7529),
          (t[2976] = 7530),
          (t[2978] = 1537),
          (t[2979] = 1538),
          (t[2980] = 1539),
          (t[2982] = 1549),
          (t[2983] = 1551),
          (t[2984] = 1552),
          (t[2986] = 1554),
          (t[2987] = 1555),
          (t[2988] = 1556),
          (t[2990] = 1623),
          (t[2991] = 1624),
          (t[2995] = 1775),
          (t[2999] = 1791),
          (t[3002] = 64290),
          (t[3003] = 64291),
          (t[3004] = 64292),
          (t[3006] = 64294),
          (t[3007] = 64295),
          (t[3008] = 64296),
          (t[3011] = 1900),
          (t[3014] = 8223),
          (t[3015] = 8244),
          (t[3017] = 7532),
          (t[3018] = 7533),
          (t[3019] = 7534),
          (t[3075] = 7590),
          (t[3076] = 7591),
          (t[3079] = 7594),
          (t[3080] = 7595),
          (t[3083] = 7598),
          (t[3084] = 7599),
          (t[3087] = 7602),
          (t[3088] = 7603),
          (t[3091] = 7606),
          (t[3092] = 7607),
          (t[3095] = 7610),
          (t[3096] = 7611),
          (t[3099] = 7614),
          (t[3100] = 7615),
          (t[3103] = 7618),
          (t[3104] = 7619),
          (t[3107] = 8337),
          (t[3108] = 8338),
          (t[3116] = 1884),
          (t[3119] = 1885),
          (t[3120] = 1885),
          (t[3123] = 1886),
          (t[3124] = 1886),
          (t[3127] = 1887),
          (t[3128] = 1887),
          (t[3131] = 1888),
          (t[3132] = 1888),
          (t[3135] = 1889),
          (t[3136] = 1889),
          (t[3139] = 1890),
          (t[3140] = 1890),
          (t[3143] = 1891),
          (t[3144] = 1891),
          (t[3147] = 1892),
          (t[3148] = 1892),
          (t[3153] = 580),
          (t[3154] = 581),
          (t[3157] = 584),
          (t[3158] = 585),
          (t[3161] = 588),
          (t[3162] = 589),
          (t[3165] = 891),
          (t[3166] = 892),
          (t[3169] = 1274),
          (t[3170] = 1275),
          (t[3173] = 1278),
          (t[3174] = 1279),
          (t[3181] = 7622),
          (t[3182] = 7623),
          (t[3282] = 11799),
          (t[3316] = 578),
          (t[3379] = 42785),
          (t[3393] = 1159),
          (t[3416] = 8377);
      });
      r.getGlyphMapForStandardFonts = h;
      var d = (0, i.getLookupTableFactory)(function (t) {
        (t[227] = 322), (t[264] = 261), (t[291] = 346);
      });
      r.getSupplementalGlyphMapForArialBlack = d;
      var p = (0, i.getLookupTableFactory)(function (t) {
        (t[1] = 32),
          (t[4] = 65),
          (t[17] = 66),
          (t[18] = 67),
          (t[24] = 68),
          (t[28] = 69),
          (t[38] = 70),
          (t[39] = 71),
          (t[44] = 72),
          (t[47] = 73),
          (t[58] = 74),
          (t[60] = 75),
          (t[62] = 76),
          (t[68] = 77),
          (t[69] = 78),
          (t[75] = 79),
          (t[87] = 80),
          (t[89] = 81),
          (t[90] = 82),
          (t[94] = 83),
          (t[100] = 84),
          (t[104] = 85),
          (t[115] = 86),
          (t[116] = 87),
          (t[121] = 88),
          (t[122] = 89),
          (t[127] = 90),
          (t[258] = 97),
          (t[268] = 261),
          (t[271] = 98),
          (t[272] = 99),
          (t[273] = 263),
          (t[282] = 100),
          (t[286] = 101),
          (t[295] = 281),
          (t[296] = 102),
          (t[336] = 103),
          (t[346] = 104),
          (t[349] = 105),
          (t[361] = 106),
          (t[364] = 107),
          (t[367] = 108),
          (t[371] = 322),
          (t[373] = 109),
          (t[374] = 110),
          (t[381] = 111),
          (t[383] = 243),
          (t[393] = 112),
          (t[395] = 113),
          (t[396] = 114),
          (t[400] = 115),
          (t[401] = 347),
          (t[410] = 116),
          (t[437] = 117),
          (t[448] = 118),
          (t[449] = 119),
          (t[454] = 120),
          (t[455] = 121),
          (t[460] = 122),
          (t[463] = 380),
          (t[853] = 44),
          (t[855] = 58),
          (t[856] = 46),
          (t[876] = 47),
          (t[878] = 45),
          (t[882] = 45),
          (t[894] = 40),
          (t[895] = 41),
          (t[896] = 91),
          (t[897] = 93),
          (t[923] = 64),
          (t[1004] = 48),
          (t[1005] = 49),
          (t[1006] = 50),
          (t[1007] = 51),
          (t[1008] = 52),
          (t[1009] = 53),
          (t[1010] = 54),
          (t[1011] = 55),
          (t[1012] = 56),
          (t[1013] = 57),
          (t[1081] = 37),
          (t[1085] = 43),
          (t[1086] = 45);
      });
      r.getSupplementalGlyphMapForCalibri = p;
    },
    function (t, r, a) {
      var i = a(201).getLookupTableFactory,
        o = i(function (t) {
          (t[63721] = 169),
            (t[63193] = 169),
            (t[63720] = 174),
            (t[63194] = 174),
            (t[63722] = 8482),
            (t[63195] = 8482),
            (t[63729] = 9127),
            (t[63730] = 9128),
            (t[63731] = 9129),
            (t[63740] = 9131),
            (t[63741] = 9132),
            (t[63742] = 9133),
            (t[63726] = 9121),
            (t[63727] = 9122),
            (t[63728] = 9123),
            (t[63737] = 9124),
            (t[63738] = 9125),
            (t[63739] = 9126),
            (t[63723] = 9115),
            (t[63724] = 9116),
            (t[63725] = 9117),
            (t[63734] = 9118),
            (t[63735] = 9119),
            (t[63736] = 9120);
        });
      var l = [
        { begin: 0, end: 127 },
        { begin: 128, end: 255 },
        { begin: 256, end: 383 },
        { begin: 384, end: 591 },
        { begin: 592, end: 687 },
        { begin: 688, end: 767 },
        { begin: 768, end: 879 },
        { begin: 880, end: 1023 },
        { begin: 11392, end: 11519 },
        { begin: 1024, end: 1279 },
        { begin: 1328, end: 1423 },
        { begin: 1424, end: 1535 },
        { begin: 42240, end: 42559 },
        { begin: 1536, end: 1791 },
        { begin: 1984, end: 2047 },
        { begin: 2304, end: 2431 },
        { begin: 2432, end: 2559 },
        { begin: 2560, end: 2687 },
        { begin: 2688, end: 2815 },
        { begin: 2816, end: 2943 },
        { begin: 2944, end: 3071 },
        { begin: 3072, end: 3199 },
        { begin: 3200, end: 3327 },
        { begin: 3328, end: 3455 },
        { begin: 3584, end: 3711 },
        { begin: 3712, end: 3839 },
        { begin: 4256, end: 4351 },
        { begin: 6912, end: 7039 },
        { begin: 4352, end: 4607 },
        { begin: 7680, end: 7935 },
        { begin: 7936, end: 8191 },
        { begin: 8192, end: 8303 },
        { begin: 8304, end: 8351 },
        { begin: 8352, end: 8399 },
        { begin: 8400, end: 8447 },
        { begin: 8448, end: 8527 },
        { begin: 8528, end: 8591 },
        { begin: 8592, end: 8703 },
        { begin: 8704, end: 8959 },
        { begin: 8960, end: 9215 },
        { begin: 9216, end: 9279 },
        { begin: 9280, end: 9311 },
        { begin: 9312, end: 9471 },
        { begin: 9472, end: 9599 },
        { begin: 9600, end: 9631 },
        { begin: 9632, end: 9727 },
        { begin: 9728, end: 9983 },
        { begin: 9984, end: 10175 },
        { begin: 12288, end: 12351 },
        { begin: 12352, end: 12447 },
        { begin: 12448, end: 12543 },
        { begin: 12544, end: 12591 },
        { begin: 12592, end: 12687 },
        { begin: 43072, end: 43135 },
        { begin: 12800, end: 13055 },
        { begin: 13056, end: 13311 },
        { begin: 44032, end: 55215 },
        { begin: 55296, end: 57343 },
        { begin: 67840, end: 67871 },
        { begin: 19968, end: 40959 },
        { begin: 57344, end: 63743 },
        { begin: 12736, end: 12783 },
        { begin: 64256, end: 64335 },
        { begin: 64336, end: 65023 },
        { begin: 65056, end: 65071 },
        { begin: 65040, end: 65055 },
        { begin: 65104, end: 65135 },
        { begin: 65136, end: 65279 },
        { begin: 65280, end: 65519 },
        { begin: 65520, end: 65535 },
        { begin: 3840, end: 4095 },
        { begin: 1792, end: 1871 },
        { begin: 1920, end: 1983 },
        { begin: 3456, end: 3583 },
        { begin: 4096, end: 4255 },
        { begin: 4608, end: 4991 },
        { begin: 5024, end: 5119 },
        { begin: 5120, end: 5759 },
        { begin: 5760, end: 5791 },
        { begin: 5792, end: 5887 },
        { begin: 6016, end: 6143 },
        { begin: 6144, end: 6319 },
        { begin: 10240, end: 10495 },
        { begin: 40960, end: 42127 },
        { begin: 5888, end: 5919 },
        { begin: 66304, end: 66351 },
        { begin: 66352, end: 66383 },
        { begin: 66560, end: 66639 },
        { begin: 118784, end: 119039 },
        { begin: 119808, end: 120831 },
        { begin: 1044480, end: 1048573 },
        { begin: 65024, end: 65039 },
        { begin: 917504, end: 917631 },
        { begin: 6400, end: 6479 },
        { begin: 6480, end: 6527 },
        { begin: 6528, end: 6623 },
        { begin: 6656, end: 6687 },
        { begin: 11264, end: 11359 },
        { begin: 11568, end: 11647 },
        { begin: 19904, end: 19967 },
        { begin: 43008, end: 43055 },
        { begin: 65536, end: 65663 },
        { begin: 65856, end: 65935 },
        { begin: 66432, end: 66463 },
        { begin: 66464, end: 66527 },
        { begin: 66640, end: 66687 },
        { begin: 66688, end: 66735 },
        { begin: 67584, end: 67647 },
        { begin: 68096, end: 68191 },
        { begin: 119552, end: 119647 },
        { begin: 73728, end: 74751 },
        { begin: 119648, end: 119679 },
        { begin: 7040, end: 7103 },
        { begin: 7168, end: 7247 },
        { begin: 7248, end: 7295 },
        { begin: 43136, end: 43231 },
        { begin: 43264, end: 43311 },
        { begin: 43312, end: 43359 },
        { begin: 43520, end: 43615 },
        { begin: 65936, end: 65999 },
        { begin: 66e3, end: 66047 },
        { begin: 66208, end: 66271 },
        { begin: 127024, end: 127135 },
      ];
      var c = i(function (t) {
        (t["¨"] = " ̈"),
          (t["¯"] = " ̄"),
          (t["´"] = " ́"),
          (t["µ"] = "μ"),
          (t["¸"] = " ̧"),
          (t["Ĳ"] = "IJ"),
          (t["ĳ"] = "ij"),
          (t["Ŀ"] = "L·"),
          (t["ŀ"] = "l·"),
          (t["ŉ"] = "ʼn"),
          (t["ſ"] = "s"),
          (t["Ǆ"] = "DŽ"),
          (t["ǅ"] = "Dž"),
          (t["ǆ"] = "dž"),
          (t["Ǉ"] = "LJ"),
          (t["ǈ"] = "Lj"),
          (t["ǉ"] = "lj"),
          (t["Ǌ"] = "NJ"),
          (t["ǋ"] = "Nj"),
          (t["ǌ"] = "nj"),
          (t["Ǳ"] = "DZ"),
          (t["ǲ"] = "Dz"),
          (t["ǳ"] = "dz"),
          (t["˘"] = " ̆"),
          (t["˙"] = " ̇"),
          (t["˚"] = " ̊"),
          (t["˛"] = " ̨"),
          (t["˜"] = " ̃"),
          (t["˝"] = " ̋"),
          (t["ͺ"] = " ͅ"),
          (t["΄"] = " ́"),
          (t["ϐ"] = "β"),
          (t["ϑ"] = "θ"),
          (t["ϒ"] = "Υ"),
          (t["ϕ"] = "φ"),
          (t["ϖ"] = "π"),
          (t["ϰ"] = "κ"),
          (t["ϱ"] = "ρ"),
          (t["ϲ"] = "ς"),
          (t["ϴ"] = "Θ"),
          (t["ϵ"] = "ε"),
          (t["Ϲ"] = "Σ"),
          (t["և"] = "եւ"),
          (t["ٵ"] = "اٴ"),
          (t["ٶ"] = "وٴ"),
          (t["ٷ"] = "ۇٴ"),
          (t["ٸ"] = "يٴ"),
          (t["ำ"] = "ํา"),
          (t["ຳ"] = "ໍາ"),
          (t["ໜ"] = "ຫນ"),
          (t["ໝ"] = "ຫມ"),
          (t["ཷ"] = "ྲཱྀ"),
          (t["ཹ"] = "ླཱྀ"),
          (t["ẚ"] = "aʾ"),
          (t["᾽"] = " ̓"),
          (t["᾿"] = " ̓"),
          (t["῀"] = " ͂"),
          (t["῾"] = " ̔"),
          (t[" "] = " "),
          (t[" "] = " "),
          (t[" "] = " "),
          (t[" "] = " "),
          (t[" "] = " "),
          (t[" "] = " "),
          (t[" "] = " "),
          (t[" "] = " "),
          (t["‗"] = " ̳"),
          (t["․"] = "."),
          (t["‥"] = ".."),
          (t["…"] = "..."),
          (t["″"] = "′′"),
          (t["‴"] = "′′′"),
          (t["‶"] = "‵‵"),
          (t["‷"] = "‵‵‵"),
          (t["‼"] = "!!"),
          (t["‾"] = " ̅"),
          (t["⁇"] = "??"),
          (t["⁈"] = "?!"),
          (t["⁉"] = "!?"),
          (t["⁗"] = "′′′′"),
          (t[" "] = " "),
          (t["₨"] = "Rs"),
          (t["℀"] = "a/c"),
          (t["℁"] = "a/s"),
          (t["℃"] = "°C"),
          (t["℅"] = "c/o"),
          (t["℆"] = "c/u"),
          (t["ℇ"] = "Ɛ"),
          (t["℉"] = "°F"),
          (t["№"] = "No"),
          (t["℡"] = "TEL"),
          (t["ℵ"] = "א"),
          (t["ℶ"] = "ב"),
          (t["ℷ"] = "ג"),
          (t["ℸ"] = "ד"),
          (t["℻"] = "FAX"),
          (t["Ⅰ"] = "I"),
          (t["Ⅱ"] = "II"),
          (t["Ⅲ"] = "III"),
          (t["Ⅳ"] = "IV"),
          (t["Ⅴ"] = "V"),
          (t["Ⅵ"] = "VI"),
          (t["Ⅶ"] = "VII"),
          (t["Ⅷ"] = "VIII"),
          (t["Ⅸ"] = "IX"),
          (t["Ⅹ"] = "X"),
          (t["Ⅺ"] = "XI"),
          (t["Ⅻ"] = "XII"),
          (t["Ⅼ"] = "L"),
          (t["Ⅽ"] = "C"),
          (t["Ⅾ"] = "D"),
          (t["Ⅿ"] = "M"),
          (t["ⅰ"] = "i"),
          (t["ⅱ"] = "ii"),
          (t["ⅲ"] = "iii"),
          (t["ⅳ"] = "iv"),
          (t["ⅴ"] = "v"),
          (t["ⅵ"] = "vi"),
          (t["ⅶ"] = "vii"),
          (t["ⅷ"] = "viii"),
          (t["ⅸ"] = "ix"),
          (t["ⅹ"] = "x"),
          (t["ⅺ"] = "xi"),
          (t["ⅻ"] = "xii"),
          (t["ⅼ"] = "l"),
          (t["ⅽ"] = "c"),
          (t["ⅾ"] = "d"),
          (t["ⅿ"] = "m"),
          (t["∬"] = "∫∫"),
          (t["∭"] = "∫∫∫"),
          (t["∯"] = "∮∮"),
          (t["∰"] = "∮∮∮"),
          (t["⑴"] = "(1)"),
          (t["⑵"] = "(2)"),
          (t["⑶"] = "(3)"),
          (t["⑷"] = "(4)"),
          (t["⑸"] = "(5)"),
          (t["⑹"] = "(6)"),
          (t["⑺"] = "(7)"),
          (t["⑻"] = "(8)"),
          (t["⑼"] = "(9)"),
          (t["⑽"] = "(10)"),
          (t["⑾"] = "(11)"),
          (t["⑿"] = "(12)"),
          (t["⒀"] = "(13)"),
          (t["⒁"] = "(14)"),
          (t["⒂"] = "(15)"),
          (t["⒃"] = "(16)"),
          (t["⒄"] = "(17)"),
          (t["⒅"] = "(18)"),
          (t["⒆"] = "(19)"),
          (t["⒇"] = "(20)"),
          (t["⒈"] = "1."),
          (t["⒉"] = "2."),
          (t["⒊"] = "3."),
          (t["⒋"] = "4."),
          (t["⒌"] = "5."),
          (t["⒍"] = "6."),
          (t["⒎"] = "7."),
          (t["⒏"] = "8."),
          (t["⒐"] = "9."),
          (t["⒑"] = "10."),
          (t["⒒"] = "11."),
          (t["⒓"] = "12."),
          (t["⒔"] = "13."),
          (t["⒕"] = "14."),
          (t["⒖"] = "15."),
          (t["⒗"] = "16."),
          (t["⒘"] = "17."),
          (t["⒙"] = "18."),
          (t["⒚"] = "19."),
          (t["⒛"] = "20."),
          (t["⒜"] = "(a)"),
          (t["⒝"] = "(b)"),
          (t["⒞"] = "(c)"),
          (t["⒟"] = "(d)"),
          (t["⒠"] = "(e)"),
          (t["⒡"] = "(f)"),
          (t["⒢"] = "(g)"),
          (t["⒣"] = "(h)"),
          (t["⒤"] = "(i)"),
          (t["⒥"] = "(j)"),
          (t["⒦"] = "(k)"),
          (t["⒧"] = "(l)"),
          (t["⒨"] = "(m)"),
          (t["⒩"] = "(n)"),
          (t["⒪"] = "(o)"),
          (t["⒫"] = "(p)"),
          (t["⒬"] = "(q)"),
          (t["⒭"] = "(r)"),
          (t["⒮"] = "(s)"),
          (t["⒯"] = "(t)"),
          (t["⒰"] = "(u)"),
          (t["⒱"] = "(v)"),
          (t["⒲"] = "(w)"),
          (t["⒳"] = "(x)"),
          (t["⒴"] = "(y)"),
          (t["⒵"] = "(z)"),
          (t["⨌"] = "∫∫∫∫"),
          (t["⩴"] = "::="),
          (t["⩵"] = "=="),
          (t["⩶"] = "==="),
          (t["⺟"] = "母"),
          (t["⻳"] = "龟"),
          (t["⼀"] = "一"),
          (t["⼁"] = "丨"),
          (t["⼂"] = "丶"),
          (t["⼃"] = "丿"),
          (t["⼄"] = "乙"),
          (t["⼅"] = "亅"),
          (t["⼆"] = "二"),
          (t["⼇"] = "亠"),
          (t["⼈"] = "人"),
          (t["⼉"] = "儿"),
          (t["⼊"] = "入"),
          (t["⼋"] = "八"),
          (t["⼌"] = "冂"),
          (t["⼍"] = "冖"),
          (t["⼎"] = "冫"),
          (t["⼏"] = "几"),
          (t["⼐"] = "凵"),
          (t["⼑"] = "刀"),
          (t["⼒"] = "力"),
          (t["⼓"] = "勹"),
          (t["⼔"] = "匕"),
          (t["⼕"] = "匚"),
          (t["⼖"] = "匸"),
          (t["⼗"] = "十"),
          (t["⼘"] = "卜"),
          (t["⼙"] = "卩"),
          (t["⼚"] = "厂"),
          (t["⼛"] = "厶"),
          (t["⼜"] = "又"),
          (t["⼝"] = "口"),
          (t["⼞"] = "囗"),
          (t["⼟"] = "土"),
          (t["⼠"] = "士"),
          (t["⼡"] = "夂"),
          (t["⼢"] = "夊"),
          (t["⼣"] = "夕"),
          (t["⼤"] = "大"),
          (t["⼥"] = "女"),
          (t["⼦"] = "子"),
          (t["⼧"] = "宀"),
          (t["⼨"] = "寸"),
          (t["⼩"] = "小"),
          (t["⼪"] = "尢"),
          (t["⼫"] = "尸"),
          (t["⼬"] = "屮"),
          (t["⼭"] = "山"),
          (t["⼮"] = "巛"),
          (t["⼯"] = "工"),
          (t["⼰"] = "己"),
          (t["⼱"] = "巾"),
          (t["⼲"] = "干"),
          (t["⼳"] = "幺"),
          (t["⼴"] = "广"),
          (t["⼵"] = "廴"),
          (t["⼶"] = "廾"),
          (t["⼷"] = "弋"),
          (t["⼸"] = "弓"),
          (t["⼹"] = "彐"),
          (t["⼺"] = "彡"),
          (t["⼻"] = "彳"),
          (t["⼼"] = "心"),
          (t["⼽"] = "戈"),
          (t["⼾"] = "戶"),
          (t["⼿"] = "手"),
          (t["⽀"] = "支"),
          (t["⽁"] = "攴"),
          (t["⽂"] = "文"),
          (t["⽃"] = "斗"),
          (t["⽄"] = "斤"),
          (t["⽅"] = "方"),
          (t["⽆"] = "无"),
          (t["⽇"] = "日"),
          (t["⽈"] = "曰"),
          (t["⽉"] = "月"),
          (t["⽊"] = "木"),
          (t["⽋"] = "欠"),
          (t["⽌"] = "止"),
          (t["⽍"] = "歹"),
          (t["⽎"] = "殳"),
          (t["⽏"] = "毋"),
          (t["⽐"] = "比"),
          (t["⽑"] = "毛"),
          (t["⽒"] = "氏"),
          (t["⽓"] = "气"),
          (t["⽔"] = "水"),
          (t["⽕"] = "火"),
          (t["⽖"] = "爪"),
          (t["⽗"] = "父"),
          (t["⽘"] = "爻"),
          (t["⽙"] = "爿"),
          (t["⽚"] = "片"),
          (t["⽛"] = "牙"),
          (t["⽜"] = "牛"),
          (t["⽝"] = "犬"),
          (t["⽞"] = "玄"),
          (t["⽟"] = "玉"),
          (t["⽠"] = "瓜"),
          (t["⽡"] = "瓦"),
          (t["⽢"] = "甘"),
          (t["⽣"] = "生"),
          (t["⽤"] = "用"),
          (t["⽥"] = "田"),
          (t["⽦"] = "疋"),
          (t["⽧"] = "疒"),
          (t["⽨"] = "癶"),
          (t["⽩"] = "白"),
          (t["⽪"] = "皮"),
          (t["⽫"] = "皿"),
          (t["⽬"] = "目"),
          (t["⽭"] = "矛"),
          (t["⽮"] = "矢"),
          (t["⽯"] = "石"),
          (t["⽰"] = "示"),
          (t["⽱"] = "禸"),
          (t["⽲"] = "禾"),
          (t["⽳"] = "穴"),
          (t["⽴"] = "立"),
          (t["⽵"] = "竹"),
          (t["⽶"] = "米"),
          (t["⽷"] = "糸"),
          (t["⽸"] = "缶"),
          (t["⽹"] = "网"),
          (t["⽺"] = "羊"),
          (t["⽻"] = "羽"),
          (t["⽼"] = "老"),
          (t["⽽"] = "而"),
          (t["⽾"] = "耒"),
          (t["⽿"] = "耳"),
          (t["⾀"] = "聿"),
          (t["⾁"] = "肉"),
          (t["⾂"] = "臣"),
          (t["⾃"] = "自"),
          (t["⾄"] = "至"),
          (t["⾅"] = "臼"),
          (t["⾆"] = "舌"),
          (t["⾇"] = "舛"),
          (t["⾈"] = "舟"),
          (t["⾉"] = "艮"),
          (t["⾊"] = "色"),
          (t["⾋"] = "艸"),
          (t["⾌"] = "虍"),
          (t["⾍"] = "虫"),
          (t["⾎"] = "血"),
          (t["⾏"] = "行"),
          (t["⾐"] = "衣"),
          (t["⾑"] = "襾"),
          (t["⾒"] = "見"),
          (t["⾓"] = "角"),
          (t["⾔"] = "言"),
          (t["⾕"] = "谷"),
          (t["⾖"] = "豆"),
          (t["⾗"] = "豕"),
          (t["⾘"] = "豸"),
          (t["⾙"] = "貝"),
          (t["⾚"] = "赤"),
          (t["⾛"] = "走"),
          (t["⾜"] = "足"),
          (t["⾝"] = "身"),
          (t["⾞"] = "車"),
          (t["⾟"] = "辛"),
          (t["⾠"] = "辰"),
          (t["⾡"] = "辵"),
          (t["⾢"] = "邑"),
          (t["⾣"] = "酉"),
          (t["⾤"] = "釆"),
          (t["⾥"] = "里"),
          (t["⾦"] = "金"),
          (t["⾧"] = "長"),
          (t["⾨"] = "門"),
          (t["⾩"] = "阜"),
          (t["⾪"] = "隶"),
          (t["⾫"] = "隹"),
          (t["⾬"] = "雨"),
          (t["⾭"] = "靑"),
          (t["⾮"] = "非"),
          (t["⾯"] = "面"),
          (t["⾰"] = "革"),
          (t["⾱"] = "韋"),
          (t["⾲"] = "韭"),
          (t["⾳"] = "音"),
          (t["⾴"] = "頁"),
          (t["⾵"] = "風"),
          (t["⾶"] = "飛"),
          (t["⾷"] = "食"),
          (t["⾸"] = "首"),
          (t["⾹"] = "香"),
          (t["⾺"] = "馬"),
          (t["⾻"] = "骨"),
          (t["⾼"] = "高"),
          (t["⾽"] = "髟"),
          (t["⾾"] = "鬥"),
          (t["⾿"] = "鬯"),
          (t["⿀"] = "鬲"),
          (t["⿁"] = "鬼"),
          (t["⿂"] = "魚"),
          (t["⿃"] = "鳥"),
          (t["⿄"] = "鹵"),
          (t["⿅"] = "鹿"),
          (t["⿆"] = "麥"),
          (t["⿇"] = "麻"),
          (t["⿈"] = "黃"),
          (t["⿉"] = "黍"),
          (t["⿊"] = "黑"),
          (t["⿋"] = "黹"),
          (t["⿌"] = "黽"),
          (t["⿍"] = "鼎"),
          (t["⿎"] = "鼓"),
          (t["⿏"] = "鼠"),
          (t["⿐"] = "鼻"),
          (t["⿑"] = "齊"),
          (t["⿒"] = "齒"),
          (t["⿓"] = "龍"),
          (t["⿔"] = "龜"),
          (t["⿕"] = "龠"),
          (t["〶"] = "〒"),
          (t["〸"] = "十"),
          (t["〹"] = "卄"),
          (t["〺"] = "卅"),
          (t["゛"] = " ゙"),
          (t["゜"] = " ゚"),
          (t["ㄱ"] = "ᄀ"),
          (t["ㄲ"] = "ᄁ"),
          (t["ㄳ"] = "ᆪ"),
          (t["ㄴ"] = "ᄂ"),
          (t["ㄵ"] = "ᆬ"),
          (t["ㄶ"] = "ᆭ"),
          (t["ㄷ"] = "ᄃ"),
          (t["ㄸ"] = "ᄄ"),
          (t["ㄹ"] = "ᄅ"),
          (t["ㄺ"] = "ᆰ"),
          (t["ㄻ"] = "ᆱ"),
          (t["ㄼ"] = "ᆲ"),
          (t["ㄽ"] = "ᆳ"),
          (t["ㄾ"] = "ᆴ"),
          (t["ㄿ"] = "ᆵ"),
          (t["ㅀ"] = "ᄚ"),
          (t["ㅁ"] = "ᄆ"),
          (t["ㅂ"] = "ᄇ"),
          (t["ㅃ"] = "ᄈ"),
          (t["ㅄ"] = "ᄡ"),
          (t["ㅅ"] = "ᄉ"),
          (t["ㅆ"] = "ᄊ"),
          (t["ㅇ"] = "ᄋ"),
          (t["ㅈ"] = "ᄌ"),
          (t["ㅉ"] = "ᄍ"),
          (t["ㅊ"] = "ᄎ"),
          (t["ㅋ"] = "ᄏ"),
          (t["ㅌ"] = "ᄐ"),
          (t["ㅍ"] = "ᄑ"),
          (t["ㅎ"] = "ᄒ"),
          (t["ㅏ"] = "ᅡ"),
          (t["ㅐ"] = "ᅢ"),
          (t["ㅑ"] = "ᅣ"),
          (t["ㅒ"] = "ᅤ"),
          (t["ㅓ"] = "ᅥ"),
          (t["ㅔ"] = "ᅦ"),
          (t["ㅕ"] = "ᅧ"),
          (t["ㅖ"] = "ᅨ"),
          (t["ㅗ"] = "ᅩ"),
          (t["ㅘ"] = "ᅪ"),
          (t["ㅙ"] = "ᅫ"),
          (t["ㅚ"] = "ᅬ"),
          (t["ㅛ"] = "ᅭ"),
          (t["ㅜ"] = "ᅮ"),
          (t["ㅝ"] = "ᅯ"),
          (t["ㅞ"] = "ᅰ"),
          (t["ㅟ"] = "ᅱ"),
          (t["ㅠ"] = "ᅲ"),
          (t["ㅡ"] = "ᅳ"),
          (t["ㅢ"] = "ᅴ"),
          (t["ㅣ"] = "ᅵ"),
          (t["ㅤ"] = "ᅠ"),
          (t["ㅥ"] = "ᄔ"),
          (t["ㅦ"] = "ᄕ"),
          (t["ㅧ"] = "ᇇ"),
          (t["ㅨ"] = "ᇈ"),
          (t["ㅩ"] = "ᇌ"),
          (t["ㅪ"] = "ᇎ"),
          (t["ㅫ"] = "ᇓ"),
          (t["ㅬ"] = "ᇗ"),
          (t["ㅭ"] = "ᇙ"),
          (t["ㅮ"] = "ᄜ"),
          (t["ㅯ"] = "ᇝ"),
          (t["ㅰ"] = "ᇟ"),
          (t["ㅱ"] = "ᄝ"),
          (t["ㅲ"] = "ᄞ"),
          (t["ㅳ"] = "ᄠ"),
          (t["ㅴ"] = "ᄢ"),
          (t["ㅵ"] = "ᄣ"),
          (t["ㅶ"] = "ᄧ"),
          (t["ㅷ"] = "ᄩ"),
          (t["ㅸ"] = "ᄫ"),
          (t["ㅹ"] = "ᄬ"),
          (t["ㅺ"] = "ᄭ"),
          (t["ㅻ"] = "ᄮ"),
          (t["ㅼ"] = "ᄯ"),
          (t["ㅽ"] = "ᄲ"),
          (t["ㅾ"] = "ᄶ"),
          (t["ㅿ"] = "ᅀ"),
          (t["ㆀ"] = "ᅇ"),
          (t["ㆁ"] = "ᅌ"),
          (t["ㆂ"] = "ᇱ"),
          (t["ㆃ"] = "ᇲ"),
          (t["ㆄ"] = "ᅗ"),
          (t["ㆅ"] = "ᅘ"),
          (t["ㆆ"] = "ᅙ"),
          (t["ㆇ"] = "ᆄ"),
          (t["ㆈ"] = "ᆅ"),
          (t["ㆉ"] = "ᆈ"),
          (t["ㆊ"] = "ᆑ"),
          (t["ㆋ"] = "ᆒ"),
          (t["ㆌ"] = "ᆔ"),
          (t["ㆍ"] = "ᆞ"),
          (t["ㆎ"] = "ᆡ"),
          (t["㈀"] = "(ᄀ)"),
          (t["㈁"] = "(ᄂ)"),
          (t["㈂"] = "(ᄃ)"),
          (t["㈃"] = "(ᄅ)"),
          (t["㈄"] = "(ᄆ)"),
          (t["㈅"] = "(ᄇ)"),
          (t["㈆"] = "(ᄉ)"),
          (t["㈇"] = "(ᄋ)"),
          (t["㈈"] = "(ᄌ)"),
          (t["㈉"] = "(ᄎ)"),
          (t["㈊"] = "(ᄏ)"),
          (t["㈋"] = "(ᄐ)"),
          (t["㈌"] = "(ᄑ)"),
          (t["㈍"] = "(ᄒ)"),
          (t["㈎"] = "(가)"),
          (t["㈏"] = "(나)"),
          (t["㈐"] = "(다)"),
          (t["㈑"] = "(라)"),
          (t["㈒"] = "(마)"),
          (t["㈓"] = "(바)"),
          (t["㈔"] = "(사)"),
          (t["㈕"] = "(아)"),
          (t["㈖"] = "(자)"),
          (t["㈗"] = "(차)"),
          (t["㈘"] = "(카)"),
          (t["㈙"] = "(타)"),
          (t["㈚"] = "(파)"),
          (t["㈛"] = "(하)"),
          (t["㈜"] = "(주)"),
          (t["㈝"] = "(오전)"),
          (t["㈞"] = "(오후)"),
          (t["㈠"] = "(一)"),
          (t["㈡"] = "(二)"),
          (t["㈢"] = "(三)"),
          (t["㈣"] = "(四)"),
          (t["㈤"] = "(五)"),
          (t["㈥"] = "(六)"),
          (t["㈦"] = "(七)"),
          (t["㈧"] = "(八)"),
          (t["㈨"] = "(九)"),
          (t["㈩"] = "(十)"),
          (t["㈪"] = "(月)"),
          (t["㈫"] = "(火)"),
          (t["㈬"] = "(水)"),
          (t["㈭"] = "(木)"),
          (t["㈮"] = "(金)"),
          (t["㈯"] = "(土)"),
          (t["㈰"] = "(日)"),
          (t["㈱"] = "(株)"),
          (t["㈲"] = "(有)"),
          (t["㈳"] = "(社)"),
          (t["㈴"] = "(名)"),
          (t["㈵"] = "(特)"),
          (t["㈶"] = "(財)"),
          (t["㈷"] = "(祝)"),
          (t["㈸"] = "(労)"),
          (t["㈹"] = "(代)"),
          (t["㈺"] = "(呼)"),
          (t["㈻"] = "(学)"),
          (t["㈼"] = "(監)"),
          (t["㈽"] = "(企)"),
          (t["㈾"] = "(資)"),
          (t["㈿"] = "(協)"),
          (t["㉀"] = "(祭)"),
          (t["㉁"] = "(休)"),
          (t["㉂"] = "(自)"),
          (t["㉃"] = "(至)"),
          (t["㋀"] = "1月"),
          (t["㋁"] = "2月"),
          (t["㋂"] = "3月"),
          (t["㋃"] = "4月"),
          (t["㋄"] = "5月"),
          (t["㋅"] = "6月"),
          (t["㋆"] = "7月"),
          (t["㋇"] = "8月"),
          (t["㋈"] = "9月"),
          (t["㋉"] = "10月"),
          (t["㋊"] = "11月"),
          (t["㋋"] = "12月"),
          (t["㍘"] = "0点"),
          (t["㍙"] = "1点"),
          (t["㍚"] = "2点"),
          (t["㍛"] = "3点"),
          (t["㍜"] = "4点"),
          (t["㍝"] = "5点"),
          (t["㍞"] = "6点"),
          (t["㍟"] = "7点"),
          (t["㍠"] = "8点"),
          (t["㍡"] = "9点"),
          (t["㍢"] = "10点"),
          (t["㍣"] = "11点"),
          (t["㍤"] = "12点"),
          (t["㍥"] = "13点"),
          (t["㍦"] = "14点"),
          (t["㍧"] = "15点"),
          (t["㍨"] = "16点"),
          (t["㍩"] = "17点"),
          (t["㍪"] = "18点"),
          (t["㍫"] = "19点"),
          (t["㍬"] = "20点"),
          (t["㍭"] = "21点"),
          (t["㍮"] = "22点"),
          (t["㍯"] = "23点"),
          (t["㍰"] = "24点"),
          (t["㏠"] = "1日"),
          (t["㏡"] = "2日"),
          (t["㏢"] = "3日"),
          (t["㏣"] = "4日"),
          (t["㏤"] = "5日"),
          (t["㏥"] = "6日"),
          (t["㏦"] = "7日"),
          (t["㏧"] = "8日"),
          (t["㏨"] = "9日"),
          (t["㏩"] = "10日"),
          (t["㏪"] = "11日"),
          (t["㏫"] = "12日"),
          (t["㏬"] = "13日"),
          (t["㏭"] = "14日"),
          (t["㏮"] = "15日"),
          (t["㏯"] = "16日"),
          (t["㏰"] = "17日"),
          (t["㏱"] = "18日"),
          (t["㏲"] = "19日"),
          (t["㏳"] = "20日"),
          (t["㏴"] = "21日"),
          (t["㏵"] = "22日"),
          (t["㏶"] = "23日"),
          (t["㏷"] = "24日"),
          (t["㏸"] = "25日"),
          (t["㏹"] = "26日"),
          (t["㏺"] = "27日"),
          (t["㏻"] = "28日"),
          (t["㏼"] = "29日"),
          (t["㏽"] = "30日"),
          (t["㏾"] = "31日"),
          (t["ﬀ"] = "ff"),
          (t["ﬁ"] = "fi"),
          (t["ﬂ"] = "fl"),
          (t["ﬃ"] = "ffi"),
          (t["ﬄ"] = "ffl"),
          (t["ﬅ"] = "ſt"),
          (t["ﬆ"] = "st"),
          (t["ﬓ"] = "մն"),
          (t["ﬔ"] = "մե"),
          (t["ﬕ"] = "մի"),
          (t["ﬖ"] = "վն"),
          (t["ﬗ"] = "մխ"),
          (t["ﭏ"] = "אל"),
          (t["ﭐ"] = "ٱ"),
          (t["ﭑ"] = "ٱ"),
          (t["ﭒ"] = "ٻ"),
          (t["ﭓ"] = "ٻ"),
          (t["ﭔ"] = "ٻ"),
          (t["ﭕ"] = "ٻ"),
          (t["ﭖ"] = "پ"),
          (t["ﭗ"] = "پ"),
          (t["ﭘ"] = "پ"),
          (t["ﭙ"] = "پ"),
          (t["ﭚ"] = "ڀ"),
          (t["ﭛ"] = "ڀ"),
          (t["ﭜ"] = "ڀ"),
          (t["ﭝ"] = "ڀ"),
          (t["ﭞ"] = "ٺ"),
          (t["ﭟ"] = "ٺ"),
          (t["ﭠ"] = "ٺ"),
          (t["ﭡ"] = "ٺ"),
          (t["ﭢ"] = "ٿ"),
          (t["ﭣ"] = "ٿ"),
          (t["ﭤ"] = "ٿ"),
          (t["ﭥ"] = "ٿ"),
          (t["ﭦ"] = "ٹ"),
          (t["ﭧ"] = "ٹ"),
          (t["ﭨ"] = "ٹ"),
          (t["ﭩ"] = "ٹ"),
          (t["ﭪ"] = "ڤ"),
          (t["ﭫ"] = "ڤ"),
          (t["ﭬ"] = "ڤ"),
          (t["ﭭ"] = "ڤ"),
          (t["ﭮ"] = "ڦ"),
          (t["ﭯ"] = "ڦ"),
          (t["ﭰ"] = "ڦ"),
          (t["ﭱ"] = "ڦ"),
          (t["ﭲ"] = "ڄ"),
          (t["ﭳ"] = "ڄ"),
          (t["ﭴ"] = "ڄ"),
          (t["ﭵ"] = "ڄ"),
          (t["ﭶ"] = "ڃ"),
          (t["ﭷ"] = "ڃ"),
          (t["ﭸ"] = "ڃ"),
          (t["ﭹ"] = "ڃ"),
          (t["ﭺ"] = "چ"),
          (t["ﭻ"] = "چ"),
          (t["ﭼ"] = "چ"),
          (t["ﭽ"] = "چ"),
          (t["ﭾ"] = "ڇ"),
          (t["ﭿ"] = "ڇ"),
          (t["ﮀ"] = "ڇ"),
          (t["ﮁ"] = "ڇ"),
          (t["ﮂ"] = "ڍ"),
          (t["ﮃ"] = "ڍ"),
          (t["ﮄ"] = "ڌ"),
          (t["ﮅ"] = "ڌ"),
          (t["ﮆ"] = "ڎ"),
          (t["ﮇ"] = "ڎ"),
          (t["ﮈ"] = "ڈ"),
          (t["ﮉ"] = "ڈ"),
          (t["ﮊ"] = "ژ"),
          (t["ﮋ"] = "ژ"),
          (t["ﮌ"] = "ڑ"),
          (t["ﮍ"] = "ڑ"),
          (t["ﮎ"] = "ک"),
          (t["ﮏ"] = "ک"),
          (t["ﮐ"] = "ک"),
          (t["ﮑ"] = "ک"),
          (t["ﮒ"] = "گ"),
          (t["ﮓ"] = "گ"),
          (t["ﮔ"] = "گ"),
          (t["ﮕ"] = "گ"),
          (t["ﮖ"] = "ڳ"),
          (t["ﮗ"] = "ڳ"),
          (t["ﮘ"] = "ڳ"),
          (t["ﮙ"] = "ڳ"),
          (t["ﮚ"] = "ڱ"),
          (t["ﮛ"] = "ڱ"),
          (t["ﮜ"] = "ڱ"),
          (t["ﮝ"] = "ڱ"),
          (t["ﮞ"] = "ں"),
          (t["ﮟ"] = "ں"),
          (t["ﮠ"] = "ڻ"),
          (t["ﮡ"] = "ڻ"),
          (t["ﮢ"] = "ڻ"),
          (t["ﮣ"] = "ڻ"),
          (t["ﮤ"] = "ۀ"),
          (t["ﮥ"] = "ۀ"),
          (t["ﮦ"] = "ہ"),
          (t["ﮧ"] = "ہ"),
          (t["ﮨ"] = "ہ"),
          (t["ﮩ"] = "ہ"),
          (t["ﮪ"] = "ھ"),
          (t["ﮫ"] = "ھ"),
          (t["ﮬ"] = "ھ"),
          (t["ﮭ"] = "ھ"),
          (t["ﮮ"] = "ے"),
          (t["ﮯ"] = "ے"),
          (t["ﮰ"] = "ۓ"),
          (t["ﮱ"] = "ۓ"),
          (t["ﯓ"] = "ڭ"),
          (t["ﯔ"] = "ڭ"),
          (t["ﯕ"] = "ڭ"),
          (t["ﯖ"] = "ڭ"),
          (t["ﯗ"] = "ۇ"),
          (t["ﯘ"] = "ۇ"),
          (t["ﯙ"] = "ۆ"),
          (t["ﯚ"] = "ۆ"),
          (t["ﯛ"] = "ۈ"),
          (t["ﯜ"] = "ۈ"),
          (t["ﯝ"] = "ٷ"),
          (t["ﯞ"] = "ۋ"),
          (t["ﯟ"] = "ۋ"),
          (t["ﯠ"] = "ۅ"),
          (t["ﯡ"] = "ۅ"),
          (t["ﯢ"] = "ۉ"),
          (t["ﯣ"] = "ۉ"),
          (t["ﯤ"] = "ې"),
          (t["ﯥ"] = "ې"),
          (t["ﯦ"] = "ې"),
          (t["ﯧ"] = "ې"),
          (t["ﯨ"] = "ى"),
          (t["ﯩ"] = "ى"),
          (t["ﯪ"] = "ئا"),
          (t["ﯫ"] = "ئا"),
          (t["ﯬ"] = "ئە"),
          (t["ﯭ"] = "ئە"),
          (t["ﯮ"] = "ئو"),
          (t["ﯯ"] = "ئو"),
          (t["ﯰ"] = "ئۇ"),
          (t["ﯱ"] = "ئۇ"),
          (t["ﯲ"] = "ئۆ"),
          (t["ﯳ"] = "ئۆ"),
          (t["ﯴ"] = "ئۈ"),
          (t["ﯵ"] = "ئۈ"),
          (t["ﯶ"] = "ئې");
        (t["ﯷ"] = "ئې"),
          (t["ﯸ"] = "ئې"),
          (t["ﯹ"] = "ئى"),
          (t["ﯺ"] = "ئى"),
          (t["ﯻ"] = "ئى"),
          (t["ﯼ"] = "ی"),
          (t["ﯽ"] = "ی"),
          (t["ﯾ"] = "ی"),
          (t["ﯿ"] = "ی"),
          (t["ﰀ"] = "ئج"),
          (t["ﰁ"] = "ئح"),
          (t["ﰂ"] = "ئم"),
          (t["ﰃ"] = "ئى"),
          (t["ﰄ"] = "ئي"),
          (t["ﰅ"] = "بج"),
          (t["ﰆ"] = "بح"),
          (t["ﰇ"] = "بخ"),
          (t["ﰈ"] = "بم"),
          (t["ﰉ"] = "بى"),
          (t["ﰊ"] = "بي"),
          (t["ﰋ"] = "تج"),
          (t["ﰌ"] = "تح"),
          (t["ﰍ"] = "تخ"),
          (t["ﰎ"] = "تم"),
          (t["ﰏ"] = "تى"),
          (t["ﰐ"] = "تي"),
          (t["ﰑ"] = "ثج"),
          (t["ﰒ"] = "ثم"),
          (t["ﰓ"] = "ثى"),
          (t["ﰔ"] = "ثي"),
          (t["ﰕ"] = "جح"),
          (t["ﰖ"] = "جم"),
          (t["ﰗ"] = "حج"),
          (t["ﰘ"] = "حم"),
          (t["ﰙ"] = "خج"),
          (t["ﰚ"] = "خح"),
          (t["ﰛ"] = "خم"),
          (t["ﰜ"] = "سج"),
          (t["ﰝ"] = "سح"),
          (t["ﰞ"] = "سخ"),
          (t["ﰟ"] = "سم"),
          (t["ﰠ"] = "صح"),
          (t["ﰡ"] = "صم"),
          (t["ﰢ"] = "ضج"),
          (t["ﰣ"] = "ضح"),
          (t["ﰤ"] = "ضخ"),
          (t["ﰥ"] = "ضم"),
          (t["ﰦ"] = "طح"),
          (t["ﰧ"] = "طم"),
          (t["ﰨ"] = "ظم"),
          (t["ﰩ"] = "عج"),
          (t["ﰪ"] = "عم"),
          (t["ﰫ"] = "غج"),
          (t["ﰬ"] = "غم"),
          (t["ﰭ"] = "فج"),
          (t["ﰮ"] = "فح"),
          (t["ﰯ"] = "فخ"),
          (t["ﰰ"] = "فم"),
          (t["ﰱ"] = "فى"),
          (t["ﰲ"] = "في"),
          (t["ﰳ"] = "قح"),
          (t["ﰴ"] = "قم"),
          (t["ﰵ"] = "قى"),
          (t["ﰶ"] = "قي"),
          (t["ﰷ"] = "كا"),
          (t["ﰸ"] = "كج"),
          (t["ﰹ"] = "كح"),
          (t["ﰺ"] = "كخ"),
          (t["ﰻ"] = "كل"),
          (t["ﰼ"] = "كم"),
          (t["ﰽ"] = "كى"),
          (t["ﰾ"] = "كي"),
          (t["ﰿ"] = "لج"),
          (t["ﱀ"] = "لح"),
          (t["ﱁ"] = "لخ"),
          (t["ﱂ"] = "لم"),
          (t["ﱃ"] = "لى"),
          (t["ﱄ"] = "لي"),
          (t["ﱅ"] = "مج"),
          (t["ﱆ"] = "مح"),
          (t["ﱇ"] = "مخ"),
          (t["ﱈ"] = "مم"),
          (t["ﱉ"] = "مى"),
          (t["ﱊ"] = "مي"),
          (t["ﱋ"] = "نج"),
          (t["ﱌ"] = "نح"),
          (t["ﱍ"] = "نخ"),
          (t["ﱎ"] = "نم"),
          (t["ﱏ"] = "نى"),
          (t["ﱐ"] = "ني"),
          (t["ﱑ"] = "هج"),
          (t["ﱒ"] = "هم"),
          (t["ﱓ"] = "هى"),
          (t["ﱔ"] = "هي"),
          (t["ﱕ"] = "يج"),
          (t["ﱖ"] = "يح"),
          (t["ﱗ"] = "يخ"),
          (t["ﱘ"] = "يم"),
          (t["ﱙ"] = "يى"),
          (t["ﱚ"] = "يي"),
          (t["ﱛ"] = "ذٰ"),
          (t["ﱜ"] = "رٰ"),
          (t["ﱝ"] = "ىٰ"),
          (t["ﱞ"] = " ٌّ"),
          (t["ﱟ"] = " ٍّ"),
          (t["ﱠ"] = " َّ"),
          (t["ﱡ"] = " ُّ"),
          (t["ﱢ"] = " ِّ"),
          (t["ﱣ"] = " ّٰ"),
          (t["ﱤ"] = "ئر"),
          (t["ﱥ"] = "ئز"),
          (t["ﱦ"] = "ئم"),
          (t["ﱧ"] = "ئن"),
          (t["ﱨ"] = "ئى"),
          (t["ﱩ"] = "ئي"),
          (t["ﱪ"] = "بر"),
          (t["ﱫ"] = "بز"),
          (t["ﱬ"] = "بم"),
          (t["ﱭ"] = "بن"),
          (t["ﱮ"] = "بى"),
          (t["ﱯ"] = "بي"),
          (t["ﱰ"] = "تر"),
          (t["ﱱ"] = "تز"),
          (t["ﱲ"] = "تم"),
          (t["ﱳ"] = "تن"),
          (t["ﱴ"] = "تى"),
          (t["ﱵ"] = "تي"),
          (t["ﱶ"] = "ثر"),
          (t["ﱷ"] = "ثز"),
          (t["ﱸ"] = "ثم"),
          (t["ﱹ"] = "ثن"),
          (t["ﱺ"] = "ثى"),
          (t["ﱻ"] = "ثي"),
          (t["ﱼ"] = "فى"),
          (t["ﱽ"] = "في"),
          (t["ﱾ"] = "قى"),
          (t["ﱿ"] = "قي"),
          (t["ﲀ"] = "كا"),
          (t["ﲁ"] = "كل"),
          (t["ﲂ"] = "كم"),
          (t["ﲃ"] = "كى"),
          (t["ﲄ"] = "كي"),
          (t["ﲅ"] = "لم"),
          (t["ﲆ"] = "لى"),
          (t["ﲇ"] = "لي"),
          (t["ﲈ"] = "ما"),
          (t["ﲉ"] = "مم"),
          (t["ﲊ"] = "نر"),
          (t["ﲋ"] = "نز"),
          (t["ﲌ"] = "نم"),
          (t["ﲍ"] = "نن"),
          (t["ﲎ"] = "نى"),
          (t["ﲏ"] = "ني"),
          (t["ﲐ"] = "ىٰ"),
          (t["ﲑ"] = "ير"),
          (t["ﲒ"] = "يز"),
          (t["ﲓ"] = "يم"),
          (t["ﲔ"] = "ين"),
          (t["ﲕ"] = "يى"),
          (t["ﲖ"] = "يي"),
          (t["ﲗ"] = "ئج"),
          (t["ﲘ"] = "ئح"),
          (t["ﲙ"] = "ئخ"),
          (t["ﲚ"] = "ئم"),
          (t["ﲛ"] = "ئه"),
          (t["ﲜ"] = "بج"),
          (t["ﲝ"] = "بح"),
          (t["ﲞ"] = "بخ"),
          (t["ﲟ"] = "بم"),
          (t["ﲠ"] = "به"),
          (t["ﲡ"] = "تج"),
          (t["ﲢ"] = "تح"),
          (t["ﲣ"] = "تخ"),
          (t["ﲤ"] = "تم"),
          (t["ﲥ"] = "ته"),
          (t["ﲦ"] = "ثم"),
          (t["ﲧ"] = "جح"),
          (t["ﲨ"] = "جم"),
          (t["ﲩ"] = "حج"),
          (t["ﲪ"] = "حم"),
          (t["ﲫ"] = "خج"),
          (t["ﲬ"] = "خم"),
          (t["ﲭ"] = "سج"),
          (t["ﲮ"] = "سح"),
          (t["ﲯ"] = "سخ"),
          (t["ﲰ"] = "سم"),
          (t["ﲱ"] = "صح"),
          (t["ﲲ"] = "صخ"),
          (t["ﲳ"] = "صم"),
          (t["ﲴ"] = "ضج"),
          (t["ﲵ"] = "ضح"),
          (t["ﲶ"] = "ضخ"),
          (t["ﲷ"] = "ضم"),
          (t["ﲸ"] = "طح"),
          (t["ﲹ"] = "ظم"),
          (t["ﲺ"] = "عج"),
          (t["ﲻ"] = "عم"),
          (t["ﲼ"] = "غج"),
          (t["ﲽ"] = "غم"),
          (t["ﲾ"] = "فج"),
          (t["ﲿ"] = "فح"),
          (t["ﳀ"] = "فخ"),
          (t["ﳁ"] = "فم"),
          (t["ﳂ"] = "قح"),
          (t["ﳃ"] = "قم"),
          (t["ﳄ"] = "كج"),
          (t["ﳅ"] = "كح"),
          (t["ﳆ"] = "كخ"),
          (t["ﳇ"] = "كل"),
          (t["ﳈ"] = "كم"),
          (t["ﳉ"] = "لج"),
          (t["ﳊ"] = "لح"),
          (t["ﳋ"] = "لخ"),
          (t["ﳌ"] = "لم"),
          (t["ﳍ"] = "له"),
          (t["ﳎ"] = "مج"),
          (t["ﳏ"] = "مح"),
          (t["ﳐ"] = "مخ"),
          (t["ﳑ"] = "مم"),
          (t["ﳒ"] = "نج"),
          (t["ﳓ"] = "نح"),
          (t["ﳔ"] = "نخ"),
          (t["ﳕ"] = "نم"),
          (t["ﳖ"] = "نه"),
          (t["ﳗ"] = "هج"),
          (t["ﳘ"] = "هم"),
          (t["ﳙ"] = "هٰ"),
          (t["ﳚ"] = "يج"),
          (t["ﳛ"] = "يح"),
          (t["ﳜ"] = "يخ"),
          (t["ﳝ"] = "يم"),
          (t["ﳞ"] = "يه"),
          (t["ﳟ"] = "ئم"),
          (t["ﳠ"] = "ئه"),
          (t["ﳡ"] = "بم"),
          (t["ﳢ"] = "به"),
          (t["ﳣ"] = "تم"),
          (t["ﳤ"] = "ته"),
          (t["ﳥ"] = "ثم"),
          (t["ﳦ"] = "ثه"),
          (t["ﳧ"] = "سم"),
          (t["ﳨ"] = "سه"),
          (t["ﳩ"] = "شم"),
          (t["ﳪ"] = "شه"),
          (t["ﳫ"] = "كل"),
          (t["ﳬ"] = "كم"),
          (t["ﳭ"] = "لم"),
          (t["ﳮ"] = "نم"),
          (t["ﳯ"] = "نه"),
          (t["ﳰ"] = "يم"),
          (t["ﳱ"] = "يه"),
          (t["ﳲ"] = "ـَّ"),
          (t["ﳳ"] = "ـُّ"),
          (t["ﳴ"] = "ـِّ"),
          (t["ﳵ"] = "طى"),
          (t["ﳶ"] = "طي"),
          (t["ﳷ"] = "عى"),
          (t["ﳸ"] = "عي"),
          (t["ﳹ"] = "غى"),
          (t["ﳺ"] = "غي"),
          (t["ﳻ"] = "سى"),
          (t["ﳼ"] = "سي"),
          (t["ﳽ"] = "شى"),
          (t["ﳾ"] = "شي"),
          (t["ﳿ"] = "حى"),
          (t["ﴀ"] = "حي"),
          (t["ﴁ"] = "جى"),
          (t["ﴂ"] = "جي"),
          (t["ﴃ"] = "خى"),
          (t["ﴄ"] = "خي"),
          (t["ﴅ"] = "صى"),
          (t["ﴆ"] = "صي"),
          (t["ﴇ"] = "ضى"),
          (t["ﴈ"] = "ضي"),
          (t["ﴉ"] = "شج"),
          (t["ﴊ"] = "شح"),
          (t["ﴋ"] = "شخ"),
          (t["ﴌ"] = "شم"),
          (t["ﴍ"] = "شر"),
          (t["ﴎ"] = "سر"),
          (t["ﴏ"] = "صر"),
          (t["ﴐ"] = "ضر"),
          (t["ﴑ"] = "طى"),
          (t["ﴒ"] = "طي"),
          (t["ﴓ"] = "عى"),
          (t["ﴔ"] = "عي"),
          (t["ﴕ"] = "غى"),
          (t["ﴖ"] = "غي"),
          (t["ﴗ"] = "سى"),
          (t["ﴘ"] = "سي"),
          (t["ﴙ"] = "شى"),
          (t["ﴚ"] = "شي"),
          (t["ﴛ"] = "حى"),
          (t["ﴜ"] = "حي"),
          (t["ﴝ"] = "جى"),
          (t["ﴞ"] = "جي"),
          (t["ﴟ"] = "خى"),
          (t["ﴠ"] = "خي"),
          (t["ﴡ"] = "صى"),
          (t["ﴢ"] = "صي"),
          (t["ﴣ"] = "ضى"),
          (t["ﴤ"] = "ضي"),
          (t["ﴥ"] = "شج"),
          (t["ﴦ"] = "شح"),
          (t["ﴧ"] = "شخ"),
          (t["ﴨ"] = "شم"),
          (t["ﴩ"] = "شر"),
          (t["ﴪ"] = "سر"),
          (t["ﴫ"] = "صر"),
          (t["ﴬ"] = "ضر"),
          (t["ﴭ"] = "شج"),
          (t["ﴮ"] = "شح"),
          (t["ﴯ"] = "شخ"),
          (t["ﴰ"] = "شم"),
          (t["ﴱ"] = "سه"),
          (t["ﴲ"] = "شه"),
          (t["ﴳ"] = "طم"),
          (t["ﴴ"] = "سج"),
          (t["ﴵ"] = "سح"),
          (t["ﴶ"] = "سخ"),
          (t["ﴷ"] = "شج"),
          (t["ﴸ"] = "شح"),
          (t["ﴹ"] = "شخ"),
          (t["ﴺ"] = "طم"),
          (t["ﴻ"] = "ظم"),
          (t["ﴼ"] = "اً"),
          (t["ﴽ"] = "اً"),
          (t["ﵐ"] = "تجم"),
          (t["ﵑ"] = "تحج"),
          (t["ﵒ"] = "تحج"),
          (t["ﵓ"] = "تحم"),
          (t["ﵔ"] = "تخم"),
          (t["ﵕ"] = "تمج"),
          (t["ﵖ"] = "تمح"),
          (t["ﵗ"] = "تمخ"),
          (t["ﵘ"] = "جمح"),
          (t["ﵙ"] = "جمح"),
          (t["ﵚ"] = "حمي"),
          (t["ﵛ"] = "حمى"),
          (t["ﵜ"] = "سحج"),
          (t["ﵝ"] = "سجح"),
          (t["ﵞ"] = "سجى"),
          (t["ﵟ"] = "سمح"),
          (t["ﵠ"] = "سمح"),
          (t["ﵡ"] = "سمج"),
          (t["ﵢ"] = "سمم"),
          (t["ﵣ"] = "سمم"),
          (t["ﵤ"] = "صحح"),
          (t["ﵥ"] = "صحح"),
          (t["ﵦ"] = "صمم"),
          (t["ﵧ"] = "شحم"),
          (t["ﵨ"] = "شحم"),
          (t["ﵩ"] = "شجي"),
          (t["ﵪ"] = "شمخ"),
          (t["ﵫ"] = "شمخ"),
          (t["ﵬ"] = "شمم"),
          (t["ﵭ"] = "شمم"),
          (t["ﵮ"] = "ضحى"),
          (t["ﵯ"] = "ضخم"),
          (t["ﵰ"] = "ضخم"),
          (t["ﵱ"] = "طمح"),
          (t["ﵲ"] = "طمح"),
          (t["ﵳ"] = "طمم"),
          (t["ﵴ"] = "طمي"),
          (t["ﵵ"] = "عجم"),
          (t["ﵶ"] = "عمم"),
          (t["ﵷ"] = "عمم"),
          (t["ﵸ"] = "عمى"),
          (t["ﵹ"] = "غمم"),
          (t["ﵺ"] = "غمي"),
          (t["ﵻ"] = "غمى"),
          (t["ﵼ"] = "فخم"),
          (t["ﵽ"] = "فخم"),
          (t["ﵾ"] = "قمح"),
          (t["ﵿ"] = "قمم"),
          (t["ﶀ"] = "لحم"),
          (t["ﶁ"] = "لحي"),
          (t["ﶂ"] = "لحى"),
          (t["ﶃ"] = "لجج"),
          (t["ﶄ"] = "لجج"),
          (t["ﶅ"] = "لخم"),
          (t["ﶆ"] = "لخم"),
          (t["ﶇ"] = "لمح"),
          (t["ﶈ"] = "لمح"),
          (t["ﶉ"] = "محج"),
          (t["ﶊ"] = "محم"),
          (t["ﶋ"] = "محي"),
          (t["ﶌ"] = "مجح"),
          (t["ﶍ"] = "مجم"),
          (t["ﶎ"] = "مخج"),
          (t["ﶏ"] = "مخم"),
          (t["ﶒ"] = "مجخ"),
          (t["ﶓ"] = "همج"),
          (t["ﶔ"] = "همم"),
          (t["ﶕ"] = "نحم"),
          (t["ﶖ"] = "نحى"),
          (t["ﶗ"] = "نجم"),
          (t["ﶘ"] = "نجم"),
          (t["ﶙ"] = "نجى"),
          (t["ﶚ"] = "نمي"),
          (t["ﶛ"] = "نمى"),
          (t["ﶜ"] = "يمم"),
          (t["ﶝ"] = "يمم"),
          (t["ﶞ"] = "بخي"),
          (t["ﶟ"] = "تجي"),
          (t["ﶠ"] = "تجى"),
          (t["ﶡ"] = "تخي"),
          (t["ﶢ"] = "تخى"),
          (t["ﶣ"] = "تمي"),
          (t["ﶤ"] = "تمى"),
          (t["ﶥ"] = "جمي"),
          (t["ﶦ"] = "جحى"),
          (t["ﶧ"] = "جمى"),
          (t["ﶨ"] = "سخى"),
          (t["ﶩ"] = "صحي"),
          (t["ﶪ"] = "شحي"),
          (t["ﶫ"] = "ضحي"),
          (t["ﶬ"] = "لجي"),
          (t["ﶭ"] = "لمي"),
          (t["ﶮ"] = "يحي"),
          (t["ﶯ"] = "يجي"),
          (t["ﶰ"] = "يمي"),
          (t["ﶱ"] = "ممي"),
          (t["ﶲ"] = "قمي"),
          (t["ﶳ"] = "نحي"),
          (t["ﶴ"] = "قمح"),
          (t["ﶵ"] = "لحم"),
          (t["ﶶ"] = "عمي"),
          (t["ﶷ"] = "كمي"),
          (t["ﶸ"] = "نجح"),
          (t["ﶹ"] = "مخي"),
          (t["ﶺ"] = "لجم"),
          (t["ﶻ"] = "كمم"),
          (t["ﶼ"] = "لجم"),
          (t["ﶽ"] = "نجح"),
          (t["ﶾ"] = "جحي"),
          (t["ﶿ"] = "حجي"),
          (t["ﷀ"] = "مجي"),
          (t["ﷁ"] = "فمي"),
          (t["ﷂ"] = "بحي"),
          (t["ﷃ"] = "كمم"),
          (t["ﷄ"] = "عجم"),
          (t["ﷅ"] = "صمم"),
          (t["ﷆ"] = "سخي"),
          (t["ﷇ"] = "نجي"),
          (t["﹉"] = "‾"),
          (t["﹊"] = "‾"),
          (t["﹋"] = "‾"),
          (t["﹌"] = "‾"),
          (t["﹍"] = "_"),
          (t["﹎"] = "_"),
          (t["﹏"] = "_"),
          (t["ﺀ"] = "ء"),
          (t["ﺁ"] = "آ"),
          (t["ﺂ"] = "آ"),
          (t["ﺃ"] = "أ"),
          (t["ﺄ"] = "أ"),
          (t["ﺅ"] = "ؤ"),
          (t["ﺆ"] = "ؤ"),
          (t["ﺇ"] = "إ"),
          (t["ﺈ"] = "إ"),
          (t["ﺉ"] = "ئ"),
          (t["ﺊ"] = "ئ"),
          (t["ﺋ"] = "ئ"),
          (t["ﺌ"] = "ئ"),
          (t["ﺍ"] = "ا"),
          (t["ﺎ"] = "ا"),
          (t["ﺏ"] = "ب"),
          (t["ﺐ"] = "ب"),
          (t["ﺑ"] = "ب"),
          (t["ﺒ"] = "ب"),
          (t["ﺓ"] = "ة"),
          (t["ﺔ"] = "ة"),
          (t["ﺕ"] = "ت"),
          (t["ﺖ"] = "ت"),
          (t["ﺗ"] = "ت"),
          (t["ﺘ"] = "ت"),
          (t["ﺙ"] = "ث"),
          (t["ﺚ"] = "ث"),
          (t["ﺛ"] = "ث"),
          (t["ﺜ"] = "ث"),
          (t["ﺝ"] = "ج"),
          (t["ﺞ"] = "ج"),
          (t["ﺟ"] = "ج"),
          (t["ﺠ"] = "ج"),
          (t["ﺡ"] = "ح"),
          (t["ﺢ"] = "ح"),
          (t["ﺣ"] = "ح"),
          (t["ﺤ"] = "ح"),
          (t["ﺥ"] = "خ"),
          (t["ﺦ"] = "خ"),
          (t["ﺧ"] = "خ"),
          (t["ﺨ"] = "خ"),
          (t["ﺩ"] = "د"),
          (t["ﺪ"] = "د"),
          (t["ﺫ"] = "ذ"),
          (t["ﺬ"] = "ذ"),
          (t["ﺭ"] = "ر"),
          (t["ﺮ"] = "ر"),
          (t["ﺯ"] = "ز"),
          (t["ﺰ"] = "ز"),
          (t["ﺱ"] = "س"),
          (t["ﺲ"] = "س"),
          (t["ﺳ"] = "س"),
          (t["ﺴ"] = "س"),
          (t["ﺵ"] = "ش"),
          (t["ﺶ"] = "ش"),
          (t["ﺷ"] = "ش"),
          (t["ﺸ"] = "ش"),
          (t["ﺹ"] = "ص"),
          (t["ﺺ"] = "ص"),
          (t["ﺻ"] = "ص"),
          (t["ﺼ"] = "ص"),
          (t["ﺽ"] = "ض"),
          (t["ﺾ"] = "ض"),
          (t["ﺿ"] = "ض"),
          (t["ﻀ"] = "ض"),
          (t["ﻁ"] = "ط"),
          (t["ﻂ"] = "ط"),
          (t["ﻃ"] = "ط"),
          (t["ﻄ"] = "ط"),
          (t["ﻅ"] = "ظ"),
          (t["ﻆ"] = "ظ"),
          (t["ﻇ"] = "ظ"),
          (t["ﻈ"] = "ظ"),
          (t["ﻉ"] = "ع"),
          (t["ﻊ"] = "ع"),
          (t["ﻋ"] = "ع"),
          (t["ﻌ"] = "ع"),
          (t["ﻍ"] = "غ"),
          (t["ﻎ"] = "غ"),
          (t["ﻏ"] = "غ"),
          (t["ﻐ"] = "غ"),
          (t["ﻑ"] = "ف"),
          (t["ﻒ"] = "ف"),
          (t["ﻓ"] = "ف"),
          (t["ﻔ"] = "ف"),
          (t["ﻕ"] = "ق"),
          (t["ﻖ"] = "ق"),
          (t["ﻗ"] = "ق"),
          (t["ﻘ"] = "ق"),
          (t["ﻙ"] = "ك"),
          (t["ﻚ"] = "ك"),
          (t["ﻛ"] = "ك"),
          (t["ﻜ"] = "ك"),
          (t["ﻝ"] = "ل"),
          (t["ﻞ"] = "ل"),
          (t["ﻟ"] = "ل"),
          (t["ﻠ"] = "ل"),
          (t["ﻡ"] = "م"),
          (t["ﻢ"] = "م"),
          (t["ﻣ"] = "م"),
          (t["ﻤ"] = "م"),
          (t["ﻥ"] = "ن"),
          (t["ﻦ"] = "ن"),
          (t["ﻧ"] = "ن"),
          (t["ﻨ"] = "ن"),
          (t["ﻩ"] = "ه"),
          (t["ﻪ"] = "ه"),
          (t["ﻫ"] = "ه"),
          (t["ﻬ"] = "ه"),
          (t["ﻭ"] = "و"),
          (t["ﻮ"] = "و"),
          (t["ﻯ"] = "ى"),
          (t["ﻰ"] = "ى"),
          (t["ﻱ"] = "ي"),
          (t["ﻲ"] = "ي"),
          (t["ﻳ"] = "ي"),
          (t["ﻴ"] = "ي"),
          (t["ﻵ"] = "لآ"),
          (t["ﻶ"] = "لآ"),
          (t["ﻷ"] = "لأ"),
          (t["ﻸ"] = "لأ"),
          (t["ﻹ"] = "لإ"),
          (t["ﻺ"] = "لإ"),
          (t["ﻻ"] = "لا"),
          (t["ﻼ"] = "لا");
      });
      (r.mapSpecialUnicodeValues = function mapSpecialUnicodeValues(t) {
        return t >= 65520 && t <= 65535
          ? 0
          : t >= 62976 && t <= 63743
          ? o()[t] || t
          : 173 === t
          ? 45
          : t;
      }),
        (r.reverseIfRtl = function reverseIfRtl(t) {
          var r = t.length;
          if (
            r <= 1 ||
            !(function isRTLRangeFor(t) {
              var r = l[13];
              return (
                (t >= r.begin && t < r.end) ||
                (t >= (r = l[11]).begin && t < r.end)
              );
            })(t.charCodeAt(0))
          )
            return t;
          for (var a = "", i = r - 1; i >= 0; i--) a += t[i];
          return a;
        }),
        (r.getUnicodeRangeFor = function getUnicodeRangeFor(t) {
          for (var r = 0, a = l.length; r < a; r++) {
            var i = l[r];
            if (t >= i.begin && t < i.end) return r;
          }
          return -1;
        }),
        (r.getNormalizedUnicodes = c),
        (r.getUnicodeForGlyph = function getUnicodeForGlyph(t, r) {
          var a = r[t];
          if (void 0 !== a) return a;
          if (!t) return -1;
          if ("u" === t[0]) {
            var i,
              o = t.length;
            if (7 === o && "n" === t[1] && "i" === t[2]) i = t.substring(3);
            else {
              if (!(o >= 5 && o <= 7)) return -1;
              i = t.substring(1);
            }
            if (i === i.toUpperCase() && (a = parseInt(i, 16)) >= 0) return a;
          }
          return -1;
        });
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.FontRendererFactory = void 0);
      var i = a(5),
        o = a(223),
        l = a(226),
        c = a(225),
        u = a(205);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _inherits(t, r) {
        if ("function" != typeof r && null !== r)
          throw new TypeError(
            "Super expression must either be null or a function",
          );
        (t.prototype = Object.create(r && r.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          r && _setPrototypeOf(t, r);
      }
      function _setPrototypeOf(t, r) {
        return (_setPrototypeOf =
          Object.setPrototypeOf ||
          function _setPrototypeOf(t, r) {
            return (t.__proto__ = r), t;
          })(t, r);
      }
      function _createSuper(t) {
        var r = (function _isNativeReflectConstruct() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        })();
        return function _createSuperInternal() {
          var a,
            i = _getPrototypeOf(t);
          if (r) {
            var o = _getPrototypeOf(this).constructor;
            a = Reflect.construct(i, arguments, o);
          } else a = i.apply(this, arguments);
          return _possibleConstructorReturn(this, a);
        };
      }
      function _possibleConstructorReturn(t, r) {
        return !r || ("object" !== _typeof(r) && "function" != typeof r)
          ? (function _assertThisInitialized(t) {
              if (void 0 === t)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return t;
            })(t)
          : r;
      }
      function _getPrototypeOf(t) {
        return (_getPrototypeOf = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function _getPrototypeOf(t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var h = (function FontRendererFactoryClosure() {
        function getLong(t, r) {
          return (t[r] << 24) | (t[r + 1] << 16) | (t[r + 2] << 8) | t[r + 3];
        }
        function getUshort(t, r) {
          return (t[r] << 8) | t[r + 1];
        }
        function getSubroutineBias(t) {
          var r = t.length,
            a = 32768;
          return r < 1240 ? (a = 107) : r < 33900 && (a = 1131), a;
        }
        function parseCmap(t, r, a) {
          var o,
            l,
            c,
            u =
              1 === getUshort(t, r + 2)
                ? getLong(t, r + 8)
                : getLong(t, r + 16),
            h = getUshort(t, r + u);
          if (4 === h) {
            getUshort(t, r + u + 2);
            var d = getUshort(t, r + u + 6) >> 1;
            for (l = r + u + 14, o = [], c = 0; c < d; c++, l += 2)
              o[c] = { end: getUshort(t, l) };
            for (l += 2, c = 0; c < d; c++, l += 2)
              o[c].start = getUshort(t, l);
            for (c = 0; c < d; c++, l += 2) o[c].idDelta = getUshort(t, l);
            for (c = 0; c < d; c++, l += 2) {
              var p = getUshort(t, l);
              if (0 !== p) {
                o[c].ids = [];
                for (var m = 0, g = o[c].end - o[c].start + 1; m < g; m++)
                  (o[c].ids[m] = getUshort(t, l + p)), (p += 2);
              }
            }
            return o;
          }
          if (12 === h) {
            getLong(t, r + u + 4);
            var b = getLong(t, r + u + 12);
            for (l = r + u + 16, o = [], c = 0; c < b; c++)
              o.push({
                start: getLong(t, l),
                end: getLong(t, l + 4),
                idDelta: getLong(t, l + 8) - getLong(t, l),
              }),
                (l += 12);
            return o;
          }
          throw new i.FormatError("unsupported cmap: ".concat(h));
        }
        function parseCff(t, r, a, i) {
          var l = new o.CFFParser(new u.Stream(t, r, a - r), {}, i).parse();
          return {
            glyphs: l.charStrings.objects,
            subrs:
              l.topDict.privateDict &&
              l.topDict.privateDict.subrsIndex &&
              l.topDict.privateDict.subrsIndex.objects,
            gsubrs: l.globalSubrIndex && l.globalSubrIndex.objects,
            isCFFCIDFont: l.isCIDFont,
            fdSelect: l.fdSelect,
            fdArray: l.fdArray,
          };
        }
        function lookupCmap(t, r) {
          for (
            var a = r.codePointAt(0), i = 0, o = 0, l = t.length - 1;
            o < l;

          ) {
            var c = (o + l + 1) >> 1;
            a < t[c].start ? (l = c - 1) : (o = c);
          }
          return (
            t[o].start <= a &&
              a <= t[o].end &&
              (i =
                (t[o].idDelta + (t[o].ids ? t[o].ids[a - t[o].start] : a)) &
                65535),
            { charCode: a, glyphId: i }
          );
        }
        function compileGlyf(t, r, a) {
          function moveTo(t, a) {
            r.push({ cmd: "moveTo", args: [t, a] });
          }
          function lineTo(t, a) {
            r.push({ cmd: "lineTo", args: [t, a] });
          }
          function quadraticCurveTo(t, a, i, o) {
            r.push({ cmd: "quadraticCurveTo", args: [t, a, i, o] });
          }
          var i,
            o = 0,
            l = ((t[o] << 24) | (t[o + 1] << 16)) >> 16,
            c = 0,
            u = 0;
          if (((o += 10), l < 0))
            do {
              i = (t[o] << 8) | t[o + 1];
              var h,
                d,
                p = (t[o + 2] << 8) | t[o + 3];
              (o += 4),
                1 & i
                  ? ((h = ((t[o] << 24) | (t[o + 1] << 16)) >> 16),
                    (d = ((t[o + 2] << 24) | (t[o + 3] << 16)) >> 16),
                    (o += 4))
                  : ((h = t[o++]), (d = t[o++])),
                2 & i ? ((c = h), (u = d)) : ((c = 0), (u = 0));
              var m = 1,
                g = 1,
                b = 0,
                y = 0;
              8 & i
                ? ((m = g = ((t[o] << 24) | (t[o + 1] << 16)) / 1073741824),
                  (o += 2))
                : 64 & i
                ? ((m = ((t[o] << 24) | (t[o + 1] << 16)) / 1073741824),
                  (g = ((t[o + 2] << 24) | (t[o + 3] << 16)) / 1073741824),
                  (o += 4))
                : 128 & i &&
                  ((m = ((t[o] << 24) | (t[o + 1] << 16)) / 1073741824),
                  (b = ((t[o + 2] << 24) | (t[o + 3] << 16)) / 1073741824),
                  (y = ((t[o + 4] << 24) | (t[o + 5] << 16)) / 1073741824),
                  (g = ((t[o + 6] << 24) | (t[o + 7] << 16)) / 1073741824),
                  (o += 8));
              var v = a.glyphs[p];
              v &&
                (r.push({ cmd: "save" }),
                r.push({ cmd: "transform", args: [m, b, y, g, c, u] }),
                compileGlyf(v, r, a),
                r.push({ cmd: "restore" }));
            } while (32 & i);
          else {
            var S,
              k,
              w = [];
            for (S = 0; S < l; S++) w.push((t[o] << 8) | t[o + 1]), (o += 2);
            o += 2 + ((t[o] << 8) | t[o + 1]);
            for (var C = w[w.length - 1] + 1, x = []; x.length < C; ) {
              var _ = 1;
              for (8 & (i = t[o++]) && (_ += t[o++]); _-- > 0; )
                x.push({ flags: i });
            }
            for (S = 0; S < C; S++) {
              switch (18 & x[S].flags) {
                case 0:
                  (c += ((t[o] << 24) | (t[o + 1] << 16)) >> 16), (o += 2);
                  break;
                case 2:
                  c -= t[o++];
                  break;
                case 18:
                  c += t[o++];
              }
              x[S].x = c;
            }
            for (S = 0; S < C; S++) {
              switch (36 & x[S].flags) {
                case 0:
                  (u += ((t[o] << 24) | (t[o + 1] << 16)) >> 16), (o += 2);
                  break;
                case 4:
                  u -= t[o++];
                  break;
                case 36:
                  u += t[o++];
              }
              x[S].y = u;
            }
            var A = 0;
            for (o = 0; o < l; o++) {
              var R = w[o],
                T = x.slice(A, R + 1);
              if (1 & T[0].flags) T.push(T[0]);
              else if (1 & T[T.length - 1].flags) T.unshift(T[T.length - 1]);
              else {
                var I = {
                  flags: 1,
                  x: (T[0].x + T[T.length - 1].x) / 2,
                  y: (T[0].y + T[T.length - 1].y) / 2,
                };
                T.unshift(I), T.push(I);
              }
              for (moveTo(T[0].x, T[0].y), S = 1, k = T.length; S < k; S++)
                1 & T[S].flags
                  ? lineTo(T[S].x, T[S].y)
                  : 1 & T[S + 1].flags
                  ? (quadraticCurveTo(T[S].x, T[S].y, T[S + 1].x, T[S + 1].y),
                    S++)
                  : quadraticCurveTo(
                      T[S].x,
                      T[S].y,
                      (T[S].x + T[S + 1].x) / 2,
                      (T[S].y + T[S + 1].y) / 2,
                    );
              A = R + 1;
            }
          }
        }
        function compileCharString(t, r, a, o) {
          function moveTo(t, a) {
            r.push({ cmd: "moveTo", args: [t, a] });
          }
          function lineTo(t, a) {
            r.push({ cmd: "lineTo", args: [t, a] });
          }
          function bezierCurveTo(t, a, i, o, l, c) {
            r.push({ cmd: "bezierCurveTo", args: [t, a, i, o, l, c] });
          }
          var l = [],
            u = 0,
            h = 0,
            d = 0;
          !(function parse(t) {
            for (var p = 0; p < t.length; ) {
              var m,
                g,
                b,
                y,
                v,
                S,
                k,
                w,
                C = !1,
                x = t[p++];
              switch (x) {
                case 1:
                case 3:
                  (d += l.length >> 1), (C = !0);
                  break;
                case 4:
                  (h += l.pop()), moveTo(u, h), (C = !0);
                  break;
                case 5:
                  for (; l.length > 0; )
                    (u += l.shift()), (h += l.shift()), lineTo(u, h);
                  break;
                case 6:
                  for (
                    ;
                    l.length > 0 &&
                    (lineTo((u += l.shift()), h), 0 !== l.length);

                  )
                    (h += l.shift()), lineTo(u, h);
                  break;
                case 7:
                  for (
                    ;
                    l.length > 0 &&
                    ((h += l.shift()), lineTo(u, h), 0 !== l.length);

                  )
                    lineTo((u += l.shift()), h);
                  break;
                case 8:
                  for (; l.length > 0; )
                    (m = u + l.shift()),
                      (b = h + l.shift()),
                      (g = m + l.shift()),
                      (y = b + l.shift()),
                      (u = g + l.shift()),
                      (h = y + l.shift()),
                      bezierCurveTo(m, b, g, y, u, h);
                  break;
                case 10:
                  if (((k = l.pop()), (w = null), a.isCFFCIDFont)) {
                    var _ = a.fdSelect.getFDIndex(o);
                    if (_ >= 0 && _ < a.fdArray.length) {
                      var A = a.fdArray[_],
                        R = void 0;
                      A.privateDict &&
                        A.privateDict.subrsIndex &&
                        (R = A.privateDict.subrsIndex.objects),
                        R && (w = R[(k += getSubroutineBias(R))]);
                    } else (0, i.warn)("Invalid fd index for glyph index.");
                  } else w = a.subrs[k + a.subrsBias];
                  w && parse(w);
                  break;
                case 11:
                  return;
                case 12:
                  switch ((x = t[p++])) {
                    case 34:
                      (g = (m = u + l.shift()) + l.shift()),
                        (v = h + l.shift()),
                        (u = g + l.shift()),
                        bezierCurveTo(m, h, g, v, u, v),
                        (g = (m = u + l.shift()) + l.shift()),
                        (u = g + l.shift()),
                        bezierCurveTo(m, v, g, h, u, h);
                      break;
                    case 35:
                      (m = u + l.shift()),
                        (b = h + l.shift()),
                        (g = m + l.shift()),
                        (y = b + l.shift()),
                        (u = g + l.shift()),
                        (h = y + l.shift()),
                        bezierCurveTo(m, b, g, y, u, h),
                        (m = u + l.shift()),
                        (b = h + l.shift()),
                        (g = m + l.shift()),
                        (y = b + l.shift()),
                        (u = g + l.shift()),
                        (h = y + l.shift()),
                        bezierCurveTo(m, b, g, y, u, h),
                        l.pop();
                      break;
                    case 36:
                      bezierCurveTo(
                        (m = u + l.shift()),
                        (v = h + l.shift()),
                        (g = m + l.shift()),
                        (S = v + l.shift()),
                        (u = g + l.shift()),
                        S,
                      ),
                        bezierCurveTo(
                          (m = u + l.shift()),
                          S,
                          (g = m + l.shift()),
                          S + l.shift(),
                          (u = g + l.shift()),
                          h,
                        );
                      break;
                    case 37:
                      var T = u,
                        I = h;
                      (m = u + l.shift()),
                        (b = h + l.shift()),
                        (g = m + l.shift()),
                        (y = b + l.shift()),
                        (u = g + l.shift()),
                        (h = y + l.shift()),
                        bezierCurveTo(m, b, g, y, u, h),
                        (m = u + l.shift()),
                        (b = h + l.shift()),
                        (g = m + l.shift()),
                        (y = b + l.shift()),
                        (u = g),
                        (h = y),
                        Math.abs(u - T) > Math.abs(h - I)
                          ? (u += l.shift())
                          : (h += l.shift()),
                        bezierCurveTo(m, b, g, y, u, h);
                      break;
                    default:
                      throw new i.FormatError(
                        "unknown operator: 12 ".concat(x),
                      );
                  }
                  break;
                case 14:
                  if (l.length >= 4) {
                    var P = l.pop(),
                      O = l.pop();
                    (h = l.pop()),
                      (u = l.pop()),
                      r.push({ cmd: "save" }),
                      r.push({ cmd: "translate", args: [u, h] });
                    var E = lookupCmap(
                      a.cmap,
                      String.fromCharCode(
                        a.glyphNameMap[c.StandardEncoding[P]],
                      ),
                    );
                    compileCharString(a.glyphs[E.glyphId], r, a, E.glyphId),
                      r.push({ cmd: "restore" }),
                      (E = lookupCmap(
                        a.cmap,
                        String.fromCharCode(
                          a.glyphNameMap[c.StandardEncoding[O]],
                        ),
                      )),
                      compileCharString(a.glyphs[E.glyphId], r, a, E.glyphId);
                  }
                  return;
                case 18:
                  (d += l.length >> 1), (C = !0);
                  break;
                case 19:
                case 20:
                  (p += ((d += l.length >> 1) + 7) >> 3), (C = !0);
                  break;
                case 21:
                  (h += l.pop()), moveTo((u += l.pop()), h), (C = !0);
                  break;
                case 22:
                  moveTo((u += l.pop()), h), (C = !0);
                  break;
                case 23:
                  (d += l.length >> 1), (C = !0);
                  break;
                case 24:
                  for (; l.length > 2; )
                    (m = u + l.shift()),
                      (b = h + l.shift()),
                      (g = m + l.shift()),
                      (y = b + l.shift()),
                      (u = g + l.shift()),
                      (h = y + l.shift()),
                      bezierCurveTo(m, b, g, y, u, h);
                  (u += l.shift()), (h += l.shift()), lineTo(u, h);
                  break;
                case 25:
                  for (; l.length > 6; )
                    (u += l.shift()), (h += l.shift()), lineTo(u, h);
                  (m = u + l.shift()),
                    (b = h + l.shift()),
                    (g = m + l.shift()),
                    (y = b + l.shift()),
                    (u = g + l.shift()),
                    (h = y + l.shift()),
                    bezierCurveTo(m, b, g, y, u, h);
                  break;
                case 26:
                  for (l.length % 2 && (u += l.shift()); l.length > 0; )
                    (m = u),
                      (b = h + l.shift()),
                      (g = m + l.shift()),
                      (y = b + l.shift()),
                      (u = g),
                      (h = y + l.shift()),
                      bezierCurveTo(m, b, g, y, u, h);
                  break;
                case 27:
                  for (l.length % 2 && (h += l.shift()); l.length > 0; )
                    bezierCurveTo(
                      (m = u + l.shift()),
                      (b = h),
                      (g = m + l.shift()),
                      (y = b + l.shift()),
                      (u = g + l.shift()),
                      (h = y),
                    );
                  break;
                case 28:
                  l.push(((t[p] << 24) | (t[p + 1] << 16)) >> 16), (p += 2);
                  break;
                case 29:
                  (k = l.pop() + a.gsubrsBias), (w = a.gsubrs[k]) && parse(w);
                  break;
                case 30:
                  for (
                    ;
                    l.length > 0 &&
                    ((m = u),
                    (b = h + l.shift()),
                    (g = m + l.shift()),
                    (y = b + l.shift()),
                    (u = g + l.shift()),
                    (h = y + (1 === l.length ? l.shift() : 0)),
                    bezierCurveTo(m, b, g, y, u, h),
                    0 !== l.length);

                  )
                    (m = u + l.shift()),
                      (b = h),
                      (g = m + l.shift()),
                      (y = b + l.shift()),
                      (h = y + l.shift()),
                      bezierCurveTo(
                        m,
                        b,
                        g,
                        y,
                        (u = g + (1 === l.length ? l.shift() : 0)),
                        h,
                      );
                  break;
                case 31:
                  for (
                    ;
                    l.length > 0 &&
                    ((m = u + l.shift()),
                    (b = h),
                    (g = m + l.shift()),
                    (y = b + l.shift()),
                    (h = y + l.shift()),
                    bezierCurveTo(
                      m,
                      b,
                      g,
                      y,
                      (u = g + (1 === l.length ? l.shift() : 0)),
                      h,
                    ),
                    0 !== l.length);

                  )
                    (m = u),
                      (b = h + l.shift()),
                      (g = m + l.shift()),
                      (y = b + l.shift()),
                      (u = g + l.shift()),
                      (h = y + (1 === l.length ? l.shift() : 0)),
                      bezierCurveTo(m, b, g, y, u, h);
                  break;
                default:
                  if (x < 32)
                    throw new i.FormatError("unknown operator: ".concat(x));
                  x < 247
                    ? l.push(x - 139)
                    : x < 251
                    ? l.push(256 * (x - 247) + t[p++] + 108)
                    : x < 255
                    ? l.push(256 * -(x - 251) - t[p++] - 108)
                    : (l.push(
                        ((t[p] << 24) |
                          (t[p + 1] << 16) |
                          (t[p + 2] << 8) |
                          t[p + 3]) /
                          65536,
                      ),
                      (p += 4));
              }
              C && (l.length = 0);
            }
          })(t);
        }
        var t = [],
          r = (function () {
            function CompiledFont(t) {
              _classCallCheck(this, CompiledFont),
                this.constructor === CompiledFont &&
                  (0, i.unreachable)("Cannot initialize CompiledFont."),
                (this.fontMatrix = t),
                (this.compiledGlyphs = Object.create(null)),
                (this.compiledCharCodeToGlyphId = Object.create(null));
            }
            return (
              _createClass(CompiledFont, [
                {
                  key: "getPathJs",
                  value: function getPathJs(t) {
                    var r = lookupCmap(this.cmap, t),
                      a = this.compiledGlyphs[r.glyphId];
                    return (
                      a ||
                        ((a = this.compileGlyph(
                          this.glyphs[r.glyphId],
                          r.glyphId,
                        )),
                        (this.compiledGlyphs[r.glyphId] = a)),
                      void 0 === this.compiledCharCodeToGlyphId[r.charCode] &&
                        (this.compiledCharCodeToGlyphId[r.charCode] =
                          r.glyphId),
                      a
                    );
                  },
                },
                {
                  key: "compileGlyph",
                  value: function compileGlyph(r, a) {
                    if (!r || 0 === r.length || 14 === r[0]) return t;
                    var o = this.fontMatrix;
                    if (this.isCFFCIDFont) {
                      var l = this.fdSelect.getFDIndex(a);
                      if (l >= 0 && l < this.fdArray.length)
                        o =
                          this.fdArray[l].getByName("FontMatrix") ||
                          i.FONT_IDENTITY_MATRIX;
                      else (0, i.warn)("Invalid fd index for glyph index.");
                    }
                    var c = [];
                    return (
                      c.push({ cmd: "save" }),
                      c.push({ cmd: "transform", args: o.slice() }),
                      c.push({ cmd: "scale", args: ["size", "-size"] }),
                      this.compileGlyphImpl(r, c, a),
                      c.push({ cmd: "restore" }),
                      c
                    );
                  },
                },
                {
                  key: "compileGlyphImpl",
                  value: function compileGlyphImpl() {
                    (0, i.unreachable)(
                      "Children classes should implement this.",
                    );
                  },
                },
                {
                  key: "hasBuiltPath",
                  value: function hasBuiltPath(t) {
                    var r = lookupCmap(this.cmap, t);
                    return (
                      void 0 !== this.compiledGlyphs[r.glyphId] &&
                      void 0 !== this.compiledCharCodeToGlyphId[r.charCode]
                    );
                  },
                },
              ]),
              CompiledFont
            );
          })(),
          a = (function (t) {
            _inherits(TrueTypeCompiled, t);
            var r = _createSuper(TrueTypeCompiled);
            function TrueTypeCompiled(t, a, i) {
              var o;
              return (
                _classCallCheck(this, TrueTypeCompiled),
                ((o = r.call(this, i || [488e-6, 0, 0, 488e-6, 0, 0])).glyphs =
                  t),
                (o.cmap = a),
                o
              );
            }
            return (
              _createClass(TrueTypeCompiled, [
                {
                  key: "compileGlyphImpl",
                  value: function compileGlyphImpl(t, r) {
                    compileGlyf(t, r, this);
                  },
                },
              ]),
              TrueTypeCompiled
            );
          })(r),
          h = (function (t) {
            _inherits(Type2Compiled, t);
            var r = _createSuper(Type2Compiled);
            function Type2Compiled(t, a, i, o) {
              var c;
              return (
                _classCallCheck(this, Type2Compiled),
                ((c = r.call(this, i || [0.001, 0, 0, 0.001, 0, 0])).glyphs =
                  t.glyphs),
                (c.gsubrs = t.gsubrs || []),
                (c.subrs = t.subrs || []),
                (c.cmap = a),
                (c.glyphNameMap = o || (0, l.getGlyphsUnicode)()),
                (c.gsubrsBias = getSubroutineBias(c.gsubrs)),
                (c.subrsBias = getSubroutineBias(c.subrs)),
                (c.isCFFCIDFont = t.isCFFCIDFont),
                (c.fdSelect = t.fdSelect),
                (c.fdArray = t.fdArray),
                c
              );
            }
            return (
              _createClass(Type2Compiled, [
                {
                  key: "compileGlyphImpl",
                  value: function compileGlyphImpl(t, r, a) {
                    compileCharString(t, r, this, a);
                  },
                },
              ]),
              Type2Compiled
            );
          })(r);
        return {
          create: function FontRendererFactory_create(t, r) {
            for (
              var o,
                l,
                c,
                u,
                d,
                p,
                m = new Uint8Array(t.data),
                g = getUshort(m, 4),
                b = 0,
                y = 12;
              b < g;
              b++, y += 16
            ) {
              var v = (0, i.bytesToString)(m.subarray(y, y + 4)),
                S = getLong(m, y + 8),
                k = getLong(m, y + 12);
              switch (v) {
                case "cmap":
                  o = parseCmap(m, S);
                  break;
                case "glyf":
                  l = m.subarray(S, S + k);
                  break;
                case "loca":
                  c = m.subarray(S, S + k);
                  break;
                case "head":
                  (p = getUshort(m, S + 18)), (d = getUshort(m, S + 50));
                  break;
                case "CFF ":
                  u = parseCff(m, S, S + k, r);
              }
            }
            if (l) {
              var w = p ? [1 / p, 0, 0, 1 / p, 0, 0] : t.fontMatrix;
              return new a(
                (function parseGlyfTable(t, r, a) {
                  var i, o;
                  a
                    ? ((i = 4),
                      (o = function fontItemDecodeLong(t, r) {
                        return (
                          (t[r] << 24) |
                          (t[r + 1] << 16) |
                          (t[r + 2] << 8) |
                          t[r + 3]
                        );
                      }))
                    : ((i = 2),
                      (o = function fontItemDecode(t, r) {
                        return (t[r] << 9) | (t[r + 1] << 1);
                      }));
                  for (var l = [], c = o(r, 0), u = i; u < r.length; u += i) {
                    var h = o(r, u);
                    l.push(t.subarray(c, h)), (c = h);
                  }
                  return l;
                })(l, c, d),
                o,
                w,
              );
            }
            return new h(u, o, t.fontMatrix, t.glyphNameMap);
          },
        };
      })();
      r.FontRendererFactory = h;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.Type1Parser = void 0);
      var i = a(225),
        o = a(201),
        l = a(205),
        c = a(5),
        u = (function Type1CharStringClosure() {
          var t = [4],
            r = [5],
            a = [6],
            i = [7],
            o = [8],
            l = [12, 35],
            u = [14],
            h = [21],
            d = [22],
            p = [30],
            m = [31];
          function Type1CharString() {
            (this.width = 0),
              (this.lsb = 0),
              (this.flexing = !1),
              (this.output = []),
              (this.stack = []);
          }
          return (
            (Type1CharString.prototype = {
              convert: function Type1CharString_convert(g, b, y) {
                for (var v, S, k, w = g.length, C = !1, x = 0; x < w; x++) {
                  var _ = g[x];
                  if (_ < 32) {
                    switch ((12 === _ && (_ = (_ << 8) + g[++x]), _)) {
                      case 1:
                      case 3:
                        this.stack = [];
                        break;
                      case 4:
                        if (this.flexing) {
                          if (this.stack.length < 1) {
                            C = !0;
                            break;
                          }
                          var A = this.stack.pop();
                          this.stack.push(0, A);
                          break;
                        }
                        C = this.executeCommand(1, t);
                        break;
                      case 5:
                        C = this.executeCommand(2, r);
                        break;
                      case 6:
                        C = this.executeCommand(1, a);
                        break;
                      case 7:
                        C = this.executeCommand(1, i);
                        break;
                      case 8:
                        C = this.executeCommand(6, o);
                        break;
                      case 9:
                        this.stack = [];
                        break;
                      case 10:
                        if (this.stack.length < 1) {
                          C = !0;
                          break;
                        }
                        if (!b[(k = this.stack.pop())]) {
                          C = !0;
                          break;
                        }
                        C = this.convert(b[k], b, y);
                        break;
                      case 11:
                        return C;
                      case 13:
                        if (this.stack.length < 2) {
                          C = !0;
                          break;
                        }
                        (v = this.stack.pop()),
                          (S = this.stack.pop()),
                          (this.lsb = S),
                          (this.width = v),
                          this.stack.push(v, S),
                          (C = this.executeCommand(2, d));
                        break;
                      case 14:
                        this.output.push(u[0]);
                        break;
                      case 21:
                        if (this.flexing) break;
                        C = this.executeCommand(2, h);
                        break;
                      case 22:
                        if (this.flexing) {
                          this.stack.push(0);
                          break;
                        }
                        C = this.executeCommand(1, d);
                        break;
                      case 30:
                        C = this.executeCommand(4, p);
                        break;
                      case 31:
                        C = this.executeCommand(4, m);
                        break;
                      case 3072:
                      case 3073:
                      case 3074:
                        this.stack = [];
                        break;
                      case 3078:
                        y
                          ? ((this.seac = this.stack.splice(-4, 4)),
                            (C = this.executeCommand(0, u)))
                          : (C = this.executeCommand(4, u));
                        break;
                      case 3079:
                        if (this.stack.length < 4) {
                          C = !0;
                          break;
                        }
                        this.stack.pop(), (v = this.stack.pop());
                        var R = this.stack.pop();
                        (S = this.stack.pop()),
                          (this.lsb = S),
                          (this.width = v),
                          this.stack.push(v, S, R),
                          (C = this.executeCommand(3, h));
                        break;
                      case 3084:
                        if (this.stack.length < 2) {
                          C = !0;
                          break;
                        }
                        var T = this.stack.pop(),
                          I = this.stack.pop();
                        this.stack.push(I / T);
                        break;
                      case 3088:
                        if (this.stack.length < 2) {
                          C = !0;
                          break;
                        }
                        k = this.stack.pop();
                        var P = this.stack.pop();
                        if (0 === k && 3 === P) {
                          var O = this.stack.splice(this.stack.length - 17, 17);
                          this.stack.push(
                            O[2] + O[0],
                            O[3] + O[1],
                            O[4],
                            O[5],
                            O[6],
                            O[7],
                            O[8],
                            O[9],
                            O[10],
                            O[11],
                            O[12],
                            O[13],
                            O[14],
                          ),
                            (C = this.executeCommand(13, l, !0)),
                            (this.flexing = !1),
                            this.stack.push(O[15], O[16]);
                        } else 1 === k && 0 === P && (this.flexing = !0);
                        break;
                      case 3089:
                        break;
                      case 3105:
                        this.stack = [];
                        break;
                      default:
                        (0, c.warn)(
                          'Unknown type 1 charstring command of "' + _ + '"',
                        );
                    }
                    if (C) break;
                  } else
                    _ <= 246
                      ? (_ -= 139)
                      : (_ =
                          _ <= 250
                            ? 256 * (_ - 247) + g[++x] + 108
                            : _ <= 254
                            ? -256 * (_ - 251) - g[++x] - 108
                            : ((255 & g[++x]) << 24) |
                              ((255 & g[++x]) << 16) |
                              ((255 & g[++x]) << 8) |
                              ((255 & g[++x]) << 0)),
                      this.stack.push(_);
                }
                return C;
              },
              executeCommand: function executeCommand(t, r, a) {
                var i = this.stack.length;
                if (t > i) return !0;
                for (var o = i - t, l = o; l < i; l++) {
                  var c = this.stack[l];
                  Number.isInteger(c)
                    ? this.output.push(28, (c >> 8) & 255, 255 & c)
                    : ((c = (65536 * c) | 0),
                      this.output.push(
                        255,
                        (c >> 24) & 255,
                        (c >> 16) & 255,
                        (c >> 8) & 255,
                        255 & c,
                      ));
                }
                return (
                  this.output.push.apply(this.output, r),
                  a ? this.stack.splice(o, t) : (this.stack.length = 0),
                  !1
                );
              },
            }),
            Type1CharString
          );
        })(),
        h = (function Type1ParserClosure() {
          function isHexDigit(t) {
            return (
              (t >= 48 && t <= 57) ||
              (t >= 65 && t <= 70) ||
              (t >= 97 && t <= 102)
            );
          }
          function decrypt(t, r, a) {
            if (a >= t.length) return new Uint8Array(0);
            var i,
              o,
              l = 0 | r;
            for (i = 0; i < a; i++) l = (52845 * (t[i] + l) + 22719) & 65535;
            var c = t.length - a,
              u = new Uint8Array(c);
            for (i = a, o = 0; o < c; i++, o++) {
              var h = t[i];
              (u[o] = h ^ (l >> 8)), (l = (52845 * (h + l) + 22719) & 65535);
            }
            return u;
          }
          function isSpecial(t) {
            return (
              47 === t ||
              91 === t ||
              93 === t ||
              123 === t ||
              125 === t ||
              40 === t ||
              41 === t
            );
          }
          function Type1Parser(t, r, a) {
            if (r) {
              var i = t.getBytes(),
                c = !(
                  (isHexDigit(i[0]) || (0, o.isWhiteSpace)(i[0])) &&
                  isHexDigit(i[1]) &&
                  isHexDigit(i[2]) &&
                  isHexDigit(i[3]) &&
                  isHexDigit(i[4]) &&
                  isHexDigit(i[5]) &&
                  isHexDigit(i[6]) &&
                  isHexDigit(i[7])
                );
              t = new l.Stream(
                c
                  ? decrypt(i, 55665, 4)
                  : (function decryptAscii(t, r, a) {
                      var i,
                        o,
                        l = 0 | r,
                        c = t.length,
                        u = new Uint8Array(c >>> 1);
                      for (i = 0, o = 0; i < c; i++) {
                        var h = t[i];
                        if (isHexDigit(h)) {
                          var d;
                          for (i++; i < c && !isHexDigit((d = t[i])); ) i++;
                          if (i < c) {
                            var p = parseInt(String.fromCharCode(h, d), 16);
                            (u[o++] = p ^ (l >> 8)),
                              (l = (52845 * (p + l) + 22719) & 65535);
                          }
                        }
                      }
                      return u.slice(a, o);
                    })(i, 55665, 4),
              );
            }
            (this.seacAnalysisEnabled = !!a),
              (this.stream = t),
              this.nextChar();
          }
          return (
            (Type1Parser.prototype = {
              readNumberArray: function Type1Parser_readNumberArray() {
                this.getToken();
                for (var t = []; ; ) {
                  var r = this.getToken();
                  if (null === r || "]" === r || "}" === r) break;
                  t.push(parseFloat(r || 0));
                }
                return t;
              },
              readNumber: function Type1Parser_readNumber() {
                var t = this.getToken();
                return parseFloat(t || 0);
              },
              readInt: function Type1Parser_readInt() {
                var t = this.getToken();
                return 0 | parseInt(t || 0, 10);
              },
              readBoolean: function Type1Parser_readBoolean() {
                return "true" === this.getToken() ? 1 : 0;
              },
              nextChar: function Type1_nextChar() {
                return (this.currentChar = this.stream.getByte());
              },
              getToken: function Type1Parser_getToken() {
                for (var t = !1, r = this.currentChar; ; ) {
                  if (-1 === r) return null;
                  if (t) (10 !== r && 13 !== r) || (t = !1);
                  else if (37 === r) t = !0;
                  else if (!(0, o.isWhiteSpace)(r)) break;
                  r = this.nextChar();
                }
                if (isSpecial(r))
                  return this.nextChar(), String.fromCharCode(r);
                var a = "";
                do {
                  (a += String.fromCharCode(r)), (r = this.nextChar());
                } while (r >= 0 && !(0, o.isWhiteSpace)(r) && !isSpecial(r));
                return a;
              },
              readCharStrings: function Type1Parser_readCharStrings(t, r) {
                return -1 === r ? t : decrypt(t, 4330, r);
              },
              extractFontProgram: function Type1Parser_extractFontProgram(t) {
                var r = this.stream,
                  a = [],
                  i = [],
                  o = Object.create(null);
                o.lenIV = 4;
                for (
                  var l,
                    c,
                    h,
                    d,
                    p,
                    m = {
                      subrs: [],
                      charstrings: [],
                      properties: { privateData: o },
                    };
                  null !== (l = this.getToken());

                )
                  if ("/" === l)
                    switch ((l = this.getToken())) {
                      case "CharStrings":
                        for (
                          this.getToken(),
                            this.getToken(),
                            this.getToken(),
                            this.getToken();
                          null !== (l = this.getToken()) && "end" !== l;

                        )
                          if ("/" === l) {
                            var g = this.getToken();
                            (c = this.readInt()),
                              this.getToken(),
                              (h = c > 0 ? r.getBytes(c) : new Uint8Array(0)),
                              (d = m.properties.privateData.lenIV),
                              (p = this.readCharStrings(h, d)),
                              this.nextChar(),
                              "noaccess" === (l = this.getToken()) &&
                                this.getToken(),
                              i.push({ glyph: g, encoded: p });
                          }
                        break;
                      case "Subrs":
                        for (
                          this.readInt(), this.getToken();
                          "dup" === this.getToken();

                        ) {
                          var b = this.readInt();
                          (c = this.readInt()),
                            this.getToken(),
                            (h = c > 0 ? r.getBytes(c) : new Uint8Array(0)),
                            (d = m.properties.privateData.lenIV),
                            (p = this.readCharStrings(h, d)),
                            this.nextChar(),
                            "noaccess" === (l = this.getToken()) &&
                              this.getToken(),
                            (a[b] = p);
                        }
                        break;
                      case "BlueValues":
                      case "OtherBlues":
                      case "FamilyBlues":
                      case "FamilyOtherBlues":
                        var y = this.readNumberArray();
                        y.length > 0 && y.length, 0;
                        break;
                      case "StemSnapH":
                      case "StemSnapV":
                        m.properties.privateData[l] = this.readNumberArray();
                        break;
                      case "StdHW":
                      case "StdVW":
                        m.properties.privateData[l] = this.readNumberArray()[0];
                        break;
                      case "BlueShift":
                      case "lenIV":
                      case "BlueFuzz":
                      case "BlueScale":
                      case "LanguageGroup":
                      case "ExpansionFactor":
                        m.properties.privateData[l] = this.readNumber();
                        break;
                      case "ForceBold":
                        m.properties.privateData[l] = this.readBoolean();
                    }
                for (var v = 0; v < i.length; v++) {
                  (g = i[v].glyph), (p = i[v].encoded);
                  var S = new u(),
                    k = S.convert(p, a, this.seacAnalysisEnabled),
                    w = S.output;
                  k && (w = [14]);
                  var C = {
                    glyphName: g,
                    charstring: w,
                    width: S.width,
                    lsb: S.lsb,
                    seac: S.seac,
                  };
                  if (
                    (".notdef" === g
                      ? m.charstrings.unshift(C)
                      : m.charstrings.push(C),
                    t.builtInEncoding)
                  ) {
                    var x = t.builtInEncoding.indexOf(g);
                    x > -1 &&
                      void 0 === t.widths[x] &&
                      x >= t.firstChar &&
                      x <= t.lastChar &&
                      (t.widths[x] = S.width);
                  }
                }
                return m;
              },
              extractFontHeader: function Type1Parser_extractFontHeader(t) {
                for (var r; null !== (r = this.getToken()); )
                  if ("/" === r)
                    switch ((r = this.getToken())) {
                      case "FontMatrix":
                        var a = this.readNumberArray();
                        t.fontMatrix = a;
                        break;
                      case "Encoding":
                        var o,
                          l = this.getToken();
                        if (/^\d+$/.test(l)) {
                          o = [];
                          var c = 0 | parseInt(l, 10);
                          this.getToken();
                          for (var u = 0; u < c; u++) {
                            for (
                              r = this.getToken();
                              "dup" !== r && "def" !== r;

                            )
                              if (null === (r = this.getToken())) return;
                            if ("def" === r) break;
                            var h = this.readInt();
                            this.getToken();
                            var d = this.getToken();
                            (o[h] = d), this.getToken();
                          }
                        } else o = (0, i.getEncoding)(l);
                        t.builtInEncoding = o;
                        break;
                      case "FontBBox":
                        var p = this.readNumberArray();
                        (t.ascent = Math.max(p[3], p[1])),
                          (t.descent = Math.min(p[1], p[3])),
                          (t.ascentScaled = !0);
                    }
              },
            }),
            Type1Parser
          );
        })();
      r.Type1Parser = h;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.getTilingPatternIR = function getTilingPatternIR(t, r, a) {
          var o = r.getArray("Matrix"),
            l = i.Util.normalizeRect(r.getArray("BBox")),
            c = r.get("XStep"),
            u = r.get("YStep"),
            h = r.get("PaintType"),
            d = r.get("TilingType");
          if (l[2] - l[0] == 0 || l[3] - l[1] == 0)
            throw new i.FormatError(
              "Invalid getTilingPatternIR /BBox array: [".concat(l, "]."),
            );
          return ["TilingPattern", a, t, o, l, c, u, h, d];
        }),
        (r.Pattern = void 0);
      var i = a(5),
        o = a(216),
        l = a(198),
        c = a(201),
        u = 2,
        h = 3,
        d = 4,
        p = 5,
        m = 6,
        g = 7,
        b = (function PatternClosure() {
          function Pattern() {
            (0, i.unreachable)("should not call Pattern constructor");
          }
          return (
            (Pattern.prototype = {
              getPattern: function Pattern_getPattern(t) {
                (0, i.unreachable)(
                  "Should not call Pattern.getStyle: ".concat(t),
                );
              },
            }),
            (Pattern.parseShading = function (t, r, a, o, b, v) {
              var S = (0, l.isStream)(t) ? t.dict : t,
                k = S.get("ShadingType");
              try {
                switch (k) {
                  case u:
                  case h:
                    return new y.RadialAxial(S, r, a, o, v);
                  case d:
                  case p:
                  case m:
                  case g:
                    return new y.Mesh(t, r, a, o, v);
                  default:
                    throw new i.FormatError("Unsupported ShadingType: " + k);
                }
              } catch (t) {
                if (t instanceof c.MissingDataException) throw t;
                return (
                  b.send("UnsupportedFeature", {
                    featureId: i.UNSUPPORTED_FEATURES.shadingPattern,
                  }),
                  (0, i.warn)(t),
                  new y.Dummy()
                );
              }
            }),
            Pattern
          );
        })();
      r.Pattern = b;
      var y = {};
      (y.SMALL_NUMBER = 1e-6),
        (y.RadialAxial = (function RadialAxialClosure() {
          function RadialAxial(t, r, a, l, c) {
            (this.matrix = r),
              (this.coordsArr = t.getArray("Coords")),
              (this.shadingType = t.get("ShadingType")),
              (this.type = "Pattern");
            var u = t.get("ColorSpace", "CS");
            (u = o.ColorSpace.parse(u, a, l, c)), (this.cs = u);
            var d = t.getArray("BBox");
            Array.isArray(d) && 4 === d.length
              ? (this.bbox = i.Util.normalizeRect(d))
              : (this.bbox = null);
            var p = 0,
              m = 1;
            if (t.has("Domain")) {
              var g = t.getArray("Domain");
              (p = g[0]), (m = g[1]);
            }
            var b = !1,
              v = !1;
            if (t.has("Extend")) {
              var S = t.getArray("Extend");
              (b = S[0]), (v = S[1]);
            }
            if (!(this.shadingType !== h || (b && v))) {
              var k = this.coordsArr[0],
                w = this.coordsArr[1],
                C = this.coordsArr[2],
                x = this.coordsArr[3],
                _ = this.coordsArr[4],
                A = this.coordsArr[5],
                R = Math.sqrt((k - x) * (k - x) + (w - _) * (w - _));
              C <= A + R &&
                A <= C + R &&
                (0, i.warn)("Unsupported radial gradient.");
            }
            (this.extendStart = b), (this.extendEnd = v);
            var T = t.get("Function"),
              I = c.createFromArray(T),
              P = (m - p) / 10,
              O = (this.colorStops = []);
            if (p >= m || P <= 0) (0, i.info)("Bad shading domain.");
            else {
              for (
                var E,
                  B = new Float32Array(u.numComps),
                  D = new Float32Array(1),
                  M = 0;
                M <= 10;
                M++
              ) {
                (D[0] = p + M * P), I(D, 0, B, 0), (E = u.getRgb(B, 0));
                var L = i.Util.makeCssRgb(E[0], E[1], E[2]);
                O.push([M / 10, L]);
              }
              var N = "transparent";
              t.has("Background") &&
                ((E = u.getRgb(t.get("Background"), 0)),
                (N = i.Util.makeCssRgb(E[0], E[1], E[2]))),
                b || (O.unshift([0, N]), (O[1][0] += y.SMALL_NUMBER)),
                v || ((O[O.length - 1][0] -= y.SMALL_NUMBER), O.push([1, N])),
                (this.colorStops = O);
            }
          }
          return (
            (RadialAxial.prototype = {
              getIR: function RadialAxial_getIR() {
                var t,
                  r,
                  a,
                  o,
                  l,
                  c = this.coordsArr,
                  d = this.shadingType;
                d === u
                  ? ((r = [c[0], c[1]]),
                    (a = [c[2], c[3]]),
                    (o = null),
                    (l = null),
                    (t = "axial"))
                  : d === h
                  ? ((r = [c[0], c[1]]),
                    (a = [c[3], c[4]]),
                    (o = c[2]),
                    (l = c[5]),
                    (t = "radial"))
                  : (0, i.unreachable)("getPattern type unknown: ".concat(d));
                var p = this.matrix;
                if (
                  p &&
                  ((r = i.Util.applyTransform(r, p)),
                  (a = i.Util.applyTransform(a, p)),
                  d === h)
                ) {
                  var m = i.Util.singularValueDecompose2dScale(p);
                  (o *= m[0]), (l *= m[1]);
                }
                return [
                  "RadialAxial",
                  t,
                  this.bbox,
                  this.colorStops,
                  r,
                  a,
                  o,
                  l,
                ];
              },
            }),
            RadialAxial
          );
        })()),
        (y.Mesh = (function MeshClosure() {
          function MeshStreamReader(t, r) {
            (this.stream = t),
              (this.context = r),
              (this.buffer = 0),
              (this.bufferLength = 0);
            var a = r.numComps;
            this.tmpCompsBuf = new Float32Array(a);
            var i = r.colorSpace.numComps;
            this.tmpCsCompsBuf = r.colorFn
              ? new Float32Array(i)
              : this.tmpCompsBuf;
          }
          MeshStreamReader.prototype = {
            get hasData() {
              if (this.stream.end) return this.stream.pos < this.stream.end;
              if (this.bufferLength > 0) return !0;
              var t = this.stream.getByte();
              return (
                !(t < 0) && ((this.buffer = t), (this.bufferLength = 8), !0)
              );
            },
            readBits: function MeshStreamReader_readBits(t) {
              var r = this.buffer,
                a = this.bufferLength;
              if (32 === t) {
                if (0 === a)
                  return (
                    ((this.stream.getByte() << 24) |
                      (this.stream.getByte() << 16) |
                      (this.stream.getByte() << 8) |
                      this.stream.getByte()) >>>
                    0
                  );
                r =
                  (r << 24) |
                  (this.stream.getByte() << 16) |
                  (this.stream.getByte() << 8) |
                  this.stream.getByte();
                var i = this.stream.getByte();
                return (
                  (this.buffer = i & ((1 << a) - 1)),
                  ((r << (8 - a)) | ((255 & i) >> a)) >>> 0
                );
              }
              if (8 === t && 0 === a) return this.stream.getByte();
              for (; a < t; ) (r = (r << 8) | this.stream.getByte()), (a += 8);
              return (
                (a -= t),
                (this.bufferLength = a),
                (this.buffer = r & ((1 << a) - 1)),
                r >> a
              );
            },
            align: function MeshStreamReader_align() {
              (this.buffer = 0), (this.bufferLength = 0);
            },
            readFlag: function MeshStreamReader_readFlag() {
              return this.readBits(this.context.bitsPerFlag);
            },
            readCoordinate: function MeshStreamReader_readCoordinate() {
              var t = this.context.bitsPerCoordinate,
                r = this.readBits(t),
                a = this.readBits(t),
                i = this.context.decode,
                o = t < 32 ? 1 / ((1 << t) - 1) : 2.3283064365386963e-10;
              return [
                r * o * (i[1] - i[0]) + i[0],
                a * o * (i[3] - i[2]) + i[2],
              ];
            },
            readComponents: function MeshStreamReader_readComponents() {
              for (
                var t = this.context.numComps,
                  r = this.context.bitsPerComponent,
                  a = r < 32 ? 1 / ((1 << r) - 1) : 2.3283064365386963e-10,
                  i = this.context.decode,
                  o = this.tmpCompsBuf,
                  l = 0,
                  c = 4;
                l < t;
                l++, c += 2
              ) {
                var u = this.readBits(r);
                o[l] = u * a * (i[c + 1] - i[c]) + i[c];
              }
              var h = this.tmpCsCompsBuf;
              return (
                this.context.colorFn && this.context.colorFn(o, 0, h, 0),
                this.context.colorSpace.getRgb(h, 0)
              );
            },
          };
          var t = (function getBClosure() {
            var t = [];
            return function getB(r) {
              return (
                t[r] ||
                  (t[r] = (function buildB(t) {
                    for (var r = [], a = 0; a <= t; a++) {
                      var i = a / t,
                        o = 1 - i;
                      r.push(
                        new Float32Array([
                          o * o * o,
                          3 * i * o * o,
                          3 * i * i * o,
                          i * i * i,
                        ]),
                      );
                    }
                    return r;
                  })(r)),
                t[r]
              );
            };
          })();
          function buildFigureFromPatch(r, a) {
            var o = r.figures[a];
            (0, i.assert)("patch" === o.type, "Unexpected patch mesh figure");
            var l = r.coords,
              c = r.colors,
              u = o.coords,
              h = o.colors,
              d = Math.min(l[u[0]][0], l[u[3]][0], l[u[12]][0], l[u[15]][0]),
              p = Math.min(l[u[0]][1], l[u[3]][1], l[u[12]][1], l[u[15]][1]),
              m = Math.max(l[u[0]][0], l[u[3]][0], l[u[12]][0], l[u[15]][0]),
              g = Math.max(l[u[0]][1], l[u[3]][1], l[u[12]][1], l[u[15]][1]),
              b = Math.ceil((20 * (m - d)) / (r.bounds[2] - r.bounds[0]));
            b = Math.max(3, Math.min(20, b));
            var y = Math.ceil((20 * (g - p)) / (r.bounds[3] - r.bounds[1]));
            y = Math.max(3, Math.min(20, y));
            for (
              var v = b + 1,
                S = new Int32Array((y + 1) * v),
                k = new Int32Array((y + 1) * v),
                w = 0,
                C = new Uint8Array(3),
                x = new Uint8Array(3),
                _ = c[h[0]],
                A = c[h[1]],
                R = c[h[2]],
                T = c[h[3]],
                I = t(y),
                P = t(b),
                O = 0;
              O <= y;
              O++
            ) {
              (C[0] = ((_[0] * (y - O) + R[0] * O) / y) | 0),
                (C[1] = ((_[1] * (y - O) + R[1] * O) / y) | 0),
                (C[2] = ((_[2] * (y - O) + R[2] * O) / y) | 0),
                (x[0] = ((A[0] * (y - O) + T[0] * O) / y) | 0),
                (x[1] = ((A[1] * (y - O) + T[1] * O) / y) | 0),
                (x[2] = ((A[2] * (y - O) + T[2] * O) / y) | 0);
              for (var E = 0; E <= b; E++, w++)
                if ((0 !== O && O !== y) || (0 !== E && E !== b)) {
                  for (var B = 0, D = 0, M = 0, L = 0; L <= 3; L++)
                    for (var N = 0; N <= 3; N++, M++) {
                      var U = I[O][L] * P[E][N];
                      (B += l[u[M]][0] * U), (D += l[u[M]][1] * U);
                    }
                  (S[w] = l.length), l.push([B, D]), (k[w] = c.length);
                  var j = new Uint8Array(3);
                  (j[0] = ((C[0] * (b - E) + x[0] * E) / b) | 0),
                    (j[1] = ((C[1] * (b - E) + x[1] * E) / b) | 0),
                    (j[2] = ((C[2] * (b - E) + x[2] * E) / b) | 0),
                    c.push(j);
                }
            }
            (S[0] = u[0]),
              (k[0] = h[0]),
              (S[b] = u[3]),
              (k[b] = h[1]),
              (S[v * y] = u[12]),
              (k[v * y] = h[2]),
              (S[v * y + b] = u[15]),
              (k[v * y + b] = h[3]),
              (r.figures[a] = {
                type: "lattice",
                coords: S,
                colors: k,
                verticesPerRow: v,
              });
          }
          function updateBounds(t) {
            for (
              var r = t.coords[0][0],
                a = t.coords[0][1],
                i = r,
                o = a,
                l = 1,
                c = t.coords.length;
              l < c;
              l++
            ) {
              var u = t.coords[l][0],
                h = t.coords[l][1];
              (r = r > u ? u : r),
                (a = a > h ? h : a),
                (i = i < u ? u : i),
                (o = o < h ? h : o);
            }
            t.bounds = [r, a, i, o];
          }
          function Mesh(t, r, a, c, u) {
            if (!(0, l.isStream)(t))
              throw new i.FormatError("Mesh data is not a stream");
            var h = t.dict;
            (this.matrix = r),
              (this.shadingType = h.get("ShadingType")),
              (this.type = "Pattern");
            var b = h.getArray("BBox");
            Array.isArray(b) && 4 === b.length
              ? (this.bbox = i.Util.normalizeRect(b))
              : (this.bbox = null);
            var y = h.get("ColorSpace", "CS");
            (y = o.ColorSpace.parse(y, a, c, u)),
              (this.cs = y),
              (this.background = h.has("Background")
                ? y.getRgb(h.get("Background"), 0)
                : null);
            var v = h.get("Function"),
              S = v ? u.createFromArray(v) : null;
            (this.coords = []), (this.colors = []), (this.figures = []);
            var k = new MeshStreamReader(t, {
                bitsPerCoordinate: h.get("BitsPerCoordinate"),
                bitsPerComponent: h.get("BitsPerComponent"),
                bitsPerFlag: h.get("BitsPerFlag"),
                decode: h.getArray("Decode"),
                colorFn: S,
                colorSpace: y,
                numComps: S ? 1 : y.numComps,
              }),
              w = !1;
            switch (this.shadingType) {
              case d:
                !(function decodeType4Shading(t, r) {
                  for (
                    var a = t.coords, o = t.colors, l = [], c = [], u = 0;
                    r.hasData;

                  ) {
                    var h = r.readFlag(),
                      d = r.readCoordinate(),
                      p = r.readComponents();
                    if (0 === u) {
                      if (!(0 <= h && h <= 2))
                        throw new i.FormatError("Unknown type4 flag");
                      switch (h) {
                        case 0:
                          u = 3;
                          break;
                        case 1:
                          c.push(c[c.length - 2], c[c.length - 1]), (u = 1);
                          break;
                        case 2:
                          c.push(c[c.length - 3], c[c.length - 1]), (u = 1);
                      }
                      l.push(h);
                    }
                    c.push(a.length), a.push(d), o.push(p), u--, r.align();
                  }
                  t.figures.push({
                    type: "triangles",
                    coords: new Int32Array(c),
                    colors: new Int32Array(c),
                  });
                })(this, k);
                break;
              case p:
                var C = 0 | h.get("VerticesPerRow");
                if (C < 2) throw new i.FormatError("Invalid VerticesPerRow");
                !(function decodeType5Shading(t, r, a) {
                  for (var i = t.coords, o = t.colors, l = []; r.hasData; ) {
                    var c = r.readCoordinate(),
                      u = r.readComponents();
                    l.push(i.length), i.push(c), o.push(u);
                  }
                  t.figures.push({
                    type: "lattice",
                    coords: new Int32Array(l),
                    colors: new Int32Array(l),
                    verticesPerRow: a,
                  });
                })(this, k, C);
                break;
              case m:
                !(function decodeType6Shading(t, r) {
                  for (
                    var a = t.coords,
                      o = t.colors,
                      l = new Int32Array(16),
                      c = new Int32Array(4);
                    r.hasData;

                  ) {
                    var u,
                      h,
                      d = r.readFlag();
                    if (!(0 <= d && d <= 3))
                      throw new i.FormatError("Unknown type6 flag");
                    var p = a.length;
                    for (u = 0, h = 0 !== d ? 8 : 12; u < h; u++)
                      a.push(r.readCoordinate());
                    var m,
                      g,
                      b,
                      y,
                      v = o.length;
                    for (u = 0, h = 0 !== d ? 2 : 4; u < h; u++)
                      o.push(r.readComponents());
                    switch (d) {
                      case 0:
                        (l[12] = p + 3),
                          (l[13] = p + 4),
                          (l[14] = p + 5),
                          (l[15] = p + 6),
                          (l[8] = p + 2),
                          (l[11] = p + 7),
                          (l[4] = p + 1),
                          (l[7] = p + 8),
                          (l[0] = p),
                          (l[1] = p + 11),
                          (l[2] = p + 10),
                          (l[3] = p + 9),
                          (c[2] = v + 1),
                          (c[3] = v + 2),
                          (c[0] = v),
                          (c[1] = v + 3);
                        break;
                      case 1:
                        (m = l[12]),
                          (g = l[13]),
                          (b = l[14]),
                          (y = l[15]),
                          (l[12] = y),
                          (l[13] = p + 0),
                          (l[14] = p + 1),
                          (l[15] = p + 2),
                          (l[8] = b),
                          (l[11] = p + 3),
                          (l[4] = g),
                          (l[7] = p + 4),
                          (l[0] = m),
                          (l[1] = p + 7),
                          (l[2] = p + 6),
                          (l[3] = p + 5),
                          (m = c[2]),
                          (g = c[3]),
                          (c[2] = g),
                          (c[3] = v),
                          (c[0] = m),
                          (c[1] = v + 1);
                        break;
                      case 2:
                        (m = l[15]),
                          (g = l[11]),
                          (l[12] = l[3]),
                          (l[13] = p + 0),
                          (l[14] = p + 1),
                          (l[15] = p + 2),
                          (l[8] = l[7]),
                          (l[11] = p + 3),
                          (l[4] = g),
                          (l[7] = p + 4),
                          (l[0] = m),
                          (l[1] = p + 7),
                          (l[2] = p + 6),
                          (l[3] = p + 5),
                          (m = c[3]),
                          (c[2] = c[1]),
                          (c[3] = v),
                          (c[0] = m),
                          (c[1] = v + 1);
                        break;
                      case 3:
                        (l[12] = l[0]),
                          (l[13] = p + 0),
                          (l[14] = p + 1),
                          (l[15] = p + 2),
                          (l[8] = l[1]),
                          (l[11] = p + 3),
                          (l[4] = l[2]),
                          (l[7] = p + 4),
                          (l[0] = l[3]),
                          (l[1] = p + 7),
                          (l[2] = p + 6),
                          (l[3] = p + 5),
                          (c[2] = c[0]),
                          (c[3] = v),
                          (c[0] = c[1]),
                          (c[1] = v + 1);
                    }
                    (l[5] = a.length),
                      a.push([
                        (-4 * a[l[0]][0] -
                          a[l[15]][0] +
                          6 * (a[l[4]][0] + a[l[1]][0]) -
                          2 * (a[l[12]][0] + a[l[3]][0]) +
                          3 * (a[l[13]][0] + a[l[7]][0])) /
                          9,
                        (-4 * a[l[0]][1] -
                          a[l[15]][1] +
                          6 * (a[l[4]][1] + a[l[1]][1]) -
                          2 * (a[l[12]][1] + a[l[3]][1]) +
                          3 * (a[l[13]][1] + a[l[7]][1])) /
                          9,
                      ]),
                      (l[6] = a.length),
                      a.push([
                        (-4 * a[l[3]][0] -
                          a[l[12]][0] +
                          6 * (a[l[2]][0] + a[l[7]][0]) -
                          2 * (a[l[0]][0] + a[l[15]][0]) +
                          3 * (a[l[4]][0] + a[l[14]][0])) /
                          9,
                        (-4 * a[l[3]][1] -
                          a[l[12]][1] +
                          6 * (a[l[2]][1] + a[l[7]][1]) -
                          2 * (a[l[0]][1] + a[l[15]][1]) +
                          3 * (a[l[4]][1] + a[l[14]][1])) /
                          9,
                      ]),
                      (l[9] = a.length),
                      a.push([
                        (-4 * a[l[12]][0] -
                          a[l[3]][0] +
                          6 * (a[l[8]][0] + a[l[13]][0]) -
                          2 * (a[l[0]][0] + a[l[15]][0]) +
                          3 * (a[l[11]][0] + a[l[1]][0])) /
                          9,
                        (-4 * a[l[12]][1] -
                          a[l[3]][1] +
                          6 * (a[l[8]][1] + a[l[13]][1]) -
                          2 * (a[l[0]][1] + a[l[15]][1]) +
                          3 * (a[l[11]][1] + a[l[1]][1])) /
                          9,
                      ]),
                      (l[10] = a.length),
                      a.push([
                        (-4 * a[l[15]][0] -
                          a[l[0]][0] +
                          6 * (a[l[11]][0] + a[l[14]][0]) -
                          2 * (a[l[12]][0] + a[l[3]][0]) +
                          3 * (a[l[2]][0] + a[l[8]][0])) /
                          9,
                        (-4 * a[l[15]][1] -
                          a[l[0]][1] +
                          6 * (a[l[11]][1] + a[l[14]][1]) -
                          2 * (a[l[12]][1] + a[l[3]][1]) +
                          3 * (a[l[2]][1] + a[l[8]][1])) /
                          9,
                      ]),
                      t.figures.push({
                        type: "patch",
                        coords: new Int32Array(l),
                        colors: new Int32Array(c),
                      });
                  }
                })(this, k),
                  (w = !0);
                break;
              case g:
                !(function decodeType7Shading(t, r) {
                  for (
                    var a = t.coords,
                      o = t.colors,
                      l = new Int32Array(16),
                      c = new Int32Array(4);
                    r.hasData;

                  ) {
                    var u,
                      h,
                      d = r.readFlag();
                    if (!(0 <= d && d <= 3))
                      throw new i.FormatError("Unknown type7 flag");
                    var p = a.length;
                    for (u = 0, h = 0 !== d ? 12 : 16; u < h; u++)
                      a.push(r.readCoordinate());
                    var m,
                      g,
                      b,
                      y,
                      v = o.length;
                    for (u = 0, h = 0 !== d ? 2 : 4; u < h; u++)
                      o.push(r.readComponents());
                    switch (d) {
                      case 0:
                        (l[12] = p + 3),
                          (l[13] = p + 4),
                          (l[14] = p + 5),
                          (l[15] = p + 6),
                          (l[8] = p + 2),
                          (l[9] = p + 13),
                          (l[10] = p + 14),
                          (l[11] = p + 7),
                          (l[4] = p + 1),
                          (l[5] = p + 12),
                          (l[6] = p + 15),
                          (l[7] = p + 8),
                          (l[0] = p),
                          (l[1] = p + 11),
                          (l[2] = p + 10),
                          (l[3] = p + 9),
                          (c[2] = v + 1),
                          (c[3] = v + 2),
                          (c[0] = v),
                          (c[1] = v + 3);
                        break;
                      case 1:
                        (m = l[12]),
                          (g = l[13]),
                          (b = l[14]),
                          (y = l[15]),
                          (l[12] = y),
                          (l[13] = p + 0),
                          (l[14] = p + 1),
                          (l[15] = p + 2),
                          (l[8] = b),
                          (l[9] = p + 9),
                          (l[10] = p + 10),
                          (l[11] = p + 3),
                          (l[4] = g),
                          (l[5] = p + 8),
                          (l[6] = p + 11),
                          (l[7] = p + 4),
                          (l[0] = m),
                          (l[1] = p + 7),
                          (l[2] = p + 6),
                          (l[3] = p + 5),
                          (m = c[2]),
                          (g = c[3]),
                          (c[2] = g),
                          (c[3] = v),
                          (c[0] = m),
                          (c[1] = v + 1);
                        break;
                      case 2:
                        (m = l[15]),
                          (g = l[11]),
                          (l[12] = l[3]),
                          (l[13] = p + 0),
                          (l[14] = p + 1),
                          (l[15] = p + 2),
                          (l[8] = l[7]),
                          (l[9] = p + 9),
                          (l[10] = p + 10),
                          (l[11] = p + 3),
                          (l[4] = g),
                          (l[5] = p + 8),
                          (l[6] = p + 11),
                          (l[7] = p + 4),
                          (l[0] = m),
                          (l[1] = p + 7),
                          (l[2] = p + 6),
                          (l[3] = p + 5),
                          (m = c[3]),
                          (c[2] = c[1]),
                          (c[3] = v),
                          (c[0] = m),
                          (c[1] = v + 1);
                        break;
                      case 3:
                        (l[12] = l[0]),
                          (l[13] = p + 0),
                          (l[14] = p + 1),
                          (l[15] = p + 2),
                          (l[8] = l[1]),
                          (l[9] = p + 9),
                          (l[10] = p + 10),
                          (l[11] = p + 3),
                          (l[4] = l[2]),
                          (l[5] = p + 8),
                          (l[6] = p + 11),
                          (l[7] = p + 4),
                          (l[0] = l[3]),
                          (l[1] = p + 7),
                          (l[2] = p + 6),
                          (l[3] = p + 5),
                          (c[2] = c[0]),
                          (c[3] = v),
                          (c[0] = c[1]),
                          (c[1] = v + 1);
                    }
                    t.figures.push({
                      type: "patch",
                      coords: new Int32Array(l),
                      colors: new Int32Array(c),
                    });
                  }
                })(this, k),
                  (w = !0);
                break;
              default:
                (0, i.unreachable)("Unsupported mesh type.");
            }
            if (w) {
              updateBounds(this);
              for (var x = 0, _ = this.figures.length; x < _; x++)
                buildFigureFromPatch(this, x);
            }
            updateBounds(this),
              (function packData(t) {
                var r,
                  a,
                  i,
                  o,
                  l = t.coords,
                  c = new Float32Array(2 * l.length);
                for (r = 0, i = 0, a = l.length; r < a; r++) {
                  var u = l[r];
                  (c[i++] = u[0]), (c[i++] = u[1]);
                }
                t.coords = c;
                var h = t.colors,
                  d = new Uint8Array(3 * h.length);
                for (r = 0, i = 0, a = h.length; r < a; r++) {
                  var p = h[r];
                  (d[i++] = p[0]), (d[i++] = p[1]), (d[i++] = p[2]);
                }
                t.colors = d;
                var m = t.figures;
                for (r = 0, a = m.length; r < a; r++) {
                  var g = m[r],
                    b = g.coords,
                    y = g.colors;
                  for (i = 0, o = b.length; i < o; i++)
                    (b[i] *= 2), (y[i] *= 3);
                }
              })(this);
          }
          return (
            (Mesh.prototype = {
              getIR: function Mesh_getIR() {
                return [
                  "Mesh",
                  this.shadingType,
                  this.coords,
                  this.colors,
                  this.figures,
                  this.bounds,
                  this.matrix,
                  this.bbox,
                  this.background,
                ];
              },
            }),
            Mesh
          );
        })()),
        (y.Dummy = (function DummyClosure() {
          function Dummy() {
            this.type = "Pattern";
          }
          return (
            (Dummy.prototype = {
              getIR: function Dummy_getIR() {
                return ["Dummy"];
              },
            }),
            Dummy
          );
        })());
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.bidi = function bidi(t, r, a) {
          var h = !0,
            d = t.length;
          if (0 === d || a) return createBidiText(t, h, a);
          (c.length = d), (u.length = d);
          var p,
            m,
            g = 0;
          for (p = 0; p < d; ++p) {
            c[p] = t.charAt(p);
            var b = t.charCodeAt(p),
              y = "L";
            b <= 255
              ? (y = o[b])
              : 1424 <= b && b <= 1524
              ? (y = "R")
              : 1536 <= b && b <= 1791
              ? (y = l[255 & b]) ||
                (0, i.warn)("Bidi: invalid Unicode character " + b.toString(16))
              : 1792 <= b && b <= 2220 && (y = "AL"),
              ("R" !== y && "AL" !== y && "AN" !== y) || g++,
              (u[p] = y);
          }
          if (0 === g) return createBidiText(t, (h = !0));
          -1 === r && (g / d < 0.3 ? ((h = !0), (r = 0)) : ((h = !1), (r = 1)));
          var v = [];
          for (p = 0; p < d; ++p) v[p] = r;
          var S,
            k = isOdd(r) ? "R" : "L",
            w = k,
            C = w,
            x = w;
          for (p = 0; p < d; ++p) "NSM" === u[p] ? (u[p] = x) : (x = u[p]);
          for (x = w, p = 0; p < d; ++p)
            "EN" === (S = u[p])
              ? (u[p] = "AL" === x ? "AN" : "EN")
              : ("R" !== S && "L" !== S && "AL" !== S) || (x = S);
          for (p = 0; p < d; ++p) "AL" === (S = u[p]) && (u[p] = "R");
          for (p = 1; p < d - 1; ++p)
            "ES" === u[p] &&
              "EN" === u[p - 1] &&
              "EN" === u[p + 1] &&
              (u[p] = "EN"),
              "CS" !== u[p] ||
                ("EN" !== u[p - 1] && "AN" !== u[p - 1]) ||
                u[p + 1] !== u[p - 1] ||
                (u[p] = u[p - 1]);
          for (p = 0; p < d; ++p)
            if ("EN" === u[p]) {
              var _;
              for (_ = p - 1; _ >= 0 && "ET" === u[_]; --_) u[_] = "EN";
              for (_ = p + 1; _ < d && "ET" === u[_]; ++_) u[_] = "EN";
            }
          for (p = 0; p < d; ++p)
            ("WS" !== (S = u[p]) && "ES" !== S && "ET" !== S && "CS" !== S) ||
              (u[p] = "ON");
          for (x = w, p = 0; p < d; ++p)
            "EN" === (S = u[p])
              ? (u[p] = "L" === x ? "L" : "EN")
              : ("R" !== S && "L" !== S) || (x = S);
          for (p = 0; p < d; ++p)
            if ("ON" === u[p]) {
              var A = findUnequal(u, p + 1, "ON"),
                R = w;
              p > 0 && (R = u[p - 1]);
              var T = C;
              A + 1 < d && (T = u[A + 1]),
                "L" !== R && (R = "R"),
                "L" !== T && (T = "R"),
                R === T && setValues(u, p, A, R),
                (p = A - 1);
            }
          for (p = 0; p < d; ++p) "ON" === u[p] && (u[p] = k);
          for (p = 0; p < d; ++p)
            (S = u[p]),
              isEven(v[p])
                ? "R" === S
                  ? (v[p] += 1)
                  : ("AN" !== S && "EN" !== S) || (v[p] += 2)
                : ("L" !== S && "AN" !== S && "EN" !== S) || (v[p] += 1);
          var I,
            P = -1,
            O = 99;
          for (p = 0, m = v.length; p < m; ++p)
            (I = v[p]), P < I && (P = I), O > I && isOdd(I) && (O = I);
          for (I = P; I >= O; --I) {
            var E = -1;
            for (p = 0, m = v.length; p < m; ++p)
              v[p] < I
                ? E >= 0 && (reverseValues(c, E, p), (E = -1))
                : E < 0 && (E = p);
            E >= 0 && reverseValues(c, E, v.length);
          }
          for (p = 0, m = c.length; p < m; ++p) {
            var B = c[p];
            ("<" !== B && ">" !== B) || (c[p] = "");
          }
          return createBidiText(c.join(""), h);
        });
      var i = a(5),
        o = [
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "S",
          "B",
          "S",
          "WS",
          "B",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "B",
          "B",
          "B",
          "S",
          "WS",
          "ON",
          "ON",
          "ET",
          "ET",
          "ET",
          "ON",
          "ON",
          "ON",
          "ON",
          "ON",
          "ES",
          "CS",
          "ES",
          "CS",
          "CS",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "CS",
          "ON",
          "ON",
          "ON",
          "ON",
          "ON",
          "ON",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "ON",
          "ON",
          "ON",
          "ON",
          "ON",
          "ON",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "ON",
          "ON",
          "ON",
          "ON",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "B",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "BN",
          "CS",
          "ON",
          "ET",
          "ET",
          "ET",
          "ET",
          "ON",
          "ON",
          "ON",
          "ON",
          "L",
          "ON",
          "ON",
          "BN",
          "ON",
          "ON",
          "ET",
          "ET",
          "EN",
          "EN",
          "ON",
          "L",
          "ON",
          "ON",
          "ON",
          "EN",
          "L",
          "ON",
          "ON",
          "ON",
          "ON",
          "ON",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "ON",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "ON",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
          "L",
        ],
        l = [
          "AN",
          "AN",
          "AN",
          "AN",
          "AN",
          "AN",
          "ON",
          "ON",
          "AL",
          "ET",
          "ET",
          "AL",
          "CS",
          "AL",
          "ON",
          "ON",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "AL",
          "AL",
          "",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "AN",
          "AN",
          "AN",
          "AN",
          "AN",
          "AN",
          "AN",
          "AN",
          "AN",
          "AN",
          "ET",
          "AN",
          "AN",
          "AL",
          "AL",
          "AL",
          "NSM",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "AN",
          "ON",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "AL",
          "AL",
          "NSM",
          "NSM",
          "ON",
          "NSM",
          "NSM",
          "NSM",
          "NSM",
          "AL",
          "AL",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "EN",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
          "AL",
        ];
      function isOdd(t) {
        return 0 != (1 & t);
      }
      function isEven(t) {
        return 0 == (1 & t);
      }
      function findUnequal(t, r, a) {
        for (var i = r, o = t.length; i < o; ++i) if (t[i] !== a) return i;
        return i;
      }
      function setValues(t, r, a, i) {
        for (var o = r; o < a; ++o) t[o] = i;
      }
      function reverseValues(t, r, a) {
        for (var i = r, o = a - 1; i < o; ++i, --o) {
          var l = t[i];
          (t[i] = t[o]), (t[o] = l);
        }
      }
      function createBidiText(t, r) {
        var a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          i = "ltr";
        return a ? (i = "ttb") : r || (i = "rtl"), { str: t, dir: i };
      }
      var c = [],
        u = [];
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.getMetrics = void 0);
      var i = a(201),
        o = (0, i.getLookupTableFactory)(function (t) {
          (t.Courier = 600),
            (t["Courier-Bold"] = 600),
            (t["Courier-BoldOblique"] = 600),
            (t["Courier-Oblique"] = 600),
            (t.Helvetica = (0, i.getLookupTableFactory)(function (t) {
              (t.space = 278),
                (t.exclam = 278),
                (t.quotedbl = 355),
                (t.numbersign = 556),
                (t.dollar = 556),
                (t.percent = 889),
                (t.ampersand = 667),
                (t.quoteright = 222),
                (t.parenleft = 333),
                (t.parenright = 333),
                (t.asterisk = 389),
                (t.plus = 584),
                (t.comma = 278),
                (t.hyphen = 333),
                (t.period = 278),
                (t.slash = 278),
                (t.zero = 556),
                (t.one = 556),
                (t.two = 556),
                (t.three = 556),
                (t.four = 556),
                (t.five = 556),
                (t.six = 556),
                (t.seven = 556),
                (t.eight = 556),
                (t.nine = 556),
                (t.colon = 278),
                (t.semicolon = 278),
                (t.less = 584),
                (t.equal = 584),
                (t.greater = 584),
                (t.question = 556),
                (t.at = 1015),
                (t.A = 667),
                (t.B = 667),
                (t.C = 722),
                (t.D = 722),
                (t.E = 667),
                (t.F = 611),
                (t.G = 778),
                (t.H = 722),
                (t.I = 278),
                (t.J = 500),
                (t.K = 667),
                (t.L = 556),
                (t.M = 833),
                (t.N = 722),
                (t.O = 778),
                (t.P = 667),
                (t.Q = 778),
                (t.R = 722),
                (t.S = 667),
                (t.T = 611),
                (t.U = 722),
                (t.V = 667),
                (t.W = 944),
                (t.X = 667),
                (t.Y = 667),
                (t.Z = 611),
                (t.bracketleft = 278),
                (t.backslash = 278),
                (t.bracketright = 278),
                (t.asciicircum = 469),
                (t.underscore = 556),
                (t.quoteleft = 222),
                (t.a = 556),
                (t.b = 556),
                (t.c = 500),
                (t.d = 556),
                (t.e = 556),
                (t.f = 278),
                (t.g = 556),
                (t.h = 556),
                (t.i = 222),
                (t.j = 222),
                (t.k = 500),
                (t.l = 222),
                (t.m = 833),
                (t.n = 556),
                (t.o = 556),
                (t.p = 556),
                (t.q = 556),
                (t.r = 333),
                (t.s = 500),
                (t.t = 278),
                (t.u = 556),
                (t.v = 500),
                (t.w = 722),
                (t.x = 500),
                (t.y = 500),
                (t.z = 500),
                (t.braceleft = 334),
                (t.bar = 260),
                (t.braceright = 334),
                (t.asciitilde = 584),
                (t.exclamdown = 333),
                (t.cent = 556),
                (t.sterling = 556),
                (t.fraction = 167),
                (t.yen = 556),
                (t.florin = 556),
                (t.section = 556),
                (t.currency = 556),
                (t.quotesingle = 191),
                (t.quotedblleft = 333),
                (t.guillemotleft = 556),
                (t.guilsinglleft = 333),
                (t.guilsinglright = 333),
                (t.fi = 500),
                (t.fl = 500),
                (t.endash = 556),
                (t.dagger = 556),
                (t.daggerdbl = 556),
                (t.periodcentered = 278),
                (t.paragraph = 537),
                (t.bullet = 350),
                (t.quotesinglbase = 222),
                (t.quotedblbase = 333),
                (t.quotedblright = 333),
                (t.guillemotright = 556),
                (t.ellipsis = 1e3),
                (t.perthousand = 1e3),
                (t.questiondown = 611),
                (t.grave = 333),
                (t.acute = 333),
                (t.circumflex = 333),
                (t.tilde = 333),
                (t.macron = 333),
                (t.breve = 333),
                (t.dotaccent = 333),
                (t.dieresis = 333),
                (t.ring = 333),
                (t.cedilla = 333),
                (t.hungarumlaut = 333),
                (t.ogonek = 333),
                (t.caron = 333),
                (t.emdash = 1e3),
                (t.AE = 1e3),
                (t.ordfeminine = 370),
                (t.Lslash = 556),
                (t.Oslash = 778),
                (t.OE = 1e3),
                (t.ordmasculine = 365),
                (t.ae = 889),
                (t.dotlessi = 278),
                (t.lslash = 222),
                (t.oslash = 611),
                (t.oe = 944),
                (t.germandbls = 611),
                (t.Idieresis = 278),
                (t.eacute = 556),
                (t.abreve = 556),
                (t.uhungarumlaut = 556),
                (t.ecaron = 556),
                (t.Ydieresis = 667),
                (t.divide = 584),
                (t.Yacute = 667),
                (t.Acircumflex = 667),
                (t.aacute = 556),
                (t.Ucircumflex = 722),
                (t.yacute = 500),
                (t.scommaaccent = 500),
                (t.ecircumflex = 556),
                (t.Uring = 722),
                (t.Udieresis = 722),
                (t.aogonek = 556),
                (t.Uacute = 722),
                (t.uogonek = 556),
                (t.Edieresis = 667),
                (t.Dcroat = 722),
                (t.commaaccent = 250),
                (t.copyright = 737),
                (t.Emacron = 667),
                (t.ccaron = 500),
                (t.aring = 556),
                (t.Ncommaaccent = 722),
                (t.lacute = 222),
                (t.agrave = 556),
                (t.Tcommaaccent = 611),
                (t.Cacute = 722),
                (t.atilde = 556),
                (t.Edotaccent = 667),
                (t.scaron = 500),
                (t.scedilla = 500),
                (t.iacute = 278),
                (t.lozenge = 471),
                (t.Rcaron = 722),
                (t.Gcommaaccent = 778),
                (t.ucircumflex = 556),
                (t.acircumflex = 556),
                (t.Amacron = 667),
                (t.rcaron = 333),
                (t.ccedilla = 500),
                (t.Zdotaccent = 611),
                (t.Thorn = 667),
                (t.Omacron = 778),
                (t.Racute = 722),
                (t.Sacute = 667),
                (t.dcaron = 643),
                (t.Umacron = 722),
                (t.uring = 556),
                (t.threesuperior = 333),
                (t.Ograve = 778),
                (t.Agrave = 667),
                (t.Abreve = 667),
                (t.multiply = 584),
                (t.uacute = 556),
                (t.Tcaron = 611),
                (t.partialdiff = 476),
                (t.ydieresis = 500),
                (t.Nacute = 722),
                (t.icircumflex = 278),
                (t.Ecircumflex = 667),
                (t.adieresis = 556),
                (t.edieresis = 556),
                (t.cacute = 500),
                (t.nacute = 556),
                (t.umacron = 556),
                (t.Ncaron = 722),
                (t.Iacute = 278),
                (t.plusminus = 584),
                (t.brokenbar = 260),
                (t.registered = 737),
                (t.Gbreve = 778),
                (t.Idotaccent = 278),
                (t.summation = 600),
                (t.Egrave = 667),
                (t.racute = 333),
                (t.omacron = 556),
                (t.Zacute = 611),
                (t.Zcaron = 611),
                (t.greaterequal = 549),
                (t.Eth = 722),
                (t.Ccedilla = 722),
                (t.lcommaaccent = 222),
                (t.tcaron = 317),
                (t.eogonek = 556),
                (t.Uogonek = 722),
                (t.Aacute = 667),
                (t.Adieresis = 667),
                (t.egrave = 556),
                (t.zacute = 500),
                (t.iogonek = 222),
                (t.Oacute = 778),
                (t.oacute = 556),
                (t.amacron = 556),
                (t.sacute = 500),
                (t.idieresis = 278),
                (t.Ocircumflex = 778),
                (t.Ugrave = 722),
                (t.Delta = 612),
                (t.thorn = 556),
                (t.twosuperior = 333),
                (t.Odieresis = 778),
                (t.mu = 556),
                (t.igrave = 278),
                (t.ohungarumlaut = 556),
                (t.Eogonek = 667),
                (t.dcroat = 556),
                (t.threequarters = 834),
                (t.Scedilla = 667),
                (t.lcaron = 299),
                (t.Kcommaaccent = 667),
                (t.Lacute = 556),
                (t.trademark = 1e3),
                (t.edotaccent = 556),
                (t.Igrave = 278),
                (t.Imacron = 278),
                (t.Lcaron = 556),
                (t.onehalf = 834),
                (t.lessequal = 549),
                (t.ocircumflex = 556),
                (t.ntilde = 556),
                (t.Uhungarumlaut = 722),
                (t.Eacute = 667),
                (t.emacron = 556),
                (t.gbreve = 556),
                (t.onequarter = 834),
                (t.Scaron = 667),
                (t.Scommaaccent = 667),
                (t.Ohungarumlaut = 778),
                (t.degree = 400),
                (t.ograve = 556),
                (t.Ccaron = 722),
                (t.ugrave = 556),
                (t.radical = 453),
                (t.Dcaron = 722),
                (t.rcommaaccent = 333),
                (t.Ntilde = 722),
                (t.otilde = 556),
                (t.Rcommaaccent = 722),
                (t.Lcommaaccent = 556),
                (t.Atilde = 667),
                (t.Aogonek = 667),
                (t.Aring = 667),
                (t.Otilde = 778),
                (t.zdotaccent = 500),
                (t.Ecaron = 667),
                (t.Iogonek = 278),
                (t.kcommaaccent = 500),
                (t.minus = 584),
                (t.Icircumflex = 278),
                (t.ncaron = 556),
                (t.tcommaaccent = 278),
                (t.logicalnot = 584),
                (t.odieresis = 556),
                (t.udieresis = 556),
                (t.notequal = 549),
                (t.gcommaaccent = 556),
                (t.eth = 556),
                (t.zcaron = 500),
                (t.ncommaaccent = 556),
                (t.onesuperior = 333),
                (t.imacron = 278),
                (t.Euro = 556);
            })),
            (t["Helvetica-Bold"] = (0, i.getLookupTableFactory)(function (t) {
              (t.space = 278),
                (t.exclam = 333),
                (t.quotedbl = 474),
                (t.numbersign = 556),
                (t.dollar = 556),
                (t.percent = 889),
                (t.ampersand = 722),
                (t.quoteright = 278),
                (t.parenleft = 333),
                (t.parenright = 333),
                (t.asterisk = 389),
                (t.plus = 584),
                (t.comma = 278),
                (t.hyphen = 333),
                (t.period = 278),
                (t.slash = 278),
                (t.zero = 556),
                (t.one = 556),
                (t.two = 556),
                (t.three = 556),
                (t.four = 556),
                (t.five = 556),
                (t.six = 556),
                (t.seven = 556),
                (t.eight = 556),
                (t.nine = 556),
                (t.colon = 333),
                (t.semicolon = 333),
                (t.less = 584),
                (t.equal = 584),
                (t.greater = 584),
                (t.question = 611),
                (t.at = 975),
                (t.A = 722),
                (t.B = 722),
                (t.C = 722),
                (t.D = 722),
                (t.E = 667),
                (t.F = 611),
                (t.G = 778),
                (t.H = 722),
                (t.I = 278),
                (t.J = 556),
                (t.K = 722),
                (t.L = 611),
                (t.M = 833),
                (t.N = 722),
                (t.O = 778),
                (t.P = 667),
                (t.Q = 778),
                (t.R = 722),
                (t.S = 667),
                (t.T = 611),
                (t.U = 722),
                (t.V = 667),
                (t.W = 944),
                (t.X = 667),
                (t.Y = 667),
                (t.Z = 611),
                (t.bracketleft = 333),
                (t.backslash = 278),
                (t.bracketright = 333),
                (t.asciicircum = 584),
                (t.underscore = 556),
                (t.quoteleft = 278),
                (t.a = 556),
                (t.b = 611),
                (t.c = 556),
                (t.d = 611),
                (t.e = 556),
                (t.f = 333),
                (t.g = 611),
                (t.h = 611),
                (t.i = 278),
                (t.j = 278),
                (t.k = 556),
                (t.l = 278),
                (t.m = 889),
                (t.n = 611),
                (t.o = 611),
                (t.p = 611),
                (t.q = 611),
                (t.r = 389),
                (t.s = 556),
                (t.t = 333),
                (t.u = 611),
                (t.v = 556),
                (t.w = 778),
                (t.x = 556),
                (t.y = 556),
                (t.z = 500),
                (t.braceleft = 389),
                (t.bar = 280),
                (t.braceright = 389),
                (t.asciitilde = 584),
                (t.exclamdown = 333),
                (t.cent = 556),
                (t.sterling = 556),
                (t.fraction = 167),
                (t.yen = 556),
                (t.florin = 556),
                (t.section = 556),
                (t.currency = 556),
                (t.quotesingle = 238),
                (t.quotedblleft = 500),
                (t.guillemotleft = 556),
                (t.guilsinglleft = 333),
                (t.guilsinglright = 333),
                (t.fi = 611),
                (t.fl = 611),
                (t.endash = 556),
                (t.dagger = 556),
                (t.daggerdbl = 556),
                (t.periodcentered = 278),
                (t.paragraph = 556),
                (t.bullet = 350),
                (t.quotesinglbase = 278),
                (t.quotedblbase = 500),
                (t.quotedblright = 500),
                (t.guillemotright = 556),
                (t.ellipsis = 1e3),
                (t.perthousand = 1e3),
                (t.questiondown = 611),
                (t.grave = 333),
                (t.acute = 333),
                (t.circumflex = 333),
                (t.tilde = 333),
                (t.macron = 333),
                (t.breve = 333),
                (t.dotaccent = 333),
                (t.dieresis = 333),
                (t.ring = 333),
                (t.cedilla = 333),
                (t.hungarumlaut = 333),
                (t.ogonek = 333),
                (t.caron = 333),
                (t.emdash = 1e3),
                (t.AE = 1e3),
                (t.ordfeminine = 370),
                (t.Lslash = 611),
                (t.Oslash = 778),
                (t.OE = 1e3),
                (t.ordmasculine = 365),
                (t.ae = 889),
                (t.dotlessi = 278),
                (t.lslash = 278),
                (t.oslash = 611),
                (t.oe = 944),
                (t.germandbls = 611),
                (t.Idieresis = 278),
                (t.eacute = 556),
                (t.abreve = 556),
                (t.uhungarumlaut = 611),
                (t.ecaron = 556),
                (t.Ydieresis = 667),
                (t.divide = 584),
                (t.Yacute = 667),
                (t.Acircumflex = 722),
                (t.aacute = 556),
                (t.Ucircumflex = 722),
                (t.yacute = 556),
                (t.scommaaccent = 556),
                (t.ecircumflex = 556),
                (t.Uring = 722),
                (t.Udieresis = 722),
                (t.aogonek = 556),
                (t.Uacute = 722),
                (t.uogonek = 611),
                (t.Edieresis = 667),
                (t.Dcroat = 722),
                (t.commaaccent = 250),
                (t.copyright = 737),
                (t.Emacron = 667),
                (t.ccaron = 556),
                (t.aring = 556),
                (t.Ncommaaccent = 722),
                (t.lacute = 278),
                (t.agrave = 556),
                (t.Tcommaaccent = 611),
                (t.Cacute = 722),
                (t.atilde = 556),
                (t.Edotaccent = 667),
                (t.scaron = 556),
                (t.scedilla = 556),
                (t.iacute = 278),
                (t.lozenge = 494),
                (t.Rcaron = 722),
                (t.Gcommaaccent = 778),
                (t.ucircumflex = 611),
                (t.acircumflex = 556),
                (t.Amacron = 722),
                (t.rcaron = 389),
                (t.ccedilla = 556),
                (t.Zdotaccent = 611),
                (t.Thorn = 667),
                (t.Omacron = 778),
                (t.Racute = 722),
                (t.Sacute = 667),
                (t.dcaron = 743),
                (t.Umacron = 722),
                (t.uring = 611),
                (t.threesuperior = 333),
                (t.Ograve = 778),
                (t.Agrave = 722),
                (t.Abreve = 722),
                (t.multiply = 584),
                (t.uacute = 611),
                (t.Tcaron = 611),
                (t.partialdiff = 494),
                (t.ydieresis = 556),
                (t.Nacute = 722),
                (t.icircumflex = 278),
                (t.Ecircumflex = 667),
                (t.adieresis = 556),
                (t.edieresis = 556),
                (t.cacute = 556),
                (t.nacute = 611),
                (t.umacron = 611),
                (t.Ncaron = 722),
                (t.Iacute = 278),
                (t.plusminus = 584),
                (t.brokenbar = 280),
                (t.registered = 737),
                (t.Gbreve = 778),
                (t.Idotaccent = 278),
                (t.summation = 600),
                (t.Egrave = 667),
                (t.racute = 389),
                (t.omacron = 611),
                (t.Zacute = 611),
                (t.Zcaron = 611),
                (t.greaterequal = 549),
                (t.Eth = 722),
                (t.Ccedilla = 722),
                (t.lcommaaccent = 278),
                (t.tcaron = 389),
                (t.eogonek = 556),
                (t.Uogonek = 722),
                (t.Aacute = 722),
                (t.Adieresis = 722),
                (t.egrave = 556),
                (t.zacute = 500),
                (t.iogonek = 278),
                (t.Oacute = 778),
                (t.oacute = 611),
                (t.amacron = 556),
                (t.sacute = 556),
                (t.idieresis = 278),
                (t.Ocircumflex = 778),
                (t.Ugrave = 722),
                (t.Delta = 612),
                (t.thorn = 611),
                (t.twosuperior = 333),
                (t.Odieresis = 778),
                (t.mu = 611),
                (t.igrave = 278),
                (t.ohungarumlaut = 611),
                (t.Eogonek = 667),
                (t.dcroat = 611),
                (t.threequarters = 834),
                (t.Scedilla = 667),
                (t.lcaron = 400),
                (t.Kcommaaccent = 722),
                (t.Lacute = 611),
                (t.trademark = 1e3),
                (t.edotaccent = 556),
                (t.Igrave = 278),
                (t.Imacron = 278),
                (t.Lcaron = 611),
                (t.onehalf = 834),
                (t.lessequal = 549),
                (t.ocircumflex = 611),
                (t.ntilde = 611),
                (t.Uhungarumlaut = 722),
                (t.Eacute = 667),
                (t.emacron = 556),
                (t.gbreve = 611),
                (t.onequarter = 834),
                (t.Scaron = 667),
                (t.Scommaaccent = 667),
                (t.Ohungarumlaut = 778),
                (t.degree = 400),
                (t.ograve = 611),
                (t.Ccaron = 722),
                (t.ugrave = 611),
                (t.radical = 549),
                (t.Dcaron = 722),
                (t.rcommaaccent = 389),
                (t.Ntilde = 722),
                (t.otilde = 611),
                (t.Rcommaaccent = 722),
                (t.Lcommaaccent = 611),
                (t.Atilde = 722),
                (t.Aogonek = 722),
                (t.Aring = 722),
                (t.Otilde = 778),
                (t.zdotaccent = 500),
                (t.Ecaron = 667),
                (t.Iogonek = 278),
                (t.kcommaaccent = 556),
                (t.minus = 584),
                (t.Icircumflex = 278),
                (t.ncaron = 611),
                (t.tcommaaccent = 333),
                (t.logicalnot = 584),
                (t.odieresis = 611),
                (t.udieresis = 611),
                (t.notequal = 549),
                (t.gcommaaccent = 611),
                (t.eth = 611),
                (t.zcaron = 500),
                (t.ncommaaccent = 611),
                (t.onesuperior = 333),
                (t.imacron = 278),
                (t.Euro = 556);
            })),
            (t["Helvetica-BoldOblique"] = (0, i.getLookupTableFactory)(
              function (t) {
                (t.space = 278),
                  (t.exclam = 333),
                  (t.quotedbl = 474),
                  (t.numbersign = 556),
                  (t.dollar = 556),
                  (t.percent = 889),
                  (t.ampersand = 722),
                  (t.quoteright = 278),
                  (t.parenleft = 333),
                  (t.parenright = 333),
                  (t.asterisk = 389),
                  (t.plus = 584),
                  (t.comma = 278),
                  (t.hyphen = 333),
                  (t.period = 278),
                  (t.slash = 278),
                  (t.zero = 556),
                  (t.one = 556),
                  (t.two = 556),
                  (t.three = 556),
                  (t.four = 556),
                  (t.five = 556),
                  (t.six = 556),
                  (t.seven = 556),
                  (t.eight = 556),
                  (t.nine = 556),
                  (t.colon = 333),
                  (t.semicolon = 333),
                  (t.less = 584),
                  (t.equal = 584),
                  (t.greater = 584),
                  (t.question = 611),
                  (t.at = 975),
                  (t.A = 722),
                  (t.B = 722),
                  (t.C = 722),
                  (t.D = 722),
                  (t.E = 667),
                  (t.F = 611),
                  (t.G = 778),
                  (t.H = 722),
                  (t.I = 278),
                  (t.J = 556),
                  (t.K = 722),
                  (t.L = 611),
                  (t.M = 833),
                  (t.N = 722),
                  (t.O = 778),
                  (t.P = 667),
                  (t.Q = 778),
                  (t.R = 722),
                  (t.S = 667),
                  (t.T = 611),
                  (t.U = 722),
                  (t.V = 667),
                  (t.W = 944),
                  (t.X = 667),
                  (t.Y = 667),
                  (t.Z = 611),
                  (t.bracketleft = 333),
                  (t.backslash = 278),
                  (t.bracketright = 333),
                  (t.asciicircum = 584),
                  (t.underscore = 556),
                  (t.quoteleft = 278),
                  (t.a = 556),
                  (t.b = 611),
                  (t.c = 556),
                  (t.d = 611),
                  (t.e = 556),
                  (t.f = 333),
                  (t.g = 611),
                  (t.h = 611),
                  (t.i = 278),
                  (t.j = 278),
                  (t.k = 556),
                  (t.l = 278),
                  (t.m = 889),
                  (t.n = 611),
                  (t.o = 611),
                  (t.p = 611),
                  (t.q = 611),
                  (t.r = 389),
                  (t.s = 556),
                  (t.t = 333),
                  (t.u = 611),
                  (t.v = 556),
                  (t.w = 778),
                  (t.x = 556),
                  (t.y = 556),
                  (t.z = 500),
                  (t.braceleft = 389),
                  (t.bar = 280),
                  (t.braceright = 389),
                  (t.asciitilde = 584),
                  (t.exclamdown = 333),
                  (t.cent = 556),
                  (t.sterling = 556),
                  (t.fraction = 167),
                  (t.yen = 556),
                  (t.florin = 556),
                  (t.section = 556),
                  (t.currency = 556),
                  (t.quotesingle = 238),
                  (t.quotedblleft = 500),
                  (t.guillemotleft = 556),
                  (t.guilsinglleft = 333),
                  (t.guilsinglright = 333),
                  (t.fi = 611),
                  (t.fl = 611),
                  (t.endash = 556),
                  (t.dagger = 556),
                  (t.daggerdbl = 556),
                  (t.periodcentered = 278),
                  (t.paragraph = 556),
                  (t.bullet = 350),
                  (t.quotesinglbase = 278),
                  (t.quotedblbase = 500),
                  (t.quotedblright = 500),
                  (t.guillemotright = 556),
                  (t.ellipsis = 1e3),
                  (t.perthousand = 1e3),
                  (t.questiondown = 611),
                  (t.grave = 333),
                  (t.acute = 333),
                  (t.circumflex = 333),
                  (t.tilde = 333),
                  (t.macron = 333),
                  (t.breve = 333),
                  (t.dotaccent = 333),
                  (t.dieresis = 333),
                  (t.ring = 333),
                  (t.cedilla = 333),
                  (t.hungarumlaut = 333),
                  (t.ogonek = 333),
                  (t.caron = 333),
                  (t.emdash = 1e3),
                  (t.AE = 1e3),
                  (t.ordfeminine = 370),
                  (t.Lslash = 611),
                  (t.Oslash = 778),
                  (t.OE = 1e3),
                  (t.ordmasculine = 365),
                  (t.ae = 889),
                  (t.dotlessi = 278),
                  (t.lslash = 278),
                  (t.oslash = 611),
                  (t.oe = 944),
                  (t.germandbls = 611),
                  (t.Idieresis = 278),
                  (t.eacute = 556),
                  (t.abreve = 556),
                  (t.uhungarumlaut = 611),
                  (t.ecaron = 556),
                  (t.Ydieresis = 667),
                  (t.divide = 584),
                  (t.Yacute = 667),
                  (t.Acircumflex = 722),
                  (t.aacute = 556),
                  (t.Ucircumflex = 722),
                  (t.yacute = 556),
                  (t.scommaaccent = 556),
                  (t.ecircumflex = 556),
                  (t.Uring = 722),
                  (t.Udieresis = 722),
                  (t.aogonek = 556),
                  (t.Uacute = 722),
                  (t.uogonek = 611),
                  (t.Edieresis = 667),
                  (t.Dcroat = 722),
                  (t.commaaccent = 250),
                  (t.copyright = 737),
                  (t.Emacron = 667),
                  (t.ccaron = 556),
                  (t.aring = 556),
                  (t.Ncommaaccent = 722),
                  (t.lacute = 278),
                  (t.agrave = 556),
                  (t.Tcommaaccent = 611),
                  (t.Cacute = 722),
                  (t.atilde = 556),
                  (t.Edotaccent = 667),
                  (t.scaron = 556),
                  (t.scedilla = 556),
                  (t.iacute = 278),
                  (t.lozenge = 494),
                  (t.Rcaron = 722),
                  (t.Gcommaaccent = 778),
                  (t.ucircumflex = 611),
                  (t.acircumflex = 556),
                  (t.Amacron = 722),
                  (t.rcaron = 389),
                  (t.ccedilla = 556),
                  (t.Zdotaccent = 611),
                  (t.Thorn = 667),
                  (t.Omacron = 778),
                  (t.Racute = 722),
                  (t.Sacute = 667),
                  (t.dcaron = 743),
                  (t.Umacron = 722),
                  (t.uring = 611),
                  (t.threesuperior = 333),
                  (t.Ograve = 778),
                  (t.Agrave = 722),
                  (t.Abreve = 722),
                  (t.multiply = 584),
                  (t.uacute = 611),
                  (t.Tcaron = 611),
                  (t.partialdiff = 494),
                  (t.ydieresis = 556),
                  (t.Nacute = 722),
                  (t.icircumflex = 278),
                  (t.Ecircumflex = 667),
                  (t.adieresis = 556),
                  (t.edieresis = 556),
                  (t.cacute = 556),
                  (t.nacute = 611),
                  (t.umacron = 611),
                  (t.Ncaron = 722),
                  (t.Iacute = 278),
                  (t.plusminus = 584),
                  (t.brokenbar = 280),
                  (t.registered = 737),
                  (t.Gbreve = 778),
                  (t.Idotaccent = 278),
                  (t.summation = 600),
                  (t.Egrave = 667),
                  (t.racute = 389),
                  (t.omacron = 611),
                  (t.Zacute = 611),
                  (t.Zcaron = 611),
                  (t.greaterequal = 549),
                  (t.Eth = 722),
                  (t.Ccedilla = 722),
                  (t.lcommaaccent = 278),
                  (t.tcaron = 389),
                  (t.eogonek = 556),
                  (t.Uogonek = 722),
                  (t.Aacute = 722),
                  (t.Adieresis = 722),
                  (t.egrave = 556),
                  (t.zacute = 500),
                  (t.iogonek = 278),
                  (t.Oacute = 778),
                  (t.oacute = 611),
                  (t.amacron = 556),
                  (t.sacute = 556),
                  (t.idieresis = 278),
                  (t.Ocircumflex = 778),
                  (t.Ugrave = 722),
                  (t.Delta = 612),
                  (t.thorn = 611),
                  (t.twosuperior = 333),
                  (t.Odieresis = 778),
                  (t.mu = 611),
                  (t.igrave = 278),
                  (t.ohungarumlaut = 611),
                  (t.Eogonek = 667),
                  (t.dcroat = 611),
                  (t.threequarters = 834),
                  (t.Scedilla = 667),
                  (t.lcaron = 400),
                  (t.Kcommaaccent = 722),
                  (t.Lacute = 611),
                  (t.trademark = 1e3),
                  (t.edotaccent = 556),
                  (t.Igrave = 278),
                  (t.Imacron = 278),
                  (t.Lcaron = 611),
                  (t.onehalf = 834),
                  (t.lessequal = 549),
                  (t.ocircumflex = 611),
                  (t.ntilde = 611),
                  (t.Uhungarumlaut = 722),
                  (t.Eacute = 667),
                  (t.emacron = 556),
                  (t.gbreve = 611),
                  (t.onequarter = 834),
                  (t.Scaron = 667),
                  (t.Scommaaccent = 667),
                  (t.Ohungarumlaut = 778),
                  (t.degree = 400),
                  (t.ograve = 611),
                  (t.Ccaron = 722),
                  (t.ugrave = 611),
                  (t.radical = 549),
                  (t.Dcaron = 722),
                  (t.rcommaaccent = 389),
                  (t.Ntilde = 722),
                  (t.otilde = 611),
                  (t.Rcommaaccent = 722),
                  (t.Lcommaaccent = 611),
                  (t.Atilde = 722),
                  (t.Aogonek = 722),
                  (t.Aring = 722),
                  (t.Otilde = 778),
                  (t.zdotaccent = 500),
                  (t.Ecaron = 667),
                  (t.Iogonek = 278),
                  (t.kcommaaccent = 556),
                  (t.minus = 584),
                  (t.Icircumflex = 278),
                  (t.ncaron = 611),
                  (t.tcommaaccent = 333),
                  (t.logicalnot = 584),
                  (t.odieresis = 611),
                  (t.udieresis = 611),
                  (t.notequal = 549),
                  (t.gcommaaccent = 611),
                  (t.eth = 611),
                  (t.zcaron = 500),
                  (t.ncommaaccent = 611),
                  (t.onesuperior = 333),
                  (t.imacron = 278),
                  (t.Euro = 556);
              },
            )),
            (t["Helvetica-Oblique"] = (0, i.getLookupTableFactory)(
              function (t) {
                (t.space = 278),
                  (t.exclam = 278),
                  (t.quotedbl = 355),
                  (t.numbersign = 556),
                  (t.dollar = 556),
                  (t.percent = 889),
                  (t.ampersand = 667),
                  (t.quoteright = 222),
                  (t.parenleft = 333),
                  (t.parenright = 333),
                  (t.asterisk = 389),
                  (t.plus = 584),
                  (t.comma = 278),
                  (t.hyphen = 333),
                  (t.period = 278),
                  (t.slash = 278),
                  (t.zero = 556),
                  (t.one = 556),
                  (t.two = 556),
                  (t.three = 556),
                  (t.four = 556),
                  (t.five = 556),
                  (t.six = 556),
                  (t.seven = 556),
                  (t.eight = 556),
                  (t.nine = 556),
                  (t.colon = 278),
                  (t.semicolon = 278),
                  (t.less = 584),
                  (t.equal = 584),
                  (t.greater = 584),
                  (t.question = 556),
                  (t.at = 1015),
                  (t.A = 667),
                  (t.B = 667),
                  (t.C = 722),
                  (t.D = 722),
                  (t.E = 667),
                  (t.F = 611),
                  (t.G = 778),
                  (t.H = 722),
                  (t.I = 278),
                  (t.J = 500),
                  (t.K = 667),
                  (t.L = 556),
                  (t.M = 833),
                  (t.N = 722),
                  (t.O = 778),
                  (t.P = 667),
                  (t.Q = 778),
                  (t.R = 722),
                  (t.S = 667),
                  (t.T = 611),
                  (t.U = 722),
                  (t.V = 667),
                  (t.W = 944),
                  (t.X = 667),
                  (t.Y = 667),
                  (t.Z = 611),
                  (t.bracketleft = 278),
                  (t.backslash = 278),
                  (t.bracketright = 278),
                  (t.asciicircum = 469),
                  (t.underscore = 556),
                  (t.quoteleft = 222),
                  (t.a = 556),
                  (t.b = 556),
                  (t.c = 500),
                  (t.d = 556),
                  (t.e = 556),
                  (t.f = 278),
                  (t.g = 556),
                  (t.h = 556),
                  (t.i = 222),
                  (t.j = 222),
                  (t.k = 500),
                  (t.l = 222),
                  (t.m = 833),
                  (t.n = 556),
                  (t.o = 556),
                  (t.p = 556),
                  (t.q = 556),
                  (t.r = 333),
                  (t.s = 500),
                  (t.t = 278),
                  (t.u = 556),
                  (t.v = 500),
                  (t.w = 722),
                  (t.x = 500),
                  (t.y = 500),
                  (t.z = 500),
                  (t.braceleft = 334),
                  (t.bar = 260),
                  (t.braceright = 334),
                  (t.asciitilde = 584),
                  (t.exclamdown = 333),
                  (t.cent = 556),
                  (t.sterling = 556),
                  (t.fraction = 167),
                  (t.yen = 556),
                  (t.florin = 556),
                  (t.section = 556),
                  (t.currency = 556),
                  (t.quotesingle = 191),
                  (t.quotedblleft = 333),
                  (t.guillemotleft = 556),
                  (t.guilsinglleft = 333),
                  (t.guilsinglright = 333),
                  (t.fi = 500),
                  (t.fl = 500),
                  (t.endash = 556),
                  (t.dagger = 556),
                  (t.daggerdbl = 556),
                  (t.periodcentered = 278),
                  (t.paragraph = 537),
                  (t.bullet = 350),
                  (t.quotesinglbase = 222),
                  (t.quotedblbase = 333),
                  (t.quotedblright = 333),
                  (t.guillemotright = 556),
                  (t.ellipsis = 1e3),
                  (t.perthousand = 1e3),
                  (t.questiondown = 611),
                  (t.grave = 333),
                  (t.acute = 333),
                  (t.circumflex = 333),
                  (t.tilde = 333),
                  (t.macron = 333),
                  (t.breve = 333),
                  (t.dotaccent = 333),
                  (t.dieresis = 333),
                  (t.ring = 333),
                  (t.cedilla = 333),
                  (t.hungarumlaut = 333),
                  (t.ogonek = 333),
                  (t.caron = 333),
                  (t.emdash = 1e3),
                  (t.AE = 1e3),
                  (t.ordfeminine = 370),
                  (t.Lslash = 556),
                  (t.Oslash = 778),
                  (t.OE = 1e3),
                  (t.ordmasculine = 365),
                  (t.ae = 889),
                  (t.dotlessi = 278),
                  (t.lslash = 222),
                  (t.oslash = 611),
                  (t.oe = 944),
                  (t.germandbls = 611),
                  (t.Idieresis = 278),
                  (t.eacute = 556),
                  (t.abreve = 556),
                  (t.uhungarumlaut = 556),
                  (t.ecaron = 556),
                  (t.Ydieresis = 667),
                  (t.divide = 584),
                  (t.Yacute = 667),
                  (t.Acircumflex = 667),
                  (t.aacute = 556),
                  (t.Ucircumflex = 722),
                  (t.yacute = 500),
                  (t.scommaaccent = 500),
                  (t.ecircumflex = 556),
                  (t.Uring = 722),
                  (t.Udieresis = 722),
                  (t.aogonek = 556),
                  (t.Uacute = 722),
                  (t.uogonek = 556),
                  (t.Edieresis = 667),
                  (t.Dcroat = 722),
                  (t.commaaccent = 250),
                  (t.copyright = 737),
                  (t.Emacron = 667),
                  (t.ccaron = 500),
                  (t.aring = 556),
                  (t.Ncommaaccent = 722),
                  (t.lacute = 222),
                  (t.agrave = 556),
                  (t.Tcommaaccent = 611),
                  (t.Cacute = 722),
                  (t.atilde = 556),
                  (t.Edotaccent = 667),
                  (t.scaron = 500),
                  (t.scedilla = 500),
                  (t.iacute = 278),
                  (t.lozenge = 471),
                  (t.Rcaron = 722),
                  (t.Gcommaaccent = 778),
                  (t.ucircumflex = 556),
                  (t.acircumflex = 556),
                  (t.Amacron = 667),
                  (t.rcaron = 333),
                  (t.ccedilla = 500),
                  (t.Zdotaccent = 611),
                  (t.Thorn = 667),
                  (t.Omacron = 778),
                  (t.Racute = 722),
                  (t.Sacute = 667),
                  (t.dcaron = 643),
                  (t.Umacron = 722),
                  (t.uring = 556),
                  (t.threesuperior = 333),
                  (t.Ograve = 778),
                  (t.Agrave = 667),
                  (t.Abreve = 667),
                  (t.multiply = 584),
                  (t.uacute = 556),
                  (t.Tcaron = 611),
                  (t.partialdiff = 476),
                  (t.ydieresis = 500),
                  (t.Nacute = 722),
                  (t.icircumflex = 278),
                  (t.Ecircumflex = 667),
                  (t.adieresis = 556),
                  (t.edieresis = 556),
                  (t.cacute = 500),
                  (t.nacute = 556),
                  (t.umacron = 556),
                  (t.Ncaron = 722),
                  (t.Iacute = 278),
                  (t.plusminus = 584),
                  (t.brokenbar = 260),
                  (t.registered = 737),
                  (t.Gbreve = 778),
                  (t.Idotaccent = 278),
                  (t.summation = 600),
                  (t.Egrave = 667),
                  (t.racute = 333),
                  (t.omacron = 556),
                  (t.Zacute = 611),
                  (t.Zcaron = 611),
                  (t.greaterequal = 549),
                  (t.Eth = 722),
                  (t.Ccedilla = 722),
                  (t.lcommaaccent = 222),
                  (t.tcaron = 317),
                  (t.eogonek = 556),
                  (t.Uogonek = 722),
                  (t.Aacute = 667),
                  (t.Adieresis = 667),
                  (t.egrave = 556),
                  (t.zacute = 500),
                  (t.iogonek = 222),
                  (t.Oacute = 778),
                  (t.oacute = 556),
                  (t.amacron = 556),
                  (t.sacute = 500),
                  (t.idieresis = 278),
                  (t.Ocircumflex = 778),
                  (t.Ugrave = 722),
                  (t.Delta = 612),
                  (t.thorn = 556),
                  (t.twosuperior = 333),
                  (t.Odieresis = 778),
                  (t.mu = 556),
                  (t.igrave = 278),
                  (t.ohungarumlaut = 556),
                  (t.Eogonek = 667),
                  (t.dcroat = 556),
                  (t.threequarters = 834),
                  (t.Scedilla = 667),
                  (t.lcaron = 299),
                  (t.Kcommaaccent = 667),
                  (t.Lacute = 556),
                  (t.trademark = 1e3),
                  (t.edotaccent = 556),
                  (t.Igrave = 278),
                  (t.Imacron = 278),
                  (t.Lcaron = 556),
                  (t.onehalf = 834),
                  (t.lessequal = 549),
                  (t.ocircumflex = 556),
                  (t.ntilde = 556),
                  (t.Uhungarumlaut = 722),
                  (t.Eacute = 667),
                  (t.emacron = 556),
                  (t.gbreve = 556),
                  (t.onequarter = 834),
                  (t.Scaron = 667),
                  (t.Scommaaccent = 667),
                  (t.Ohungarumlaut = 778),
                  (t.degree = 400),
                  (t.ograve = 556),
                  (t.Ccaron = 722),
                  (t.ugrave = 556),
                  (t.radical = 453),
                  (t.Dcaron = 722),
                  (t.rcommaaccent = 333),
                  (t.Ntilde = 722),
                  (t.otilde = 556),
                  (t.Rcommaaccent = 722),
                  (t.Lcommaaccent = 556),
                  (t.Atilde = 667),
                  (t.Aogonek = 667),
                  (t.Aring = 667),
                  (t.Otilde = 778),
                  (t.zdotaccent = 500),
                  (t.Ecaron = 667),
                  (t.Iogonek = 278),
                  (t.kcommaaccent = 500),
                  (t.minus = 584),
                  (t.Icircumflex = 278),
                  (t.ncaron = 556),
                  (t.tcommaaccent = 278),
                  (t.logicalnot = 584),
                  (t.odieresis = 556),
                  (t.udieresis = 556),
                  (t.notequal = 549),
                  (t.gcommaaccent = 556),
                  (t.eth = 556),
                  (t.zcaron = 500),
                  (t.ncommaaccent = 556),
                  (t.onesuperior = 333),
                  (t.imacron = 278),
                  (t.Euro = 556);
              },
            )),
            (t.Symbol = (0, i.getLookupTableFactory)(function (t) {
              (t.space = 250),
                (t.exclam = 333),
                (t.universal = 713),
                (t.numbersign = 500),
                (t.existential = 549),
                (t.percent = 833),
                (t.ampersand = 778),
                (t.suchthat = 439),
                (t.parenleft = 333),
                (t.parenright = 333),
                (t.asteriskmath = 500),
                (t.plus = 549),
                (t.comma = 250),
                (t.minus = 549),
                (t.period = 250),
                (t.slash = 278),
                (t.zero = 500),
                (t.one = 500),
                (t.two = 500),
                (t.three = 500),
                (t.four = 500),
                (t.five = 500),
                (t.six = 500),
                (t.seven = 500),
                (t.eight = 500),
                (t.nine = 500),
                (t.colon = 278),
                (t.semicolon = 278),
                (t.less = 549),
                (t.equal = 549),
                (t.greater = 549),
                (t.question = 444),
                (t.congruent = 549),
                (t.Alpha = 722),
                (t.Beta = 667),
                (t.Chi = 722),
                (t.Delta = 612),
                (t.Epsilon = 611),
                (t.Phi = 763),
                (t.Gamma = 603),
                (t.Eta = 722),
                (t.Iota = 333),
                (t.theta1 = 631),
                (t.Kappa = 722),
                (t.Lambda = 686),
                (t.Mu = 889),
                (t.Nu = 722),
                (t.Omicron = 722),
                (t.Pi = 768),
                (t.Theta = 741),
                (t.Rho = 556),
                (t.Sigma = 592),
                (t.Tau = 611),
                (t.Upsilon = 690),
                (t.sigma1 = 439),
                (t.Omega = 768),
                (t.Xi = 645),
                (t.Psi = 795),
                (t.Zeta = 611),
                (t.bracketleft = 333),
                (t.therefore = 863),
                (t.bracketright = 333),
                (t.perpendicular = 658),
                (t.underscore = 500),
                (t.radicalex = 500),
                (t.alpha = 631),
                (t.beta = 549),
                (t.chi = 549),
                (t.delta = 494),
                (t.epsilon = 439),
                (t.phi = 521),
                (t.gamma = 411),
                (t.eta = 603),
                (t.iota = 329),
                (t.phi1 = 603),
                (t.kappa = 549),
                (t.lambda = 549),
                (t.mu = 576),
                (t.nu = 521),
                (t.omicron = 549),
                (t.pi = 549),
                (t.theta = 521),
                (t.rho = 549),
                (t.sigma = 603),
                (t.tau = 439),
                (t.upsilon = 576),
                (t.omega1 = 713),
                (t.omega = 686),
                (t.xi = 493),
                (t.psi = 686),
                (t.zeta = 494),
                (t.braceleft = 480),
                (t.bar = 200),
                (t.braceright = 480),
                (t.similar = 549),
                (t.Euro = 750),
                (t.Upsilon1 = 620),
                (t.minute = 247),
                (t.lessequal = 549),
                (t.fraction = 167),
                (t.infinity = 713),
                (t.florin = 500),
                (t.club = 753),
                (t.diamond = 753),
                (t.heart = 753),
                (t.spade = 753),
                (t.arrowboth = 1042),
                (t.arrowleft = 987),
                (t.arrowup = 603),
                (t.arrowright = 987),
                (t.arrowdown = 603),
                (t.degree = 400),
                (t.plusminus = 549),
                (t.second = 411),
                (t.greaterequal = 549),
                (t.multiply = 549),
                (t.proportional = 713),
                (t.partialdiff = 494),
                (t.bullet = 460),
                (t.divide = 549),
                (t.notequal = 549),
                (t.equivalence = 549),
                (t.approxequal = 549),
                (t.ellipsis = 1e3),
                (t.arrowvertex = 603),
                (t.arrowhorizex = 1e3),
                (t.carriagereturn = 658),
                (t.aleph = 823),
                (t.Ifraktur = 686),
                (t.Rfraktur = 795),
                (t.weierstrass = 987),
                (t.circlemultiply = 768),
                (t.circleplus = 768),
                (t.emptyset = 823),
                (t.intersection = 768),
                (t.union = 768),
                (t.propersuperset = 713),
                (t.reflexsuperset = 713),
                (t.notsubset = 713),
                (t.propersubset = 713),
                (t.reflexsubset = 713),
                (t.element = 713),
                (t.notelement = 713),
                (t.angle = 768),
                (t.gradient = 713),
                (t.registerserif = 790),
                (t.copyrightserif = 790),
                (t.trademarkserif = 890),
                (t.product = 823),
                (t.radical = 549),
                (t.dotmath = 250),
                (t.logicalnot = 713),
                (t.logicaland = 603),
                (t.logicalor = 603),
                (t.arrowdblboth = 1042),
                (t.arrowdblleft = 987),
                (t.arrowdblup = 603),
                (t.arrowdblright = 987),
                (t.arrowdbldown = 603),
                (t.lozenge = 494),
                (t.angleleft = 329),
                (t.registersans = 790),
                (t.copyrightsans = 790),
                (t.trademarksans = 786),
                (t.summation = 713),
                (t.parenlefttp = 384),
                (t.parenleftex = 384),
                (t.parenleftbt = 384),
                (t.bracketlefttp = 384),
                (t.bracketleftex = 384),
                (t.bracketleftbt = 384),
                (t.bracelefttp = 494),
                (t.braceleftmid = 494),
                (t.braceleftbt = 494),
                (t.braceex = 494),
                (t.angleright = 329),
                (t.integral = 274),
                (t.integraltp = 686),
                (t.integralex = 686),
                (t.integralbt = 686),
                (t.parenrighttp = 384),
                (t.parenrightex = 384),
                (t.parenrightbt = 384),
                (t.bracketrighttp = 384),
                (t.bracketrightex = 384),
                (t.bracketrightbt = 384),
                (t.bracerighttp = 494),
                (t.bracerightmid = 494),
                (t.bracerightbt = 494),
                (t.apple = 790);
            })),
            (t["Times-Roman"] = (0, i.getLookupTableFactory)(function (t) {
              (t.space = 250),
                (t.exclam = 333),
                (t.quotedbl = 408),
                (t.numbersign = 500),
                (t.dollar = 500),
                (t.percent = 833),
                (t.ampersand = 778),
                (t.quoteright = 333),
                (t.parenleft = 333),
                (t.parenright = 333),
                (t.asterisk = 500),
                (t.plus = 564),
                (t.comma = 250),
                (t.hyphen = 333),
                (t.period = 250),
                (t.slash = 278),
                (t.zero = 500),
                (t.one = 500),
                (t.two = 500),
                (t.three = 500),
                (t.four = 500),
                (t.five = 500),
                (t.six = 500),
                (t.seven = 500),
                (t.eight = 500),
                (t.nine = 500),
                (t.colon = 278),
                (t.semicolon = 278),
                (t.less = 564),
                (t.equal = 564),
                (t.greater = 564),
                (t.question = 444),
                (t.at = 921),
                (t.A = 722),
                (t.B = 667),
                (t.C = 667),
                (t.D = 722),
                (t.E = 611),
                (t.F = 556),
                (t.G = 722),
                (t.H = 722),
                (t.I = 333),
                (t.J = 389),
                (t.K = 722),
                (t.L = 611),
                (t.M = 889),
                (t.N = 722),
                (t.O = 722),
                (t.P = 556),
                (t.Q = 722),
                (t.R = 667),
                (t.S = 556),
                (t.T = 611),
                (t.U = 722),
                (t.V = 722),
                (t.W = 944),
                (t.X = 722),
                (t.Y = 722),
                (t.Z = 611),
                (t.bracketleft = 333),
                (t.backslash = 278),
                (t.bracketright = 333),
                (t.asciicircum = 469),
                (t.underscore = 500),
                (t.quoteleft = 333),
                (t.a = 444),
                (t.b = 500),
                (t.c = 444),
                (t.d = 500),
                (t.e = 444),
                (t.f = 333),
                (t.g = 500),
                (t.h = 500),
                (t.i = 278),
                (t.j = 278),
                (t.k = 500),
                (t.l = 278),
                (t.m = 778),
                (t.n = 500),
                (t.o = 500),
                (t.p = 500),
                (t.q = 500),
                (t.r = 333),
                (t.s = 389),
                (t.t = 278),
                (t.u = 500),
                (t.v = 500),
                (t.w = 722),
                (t.x = 500),
                (t.y = 500),
                (t.z = 444),
                (t.braceleft = 480),
                (t.bar = 200),
                (t.braceright = 480),
                (t.asciitilde = 541),
                (t.exclamdown = 333),
                (t.cent = 500),
                (t.sterling = 500),
                (t.fraction = 167),
                (t.yen = 500),
                (t.florin = 500),
                (t.section = 500),
                (t.currency = 500),
                (t.quotesingle = 180),
                (t.quotedblleft = 444),
                (t.guillemotleft = 500),
                (t.guilsinglleft = 333),
                (t.guilsinglright = 333),
                (t.fi = 556),
                (t.fl = 556),
                (t.endash = 500),
                (t.dagger = 500),
                (t.daggerdbl = 500),
                (t.periodcentered = 250),
                (t.paragraph = 453),
                (t.bullet = 350),
                (t.quotesinglbase = 333),
                (t.quotedblbase = 444),
                (t.quotedblright = 444),
                (t.guillemotright = 500),
                (t.ellipsis = 1e3),
                (t.perthousand = 1e3),
                (t.questiondown = 444),
                (t.grave = 333),
                (t.acute = 333),
                (t.circumflex = 333),
                (t.tilde = 333),
                (t.macron = 333),
                (t.breve = 333),
                (t.dotaccent = 333),
                (t.dieresis = 333),
                (t.ring = 333),
                (t.cedilla = 333),
                (t.hungarumlaut = 333),
                (t.ogonek = 333),
                (t.caron = 333),
                (t.emdash = 1e3),
                (t.AE = 889),
                (t.ordfeminine = 276),
                (t.Lslash = 611),
                (t.Oslash = 722),
                (t.OE = 889),
                (t.ordmasculine = 310),
                (t.ae = 667),
                (t.dotlessi = 278),
                (t.lslash = 278),
                (t.oslash = 500),
                (t.oe = 722),
                (t.germandbls = 500),
                (t.Idieresis = 333),
                (t.eacute = 444),
                (t.abreve = 444),
                (t.uhungarumlaut = 500),
                (t.ecaron = 444),
                (t.Ydieresis = 722),
                (t.divide = 564),
                (t.Yacute = 722),
                (t.Acircumflex = 722),
                (t.aacute = 444),
                (t.Ucircumflex = 722),
                (t.yacute = 500),
                (t.scommaaccent = 389),
                (t.ecircumflex = 444),
                (t.Uring = 722),
                (t.Udieresis = 722),
                (t.aogonek = 444),
                (t.Uacute = 722),
                (t.uogonek = 500),
                (t.Edieresis = 611),
                (t.Dcroat = 722),
                (t.commaaccent = 250),
                (t.copyright = 760),
                (t.Emacron = 611),
                (t.ccaron = 444),
                (t.aring = 444),
                (t.Ncommaaccent = 722),
                (t.lacute = 278),
                (t.agrave = 444),
                (t.Tcommaaccent = 611),
                (t.Cacute = 667),
                (t.atilde = 444),
                (t.Edotaccent = 611),
                (t.scaron = 389),
                (t.scedilla = 389),
                (t.iacute = 278),
                (t.lozenge = 471),
                (t.Rcaron = 667),
                (t.Gcommaaccent = 722),
                (t.ucircumflex = 500),
                (t.acircumflex = 444),
                (t.Amacron = 722),
                (t.rcaron = 333),
                (t.ccedilla = 444),
                (t.Zdotaccent = 611),
                (t.Thorn = 556),
                (t.Omacron = 722),
                (t.Racute = 667),
                (t.Sacute = 556),
                (t.dcaron = 588),
                (t.Umacron = 722),
                (t.uring = 500),
                (t.threesuperior = 300),
                (t.Ograve = 722),
                (t.Agrave = 722),
                (t.Abreve = 722),
                (t.multiply = 564),
                (t.uacute = 500),
                (t.Tcaron = 611),
                (t.partialdiff = 476),
                (t.ydieresis = 500),
                (t.Nacute = 722),
                (t.icircumflex = 278),
                (t.Ecircumflex = 611),
                (t.adieresis = 444),
                (t.edieresis = 444),
                (t.cacute = 444),
                (t.nacute = 500),
                (t.umacron = 500),
                (t.Ncaron = 722),
                (t.Iacute = 333),
                (t.plusminus = 564),
                (t.brokenbar = 200),
                (t.registered = 760),
                (t.Gbreve = 722),
                (t.Idotaccent = 333),
                (t.summation = 600),
                (t.Egrave = 611),
                (t.racute = 333),
                (t.omacron = 500),
                (t.Zacute = 611),
                (t.Zcaron = 611),
                (t.greaterequal = 549),
                (t.Eth = 722),
                (t.Ccedilla = 667),
                (t.lcommaaccent = 278),
                (t.tcaron = 326),
                (t.eogonek = 444),
                (t.Uogonek = 722),
                (t.Aacute = 722),
                (t.Adieresis = 722),
                (t.egrave = 444),
                (t.zacute = 444),
                (t.iogonek = 278),
                (t.Oacute = 722),
                (t.oacute = 500),
                (t.amacron = 444),
                (t.sacute = 389),
                (t.idieresis = 278),
                (t.Ocircumflex = 722),
                (t.Ugrave = 722),
                (t.Delta = 612),
                (t.thorn = 500),
                (t.twosuperior = 300),
                (t.Odieresis = 722),
                (t.mu = 500),
                (t.igrave = 278),
                (t.ohungarumlaut = 500),
                (t.Eogonek = 611),
                (t.dcroat = 500),
                (t.threequarters = 750),
                (t.Scedilla = 556),
                (t.lcaron = 344),
                (t.Kcommaaccent = 722),
                (t.Lacute = 611),
                (t.trademark = 980),
                (t.edotaccent = 444),
                (t.Igrave = 333),
                (t.Imacron = 333),
                (t.Lcaron = 611),
                (t.onehalf = 750),
                (t.lessequal = 549),
                (t.ocircumflex = 500),
                (t.ntilde = 500),
                (t.Uhungarumlaut = 722),
                (t.Eacute = 611),
                (t.emacron = 444),
                (t.gbreve = 500),
                (t.onequarter = 750),
                (t.Scaron = 556),
                (t.Scommaaccent = 556),
                (t.Ohungarumlaut = 722),
                (t.degree = 400),
                (t.ograve = 500),
                (t.Ccaron = 667),
                (t.ugrave = 500),
                (t.radical = 453),
                (t.Dcaron = 722),
                (t.rcommaaccent = 333),
                (t.Ntilde = 722),
                (t.otilde = 500),
                (t.Rcommaaccent = 667),
                (t.Lcommaaccent = 611),
                (t.Atilde = 722),
                (t.Aogonek = 722),
                (t.Aring = 722),
                (t.Otilde = 722),
                (t.zdotaccent = 444),
                (t.Ecaron = 611),
                (t.Iogonek = 333),
                (t.kcommaaccent = 500),
                (t.minus = 564),
                (t.Icircumflex = 333),
                (t.ncaron = 500),
                (t.tcommaaccent = 278),
                (t.logicalnot = 564),
                (t.odieresis = 500),
                (t.udieresis = 500),
                (t.notequal = 549),
                (t.gcommaaccent = 500),
                (t.eth = 500),
                (t.zcaron = 444),
                (t.ncommaaccent = 500),
                (t.onesuperior = 300),
                (t.imacron = 278),
                (t.Euro = 500);
            })),
            (t["Times-Bold"] = (0, i.getLookupTableFactory)(function (t) {
              (t.space = 250),
                (t.exclam = 333),
                (t.quotedbl = 555),
                (t.numbersign = 500),
                (t.dollar = 500),
                (t.percent = 1e3),
                (t.ampersand = 833),
                (t.quoteright = 333),
                (t.parenleft = 333),
                (t.parenright = 333),
                (t.asterisk = 500),
                (t.plus = 570),
                (t.comma = 250),
                (t.hyphen = 333),
                (t.period = 250),
                (t.slash = 278),
                (t.zero = 500),
                (t.one = 500),
                (t.two = 500),
                (t.three = 500),
                (t.four = 500),
                (t.five = 500),
                (t.six = 500),
                (t.seven = 500),
                (t.eight = 500),
                (t.nine = 500),
                (t.colon = 333),
                (t.semicolon = 333),
                (t.less = 570),
                (t.equal = 570),
                (t.greater = 570),
                (t.question = 500),
                (t.at = 930),
                (t.A = 722),
                (t.B = 667),
                (t.C = 722),
                (t.D = 722),
                (t.E = 667),
                (t.F = 611),
                (t.G = 778),
                (t.H = 778),
                (t.I = 389),
                (t.J = 500),
                (t.K = 778),
                (t.L = 667),
                (t.M = 944),
                (t.N = 722),
                (t.O = 778),
                (t.P = 611),
                (t.Q = 778),
                (t.R = 722),
                (t.S = 556),
                (t.T = 667),
                (t.U = 722),
                (t.V = 722),
                (t.W = 1e3),
                (t.X = 722),
                (t.Y = 722),
                (t.Z = 667),
                (t.bracketleft = 333),
                (t.backslash = 278),
                (t.bracketright = 333),
                (t.asciicircum = 581),
                (t.underscore = 500),
                (t.quoteleft = 333),
                (t.a = 500),
                (t.b = 556),
                (t.c = 444),
                (t.d = 556),
                (t.e = 444),
                (t.f = 333),
                (t.g = 500),
                (t.h = 556),
                (t.i = 278),
                (t.j = 333),
                (t.k = 556),
                (t.l = 278),
                (t.m = 833),
                (t.n = 556),
                (t.o = 500),
                (t.p = 556),
                (t.q = 556),
                (t.r = 444),
                (t.s = 389),
                (t.t = 333),
                (t.u = 556),
                (t.v = 500),
                (t.w = 722),
                (t.x = 500),
                (t.y = 500),
                (t.z = 444),
                (t.braceleft = 394),
                (t.bar = 220),
                (t.braceright = 394),
                (t.asciitilde = 520),
                (t.exclamdown = 333),
                (t.cent = 500),
                (t.sterling = 500),
                (t.fraction = 167),
                (t.yen = 500),
                (t.florin = 500),
                (t.section = 500),
                (t.currency = 500),
                (t.quotesingle = 278),
                (t.quotedblleft = 500),
                (t.guillemotleft = 500),
                (t.guilsinglleft = 333),
                (t.guilsinglright = 333),
                (t.fi = 556),
                (t.fl = 556),
                (t.endash = 500),
                (t.dagger = 500),
                (t.daggerdbl = 500),
                (t.periodcentered = 250),
                (t.paragraph = 540),
                (t.bullet = 350),
                (t.quotesinglbase = 333),
                (t.quotedblbase = 500),
                (t.quotedblright = 500),
                (t.guillemotright = 500),
                (t.ellipsis = 1e3),
                (t.perthousand = 1e3),
                (t.questiondown = 500),
                (t.grave = 333),
                (t.acute = 333),
                (t.circumflex = 333),
                (t.tilde = 333),
                (t.macron = 333),
                (t.breve = 333),
                (t.dotaccent = 333),
                (t.dieresis = 333),
                (t.ring = 333),
                (t.cedilla = 333),
                (t.hungarumlaut = 333),
                (t.ogonek = 333),
                (t.caron = 333),
                (t.emdash = 1e3),
                (t.AE = 1e3),
                (t.ordfeminine = 300),
                (t.Lslash = 667),
                (t.Oslash = 778),
                (t.OE = 1e3),
                (t.ordmasculine = 330),
                (t.ae = 722),
                (t.dotlessi = 278),
                (t.lslash = 278),
                (t.oslash = 500),
                (t.oe = 722),
                (t.germandbls = 556),
                (t.Idieresis = 389),
                (t.eacute = 444),
                (t.abreve = 500),
                (t.uhungarumlaut = 556),
                (t.ecaron = 444),
                (t.Ydieresis = 722),
                (t.divide = 570),
                (t.Yacute = 722),
                (t.Acircumflex = 722),
                (t.aacute = 500),
                (t.Ucircumflex = 722),
                (t.yacute = 500),
                (t.scommaaccent = 389),
                (t.ecircumflex = 444),
                (t.Uring = 722),
                (t.Udieresis = 722),
                (t.aogonek = 500),
                (t.Uacute = 722),
                (t.uogonek = 556),
                (t.Edieresis = 667),
                (t.Dcroat = 722),
                (t.commaaccent = 250),
                (t.copyright = 747),
                (t.Emacron = 667),
                (t.ccaron = 444),
                (t.aring = 500),
                (t.Ncommaaccent = 722),
                (t.lacute = 278),
                (t.agrave = 500),
                (t.Tcommaaccent = 667),
                (t.Cacute = 722),
                (t.atilde = 500),
                (t.Edotaccent = 667),
                (t.scaron = 389),
                (t.scedilla = 389),
                (t.iacute = 278),
                (t.lozenge = 494),
                (t.Rcaron = 722),
                (t.Gcommaaccent = 778),
                (t.ucircumflex = 556),
                (t.acircumflex = 500),
                (t.Amacron = 722),
                (t.rcaron = 444),
                (t.ccedilla = 444),
                (t.Zdotaccent = 667),
                (t.Thorn = 611),
                (t.Omacron = 778),
                (t.Racute = 722),
                (t.Sacute = 556),
                (t.dcaron = 672),
                (t.Umacron = 722),
                (t.uring = 556),
                (t.threesuperior = 300),
                (t.Ograve = 778),
                (t.Agrave = 722),
                (t.Abreve = 722),
                (t.multiply = 570),
                (t.uacute = 556),
                (t.Tcaron = 667),
                (t.partialdiff = 494),
                (t.ydieresis = 500),
                (t.Nacute = 722),
                (t.icircumflex = 278),
                (t.Ecircumflex = 667),
                (t.adieresis = 500),
                (t.edieresis = 444),
                (t.cacute = 444),
                (t.nacute = 556),
                (t.umacron = 556),
                (t.Ncaron = 722),
                (t.Iacute = 389),
                (t.plusminus = 570),
                (t.brokenbar = 220),
                (t.registered = 747),
                (t.Gbreve = 778),
                (t.Idotaccent = 389),
                (t.summation = 600),
                (t.Egrave = 667),
                (t.racute = 444),
                (t.omacron = 500),
                (t.Zacute = 667),
                (t.Zcaron = 667),
                (t.greaterequal = 549),
                (t.Eth = 722),
                (t.Ccedilla = 722),
                (t.lcommaaccent = 278),
                (t.tcaron = 416),
                (t.eogonek = 444),
                (t.Uogonek = 722),
                (t.Aacute = 722),
                (t.Adieresis = 722),
                (t.egrave = 444),
                (t.zacute = 444),
                (t.iogonek = 278),
                (t.Oacute = 778),
                (t.oacute = 500),
                (t.amacron = 500),
                (t.sacute = 389),
                (t.idieresis = 278),
                (t.Ocircumflex = 778),
                (t.Ugrave = 722),
                (t.Delta = 612),
                (t.thorn = 556),
                (t.twosuperior = 300),
                (t.Odieresis = 778),
                (t.mu = 556),
                (t.igrave = 278),
                (t.ohungarumlaut = 500),
                (t.Eogonek = 667),
                (t.dcroat = 556),
                (t.threequarters = 750),
                (t.Scedilla = 556),
                (t.lcaron = 394),
                (t.Kcommaaccent = 778),
                (t.Lacute = 667),
                (t.trademark = 1e3),
                (t.edotaccent = 444),
                (t.Igrave = 389),
                (t.Imacron = 389),
                (t.Lcaron = 667),
                (t.onehalf = 750),
                (t.lessequal = 549),
                (t.ocircumflex = 500),
                (t.ntilde = 556),
                (t.Uhungarumlaut = 722),
                (t.Eacute = 667),
                (t.emacron = 444),
                (t.gbreve = 500),
                (t.onequarter = 750),
                (t.Scaron = 556),
                (t.Scommaaccent = 556),
                (t.Ohungarumlaut = 778),
                (t.degree = 400),
                (t.ograve = 500),
                (t.Ccaron = 722),
                (t.ugrave = 556),
                (t.radical = 549),
                (t.Dcaron = 722),
                (t.rcommaaccent = 444),
                (t.Ntilde = 722),
                (t.otilde = 500),
                (t.Rcommaaccent = 722),
                (t.Lcommaaccent = 667),
                (t.Atilde = 722),
                (t.Aogonek = 722),
                (t.Aring = 722),
                (t.Otilde = 778),
                (t.zdotaccent = 444),
                (t.Ecaron = 667),
                (t.Iogonek = 389),
                (t.kcommaaccent = 556),
                (t.minus = 570),
                (t.Icircumflex = 389),
                (t.ncaron = 556),
                (t.tcommaaccent = 333),
                (t.logicalnot = 570),
                (t.odieresis = 500),
                (t.udieresis = 556),
                (t.notequal = 549),
                (t.gcommaaccent = 500),
                (t.eth = 500),
                (t.zcaron = 444),
                (t.ncommaaccent = 556),
                (t.onesuperior = 300),
                (t.imacron = 278),
                (t.Euro = 500);
            })),
            (t["Times-BoldItalic"] = (0, i.getLookupTableFactory)(function (t) {
              (t.space = 250),
                (t.exclam = 389),
                (t.quotedbl = 555),
                (t.numbersign = 500),
                (t.dollar = 500),
                (t.percent = 833),
                (t.ampersand = 778),
                (t.quoteright = 333),
                (t.parenleft = 333),
                (t.parenright = 333),
                (t.asterisk = 500),
                (t.plus = 570),
                (t.comma = 250),
                (t.hyphen = 333),
                (t.period = 250),
                (t.slash = 278),
                (t.zero = 500),
                (t.one = 500),
                (t.two = 500),
                (t.three = 500),
                (t.four = 500),
                (t.five = 500),
                (t.six = 500),
                (t.seven = 500),
                (t.eight = 500),
                (t.nine = 500),
                (t.colon = 333),
                (t.semicolon = 333),
                (t.less = 570),
                (t.equal = 570),
                (t.greater = 570),
                (t.question = 500),
                (t.at = 832),
                (t.A = 667),
                (t.B = 667),
                (t.C = 667),
                (t.D = 722),
                (t.E = 667),
                (t.F = 667),
                (t.G = 722),
                (t.H = 778),
                (t.I = 389),
                (t.J = 500),
                (t.K = 667),
                (t.L = 611),
                (t.M = 889),
                (t.N = 722),
                (t.O = 722),
                (t.P = 611),
                (t.Q = 722),
                (t.R = 667),
                (t.S = 556),
                (t.T = 611),
                (t.U = 722),
                (t.V = 667),
                (t.W = 889),
                (t.X = 667),
                (t.Y = 611),
                (t.Z = 611),
                (t.bracketleft = 333),
                (t.backslash = 278),
                (t.bracketright = 333),
                (t.asciicircum = 570),
                (t.underscore = 500),
                (t.quoteleft = 333),
                (t.a = 500),
                (t.b = 500),
                (t.c = 444),
                (t.d = 500),
                (t.e = 444),
                (t.f = 333),
                (t.g = 500),
                (t.h = 556),
                (t.i = 278),
                (t.j = 278),
                (t.k = 500),
                (t.l = 278),
                (t.m = 778),
                (t.n = 556),
                (t.o = 500),
                (t.p = 500),
                (t.q = 500),
                (t.r = 389),
                (t.s = 389),
                (t.t = 278),
                (t.u = 556),
                (t.v = 444),
                (t.w = 667),
                (t.x = 500),
                (t.y = 444),
                (t.z = 389),
                (t.braceleft = 348),
                (t.bar = 220),
                (t.braceright = 348),
                (t.asciitilde = 570),
                (t.exclamdown = 389),
                (t.cent = 500),
                (t.sterling = 500),
                (t.fraction = 167),
                (t.yen = 500),
                (t.florin = 500),
                (t.section = 500),
                (t.currency = 500),
                (t.quotesingle = 278),
                (t.quotedblleft = 500),
                (t.guillemotleft = 500),
                (t.guilsinglleft = 333),
                (t.guilsinglright = 333),
                (t.fi = 556),
                (t.fl = 556),
                (t.endash = 500),
                (t.dagger = 500),
                (t.daggerdbl = 500),
                (t.periodcentered = 250),
                (t.paragraph = 500),
                (t.bullet = 350),
                (t.quotesinglbase = 333),
                (t.quotedblbase = 500),
                (t.quotedblright = 500),
                (t.guillemotright = 500),
                (t.ellipsis = 1e3),
                (t.perthousand = 1e3),
                (t.questiondown = 500),
                (t.grave = 333),
                (t.acute = 333),
                (t.circumflex = 333),
                (t.tilde = 333),
                (t.macron = 333),
                (t.breve = 333),
                (t.dotaccent = 333),
                (t.dieresis = 333),
                (t.ring = 333),
                (t.cedilla = 333),
                (t.hungarumlaut = 333),
                (t.ogonek = 333),
                (t.caron = 333),
                (t.emdash = 1e3),
                (t.AE = 944),
                (t.ordfeminine = 266),
                (t.Lslash = 611),
                (t.Oslash = 722),
                (t.OE = 944),
                (t.ordmasculine = 300),
                (t.ae = 722),
                (t.dotlessi = 278),
                (t.lslash = 278),
                (t.oslash = 500),
                (t.oe = 722),
                (t.germandbls = 500),
                (t.Idieresis = 389),
                (t.eacute = 444),
                (t.abreve = 500),
                (t.uhungarumlaut = 556),
                (t.ecaron = 444),
                (t.Ydieresis = 611),
                (t.divide = 570),
                (t.Yacute = 611),
                (t.Acircumflex = 667),
                (t.aacute = 500),
                (t.Ucircumflex = 722),
                (t.yacute = 444),
                (t.scommaaccent = 389),
                (t.ecircumflex = 444),
                (t.Uring = 722),
                (t.Udieresis = 722),
                (t.aogonek = 500),
                (t.Uacute = 722),
                (t.uogonek = 556),
                (t.Edieresis = 667),
                (t.Dcroat = 722),
                (t.commaaccent = 250),
                (t.copyright = 747),
                (t.Emacron = 667),
                (t.ccaron = 444),
                (t.aring = 500),
                (t.Ncommaaccent = 722),
                (t.lacute = 278),
                (t.agrave = 500),
                (t.Tcommaaccent = 611),
                (t.Cacute = 667),
                (t.atilde = 500),
                (t.Edotaccent = 667),
                (t.scaron = 389),
                (t.scedilla = 389),
                (t.iacute = 278),
                (t.lozenge = 494),
                (t.Rcaron = 667),
                (t.Gcommaaccent = 722),
                (t.ucircumflex = 556),
                (t.acircumflex = 500),
                (t.Amacron = 667),
                (t.rcaron = 389),
                (t.ccedilla = 444),
                (t.Zdotaccent = 611),
                (t.Thorn = 611),
                (t.Omacron = 722),
                (t.Racute = 667),
                (t.Sacute = 556),
                (t.dcaron = 608),
                (t.Umacron = 722),
                (t.uring = 556),
                (t.threesuperior = 300),
                (t.Ograve = 722),
                (t.Agrave = 667),
                (t.Abreve = 667),
                (t.multiply = 570),
                (t.uacute = 556),
                (t.Tcaron = 611),
                (t.partialdiff = 494),
                (t.ydieresis = 444),
                (t.Nacute = 722),
                (t.icircumflex = 278),
                (t.Ecircumflex = 667),
                (t.adieresis = 500),
                (t.edieresis = 444),
                (t.cacute = 444),
                (t.nacute = 556),
                (t.umacron = 556),
                (t.Ncaron = 722),
                (t.Iacute = 389),
                (t.plusminus = 570),
                (t.brokenbar = 220),
                (t.registered = 747),
                (t.Gbreve = 722),
                (t.Idotaccent = 389),
                (t.summation = 600),
                (t.Egrave = 667),
                (t.racute = 389),
                (t.omacron = 500),
                (t.Zacute = 611),
                (t.Zcaron = 611),
                (t.greaterequal = 549),
                (t.Eth = 722),
                (t.Ccedilla = 667),
                (t.lcommaaccent = 278),
                (t.tcaron = 366),
                (t.eogonek = 444),
                (t.Uogonek = 722),
                (t.Aacute = 667),
                (t.Adieresis = 667),
                (t.egrave = 444),
                (t.zacute = 389),
                (t.iogonek = 278),
                (t.Oacute = 722),
                (t.oacute = 500),
                (t.amacron = 500),
                (t.sacute = 389),
                (t.idieresis = 278),
                (t.Ocircumflex = 722),
                (t.Ugrave = 722),
                (t.Delta = 612),
                (t.thorn = 500),
                (t.twosuperior = 300),
                (t.Odieresis = 722),
                (t.mu = 576),
                (t.igrave = 278),
                (t.ohungarumlaut = 500),
                (t.Eogonek = 667),
                (t.dcroat = 500),
                (t.threequarters = 750),
                (t.Scedilla = 556),
                (t.lcaron = 382),
                (t.Kcommaaccent = 667),
                (t.Lacute = 611),
                (t.trademark = 1e3),
                (t.edotaccent = 444),
                (t.Igrave = 389),
                (t.Imacron = 389),
                (t.Lcaron = 611),
                (t.onehalf = 750),
                (t.lessequal = 549),
                (t.ocircumflex = 500),
                (t.ntilde = 556),
                (t.Uhungarumlaut = 722),
                (t.Eacute = 667),
                (t.emacron = 444),
                (t.gbreve = 500),
                (t.onequarter = 750),
                (t.Scaron = 556),
                (t.Scommaaccent = 556),
                (t.Ohungarumlaut = 722),
                (t.degree = 400),
                (t.ograve = 500),
                (t.Ccaron = 667),
                (t.ugrave = 556),
                (t.radical = 549),
                (t.Dcaron = 722),
                (t.rcommaaccent = 389),
                (t.Ntilde = 722),
                (t.otilde = 500),
                (t.Rcommaaccent = 667),
                (t.Lcommaaccent = 611),
                (t.Atilde = 667),
                (t.Aogonek = 667),
                (t.Aring = 667),
                (t.Otilde = 722),
                (t.zdotaccent = 389),
                (t.Ecaron = 667),
                (t.Iogonek = 389),
                (t.kcommaaccent = 500),
                (t.minus = 606),
                (t.Icircumflex = 389),
                (t.ncaron = 556),
                (t.tcommaaccent = 278),
                (t.logicalnot = 606),
                (t.odieresis = 500),
                (t.udieresis = 556),
                (t.notequal = 549),
                (t.gcommaaccent = 500),
                (t.eth = 500),
                (t.zcaron = 389),
                (t.ncommaaccent = 556),
                (t.onesuperior = 300),
                (t.imacron = 278),
                (t.Euro = 500);
            })),
            (t["Times-Italic"] = (0, i.getLookupTableFactory)(function (t) {
              (t.space = 250),
                (t.exclam = 333),
                (t.quotedbl = 420),
                (t.numbersign = 500),
                (t.dollar = 500),
                (t.percent = 833),
                (t.ampersand = 778),
                (t.quoteright = 333),
                (t.parenleft = 333),
                (t.parenright = 333),
                (t.asterisk = 500),
                (t.plus = 675),
                (t.comma = 250),
                (t.hyphen = 333),
                (t.period = 250),
                (t.slash = 278),
                (t.zero = 500),
                (t.one = 500),
                (t.two = 500),
                (t.three = 500),
                (t.four = 500),
                (t.five = 500),
                (t.six = 500),
                (t.seven = 500),
                (t.eight = 500),
                (t.nine = 500),
                (t.colon = 333),
                (t.semicolon = 333),
                (t.less = 675),
                (t.equal = 675),
                (t.greater = 675),
                (t.question = 500),
                (t.at = 920),
                (t.A = 611),
                (t.B = 611),
                (t.C = 667),
                (t.D = 722),
                (t.E = 611),
                (t.F = 611),
                (t.G = 722),
                (t.H = 722),
                (t.I = 333),
                (t.J = 444),
                (t.K = 667),
                (t.L = 556),
                (t.M = 833),
                (t.N = 667),
                (t.O = 722),
                (t.P = 611),
                (t.Q = 722),
                (t.R = 611),
                (t.S = 500),
                (t.T = 556),
                (t.U = 722),
                (t.V = 611),
                (t.W = 833),
                (t.X = 611),
                (t.Y = 556),
                (t.Z = 556),
                (t.bracketleft = 389),
                (t.backslash = 278),
                (t.bracketright = 389),
                (t.asciicircum = 422),
                (t.underscore = 500),
                (t.quoteleft = 333),
                (t.a = 500),
                (t.b = 500),
                (t.c = 444),
                (t.d = 500),
                (t.e = 444),
                (t.f = 278),
                (t.g = 500),
                (t.h = 500),
                (t.i = 278),
                (t.j = 278),
                (t.k = 444),
                (t.l = 278),
                (t.m = 722),
                (t.n = 500),
                (t.o = 500),
                (t.p = 500),
                (t.q = 500),
                (t.r = 389),
                (t.s = 389),
                (t.t = 278),
                (t.u = 500),
                (t.v = 444),
                (t.w = 667),
                (t.x = 444),
                (t.y = 444),
                (t.z = 389),
                (t.braceleft = 400),
                (t.bar = 275),
                (t.braceright = 400),
                (t.asciitilde = 541),
                (t.exclamdown = 389),
                (t.cent = 500),
                (t.sterling = 500),
                (t.fraction = 167),
                (t.yen = 500),
                (t.florin = 500),
                (t.section = 500),
                (t.currency = 500),
                (t.quotesingle = 214),
                (t.quotedblleft = 556),
                (t.guillemotleft = 500),
                (t.guilsinglleft = 333),
                (t.guilsinglright = 333),
                (t.fi = 500),
                (t.fl = 500),
                (t.endash = 500),
                (t.dagger = 500),
                (t.daggerdbl = 500),
                (t.periodcentered = 250),
                (t.paragraph = 523),
                (t.bullet = 350),
                (t.quotesinglbase = 333),
                (t.quotedblbase = 556),
                (t.quotedblright = 556),
                (t.guillemotright = 500),
                (t.ellipsis = 889),
                (t.perthousand = 1e3),
                (t.questiondown = 500),
                (t.grave = 333),
                (t.acute = 333),
                (t.circumflex = 333),
                (t.tilde = 333),
                (t.macron = 333),
                (t.breve = 333),
                (t.dotaccent = 333),
                (t.dieresis = 333),
                (t.ring = 333),
                (t.cedilla = 333),
                (t.hungarumlaut = 333),
                (t.ogonek = 333),
                (t.caron = 333),
                (t.emdash = 889),
                (t.AE = 889),
                (t.ordfeminine = 276),
                (t.Lslash = 556),
                (t.Oslash = 722),
                (t.OE = 944),
                (t.ordmasculine = 310),
                (t.ae = 667),
                (t.dotlessi = 278),
                (t.lslash = 278),
                (t.oslash = 500),
                (t.oe = 667),
                (t.germandbls = 500),
                (t.Idieresis = 333),
                (t.eacute = 444),
                (t.abreve = 500),
                (t.uhungarumlaut = 500),
                (t.ecaron = 444),
                (t.Ydieresis = 556),
                (t.divide = 675),
                (t.Yacute = 556),
                (t.Acircumflex = 611),
                (t.aacute = 500),
                (t.Ucircumflex = 722),
                (t.yacute = 444),
                (t.scommaaccent = 389),
                (t.ecircumflex = 444),
                (t.Uring = 722),
                (t.Udieresis = 722),
                (t.aogonek = 500),
                (t.Uacute = 722),
                (t.uogonek = 500),
                (t.Edieresis = 611),
                (t.Dcroat = 722),
                (t.commaaccent = 250),
                (t.copyright = 760),
                (t.Emacron = 611),
                (t.ccaron = 444),
                (t.aring = 500),
                (t.Ncommaaccent = 667),
                (t.lacute = 278),
                (t.agrave = 500),
                (t.Tcommaaccent = 556),
                (t.Cacute = 667),
                (t.atilde = 500),
                (t.Edotaccent = 611),
                (t.scaron = 389),
                (t.scedilla = 389),
                (t.iacute = 278),
                (t.lozenge = 471),
                (t.Rcaron = 611),
                (t.Gcommaaccent = 722),
                (t.ucircumflex = 500),
                (t.acircumflex = 500),
                (t.Amacron = 611),
                (t.rcaron = 389),
                (t.ccedilla = 444),
                (t.Zdotaccent = 556),
                (t.Thorn = 611),
                (t.Omacron = 722),
                (t.Racute = 611),
                (t.Sacute = 500),
                (t.dcaron = 544),
                (t.Umacron = 722),
                (t.uring = 500),
                (t.threesuperior = 300),
                (t.Ograve = 722),
                (t.Agrave = 611),
                (t.Abreve = 611),
                (t.multiply = 675),
                (t.uacute = 500),
                (t.Tcaron = 556),
                (t.partialdiff = 476),
                (t.ydieresis = 444),
                (t.Nacute = 667),
                (t.icircumflex = 278),
                (t.Ecircumflex = 611),
                (t.adieresis = 500),
                (t.edieresis = 444),
                (t.cacute = 444),
                (t.nacute = 500),
                (t.umacron = 500),
                (t.Ncaron = 667),
                (t.Iacute = 333),
                (t.plusminus = 675),
                (t.brokenbar = 275),
                (t.registered = 760),
                (t.Gbreve = 722),
                (t.Idotaccent = 333),
                (t.summation = 600),
                (t.Egrave = 611),
                (t.racute = 389),
                (t.omacron = 500),
                (t.Zacute = 556),
                (t.Zcaron = 556),
                (t.greaterequal = 549),
                (t.Eth = 722),
                (t.Ccedilla = 667),
                (t.lcommaaccent = 278),
                (t.tcaron = 300),
                (t.eogonek = 444),
                (t.Uogonek = 722),
                (t.Aacute = 611),
                (t.Adieresis = 611),
                (t.egrave = 444),
                (t.zacute = 389),
                (t.iogonek = 278),
                (t.Oacute = 722),
                (t.oacute = 500),
                (t.amacron = 500),
                (t.sacute = 389),
                (t.idieresis = 278),
                (t.Ocircumflex = 722),
                (t.Ugrave = 722),
                (t.Delta = 612),
                (t.thorn = 500),
                (t.twosuperior = 300),
                (t.Odieresis = 722),
                (t.mu = 500),
                (t.igrave = 278),
                (t.ohungarumlaut = 500),
                (t.Eogonek = 611),
                (t.dcroat = 500),
                (t.threequarters = 750),
                (t.Scedilla = 500),
                (t.lcaron = 300),
                (t.Kcommaaccent = 667),
                (t.Lacute = 556),
                (t.trademark = 980),
                (t.edotaccent = 444),
                (t.Igrave = 333),
                (t.Imacron = 333),
                (t.Lcaron = 611),
                (t.onehalf = 750),
                (t.lessequal = 549),
                (t.ocircumflex = 500),
                (t.ntilde = 500),
                (t.Uhungarumlaut = 722),
                (t.Eacute = 611),
                (t.emacron = 444),
                (t.gbreve = 500),
                (t.onequarter = 750),
                (t.Scaron = 500),
                (t.Scommaaccent = 500),
                (t.Ohungarumlaut = 722),
                (t.degree = 400),
                (t.ograve = 500),
                (t.Ccaron = 667),
                (t.ugrave = 500),
                (t.radical = 453),
                (t.Dcaron = 722),
                (t.rcommaaccent = 389),
                (t.Ntilde = 667),
                (t.otilde = 500),
                (t.Rcommaaccent = 611),
                (t.Lcommaaccent = 556),
                (t.Atilde = 611),
                (t.Aogonek = 611),
                (t.Aring = 611),
                (t.Otilde = 722),
                (t.zdotaccent = 389),
                (t.Ecaron = 611),
                (t.Iogonek = 333),
                (t.kcommaaccent = 444),
                (t.minus = 675),
                (t.Icircumflex = 333),
                (t.ncaron = 500),
                (t.tcommaaccent = 278),
                (t.logicalnot = 675),
                (t.odieresis = 500),
                (t.udieresis = 500),
                (t.notequal = 549),
                (t.gcommaaccent = 500),
                (t.eth = 500),
                (t.zcaron = 389),
                (t.ncommaaccent = 500),
                (t.onesuperior = 300),
                (t.imacron = 278),
                (t.Euro = 500);
            })),
            (t.ZapfDingbats = (0, i.getLookupTableFactory)(function (t) {
              (t.space = 278),
                (t.a1 = 974),
                (t.a2 = 961),
                (t.a202 = 974),
                (t.a3 = 980),
                (t.a4 = 719),
                (t.a5 = 789),
                (t.a119 = 790),
                (t.a118 = 791),
                (t.a117 = 690),
                (t.a11 = 960),
                (t.a12 = 939),
                (t.a13 = 549),
                (t.a14 = 855),
                (t.a15 = 911),
                (t.a16 = 933),
                (t.a105 = 911),
                (t.a17 = 945),
                (t.a18 = 974),
                (t.a19 = 755),
                (t.a20 = 846),
                (t.a21 = 762),
                (t.a22 = 761),
                (t.a23 = 571),
                (t.a24 = 677),
                (t.a25 = 763),
                (t.a26 = 760),
                (t.a27 = 759),
                (t.a28 = 754),
                (t.a6 = 494),
                (t.a7 = 552),
                (t.a8 = 537),
                (t.a9 = 577),
                (t.a10 = 692),
                (t.a29 = 786),
                (t.a30 = 788),
                (t.a31 = 788),
                (t.a32 = 790),
                (t.a33 = 793),
                (t.a34 = 794),
                (t.a35 = 816),
                (t.a36 = 823),
                (t.a37 = 789),
                (t.a38 = 841),
                (t.a39 = 823),
                (t.a40 = 833),
                (t.a41 = 816),
                (t.a42 = 831),
                (t.a43 = 923),
                (t.a44 = 744),
                (t.a45 = 723),
                (t.a46 = 749),
                (t.a47 = 790),
                (t.a48 = 792),
                (t.a49 = 695),
                (t.a50 = 776),
                (t.a51 = 768),
                (t.a52 = 792),
                (t.a53 = 759),
                (t.a54 = 707),
                (t.a55 = 708),
                (t.a56 = 682),
                (t.a57 = 701),
                (t.a58 = 826),
                (t.a59 = 815),
                (t.a60 = 789),
                (t.a61 = 789),
                (t.a62 = 707),
                (t.a63 = 687),
                (t.a64 = 696),
                (t.a65 = 689),
                (t.a66 = 786),
                (t.a67 = 787),
                (t.a68 = 713),
                (t.a69 = 791),
                (t.a70 = 785),
                (t.a71 = 791),
                (t.a72 = 873),
                (t.a73 = 761),
                (t.a74 = 762),
                (t.a203 = 762),
                (t.a75 = 759),
                (t.a204 = 759),
                (t.a76 = 892),
                (t.a77 = 892),
                (t.a78 = 788),
                (t.a79 = 784),
                (t.a81 = 438),
                (t.a82 = 138),
                (t.a83 = 277),
                (t.a84 = 415),
                (t.a97 = 392),
                (t.a98 = 392),
                (t.a99 = 668),
                (t.a100 = 668),
                (t.a89 = 390),
                (t.a90 = 390),
                (t.a93 = 317),
                (t.a94 = 317),
                (t.a91 = 276),
                (t.a92 = 276),
                (t.a205 = 509),
                (t.a85 = 509),
                (t.a206 = 410),
                (t.a86 = 410),
                (t.a87 = 234),
                (t.a88 = 234),
                (t.a95 = 334),
                (t.a96 = 334),
                (t.a101 = 732),
                (t.a102 = 544),
                (t.a103 = 544),
                (t.a104 = 910),
                (t.a106 = 667),
                (t.a107 = 760),
                (t.a108 = 760),
                (t.a112 = 776),
                (t.a111 = 595),
                (t.a110 = 694),
                (t.a109 = 626),
                (t.a120 = 788),
                (t.a121 = 788),
                (t.a122 = 788),
                (t.a123 = 788),
                (t.a124 = 788),
                (t.a125 = 788),
                (t.a126 = 788),
                (t.a127 = 788),
                (t.a128 = 788),
                (t.a129 = 788),
                (t.a130 = 788),
                (t.a131 = 788),
                (t.a132 = 788),
                (t.a133 = 788),
                (t.a134 = 788),
                (t.a135 = 788),
                (t.a136 = 788),
                (t.a137 = 788),
                (t.a138 = 788),
                (t.a139 = 788),
                (t.a140 = 788),
                (t.a141 = 788),
                (t.a142 = 788),
                (t.a143 = 788),
                (t.a144 = 788),
                (t.a145 = 788),
                (t.a146 = 788),
                (t.a147 = 788),
                (t.a148 = 788),
                (t.a149 = 788),
                (t.a150 = 788),
                (t.a151 = 788),
                (t.a152 = 788),
                (t.a153 = 788),
                (t.a154 = 788),
                (t.a155 = 788),
                (t.a156 = 788),
                (t.a157 = 788),
                (t.a158 = 788),
                (t.a159 = 788),
                (t.a160 = 894),
                (t.a161 = 838),
                (t.a163 = 1016),
                (t.a164 = 458),
                (t.a196 = 748),
                (t.a165 = 924),
                (t.a192 = 748),
                (t.a166 = 918),
                (t.a167 = 927),
                (t.a168 = 928),
                (t.a169 = 928),
                (t.a170 = 834),
                (t.a171 = 873),
                (t.a172 = 828),
                (t.a173 = 924),
                (t.a162 = 924),
                (t.a174 = 917),
                (t.a175 = 930),
                (t.a176 = 931),
                (t.a177 = 463),
                (t.a178 = 883),
                (t.a179 = 836),
                (t.a193 = 836),
                (t.a180 = 867),
                (t.a199 = 867),
                (t.a181 = 696),
                (t.a200 = 696),
                (t.a182 = 874),
                (t.a201 = 874),
                (t.a183 = 760),
                (t.a184 = 946),
                (t.a197 = 771),
                (t.a185 = 865),
                (t.a194 = 771),
                (t.a198 = 888),
                (t.a186 = 967),
                (t.a195 = 888),
                (t.a187 = 831),
                (t.a188 = 873),
                (t.a189 = 927),
                (t.a190 = 970),
                (t.a191 = 918);
            }));
        });
      r.getMetrics = o;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.isPDFFunction = function isPDFFunction(t) {
          var r;
          if ("object" !== _typeof(t)) return !1;
          if ((0, o.isDict)(t)) r = t;
          else {
            if (!(0, o.isStream)(t)) return !1;
            r = t.dict;
          }
          return r.has("FunctionType");
        }),
        (r.PostScriptCompiler =
          r.PostScriptEvaluator =
          r.PDFFunctionFactory =
            void 0);
      var i = a(5),
        o = a(198),
        l = a(235);
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      var c = (function () {
        function PDFFunctionFactory(t) {
          var r = t.xref,
            a = t.isEvalSupported,
            i = void 0 === a || a;
          !(function _classCallCheck(t, r) {
            if (!(t instanceof r))
              throw new TypeError("Cannot call a class as a function");
          })(this, PDFFunctionFactory),
            (this.xref = r),
            (this.isEvalSupported = !1 !== i);
        }
        return (
          (function _createClass(t, r, a) {
            return (
              r && _defineProperties(t.prototype, r),
              a && _defineProperties(t, a),
              t
            );
          })(PDFFunctionFactory, [
            {
              key: "create",
              value: function create(t) {
                return u.parse({
                  xref: this.xref,
                  isEvalSupported: this.isEvalSupported,
                  fn: t,
                });
              },
            },
            {
              key: "createFromArray",
              value: function createFromArray(t) {
                return u.parseArray({
                  xref: this.xref,
                  isEvalSupported: this.isEvalSupported,
                  fnObj: t,
                });
              },
            },
          ]),
          PDFFunctionFactory
        );
      })();
      function toNumberArray(t) {
        if (!Array.isArray(t)) return null;
        for (var r = t.length, a = 0; a < r; a++)
          if ("number" != typeof t[a]) {
            for (var i = new Array(r), o = 0; o < r; o++) i[o] = +t[o];
            return i;
          }
        return t;
      }
      r.PDFFunctionFactory = c;
      var u = (function PDFFunctionClosure() {
        return {
          getSampleArray: function getSampleArray(t, r, a, i) {
            var o,
              l,
              c = 1;
            for (o = 0, l = t.length; o < l; o++) c *= t[o];
            c *= r;
            var u = new Array(c),
              h = 0,
              d = 0,
              p = 1 / (Math.pow(2, a) - 1),
              m = i.getBytes((c * a + 7) / 8),
              g = 0;
            for (o = 0; o < c; o++) {
              for (; h < a; ) (d <<= 8), (d |= m[g++]), (h += 8);
              (h -= a), (u[o] = (d >> h) * p), (d &= (1 << h) - 1);
            }
            return u;
          },
          getIR: function getIR(t) {
            var r = t.xref,
              a = t.isEvalSupported,
              o = t.fn,
              l = o.dict;
            l || (l = o);
            var c = [
              this.constructSampled,
              null,
              this.constructInterpolated,
              this.constructStiched,
              this.constructPostScript,
            ][l.get("FunctionType")];
            if (!c) throw new i.FormatError("Unknown type of function");
            return c.call(this, {
              xref: r,
              isEvalSupported: a,
              fn: o,
              dict: l,
            });
          },
          fromIR: function fromIR(t) {
            var r = t.xref,
              a = t.isEvalSupported,
              i = t.IR;
            switch (i[0]) {
              case 0:
                return this.constructSampledFromIR({
                  xref: r,
                  isEvalSupported: a,
                  IR: i,
                });
              case 2:
                return this.constructInterpolatedFromIR({
                  xref: r,
                  isEvalSupported: a,
                  IR: i,
                });
              case 3:
                return this.constructStichedFromIR({
                  xref: r,
                  isEvalSupported: a,
                  IR: i,
                });
              default:
                return this.constructPostScriptFromIR({
                  xref: r,
                  isEvalSupported: a,
                  IR: i,
                });
            }
          },
          parse: function parse(t) {
            var r = t.xref,
              a = t.isEvalSupported,
              i = t.fn,
              o = this.getIR({ xref: r, isEvalSupported: a, fn: i });
            return this.fromIR({ xref: r, isEvalSupported: a, IR: o });
          },
          parseArray: function parseArray(t) {
            var r = t.xref,
              a = t.isEvalSupported,
              i = t.fnObj;
            if (!Array.isArray(i))
              return this.parse({ xref: r, isEvalSupported: a, fn: i });
            for (var o = [], l = 0, c = i.length; l < c; l++)
              o.push(
                this.parse({
                  xref: r,
                  isEvalSupported: a,
                  fn: r.fetchIfRef(i[l]),
                }),
              );
            return function (t, r, a, i) {
              for (var l = 0, c = o.length; l < c; l++) o[l](t, r, a, i + l);
            };
          },
          constructSampled: function constructSampled(t) {
            t.xref, t.isEvalSupported;
            var r = t.fn,
              a = t.dict;
            function toMultiArray(t) {
              for (var r = t.length, a = [], i = 0, o = 0; o < r; o += 2)
                (a[i] = [t[o], t[o + 1]]), ++i;
              return a;
            }
            var o = toNumberArray(a.getArray("Domain")),
              l = toNumberArray(a.getArray("Range"));
            if (!o || !l) throw new i.FormatError("No domain or range");
            var c = o.length / 2,
              u = l.length / 2;
            (o = toMultiArray(o)), (l = toMultiArray(l));
            var h = toNumberArray(a.getArray("Size")),
              d = a.get("BitsPerSample"),
              p = a.get("Order") || 1;
            1 !== p &&
              (0, i.info)("No support for cubic spline interpolation: " + p);
            var m = toNumberArray(a.getArray("Encode"));
            if (m) m = toMultiArray(m);
            else {
              m = [];
              for (var g = 0; g < c; ++g) m.push([0, h[g] - 1]);
            }
            var b = toNumberArray(a.getArray("Decode"));
            return [
              0,
              c,
              o,
              m,
              (b = b ? toMultiArray(b) : l),
              this.getSampleArray(h, u, d, r),
              h,
              u,
              Math.pow(2, d) - 1,
              l,
            ];
          },
          constructSampledFromIR: function constructSampledFromIR(t) {
            t.xref, t.isEvalSupported;
            var r = t.IR;
            function interpolate(t, r, a, i, o) {
              return i + ((o - i) / (a - r)) * (t - r);
            }
            return function constructSampledFromIRResult(t, a, i, o) {
              var l,
                c,
                u = r[1],
                h = r[2],
                d = r[3],
                p = r[4],
                m = r[5],
                g = r[6],
                b = r[7],
                y = r[9],
                v = 1 << u,
                S = new Float64Array(v),
                k = new Uint32Array(v);
              for (c = 0; c < v; c++) S[c] = 1;
              var w = b,
                C = 1;
              for (l = 0; l < u; ++l) {
                var x = h[l][0],
                  _ = h[l][1],
                  A = interpolate(
                    Math.min(Math.max(t[a + l], x), _),
                    x,
                    _,
                    d[l][0],
                    d[l][1],
                  ),
                  R = g[l],
                  T =
                    (A = Math.min(Math.max(A, 0), R - 1)) < R - 1
                      ? Math.floor(A)
                      : A - 1,
                  I = T + 1 - A,
                  P = A - T,
                  O = T * w,
                  E = O + w;
                for (c = 0; c < v; c++)
                  c & C
                    ? ((S[c] *= P), (k[c] += E))
                    : ((S[c] *= I), (k[c] += O));
                (w *= R), (C <<= 1);
              }
              for (c = 0; c < b; ++c) {
                var B = 0;
                for (l = 0; l < v; l++) B += m[k[l] + c] * S[l];
                (B = interpolate(B, 0, 1, p[c][0], p[c][1])),
                  (i[o + c] = Math.min(Math.max(B, y[c][0]), y[c][1]));
              }
            };
          },
          constructInterpolated: function constructInterpolated(t) {
            t.xref, t.isEvalSupported, t.fn;
            for (
              var r = t.dict,
                a = toNumberArray(r.getArray("C0")) || [0],
                i = toNumberArray(r.getArray("C1")) || [1],
                o = r.get("N"),
                l = a.length,
                c = [],
                u = 0;
              u < l;
              ++u
            )
              c.push(i[u] - a[u]);
            return [2, a, c, o];
          },
          constructInterpolatedFromIR: function constructInterpolatedFromIR(t) {
            t.xref, t.isEvalSupported;
            var r = t.IR,
              a = r[1],
              i = r[2],
              o = r[3],
              l = i.length;
            return function constructInterpolatedFromIRResult(t, r, c, u) {
              for (
                var h = 1 === o ? t[r] : Math.pow(t[r], o), d = 0;
                d < l;
                ++d
              )
                c[u + d] = a[d] + h * i[d];
            };
          },
          constructStiched: function constructStiched(t) {
            var r = t.xref,
              a = t.isEvalSupported,
              o = (t.fn, t.dict),
              l = toNumberArray(o.getArray("Domain"));
            if (!l) throw new i.FormatError("No domain");
            if (1 !== l.length / 2)
              throw new i.FormatError("Bad domain for stiched function");
            for (
              var c = o.get("Functions"), u = [], h = 0, d = c.length;
              h < d;
              ++h
            )
              u.push(
                this.parse({
                  xref: r,
                  isEvalSupported: a,
                  fn: r.fetchIfRef(c[h]),
                }),
              );
            return [
              3,
              l,
              toNumberArray(o.getArray("Bounds")),
              toNumberArray(o.getArray("Encode")),
              u,
            ];
          },
          constructStichedFromIR: function constructStichedFromIR(t) {
            t.xref, t.isEvalSupported;
            var r = t.IR,
              a = r[1],
              i = r[2],
              o = r[3],
              l = r[4],
              c = new Float32Array(1);
            return function constructStichedFromIRResult(t, r, u, h) {
              for (
                var d = (function constructStichedFromIRClip(t, r, a) {
                    return t > a ? (t = a) : t < r && (t = r), t;
                  })(t[r], a[0], a[1]),
                  p = 0,
                  m = i.length;
                p < m && !(d < i[p]);
                ++p
              );
              var g = a[0];
              p > 0 && (g = i[p - 1]);
              var b = a[1];
              p < i.length && (b = i[p]);
              var y = o[2 * p],
                v = o[2 * p + 1];
              (c[0] = g === b ? y : y + ((d - g) * (v - y)) / (b - g)),
                l[p](c, 0, u, h);
            };
          },
          constructPostScript: function constructPostScript(t) {
            t.xref, t.isEvalSupported;
            var r = t.fn,
              a = t.dict,
              o = toNumberArray(a.getArray("Domain")),
              c = toNumberArray(a.getArray("Range"));
            if (!o) throw new i.FormatError("No domain.");
            if (!c) throw new i.FormatError("No range.");
            var u = new l.PostScriptLexer(r);
            return [4, o, c, new l.PostScriptParser(u).parse()];
          },
          constructPostScriptFromIR: function constructPostScriptFromIR(t) {
            t.xref;
            var r = t.isEvalSupported,
              a = t.IR,
              o = a[1],
              l = a[2],
              c = a[3];
            if (r && i.IsEvalSupportedCached.value) {
              var u = new p().compile(c, o, l);
              if (u)
                return new Function(
                  "src",
                  "srcOffset",
                  "dest",
                  "destOffset",
                  u,
                );
            }
            (0, i.info)("Unable to compile PS function");
            var h = l.length >> 1,
              m = o.length >> 1,
              g = new d(c),
              b = Object.create(null),
              y = 8192,
              v = new Float32Array(m);
            return function constructPostScriptFromIRResult(t, r, a, i) {
              var o,
                c,
                u = "",
                d = v;
              for (o = 0; o < m; o++)
                (c = t[r + o]), (d[o] = c), (u += c + "_");
              var p = b[u];
              if (void 0 === p) {
                var S = new Float32Array(h),
                  k = g.execute(d),
                  w = k.length - h;
                for (o = 0; o < h; o++) {
                  c = k[w + o];
                  var C = l[2 * o];
                  (c < C || c > (C = l[2 * o + 1])) && (c = C), (S[o] = c);
                }
                y > 0 && (y--, (b[u] = S)), a.set(S, i);
              } else a.set(p, i);
            };
          },
        };
      })();
      var h = (function PostScriptStackClosure() {
          function PostScriptStack(t) {
            this.stack = t ? Array.prototype.slice.call(t, 0) : [];
          }
          return (
            (PostScriptStack.prototype = {
              push: function PostScriptStack_push(t) {
                if (this.stack.length >= 100)
                  throw new Error("PostScript function stack overflow.");
                this.stack.push(t);
              },
              pop: function PostScriptStack_pop() {
                if (this.stack.length <= 0)
                  throw new Error("PostScript function stack underflow.");
                return this.stack.pop();
              },
              copy: function PostScriptStack_copy(t) {
                if (this.stack.length + t >= 100)
                  throw new Error("PostScript function stack overflow.");
                for (
                  var r = this.stack, a = r.length - t, i = t - 1;
                  i >= 0;
                  i--, a++
                )
                  r.push(r[a]);
              },
              index: function PostScriptStack_index(t) {
                this.push(this.stack[this.stack.length - t - 1]);
              },
              roll: function PostScriptStack_roll(t, r) {
                var a,
                  i,
                  o,
                  l = this.stack,
                  c = l.length - t,
                  u = l.length - 1,
                  h = c + (r - Math.floor(r / t) * t);
                for (a = c, i = u; a < i; a++, i--)
                  (o = l[a]), (l[a] = l[i]), (l[i] = o);
                for (a = c, i = h - 1; a < i; a++, i--)
                  (o = l[a]), (l[a] = l[i]), (l[i] = o);
                for (a = h, i = u; a < i; a++, i--)
                  (o = l[a]), (l[a] = l[i]), (l[i] = o);
              },
            }),
            PostScriptStack
          );
        })(),
        d = (function PostScriptEvaluatorClosure() {
          function PostScriptEvaluator(t) {
            this.operators = t;
          }
          return (
            (PostScriptEvaluator.prototype = {
              execute: function PostScriptEvaluator_execute(t) {
                for (
                  var r,
                    a,
                    o,
                    l = new h(t),
                    c = 0,
                    u = this.operators,
                    d = u.length;
                  c < d;

                )
                  if ("number" != typeof (r = u[c++]))
                    switch (r) {
                      case "jz":
                        (o = l.pop()), (a = l.pop()) || (c = o);
                        break;
                      case "j":
                        c = a = l.pop();
                        break;
                      case "abs":
                        (a = l.pop()), l.push(Math.abs(a));
                        break;
                      case "add":
                        (o = l.pop()), (a = l.pop()), l.push(a + o);
                        break;
                      case "and":
                        (o = l.pop()),
                          (a = l.pop()),
                          (0, i.isBool)(a) && (0, i.isBool)(o)
                            ? l.push(a && o)
                            : l.push(a & o);
                        break;
                      case "atan":
                        (a = l.pop()), l.push(Math.atan(a));
                        break;
                      case "bitshift":
                        (o = l.pop()),
                          (a = l.pop()) > 0 ? l.push(a << o) : l.push(a >> o);
                        break;
                      case "ceiling":
                        (a = l.pop()), l.push(Math.ceil(a));
                        break;
                      case "copy":
                        (a = l.pop()), l.copy(a);
                        break;
                      case "cos":
                        (a = l.pop()), l.push(Math.cos(a));
                        break;
                      case "cvi":
                        (a = 0 | l.pop()), l.push(a);
                        break;
                      case "cvr":
                        break;
                      case "div":
                        (o = l.pop()), (a = l.pop()), l.push(a / o);
                        break;
                      case "dup":
                        l.copy(1);
                        break;
                      case "eq":
                        (o = l.pop()), (a = l.pop()), l.push(a === o);
                        break;
                      case "exch":
                        l.roll(2, 1);
                        break;
                      case "exp":
                        (o = l.pop()), (a = l.pop()), l.push(Math.pow(a, o));
                        break;
                      case "false":
                        l.push(!1);
                        break;
                      case "floor":
                        (a = l.pop()), l.push(Math.floor(a));
                        break;
                      case "ge":
                        (o = l.pop()), (a = l.pop()), l.push(a >= o);
                        break;
                      case "gt":
                        (o = l.pop()), (a = l.pop()), l.push(a > o);
                        break;
                      case "idiv":
                        (o = l.pop()), (a = l.pop()), l.push((a / o) | 0);
                        break;
                      case "index":
                        (a = l.pop()), l.index(a);
                        break;
                      case "le":
                        (o = l.pop()), (a = l.pop()), l.push(a <= o);
                        break;
                      case "ln":
                        (a = l.pop()), l.push(Math.log(a));
                        break;
                      case "log":
                        (a = l.pop()), l.push(Math.log(a) / Math.LN10);
                        break;
                      case "lt":
                        (o = l.pop()), (a = l.pop()), l.push(a < o);
                        break;
                      case "mod":
                        (o = l.pop()), (a = l.pop()), l.push(a % o);
                        break;
                      case "mul":
                        (o = l.pop()), (a = l.pop()), l.push(a * o);
                        break;
                      case "ne":
                        (o = l.pop()), (a = l.pop()), l.push(a !== o);
                        break;
                      case "neg":
                        (a = l.pop()), l.push(-a);
                        break;
                      case "not":
                        (a = l.pop()),
                          (0, i.isBool)(a) ? l.push(!a) : l.push(~a);
                        break;
                      case "or":
                        (o = l.pop()),
                          (a = l.pop()),
                          (0, i.isBool)(a) && (0, i.isBool)(o)
                            ? l.push(a || o)
                            : l.push(a | o);
                        break;
                      case "pop":
                        l.pop();
                        break;
                      case "roll":
                        (o = l.pop()), (a = l.pop()), l.roll(a, o);
                        break;
                      case "round":
                        (a = l.pop()), l.push(Math.round(a));
                        break;
                      case "sin":
                        (a = l.pop()), l.push(Math.sin(a));
                        break;
                      case "sqrt":
                        (a = l.pop()), l.push(Math.sqrt(a));
                        break;
                      case "sub":
                        (o = l.pop()), (a = l.pop()), l.push(a - o);
                        break;
                      case "true":
                        l.push(!0);
                        break;
                      case "truncate":
                        (a = (a = l.pop()) < 0 ? Math.ceil(a) : Math.floor(a)),
                          l.push(a);
                        break;
                      case "xor":
                        (o = l.pop()),
                          (a = l.pop()),
                          (0, i.isBool)(a) && (0, i.isBool)(o)
                            ? l.push(a !== o)
                            : l.push(a ^ o);
                        break;
                      default:
                        throw new i.FormatError("Unknown operator ".concat(r));
                    }
                  else l.push(r);
                return l.stack;
              },
            }),
            PostScriptEvaluator
          );
        })();
      r.PostScriptEvaluator = d;
      var p = (function PostScriptCompilerClosure() {
        function AstNode(t) {
          this.type = t;
        }
        function AstArgument(t, r, a) {
          AstNode.call(this, "args"),
            (this.index = t),
            (this.min = r),
            (this.max = a);
        }
        function AstLiteral(t) {
          AstNode.call(this, "literal"),
            (this.number = t),
            (this.min = t),
            (this.max = t);
        }
        function AstBinaryOperation(t, r, a, i, o) {
          AstNode.call(this, "binary"),
            (this.op = t),
            (this.arg1 = r),
            (this.arg2 = a),
            (this.min = i),
            (this.max = o);
        }
        function AstMin(t, r) {
          AstNode.call(this, "max"),
            (this.arg = t),
            (this.min = t.min),
            (this.max = r);
        }
        function AstVariable(t, r, a) {
          AstNode.call(this, "var"),
            (this.index = t),
            (this.min = r),
            (this.max = a);
        }
        function AstVariableDefinition(t, r) {
          AstNode.call(this, "definition"), (this.variable = t), (this.arg = r);
        }
        function ExpressionBuilderVisitor() {
          this.parts = [];
        }
        function buildAddOperation(t, r) {
          return "literal" === r.type && 0 === r.number
            ? t
            : "literal" === t.type && 0 === t.number
            ? r
            : "literal" === r.type && "literal" === t.type
            ? new AstLiteral(t.number + r.number)
            : new AstBinaryOperation("+", t, r, t.min + r.min, t.max + r.max);
        }
        function buildMulOperation(t, r) {
          if ("literal" === r.type) {
            if (0 === r.number) return new AstLiteral(0);
            if (1 === r.number) return t;
            if ("literal" === t.type)
              return new AstLiteral(t.number * r.number);
          }
          if ("literal" === t.type) {
            if (0 === t.number) return new AstLiteral(0);
            if (1 === t.number) return r;
          }
          return new AstBinaryOperation(
            "*",
            t,
            r,
            Math.min(
              t.min * r.min,
              t.min * r.max,
              t.max * r.min,
              t.max * r.max,
            ),
            Math.max(
              t.min * r.min,
              t.min * r.max,
              t.max * r.min,
              t.max * r.max,
            ),
          );
        }
        function buildSubOperation(t, r) {
          if ("literal" === r.type) {
            if (0 === r.number) return t;
            if ("literal" === t.type)
              return new AstLiteral(t.number - r.number);
          }
          return "binary" === r.type &&
            "-" === r.op &&
            "literal" === t.type &&
            1 === t.number &&
            "literal" === r.arg1.type &&
            1 === r.arg1.number
            ? r.arg2
            : new AstBinaryOperation("-", t, r, t.min - r.max, t.max - r.min);
        }
        function buildMinOperation(t, r) {
          return t.min >= r
            ? new AstLiteral(r)
            : t.max <= r
            ? t
            : new AstMin(t, r);
        }
        function PostScriptCompiler() {}
        return (
          (AstNode.prototype.visit = function (t) {
            (0, i.unreachable)("abstract method");
          }),
          (AstArgument.prototype = Object.create(AstNode.prototype)),
          (AstArgument.prototype.visit = function (t) {
            t.visitArgument(this);
          }),
          (AstLiteral.prototype = Object.create(AstNode.prototype)),
          (AstLiteral.prototype.visit = function (t) {
            t.visitLiteral(this);
          }),
          (AstBinaryOperation.prototype = Object.create(AstNode.prototype)),
          (AstBinaryOperation.prototype.visit = function (t) {
            t.visitBinaryOperation(this);
          }),
          (AstMin.prototype = Object.create(AstNode.prototype)),
          (AstMin.prototype.visit = function (t) {
            t.visitMin(this);
          }),
          (AstVariable.prototype = Object.create(AstNode.prototype)),
          (AstVariable.prototype.visit = function (t) {
            t.visitVariable(this);
          }),
          (AstVariableDefinition.prototype = Object.create(AstNode.prototype)),
          (AstVariableDefinition.prototype.visit = function (t) {
            t.visitVariableDefinition(this);
          }),
          (ExpressionBuilderVisitor.prototype = {
            visitArgument: function visitArgument(t) {
              this.parts.push(
                "Math.max(",
                t.min,
                ", Math.min(",
                t.max,
                ", src[srcOffset + ",
                t.index,
                "]))",
              );
            },
            visitVariable: function visitVariable(t) {
              this.parts.push("v", t.index);
            },
            visitLiteral: function visitLiteral(t) {
              this.parts.push(t.number);
            },
            visitBinaryOperation: function visitBinaryOperation(t) {
              this.parts.push("("),
                t.arg1.visit(this),
                this.parts.push(" ", t.op, " "),
                t.arg2.visit(this),
                this.parts.push(")");
            },
            visitVariableDefinition: function visitVariableDefinition(t) {
              this.parts.push("var "),
                t.variable.visit(this),
                this.parts.push(" = "),
                t.arg.visit(this),
                this.parts.push(";");
            },
            visitMin: function visitMin(t) {
              this.parts.push("Math.min("),
                t.arg.visit(this),
                this.parts.push(", ", t.max, ")");
            },
            toString: function toString() {
              return this.parts.join("");
            },
          }),
          (PostScriptCompiler.prototype = {
            compile: function PostScriptCompiler_compile(t, r, a) {
              for (
                var i,
                  o,
                  l,
                  c,
                  u,
                  h,
                  d,
                  p,
                  m = [],
                  g = [],
                  b = r.length >> 1,
                  y = a.length >> 1,
                  v = 0,
                  S = 0;
                S < b;
                S++
              )
                m.push(new AstArgument(S, r[2 * S], r[2 * S + 1]));
              for (var k = 0, w = t.length; k < w; k++)
                if ("number" != typeof (p = t[k]))
                  switch (p) {
                    case "add":
                      if (m.length < 2) return null;
                      (c = m.pop()),
                        (l = m.pop()),
                        m.push(buildAddOperation(l, c));
                      break;
                    case "cvr":
                      if (m.length < 1) return null;
                      break;
                    case "mul":
                      if (m.length < 2) return null;
                      (c = m.pop()),
                        (l = m.pop()),
                        m.push(buildMulOperation(l, c));
                      break;
                    case "sub":
                      if (m.length < 2) return null;
                      (c = m.pop()),
                        (l = m.pop()),
                        m.push(buildSubOperation(l, c));
                      break;
                    case "exch":
                      if (m.length < 2) return null;
                      (u = m.pop()), (h = m.pop()), m.push(u, h);
                      break;
                    case "pop":
                      if (m.length < 1) return null;
                      m.pop();
                      break;
                    case "index":
                      if (m.length < 1) return null;
                      if ("literal" !== (l = m.pop()).type) return null;
                      if (
                        (i = l.number) < 0 ||
                        !Number.isInteger(i) ||
                        m.length < i
                      )
                        return null;
                      if (
                        "literal" === (u = m[m.length - i - 1]).type ||
                        "var" === u.type
                      ) {
                        m.push(u);
                        break;
                      }
                      (d = new AstVariable(v++, u.min, u.max)),
                        (m[m.length - i - 1] = d),
                        m.push(d),
                        g.push(new AstVariableDefinition(d, u));
                      break;
                    case "dup":
                      if (m.length < 1) return null;
                      if (
                        "number" == typeof t[k + 1] &&
                        "gt" === t[k + 2] &&
                        t[k + 3] === k + 7 &&
                        "jz" === t[k + 4] &&
                        "pop" === t[k + 5] &&
                        t[k + 6] === t[k + 1]
                      ) {
                        (l = m.pop()),
                          m.push(buildMinOperation(l, t[k + 1])),
                          (k += 6);
                        break;
                      }
                      if (
                        "literal" === (u = m[m.length - 1]).type ||
                        "var" === u.type
                      ) {
                        m.push(u);
                        break;
                      }
                      (d = new AstVariable(v++, u.min, u.max)),
                        (m[m.length - 1] = d),
                        m.push(d),
                        g.push(new AstVariableDefinition(d, u));
                      break;
                    case "roll":
                      if (m.length < 2) return null;
                      if (
                        ((c = m.pop()),
                        (l = m.pop()),
                        "literal" !== c.type || "literal" !== l.type)
                      )
                        return null;
                      if (
                        ((o = c.number),
                        (i = l.number) <= 0 ||
                          !Number.isInteger(i) ||
                          !Number.isInteger(o) ||
                          m.length < i)
                      )
                        return null;
                      if (0 === (o = ((o % i) + i) % i)) break;
                      Array.prototype.push.apply(
                        m,
                        m.splice(m.length - i, i - o),
                      );
                      break;
                    default:
                      return null;
                  }
                else m.push(new AstLiteral(p));
              if (m.length !== y) return null;
              var C = [];
              return (
                g.forEach(function (t) {
                  var r = new ExpressionBuilderVisitor();
                  t.visit(r), C.push(r.toString());
                }),
                m.forEach(function (t, r) {
                  var i = new ExpressionBuilderVisitor();
                  t.visit(i);
                  var o = a[2 * r],
                    l = a[2 * r + 1],
                    c = [i.toString()];
                  o > t.min && (c.unshift("Math.max(", o, ", "), c.push(")")),
                    l < t.max && (c.unshift("Math.min(", l, ", "), c.push(")")),
                    c.unshift("dest[destOffset + ", r, "] = "),
                    c.push(";"),
                    C.push(c.join(""));
                }),
                C.join("\n")
              );
            },
          }),
          PostScriptCompiler
        );
      })();
      r.PostScriptCompiler = p;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.PostScriptParser = r.PostScriptLexer = void 0);
      var i = a(5),
        o = a(198),
        l = a(201);
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var c = (function () {
        function PostScriptParser(t) {
          _classCallCheck(this, PostScriptParser),
            (this.lexer = t),
            (this.operators = []),
            (this.token = null),
            (this.prev = null);
        }
        return (
          _createClass(PostScriptParser, [
            {
              key: "nextToken",
              value: function nextToken() {
                (this.prev = this.token), (this.token = this.lexer.getToken());
              },
            },
            {
              key: "accept",
              value: function accept(t) {
                return this.token.type === t && (this.nextToken(), !0);
              },
            },
            {
              key: "expect",
              value: function expect(t) {
                if (this.accept(t)) return !0;
                throw new i.FormatError(
                  "Unexpected symbol: found "
                    .concat(this.token.type, " expected ")
                    .concat(t, "."),
                );
              },
            },
            {
              key: "parse",
              value: function parse() {
                return (
                  this.nextToken(),
                  this.expect(u.LBRACE),
                  this.parseBlock(),
                  this.expect(u.RBRACE),
                  this.operators
                );
              },
            },
            {
              key: "parseBlock",
              value: function parseBlock() {
                for (;;)
                  if (this.accept(u.NUMBER))
                    this.operators.push(this.prev.value);
                  else if (this.accept(u.OPERATOR))
                    this.operators.push(this.prev.value);
                  else {
                    if (!this.accept(u.LBRACE)) return;
                    this.parseCondition();
                  }
              },
            },
            {
              key: "parseCondition",
              value: function parseCondition() {
                var t = this.operators.length;
                if (
                  (this.operators.push(null, null),
                  this.parseBlock(),
                  this.expect(u.RBRACE),
                  this.accept(u.IF))
                )
                  (this.operators[t] = this.operators.length),
                    (this.operators[t + 1] = "jz");
                else {
                  if (!this.accept(u.LBRACE))
                    throw new i.FormatError(
                      "PS Function: error parsing conditional.",
                    );
                  var r = this.operators.length;
                  this.operators.push(null, null);
                  var a = this.operators.length;
                  this.parseBlock(),
                    this.expect(u.RBRACE),
                    this.expect(u.IFELSE),
                    (this.operators[r] = this.operators.length),
                    (this.operators[r + 1] = "j"),
                    (this.operators[t] = a),
                    (this.operators[t + 1] = "jz");
                }
              },
            },
          ]),
          PostScriptParser
        );
      })();
      r.PostScriptParser = c;
      var u = {
          LBRACE: 0,
          RBRACE: 1,
          NUMBER: 2,
          OPERATOR: 3,
          IF: 4,
          IFELSE: 5,
        },
        h = (function PostScriptTokenClosure() {
          var t = Object.create(null);
          return (function () {
            function PostScriptToken(t, r) {
              _classCallCheck(this, PostScriptToken),
                (this.type = t),
                (this.value = r);
            }
            return (
              _createClass(PostScriptToken, null, [
                {
                  key: "getOperator",
                  value: function getOperator(r) {
                    var a = t[r];
                    return a || (t[r] = new PostScriptToken(u.OPERATOR, r));
                  },
                },
                {
                  key: "LBRACE",
                  get: function get() {
                    return (0, i.shadow)(
                      this,
                      "LBRACE",
                      new PostScriptToken(u.LBRACE, "{"),
                    );
                  },
                },
                {
                  key: "RBRACE",
                  get: function get() {
                    return (0, i.shadow)(
                      this,
                      "RBRACE",
                      new PostScriptToken(u.RBRACE, "}"),
                    );
                  },
                },
                {
                  key: "IF",
                  get: function get() {
                    return (0, i.shadow)(
                      this,
                      "IF",
                      new PostScriptToken(u.IF, "IF"),
                    );
                  },
                },
                {
                  key: "IFELSE",
                  get: function get() {
                    return (0, i.shadow)(
                      this,
                      "IFELSE",
                      new PostScriptToken(u.IFELSE, "IFELSE"),
                    );
                  },
                },
              ]),
              PostScriptToken
            );
          })();
        })(),
        d = (function () {
          function PostScriptLexer(t) {
            _classCallCheck(this, PostScriptLexer),
              (this.stream = t),
              this.nextChar(),
              (this.strBuf = []);
          }
          return (
            _createClass(PostScriptLexer, [
              {
                key: "nextChar",
                value: function nextChar() {
                  return (this.currentChar = this.stream.getByte());
                },
              },
              {
                key: "getToken",
                value: function getToken() {
                  for (var t = !1, r = this.currentChar; ; ) {
                    if (r < 0) return o.EOF;
                    if (t) (10 !== r && 13 !== r) || (t = !1);
                    else if (37 === r) t = !0;
                    else if (!(0, l.isWhiteSpace)(r)) break;
                    r = this.nextChar();
                  }
                  switch (0 | r) {
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 43:
                    case 45:
                    case 46:
                      return new h(u.NUMBER, this.getNumber());
                    case 123:
                      return this.nextChar(), h.LBRACE;
                    case 125:
                      return this.nextChar(), h.RBRACE;
                  }
                  var a = this.strBuf;
                  for (
                    a.length = 0, a[0] = String.fromCharCode(r);
                    (r = this.nextChar()) >= 0 &&
                    ((r >= 65 && r <= 90) || (r >= 97 && r <= 122));

                  )
                    a.push(String.fromCharCode(r));
                  var i = a.join("");
                  switch (i.toLowerCase()) {
                    case "if":
                      return h.IF;
                    case "ifelse":
                      return h.IFELSE;
                    default:
                      return h.getOperator(i);
                  }
                },
              },
              {
                key: "getNumber",
                value: function getNumber() {
                  var t = this.currentChar,
                    r = this.strBuf;
                  for (
                    r.length = 0, r[0] = String.fromCharCode(t);
                    (t = this.nextChar()) >= 0 &&
                    ((t >= 48 && t <= 57) || 45 === t || 46 === t);

                  )
                    r.push(String.fromCharCode(t));
                  var a = parseFloat(r.join(""));
                  if (isNaN(a))
                    throw new i.FormatError(
                      "Invalid floating point number: ".concat(a),
                    );
                  return a;
                },
              },
            ]),
            PostScriptLexer
          );
        })();
      r.PostScriptLexer = d;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.MurmurHash3_64 = void 0);
      var i = a(5);
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      var o = 3285377520,
        l = 4294901760,
        c = 65535,
        u = (function () {
          function MurmurHash3_64(t) {
            !(function _classCallCheck(t, r) {
              if (!(t instanceof r))
                throw new TypeError("Cannot call a class as a function");
            })(this, MurmurHash3_64),
              (this.h1 = t ? 4294967295 & t : o),
              (this.h2 = t ? 4294967295 & t : o);
          }
          return (
            (function _createClass(t, r, a) {
              return (
                r && _defineProperties(t.prototype, r),
                a && _defineProperties(t, a),
                t
              );
            })(MurmurHash3_64, [
              {
                key: "update",
                value: function update(t) {
                  var r, a;
                  if ((0, i.isString)(t)) {
                    (r = new Uint8Array(2 * t.length)), (a = 0);
                    for (var o = 0, u = t.length; o < u; o++) {
                      var h = t.charCodeAt(o);
                      h <= 255
                        ? (r[a++] = h)
                        : ((r[a++] = h >>> 8), (r[a++] = 255 & h));
                    }
                  } else {
                    if (!(0, i.isArrayBuffer)(t))
                      throw new Error(
                        "Wrong data format in MurmurHash3_64_update. Input must be a string or array.",
                      );
                    a = (r = t).byteLength;
                  }
                  for (
                    var d = a >> 2,
                      p = a - 4 * d,
                      m = new Uint32Array(r.buffer, 0, d),
                      g = 0,
                      b = 0,
                      y = this.h1,
                      v = this.h2,
                      S = 3432918353,
                      k = 461845907,
                      w = 11601,
                      C = 13715,
                      x = 0;
                    x < d;
                    x++
                  )
                    1 & x
                      ? (y =
                          5 *
                            (y =
                              ((y ^= g =
                                (((g =
                                  ((g =
                                    (((g = m[x]) * S) & l) | ((g * w) & c)) <<
                                    15) |
                                  (g >>> 17)) *
                                  k) &
                                  l) |
                                ((g * C) & c)) <<
                                13) |
                              (y >>> 19)) +
                          3864292196)
                      : (v =
                          5 *
                            (v =
                              ((v ^= b =
                                (((b =
                                  ((b =
                                    (((b = m[x]) * S) & l) | ((b * w) & c)) <<
                                    15) |
                                  (b >>> 17)) *
                                  k) &
                                  l) |
                                ((b * C) & c)) <<
                                13) |
                              (v >>> 19)) +
                          3864292196);
                  switch (((g = 0), p)) {
                    case 3:
                      g ^= r[4 * d + 2] << 16;
                    case 2:
                      g ^= r[4 * d + 1] << 8;
                    case 1:
                      (g =
                        (((g =
                          ((g = (((g ^= r[4 * d]) * S) & l) | ((g * w) & c)) <<
                            15) |
                          (g >>> 17)) *
                          k) &
                          l) |
                        ((g * C) & c)),
                        1 & d ? (y ^= g) : (v ^= g);
                  }
                  (this.h1 = y), (this.h2 = v);
                },
              },
              {
                key: "hexdigest",
                value: function hexdigest() {
                  var t = this.h1,
                    r = this.h2;
                  (t = ((3981806797 * (t ^= r >>> 1)) & l) | ((36045 * t) & c)),
                    (t =
                      ((444984403 *
                        (t ^=
                          (r =
                            ((4283543511 * r) & l) |
                            (((2950163797 * ((r << 16) | (t >>> 16))) & l) >>>
                              16)) >>> 1)) &
                        l) |
                      ((60499 * t) & c));
                  var a = (
                      (t ^=
                        (r =
                          ((3301882366 * r) & l) |
                          (((3120437893 * ((r << 16) | (t >>> 16))) & l) >>>
                            16)) >>> 1) >>> 0
                    ).toString(16),
                    i = (r >>> 0).toString(16);
                  return a.padStart(8, "0") + i.padStart(8, "0");
                },
              },
            ]),
            MurmurHash3_64
          );
        })();
      r.MurmurHash3_64 = u;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.PDFImage = void 0);
      var i = a(5),
        o = a(198),
        l = a(216),
        c = a(205),
        u = a(211),
        h = a(214),
        d = (function PDFImageClosure() {
          function decodeAndClamp(t, r, a, i) {
            return (t = r + t * a) < 0 ? (t = 0) : t > i && (t = i), t;
          }
          function resizeImageMask(t, r, a, i, o, l) {
            var c,
              u = o * l;
            c =
              r <= 8
                ? new Uint8Array(u)
                : r <= 16
                ? new Uint16Array(u)
                : new Uint32Array(u);
            var h,
              d,
              p,
              m,
              g = a / o,
              b = i / l,
              y = 0,
              v = new Uint16Array(o),
              S = a;
            for (h = 0; h < o; h++) v[h] = Math.floor(h * g);
            for (h = 0; h < l; h++)
              for (p = Math.floor(h * b) * S, d = 0; d < o; d++)
                (m = p + v[d]), (c[y++] = t[m]);
            return c;
          }
          function PDFImage(t) {
            var r = t.xref,
              a = t.res,
              c = t.image,
              u = t.isInline,
              d = void 0 !== u && u,
              p = t.smask,
              m = void 0 === p ? null : p,
              g = t.mask,
              b = void 0 === g ? null : g,
              y = t.isMask,
              v = void 0 !== y && y,
              S = t.pdfFunctionFactory;
            this.image = c;
            var k = c.dict,
              w = k.get("Filter");
            if ((0, o.isName)(w))
              switch (w.name) {
                case "JPXDecode":
                  var C = new h.JpxImage();
                  C.parseImageProperties(c.stream),
                    c.stream.reset(),
                    (c.width = C.width),
                    (c.height = C.height),
                    (c.bitsPerComponent = C.bitsPerComponent),
                    (c.numComps = C.componentsCount);
                  break;
                case "JBIG2Decode":
                  (c.bitsPerComponent = 1), (c.numComps = 1);
              }
            var x = k.get("Width", "W"),
              _ = k.get("Height", "H");
            if (
              (Number.isInteger(c.width) &&
                c.width > 0 &&
                Number.isInteger(c.height) &&
                c.height > 0 &&
                (c.width !== x || c.height !== _) &&
                ((0, i.warn)(
                  "PDFImage - using the Width/Height of the image data, rather than the image dictionary.",
                ),
                (x = c.width),
                (_ = c.height)),
              x < 1 || _ < 1)
            )
              throw new i.FormatError(
                "Invalid image width: ".concat(x, " or height: ").concat(_),
              );
            (this.width = x),
              (this.height = _),
              (this.interpolate = k.get("Interpolate", "I") || !1),
              (this.imageMask = k.get("ImageMask", "IM") || !1),
              (this.matte = k.get("Matte") || !1);
            var A = c.bitsPerComponent;
            if (!A && !(A = k.get("BitsPerComponent", "BPC"))) {
              if (!this.imageMask)
                throw new i.FormatError(
                  "Bits per component missing in image: ".concat(
                    this.imageMask,
                  ),
                );
              A = 1;
            }
            if (((this.bpc = A), !this.imageMask)) {
              var R = k.get("ColorSpace", "CS");
              if (!R)
                switch (
                  ((0, i.info)(
                    "JPX images (which do not require color spaces)",
                  ),
                  c.numComps)
                ) {
                  case 1:
                    R = o.Name.get("DeviceGray");
                    break;
                  case 3:
                    R = o.Name.get("DeviceRGB");
                    break;
                  case 4:
                    R = o.Name.get("DeviceCMYK");
                    break;
                  default:
                    throw new Error(
                      "JPX images with ".concat(c.numComps, " ") +
                        "color components not supported.",
                    );
                }
              var T = d ? a : null;
              (this.colorSpace = l.ColorSpace.parse(R, r, T, S)),
                (this.numComps = this.colorSpace.numComps);
            }
            if (
              ((this.decode = k.getArray("Decode", "D")),
              (this.needsDecode = !1),
              this.decode &&
                ((this.colorSpace &&
                  !this.colorSpace.isDefaultDecode(this.decode, A)) ||
                  (v && !l.ColorSpace.isDefaultDecode(this.decode, 1))))
            ) {
              this.needsDecode = !0;
              var I = (1 << A) - 1;
              (this.decodeCoefficients = []), (this.decodeAddends = []);
              for (
                var P = this.colorSpace && "Indexed" === this.colorSpace.name,
                  O = 0,
                  E = 0;
                O < this.decode.length;
                O += 2, ++E
              ) {
                var B = this.decode[O],
                  D = this.decode[O + 1];
                (this.decodeCoefficients[E] = P ? (D - B) / I : D - B),
                  (this.decodeAddends[E] = P ? B : I * B);
              }
            }
            if (m)
              this.smask = new PDFImage({
                xref: r,
                res: a,
                image: m,
                isInline: d,
                pdfFunctionFactory: S,
              });
            else if (b) {
              if ((0, o.isStream)(b))
                b.dict.get("ImageMask", "IM")
                  ? (this.mask = new PDFImage({
                      xref: r,
                      res: a,
                      image: b,
                      isInline: d,
                      isMask: !0,
                      pdfFunctionFactory: S,
                    }))
                  : (0, i.warn)("Ignoring /Mask in image without /ImageMask.");
              else this.mask = b;
            }
          }
          return (
            (PDFImage.buildImage = function (t) {
              var r = t.xref,
                a = t.res,
                l = t.image,
                c = t.isInline,
                u = void 0 !== c && c,
                h = t.pdfFunctionFactory,
                d = l,
                p = null,
                m = null,
                g = l.dict.get("SMask"),
                b = l.dict.get("Mask");
              return (
                g
                  ? (p = g)
                  : b &&
                    ((0, o.isStream)(b) || Array.isArray(b)
                      ? (m = b)
                      : (0, i.warn)("Unsupported mask format.")),
                Promise.resolve(
                  new PDFImage({
                    xref: r,
                    res: a,
                    image: d,
                    isInline: u,
                    smask: p,
                    mask: m,
                    pdfFunctionFactory: h,
                  }),
                )
              );
            }),
            (PDFImage.createMask = function (t) {
              var r,
                a,
                i = t.imgArray,
                o = t.width,
                l = t.height,
                c = t.imageIsFromDecodeStream,
                u = t.inverseDecode,
                h = ((o + 7) >> 3) * l,
                d = i.byteLength;
              if (!c || (u && !(h === d)))
                if (u)
                  for ((r = new Uint8ClampedArray(h)).set(i), a = d; a < h; a++)
                    r[a] = 255;
                else (r = new Uint8ClampedArray(d)).set(i);
              else r = i;
              if (u) for (a = 0; a < d; a++) r[a] ^= 255;
              return { data: r, width: o, height: l };
            }),
            (PDFImage.prototype = {
              get drawWidth() {
                return Math.max(
                  this.width,
                  (this.smask && this.smask.width) || 0,
                  (this.mask && this.mask.width) || 0,
                );
              },
              get drawHeight() {
                return Math.max(
                  this.height,
                  (this.smask && this.smask.height) || 0,
                  (this.mask && this.mask.height) || 0,
                );
              },
              decodeBuffer: function decodeBuffer(t) {
                var r,
                  a,
                  i = this.bpc,
                  o = this.numComps,
                  l = this.decodeAddends,
                  c = this.decodeCoefficients,
                  u = (1 << i) - 1;
                if (1 !== i) {
                  var h = 0;
                  for (r = 0, a = this.width * this.height; r < a; r++)
                    for (var d = 0; d < o; d++)
                      (t[h] = decodeAndClamp(t[h], l[d], c[d], u)), h++;
                } else for (r = 0, a = t.length; r < a; r++) t[r] = +!t[r];
              },
              getComponents: function getComponents(t) {
                var r = this.bpc;
                if (8 === r) return t;
                var a,
                  i = this.width,
                  o = this.height,
                  l = this.numComps,
                  c = i * o * l,
                  u = 0;
                a =
                  r <= 8
                    ? new Uint8Array(c)
                    : r <= 16
                    ? new Uint16Array(c)
                    : new Uint32Array(c);
                var h,
                  d,
                  p = i * l,
                  m = (1 << r) - 1,
                  g = 0;
                if (1 === r)
                  for (var b, y, v, S = 0; S < o; S++) {
                    for (y = g + (-8 & p), v = g + p; g < y; )
                      (d = t[u++]),
                        (a[g] = (d >> 7) & 1),
                        (a[g + 1] = (d >> 6) & 1),
                        (a[g + 2] = (d >> 5) & 1),
                        (a[g + 3] = (d >> 4) & 1),
                        (a[g + 4] = (d >> 3) & 1),
                        (a[g + 5] = (d >> 2) & 1),
                        (a[g + 6] = (d >> 1) & 1),
                        (a[g + 7] = 1 & d),
                        (g += 8);
                    if (g < v)
                      for (d = t[u++], b = 128; g < v; )
                        (a[g++] = +!!(d & b)), (b >>= 1);
                  }
                else {
                  var k = 0;
                  for (d = 0, g = 0, h = c; g < h; ++g) {
                    for (g % p == 0 && ((d = 0), (k = 0)); k < r; )
                      (d = (d << 8) | t[u++]), (k += 8);
                    var w = k - r,
                      C = d >> w;
                    C < 0 ? (C = 0) : C > m && (C = m),
                      (a[g] = C),
                      (d &= (1 << w) - 1),
                      (k = w);
                  }
                }
                return a;
              },
              fillOpacity: function fillOpacity(t, r, a, o, l) {
                var c,
                  u,
                  h,
                  d,
                  p,
                  m,
                  g = this.smask,
                  b = this.mask;
                if (g)
                  (u = g.width),
                    (h = g.height),
                    (c = new Uint8ClampedArray(u * h)),
                    g.fillGrayBuffer(c),
                    (u === r && h === a) ||
                      (c = resizeImageMask(c, g.bpc, u, h, r, a));
                else if (b)
                  if (b instanceof PDFImage) {
                    for (
                      u = b.width,
                        h = b.height,
                        c = new Uint8ClampedArray(u * h),
                        b.numComps = 1,
                        b.fillGrayBuffer(c),
                        d = 0,
                        p = u * h;
                      d < p;
                      ++d
                    )
                      c[d] = 255 - c[d];
                    (u === r && h === a) ||
                      (c = resizeImageMask(c, b.bpc, u, h, r, a));
                  } else {
                    if (!Array.isArray(b))
                      throw new i.FormatError("Unknown mask format.");
                    c = new Uint8ClampedArray(r * a);
                    var y = this.numComps;
                    for (d = 0, p = r * a; d < p; ++d) {
                      var v = 0,
                        S = d * y;
                      for (m = 0; m < y; ++m) {
                        var k = l[S + m],
                          w = 2 * m;
                        if (k < b[w] || k > b[w + 1]) {
                          v = 255;
                          break;
                        }
                      }
                      c[d] = v;
                    }
                  }
                if (c)
                  for (d = 0, m = 3, p = r * o; d < p; ++d, m += 4) t[m] = c[d];
                else
                  for (d = 0, m = 3, p = r * o; d < p; ++d, m += 4) t[m] = 255;
              },
              undoPreblend: function undoPreblend(t, r, a) {
                var i = this.smask && this.smask.matte;
                if (i)
                  for (
                    var o = this.colorSpace.getRgb(i, 0),
                      l = o[0],
                      c = o[1],
                      u = o[2],
                      h = r * a * 4,
                      d = 0;
                    d < h;
                    d += 4
                  ) {
                    var p = t[d + 3];
                    if (0 !== p) {
                      var m = 255 / p;
                      (t[d] = (t[d] - l) * m + l),
                        (t[d + 1] = (t[d + 1] - c) * m + c),
                        (t[d + 2] = (t[d + 2] - u) * m + u);
                    } else (t[d] = 255), (t[d + 1] = 255), (t[d + 2] = 255);
                  }
              },
              createImageData: function createImageData() {
                var t,
                  r =
                    arguments.length > 0 &&
                    void 0 !== arguments[0] &&
                    arguments[0],
                  a = this.drawWidth,
                  o = this.drawHeight,
                  l = { width: a, height: o, kind: 0, data: null },
                  h = this.numComps,
                  d = this.width,
                  p = this.height,
                  m = this.bpc,
                  g = (d * h * m + 7) >> 3;
                if (!r) {
                  var b;
                  if (
                    ("DeviceGray" === this.colorSpace.name && 1 === m
                      ? (b = i.ImageKind.GRAYSCALE_1BPP)
                      : "DeviceRGB" !== this.colorSpace.name ||
                        8 !== m ||
                        this.needsDecode ||
                        (b = i.ImageKind.RGB_24BPP),
                    b && !this.smask && !this.mask && a === d && o === p)
                  ) {
                    if (
                      ((l.kind = b),
                      (t = this.getImageBytes(p * g)),
                      this.image instanceof c.DecodeStream)
                    )
                      l.data = t;
                    else {
                      var y = new Uint8ClampedArray(t.length);
                      y.set(t), (l.data = y);
                    }
                    if (this.needsDecode) {
                      (0, i.assert)(
                        b === i.ImageKind.GRAYSCALE_1BPP,
                        "PDFImage.createImageData: The image must be grayscale.",
                      );
                      for (var v = l.data, S = 0, k = v.length; S < k; S++)
                        v[S] ^= 255;
                    }
                    return l;
                  }
                  if (
                    this.image instanceof u.JpegStream &&
                    !this.smask &&
                    !this.mask
                  ) {
                    var w = p * g;
                    switch (this.colorSpace.name) {
                      case "DeviceGray":
                        w *= 3;
                      case "DeviceRGB":
                      case "DeviceCMYK":
                        return (
                          (l.kind = i.ImageKind.RGB_24BPP),
                          (l.data = this.getImageBytes(w, a, o, !0)),
                          l
                        );
                    }
                  }
                }
                var C,
                  x,
                  _ =
                    0 |
                    ((((t = this.getImageBytes(p * g)).length / g) * o) / p),
                  A = this.getComponents(t);
                return (
                  r || this.smask || this.mask
                    ? ((l.kind = i.ImageKind.RGBA_32BPP),
                      (l.data = new Uint8ClampedArray(a * o * 4)),
                      (C = 1),
                      (x = !0),
                      this.fillOpacity(l.data, a, o, _, A))
                    : ((l.kind = i.ImageKind.RGB_24BPP),
                      (l.data = new Uint8ClampedArray(a * o * 3)),
                      (C = 0),
                      (x = !1)),
                  this.needsDecode && this.decodeBuffer(A),
                  this.colorSpace.fillRgb(l.data, d, p, a, o, _, m, A, C),
                  x && this.undoPreblend(l.data, a, _),
                  l
                );
              },
              fillGrayBuffer: function fillGrayBuffer(t) {
                var r = this.numComps;
                if (1 !== r)
                  throw new i.FormatError(
                    "Reading gray scale from a color image: ".concat(r),
                  );
                var a,
                  o,
                  l = this.width,
                  c = this.height,
                  u = this.bpc,
                  h = (l * r * u + 7) >> 3,
                  d = this.getImageBytes(c * h),
                  p = this.getComponents(d);
                if (1 !== u) {
                  this.needsDecode && this.decodeBuffer(p), (o = l * c);
                  var m = 255 / ((1 << u) - 1);
                  for (a = 0; a < o; ++a) t[a] = m * p[a];
                } else if (((o = l * c), this.needsDecode))
                  for (a = 0; a < o; ++a) t[a] = (p[a] - 1) & 255;
                else for (a = 0; a < o; ++a) t[a] = 255 & -p[a];
              },
              getImageBytes: function getImageBytes(t, r, a) {
                var i =
                  arguments.length > 3 &&
                  void 0 !== arguments[3] &&
                  arguments[3];
                return (
                  this.image.reset(),
                  (this.image.drawWidth = r || this.width),
                  (this.image.drawHeight = a || this.height),
                  (this.image.forceRGB = !!i),
                  this.image.getBytes(t, !0)
                );
              },
            }),
            PDFImage
          );
        })();
      r.PDFImage = d;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.MessageHandler = void 0);
      var i = (function _interopRequireDefault(t) {
          return t && t.__esModule ? t : { default: t };
        })(a(2)),
        o = a(5);
      function asyncGeneratorStep(t, r, a, i, o, l, c) {
        try {
          var u = t[l](c),
            h = u.value;
        } catch (t) {
          return void a(t);
        }
        u.done ? r(h) : Promise.resolve(h).then(i, o);
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _typeof(t) {
        return (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function _typeof(t) {
                return typeof t;
              }
            : function _typeof(t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              })(t);
      }
      var l = 1,
        c = 2,
        u = 1,
        h = 2,
        d = 3,
        p = 4,
        m = 5,
        g = 6,
        b = 7,
        y = 8;
      function wrapReason(t) {
        if ("object" !== _typeof(t) || null === t) return t;
        switch (t.name) {
          case "AbortException":
            return new o.AbortException(t.message);
          case "MissingPDFException":
            return new o.MissingPDFException(t.message);
          case "UnexpectedResponseException":
            return new o.UnexpectedResponseException(t.message, t.status);
          case "UnknownErrorException":
            return new o.UnknownErrorException(t.message, t.details);
          default:
            return new o.UnknownErrorException(t.message, t.toString());
        }
      }
      var v = (function () {
        function MessageHandler(t, r, a) {
          var i = this;
          !(function _classCallCheck(t, r) {
            if (!(t instanceof r))
              throw new TypeError("Cannot call a class as a function");
          })(this, MessageHandler),
            (this.sourceName = t),
            (this.targetName = r),
            (this.comObj = a),
            (this.callbackId = 1),
            (this.streamId = 1),
            (this.postMessageTransfers = !0),
            (this.streamSinks = Object.create(null)),
            (this.streamControllers = Object.create(null)),
            (this.callbackCapabilities = Object.create(null)),
            (this.actionHandler = Object.create(null)),
            (this._onComObjOnMessage = function (t) {
              var r = t.data;
              if (r.targetName === i.sourceName)
                if (r.stream) i._processStreamMessage(r);
                else if (r.callback) {
                  var o = r.callbackId,
                    u = i.callbackCapabilities[o];
                  if (!u) throw new Error("Cannot resolve callback ".concat(o));
                  if ((delete i.callbackCapabilities[o], r.callback === l))
                    u.resolve(r.data);
                  else {
                    if (r.callback !== c)
                      throw new Error("Unexpected callback case");
                    u.reject(wrapReason(r.reason));
                  }
                } else {
                  var h = i.actionHandler[r.action];
                  if (!h)
                    throw new Error(
                      "Unknown action from worker: ".concat(r.action),
                    );
                  if (r.callbackId) {
                    var d = i.sourceName,
                      p = r.sourceName;
                    new Promise(function (t) {
                      t(h(r.data));
                    }).then(
                      function (t) {
                        a.postMessage({
                          sourceName: d,
                          targetName: p,
                          callback: l,
                          callbackId: r.callbackId,
                          data: t,
                        });
                      },
                      function (t) {
                        a.postMessage({
                          sourceName: d,
                          targetName: p,
                          callback: c,
                          callbackId: r.callbackId,
                          reason: wrapReason(t),
                        });
                      },
                    );
                  } else r.streamId ? i._createStreamSink(r) : h(r.data);
                }
            }),
            a.addEventListener("message", this._onComObjOnMessage);
        }
        var t;
        return (
          (function _createClass(t, r, a) {
            return (
              r && _defineProperties(t.prototype, r),
              a && _defineProperties(t, a),
              t
            );
          })(MessageHandler, [
            {
              key: "on",
              value: function on(t, r) {
                var a = this.actionHandler;
                if (a[t])
                  throw new Error(
                    'There is already an actionName called "'.concat(t, '"'),
                  );
                a[t] = r;
              },
            },
            {
              key: "send",
              value: function send(t, r, a) {
                this._postMessage(
                  {
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: t,
                    data: r,
                  },
                  a,
                );
              },
            },
            {
              key: "sendWithPromise",
              value: function sendWithPromise(t, r, a) {
                var i = this.callbackId++,
                  l = (0, o.createPromiseCapability)();
                this.callbackCapabilities[i] = l;
                try {
                  this._postMessage(
                    {
                      sourceName: this.sourceName,
                      targetName: this.targetName,
                      action: t,
                      callbackId: i,
                      data: r,
                    },
                    a,
                  );
                } catch (t) {
                  l.reject(t);
                }
                return l.promise;
              },
            },
            {
              key: "sendWithStream",
              value: function sendWithStream(t, r, a, i) {
                var l = this,
                  c = this.streamId++,
                  h = this.sourceName,
                  d = this.targetName,
                  p = this.comObj;
                return new ReadableStream(
                  {
                    start: function start(a) {
                      var u = (0, o.createPromiseCapability)();
                      return (
                        (l.streamControllers[c] = {
                          controller: a,
                          startCall: u,
                          pullCall: null,
                          cancelCall: null,
                          isClosed: !1,
                        }),
                        l._postMessage(
                          {
                            sourceName: h,
                            targetName: d,
                            action: t,
                            streamId: c,
                            data: r,
                            desiredSize: a.desiredSize,
                          },
                          i,
                        ),
                        u.promise
                      );
                    },
                    pull: function pull(t) {
                      var r = (0, o.createPromiseCapability)();
                      return (
                        (l.streamControllers[c].pullCall = r),
                        p.postMessage({
                          sourceName: h,
                          targetName: d,
                          stream: g,
                          streamId: c,
                          desiredSize: t.desiredSize,
                        }),
                        r.promise
                      );
                    },
                    cancel: function cancel(t) {
                      (0, o.assert)(
                        t instanceof Error,
                        "cancel must have a valid reason",
                      );
                      var r = (0, o.createPromiseCapability)();
                      return (
                        (l.streamControllers[c].cancelCall = r),
                        (l.streamControllers[c].isClosed = !0),
                        p.postMessage({
                          sourceName: h,
                          targetName: d,
                          stream: u,
                          streamId: c,
                          reason: wrapReason(t),
                        }),
                        r.promise
                      );
                    },
                  },
                  a,
                );
              },
            },
            {
              key: "_createStreamSink",
              value: function _createStreamSink(t) {
                var r = this,
                  a = this.actionHandler[t.action],
                  i = t.streamId,
                  l = this.sourceName,
                  c = t.sourceName,
                  u = this.comObj,
                  h = {
                    enqueue: function enqueue(t) {
                      var a =
                          arguments.length > 1 && void 0 !== arguments[1]
                            ? arguments[1]
                            : 1,
                        u = arguments.length > 2 ? arguments[2] : void 0;
                      if (!this.isCancelled) {
                        var h = this.desiredSize;
                        (this.desiredSize -= a),
                          h > 0 &&
                            this.desiredSize <= 0 &&
                            ((this.sinkCapability = (0,
                            o.createPromiseCapability)()),
                            (this.ready = this.sinkCapability.promise)),
                          r._postMessage(
                            {
                              sourceName: l,
                              targetName: c,
                              stream: p,
                              streamId: i,
                              chunk: t,
                            },
                            u,
                          );
                      }
                    },
                    close: function close() {
                      this.isCancelled ||
                        ((this.isCancelled = !0),
                        u.postMessage({
                          sourceName: l,
                          targetName: c,
                          stream: d,
                          streamId: i,
                        }),
                        delete r.streamSinks[i]);
                    },
                    error: function error(t) {
                      (0, o.assert)(
                        t instanceof Error,
                        "error must have a valid reason",
                      ),
                        this.isCancelled ||
                          ((this.isCancelled = !0),
                          u.postMessage({
                            sourceName: l,
                            targetName: c,
                            stream: m,
                            streamId: i,
                            reason: wrapReason(t),
                          }));
                    },
                    sinkCapability: (0, o.createPromiseCapability)(),
                    onPull: null,
                    onCancel: null,
                    isCancelled: !1,
                    desiredSize: t.desiredSize,
                    ready: null,
                  };
                h.sinkCapability.resolve(),
                  (h.ready = h.sinkCapability.promise),
                  (this.streamSinks[i] = h),
                  new Promise(function (r) {
                    r(a(t.data, h));
                  }).then(
                    function () {
                      u.postMessage({
                        sourceName: l,
                        targetName: c,
                        stream: y,
                        streamId: i,
                        success: !0,
                      });
                    },
                    function (t) {
                      u.postMessage({
                        sourceName: l,
                        targetName: c,
                        stream: y,
                        streamId: i,
                        reason: wrapReason(t),
                      });
                    },
                  );
              },
            },
            {
              key: "_processStreamMessage",
              value: function _processStreamMessage(t) {
                var r = t.streamId,
                  a = this.sourceName,
                  i = t.sourceName,
                  l = this.comObj;
                switch (t.stream) {
                  case y:
                    t.success
                      ? this.streamControllers[r].startCall.resolve()
                      : this.streamControllers[r].startCall.reject(
                          wrapReason(t.reason),
                        );
                    break;
                  case b:
                    t.success
                      ? this.streamControllers[r].pullCall.resolve()
                      : this.streamControllers[r].pullCall.reject(
                          wrapReason(t.reason),
                        );
                    break;
                  case g:
                    if (!this.streamSinks[r]) {
                      l.postMessage({
                        sourceName: a,
                        targetName: i,
                        stream: b,
                        streamId: r,
                        success: !0,
                      });
                      break;
                    }
                    this.streamSinks[r].desiredSize <= 0 &&
                      t.desiredSize > 0 &&
                      this.streamSinks[r].sinkCapability.resolve(),
                      (this.streamSinks[r].desiredSize = t.desiredSize);
                    var c = this.streamSinks[t.streamId].onPull;
                    new Promise(function (t) {
                      t(c && c());
                    }).then(
                      function () {
                        l.postMessage({
                          sourceName: a,
                          targetName: i,
                          stream: b,
                          streamId: r,
                          success: !0,
                        });
                      },
                      function (t) {
                        l.postMessage({
                          sourceName: a,
                          targetName: i,
                          stream: b,
                          streamId: r,
                          reason: wrapReason(t),
                        });
                      },
                    );
                    break;
                  case p:
                    if (
                      ((0, o.assert)(
                        this.streamControllers[r],
                        "enqueue should have stream controller",
                      ),
                      this.streamControllers[r].isClosed)
                    )
                      break;
                    this.streamControllers[r].controller.enqueue(t.chunk);
                    break;
                  case d:
                    if (
                      ((0, o.assert)(
                        this.streamControllers[r],
                        "close should have stream controller",
                      ),
                      this.streamControllers[r].isClosed)
                    )
                      break;
                    (this.streamControllers[r].isClosed = !0),
                      this.streamControllers[r].controller.close(),
                      this._deleteStreamController(r);
                    break;
                  case m:
                    (0, o.assert)(
                      this.streamControllers[r],
                      "error should have stream controller",
                    ),
                      this.streamControllers[r].controller.error(
                        wrapReason(t.reason),
                      ),
                      this._deleteStreamController(r);
                    break;
                  case h:
                    t.success
                      ? this.streamControllers[r].cancelCall.resolve()
                      : this.streamControllers[r].cancelCall.reject(
                          wrapReason(t.reason),
                        ),
                      this._deleteStreamController(r);
                    break;
                  case u:
                    if (!this.streamSinks[r]) break;
                    var v = this.streamSinks[t.streamId].onCancel;
                    new Promise(function (r) {
                      r(v && v(wrapReason(t.reason)));
                    }).then(
                      function () {
                        l.postMessage({
                          sourceName: a,
                          targetName: i,
                          stream: h,
                          streamId: r,
                          success: !0,
                        });
                      },
                      function (t) {
                        l.postMessage({
                          sourceName: a,
                          targetName: i,
                          stream: h,
                          streamId: r,
                          reason: wrapReason(t),
                        });
                      },
                    ),
                      this.streamSinks[r].sinkCapability.reject(
                        wrapReason(t.reason),
                      ),
                      (this.streamSinks[r].isCancelled = !0),
                      delete this.streamSinks[r];
                    break;
                  default:
                    throw new Error("Unexpected stream case");
                }
              },
            },
            {
              key: "_deleteStreamController",
              value:
                ((t = (function _asyncToGenerator(t) {
                  return function () {
                    var r = this,
                      a = arguments;
                    return new Promise(function (i, o) {
                      var l = t.apply(r, a);
                      function _next(t) {
                        asyncGeneratorStep(l, i, o, _next, _throw, "next", t);
                      }
                      function _throw(t) {
                        asyncGeneratorStep(l, i, o, _next, _throw, "throw", t);
                      }
                      _next(void 0);
                    });
                  };
                })(
                  i.default.mark(function _callee(t) {
                    return i.default.wrap(
                      function _callee$(r) {
                        for (;;)
                          switch ((r.prev = r.next)) {
                            case 0:
                              return (
                                (r.next = 2),
                                Promise.allSettled(
                                  [
                                    this.streamControllers[t].startCall,
                                    this.streamControllers[t].pullCall,
                                    this.streamControllers[t].cancelCall,
                                  ].map(function (t) {
                                    return t && t.promise;
                                  }),
                                )
                              );
                            case 2:
                              delete this.streamControllers[t];
                            case 3:
                            case "end":
                              return r.stop();
                          }
                      },
                      _callee,
                      this,
                    );
                  }),
                )),
                function _deleteStreamController(r) {
                  return t.apply(this, arguments);
                }),
            },
            {
              key: "_postMessage",
              value: function _postMessage(t, r) {
                r && this.postMessageTransfers
                  ? this.comObj.postMessage(t, r)
                  : this.comObj.postMessage(t);
              },
            },
            {
              key: "destroy",
              value: function destroy() {
                this.comObj.removeEventListener(
                  "message",
                  this._onComObjOnMessage,
                );
              },
            },
          ]),
          MessageHandler
        );
      })();
      r.MessageHandler = v;
    },
    function (t, r, a) {
      "use strict";
      Object.defineProperty(r, "__esModule", { value: !0 }),
        (r.PDFWorkerStream = void 0);
      var i = (function _interopRequireDefault(t) {
          return t && t.__esModule ? t : { default: t };
        })(a(2)),
        o = a(5);
      function asyncGeneratorStep(t, r, a, i, o, l, c) {
        try {
          var u = t[l](c),
            h = u.value;
        } catch (t) {
          return void a(t);
        }
        u.done ? r(h) : Promise.resolve(h).then(i, o);
      }
      function _asyncToGenerator(t) {
        return function () {
          var r = this,
            a = arguments;
          return new Promise(function (i, o) {
            var l = t.apply(r, a);
            function _next(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "next", t);
            }
            function _throw(t) {
              asyncGeneratorStep(l, i, o, _next, _throw, "throw", t);
            }
            _next(void 0);
          });
        };
      }
      function _classCallCheck(t, r) {
        if (!(t instanceof r))
          throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(t, r) {
        for (var a = 0; a < r.length; a++) {
          var i = r[a];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(t, i.key, i);
        }
      }
      function _createClass(t, r, a) {
        return (
          r && _defineProperties(t.prototype, r),
          a && _defineProperties(t, a),
          t
        );
      }
      var l = (function () {
        function PDFWorkerStream(t) {
          _classCallCheck(this, PDFWorkerStream),
            (this._msgHandler = t),
            (this._contentLength = null),
            (this._fullRequestReader = null),
            (this._rangeRequestReaders = []);
        }
        return (
          _createClass(PDFWorkerStream, [
            {
              key: "getFullReader",
              value: function getFullReader() {
                return (
                  (0, o.assert)(
                    !this._fullRequestReader,
                    "PDFWorkerStream.getFullReader can only be called once.",
                  ),
                  (this._fullRequestReader = new c(this._msgHandler)),
                  this._fullRequestReader
                );
              },
            },
            {
              key: "getRangeReader",
              value: function getRangeReader(t, r) {
                var a = new u(t, r, this._msgHandler);
                return this._rangeRequestReaders.push(a), a;
              },
            },
            {
              key: "cancelAllRequests",
              value: function cancelAllRequests(t) {
                this._fullRequestReader && this._fullRequestReader.cancel(t),
                  this._rangeRequestReaders.slice(0).forEach(function (r) {
                    r.cancel(t);
                  });
              },
            },
          ]),
          PDFWorkerStream
        );
      })();
      r.PDFWorkerStream = l;
      var c = (function () {
          function PDFWorkerStreamReader(t) {
            var r = this;
            _classCallCheck(this, PDFWorkerStreamReader),
              (this._msgHandler = t),
              (this.onProgress = null),
              (this._contentLength = null),
              (this._isRangeSupported = !1),
              (this._isStreamingSupported = !1);
            var a = this._msgHandler.sendWithStream("GetReader");
            (this._reader = a.getReader()),
              (this._headersReady = this._msgHandler
                .sendWithPromise("ReaderHeadersReady")
                .then(function (t) {
                  (r._isStreamingSupported = t.isStreamingSupported),
                    (r._isRangeSupported = t.isRangeSupported),
                    (r._contentLength = t.contentLength);
                }));
          }
          var t;
          return (
            _createClass(PDFWorkerStreamReader, [
              {
                key: "read",
                value:
                  ((t = _asyncToGenerator(
                    i.default.mark(function _callee() {
                      var t, r;
                      return i.default.wrap(
                        function _callee$(a) {
                          for (;;)
                            switch ((a.prev = a.next)) {
                              case 0:
                                return (a.next = 2), this._reader.read();
                              case 2:
                                if (((t = a.sent), (r = t.value), !t.done)) {
                                  a.next = 7;
                                  break;
                                }
                                return a.abrupt("return", {
                                  value: void 0,
                                  done: !0,
                                });
                              case 7:
                                return a.abrupt("return", {
                                  value: r.buffer,
                                  done: !1,
                                });
                              case 8:
                              case "end":
                                return a.stop();
                            }
                        },
                        _callee,
                        this,
                      );
                    }),
                  )),
                  function read() {
                    return t.apply(this, arguments);
                  }),
              },
              {
                key: "cancel",
                value: function cancel(t) {
                  this._reader.cancel(t);
                },
              },
              {
                key: "headersReady",
                get: function get() {
                  return this._headersReady;
                },
              },
              {
                key: "contentLength",
                get: function get() {
                  return this._contentLength;
                },
              },
              {
                key: "isStreamingSupported",
                get: function get() {
                  return this._isStreamingSupported;
                },
              },
              {
                key: "isRangeSupported",
                get: function get() {
                  return this._isRangeSupported;
                },
              },
            ]),
            PDFWorkerStreamReader
          );
        })(),
        u = (function () {
          function PDFWorkerStreamRangeReader(t, r, a) {
            _classCallCheck(this, PDFWorkerStreamRangeReader),
              (this._msgHandler = a),
              (this.onProgress = null);
            var i = this._msgHandler.sendWithStream("GetRangeReader", {
              begin: t,
              end: r,
            });
            this._reader = i.getReader();
          }
          var t;
          return (
            _createClass(PDFWorkerStreamRangeReader, [
              {
                key: "read",
                value:
                  ((t = _asyncToGenerator(
                    i.default.mark(function _callee2() {
                      var t, r;
                      return i.default.wrap(
                        function _callee2$(a) {
                          for (;;)
                            switch ((a.prev = a.next)) {
                              case 0:
                                return (a.next = 2), this._reader.read();
                              case 2:
                                if (((t = a.sent), (r = t.value), !t.done)) {
                                  a.next = 7;
                                  break;
                                }
                                return a.abrupt("return", {
                                  value: void 0,
                                  done: !0,
                                });
                              case 7:
                                return a.abrupt("return", {
                                  value: r.buffer,
                                  done: !1,
                                });
                              case 8:
                              case "end":
                                return a.stop();
                            }
                        },
                        _callee2,
                        this,
                      );
                    }),
                  )),
                  function read() {
                    return t.apply(this, arguments);
                  }),
              },
              {
                key: "cancel",
                value: function cancel(t) {
                  this._reader.cancel(t);
                },
              },
              {
                key: "isStreamingSupported",
                get: function get() {
                  return !1;
                },
              },
            ]),
            PDFWorkerStreamRangeReader
          );
        })();
    },
  ]);
});
